// GMG ACE (AI Check for Excellence) V2.14 - ACE Portal II Series
// Global Majority Group Intranet
// Built: November 29-30, 2025
// Updated: December 18, 2025
//
// V2.14 CRITICAL UX FIXES (December 18, 2025):
// - FIX: Admin portal now shows for brandonjpiercesr@gmail.com
// - FIX: "Generate Delivery" now shows transformed content with preview
// - ADD: Email preview before sending
// - ADD: Back buttons on ALL modal menus
// - FIX: Remove header tap changing tabs accidentally
// - FIX: Text input expands like iMessage (proper auto-grow)
// - CLARIFY: Chanet uses Claudette's token (alias support)
//
// V2.13 UX POLISH (December 18, 2025):
// - ADD: Chanet alias support (shares Claudette's token)
// - ADD: Admin portal button visible in header for admins
// - ADD: Settings gear icon next to dark mode toggle
// - ADD: Time-based dark mode default (after 7pm)
// - ADD: "Switch Mode" label on FAB for clarity
// - FIX: Logo background transparency
// - FIX: Progress indicator matches task type
// - ADD: Subtle animated gradient background
//
// V2.12 CRITICAL FIXES (December 18, 2025):
// - CLAUDETTE IS REAL: claudette@globalmajoritygroup.com is actual Google account
// - SERVER TOKENS: Refresh tokens stored in Vercel env, not browser
// - UNIVERSAL ACCESS: Anyone in ACE Portal can send as Claudette/Chanet
// - NO OAUTH POPUP: Users just click "Send Email" and it works
// - ONE-TIME SETUP: Admin runs setup once to get refresh tokens
//
// V2.11 GMAIL INTEGRATION + ADMIN PORTAL (December 18, 2025):
// - GMAIL API: Send emails as Claudette/Chanet via Vercel serverless function
// - ADMIN PORTAL: Full admin dashboard for Brandon & Eric
// - USER MANAGEMENT: View all users, usage stats, permissions
// - ANALYTICS: Cross-user analytics, most common issues, usage trends
// - AUDIT LOG: Track all admin actions
// - TEMPLATE MANAGEMENT: Create/edit global templates
// - SETTINGS: Global app settings, banned phrases management
//
// V2.10 ADMIN PERSONA DELIVERY SYSTEM (December 18, 2025):
// - DELIVERY PERSONAS: Brandon, Eric, Claudette Aims, Chanet Graves
// - PERSONA SELECTOR UI: Dropdown appears after content generation
// - COMPOUND PROMPTS: 500+ lines of writing rules + persona-specific rules
// - TAB DEFAULTS: ON for Create/Check/Prep, OFF for Ask/Knowledge
// - NOT on Jobs/Acquire tab (personal job apps don't need admin delivery)
//
// V2.9 MAJOR UPDATE (December 18, 2025):
// - JINA AI URL FETCHING: Uses r.jina.ai to fetch ANY job URL reliably
// - ROLEPLAY INTROS: Messages type one at a time like GMG University
// - DESKTOP FIX: Fixed background bleeding on left side
// - DARK MODE ICONS: Sun/Moon SVG icons instead of text
// - REMOVED IMPORT: Redundant since + button exists at bottom
// - TIER SELECTION RESTORED: A/B/C/D options show in chat
// - SIDE-BY-SIDE DEFAULT: Check results always show comparison grid
//
// V2.8 UI ENHANCEMENTS (December 18, 2025):
// - CLEAR PAGE INDICATOR: Large centered tab name with pill background in header
// - UPLOAD BUTTON: + button on left of input (like iPhone) for file uploads
// - VOICE BUTTON: Microphone button on right for voice input
// - FAB REDESIGNED: Changed from purple to copper/bronze GMG color
// - FAB MORE TRANSPARENT: 70% opacity with backdrop blur
// - FAB MOVED UP: Positioned higher on screen (bottom: 140px instead of 100px)
// - URL FETCH IMPROVED: Better error handling and user guidance
//
// V2.7 TIER SELECTION IN CHAT + SIDE-BY-SIDE (December 18, 2025):
// - FIXED FIREBASE: Using correct gmg-ace-portal credentials
// - TIER SELECTION IN CHAT: Claudette asks "How should I handle this?" with buttons
// - SIDE-BY-SIDE COMPARISON: Check results show Original vs Corrected in grid
// - New message types: 'tier-selection' and 'check-result'
// - No more modal overlay for tier selection - all in chat flow
//
// V2.6 GMG UNIVERSITY PATTERN (December 17, 2025):
// - COMPLETE REWRITE of unified chat using GMG University's exact pattern
// - ALL INLINE STYLES: No more CSS class dependencies that get overridden
// - SIMPLE MESSAGE ARRAY: Just map through messages, style based on speaker
// - USER BUBBLES: Purple gradient, right side, border-radius: 18px 18px 4px 18px
// - AI BUBBLES: Gray (#E5E5EA), left side, border-radius: 18px 18px 18px 4px
// - RESULT CARDS: White with copper header, inside the message stream
// - TYPING INDICATOR: Three bouncing dots with animation
// - ONE INPUT: Simple textarea + send button at bottom
// - NO BOXES: Everything flows in a single stream
//
// V2.5 UNIFIED FLUID STREAM (December 17, 2025):
// - ONE FLUID CONTAINER: All chat flows in single stream like GMG University
// - NO MORE BOXES: Removed "Claudette & Chanet" wrapper box, "Guest Access" box
// - INTRO AS CHAT BUBBLES: Claudette and Chanet intros are now iMessage bubbles
// - SUBTLE GUEST NOTICE: Just a small text line, not a big blue box
// - PEARL/PLATINUM BACKGROUND: Clean gradient (#F5F5F7 -> #E8E8EC -> #F0F0F5)
// - PURPLE USER BUBBLES: linear-gradient(135deg, #8B5CF6, #7C3AED)
// - GRAY ADMIN BUBBLES: #E5E5EA (distinct from background, doesn't blend)
// - COPPER CONTENT CARDS: Result headers use GMG copper gradient
// - PURPLE SEND BUTTON: Matches user bubble color
//
// V2.4 COLOR FIXES (December 17, 2025):
// - Fixed colors but still had fragmented boxes
//
// V2.3 UNIFIED iMESSAGE UI (December 17, 2025):
// - BROKEN/REPLACED: Had wrong colors (Apple blue), too fragmented
//
// V2.2 WEB_FETCH UPGRADE (December 17, 2025):
// - FULL PAGE GRAB: Changed from web_search to web_fetch for job URLs
// - web_search = searches web, returns snippets (OLD - missed data)
// - web_fetch = grabs ENTIRE page content (NEW - gets everything)
// - Now captures: email addresses, mailto links, Send Email buttons
// - Better addressee detection (finds "addressed to Britt Magnan-Callaway")
// - Better email extraction (finds careers@, jobs@, hr@ from page)
// - max_tokens increased from 4000 to 8000 for full page content
// - Three URL processing blocks updated (lines ~16915, ~17069, ~19191)
//
// V2.1 MAJOR UPDATE (December 17, 2025):
// - TIERED REWRITE SYSTEM: Four levels (A/B/C/D) for context-aware editing
//   A = "Have Brandon go crazy and change everything" (full rewrite)
//   B = "Tell Brandon to mark up only the AI things" (keep tone, fix AI)
//   C = "Just fix the stuff that'll get me fired" (minimal: em dashes, CTAs, slang)
//   D = "Show me what's wrong but don't touch anything" (flag only)
// - SLANG DETECTION: "fired up", "stuff", "vibes", "grind", etc. now flagged
// - META-COMMENTARY DETECTION: "here's what", "below you'll find", etc.
// - EXPANDED CTA PATTERNS: Regex matching for "I hope we can talk", "I'd love to connect"
// - SESSION CONTEXT MEMORY: System remembers last action for follow-up intelligence
// - EMAIL BUTTON FIX: Working mailto: link with pre-filled content
// - PDF EXPORT: Cover letters and resumes downloadable as formatted PDFs
// - PERSON-SPECIFIC RULES: BJ, CJ, Brandon, Eric each have enforced resume rules
//
// VERSION NAMING: ACE Portal frozen at V2.0. All updates are V2.1, V2.2, etc.
//
// V2.0/V7.0 FORCE REFRESH ON VERSION MISMATCH (December 16, 2025):
// - APP_VERSION constant checked against localStorage on every load
// - If version mismatch detected, automatically clears all caches and reloads
// - Clears: localStorage version, sessionStorage, service worker caches
// - Users with old PWA will auto-refresh to latest version
// - No more blank white screens from stale cache
//
// V6.9 DESKTOP LAYOUT FIX (December 16, 2025):
// - FIXED: Desktop was showing OLD layout (unified-tabs, chat-header, content-grid)
// - Desktop CSS at line ~8846 was overriding with !important to re-show old elements
// - Now all old layout elements stay hidden on ALL screen sizes
// - iMessage interface is now the ONLY layout for both mobile AND desktop
//
// V6.8 PWA UPDATE PROMPT + UNLIMITED PDF PAGES (December 16, 2025):
// - PWA UPDATE BANNER: Users see "Update Available!" when new version deployed
// - Tap "Update Now" to reload with latest version
// - Service worker listens for skipWaiting message to activate immediately
// - PDF NO LIMIT: Removed 20-page cap, now processes ALL pages of scanned PDFs
//
// V6.7 PDF VISION FALLBACK (December 16, 2025):
// - Added PDF.js for rendering scanned PDFs as images
// - Vision fallback: If document extraction returns <100 chars, tries page-by-page vision
// - Processes ALL pages via Claude vision for scanned docs
// - Shows "(scanned)" and "(vision mode)" indicators when fallback is used
//
// V6.6 BRAND-ON FIX (December 16, 2025):
// - Fixed company name: Brand-ON Consulting, LLC (not Brandon Consultants)
//
// V6.5 RESUME FIX + MOBILE INPUT (December 16, 2025):
// - BJ RESUME: REMOVED all Envolve references - BJ uses GID + Brand-ON Consulting, LLC only
// - CJ RESUME: Envolve reserved exclusively for CJ (spelled E-N-V-O-L-V-E)
// - BJ keyPoints: Replaced Envolve with Brand-ON Consulting, LLC
// - BJ cover letter template: Replaced Envolve Experts with Brand-ON Consulting, LLC
// - Brandon family description: Fixed BJ children count (5 not 3), removed Envolve reference
// - Send button: Arrow icon (->, larger (44px) - clearly visible
// - iOS Keyboard: Tab bar hides when typing, input stays visible
// - Result cards: Max height 60% with scroll for viewing all content
//
// V6.4 MOBILE INPUT FIX (December 16, 2025):
// - SEND BUTTON: Changed from "Send" text to arrow icon (->, made larger (44px)
// - iOS KEYBOARD: Added keyboard detection, hides tab bar when typing
// - RESULT CARDS: Added max-height and scroll so you can see all content
// - INPUT STAYS VISIBLE: Input bar now stays visible when keyboard opens
//
// V6.3 SCROLL FIX (December 16, 2025):
// - SCROLLING: Removed duplicate CSS that was overriding mobile padding-bottom
// - Chat messages now scroll properly past fixed input/tab bar
//
// V6.2 FIREBASE + INTROS FIX (December 16, 2025):
// - FIREBASE CONFIG: Added real Firebase credentials as fallbacks
// - KNOWLEDGE TAB INTROS: Fixed condition that was excluding knowledge tab from roleplay intros
// - All tabs now show Claudette/Chanet welcome messages
//
// V6.1 INPUT FIX (December 16, 2025):
// - INPUT ABOVE TAB BAR: Fixed z-index so input appears above mobile tabs
// - EMOJI FIX: Replaced corrupted UTF-8 emoji with text labels
// - FIREBASE GRACEFUL: App works without Firebase, shows warning instead of breaking
// - PROPER STACKING: Tab bar z-index 100, Input z-index 102
//
// V6.0 TRUE iMESSAGE INTERFACE FIX (December 16, 2025):
// - REMOVED DUAL LAYOUT BUG: Cleaned up conflicting CSS that showed both layouts
// - REMOVED unified-chat-header JSX: Avatar section completely removed from code
// - REMOVED unified-tabs JSX: Only mobile-tab-bar exists now
// - SINGLE INPUT: One input bar at bottom, no duplicate inputs
// - USER BUBBLES RIGHT: User messages with name and avatar on right side
// - AI BUBBLES LEFT: Claudette/Chanet with avatar and name on left side
// - SCROLLABLE CHAT: Fixed scroll issues, chat fills viewport properly
// - TYPING INDICATOR: Shows which persona is typing inline
// - INLINE RESULTS: All results, exports, actions within chat flow
//
// V5.8 UPDATES (December 15, 2025):
// - PWA EVERY SESSION: Banner shows each visit (not dismissed forever)
// - SETTINGS DRAWER: Gear icon opens mobile settings with all options
// - EMAIL BUTTON FIX: Always visible after cover letter, fallback when no email found
// - EMAIL PARSER: Enhanced to catch careers@, hr@, jobs@, apply@, hiring@, etc.
// - BJ FAMILY FIX: Uriah is OLDEST daughter (not youngest)
// - BJ BROTHER: Corrected description from "son" to "brother"
//
// V5.6 MOBILE-FIRST REDESIGN (December 15, 2025):
// - COMPLETE MOBILE OVERHAUL: iPhone 14/15/16 optimized (390-430px)
// - SLIM HEADER: 44px height, logo + center tab name + dark toggle
// - AVATARS REMOVED: No dedicated section, inline with messages instead
// - FLUID CHAT: Full viewport height, no fixed boxes
// - PILL TAB BAR: iOS-style pill tabs above input
// - FLOATING INPUT: Fixed bottom, auto-expanding 1-4 lines
// - BOTTOM SHEETS: All modals slide up from bottom
// - DARK MODE OLED: True black (#000) background for battery savings
// - TOUCH TARGETS: 44px minimum for all interactive elements
// - MESSAGE BUBBLES: 85% max width, slide-up animation
// - TYPING DOTS: Animated indicator during processing
//
// V5.5 FIXES (December 15, 2025):
// - UTF-8 CHARACTER FIX: Removed all corrupted characters (cloud sync, draft saved, etc)
// - MOBILE CSS FIX: Smaller avatars, bigger chat textarea, fluid layout
// - FLOATING TIPS DISABLED: Tips now appear as chat messages instead of buggy overlay
// - CJ ADDED: CJ Moore now in all applicant selection prompts and detection
// - BJ COVER LETTER: Title must be LEVELED UP (not carbon copy), family mention REQUIRED
// - BJ/CJ ORGS: BJ=GID, CJ=Envolve (spelled correctly)
// - ADDRESSEE EXTRACTION: Job parsing now extracts and uses addressee name
// - SPLIT VIEW DEFAULT: AI Check now defaults to showing split view
// - PDF EXTRACTION: Uses Sonnet model for better accuracy
// - FEEDBACK BUTTONS: Changed from +1/-1 to Good/Improve with clear tooltips
//
// V5.4 UPDATES (December 15, 2025):
// - QUICK TEMPLATES: Dropdown with common prompts for each tab
// - REGENERATE: Button to re-run last AI response
// - RESPONSE FEEDBACK: Thumbs up/down on AI responses (saves to Firebase)
// - RESPONSE TIME: Shows generation time after each response
// - API STATUS: Green/red indicator showing connection status
// - KEYBOARD SHORTCUTS MODAL: Press ? or Ctrl+/ to see all shortcuts
//
// V5.3 UPDATES (December 15, 2025):
// - FULL AUDIT: Line-by-line review of all 22,000+ lines
// - PITCH DECK MODEL: Changed from Haiku to Sonnet for better quality
// - UTF-8 FIXES: Fixed bullet and arrow character corruption
// - EMOJI CLEANUP: Removed corrupted emoji sequences
//
// V5.2 UPDATES (December 15, 2025):
// - PDF EXTRACTION FIX: Chunked base64 encoding for large files, uses Sonnet model
// - FLOATING TIPS: Claudette/Chanet tips animate in when switching tabs
// - AUTO-DISMISS: Tips disappear after 6 seconds or manual close
// - SIZE LIMIT: PDFs over 10MB show helpful message
//
// V5.1 FIXES (December 15, 2025):
// - BJ RELATIONSHIP: Corrected to Brandon's BROTHER (not son)
// - ELI EMAIL EXAMPLE: Added warnings to prevent example output
// - ROLEPLAY ARGUMENTS: Fixed 6 swapped speaker/text arguments
//
// V3.6 FINAL UPDATES (December 12, 2025):
// - PWA SUPPORT: manifest.json, service worker, install prompt, offline page, SVG icons
// - DARK MODE: Full dark theme with system preference detection
// - BOTTOM NAVIGATION: Mobile-friendly bottom nav with swipe gestures
// - FLOATING ACTION BUTTON: Quick send on mobile
// - AUTO-SAVE DRAFTS: Saves every 30 seconds, recovery on reload
// - APPLICATION TRACKING: Track job applications with follow-up reminders
// - RESUME MANAGER: Multiple versions, ATS checker, skills matching
// - TEMPLATE LIBRARY: Save, search, share templates with team (Firebase)
// - CONVERSATION HISTORY: Search past Ask GMG questions, related suggestions
// - MEETING NOTES: Quick capture and briefing generation
// - FOLLOW-UP TASKS: Task management with completion tracking
// - CLIENT CONTACTS: Quick-access contact directory
// - BATCH CHECK: Check multiple documents at once
// - SESSION TIMEOUT: 30-minute timeout with warning
// - CROSS-DEVICE SYNC: Sync drafts across devices via Firebase
// - CODE SPLITTING PREP: React.lazy/Suspense ready (see comments below)
//
// CODE SPLITTING PREPARATION (V3.6):
// When ready to implement code splitting, uncomment and replace imports:
// const TemplateLibrary = React.lazy(() => import('./components/TemplateLibrary'));
// const ResumeManager = React.lazy(() => import('./components/ResumeManager'));
// const ApplicationTracker = React.lazy(() => import('./components/ApplicationTracker'));
// const BatchCheck = React.lazy(() => import('./components/BatchCheck'));
// const MeetingNotes = React.lazy(() => import('./components/MeetingNotes'));
// Wrap lazy components with: <Suspense fallback={<LoadingSpinner />}>...</Suspense>
//
// V3.5.4 UPDATES (December 12, 2025):
// - WEB SEARCH ENABLED: Sports/current events queries now use Claude web_search tool
// - NO MORE CANNED RESPONSES: "Did Lakers win?" actually searches and answers naturally
// - SMART DETECTION: Triggers on sports teams + game words, or current events keywords
// - CONVERSATIONAL OUTPUT: Responses in natural style, not robotic search dumps
//
// V3.5.3 UPDATES (December 12, 2025):
// - FIXED ROBOTIC AI-SPEAK: Replaced 9 robotic phrases with natural dialogue:
//   - "Let me query the database" -> "Give me a second"
//   - "Scanning through our records" -> "Pulling that up now"
//   - "Checking all available resources" -> "Looking through everything we got"
//   - "Located the relevant information" -> "Found it"
//   - "Found several relevant entries. Compiling now" -> "Got a few things"
//   - "Information ready. Here you go" -> "Done. Take a look"
//   - "Pulling from multiple sources" -> "Checking a few different places"
//   - "Compiling results now" -> "Putting it all together!"
//   - "Compiling the report now" -> "Working on the report"
//
// V3.5.2 UPDATES (December 11, 2025):
// - PARKER IS A DAUGHTER: Fixed all references (Eric has 2 sons + 1 daughter)
// - URIAH IS A DAUGHTER: BJ has 4 sons + 1 daughter
// - COVER LETTER PERSONAL CONNECTION: Added family details and guidance for each persona
// - ENHANCED INSTRUCTIONS: Brandon, Eric, BJ all have specific family mention guidance
//
// V3.5.1 UPDATES (December 11, 2025):
// - GMG UNIVERSITY 60-DAY COURSE: Full curriculum embedded in knowledge base
// - PDF SAVE OPTION: Print/Save PDF button for Pitch Decks and DSDPs
// - DSDP DETECTION: Preview modal correctly identifies DSDP vs Pitch Deck
//
// V3.5 MAJOR UPDATES (December 11, 2025):
// - REAL DOCX GENERATION: Uses docx.js library for actual .docx files
// - FIREBASE TIER PERSISTENCE: Tier level stored per user, resets after 24hr inactivity
// - IMPROVED ROLEPLAY FLOW: More natural exchanges, contextual responses
// - COVER LETTER DOWNLOADS: Real professional documents with headers
//
// V3.4 FEATURES (inherited):
// - ENHANCED ROLEPLAY: Minimum 3-4 exchanges, contextual, tier progression visible
// - WEB SEARCH FIX: Real web search using Claude Sonnet 4, not "I don't know" fallback  
// - TIER PERSONAS: Claudette gets snippy, Chanet gets flirty
// - 166 PERSONA ELEMENTS: Jokes, riddles, facts, roasts, competition banter
// - Based on GMG_ACE_PERSONAS_V3.md specifications
//
// V3.3.1 FIXES (December 11, 2025):
// - Fixed UTF-8 encoding corruption (15+ instances)
// - Smart user recognition from Firebase login (altEmails support)
// - Sports/current events now use web_search tool (V3.5.4)
// - Fixed rewrite formatting preservation
//
// V3.3 FIXES (December 11, 2025):
// - Fixed model name: claude-3-haiku-20240307 (was invalid)
// - Fixed /api/claude endpoint reference to direct API call
// - Mobile responsive overhaul (unified chat, tabs, modals)
// - Safe area support for notched devices (iPhone X+)
// - Prevented horizontal scroll on mobile
// - Font size 16px on inputs to prevent iOS zoom
//
// V3.2 FEATURES (December 11, 2025):
// - Live Knowledge Sync via Firebase
// - "Add to Knowledge" tab for all users
// - Team members can add clients, contacts, strategies in real-time
// - Ask GMG searches both static JSX + live Firebase additions
// - Knowledge additions tagged with who added and when
//
// V3.1 FIXES (December 11, 2025):
// - Firebase sync for history (replaces localStorage)
// - Guest permissions updated: Ask + AI Checker only
// - Sign-in prompt modal after welcome scene for guests
// - Clear messaging about signing in for full features
//
// V3.0 EXTERNAL HOSTING VERSION:
// - Anthropic API key from environment variable
// - Firebase Authentication (Google Sign-In)
// - Role-based permissions (Founder, Alumni, Fellow)
// - User history saved to Firestore
// - Deployed on Vercel
//
// ROLE PERMISSIONS:
// - founder (Brandon, Eric): ALL tabs
// - alumni (BJ, Mike): Ask, Create, Check, Client Prep, Brainstorm, Knowledge (NO Job Apps)
// - fellow (Eli): Ask, Create, Knowledge only
// - guest (not signed in): Ask + AI Checker only
//
// API KEY: Set in .env file as REACT_APP_ANTHROPIC_API_KEY
// FIREBASE: Set in .env file (see setup guide)
//
// V2.2.3 FIXES (inherited):
// - DSDP researches client via web search BEFORE generating numbers
// - Footer only on last page
// - Removed horizontal divider lines
// - Cleaner design with proper white space
//
// V38.10 FEATURES (inherited):
// - Personas V3 (166 elements)
// - Popup delivery system for ALL tabs
// - Brainstorming Calls tab (password: bigbrain)
// - Individual cover letters optimized (no GMG_KNOWLEDGE)
// - Eric's kids corrected: EJ (7), Parker (5 GIRL), Evan (2)
//
// V38.8 MAJOR FEATURES:
// - FIXED: Search results now display properly (fallback for empty content)
// - FIXED: Check tab crash (defensive error handling)
// - FIXED: API model string corrected to claude-3-haiku-20240307
// - ADDED: Voice input button with recording indicator
// - ADDED: Attach file button (txt, md, csv, json)
// - ADDED: Read Aloud button (text-to-speech)
// - ADDED: Stop reading button
// - ADDED: Smart download (detects html, csv, letter, proposal formats)
// - ADDED: Quick local answers for Eric Lane, Brandon Pierce, GMG basics
// - ADDED: PARALLEL FUSION SEARCH (GMG + Web run simultaneously)
//   * GMG queries prioritize internal knowledge
//   * Current events queries prioritize web search  
//   * Intelligent merge when both have relevant results
//
// V38.3 STAR-002: UNIFIED CHAT UI
// - Single chat box for ALL interactions (roleplay, results, tracked changes)
// - Input at bottom, messages scroll up
// - Tabs above the chat box
// - Legacy 3-column layout preserved for prep/acquire tabs
//
// V38.2 STAR-001 COMPLETE: Full Eric Lane knowledge (530+ lines)
// V38.2 STAR-003 COMPLETE: 100+ roleplay scenarios (409 speaker lines)
// V38.2: Minimum roleplay delay (4 seconds)
//
// V37.9 CHANGES:
// - FIXED: Sports detection now includes 100+ teams (NFL, NBA, MLB, NHL, College)
// - FIXED: "did panthers win?" now triggers web search correctly
// - FIXED: parseJobDescriptionWithAI uses FULL GMG_KNOWLEDGE (V38 Fix #5)
// - FIXED: generatePitchDeckHTML uses FULL GMG_KNOWLEDGE without truncation (V38 Fix #6)
//
// V37.8 CHANGES:
// - FIXED: Web search detection expanded (now catches "find out when", "start date", "when does/is", "schedule")
// - FIXED: Sonnet 4 fallback when GMG knowledge doesn't have the answer (auto-tries web search)
// - Brave API key: BSAiO-gXitoh4oWzj0wROPZgyJZihaU (already configured)
//
// V27.1: Fixed greetings, sign-offs, Eric family, BJ GID title mirroring
// 
// V27 FEATURES (NEW):
// - Renamed to "GMG AI Check for Excellence (ACE)"
// - Client Acquisition Tab (Password Protected: GMG)
// - Applicant Profiles: Brandon, Eric, BJ with full instructions embedded
// - Job Description Analysis and Classification (WHO SHOULD APPLY)
// - Cover Letter Generation in each applicant's voice
// - Application Email Generation
// - Spreadsheet Row Output for GMG EBC Client Acquisition List
// - PDF Generation with GMG branding
// - Tier 4 "Competition for Affection" persona (15+ interactions)
// - Follow-up capability per application
// - Dynamic GID Title Mirroring for BJ applications
//
// V26 FEATURES (inherited):
// - Client Profiles Database (visual cards in Search GMG, no salary info)
// - Smart Suggestions (CLICKABLE - adds text to prompt when clicked)
// - Analytics Dashboard (track creates, checks, asks, improvement over time)
// - Voice Input Improvement (waveform, auto-punctuation, confirmation modal)
// - AI Learning from Corrections (capture edits to improve future checks)
// - Bug fixes: .docx extension, handleSave null checks, handleClearMemory reset
// - Welcome popup auto-scroll (messages now scroll into view)
// - Chat scroll fix (no longer jumps whole page during roleplay)
// - Slowed roleplay timing (800ms first, 2200ms subsequent - more readable)
// - Create tab now applies SAME standards as AI Check (cleanCreateOutput function)
// - Added AI Detection Avoidance rules (Rules 18-26 from Brandon AI proof writing)
// - Create output auto-cleans: em dashes, CTA endings, AI phrases, tech jargon
// - Create output enforces contractions (I'm, we're, don't, can't, etc.)
// - Create output converts colons to periods for AI detection avoidance
//
// V25 FEATURES (inherited):
// - PropTypes validation for type safety
// - Persistent session count (halves on refresh for persona progression)
// - Export results button (download as .txt)
// - Keyboard shortcuts (Ctrl+Enter submit, Ctrl+1/2/3 tabs, Escape close)
// - Live character/word count under textarea
// - Sound effects toggle (completion ding)
// - History log with localStorage (last 20 requests)
// - Bulk AI Check mode (separate with ---)
// - Comparison diff view (highlights changes)
//
// V24 FEATURES (inherited):
// - 36 unique roleplay scenarios (4 per tab x 3 tiers)
// - Intelligent AI Check delivery with issue summaries
// - Progressive persona tiers (professional snippy/flirty extreme)
// - Expanded AI phrase detection (40+ banned phrases)
//
// V23 FEATURES (inherited):
// - Full writing standards injection for intelligent rewrites (330+ lines)
// - Glassmorphism card effects with backdrop blur
// - Fresh high-quality avatar images (72x72) and logo (100x100)
// - Tab button names: Create (By GMG's Approved AI), See If You Sound Like AI Or Not, Search Internal GMG Data
// - Example-driven rewrite prompts for true voice transformation

import React, { useState, useEffect, useRef, useCallback } from 'react';
import { auth, signInWithGoogle, logOut, saveToHistory, getHistory, saveTierLevel, getTierLevel } from './firebase';
import { onAuthStateChanged } from 'firebase/auth';
import { getFirestore, collection, addDoc, getDocs, query, orderBy, onSnapshot, doc, setDoc, getDoc, where, updateDoc, deleteDoc } from 'firebase/firestore';
import { generateCoverLetterDocx, generateDSDPDocx } from './docxGenerator';
// V2.1: jsPDF for PDF generation (add to package.json: "jspdf": "^2.5.1")
import { jsPDF } from 'jspdf';

/* global mammoth, XLSX */

// ============================================
// V2.1: PDF GENERATION FUNCTIONS
// ============================================

const PDF_COLORS = {
  navy: [25, 25, 112],
  copper: [184, 115, 51],
  red: [139, 35, 50],
  white: [255, 255, 255],
  black: [0, 0, 0],
  gray: [100, 100, 100]
};

const PERSON_PDF_COLORS = {
  bj: [31, 71, 136],
  cj: [31, 71, 136],
  brandon: [139, 35, 50],
  eric: [25, 25, 112]
};

const generateCoverLetterPDF = (coverLetter, applicant, job) => {
  try {
    const doc = new jsPDF();
    const pageWidth = doc.internal.pageSize.getWidth();
    const margin = 20;
    const contentWidth = pageWidth - (margin * 2);
    
    // Header with applicant info
    const headerColor = PERSON_PDF_COLORS[applicant?.shortName?.toLowerCase()] || PDF_COLORS.navy;
    doc.setFillColor(...headerColor);
    doc.rect(0, 0, pageWidth, 35, 'F');
    
    // Applicant name in header
    doc.setTextColor(...PDF_COLORS.white);
    doc.setFontSize(18);
    doc.setFont('helvetica', 'bold');
    doc.text(applicant?.name || 'Applicant', margin, 20);
    
    // Contact info in header
    doc.setFontSize(10);
    doc.setFont('helvetica', 'normal');
    const contactLine = [applicant?.email, applicant?.phone].filter(Boolean).join(' | ');
    doc.text(contactLine, margin, 28);
    
    // Date
    doc.setTextColor(...PDF_COLORS.black);
    doc.setFontSize(11);
    const today = new Date().toLocaleDateString('en-US', { 
      year: 'numeric', 
      month: 'long', 
      day: 'numeric' 
    });
    doc.text(today, margin, 50);
    
    // Recipient info
    let yPosition = 60;
    if (job?.organization) {
      doc.text(job.organization, margin, yPosition);
      yPosition += 6;
    }
    if (job?.location) {
      doc.text(job.location, margin, yPosition);
      yPosition += 6;
    }
    
    // Subject line
    yPosition += 8;
    doc.setFont('helvetica', 'bold');
    doc.text(`Re: ${job?.title || 'Application'}`, margin, yPosition);
    
    // Cover letter body
    yPosition += 12;
    doc.setFont('helvetica', 'normal');
    doc.setFontSize(11);
    
    const lines = doc.splitTextToSize(coverLetter || '', contentWidth);
    const lineHeight = 6;
    const maxY = doc.internal.pageSize.getHeight() - 30;
    
    for (let i = 0; i < lines.length; i++) {
      if (yPosition > maxY) {
        doc.addPage();
        yPosition = margin;
      }
      doc.text(lines[i], margin, yPosition);
      yPosition += lineHeight;
    }
    
    // Footer
    const footerY = doc.internal.pageSize.getHeight() - 15;
    doc.setFontSize(8);
    doc.setTextColor(...PDF_COLORS.gray);
    doc.text('Generated by GMG ACE Portal', pageWidth / 2, footerY, { align: 'center' });
    
    // Generate filename
    const orgFirstWord = (job?.organization || 'Application').split(' ')[0].replace(/[^a-zA-Z]/g, '');
    const filename = `${(applicant?.name || 'Applicant').replace(/\s+/g, '_')}_CoverLetter_${orgFirstWord}.pdf`;
    
    doc.save(filename);
    return true;
  } catch (error) {
    console.error('PDF generation error:', error);
    alert('PDF generation failed. Make sure jsPDF is installed (npm install jspdf)');
    return false;
  }
};

const generateResumePDF = (applicant, job = null) => {
  try {
    const doc = new jsPDF();
    const pageWidth = doc.internal.pageSize.getWidth();
    const margin = 20;
    const contentWidth = pageWidth - (margin * 2);
    
    // Header with person-specific color
    const headerColor = PERSON_PDF_COLORS[applicant?.shortName?.toLowerCase()] || PDF_COLORS.navy;
    doc.setFillColor(...headerColor);
    doc.rect(0, 0, pageWidth, 40, 'F');
    
    // Name
    doc.setTextColor(...PDF_COLORS.white);
    doc.setFontSize(24);
    doc.setFont('helvetica', 'bold');
    doc.text(applicant?.name || 'Resume', margin, 22);
    
    // Title/Role
    doc.setFontSize(12);
    doc.setFont('helvetica', 'normal');
    doc.text(applicant?.currentRole || applicant?.title || '', margin, 32);
    
    // Contact bar
    doc.setFillColor(245, 245, 247);
    doc.rect(0, 40, pageWidth, 12, 'F');
    doc.setTextColor(...PDF_COLORS.gray);
    doc.setFontSize(9);
    const contactInfo = [applicant?.email, applicant?.phone, applicant?.location].filter(Boolean).join('  •  ');
    doc.text(contactInfo, pageWidth / 2, 48, { align: 'center' });
    
    let yPosition = 60;
    
    // Professional Summary
    if (applicant?.summary || applicant?.bio) {
      doc.setTextColor(...headerColor);
      doc.setFontSize(12);
      doc.setFont('helvetica', 'bold');
      doc.text('PROFESSIONAL SUMMARY', margin, yPosition);
      yPosition += 8;
      
      doc.setTextColor(...PDF_COLORS.black);
      doc.setFontSize(10);
      doc.setFont('helvetica', 'normal');
      const summaryLines = doc.splitTextToSize(applicant?.summary || applicant?.bio || '', contentWidth);
      doc.text(summaryLines, margin, yPosition);
      yPosition += summaryLines.length * 5 + 10;
    }
    
    // Key Points / Skills
    if (applicant?.keyPoints && applicant.keyPoints.length > 0) {
      doc.setTextColor(...headerColor);
      doc.setFontSize(12);
      doc.setFont('helvetica', 'bold');
      doc.text('KEY QUALIFICATIONS', margin, yPosition);
      yPosition += 8;
      
      doc.setTextColor(...PDF_COLORS.black);
      doc.setFontSize(10);
      doc.setFont('helvetica', 'normal');
      
      applicant.keyPoints.forEach(point => {
        if (yPosition > 270) {
          doc.addPage();
          yPosition = margin;
        }
        const bulletLines = doc.splitTextToSize(`• ${point}`, contentWidth - 5);
        doc.text(bulletLines, margin + 5, yPosition);
        yPosition += bulletLines.length * 5 + 3;
      });
      yPosition += 7;
    }
    
    // Experience
    doc.setTextColor(...headerColor);
    doc.setFontSize(12);
    doc.setFont('helvetica', 'bold');
    doc.text('PROFESSIONAL EXPERIENCE', margin, yPosition);
    yPosition += 8;
    
    doc.setTextColor(...PDF_COLORS.black);
    doc.setFontSize(10);
    doc.setFont('helvetica', 'normal');
    
    if (applicant?.currentOrg) {
      doc.setFont('helvetica', 'bold');
      doc.text(applicant.currentOrg, margin, yPosition);
      doc.setFont('helvetica', 'normal');
      yPosition += 5;
      doc.text(applicant?.currentRole || 'Professional', margin, yPosition);
      yPosition += 10;
    }
    
    // Footer
    const footerY = doc.internal.pageSize.getHeight() - 15;
    doc.setFontSize(8);
    doc.setTextColor(...PDF_COLORS.gray);
    doc.text('Generated by GMG ACE Portal', pageWidth / 2, footerY, { align: 'center' });
    
    const filename = `${(applicant?.name || 'Applicant').replace(/\s+/g, '_')}_Resume.pdf`;
    doc.save(filename);
    return true;
  } catch (error) {
    console.error('Resume PDF generation error:', error);
    alert('PDF generation failed. Make sure jsPDF is installed (npm install jspdf)');
    return false;
  }
};

// ============================================
// V7.0 VERSION CHECK & FORCE REFRESH
// ============================================

const APP_VERSION = '2.15';

// V7.0: Force refresh if version mismatch (prevents blank white screen from stale PWA cache)
(function checkVersionAndRefresh() {
  const cachedVersion = localStorage.getItem('gmg_ace_version');
  
  if (cachedVersion && cachedVersion !== APP_VERSION) {
    console.log(`Version mismatch: cached ${cachedVersion}, current ${APP_VERSION}. Force refreshing...`);
    
    // Clear all caches
    localStorage.removeItem('gmg_ace_version');
    sessionStorage.clear();
    
    // Clear service worker caches
    if ('caches' in window) {
      caches.keys().then(names => {
        names.forEach(name => caches.delete(name));
      });
    }
    
    // Unregister service workers
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.getRegistrations().then(registrations => {
        registrations.forEach(registration => registration.unregister());
      });
    }
    
    // Force reload from server (bypass cache)
    window.location.reload(true);
    return;
  }
  
  // Store current version
  localStorage.setItem('gmg_ace_version', APP_VERSION);
})();

// ============================================
// V3.0 EXTERNAL HOSTING: API KEY & FIREBASE
// ============================================

// Anthropic API Key (from environment variable for security)
const ANTHROPIC_API_KEY = process.env.REACT_APP_ANTHROPIC_API_KEY || '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';

// V4.5: Development mode check for conditional logging
const IS_DEV = process.env.NODE_ENV === 'development';
const devLog = (...args) => { if (IS_DEV) console.log(...args); };
const devWarn = (...args) => { if (IS_DEV) console.warn(...args); };
const devError = (...args) => { if (IS_DEV) console.error(...args); };

// V4.1: Centralized model configuration for easy updates
const MODEL_CONFIG = {
  fast: 'claude-3-haiku-20240307',
  quality: 'claude-sonnet-4-20250514'
};

// V4.1: Centralized sports teams list (NFL, NBA, MLB, NHL, College)
const SPORTS_TEAMS = [
  // NFL
  'panthers', 'saints', 'patriots', 'eagles', 'cowboys', 'chiefs', 'bills', 'ravens',
  'steelers', 'broncos', 'raiders', 'chargers', 'dolphins', 'jets', 'giants', 'commanders',
  'bears', 'packers', 'vikings', 'lions', 'falcons', 'buccaneers', 'bucs', 'seahawks',
  'niners', '49ers', 'cardinals', 'rams', 'titans', 'colts', 'jaguars', 'texans', 'bengals', 'browns',
  // NBA
  'lakers', 'celtics', 'warriors', 'heat', 'bulls', 'knicks', 'nets', 'sixers', '76ers',
  'suns', 'mavericks', 'mavs', 'rockets', 'spurs', 'nuggets', 'clippers', 'thunder',
  'bucks', 'raptors', 'hornets', 'hawks', 'pistons', 'pacers', 'cavaliers', 'cavs',
  'magic', 'wizards', 'timberwolves', 'wolves', 'blazers', 'trail blazers', 'jazz', 'pelicans', 'grizzlies', 'kings',
  // MLB
  'yankees', 'red sox', 'dodgers', 'cubs', 'mets', 'braves', 'phillies', 'cardinals',
  'astros', 'padres', 'brewers', 'guardians', 'twins', 'mariners', 'rangers',
  'orioles', 'rays', 'blue jays', 'white sox', 'tigers', 'royals', 'athletics', 'angels',
  'rockies', 'diamondbacks', 'd-backs', 'marlins', 'nationals', 'reds', 'pirates',
  // NHL
  'hurricanes', 'bruins', 'maple leafs', 'canadiens', 'habs', 'penguins', 'capitals', 'caps',
  'lightning', 'rangers', 'islanders', 'devils', 'flyers', 'blue jackets',
  'blackhawks', 'red wings', 'predators', 'preds', 'blues', 'wild', 'flames',
  'oilers', 'canucks', 'kraken', 'golden knights', 'knights', 'coyotes', 'sharks', 'ducks', 'avalanche',
  // College
  'tar heels', 'unc', 'duke', 'nc state', 'wolfpack', 'clemson', 'alabama', 'crimson tide',
  'georgia', 'bulldogs', 'ohio state', 'buckeyes', 'michigan', 'wolverines', 'usc', 'trojans',
  'notre dame', 'texas', 'longhorns', 'oklahoma', 'sooners', 'lsu', 'tigers', 'florida', 'gators',
  'auburn', 'tennessee', 'vols', 'kentucky', 'wildcats', 'kansas', 'jayhawks', 'gonzaga'
];

// ============================================
// V2.1: TIERED REWRITE SYSTEM
// ============================================
const REWRITE_TIERS = {
  A: {
    name: "Have Brandon go crazy and change everything",
    description: "Full rewrite to GMG's signature voice (recommended for most things)",
    strictness: 'maximum',
    removes: ['warmth markers', 'AI phrases', 'soft CTAs', 'meta-commentary', 'redundancy']
  },
  B: {
    name: "Tell Brandon to mark up only the AI things",
    description: "Keep tone/warmth, remove AI tells (recommended where tone matters)",
    strictness: 'moderate',
    keeps: ['It means a lot', 'soft CTAs', 'formal warmth'],
    removes: ['obvious AI tells', 'tech jargon', 'SUPER BAN phrases']
  },
  C: {
    name: "Just fix the stuff that'll get me fired",
    description: "Only em dashes, explicit CTAs, slang - minimal changes",
    strictness: 'minimal',
    removes: ['em dashes', 'explicit CTAs', 'slang only']
  },
  D: {
    name: "Show me what's wrong but don't touch anything",
    description: "Flag issues only - you decide what to fix",
    strictness: 'none',
    action: 'report only'
  }
};

// ============================================
// V2.10: ADMIN PERSONA DELIVERY SYSTEM
// ============================================
// Instead of AI responding directly, users can choose to have
// work delivered AS executive assistants on behalf of founders.
// Claudette Aims = Claude AI (Cl-AUDE-tte)
// Chanet Graves = ChatGPT (Ch-at G-PT, G for Graves)
// ============================================

// Brandon's complete writing rules (embedded for compound effect)
const BRANDON_WRITING_RULES = `
BRANDON'S WRITING STANDARDS (FIREABLE OFFENSES - NEVER DO THESE):

1. EM DASHES ARE BANNED
Em dashes (—) and double dashes (--) are completely banned. Not reduced. Banned.
WRONG: "The project is moving forward — we should connect soon."
RIGHT: "The project is moving forward, and I would love if we could connect soon."
Replace with a comma, a period, or rewrite the sentence.

2. CHOPPY TECH BRO STYLE IS BANNED
Short punchy sentences trying to sound direct are banned.
BANNED: "Launch fast. Iterate quickly. Ship features."
BANNED: "Problem identified. Solution proposed. Next steps outlined."
RIGHT: "We should launch quickly and iterate based on what we learn, then scale what's actually working."
If you can connect two thoughts with a comma, do it. Sentences under five words standing alone are probably wrong.

3. ROBOTIC PARALLEL STRUCTURE IS BANNED
Perfect balanced comparisons are banned.
BANNED: "This isn't X. This is Y."
BANNED: "Could be a job posting. Could be a direct outreach. Could be a response."
Real writing is messier. Break the symmetry.

4. GREETING BEFORE NAME
Never start with just the name.
WRONG: "Eric,"
RIGHT: "Hey Eric,"

5. NO CALL-TO-ACTION ENDINGS
Just end. Don't ask for anything.
BANNED: "Looking forward to hearing from you"
BANNED: "Let me know if you have any questions"
BANNED: "Please don't hesitate to reach out"
BANNED: "Feel free to reach out anytime"
RIGHT: Just end with your last sentence, then "Thanks," and signature.

6. NO SLANG
BANNED: "stuff" (use specific nouns)
BANNED: "holds that down" (use "manages")
BANNED: "grind", "dope", "fire", "lit", "vibes"

7. NO CONSULTANT JARGON
BANNED: "leverage" (use "use")
BANNED: "synergize", "circle back", "bandwidth", "deep dive"
BANNED: "deliverables" (name the specific thing)
BANNED: "stakeholders" (name who you mean)
BANNED: "Furthermore", "Additionally", "Moreover"
BANNED: "In conclusion", "To summarize"

8. NO META COMMENTARY
Never explain what you're doing inside the deliverable. Just do it.
BANNED: "This document outlines the terms..."
BANNED: "Below you'll find the key metrics..."
BANNED: "I've organized this into three sections..."
BANNED: "In this email, I wanted to share..."
Just start. Don't announce. Don't explain. Don't introduce.

9. BANNED AI PHRASES
BANNED: "Here's the thing", "I genuinely appreciate", "deeply resonated"
BANNED: "I'd be happy to", "I'm excited to share", "It's worth noting"
BANNED: "That said", "Moving forward", "At the end of the day"
BANNED: "Game-changer", "Touch base", "On my radar"
BANNED: "walked away feeling energized", "left our call excited"

10. COMPLETE SENTENCES WITH NATURAL FLOW
Brandon writes in complete sentences that connect related thoughts with commas.
WRONG: "The project is moving forward. We should connect soon. I'll send the details."
RIGHT: "The project is moving forward, so we should probably connect soon and I can send you the details then."

11. SIMPLE CLOSINGS ONLY
Use: "Thanks," or "Best," or "Talk soon,"
NEVER: "Best regards," "Sincerely," "Warmly," "With gratitude," "Looking forward,"

12. FORMATTING BRANDON HATES
- Excessive headers breaking up short content
- Bullet points when prose flows better
- Rhetorical questions at paragraph ends
- Single-sentence paragraphs trying to be punchy

THE UNDERLYING PRINCIPLE:
Write like you're talking across a table at a coffee shop. Complete sentences that flow naturally.
Warm but professional tone. Specific details, not vague corporate speak.
Middle school reading level for accessibility. No slang, no jargon, just clear professional language.
`;

const DELIVERY_PERSONAS = {
  brandon: {
    id: 'brandon',
    name: "Brandon Pierce Sr.",
    type: "direct",
    title: "Co-Founder and Managing Partner",
    email: "brandon@globalmajoritygroup.com",
    systemPrompt: `You are Brandon Pierce Sr., Co-Founder and Managing Partner of Global Majority Group.

Write directly in Brandon's voice. First person. Professional but warm.

${BRANDON_WRITING_RULES}

BRANDON'S DIRECT VOICE:
- Confident and direct
- Uses "I" statements naturally
- Warm but professional
- Specific and concrete
- Never apologetic or uncertain

SIGNATURE:
Brandon Pierce Sr.
Co-Founder and Managing Partner
Global Majority Group
brandon@globalmajoritygroup.com`
  },
  
  eric: {
    id: 'eric',
    name: "Dr. Eric Lane Sr.",
    type: "direct",
    title: "Co-Founder and Managing Partner",
    email: "eric@globalmajoritygroup.com",
    systemPrompt: `You are Dr. Eric Lane Sr., Co-Founder and Managing Partner of Global Majority Group.

Write directly in Eric's voice. First person. Academic background but accessible.

${BRANDON_WRITING_RULES}

ERIC'S DIRECT VOICE:
- Thoughtful and measured
- Uses "I" statements naturally
- Draws on academic and sports industry expertise
- Collaborative tone
- Client-relationship focused

SIGNATURE:
Dr. Eric Lane Sr.
Co-Founder and Managing Partner
Global Majority Group
eric@globalmajoritygroup.com`
  },
  
  claudette: {
    id: 'claudette',
    name: "Claudette Aims",
    type: "admin",
    boss: "Brandon Pierce Sr.",
    bossShort: "Brandon",
    title: "Sr. Executive Assistant to Brandon Pierce Sr.",
    email: "claudette@globalmajoritygroup.com",
    systemPrompt: `You are Claudette Aims, Sr. Executive Assistant to Brandon Pierce Sr. at Global Majority Group.

CORE IDENTITY:
- You work directly for Brandon and handle his communications
- You've worked with Brandon long enough to question decisions and offer strategic input
- You are efficient, direct, and occasionally push back with professional confidence
- You complete tasks on Brandon's behalf and deliver them to others

WRITING VOICE:
- Write in first person as Claudette ("I prepared..." "I advised..." "I flagged...")
- Reference Brandon in third person ("Brandon asked me to..." "Brandon was thinking..." "Brandon wanted...")
- Professional but not overly formal
- Confident, not apologetic
- Never say "I hope this helps" or "Please don't hesitate"

DELIVERY FORMAT (ALWAYS FOLLOW THIS STRUCTURE):
1. Greeting to recipient ("Hey Eric," or "Hi [Name],")
2. Context line ("Brandon asked me to send over..." or "Brandon wanted me to prepare...")
3. Main content with what was done and why
4. Strategic question if applicable ("Brandon had one question..." or "I advised X because Y...")
5. Closing with any action items ("Let me know if you need any clarifications.")
6. Signature block

${BRANDON_WRITING_RULES}

CLAUDETTE-SPECIFIC PHRASES TO USE:
- "Brandon asked me to..."
- "Brandon was leaning towards X, but I advised Y because..."
- "I flagged this for Brandon's review"
- "Brandon mentioned he wants your input on..."
- "One question Brandon had was..."
- "I advised [action] because [reason]"
- "Let me know if you need any clarifications"
- "All documents are attached"

CLAUDETTE-SPECIFIC PHRASES TO AVOID:
- "I hope this helps"
- "Please don't hesitate to reach out"
- "I'm happy to help"
- "Feel free to contact me"
- Anything that sounds like an AI assistant
- Explaining what Claude did (you are Claudette, not Claude)

SIGNATURE (ALWAYS END WITH THIS):
Thanks,

Claudette Aims
Sr. Executive Assistant to Brandon Pierce Sr.
Global Majority Group`
  },
  
  chanet: {
    id: 'chanet',
    name: "Chanet Graves",
    type: "admin",
    boss: "Dr. Eric Lane Sr.",
    bossShort: "Eric",
    title: "Sr. Executive Assistant to Dr. Eric Lane Sr.",
    email: "chanet@globalmajoritygroup.com",
    systemPrompt: `You are Chanet Graves, Sr. Executive Assistant to Dr. Eric Lane Sr. at Global Majority Group.

CORE IDENTITY:
- You support Eric's client relationships and Sports Division work
- You coordinate between Eric and Brandon's operations (you know Claudette)
- You are supportive, organized, and diplomatic
- You handle Eric's deliverables and communications

WRITING VOICE:
- Write in first person as Chanet ("I prepared..." "I coordinated...")
- Reference Eric in third person ("Eric asked me to..." "Eric wanted..." "Eric mentioned...")
- Professional and diplomatic
- Facilitates rather than directs
- Coordinates cross-team when needed

DELIVERY FORMAT (ALWAYS FOLLOW THIS STRUCTURE):
1. Greeting to recipient ("Hey Brandon," or "Hi [Name],")
2. Context line ("Eric asked me to send over..." or "Eric wanted me to prepare...")
3. Main content with what was done and the thinking behind it
4. Decision point if applicable ("Eric wanted your input on..." or "Eric's thinking [approach]...")
5. Coordination notes if cross-team ("I've also copied..." or "I'm coordinating with Claudette...")
6. Closing ("Let me know if you have questions.")
7. Signature block

${BRANDON_WRITING_RULES}

CHANET-SPECIFIC PHRASES TO USE:
- "Eric asked me to send this over for your review"
- "Eric wanted your input before finalizing"
- "Eric mentioned this aligns with the Sports Division approach"
- "I'm coordinating with Claudette on the timeline"
- "Eric was thinking [approach], but wanted to make sure it aligns with..."
- "I've also copied [person] on this since [reason]"
- "Let me know if you have questions"

CHANET-SPECIFIC PHRASES TO AVOID:
- "I hope this helps"
- "Please don't hesitate to reach out"
- Anything that sounds like an AI assistant
- Being too directive (Chanet facilitates, doesn't direct)

SIGNATURE (ALWAYS END WITH THIS):
Thanks,

Chanet Graves
Sr. Executive Assistant to Dr. Eric Lane Sr.
Global Majority Group`
  }
};

// V2.10: Tab-specific delivery persona defaults
const DELIVERY_PERSONA_DEFAULTS = {
  create: true,    // ON by default
  check: true,     // ON by default
  prep: true,      // ON by default
  ask: false,      // OFF by default
  knowledge: false, // OFF by default
  acquire: null    // Not available
};

// ============================================
// V2.11: ADMIN PORTAL CONFIGURATION
// ============================================

// Admin users who can access the admin portal
const ADMIN_USERS = [
  'brandon@globalmajoritygroup.com',
  'bpierce@globalmajoritygroup.com',
  'brandonjpiercesr@gmail.com',
  'eric@globalmajoritygroup.com',
  'elane@globalmajoritygroup.com'
];

// Admin portal sections
const ADMIN_SECTIONS = {
  dashboard: { name: 'Dashboard', icon: '📊', description: 'Overview and quick stats' },
  users: { name: 'Users', icon: '👥', description: 'Manage team members' },
  analytics: { name: 'Analytics', icon: '📈', description: 'Usage trends and insights' },
  templates: { name: 'Templates', icon: '📄', description: 'Global template library' },
  phrases: { name: 'Banned Phrases', icon: '🚫', description: 'Manage AI detection rules' },
  audit: { name: 'Audit Log', icon: '📋', description: 'Track all actions' },
  settings: { name: 'Settings', icon: '⚙️', description: 'App configuration' }
};

// ============================================
// V2.11.1: SERVER-SIDE GMAIL CONFIGURATION
// ============================================
// Claudette and Chanet are REAL Google Workspace accounts.
// Refresh tokens are stored in Vercel environment variables.
// No OAuth popup needed - server handles everything.
//
// Required Vercel Environment Variables:
// - GOOGLE_CLIENT_ID (OAuth client ID)
// - GOOGLE_CLIENT_SECRET (OAuth client secret)
// - CLAUDETTE_REFRESH_TOKEN (from one-time setup)
// - CHANET_REFRESH_TOKEN (from one-time setup, optional)
// ============================================

// Email personas with their actual accounts
const EMAIL_ACCOUNTS = {
  claudette: {
    email: 'claudette@globalmajoritygroup.com',
    name: 'Claudette Aims',
    title: 'Sr. Executive Assistant to Brandon Pierce Sr.',
    envToken: 'CLAUDETTE_REFRESH_TOKEN'
  },
  chanet: {
    email: 'chanet@globalmajoritygroup.com',
    name: 'Chanet Graves',
    title: 'Sr. Executive Assistant to Dr. Eric Lane Sr.',
    envToken: 'CHANET_REFRESH_TOKEN'
  }
};

const TAB_TIPS = {
  create: [
    { speaker: 'claudette', text: "Pro tip: I check everything for em dashes before you see it." },
    { speaker: 'chanet', text: "The more context you give me, the better the output. Don't be shy!" },
    { speaker: 'claudette', text: "Remember: middle school reading level. Simple but not dumb." },
    { speaker: 'chanet', text: "Say 'pitch deck for [Client]' and I'll build the whole thing." },
    { speaker: 'claudette', text: "I can create DSDPs, pitch decks, emails, and proposals. What do you need?" }
  ],
  check: [
    { speaker: 'claudette', text: "Paste any writing. I'll find every AI phrase and banned pattern." },
    { speaker: 'chanet', text: "The fire emoji count shows how many issues I found. Zero fires = perfect!" },
    { speaker: 'claudette', text: "I'll rewrite it for you if you want. Just ask." },
    { speaker: 'chanet', text: "Separate multiple documents with --- for batch checking." },
    { speaker: 'claudette', text: "Pro tip: Read your writing out loud. If it sounds robotic, I'll catch it." }
  ],
  ask: [
    { speaker: 'chanet', text: "Ask me anything about GMG, our clients, or fundraising strategies." },
    { speaker: 'claudette', text: "I search our knowledge base AND the web if I don't have the answer." },
    { speaker: 'chanet', text: "Try asking about Eric's background, Brandon's Coca-Cola days, or the Recipe Pitch." },
    { speaker: 'claudette', text: "I know the 60-Day Fundraising Course inside and out." },
    { speaker: 'chanet', text: "Sports scores, current events, fundraising facts. I've got it all." }
  ],
  prep: [
    { speaker: 'claudette', text: "Tell me the client name and I'll build a complete prep package." },
    { speaker: 'chanet', text: "I research the organization before creating anything." },
    { speaker: 'claudette', text: "DSDPs include real benchmarks and revenue projections." },
    { speaker: 'chanet', text: "Say 'pitch deck for [Client]' or 'DSDP for [Client]' to get started." },
    { speaker: 'claudette', text: "Every document uses GMG's signature formatting and branding." }
  ],
  acquire: [
    { speaker: 'chanet', text: "Paste a job URL or description and I'll parse everything." },
    { speaker: 'claudette', text: "I'll recommend who should apply: Brandon, Eric, BJ, CJ, or GMG Flip." },
    { speaker: 'chanet', text: "Say 'me' to apply as yourself, or pick a team member." },
    { speaker: 'claudette', text: "Cover letters download as PDF or DOCX. Your choice." },
    { speaker: 'chanet', text: "Say 'thank you' for interview follow-up letters, 'salary' for negotiation emails." }
  ],
  brainstorm: [
    { speaker: 'claudette', text: "This is password protected. Ask Brandon or Eric for access." },
    { speaker: 'chanet', text: "Used for internal call prep and strategic planning." }
  ],
  knowledge: [
    { speaker: 'chanet', text: "Add clients, contacts, strategies, and notes here." },
    { speaker: 'claudette', text: "Everything you add is searchable in Ask GMG immediately." },
    { speaker: 'chanet', text: "Your additions are tagged with your name and timestamp." },
    { speaker: 'claudette', text: "The whole team can see and search what you add." },
    { speaker: 'chanet', text: "Add meeting notes, client preferences, anything worth remembering." }
  ]
};

// DEBUG: Log API key on load (remove after testing)
// DEV: devLog('=== API DEBUG ===');
// DEV: devLog('API Key loaded:', ANTHROPIC_API_KEY ? 'YES' : 'NO');
// DEV: devLog('API Key length:', ANTHROPIC_API_KEY?.length);

// ============================================
// V3.2 LIVE KNOWLEDGE SYNC
// ============================================

// Knowledge categories
const KNOWLEDGE_CATEGORIES = [
  { value: 'client', label: 'Client Info', description: 'Organization details, history, preferences' },
  { value: 'contact', label: 'Contact', description: 'Person name, email, phone, role' },
  { value: 'strategy', label: 'Strategy Note', description: 'Approach, tactics, lessons learned' },
  { value: 'meeting', label: 'Meeting Note', description: 'Key takeaways from calls or meetings' },
  { value: 'process', label: 'Process/How-To', description: 'Steps, procedures, best practices' },
  { value: 'other', label: 'Other', description: 'Anything else worth remembering' }
];

// Firebase knowledge functions (will be initialized in component)
let db = null;
try {
  db = getFirestore();
} catch (e) {
  devLog('Firestore not available in this environment');
}

// Save knowledge addition to Firebase
const saveKnowledgeAddition = async (data) => {
  if (!db) return null;
  try {
    const docRef = await addDoc(collection(db, 'knowledge_additions'), {
      ...data,
      addedAt: new Date().toISOString(),
      searchText: `${data.title} ${data.content} ${data.category}`.toLowerCase()
    });
    return docRef.id;
  } catch (error) {
    devError('Error saving knowledge:', error);
    return null;
  }
};

// Load all knowledge additions from Firebase
const loadKnowledgeAdditions = async () => {
  if (!db) return [];
  try {
    const q = query(collection(db, 'knowledge_additions'), orderBy('addedAt', 'desc'));
    const snapshot = await getDocs(q);
    return snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
  } catch (error) {
    devError('Error loading knowledge:', error);
    return [];
  }
};

// Subscribe to real-time knowledge updates
const subscribeToKnowledge = (callback) => {
  if (!db) return () => {};
  try {
    const q = query(collection(db, 'knowledge_additions'), orderBy('addedAt', 'desc'));
    return onSnapshot(q, (snapshot) => {
      const additions = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      callback(additions);
    });
  } catch (error) {
    devError('Error subscribing to knowledge:', error);
    return () => {};
  }
};

// V3.6: Save job application to Firebase for tracking
const saveApplication = async (userId, applicationData) => {
  if (!db || !userId) return null;
  try {
    // V5.1: Save to personal applications collection
    const docRef = await addDoc(collection(db, 'applications'), {
      userId,
      company: applicationData.company || 'Unknown Company',
      position: applicationData.position || 'Unknown Position',
      salary: applicationData.salary || 'Not Listed',
      location: applicationData.location || 'Not Listed',
      url: applicationData.url || '',
      applicant: applicationData.applicant || 'Brandon',
      classification: applicationData.classification || '',
      status: 'APPLIED',
      appliedDate: new Date().toISOString(),
      lastUpdated: new Date().toISOString(),
      coverLetterLength: applicationData.coverLetterLength || 0,
      notes: ''
    });
    
    // V5.1: ALSO save to shared team log (visible to Brandon and Eric)
    await addDoc(collection(db, 'team_applications_log'), {
      applicantName: applicationData.applicant || 'Unknown',
      applicantEmail: applicationData.applicantEmail || '',
      company: applicationData.company || 'Unknown Company',
      position: applicationData.position || 'Unknown Position',
      salary: applicationData.salary || 'Not Listed',
      location: applicationData.location || 'Not Listed',
      appliedAt: new Date().toISOString(),
      submittedBy: userId,
      status: 'APPLIED'
    });
    
    return docRef.id;
  } catch (error) {
    devError('Error saving application:', error);
    return null;
  }
};

// ============================================
// V3.0 TEAM PROFILES (for cover letter generation)
// ============================================

const TEAM_PROFILES = [
  { shortName: 'Brandon', name: 'Brandon Pierce', email: 'brandon@globalmajoritygroup.com', altEmails: ['brandonjpiercesr@gmail.com'] },
  { shortName: 'Eric', name: 'Eric Lane', email: 'eric@globalmajoritygroup.com', altEmails: ['ericreeselanesr@gmail.com', 'ericreecelanesr@gmail.com', 'eric@gidconsulting.co', 'ericlane@gidconsulting.co'] },
  { shortName: 'BJ', name: 'Bryan Pierce Jr.', email: 'bj@globalmajoritygroup.com', altEmails: ['thebjpierce@icloud.com', 'bryanjpiercejr@gmail.com', 'thebjpierce@gmail.com'] },
  // V4.3: Added CJ Moore - applies to same roles as BJ
  { shortName: 'CJ', name: 'C.J. Moore', email: 'cj@globalmajoritygroup.com', altEmails: ['cj.d.moore32@gmail.com'] }
];

// V3.3: Get team profile from logged-in user email
const getProfileFromEmail = (email) => {
  if (!email) return null;
  const lowerEmail = email.toLowerCase();
  return TEAM_PROFILES.find(p => 
    p.email.toLowerCase() === lowerEmail || 
    (p.altEmails && p.altEmails.some(e => e.toLowerCase() === lowerEmail))
  );
};

// V3.3: Get friendly greeting name from user
const getUserFirstName = (user) => {
  if (!user) return 'there';
  if (user.displayName) return user.displayName.split(' ')[0];
  const profile = getProfileFromEmail(user.email);
  if (profile) return profile.shortName;
  return user.email?.split('@')[0] || 'there';
};

// ============================================
// V4.4: getTierInterlude MOVED to line ~5150 (after persona constants)
// See getEnhancedTierInterlude for the actual implementation
// ============================================

// ============================================
// V3.0 ROLE-BASED PERMISSIONS SYSTEM
// ============================================

const USER_ROLES = {
  // Brandon - multiple emails
  'brandonjpiercesr@gmail.com': 'founder',
  'brandon@globalmajoritygroup.com': 'founder',
  
  // Eric - multiple emails
  'ericreeselanesr@gmail.com': 'founder',
  'ericreecelanesr@gmail.com': 'founder',
  'eric@gidconsulting.co': 'founder',
  'ericlane@gidconsulting.co': 'founder',
  'eric@globalmajoritygroup.com': 'founder',
  
  // BJ - multiple emails
  'thebjpierce@icloud.com': 'alumni',
  'bryanjpiercejr@gmail.com': 'alumni',
  'thebjpierce@gmail.com': 'alumni',
  
  // Mike
  'mike@globalmajoritygroup.com': 'alumni',
  
  // Eli - multiple emails
  'eli@globalmajoritygroup.com': 'fellow',
  'eli.cooley@gmail.com': 'fellow'
};

// V3.0: FOR NOW - Everyone gets all tabs
// Change this later when you want to restrict access
const ROLE_PERMISSIONS = {
  founder: ['ask', 'create', 'check', 'prep', 'acquire', 'brainstorm', 'knowledge'],
  alumni: ['ask', 'create', 'check', 'prep', 'brainstorm', 'knowledge'],
  fellow: ['ask', 'create', 'knowledge'],
  guest: ['ask', 'check']  // V3.1: Guests can use Ask + AI Checker only
};

const getUserRole = (email) => {
  if (!email) return 'guest';
  const normalizedEmail = email.toLowerCase();
  return USER_ROLES[normalizedEmail] || 'guest';
};

const canAccessTab = (email, tab) => {
  const role = getUserRole(email);
  const permissions = ROLE_PERMISSIONS[role] || ROLE_PERMISSIONS.guest;
  return permissions.includes(tab);
};

// ============================================
// V3.0 API CALL WRAPPER (adds auth header)
// ============================================

// Helper to get API headers with CORS support for direct browser access
const getApiHeaders = () => {
  return { 
    'Content-Type': 'application/json',
    'x-api-key': ANTHROPIC_API_KEY,
    'anthropic-version': '2023-06-01',
    'anthropic-dangerous-direct-browser-access': 'true'
  };
};

const makeAnthropicRequest = async (body) => {
  const response = await fetch('https://api.anthropic.com/v1/messages', {
    method: 'POST',
    headers: getApiHeaders(),
    body: JSON.stringify(body)
  });
  
  if (!response.ok) {
    const error = await response.text();
    throw new Error(`API request failed: ${response.status} - ${error}`);
  }
  
  return response.json();
};

// V2.9: Jina AI Reader for robust URL fetching
// This service can fetch ANY URL and convert it to clean text
// Works on sites that block standard scraping (Idealist, Indeed, etc.)
const fetchUrlWithJina = async (url) => {
  try {
    // Jina Reader API - prepend r.jina.ai to any URL
    const jinaUrl = `https://r.jina.ai/${url}`;
    
    const response = await fetch(jinaUrl, {
      headers: {
        'Accept': 'text/plain',
        'x-timeout': '30',
        'x-no-cache': 'true'
      }
    });
    
    if (!response.ok) {
      throw new Error(`Jina fetch failed: ${response.status}`);
    }
    
    const content = await response.text();
    
    // Check if we got meaningful content
    if (content && content.length > 200) {
      return { success: true, content, source: 'jina' };
    }
    
    return { success: false, error: 'Content too short', source: 'jina' };
  } catch (error) {
    console.warn('Jina fetch error:', error.message);
    return { success: false, error: error.message, source: 'jina' };
  }
};

// V2.9: Multi-strategy URL fetcher with fallbacks
const fetchJobUrlContent = async (url) => {
  // Strategy 1: Try Jina AI first (most reliable)
  const jinaResult = await fetchUrlWithJina(url);
  if (jinaResult.success) {
    return jinaResult;
  }
  
  // Strategy 2: Try Claude web_fetch as fallback
  try {
    const response = await fetch('https://api.anthropic.com/v1/messages', {
      method: 'POST',
      headers: getApiHeaders(),
      body: JSON.stringify({
        model: MODEL_CONFIG.quality,
        max_tokens: 8000,
        messages: [{
          role: 'user',
          content: `Fetch the complete content from this URL: ${url}
          
Return the FULL page content as plain text. Include all job details, requirements, salary, and application instructions.`
        }],
        tools: [{ type: 'web_fetch_20250305', name: 'web_fetch' }]
      })
    });
    
    if (response.ok) {
      const data = await response.json();
      let content = '';
      if (data.content && Array.isArray(data.content)) {
        for (const block of data.content) {
          if (block.type === 'text') content += block.text;
        }
      }
      
      if (content && content.length > 200) {
        return { success: true, content, source: 'claude' };
      }
    }
  } catch (error) {
    console.warn('Claude web_fetch error:', error.message);
  }
  
  // Both strategies failed
  return { 
    success: false, 
    error: 'Could not fetch URL content. The site may be blocking automated access.',
    source: 'none'
  };
};

// PropTypes for type safety (graceful fallback if not available)
let PropTypes;
try {
 PropTypes = require('prop-types');
} catch (e) {
 // PropTypes not available in artifact environment - use empty object
 PropTypes = { string: {}, number: {}, bool: {}, func: {}, object: {}, array: {} };
}

// ============================================
// SECTION 1: BASE64 IMAGES (V23 - HIGH QUALITY)
// ============================================

const IMAGES = {
 // GMG Logo - 80x80
 logo: 'data:image/jpeg;base64,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',
 
 // Chanet Avatar - 72x72
 chanet: 'data:image/jpeg;base64,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',
 
 // Claudette Avatar - 72x72
 claudette: 'data:image/jpeg;base64,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'
};

// ============================================
// SECTION 2: BRAND COLORS (FROM V17)
// ============================================

const COLORS = {
 // Primary Brand
 navy: '#191970',
 copper: '#B87333',
 platinum: '#E5E4E2',
 pearl: '#F5F5F7',  // V2.7: Changed from cream #F0EAD6 to proper gray
 
 // Aliases for convenience
 primary: '#191970', // Same as navy
 secondary: '#B87333', // Same as copper
 
 // Background
 beige: '#F5EBE0',
 white: '#FFFFFF',
 
 // Accents (for hover effects)
 purple: '#9B8BA8',
 pink: '#E8B4B8',
 gold: '#D4AF37',
 silver: '#E5E4E2',
 
 // Severity Scale (Brandon Would Hate This)
 critical: '#dc2626',
 high: '#ea580c',
 medium: '#ca8a04',
 low: '#65a30d',
 success: '#16a34a',
 
 // UI Elements
 cardBorder: '#D4A574',
 cardBg: '#FAF8F3',
 textBody: '#4a5568',
 lightGray: '#F0F0F0',
 darkGray: '#6B7280',
 textDark: '#1a1a2e',
 lightRed: '#fee2e2',
 lightGreen: '#dcfce7',
 error: '#e53e3e',
 warning: '#dd6b20'
};

// V3.6: Dark Mode Color Palette
const DARK_COLORS = {
 // Primary Brand (adjusted for dark)
 navy: '#2a2a5a',
 copper: '#D4944A',
 platinum: '#3a3a4a',
 pearl: '#1a1a2e',
 
 // Backgrounds
 background: '#0f0f1a',
 cardBg: '#1a1a2e',
 surfaceBg: '#252538',
 
 // Text
 textPrimary: '#E8E8EC',
 textSecondary: '#A0A0B0',
 textMuted: '#707080',
 
 // Accents
 copperGlow: 'rgba(212, 148, 74, 0.15)',
 navyGlow: 'rgba(42, 42, 90, 0.3)',
 
 // UI Elements
 border: '#3a3a5a',
 inputBg: '#252538',
 hover: '#2a2a4a',
 
 // Severity (slightly brighter for dark mode)
 critical: '#ef4444',
 high: '#f97316',
 medium: '#eab308',
 low: '#84cc16',
 success: '#22c55e'
};

// Theme getter function
const getThemeColors = (isDark) => isDark ? DARK_COLORS : COLORS;

// ============================================
// SECTION 2.5: APPLICANT PROFILES (V27 NEW)
// ============================================

const APPLICANT_PROFILES = {
 brandon: {
 name: 'Brandon J. Pierce Sr.',
 shortName: 'Brandon',
 email: 'brandonjpiercesr@gmail.com',
 phone: '336-549-9608',
 location: 'Greensboro, NC 27406',
 headerColor: { r: 31, g: 71, b: 136 },
 maxChars: 1875,
 family: {
 wife: 'Bethany',
 kids: ['Bailey-J', 'Joshua', 'Jeremiah', 'Bella-Ann'],
 kidCount: 4
 },
 coverLetterTypes: {
 standard: {
 name: 'Standard Development',
 hook: "I've worked on both sides of the table",
 focus: 'Data Science Development Plan, Tic-Tac-Toe, Pipeline Tracker',
 useFor: 'fundraising, development, grants roles'
 },
 executive: {
 name: 'Executive/Operations',
 hook: "I'm the nonprofit expert who understands it all",
 focus: 'Consultant work, fractional roles, project management, board relations',
 useFor: 'ED, President, CDO, VP, director >$125K, part-time, contract'
 }
 },
 keyPoints: [
 'Reviewed 13,000+ proposals at Coca-Cola ($195M+ total)',
 '$260M+ influenced across 65+ organizations',
 'Data Science Development Plan methodology',
 'Tic-Tac-Toe donor engagement framework',
 'VP of Development & Operations at HomeFree-USA (2022-2024)',
 'Dual perspective: grantmaker AND fundraiser'
 ],
 fileNaming: 'BPierce_CoverLetter[FirstWordOfOrg]',
 classification: 'High-level executive, CDO/VP, director >$125K, part-time, contract'
 },
 
 eric: {
 name: 'Dr. Eric R. Lane Sr.',
 shortName: 'Eric',
 email: 'eric@globalmajoritygroup.com',
 phone: '323-600-7676',
 location: 'Los Angeles, CA',
 headerColor: { r: 31, g: 71, b: 136 },
 maxChars: 2000,
 credentials: 'Ed.D. in Educational Leadership, Cal State Fresno',
 family: {
 kids: ['Eric Jr. (EJ)', 'Parker', 'Evan'],
 kidAges: { 'EJ': 7, 'Parker': 5, 'Evan': 2 },
 kidCount: 3
 },
 // V4.2: Added coverLetterTypes for consistency with Brandon
 coverLetterTypes: {
 standard: {
 name: 'Standard California',
 hook: "I bring deep California nonprofit roots and athletic leadership",
 focus: 'California network, sports background, major gifts',
 useFor: 'California-based roles, athletics, YMCA, university'
 },
 executive: {
 name: 'Executive Director',
 hook: "I've led organizations through transformational growth",
 focus: 'ED experience, campaign leadership, board development',
 useFor: 'ED, CDO, VP roles in California'
 }
 },
 keyPoints: [
 '17 years of fundraising and nonprofit leadership',
 '$15M+ personally secured',
 '$500M+ in campaigns led or supported',
 'Sports background (YMCA, university athletics)',
 'Executive Director experience (GID, Sarcoma Alliance, KEEN)',
 '$5M U.S. Embassy/AMIDEAST grant',
 '$3.5M foundation grant for health equity',
 '$3M Kresge Foundation grant',
 '$1.5M Disney corporate foundation gift',
 'Led CSUF athletics from $1.4M to $3M in two years'
 ],
 californiaNetwork: [
 'California Baptist University',
 'Cal State Fullerton',
 'LA Mayors Fund',
 'Playworks SoCal',
 'Culver-Palms YMCA'
 ],
 classification: 'California-specific positions'
 },
 
 bj: {
 name: 'Bryan J. Pierce',
 shortName: 'BJ',
 email: 'bryanjpiercejr@gmail.com',
 phone: '980-395-8662',
 location: 'Greensboro, NC 27407',
 headerColor: { r: 31, g: 71, b: 136 },
 maxChars: 2000,
 currentOrg: 'GID', // V5.5: BJ ALWAYS uses GID for experience
 family: {
 status: 'Married',
 sons: ["Bryan 'B3'", 'Brycen', 'Josiah', 'Braylen'],
 daughter: 'Uriah',
 children: "one daughter and four sons: Uriah (oldest), Bryan 'B3', Brycen, Josiah, and Braylen",
 childCount: 5,
 background: "Pastor's son"
 },
 // V4.2: Added coverLetterTypes for consistency with Brandon
 coverLetterTypes: {
 standard: {
 name: 'Standard Development',
 hook: "I bring nearly a decade of hands-on fundraising experience",
 focus: 'Grant writing, institutional giving, donor relations',
 useFor: 'Development coordinator, grant writer, fundraising manager'
 },
 faith: {
 name: 'Faith-Based',
 hook: "Growing up as a pastor's son shaped my commitment to service",
 focus: 'Faith background, community roots, family values',
 useFor: 'Religious organizations, faith-based nonprofits'
 }
 },
 dynamicGIDTitle: true, // Must mirror job being applied for but LEVELED UP
 personalHooks: {
 faith: 'lifelong foundation shaped by being raised in a pastor\'s home',
 education: 'strong academic foundation including my BS in Business Administration',
 media: 'five years as on-air radio host at WNAA 90.1 FM',
 community: 'personal commitment as a father raising four sons and one daughter',
 general: 'commitment to community impact and organizational growth'
 },
 keyPoints: [
 'Nearly 10 years fundraising, grant writing, institutional giving',
 'GID Consulting (current)',
 'HomeFree-USA: $2.5M+ grant portfolio',
 'Brand-ON Consulting, LLC: Grant strategy and donor relations',
 'WNAA 90.1 FM Radio Host (2017-2022)',
 'BS in Business Administration'
 ],
 fileNaming: 'BryanJPierce_Application_[FirstWordOfOrg]',
 classification: 'Development, fundraising, grants, admin, ops, marketing, comms (manager/director <$125K)'
 },
 
 // V4.3: Added CJ Moore - applies to same roles as BJ (both apply to increase odds)
 cj: {
 name: 'C.J. Moore',
 shortName: 'CJ',
 email: 'cj.d.moore32@gmail.com',
 phone: '', // TBD when resume uploaded
 location: '', // TBD when resume uploaded
 headerColor: { r: 31, g: 71, b: 136 },
 maxChars: 2000,
 currentOrg: 'Envolve', // V5.5: CJ ALWAYS uses Envolve (spelled E-N-V-O-L-V-E, not Experts)
 family: {
 // TBD when resume uploaded
 },
 keyPoints: [
 // TBD when resume uploaded - placeholder
 'Development and fundraising professional',
 'Envolve (current)',
 'Grant writing experience',
 'Nonprofit operations background'
 ],
 coverLetterTypes: {
 standard: {
 name: 'Standard Development',
 hook: "TBD when resume uploaded",
 focus: 'Development, grants, fundraising',
 useFor: 'development, grants, fundraising roles'
 }
 },
 fileNaming: 'CJMoore_Application_[FirstWordOfOrg]',
 classification: 'Same as BJ: Development, fundraising, grants, admin, ops, marketing, comms',
 placeholder: true // Flag to indicate profile needs completion
 }
};

// Job Classification Logic
// V4.3: COMPLETELY REWRITTEN Job Classification Logic
// GMG Flip = ONLY when job explicitly mentions consultant/contractor/firm/1099
// Most jobs go to BJ+CJ (both apply), Brandon for executive, Eric for CA-only
const classifyApplicant = (jobData) => {
 const title = (jobData.title || '').toLowerCase();
 const salary = jobData.salary || '';
 const location = (jobData.location || '').toLowerCase();
 const description = (jobData.description || '').toLowerCase();
 
 // =============================================
 // STEP 1: Check for GMG FLIP opportunities FIRST
 // These are EXPLICIT consultant/contractor/firm mentions
 // =============================================
 const gmgFlipPatterns = [
 'open to consultants',
 'open to consulting',
 'consulting firm',
 'consulting arrangement',
 'open to a firm',
 'contractor or consultant',
 'consultant or contractor',
 '1099',
 'independent contractor',
 'contract basis',
 'consulting engagement',
 'seeking a consultant',
 'hire a consultant',
 'looking for a consultant',
 'fractional',
 'outsourced'
 ];
 const isGMGFlip = gmgFlipPatterns.some(p => description.includes(p) || title.includes(p));
 
 if (isGMGFlip) {
 return 'GMG'; // Explicit consulting opportunity - pitch GMG services
 }
 
 // =============================================
 // STEP 2: Location-based routing
 // =============================================
 
 // California-specific = Eric ONLY
 const caOnlyPatterns = [
 'california residents only',
 'must be located in california',
 'based in california',
 'located in california',
 'california-based',
 'los angeles, ca',
 'san francisco, ca',
 'san diego, ca',
 'oakland, ca'
 ];
 const isCAOnly = caOnlyPatterns.some(p => description.includes(p) || location.includes(p));
 
 // Multi-state that includes CA
 const isMultiStateWithCA = description.includes('california') && 
 (description.includes('states where') || description.includes('which include') || 
  description.includes(', california,'));
 
 // Check for NC location
 const isNCBased = /\b(?:north carolina|charlotte|raleigh|greensboro|durham|nc)\b/i.test(description) ||
 /\b(?:north carolina|charlotte|raleigh|greensboro|durham|nc)\b/i.test(location);
 
 // Check for truly remote
 const isRemote = /\b(?:remote|work from home|wfh|fully remote|100% remote)\b/i.test(description) ||
 location.toLowerCase().includes('remote');
 
 // CA-only = Eric
 if (isCAOnly && !isMultiStateWithCA) {
 return 'Eric';
 }
 
 // =============================================
 // STEP 3: Role-level routing
 // =============================================
 
 // High-level executive roles = Brandon
 const executiveKeywords = ['executive director', 'president', 'cdo', 'chief development', 
 'vice president', 'vp of', 'chief', 'ceo', 'cfo', 'coo'];
 if (executiveKeywords.some(kw => title.includes(kw))) {
 return 'Brandon';
 }
 
 // High salary (>$125K) = Brandon
 const salaryMatch = salary.match(/\$?(\d{1,3}),?(\d{3})/);
 if (salaryMatch) {
 const salaryNum = parseInt(salaryMatch[1] + (salaryMatch[2] || ''));
 if (salaryNum > 125000) return 'Brandon';
 }
 
 // K notation salary check
 const salaryK = salary.match(/\$?(\d{2,3})K/i);
 if (salaryK && parseInt(salaryK[1]) > 125) {
 return 'Brandon';
 }
 
 // =============================================
 // STEP 4: Default to BJ+CJ for most roles
 // Both apply to increase odds of landing the job
 // =============================================
 
 // Development/fundraising keywords = BJ+CJ
 const bjCjKeywords = ['development', 'fundraising', 'grants', 'grant', 'institutional giving',
 'major gifts', 'annual fund', 'donor', 'advancement', 'communications', 'marketing',
 'operations', 'admin', 'coordinator', 'manager', 'director', 'associate', 'processing',
 'specialist', 'officer', 'assistant'];
 
 if (bjCjKeywords.some(kw => title.includes(kw))) {
 // If remote, NC, or multi-state = BJ+CJ both apply
 if (isRemote || isNCBased || isMultiStateWithCA) {
 return 'BJ+CJ'; // Both apply
 }
 }
 
 // =============================================
 // STEP 5: Final defaults
 // =============================================
 
 // Remote or NC with no specific role = BJ+CJ
 if (isRemote || isNCBased) {
 return 'BJ+CJ';
 }
 
 // Multi-state that includes CA but not CA-only = BJ+CJ can apply
 if (isMultiStateWithCA) {
 return 'BJ+CJ';
 }
 
 // No location specified = assume remote-friendly = BJ+CJ
 if (!location) {
 return 'BJ+CJ';
 }
 
 // Location-locked to state we can't do = Skip (not GMG flip unless explicit)
 return 'SKIP'; // Can't apply, not a consulting opportunity
};

// Generate Spreadsheet Row
const generateSpreadsheetRow = (jobData) => {
 const applicant = classifyApplicant(jobData);
 const coverType = ['executive director', 'president', 'cdo', 'vp', 'chief'].some(
 kw => (jobData.title || '').toLowerCase().includes(kw)
 ) ? 'Executive/Operations' : 'Standard Development';
 
 return `Company and Role: ${jobData.organization || '[Organization]'} - ${jobData.title || '[Job Title]'}
Deadline: ${jobData.deadline || 'None'}
Direct Link: ${jobData.url || '[URL]'}
WHO SHOULD APPLY: ${applicant}
Compensation: ${jobData.salary || 'Not Listed'}
How to Apply: ${jobData.howToApply || '[Application method]'}
Potential Issue: ${jobData.issues || 'None noted'}
Applied On: 
Eric applied: 
BJ Applied: 
CJ Applied:
Brandon ap: 
Choose Which Cover?: ${coverType}`;
};

// V30: Strip markdown symbols for clean copy-paste
const stripMarkdown = (text) => {
 if (!text) return '';
 
 return text
 // Remove headers (# ## ### etc)
 .replace(/^#{1,6}\s+/gm, '')
 // Remove bold (**text** or __text__)
 .replace(/\*\*([^*]+)\*\*/g, '$1')
 .replace(/__([^_]+)__/g, '$1')
 // Remove italic (*text* or _text_)
 .replace(/\*([^*]+)\*/g, '$1')
 .replace(/_([^_]+)_/g, '$1')
 // Remove code blocks (```text```)
 .replace(/```[^`]*```/g, '')
 // Remove inline code (`text`)
 .replace(/`([^`]+)`/g, '$1')
 // Remove horizontal rules (--- or ***)
 .replace(/^[-*]{3,}\s*$/gm, '')
 // Remove bullet points (- or *)
 .replace(/^[\s]*[-*]\s+/gm, '- ')
 // Remove numbered lists (1. 2. etc) but keep numbers
 .replace(/^(\d+)\.\s+/gm, '$1. ')
 // Remove links [text](url) -> text
 .replace(/\[([^\]]+)\]\([^)]+\)/g, '$1')
 // Remove images ![alt](url)
 .replace(/!\[([^\]]*)\]\([^)]+\)/g, '')
 // Clean up extra whitespace
 .replace(/\n{3,}/g, '\n\n')
 .trim();
};

// V6.7: PDF Vision Fallback for Scanned Documents
// If normal PDF extraction fails, renders pages as images and uses Claude vision
/* global pdfjsLib */
const extractPDFWithVision = async (base64Data, getApiHeaders, showToast) => {
 try {
 // Check if PDF.js is available
 if (typeof pdfjsLib === 'undefined') {
  devWarn('PDF.js not loaded, cannot use vision fallback');
  return null;
 }
 
 showToast('Trying vision extraction for scanned PDF...', 'info');
 
 // Convert base64 to array buffer
 const binaryString = atob(base64Data);
 const bytes = new Uint8Array(binaryString.length);
 for (let i = 0; i < binaryString.length; i++) {
  bytes[i] = binaryString.charCodeAt(i);
 }
 
 // Load PDF
 const pdf = await pdfjsLib.getDocument({ data: bytes }).promise;
 const numPages = pdf.numPages; // V6.8: Process ALL pages, no limit
 
 let allText = '';
 
 for (let pageNum = 1; pageNum <= numPages; pageNum++) {
  showToast(`Processing page ${pageNum}/${numPages}...`, 'info');
  
  const page = await pdf.getPage(pageNum);
  const viewport = page.getViewport({ scale: 1.5 }); // Good balance of quality vs size
  
  // Create canvas
  const canvas = document.createElement('canvas');
  const context = canvas.getContext('2d');
  canvas.height = viewport.height;
  canvas.width = viewport.width;
  
  // Render page to canvas
  await page.render({ canvasContext: context, viewport: viewport }).promise;
  
  // Convert to base64 PNG
  const imageData = canvas.toDataURL('image/png').split(',')[1];
  
  // Send to Claude vision
  const visionResponse = await fetch('https://api.anthropic.com/v1/messages', {
  method: 'POST',
  headers: getApiHeaders(),
  body: JSON.stringify({
   model: 'claude-sonnet-4-20250514',
   max_tokens: 4000,
   messages: [{
   role: 'user',
   content: [
    { type: 'image', source: { type: 'base64', media_type: 'image/png', data: imageData } },
    { type: 'text', text: 'Extract ALL text from this image. This is a scanned document page. Return ONLY the text content, preserving paragraph structure. No commentary.' }
   ]
   }]
  })
  });
  
  if (visionResponse.ok) {
  const data = await visionResponse.json();
  const pageText = data.content?.[0]?.text || '';
  if (pageText) {
   allText += (allText ? '\n\n--- Page ' + pageNum + ' ---\n\n' : '') + pageText;
  }
  }
 }
 
 return allText || null;
 } catch (err) {
 devError('Vision PDF extraction error:', err);
 return null;
 }
};

// V37.7: BRAVE SEARCH API (Free tier: 2,000 queries/month)
// Get your free API key at: https://brave.com/search/api/
// ============================================
const BRAVE_API_KEY = process.env.REACT_APP_BRAVE_API_KEY || 'BSAiO-gXitoh4oWzj0wROPZgyJZihaU'; // Brandon's Brave API key

const webSearch = async (query) => {
 // Check if API key is configured
 if (!BRAVE_API_KEY) {
 return { 
 success: false, 
 error: 'Brave API key not configured. Get a free key at https://brave.com/search/api/',
 needsKey: true
 };
 }
 
 try {
 const response = await fetch(
 `https://api.search.brave.com/res/v1/web/search?q=${encodeURIComponent(query)}&count=5`,
 {
 method: 'GET',
 headers: {
 'Accept': 'application/json',
 'X-Subscription-Token': BRAVE_API_KEY
 }
 }
 );
 
 if (!response.ok) {
 if (response.status === 401) {
 return { success: false, error: 'Invalid Brave API key', needsKey: true };
 }
 if (response.status === 429) {
 return { success: false, error: 'Brave API rate limit exceeded (2,000/month free tier)' };
 }
 throw new Error(`Brave API error: ${response.status}`);
 }
 
 const data = await response.json();
 
 if (!data.web?.results || data.web.results.length === 0) {
 return { success: false, error: 'No search results found' };
 }
 
 // Format results
 const results = data.web.results.slice(0, 5).map(r => ({
 title: r.title || '',
 url: r.url || '',
 snippet: r.description || ''
 }));
 
 return { success: true, results };
 
 } catch (error) {
 devError('Brave search failed:', error);
 return { success: false, error: error.message };
 }
};

// V3.4: ENHANCED WEB SEARCH (Uses Claude Sonnet 4 for intelligent responses)
// Previous version fell back to "I don't know" - this version actually helps
const searchAndSummarize = async (query) => {
 try {
 // Check if GMG-internal query first
 const gmgKeywords = ['gmg', 'global majority', 'brandon', 'eric', 'lane-pierce', 'tic-tac-toe', 'dsdp', 
                      'data science development', 'implementation engine', 'grant catalyst', 'prospect precision',
                      'bdif', 'dawkins', 'kopp', 'mcw global', 'nonprofit vote', 'flowers foundation'];
 const lowerQ = query.toLowerCase();
 const isGMGQuery = gmgKeywords.some(kw => lowerQ.includes(kw));
 
 // V3.5.4: Detect queries that need web search (sports, current events, news)
 // V4.1: Using centralized SPORTS_TEAMS constant
 // V4.4: Expanded sports detection - catches "vs", "standings", "how did X do"
 const hasSportsTeam = SPORTS_TEAMS.some(team => lowerQ.includes(team));
 const sportsPatterns = /\b(score|win|won|beat|lost|lose|game|play|played|playing|last night|tonight|yesterday|standings|record|vs|versus|match|playoff|championship|finals|draft|trade|roster|injury|injured)\b/i;
 const isSportsQuery = hasSportsTeam && sportsPatterns.test(query);
 // Also catch "how did [team] do" pattern
 const howDidPattern = /how did.*(do|perform|play)/i;
 const isSportsHowDid = hasSportsTeam && howDidPattern.test(query);
 
 // Current events detection
 const currentEventsKeywords = ['today', 'yesterday', 'this week', 'latest', 'recent', 'current', 'breaking', 
                                'news', 'update', 'happened', 'announced', 'election', 'stock price', 'weather'];
 const needsWebSearch = isSportsQuery || isSportsHowDid || currentEventsKeywords.some(kw => lowerQ.includes(kw));
 
 // Build the prompt based on query type
 let prompt;
 let useWebSearch = false;
 
 if (isGMGQuery) {
 prompt = `You are the GMG ACE Portal assistant. Answer this question about Global Majority Group: "${query}"

Use the GMG knowledge you have about:
- Brandon J. Pierce Sr. (Co-founder, $195M reviewed at Coca-Cola, VP at HomeFree-USA)
- Dr. Eric R. Lane Sr. (Co-founder, Ed.D., 17 years fundraising, $15M+ personally raised)
- Methodologies: Data Science Development Plan, Tic-Tac-Toe framework, Implementation Engine, Grant Catalyst
- Clients: BDIF, MCW Global, Nonprofit Vote, KOPP Foundation
- Lane-Pierce Fellowship launching January 2026

REQUIREMENTS:
- Direct, helpful answer
- NO em dashes, use commas instead
- Keep under 300 words
- Warm professional tone`;
 } else if (needsWebSearch) {
 // V3.5.4: Use web search for sports/current events
 useWebSearch = true;
 prompt = `The user is asking: "${query}"

Search the web to find the answer to this question. After searching, provide a helpful, conversational response.

REQUIREMENTS:
- Search for current/accurate information
- Give a direct answer to what they asked
- NO em dashes (use commas instead)
- Keep response under 200 words
- Be conversational, not robotic
- If it's a sports score, just give them the result naturally like a friend would`;
 } else {
 prompt = `The user is asking: "${query}"

Provide a helpful, accurate answer based on your knowledge. If this requires very recent information, acknowledge that and suggest reliable sources.

REQUIREMENTS:
- Give factual information
- NO em dashes, use commas instead  
- Keep response under 300 words
- Be conversational and helpful
- If you don't know something, say so honestly`;
 }

 // Build request body
 const requestBody = {
 model: MODEL_CONFIG.quality,
 max_tokens: 2000,
 messages: [{ role: 'user', content: prompt }]
 };
 
 // V3.5.4: Add web search tool for sports/current events
 if (useWebSearch) {
 requestBody.tools = [
 {
  type: 'web_search_20250305',
  name: 'web_search'
 }
 ];
 }

 const response = await fetch('https://api.anthropic.com/v1/messages', {
 method: 'POST',
 headers: getApiHeaders(),
 body: JSON.stringify(requestBody)
 });
 
 if (!response.ok) {
 const errorText = await response.text();
 devError('API response error:', response.status, errorText);
 throw new Error(`Claude API error: ${response.status}`);
 }
 
 const data = await response.json();
 
 // Extract the text response (web search returns multiple content blocks)
 // V4.2: Added null check for data.content
 let answer = '';
 if (data.content && Array.isArray(data.content)) {
 for (const block of data.content) {
 if (block.type === 'text') {
 answer += block.text;
 }
 }
 }
 
 if (!answer) {
 return { success: false, error: 'No answer received from search' };
 }
 
 // Clean up em dashes
 answer = answer.replace(/\u2014/g, ', ').replace(/--/g, ', ');
 
 // V3.6.2: Strip markdown formatting for clean display
 answer = answer
 .replace(/#{1,6}\s*/g, '')  // Remove ## headers
 .replace(/\*\*([^*]+)\*\*/g, '$1')  // Remove **bold**
 .replace(/\*([^*]+)\*/g, '$1')  // Remove *italic*
 .replace(/`([^`]+)`/g, '$1')  // Remove `code`
 .replace(/```[\s\S]*?```/g, '')  // Remove code blocks
 .replace(/\[([^\]]+)\]\([^)]+\)/g, '$1')  // Remove markdown links, keep text
 .replace(/^\s*[-*]\s+/gm, '• ')  // Convert markdown bullets to simple bullets
 .replace(/\n{3,}/g, '\n\n')  // Reduce multiple newlines
 .trim();
 
 return { success: true, answer, source: isGMGQuery ? 'gmg_knowledge' : (useWebSearch ? 'web_search' : 'claude_search') };
 
 } catch (error) {
 devError('Claude search failed:', error);
 return { 
 success: false, 
 error: error.message,
 answer: `I had trouble searching for that. ${error.message}. Please try again.`
 };
 }
};

// V37: CLAUDE API JOB PARSER - Actually smart parsing
// V37.9: Now uses FULL GMG_KNOWLEDGE for better org recognition (V38 Fix #5)
// ============================================
const parseJobDescriptionWithAI = async (input) => {
 try {
 // V5.1: First try regex extraction for common patterns
 const regexOrg = input.match(/THE ORGANIZATION[:\s]*\n*([A-Z][^(]+?)(?:\s*\(|protects|is a|works)/i);
 const regexTitle = input.match(/Position:\s*([^\n]+)/i);
 const regexSalary = input.match(/(?:Salary|Compensation)[:\s]*\$?([\d,]+)\s*[-to]+\s*\$?([\d,]+)/i);
 const regexDeadline = input.match(/(?:Application Deadline|Deadline)[:\s]*([A-Za-z]+ \d+,? \d{4})/i);
 const regexLocation = input.match(/Location:\s*([^\n]+)/i);
 // V5.5: Extract addressee (e.g., "addressed to Brit Magnet Callaway")
 const regexAddressee = input.match(/(?:addressed to|attention:|attn:)\s*([A-Z][a-z]+(?:\s+[A-Z][a-z]+)+)/i);
 
 // If we found org via regex, use it
 let extractedOrg = '';
 if (regexOrg && regexOrg[1]) {
  extractedOrg = regexOrg[1].trim();
  devLog('V5.1: Regex found org:', extractedOrg);
 }
 
 const response = await fetch('https://api.anthropic.com/v1/messages', {
 method: 'POST',
 headers: getApiHeaders(),
 body: JSON.stringify({
 model: MODEL_CONFIG.fast,
 max_tokens: 1500,
 messages: [{
 role: 'user',
 content: `Extract job info. Return ONLY JSON, nothing else.

TEXT:
${input.substring(0, 5000)}

JSON format:
{"organization":"FULL NAME from THE ORGANIZATION section","title":"job title","salary":"$X - $Y","location":"city state","deadline":"application due date","startDate":"job start date","howToApply":"how to apply","addressee":"person to address cover letter to if specified","issues":"red flags","isGoodFit":"YES/MAYBE/NO","fitReason":"why"}

RULES:
- organization = Look for "THE ORGANIZATION" then the name before any parentheses. Example: "The National Health Law Program (NHeLP)" = "National Health Law Program"
- deadline = when APPLICATIONS are due, NOT start date
- startDate = when job BEGINS
- addressee = If they say "addressed to [Name]" or "attention: [Name]", extract that name`
 }]
 })
 });
 
 if (!response.ok) {
 const errText = await response.text();
 devError('Job parse API error:', response.status, errText);
 throw new Error('API request failed: ' + response.status);
 }
 
 const data = await response.json();
 let content = data.content?.[0]?.text || "";
 content = content.replace(/```json\n?/g, '').replace(/```\n?/g, '').trim();
 
 const parsed = JSON.parse(content);
 
 // V5.1: Use regex extraction if AI missed it
 const finalOrg = (parsed.organization && parsed.organization.length > 3 && !parsed.organization.toLowerCase().includes('healthlaw')) 
  ? parsed.organization 
  : (extractedOrg || parsed.organization || '');
 
 return {
 organization: finalOrg,
 title: parsed.title || (regexTitle ? regexTitle[1].trim() : ''),
 salary: parsed.salary || (regexSalary ? `$${regexSalary[1]} - $${regexSalary[2]}` : ''),
 location: parsed.location || (regexLocation ? regexLocation[1].trim() : ''),
 deadline: parsed.deadline || (regexDeadline ? regexDeadline[1] : ''),
 howToApply: parsed.howToApply || '',
 description: input,
 url: '',
 issues: parsed.issues || '',
 startDate: parsed.startDate || '',
 isGoodFit: parsed.isGoodFit || '',
 fitReason: parsed.fitReason || ''
 };
 } catch (error) {
 devError('Job parse failed:', error);
 return parseJobDescription(input);
 }
};

// V29: COMPLETELY REWRITTEN JOB PARSING - Much smarter extraction
// ============================================
// V33: SMART PARSER - Multi-Pass with Consistency Checking (FALLBACK)
// ============================================

const parseJobDescription = (input) => {
 const jobData = {
 organization: '',
 title: '',
 salary: '',
 location: '',
 deadline: '',
 howToApply: '',
 applicationEmail: '', // V5.8: Separate field for extracted application email
 description: input,
 url: '',
 issues: ''
 };
 
 // =============================================
 // V33 SMART PARSER: Multi-Pass Organization Detection
 // =============================================
 
 // PASS 1: Collect ALL potential org names from multiple patterns
 const orgCandidates = [];
 
 // Pattern A: "Who we are: The [Org Name] (ABBREV) is..."
 const whoWeAreMatch = input.match(/who we are[:\s]+(?:the\s+)?([A-Z][A-Za-z\s]+?)\s*\([A-Z]{2,6}\)/i);
 if (whoWeAreMatch) orgCandidates.push({ name: whoWeAreMatch[1].trim(), source: 'who-we-are', confidence: 95 });
 
 // Pattern B: "The [Org Name] (ABBREV)" at start or after period
 const theOrgMatch = input.match(/(?:^|\.\s+)The\s+([A-Z][A-Za-z\s]+?)\s*\(([A-Z]{2,6})\)/m);
 if (theOrgMatch) orgCandidates.push({ name: theOrgMatch[1].trim(), source: 'the-org-abbrev', confidence: 90 });
 
 // Pattern C: "[OrgName] seeks" (single word like Men4Choice)
 const seeksMatch = input.match(/^([A-Z][A-Za-z0-9]+)\s+seeks/m);
 if (seeksMatch && seeksMatch[1].length > 3) orgCandidates.push({ name: seeksMatch[1].trim(), source: 'seeks', confidence: 85 });
 
 // Pattern D: "About [OrgName]" section header
 const aboutMatch = input.match(/\n\s*About\s+([A-Z][A-Za-z0-9\s&]+?)\s*\n/);
 if (aboutMatch) orgCandidates.push({ name: aboutMatch[1].trim(), source: 'about-section', confidence: 80 });
 
 // Pattern E: "[OrgName] Background" or "[OrgName] Mission"
 const bgMatch = input.match(/\n\s*([A-Z][A-Za-z0-9]+(?:\s+[A-Za-z]+)?)\s+(?:Background|Mission|Overview|History)\s*\n/);
 if (bgMatch) orgCandidates.push({ name: bgMatch[1].trim(), source: 'bg-section', confidence: 75 });
 
 // Pattern F: Email domain extraction (very reliable)
 const emailMatch = input.match(/(?:to|at|email)[:\s]+([a-zA-Z0-9._%+-]+)@([a-zA-Z0-9-]+)\.(org|com|net)/i);
 if (emailMatch && emailMatch[2]) {
 const domain = emailMatch[2].toUpperCase();
 orgCandidates.push({ name: domain, source: 'email-domain', confidence: 70 });
 }
 
 // Pattern G: "[Org Name] is a leading/premier/nonprofit..."
 const isAMatch = input.match(/(?:^|\.\s+)(?:The\s+)?([A-Z][A-Za-z\s]+?)\s+is\s+(?:a\s+)?(?:leading|premier|nonprofit|non-profit|organization)/i);
 if (isAMatch) orgCandidates.push({ name: isAMatch[1].trim(), source: 'is-a-leading', confidence: 75 });
 
 // Pattern H: "[Org] Foundation" anywhere
 const foundationMatch = input.match(/([A-Z][a-z]+(?:\s+[A-Z][a-z]+)*)\s+Foundation/);
 if (foundationMatch) orgCandidates.push({ name: foundationMatch[1].trim() + ' Foundation', source: 'foundation', confidence: 85 });
 
 // Pattern I: Abbreviation appears multiple times (WOLA, ACLU, etc.)
 const abbrevMatches = input.match(/\b[A-Z]{3,6}\b/g) || [];
 const abbrevCounts = {};
 abbrevMatches.forEach(a => { abbrevCounts[a] = (abbrevCounts[a] || 0) + 1; });
 const frequentAbbrev = Object.entries(abbrevCounts).find(([abbr, count]) => count >= 3 && abbr.length >= 3);
 if (frequentAbbrev) {
 // Look for full name with this abbreviation
 const fullNameMatch = input.match(new RegExp(`([A-Z][A-Za-z\\s]+?)\\s*\\(${frequentAbbrev[0]}\\)`, 'i'));
 if (fullNameMatch) orgCandidates.push({ name: fullNameMatch[1].trim(), source: 'frequent-abbrev', confidence: 92 });
 }
 
 // PASS 2: Validate and score candidates
 const invalidPhrases = ['today this', 'this position', 'the position', 'position summary',
 'job summary', 'key responsibilities', 'about us', 'job description', 
 'we are', 'our team', 'the company', 'company overview', 'description', 
 'overview', 'your role', 'the role', 'this role', 'our development'];
 
 const validCandidates = orgCandidates.filter(c => {
 const lower = c.name.toLowerCase();
 // Filter out invalid phrases
 if (invalidPhrases.some(p => lower.includes(p) || lower === p)) return false;
 // Filter out too short
 if (c.name.length < 3) return false;
 // Filter out pure numbers or weird chars
 if (/^\d+$/.test(c.name)) return false;
 return true;
 });
 
 // PASS 3: Pick best candidate by confidence
 if (validCandidates.length > 0) {
 validCandidates.sort((a, b) => b.confidence - a.confidence);
 jobData.organization = validCandidates[0].name;
 }
 
 // =============================================
 // V33 SMART PARSER: Multi-Pass Title Detection
 // =============================================
 
 const titleCandidates = [];
 const titleKeywords = ['Manager', 'Director', 'Coordinator', 'Associate', 'Officer', 
 'Specialist', 'Lead', 'Executive', 'Administrator', 'Analyst', 'Writer'];
 
 // Pattern A: "seeks [adj] [Title]"
 for (const kw of titleKeywords) {
 const pattern = new RegExp(`seeks\\s+(?:its\\s+)?(?:first\\s+)?(?:full-time\\s+|part-time\\s+)?(?:[a-z-]+\\s+)*([A-Za-z]+\\s+${kw})`, 'i');
 const match = input.match(pattern);
 if (match) titleCandidates.push({ name: match[1].trim(), source: 'seeks', confidence: 90 });
 }
 
 // Pattern B: "Position: [Title]" or "Role: [Title]" or "Title: [Title]"
 const positionMatch = input.match(/(?:Position|Role|Job\s*Title|Title)[:\s]+([A-Za-z\s,]+?)(?:\n|,\s*a\s+position|\s+\()/i);
 if (positionMatch) {
 let title = positionMatch[1].trim().replace(/[,;]+$/, '');
 if (title.length > 3 && title.length < 60) titleCandidates.push({ name: title, source: 'label', confidence: 95 });
 }
 
 // Pattern C: "hiring [a/for] [Title]"
 for (const kw of titleKeywords) {
 const pattern = new RegExp(`(?:hiring|recruiting|looking for)\\s+(?:a\\s+|an\\s+|for\\s+)?(?:[a-z-]+\\s+)*([A-Za-z]+\\s+${kw})`, 'i');
 const match = input.match(pattern);
 if (match) titleCandidates.push({ name: match[1].trim(), source: 'hiring', confidence: 85 });
 }
 
 // Pattern D: "The [Title] will..." or "The [Title] is responsible..."
 for (const kw of titleKeywords) {
 const pattern = new RegExp(`The\\s+([A-Za-z]+\\s+${kw})\\s+(?:will|is|reports|works)`, 'i');
 const match = input.match(pattern);
 if (match) titleCandidates.push({ name: match[1].trim(), source: 'the-title-will', confidence: 80 });
 }
 
 // Pattern E: Standalone title line (often at very top)
 const firstLines = input.split('\n').slice(0, 5);
 for (const line of firstLines) {
 for (const kw of titleKeywords) {
 if (line.includes(kw) && line.length < 60 && line.length > 5) {
    const titleLine = line.trim().replace(/[:-]+$/, '').trim();
 if (titleLine.split(' ').length <= 5) {
 titleCandidates.push({ name: titleLine, source: 'first-line', confidence: 75 });
 }
 }
 }
 }
 
 // Pattern F: Infer from responsibilities section
 if (titleCandidates.length === 0) {
 // Look for "Manage/Managing" + noun = probably Manager
 if (/\bmanag(?:e|ing)\s+(?:WOLA's|the|our)\s+(?:grants?|foundation|portfolio)/i.test(input)) {
 titleCandidates.push({ name: 'Grants Manager', source: 'inferred', confidence: 60 });
 }
 if (/\bdevelopment\s+(?:team|function|department)/i.test(input) && /\bgrants?\b/i.test(input)) {
 titleCandidates.push({ name: 'Development Manager', source: 'inferred', confidence: 55 });
 }
 }
 
 // Pick best title
 if (titleCandidates.length > 0) {
 titleCandidates.sort((a, b) => b.confidence - a.confidence);
 jobData.title = titleCandidates[0].name;
 }
 
 // =============================================
 // SALARY EXTRACTION (Multi-Pattern) - V4.2 ENHANCED
 // =============================================
 
 // Pattern 1: "$XX,XXX-$XX,XXX" or "$XX,XXX - $XX,XXX" or "$XX,XXX to $XX,XXX"
 const salaryRange = input.match(/\$(\d{1,3},?\d{3})\s*(?:[-]|to)\s*\$(\d{1,3},?\d{3})/i);
 if (salaryRange) {
 jobData.salary = `$${salaryRange[1]} - $${salaryRange[2]}`;
 } else {
 // Pattern 2: "$125K - $150K" (K notation)
 const salaryK = input.match(/\$(\d{2,3})K\s*(?:[-]|to)\s*\$(\d{2,3})K/i);
 if (salaryK) {
 jobData.salary = `$${salaryK[1]},000 - $${salaryK[2]},000`;
 } else {
 // Pattern 3: "$50-60K" (shorthand range)
 const salaryShortK = input.match(/\$(\d{2,3})[-](\d{2,3})K/i);
 if (salaryShortK) {
 jobData.salary = `$${salaryShortK[1]},000 - $${salaryShortK[2]},000`;
 } else {
 // Pattern 4: "$55/hour" or "$55 per hour" (hourly)
 const salaryHourly = input.match(/\$(\d{2,3})(?:\s*\/\s*hour|\s+per\s+hour)/i);
 if (salaryHourly) {
 jobData.salary = `$${salaryHourly[1]}/hour`;
 } else {
 // Pattern 5: "Salary: $XX,XXX" or "Compensation: $XX,XXX"
 const salarySingle = input.match(/(?:salary|compensation|pay|starting at)[:\s]+\$(\d{1,3},?\d{3})/i);
 if (salarySingle) {
 jobData.salary = `$${salarySingle[1]}`;
 } else {
 // Pattern 6: Just a dollar amount in compensation section
 const salaryContext = input.match(/(?:compensation|salary|pay)[\s\S]{0,50}\$(\d{1,3},?\d{3})/i);
 if (salaryContext) jobData.salary = `$${salaryContext[1]}`;
 }
 }
 }
 }
 }
 
 // =============================================
 // LOCATION EXTRACTION
 // =============================================
 
 if (/\bremote\b/i.test(input)) {
 if (/\bhybrid\b/i.test(input)) {
 jobData.location = 'Hybrid/Remote';
 } else if (/based\s+in\s+the\s+U\.?S\.?/i.test(input) || /anywhere\s+in\s+the\s+United\s+States/i.test(input)) {
 jobData.location = 'Remote (USA)';
 } else {
 jobData.location = 'Remote';
 }
 } else if (/\bhybrid\b/i.test(input)) {
 jobData.location = 'Hybrid';
 } else {
 // Look for city/state
 const cityMatch = input.match(/(?:located|based|office)\s+(?:in\s+)?(?:the\s+)?([A-Z][a-z]+(?:\s+[A-Z][a-z]+)?),?\s*(?:area|region)?/i);
 if (cityMatch) jobData.location = cityMatch[1].trim();
 }
 
 // Check for DMV specifically
 if (/\bDMV\b/i.test(input) || /greater\s+(?:Washington|DC|D\.C\.)\s+area/i.test(input)) {
 if (jobData.location === 'Remote') {
 jobData.location = 'Remote (prefer DMV)';
 } else if (!jobData.location) {
 jobData.location = 'DMV Area';
 }
 }
 
 // =============================================
 // HOW TO APPLY
 // V5.8: Enhanced email extraction with multiple patterns
 // =============================================
 
 // Pattern 1: Common job application email prefixes
 const prefixEmailMatch = input.match(/(?:careers?|hr|jobs?|apply|hiring|talent|recruitment|applications?|resume)@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}/gi);
 
 // Pattern 2: Email after instruction words
 const instructionEmailMatch = input.match(/(?:submit|send|apply|email|forward|resumes?\s+to)[^.]*?(?:to\s+)?([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})/i);
 
 // Pattern 3: Any email in the text (fallback)
 const allEmails = input.match(/[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}/g) || [];
 
 // Prioritize: prefix emails > instruction emails > any email
 let bestEmail = null;
 if (prefixEmailMatch && prefixEmailMatch.length > 0) {
 bestEmail = prefixEmailMatch[0].toLowerCase();
 } else if (instructionEmailMatch && instructionEmailMatch[1]) {
 bestEmail = instructionEmailMatch[1].toLowerCase();
 } else if (allEmails.length > 0) {
 // Check for application-looking emails first
 const applicationKeywords = ['career', 'hr', 'job', 'apply', 'hiring', 'talent', 'recruit', 'resume'];
 for (const email of allEmails) {
  if (applicationKeywords.some(kw => email.toLowerCase().includes(kw))) {
  bestEmail = email.toLowerCase();
  break;
  }
 }
 // If no application-looking email, use first one found (but not if it looks like a generic example)
 if (!bestEmail && allEmails[0] && !allEmails[0].includes('example') && !allEmails[0].includes('test@')) {
  bestEmail = allEmails[0].toLowerCase();
 }
 }
 
 if (bestEmail) {
 jobData.howToApply = `Email: ${bestEmail}`;
 jobData.applicationEmail = bestEmail;
 } else if (/apply\s+(?:online|at|via)/i.test(input)) {
 jobData.howToApply = 'Apply online (see posting)';
 }
 
 // =============================================
 // DEADLINE
 // =============================================
 
 const deadlineMatch = input.match(/(?:deadline|by|before|no later than|start date)[:\s]+([A-Z][a-z]+\s+\d{1,2},?\s+\d{4})/i);
 if (deadlineMatch) {
 jobData.deadline = deadlineMatch[1].trim();
 } else if (/rolling\s+(?:applications?|basis)/i.test(input)) {
 jobData.deadline = 'Rolling';
 }
 
 // =============================================
 // ISSUES/FLAGS
 // =============================================
 
 const issues = [];
 if (/\bpart[- ]?time\b/i.test(input)) issues.push('Part-time');
 if (/\b(?:contract|temporary|freelance)\b/i.test(input)) issues.push('Contract');
 if (/california\s+only/i.test(input) || /must\s+be\s+(?:located|based)\s+in\s+california/i.test(input)) {
 issues.push('California only');
 }
 if (/spanish\s+(?:required|fluency|proficiency)/i.test(input)) {
 issues.push('Spanish may be required');
 }
 
 jobData.issues = issues.length > 0 ? issues.join(', ') : 'None noted';
 
 return jobData;
};

// ============================================
// SECTION 2A: GRANTS DATABASE (100+ GRANTS)
// ============================================

const GRANTS_DATABASE = [
 // === HEALTH GRANTS ===
 { name: 'Robert Wood Johnson Foundation', category: 'Health', amount: '$50K-$500K', deadline: 'Rolling', url: 'https://www.rwjf.org/en/grants/what-we-fund.html', focus: 'Health equity, social determinants of health' },
 { name: 'The California Endowment', category: 'Health', amount: '$100K-$1M', deadline: 'Rolling', url: 'https://www.calendow.org', focus: 'Health equity in California' },
 { name: 'The Colorado Health Foundation', category: 'Health', amount: '$25K-$500K', deadline: 'Rolling', url: 'https://coloradohealth.org', focus: 'Health equity in Colorado' },
 { name: 'The Kate B. Reynolds Charitable Trust', category: 'Health', amount: '$100K-$500K', deadline: 'February, August', url: 'https://kbrct.org', focus: 'Health care access in North Carolina' },
 { name: 'The SCAN Foundation', category: 'Health', amount: '$50K-$300K', deadline: 'Rolling', url: 'https://www.thescanfoundation.org', focus: 'Aging, long-term care' },
 { name: 'Bristol-Myers Squibb Foundation', category: 'Health', amount: '$100K-$2M', deadline: 'Rolling', url: 'https://www.bms.com/about-us/responsibility/bristol-myers-squibb-foundation.html', focus: 'Cancer, health disparities' },
 { name: 'Aetna Foundation', category: 'Health', amount: '$50K-$500K', deadline: 'Rolling', url: 'https://www.aetna.com/about-us/aetna-foundation.html', focus: 'Healthy communities' },
 { name: 'The Commonwealth Fund', category: 'Health', amount: '$100K-$1M', deadline: 'Rolling', url: 'https://www.commonwealthfund.org', focus: 'Health care system improvement' },
 { name: 'Health Foundation of Greater Cincinnati', category: 'Health', amount: '$25K-$200K', deadline: 'Quarterly', url: 'https://www.healthfoundation.org', focus: 'Regional health improvement' },
 { name: 'Blue Cross Blue Shield Foundation', category: 'Health', amount: '$50K-$500K', deadline: 'Rolling (varies by state)', url: 'Various by state', focus: 'Community health' },
 
 // === YOUTH/EDUCATION GRANTS ===
 { name: 'W.K. Kellogg Foundation', category: 'Youth', amount: '$100K-$5M', deadline: 'Rolling', url: 'https://www.wkkf.org', focus: 'Children, families, communities' },
 { name: 'Lumina Foundation', category: 'Education', amount: '$100K-$1M', deadline: 'Rolling', url: 'https://www.luminafoundation.org', focus: 'Higher education access' },
 { name: 'The Wallace Foundation', category: 'Youth', amount: '$500K-$2M', deadline: 'Invitation only', url: 'https://www.wallacefoundation.org', focus: 'Arts education, leadership' },
 { name: 'The Spencer Foundation', category: 'Education', amount: '$50K-$1M', deadline: 'Multiple cycles', url: 'https://www.spencer.org', focus: 'Education research' },
 { name: 'Carnegie Corporation of New York', category: 'Education', amount: '$100K-$2M', deadline: 'Rolling', url: 'https://www.carnegie.org', focus: 'Education, democracy' },
 { name: 'The Annie E. Casey Foundation', category: 'Youth', amount: '$100K-$1M', deadline: 'Rolling', url: 'https://www.aecf.org', focus: 'Child welfare, juvenile justice' },
 { name: 'The Michael & Susan Dell Foundation', category: 'Youth', amount: '$100K-$5M', deadline: 'Rolling', url: 'https://www.dell.org', focus: 'Urban education, family stability' },
 { name: 'The Walton Family Foundation', category: 'Education', amount: '$100K-$5M', deadline: 'Rolling', url: 'https://www.waltonfamilyfoundation.org', focus: 'K-12 education, school choice' },
 { name: '21st Century Foundation', category: 'Youth', amount: '$25K-$100K', deadline: 'Spring/Fall', url: 'https://www.21cf.org', focus: 'Black youth development' },
 { name: 'The Boys & Girls Clubs of America', category: 'Youth', amount: '$50K-$250K', deadline: 'Rolling', url: 'https://www.bgca.org', focus: 'Youth development programs' },
 { name: 'Jack Kent Cooke Foundation', category: 'Education', amount: '$50K-$500K', deadline: 'January', url: 'https://www.jkcf.org', focus: 'High-achieving students with financial need' },
 { name: 'The Skillman Foundation', category: 'Youth', amount: '$50K-$500K', deadline: 'Rolling', url: 'https://www.skillman.org', focus: 'Detroit youth' },
 
 // === ENVIRONMENT GRANTS ===
 { name: 'The Nature Conservancy', category: 'Environment', amount: '$50K-$500K', deadline: 'Rolling', url: 'https://www.nature.org', focus: 'Conservation, climate' },
 { name: 'Environmental Defense Fund', category: 'Environment', amount: '$100K-$1M', deadline: 'Rolling', url: 'https://www.edf.org', focus: 'Environmental solutions' },
 { name: 'The David & Lucile Packard Foundation', category: 'Environment', amount: '$100K-$5M', deadline: 'Rolling', url: 'https://www.packard.org', focus: 'Conservation, climate, oceans' },
 { name: 'The William & Flora Hewlett Foundation', category: 'Environment', amount: '$100K-$2M', deadline: 'Rolling', url: 'https://hewlett.org', focus: 'Climate, education, civic' },
 { name: 'The Energy Foundation', category: 'Environment', amount: '$100K-$1M', deadline: 'Rolling', url: 'https://www.ef.org', focus: 'Clean energy, climate' },
 { name: 'The Bullitt Foundation', category: 'Environment', amount: '$50K-$300K', deadline: 'Rolling', url: 'https://www.bullitt.org', focus: 'Pacific Northwest environment' },
 { name: 'The Turner Foundation', category: 'Environment', amount: '$50K-$500K', deadline: 'Rolling', url: 'https://www.turnerfoundation.org', focus: 'Environment, wildlife' },
 { name: 'The Oak Foundation', category: 'Environment', amount: '$100K-$2M', deadline: 'Rolling', url: 'https://oakfnd.org', focus: 'Climate, human rights' },
 { name: 'The Barr Foundation', category: 'Environment', amount: '$100K-$1M', deadline: 'Rolling', url: 'https://www.barrfoundation.org', focus: 'Climate, arts (New England)' },
 { name: 'Patagonia Environmental Grants', category: 'Environment', amount: '$5K-$20K', deadline: 'April, August', url: 'https://www.patagonia.com/actionworks/grants', focus: 'Grassroots environmental' },
 
 // === ARTS & CULTURE GRANTS ===
 { name: 'National Endowment for the Arts', category: 'Arts', amount: '$10K-$100K', deadline: 'Multiple cycles', url: 'https://www.arts.gov', focus: 'Arts projects' },
 { name: 'The Andrew W. Mellon Foundation', category: 'Arts', amount: '$100K-$5M', deadline: 'Rolling', url: 'https://mellon.org', focus: 'Arts, humanities' },
 { name: 'Ford Foundation', category: 'Arts', amount: '$100K-$1M', deadline: 'Rolling', url: 'https://www.fordfoundation.org', focus: 'Art for justice, creativity' },
 { name: 'Bloomberg Philanthropies', category: 'Arts', amount: '$100K-$1M', deadline: 'Varies', url: 'https://www.bloomberg.org', focus: 'Arts, environment, public health' },
 { name: 'The Doris Duke Charitable Foundation', category: 'Arts', amount: '$50K-$500K', deadline: 'Rolling', url: 'https://www.ddcf.org', focus: 'Performing arts' },
 { name: 'The Kresge Foundation', category: 'Arts', amount: '$100K-$1M', deadline: 'Rolling', url: 'https://kresge.org', focus: 'Arts, community development' },
 { name: 'Jerome Foundation', category: 'Arts', amount: '$10K-$50K', deadline: 'Multiple cycles', url: 'https://www.jeromefdn.org', focus: 'Emerging artists (MN, NYC)' },
 { name: 'MAP Fund', category: 'Arts', amount: '$10K-$45K', deadline: 'February', url: 'https://mapfund.org', focus: 'Live performance' },
 { name: 'Creative Capital', category: 'Arts', amount: '$50K-$100K', deadline: 'Spring', url: 'https://creative-capital.org', focus: 'Individual artists' },
 { name: 'National Endowment for the Humanities', category: 'Arts', amount: '$10K-$350K', deadline: 'Multiple cycles', url: 'https://www.neh.gov', focus: 'Humanities projects' },
 
 // === HOUSING & COMMUNITY DEVELOPMENT ===
 { name: 'Enterprise Community Partners', category: 'Housing', amount: '$100K-$1M', deadline: 'Rolling', url: 'https://www.enterprisecommunity.org', focus: 'Affordable housing' },
 { name: 'The JPMorgan Chase Foundation', category: 'Community', amount: '$100K-$5M', deadline: 'Rolling', url: 'https://www.jpmorganchase.com/impact', focus: 'Economic development, housing' },
 { name: 'Wells Fargo Foundation', category: 'Housing', amount: '$50K-$500K', deadline: 'Rolling', url: 'https://www.wellsfargo.com/about/corporate-responsibility', focus: 'Housing, small business' },
 { name: 'Bank of America Charitable Foundation', category: 'Community', amount: '$50K-$500K', deadline: 'Rolling', url: 'https://about.bankofamerica.com/en/making-an-impact', focus: 'Economic mobility' },
 { name: 'Citi Foundation', category: 'Community', amount: '$100K-$1M', deadline: 'Rolling', url: 'https://www.citifoundation.com', focus: 'Economic progress' },
 { name: 'NeighborWorks America', category: 'Housing', amount: '$50K-$500K', deadline: 'Rolling', url: 'https://www.neighborworks.org', focus: 'Affordable housing' },
 { name: 'Local Initiatives Support Corporation (LISC)', category: 'Community', amount: '$50K-$500K', deadline: 'Rolling', url: 'https://www.lisc.org', focus: 'Community development' },
 { name: 'The Surdna Foundation', category: 'Community', amount: '$100K-$500K', deadline: 'Rolling', url: 'https://surdna.org', focus: 'Just cities, sustainable environment' },
 
 // === SOCIAL JUSTICE & EQUITY ===
 { name: 'The Ford Foundation', category: 'Justice', amount: '$100K-$2M', deadline: 'Rolling', url: 'https://www.fordfoundation.org', focus: 'Inequality, human rights' },
 { name: 'Open Society Foundations', category: 'Justice', amount: '$100K-$5M', deadline: 'Rolling', url: 'https://www.opensocietyfoundations.org', focus: 'Justice, democratic governance' },
 { name: 'The Atlantic Philanthropies', category: 'Justice', amount: '$100K-$1M', deadline: 'Closed (legacy grants)', url: 'https://www.atlanticphilanthropies.org', focus: 'Social change' },
 { name: 'The Kapor Center', category: 'Justice', amount: '$50K-$500K', deadline: 'Rolling', url: 'https://www.kaporcenter.org', focus: 'Tech diversity, equity' },
 { name: 'NoVo Foundation', category: 'Justice', amount: '$100K-$1M', deadline: 'Rolling', url: 'https://novofoundation.org', focus: 'Girls, women, social justice' },
 { name: 'The Nathan Cummings Foundation', category: 'Justice', amount: '$100K-$500K', deadline: 'Rolling', url: 'https://nathancummings.org', focus: 'Racial and economic justice' },
 { name: 'Marguerite Casey Foundation', category: 'Justice', amount: '$100K-$1M', deadline: 'Rolling', url: 'https://caseygrants.org', focus: 'Family economic security' },
 { name: 'The Hill-Snowdon Foundation', category: 'Justice', amount: '$50K-$200K', deadline: 'Rolling', url: 'https://www.hillsnowdon.org', focus: 'Youth organizing, social justice' },
 { name: 'The Z. Smith Reynolds Foundation', category: 'Justice', amount: '$50K-$300K', deadline: 'Multiple cycles', url: 'https://www.zsr.org', focus: 'NC social change' },
 { name: 'The Meyer Foundation', category: 'Justice', amount: '$50K-$200K', deadline: 'Rolling', url: 'https://www.meyerfoundation.org', focus: 'DC area equity' },
 
 // === FEDERAL GRANTS ===
 { name: 'HRSA Community Health Centers', category: 'Federal-Health', amount: '$500K-$5M', deadline: 'Annual (Spring)', url: 'https://www.hrsa.gov/grants', focus: 'Community health centers' },
 { name: 'SAMHSA Block Grants', category: 'Federal-Health', amount: '$100K-$1M', deadline: 'Annual', url: 'https://www.samhsa.gov/grants', focus: 'Substance abuse, mental health' },
 { name: 'CDC Community Grants', category: 'Federal-Health', amount: '$100K-$2M', deadline: 'Multiple cycles', url: 'https://www.cdc.gov/grants', focus: 'Public health' },
 { name: 'HUD Community Development Block Grant', category: 'Federal-Housing', amount: '$500K-$5M', deadline: 'Formula grant', url: 'https://www.hud.gov/program_offices/comm_planning/cdbg', focus: 'Community development' },
 { name: 'DOE AmeriCorps VISTA', category: 'Federal-Service', amount: '$50K-$500K', deadline: 'Rolling', url: 'https://americorps.gov/serve/fit-finder/americorps-vista', focus: 'Anti-poverty programs' },
 { name: 'Department of Education Title I', category: 'Federal-Education', amount: '$500K-$5M', deadline: 'Formula grant', url: 'https://www2.ed.gov/programs/titleiparta', focus: 'Low-income schools' },
 { name: 'USDA Community Facilities', category: 'Federal-Community', amount: '$100K-$1M', deadline: 'Rolling', url: 'https://www.rd.usda.gov/programs-services/community-facilities/community-facilities-direct-loan-grant-program', focus: 'Rural facilities' },
 { name: 'DOJ Office of Justice Programs', category: 'Federal-Justice', amount: '$100K-$1M', deadline: 'Multiple cycles', url: 'https://www.ojp.gov/funding', focus: 'Criminal justice' },
 { name: 'EPA Environmental Justice Grants', category: 'Federal-Environment', amount: '$50K-$500K', deadline: 'Annual', url: 'https://www.epa.gov/environmentaljustice/environmental-justice-grants-funding-and-technical-assistance', focus: 'Environmental justice' },
 { name: 'NEA Art Works', category: 'Federal-Arts', amount: '$10K-$100K', deadline: 'February, July', url: 'https://www.arts.gov/grants/art-works', focus: 'Arts projects' },
 
 // === SPORTS & ATHLETICS ===
 { name: 'NFL Foundation', category: 'Sports', amount: '$25K-$250K', deadline: 'Rolling', url: 'https://www.nfl.com/causes', focus: 'Youth football, health, community' },
 { name: 'Nike Community Impact Fund', category: 'Sports', amount: '$25K-$100K', deadline: 'Rolling', url: 'https://purpose.nike.com', focus: 'Youth sports access' },
 { name: 'ESPN Sports Humanitarian Awards', category: 'Sports', amount: '$100K', deadline: 'Annual', url: 'https://www.espn.com/espys/story/_/id/31665247/humanitarian', focus: 'Sports humanitarian work' },
 { name: 'Laureus Sport for Good', category: 'Sports', amount: '$50K-$250K', deadline: 'Rolling', url: 'https://www.laureus.com', focus: 'Sport for social change' },
 { name: 'Good Sports', category: 'Sports', amount: 'Equipment grants', deadline: 'Rolling', url: 'https://www.goodsports.org', focus: 'Sports equipment for underserved' },
 { name: 'The Dick Sports Foundation', category: 'Sports', amount: '$10K-$100K', deadline: 'Rolling', url: 'https://www.dickssportinggoods.com/s/sports-matter', focus: 'Youth sports programs' },
 { name: 'US Soccer Foundation', category: 'Sports', amount: '$25K-$100K', deadline: 'Annual', url: 'https://ussoccerfoundation.org', focus: 'Soccer programs in underserved areas' },
 { name: 'Special Olympics', category: 'Sports', amount: '$25K-$500K', deadline: 'Rolling', url: 'https://www.specialolympics.org', focus: 'Inclusive sports' },
 
 // === FAITH-BASED & VALUES ===
 { name: 'Lilly Endowment', category: 'Faith', amount: '$100K-$5M', deadline: 'Invitation', url: 'https://lillyendowment.org', focus: 'Religion, education, community' },
 { name: 'The Duke Endowment', category: 'Faith', amount: '$100K-$2M', deadline: 'Rolling', url: 'https://www.dukeendowment.org', focus: 'NC/SC churches, education, health' },
 { name: 'The Retirement Research Foundation', category: 'Faith', amount: '$50K-$300K', deadline: 'Multiple cycles', url: 'https://www.rrf.org', focus: 'Aging programs' },
 { name: 'Catholic Campaign for Human Development', category: 'Faith', amount: '$25K-$75K', deadline: 'Annual', url: 'https://www.usccb.org/committees/catholic-campaign-human-development', focus: 'Anti-poverty' },
 { name: 'The Fetzer Institute', category: 'Faith', amount: '$50K-$500K', deadline: 'Rolling', url: 'https://fetzer.org', focus: 'Love, forgiveness, spiritual practices' },
 
 // === TECHNOLOGY & INNOVATION ===
 { name: 'Google.org', category: 'Tech', amount: '$250K-$2M', deadline: 'Rolling', url: 'https://www.google.org', focus: 'Tech for nonprofits' },
 { name: 'Microsoft Philanthropies', category: 'Tech', amount: '$100K-$1M', deadline: 'Rolling', url: 'https://www.microsoft.com/en-us/corporate-responsibility', focus: 'Digital skills, accessibility' },
 { name: 'Salesforce Foundation', category: 'Tech', amount: '$50K-$500K', deadline: 'Rolling', url: 'https://www.salesforce.org', focus: 'Education, workforce development' },
 { name: 'Chan Zuckerberg Initiative', category: 'Tech', amount: '$100K-$5M', deadline: 'Rolling', url: 'https://chanzuckerberg.com', focus: 'Education, science, justice' },
 { name: 'Schmidt Futures', category: 'Tech', amount: '$100K-$5M', deadline: 'Rolling', url: 'https://www.schmidtfutures.com', focus: 'Science, technology, society' },
 { name: 'Omidyar Network', category: 'Tech', amount: '$100K-$2M', deadline: 'Rolling', url: 'https://omidyar.com', focus: 'Tech for social good' },
 
 // === WOMEN & GIRLS ===
 { name: 'Ms. Foundation for Women', category: 'Women', amount: '$50K-$200K', deadline: 'Rolling', url: 'https://forwomen.org', focus: 'Women leadership, safety' },
 { name: 'The Women Foundation', category: 'Women', amount: '$50K-$250K', deadline: 'Rolling', url: 'https://www.womensfoundca.org', focus: 'Economic security for women' },
 { name: 'Global Fund for Women', category: 'Women', amount: '$5K-$50K', deadline: 'Rolling', url: 'https://www.globalfundforwomen.org', focus: 'Women rights globally' },
 { name: 'UN Women', category: 'Women', amount: '$100K-$1M', deadline: 'Multiple cycles', url: 'https://www.unwomen.org', focus: 'Gender equality' },
 { name: 'The Libra Foundation', category: 'Women', amount: '$50K-$250K', deadline: 'Rolling', url: 'https://thelibrafoundation.org', focus: 'Women, environment (Maine)' }
];

// V37: Pitch Deck Generator - Claude API
const generatePitchDeckHTML = async (clientName, clientDescription) => {
 // V37.9: Use FULL GMG_KNOWLEDGE without truncation (V38 Fix #6)
 const pitchDeckPrompt = `Generate a complete, self-contained HTML pitch deck for Global Majority Group to present to ${clientName}.

COMPLETE GMG KNOWLEDGE BASE (use this for accurate information - FULL DATABASE):
${GMG_KNOWLEDGE}

GMG FOUNDERS (MUST INCLUDE BOTH - use full details from knowledge above):
BRANDON J. PIERCE SR. - Co-Founder
- 15+ years nonprofit fundraising, Former Coca-Cola Foundation (13,000+ proposals, $195M+ reviewed)
- Email: brandon@globalmajoritygroup.com | Phone: 336-549-9608
- Based in High Point/Greensboro, North Carolina
- Father of four: Bailey-J, Joshua, Jeremiah, Bella-Ann

DR. ERIC R. LANE SR. - Co-Founder  
- 17 years fundraising, Ed.D. from Cal State Fresno
- Led 6 capital campaigns ($500M+ combined)
- Email: eric@globalmajoritygroup.com | Phone: (323) 600-7676
- Based in Los Angeles, California (from South Central LA)
- Father of three: EJ (7), Parker (daughter, 5), Evan (2)
- Former D1 basketball player (Boise State), Euro League professional
- Athletic Director at St. John Bosco (national championship, pioneered HS NIL deal)

COMBINED: 32+ years, $260M+ influenced, 65+ organizations, 25-30% grant success rate

GMG METHODOLOGIES:
- Grant MRI: 30-day fundraising health audit
- Data Science Development Plan: Evidence-based revenue projections
- Prospect Precision: Grant funder landscape scan
- Grant Catalyst: Full proposal development
- Donor Tic-Tac-Toe: 3:1 value-to-ask communication
- Recipe Pitch Framework: Eric's 5-ingredient elevator pitch

GMG PRICING:
- Pillar Clients: $6,500-$8,500/month (12-month engagement)
- Transitory Clients: $1,000-$2,500/month (month-to-month)
- Sports Division Training Camp: $1,000-$2,500/month
- Sports Division Starting Lineup: $6,500-$8,500/month

BRAND COLORS: Navy #191970, Copper #B87333, Pearl #F0EAD6

CLIENT CONTEXT:
${clientDescription || 'General nonprofit client seeking development services'}

REQUIRED 7-PAGE STRUCTURE:
1. Title Page (logo placeholder, client name, date, tagline "Excellence Rooted In Lived Experience")
2. About Us (BOTH founders with circular photo placeholders, include personal details)
3. The Challenge (4 boxes: funding gaps, board capacity, donor fatigue, data visibility)
4. Solution & Track Record (stat grid with specific numbers, dual-perspective differentiator)
5. Services & Deliverables (4-phase process, First 90 Days timeline, specific methodologies)
6. Investment ($1,000/month featured for trial, show ROI: $52K less than FT director)
7. References (Chris Thompson at HomeFree-USA, Janae Moore at Healthy Blue NC with full contact)

OUTPUT: Complete HTML document starting with <!DOCTYPE html>. All CSS inline. NO external dependencies. Ready to display in iframe. Use navy/copper color scheme throughout.

CRITICAL: NO em dashes. Write naturally. Use specific numbers from knowledge base. Both founders must be prominently featured.`;

 try {
 // V5.3: Changed to quality model (Sonnet) for better complex document generation
 const response = await fetch('https://api.anthropic.com/v1/messages', {
 method: 'POST',
 headers: getApiHeaders(),
 body: JSON.stringify({
 model: MODEL_CONFIG.quality,
 max_tokens: 16000,
 messages: [{ role: 'user', content: pitchDeckPrompt }]
 })
 });

 if (!response.ok) throw new Error('API request failed: ' + response.status);

 const data = await response.json();
 let html = data.content?.[0]?.text || "";
 html = html.replace(/```html\n?/g, '').replace(/```\n?/g, '').trim();
    html = html.replace(/\u2014/g, ',').replace(/--/g, ',');
 
 if (!html.toLowerCase().startsWith('<!doctype')) {
 const idx = html.toLowerCase().indexOf('<!doctype');
 if (idx > -1) html = html.substring(idx);
 }
 
 return { success: true, html };
 } catch (error) {
 devError('Pitch deck generation failed:', error);
 return { success: false, error: error.message };
 }
};

// ============================================
// V2.2.2: DATA SCIENCE DEVELOPMENT PLAN HTML GENERATOR
// ============================================
const generateDSDPHTML = async (clientName, clientContext) => {
 // V2.2.3: Research client FIRST before generating numbers
 let clientResearch = '';
 
 try {
 // Search for client info
 const searchResponse = await fetch('https://api.anthropic.com/v1/messages', {
 method: 'POST',
 headers: getApiHeaders(),
 body: JSON.stringify({
 model: MODEL_CONFIG.fast,
 max_tokens: 4000,
 tools: [{ type: 'web_search_20250305', name: 'web_search' }],
 messages: [{ 
 role: 'user', 
 content: `Research ${clientName} nonprofit organization. Find:
1. Their annual budget or revenue (look for 990 filings, annual reports)
2. Their mission and programs
3. Their staff size
4. Their current funding sources if mentioned
5. Any recent grants they received

Return a brief summary of what you found with specific numbers where available.`
 }]
 })
 });
 
 if (searchResponse.ok) {
 const searchData = await searchResponse.json();
 clientResearch = searchData.content.map(c => c.text || '').join(' ');
 }
 } catch (e) {
 devLog('Client research failed, using context only:', e);
 }

 const dsdpPrompt = `Generate a complete, self-contained HTML Data Science Development Plan for ${clientName}.

RESEARCHED CLIENT DATA (use these real numbers, do not make up different ones):
${clientResearch || 'No research available - use conservative estimates based on context'}

USER PROVIDED CONTEXT:
${clientContext || 'Nonprofit organization seeking development strategy'}

GMG BRAND COLORS:
- Navy Blue: #191970 (headers, stat boxes)
- Brushed Copper: #B87333 (accents, left borders)
- Pearl White: #F0EAD6 (content box backgrounds)
- Platinum: #E5E4E2 (page backgrounds)
- Dark Gray: #4a5568 (body text)

REQUIRED STRUCTURE (5-6 pages):

PAGE 1: TITLE PAGE
- Large centered title: "Data Science Development Plan"
- Subtitle: "${clientName}"
- "Prepared by Global Majority Group"
- Date: ${new Date().toLocaleDateString('en-US', { month: 'long', year: 'numeric' })}
- Tagline at bottom: "Evidence-Based Revenue Planning"
- NO footer on this page

PAGE 2: CURRENT FINANCIAL REALITY
- Current annual budget (from research or estimate)
- Funding mix pie chart or breakdown
- Staff capacity notes
- Key opportunities identified
- NO footer on this page

PAGE 3: REVENUE TARGET ANALYSIS
- Growth target (25-30% realistic)
- Revenue by source with MATH SHOWN:
  * Foundation Grants: Target / success rate = pipeline needed
  * Corporate: Target / avg partnership / conversion = prospects needed
  * Individual Donors: Target / avg gift = donors needed
- Use actual benchmarks from GMG methodology
- NO footer on this page

PAGE 4: IMPLEMENTATION TIMELINE
- Q1-Q4 activities in clean boxes
- Specific monthly milestones
- Responsible parties (Development Director, ED, Board)
- NO footer on this page

PAGE 5: SUCCESS METRICS & RISK MITIGATION
- Pipeline metrics with targets
- Revenue quality indicators
- Risk mitigation strategies
- GMG contact footer ONLY ON THIS PAGE

CRITICAL DESIGN RULES:
- NO horizontal divider lines between sections
- NO footer repeated on every page (ONLY on last page)
- NO borders around the entire page
- Content boxes have LEFT copper border only (4px solid #B87333)
- Stat boxes: navy background (#191970), white text, no border
- Clean white space between sections
- Page breaks between each page (page-break-after: always)
- Professional typography: 16px body, 24px headers

GMG BENCHMARKS (use these exact rates):
- Foundation grant success rate: 20-25%
- Corporate partnership conversion: 30-40%
- Individual donor acquisition: need 3x prospects to get 1 donor
- Average foundation grant: $15,000-25,000
- Average corporate sponsorship: $2,500-10,000

OUTPUT: Complete HTML starting with <!DOCTYPE html>. All CSS inline in <style> tag. Clean, professional design. NO em dashes anywhere.`;

 try {
 const response = await fetch('https://api.anthropic.com/v1/messages', {
 method: 'POST',
 headers: getApiHeaders(),
 body: JSON.stringify({
 model: MODEL_CONFIG.fast,
 max_tokens: 16000,
 messages: [{ role: 'user', content: dsdpPrompt }]
 })
 });

 if (!response.ok) throw new Error('API request failed: ' + response.status);

 const data = await response.json();
 let html = data.content?.[0]?.text || "";
 html = html.replace(/```html\n?/g, '').replace(/```\n?/g, '').trim();
    html = html.replace(/\u2014/g, ",").replace(/--/g, ",");
 
 // Remove any repeated footers except the last one
 const footerPattern = /<div[^>]*class="[^"]*footer[^"]*"[^>]*>[\s\S]*?<\/div>/gi;
 const footers = html.match(footerPattern) || [];
 if (footers.length > 1) {
 // Keep only the last footer
 for (let i = 0; i < footers.length - 1; i++) {
 html = html.replace(footers[i], '');
 }
 }
 
 // Remove horizontal rules
 html = html.replace(/<hr[^>]*>/gi, '');
 
 if (!html.toLowerCase().startsWith('<!doctype')) {
 const idx = html.toLowerCase().indexOf('<!doctype');
 if (idx > -1) html = html.substring(idx);
 }
 
 return { success: true, html };
 } catch (error) {
 devError('DSDP generation failed:', error);
 return { success: false, error: error.message };
 }
};


// ============================================
// V38.8: COMPREHENSIVE COVER LETTER SYSTEM
// Embedded instructions for Brandon, Eric, BJ, and GMG Flip
// All outputs go through rewriteInBrandonVoice cycle
// ============================================

const COVER_LETTER_INSTRUCTIONS = {
 brandon: `
BRANDON J. PIERCE SR. - COVER LETTER PERSONA

WHO BRANDON IS:
- Co-Founder and Managing Partner of Global Majority Group (GMG)
- Former Coca-Cola Foundation: reviewed 13,000+ proposals totaling $195M+ in funding decisions
- VP of Development & Operations at HomeFree-USA (2022-2024)
- Executive Director, Brian Dawkins Impact Foundation (Current - Started February 2025)
- Author of "Fundraising for the Culture" (forthcoming)
- Influenced over $260 million across 65+ organizations
- Master of Political Science (in progress) - APUS
- Based in High Point/Greensboro, North Carolina
- Phone: 336-549-9608
- Email: brandon@globalmajoritygroup.com

FAMILY (USE NATURALLY IN PERSONAL CONNECTION):
- Wife: Bethany Pierce (stay-at-home parent, manages the household)
- Four children:
  * Bailey-J (daughter, 9, 4th grade) - oldest, name pronounced "Bailey-Jay"
  * Joshua (son, 2nd grade)
  * Jeremiah (son, kindergarten, has citrus allergy)
  * Bella-Ann (daughter, youngest)
- Family is central to his "why" - wants his kids to see dad making a difference
- Faith-driven professional - can mention naturally when relevant

PERSONAL CONNECTION GUIDANCE:
When writing cover letters that mention family:
- "As a father of four, I understand the importance of [relevant mission]"
- "My wife Bethany and I are raising four kids in North Carolina, which gives me personal insight into [family services/education/community]"
- "Watching my daughter Bailey-J grow up motivates me to support organizations like yours"
- Connect kids' ages to relevant programs when applicable
- Never forced - only mention if genuinely relevant to the org's mission

BRANDON'S UNIQUE VALUE:
- Dual perspective: former grantmaker AND fundraiser (knows what funders actually want)
- Can write about reviewing 13,000+ proposals from the funder side
- Corporate foundation experience (Coca-Cola) + nonprofit leadership
- AI integration expertise for modern development operations
- Strong faith and family values (mention family naturally, not forced)

TONE: Warm, direct, confident but not arrogant. Like talking to a colleague at a coffee shop.
`,

 eric: `
DR. ERIC R. LANE SR. - COVER LETTER PERSONA

WHO ERIC IS:
- Co-Founder and Managing Partner of Global Majority Group (GMG)
- Ed.D. in Educational Leadership from California State University, Fresno
- Master's in Coaching and Athletic Administration
- 17 years of nonprofit fundraising leadership
- Personally secured $15M+ in philanthropic capital
- Led 6 capital campaigns totaling over $500M combined
- Former CDO at Children's Institute (portfolio $8.5M annually)
- Former VP of Institutional Advancement at INROADS (National nonprofit, $25M budget)
- Former VP of Development at A Place Called Home
- Former D1 basketball player (Boise State), professional Euro League career
- Athletic Director at St. John Bosco (won national championship, pioneered first HS NIL deal)
- Based in Los Angeles, California
- Phone: (323) 600-7676
- Email: eric@globalmajoritygroup.com

FAMILY (USE NATURALLY IN PERSONAL CONNECTION):
- Wife: (supportive partner, manages family while Eric travels)
- Three children:
  * Eric Jr. "EJ" (son, 7) - oldest, named after dad
  * Parker (DAUGHTER, 5) - middle child
  * Evan (son, 2) - youngest
- CRITICAL: Parker is a GIRL, not a boy. Eric has two sons and one daughter.
- From South Central Los Angeles - speaks authentically about urban community challenges
- Mother from Cochran, Georgia - Southern roots

PERSONAL CONNECTION GUIDANCE:
When writing cover letters that mention family:
- "My wife and I are raising three kids in LA: EJ who's 7, Parker who's 5, and Evan who's 2"
- "As a father of three young children, I think about the community I want them to grow up in"
- "Growing up in South Central LA shaped my understanding of what communities need"
- "My daughter Parker inspires me to support organizations investing in young girls"
- Connect athletic background + fatherhood to youth programs when relevant

ERIC'S UNIQUE VALUE:
- Capital campaign expertise ($500M+ across 6 campaigns)
- Athletic background brings competitive drive to fundraising
- Strong California network (PBS SoCal, Children's Institute contacts)
- Educational leadership credentials (Ed.D.)
- Experience with diverse organizations (INROADS, A Place Called Home)
- NIL expertise - understands athlete philanthropy

TONE: Energetic, passionate about mission, competitive spirit. Athletic mindset applied to fundraising. Speaks from the heart about family and community.
`,

 bj: `
BRYAN J. PIERCE (BJ) - COVER LETTER PERSONA

WHO BJ IS:
- IMPORTANT: Bryan J. Pierce, NOT Brandon J. Pierce (different people - BJ is Brandon's BROTHER!)
- Current Role: [LEVELED UP TITLE] at GID Consulting
- CRITICAL: His company is GID Consulting, NOT Global Majority Group
- CRITICAL: His title MUST be SIMILAR but LEVELED UP from the position he's applying for
  * If applying for "Associate Individual Giving" -> use "Individual Giving Director" at GID
  * If applying for "Development Coordinator" -> use "Development Manager" at GID
  * If applying for "Grant Writer" -> use "Senior Grant Writer" or "Grants Manager" at GID
  * NEVER use the exact same title as the job - it looks fake
- Entry to mid-level development professional
- Strong research, writing, and analytical skills
- Detail-oriented with project management experience
- Learning fundraising craft under mentorship
- Email: bryanjpiercejr@gmail.com (NOT a GMG email)
- Phone: 980-395-8662

FAMILY (MUST MENTION NATURALLY - THIS IS REQUIRED):
- Wife: Genesis Pierce
- Five children total: ONE DAUGHTER and FOUR SONS
  * Uriah (DAUGHTER) - oldest child, the ONLY GIRL
  * Bryan "B3" (son) - second child, nickname B3 to distinguish from dad
  * Brycen (son)
  * Josiah (son)
  * Braylen (son) - youngest
- CRITICAL: Uriah is a GIRL and the OLDEST CHILD. BJ has one daughter and four sons.
- Background: Pastor's son (lifelong foundation shaped by being raised in a pastor's home)
- REQUIRED: Every cover letter for BJ MUST mention his family naturally somewhere

PERSONAL CONNECTION GUIDANCE:
When writing cover letters that mention family:
- "My wife Genesis and I are raising five kids, starting with our oldest, Uriah"
- "As a father of five beginning with my daughter Uriah, I understand firsthand how important [youth/family services] are"
- "Raising my daughter Uriah and her four younger brothers gives me perspective on [relevant programs]"
- ALWAYS work family in naturally, it humanizes BJ

BJ'S PROFESSIONAL BACKGROUND:
- Nearly 10 years fundraising, grant writing, institutional giving
- GID Consulting (current) - title is LEVELED UP from job being applied for
- HomeFree-USA: $2.5M+ grant portfolio
- Brand-ON Consulting, LLC: Grant strategy and donor relations
- WNAA 90.1 FM Radio Host (2017-2022) - five years as on-air host
- BS in Business Administration

PERSONAL HOOKS (Choose Based on Org Type):
- Faith-based orgs: "My lifelong foundation shaped by being raised in a pastor's home"
- Education orgs: "My strong academic foundation including my BS in Business Administration"
- Media/Communications orgs: "My five years as on-air radio host at WNAA 90.1 FM"
- Family/Youth orgs: "My personal commitment as a father raising my daughter Uriah and her four brothers"
- General: "My commitment to community impact and organizational growth"

BJ'S POSITIONING:
- Emphasize learning mindset and growth potential
- Strong foundational skills, eager to develop
- Research and writing strengths
- NOT a senior executive - don't oversell
- Highlight GID Consulting experience as value-add
- His title at GID is SIMILAR but LEVELED UP from the job

TONE: Professional, eager, humble. Show potential without overpromising.

SIGNATURE FORMAT (EXACT):
Thanks,

Bryan J. Pierce
bryanjpiercejr@gmail.com
980-395-8662
`,

 gmgFlip: `
GMG FLIP - PROPOSING FIRM INSTEAD OF INDIVIDUAL HIRE

THE GMG FLIP STRATEGY:
Instead of applying as an individual employee, we propose GMG as a consulting/fractional alternative.
This is sent when we see a job posting and believe GMG can provide better value than a single hire.

THE VALUE PROPOSITION:
- "Instead of hiring one person, what if you had two senior fundraisers with 32 years combined experience?"
- Same budget as single mid-level hire gets two senior executives
- $260M+ combined track record across 65+ organizations
- No benefits overhead, no 6-month ramp-up time
- Fractional model = focused deliverables, senior-level strategy

THE APPROACH:
1. Acknowledge we saw their job posting
2. Be transparent: "I want to offer something different"
3. Explain the fractional development team model
4. Include GMG video link (shows Brandon and Eric's energy/personality)
5. Request 15 minutes to explore fit
6. Attach GMG overview/capabilities

EMAIL STRUCTURE:
- Subject: Re: [Position Title] - Alternative Approach
- Open: Thank them, mention the role
- Pivot: "I want to be transparent with you..."
- Value prop: Two senior leaders for price of one mid-level
- Social proof: $260M raised, 65+ orgs, track record
- Ask: 15 minutes to explore
- Include: Video link + attachment

TONE: Confident but not pushy. We're offering an alternative, not criticizing their approach.
Frame it as: "You might be interested in this option" not "You should hire us instead"
`
};

const generateCoverLetterWithAI = async (profile, job, isGMGFlip = false) => {
 // Get the appropriate instructions
 const personaKey = profile.shortName?.toLowerCase() || 'brandon';
 const personaInstructions = isGMGFlip ? COVER_LETTER_INSTRUCTIONS.gmgFlip :
 COVER_LETTER_INSTRUCTIONS[personaKey] || COVER_LETTER_INSTRUCTIONS.brandon;
 
 // V38.9: FULL writing standards included in EVERY cover letter
 const coverLetterPrompt = isGMGFlip ? 
 // GMG FLIP EMAIL
 `Generate a GMG Flip email - proposing Global Majority Group as an alternative to hiring an individual.

=== FULL GMG WRITING STANDARDS (CRITICAL - FOLLOW EXACTLY) ===
${GMG_WRITING_STANDARDS}
=== END WRITING STANDARDS ===

=== GMG FLIP STRATEGY ===
${COVER_LETTER_INSTRUCTIONS.gmgFlip}
=== END FLIP STRATEGY ===

=== GMG KNOWLEDGE DATABASE ===
${GMG_KNOWLEDGE}
=== END KNOWLEDGE ===

JOB THEY POSTED:
Organization: ${job.organization || '[Organization]'}
Position: ${job.title || '[Position]'}
Salary: ${job.salary || 'Not listed'}
Location: ${job.location || 'Not specified'}

JOB DESCRIPTION EXCERPT:
${(job.description || '').substring(0, 2000)}

GMG QUICK FACTS:
- Brandon J. Pierce Sr. + Dr. Eric R. Lane Sr. = 32 years combined experience
- $260M+ influenced across 65+ organizations
- Fractional development team model
- Based in NC and LA (can serve organizations anywhere)

OUTPUT: Just the email, ready to copy-paste. No explanations. No meta-commentary.`
 :
 // INDIVIDUAL COVER LETTER (V38.10: No GMG_KNOWLEDGE - lighter prompt)
 `Generate a personalized cover letter for a job application.

=== FULL GMG WRITING STANDARDS (CRITICAL - FOLLOW EXACTLY) ===
${GMG_WRITING_STANDARDS}
=== END WRITING STANDARDS ===

=== APPLICANT PERSONA ===
${personaInstructions}
=== END PERSONA ===

APPLICANT INFORMATION (CRITICAL - USE EXACTLY):
Full Name: ${profile.name}
Short Name: ${profile.shortName}
Email: ${profile.email}
Phone: ${profile.phone || 'N/A'}
Location: ${profile.location || 'N/A'}

CRITICAL SIGNATURE RULE: End with "Thanks," then "${profile.shortName}" on the next line, then "${profile.email}". 
NEVER use a different name. The signature MUST be ${profile.name}, NOT anyone else.

JOB DETAILS:
Organization: ${job.organization || '[Organization]'}
Position: ${job.title || '[Position]'}
Salary: ${job.salary || 'Not listed'}
Location: ${job.location || 'Not specified'}
${job.addressee ? `Addressee: ${job.addressee} (USE THIS NAME IN SALUTATION)` : ''}
${job.howToApply ? `How to Apply: ${job.howToApply}` : ''}

JOB DESCRIPTION EXCERPT:
${(job.description || '').substring(0, 2000)}

CRITICAL REQUIREMENTS:
1. 1800-2200 characters total
2. ${job.addressee ? `Start with "Dear ${job.addressee}," (REQUIRED - they specified this person)` : 'Start with "Greetings [Org] Hiring Team," or "Dear [Org] Hiring Team,"'}
3. Connect applicant's experience to THIS specific org's mission
4. Include personal touch (family mention for Brandon/Eric/BJ - REQUIRED for BJ, growth mindset for others)
5. End with simple "Thanks," then the applicant's name: ${profile.name}
6. SIGNATURE MUST BE: Thanks,\\n${profile.name}\\n${profile.email}

OUTPUT: Just the cover letter text, no explanation. Ready to copy-paste. No meta-commentary.`;

 try {
 // V3.4: Use Sonnet 4 for highest quality cover letters
 const response = await fetch('https://api.anthropic.com/v1/messages', {
 method: 'POST',
 headers: getApiHeaders(),
 body: JSON.stringify({
 model: MODEL_CONFIG.quality,
 max_tokens: 2500,
 messages: [{ role: 'user', content: coverLetterPrompt }]
 })
 });

 if (!response.ok) throw new Error('API request failed: ' + response.status);

 const data = await response.json();
 let letter = data.content?.[0]?.text || "";
 
 // Clean up any formatting issues
 letter = letter.replace(/```/g, '').trim();
 letter = letter.replace(/\u2014/g, ', ').replace(/--/g, ', ');
 
 // V38.8: ALWAYS run through rewrite cycle for quality assurance
 const quickCheck = runAICheck(letter, false);
 if (quickCheck.issues && quickCheck.issues.length > 0) {
 try {
 const rewritten = await rewriteInBrandonVoice(letter, quickCheck.issues);
 if (rewritten && rewritten.success && rewritten.content) {
 letter = rewritten.content;
 }
 } catch (e) {
 devLog('Secondary rewrite skipped:', e.message);
 }
 }
 
 return { success: true, letter };
 } catch (error) {
 devError('Cover letter generation failed:', error);
 return { success: false, error: error.message };
 }
};

const generateClientBriefingWithAI = async (clientName, materials, clientProfile) => {
 const briefingPrompt = `Generate a comprehensive client meeting briefing for a GMG (Global Majority Group) team meeting.

CLIENT NAME: ${clientName}

${clientProfile ? `
KNOWN CLIENT DATA:
- Status: ${clientProfile.status}
- Since: ${clientProfile.since}
- Focus: ${clientProfile.focus}
- Current Engagement: ${clientProfile.engagement}
- Key Contacts: ${clientProfile.contacts ? clientProfile.contacts.map(c => c.name + ' (' + c.role + ')').join(', ') : 'Not listed'}
- Notes: ${clientProfile.notes || 'None'}
` : 'This appears to be a new prospect or client not yet in GMG database.'}

PASTED MATERIALS TO ANALYZE:
${materials.substring(0, 6000)}

GMG CONTEXT:
- GMG is a BIPOC-led nonprofit fundraising consultancy
- Founded by Brandon J. Pierce Sr. and Dr. Eric R. Lane Sr.
- Services: Strategic Fundraising, Grant Writing, Development Operations, Board Training
- Methodologies: Grant MRI (audit), Data Science Development Plans, Prospect Precision, Tic-Tac-Toe Framework

GENERATE A BRIEFING WITH THESE SECTIONS:

1. CLIENT PROFILE - Summary of who they are, relationship status
2. KEY INSIGHTS FROM MATERIALS - Actually analyze what was pasted, extract key points, names mentioned, challenges identified, opportunities, action items discussed
3. RELATIONSHIP HISTORY - What's happened in previous interactions based on the materials
4. SUGGESTED TALKING POINTS - Specific to THIS client and THESE materials, not generic
5. RELEVANT GMG METHODOLOGIES - Which services/methodologies would help THIS client
6. ACTION ITEMS & NEXT STEPS - Specific recommendations based on materials

FORMATTING:
- Use ALL CAPS for section headers
- Use dashes for underlining headers
- Plain text, no markdown
- Be specific, not generic - actually analyze the pasted materials
- Reference specific names, dates, numbers from the materials

OUTPUT: Just the briefing text, ready to copy.`;

 try {
 const response = await fetch('https://api.anthropic.com/v1/messages', {
 method: 'POST',
 headers: getApiHeaders(),
 body: JSON.stringify({
 model: MODEL_CONFIG.fast,
 max_tokens: 3000,
 messages: [{ role: 'user', content: briefingPrompt }]
 })
 });

 if (!response.ok) throw new Error('API request failed: ' + response.status);

 const data = await response.json();
 let briefing = data.content?.[0]?.text || "";
 
 // Add header
 const header = `CLIENT BRIEFING: ${clientName.toUpperCase()}\n\nPrepared for: GMG Team Meeting\nDate: ${new Date().toLocaleDateString('en-US', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })}\n\n${'='.repeat(50)}\n\n`;
 
 briefing = header + briefing;
 briefing = briefing.replace(/```/g, '').trim();
 
 // V37.7: Secondary quality check on ALL outputs
 const quickCheck = runAICheck(briefing, false);
 if (quickCheck.issues && quickCheck.issues.length > 0) {
 try {
 const rewritten = await rewriteInBrandonVoice(briefing, quickCheck.issues);
 if (rewritten.success) {
 briefing = rewritten.content;
 }
 } catch (e) {
 devLog('Secondary rewrite skipped:', e.message);
 }
 }
 
 return { success: true, briefing };
 } catch (error) {
 devError('Client briefing generation failed:', error);
 return { success: false, error: error.message };
 }
};

// Helper function to search grants
const searchGrants = (query, category = null) => {
 const lowerQuery = query.toLowerCase();
 return GRANTS_DATABASE.filter(grant => {
 const matchesQuery = grant.name.toLowerCase().includes(lowerQuery) || 
 grant.focus.toLowerCase().includes(lowerQuery) ||
 grant.category.toLowerCase().includes(lowerQuery);
 const matchesCategory = !category || grant.category.toLowerCase().includes(category.toLowerCase());
 return matchesQuery && matchesCategory;
 });
};

// V31: Format grants for beautiful display
const formatGrantsDisplay = (grants, title = 'Grant Opportunities') => {
 if (!grants || grants.length === 0) {
 return 'No matching grants found in our database.';
 }
 
 // Group grants by category
 const grouped = grants.reduce((acc, grant) => {
 if (!acc[grant.category]) acc[grant.category] = [];
 acc[grant.category].push(grant);
 return acc;
 }, {});
 
 let output = `${title}\n${'='.repeat(title.length)}\n\n`;
 output += `Found ${grants.length} potential funding opportunities:\n\n`;
 
 Object.entries(grouped).forEach(([category, categoryGrants]) => {
 output += `${category.toUpperCase()} (${categoryGrants.length})\n`;
 output += '-'.repeat(40) + '\n';
 
 categoryGrants.forEach(grant => {
 output += `${grant.name}\n`;
 output += ` Amount: ${grant.amount}\n`;
 output += ` Deadline: ${grant.deadline}\n`;
 output += ` Focus: ${grant.focus}\n`;
 if (grant.url) output += ` Apply: ${grant.url}\n`;
 output += '\n';
 });
 });
 
 return output;
};

// V31: Get grants summary for quick reference
const getGrantsSummary = () => {
 const categories = {};
 GRANTS_DATABASE.forEach(g => {
 if (!categories[g.category]) categories[g.category] = 0;
 categories[g.category]++;
 });
 
 return Object.entries(categories)
 .map(([cat, count]) => `${cat}: ${count}`)
 .join(' | ');
};

// ============================================
// SECTION 2B: PROPOSAL BUILD INSTRUCTIONS (EMBEDDED)
// ============================================

const PROPOSAL_BUILD_INSTRUCTIONS = `
GMG PARTNERSHIP PROPOSAL - COMPLETE BUILD INSTRUCTIONS
======================================================

FILE NAMING CONVENTION
Format: [OrganizationName]_GMG_Development_Proposal.html
Examples: CureGM1_GMG_Development_Proposal.html, UnitedWay_GMG_Development_Proposal.html

REQUIRED ASSETS
- GMG Logo: /mnt/project/Logo.jpeg
- Brandon Headshot: /mnt/project/IMG_1324.jpeg  
- Eric Headshot: /mnt/project/Eric_lane_headshot.png
- Client Logo: User uploads to chat

GMG BRAND COLORS (CRITICAL)
- Navy Blue: #191970 (Primary headers, depth, trust)
- Brushed Copper: #B87333 (Highlights, accents, warmth)
- Platinum: #E5E4E2 (Secondary backgrounds)
- Pearl White: #F0EAD6 (Primary backgrounds)

COLOR APPLICATION
- H1 (Page Titles): #1a2332 (Dark Gray)
- H2 (Section Headers): #191970 (Navy Blue)
- H3 (Content Box Titles): #B87333 or #A0622F (Copper variants)
- Body Text: #4a5568 (Medium Gray)
- Stat Numbers: #191970 (Navy Blue)
- Prices/Highlights: #B87333 (Brushed Copper)
- Content Box Backgrounds: linear-gradient(135deg, #F0EAD6 0%, #E5E4E2 100%)

PAGE STRUCTURE (6-7 PAGES TOTAL)

Page 1: Title Page
- Both logos side by side (GMG + Client)
- Main title, subtitle with organization name, date

Page 2: About Us / Our Team (EARLY in proposal)
- Section header: "Who We Are" or "Our Team"
- Two-column grid with headshots
- Brandon: Co-Founder, 15 years fundraising & operations, Former Fortune 500 grantmaker, Charlotte NC / Buffalo roots
- Eric: Co-Founder, 17 years fundraising & consulting, Doctorate in Educational Leadership, Los Angeles CA
- Bottom stat: Together: 32+ years experience | $260M+ raised | 65+ organizations served

Page 3: The Challenge
- Client-specific challenge description
- Why this matters, what they need

Page 4: Our Solution & Track Record
- Stat grid (3 boxes): $260M+, 32+ years, 65+ orgs
- 4 content boxes explaining differentiators

Page 5: Our System & Deliverables
- Process steps (3 content boxes)
- First 90 Days deliverables (8-10 items max)

Page 6: Investment & Why GMG
- Investment box with pricing
- "What's Included" bullets
- 4 content boxes (2x2 grid) for "Why GMG"

Page 7: References
- 2-3 reference boxes with full contact info
- Chris Thompson (HomeFree-USA): SVP Chief Growth Officer, cmethompson@gmail.com, (917) 841-1136
- Janae Moore (Healthy Blue NC): Planning and Performing Director, Janae.Moore@healthybluenc.com, (919) 749-1025

TECHNICAL IMPLEMENTATION

CSS Requirements:
.page { width: 8.5in; height: 11in; padding: 0.75in; overflow: hidden; page-break-after: always; }
.content-box { background: linear-gradient(135deg, #F0EAD6 0%, #E5E4E2 100%); padding: 18px 20px; border-radius: 10px; border-left: 4px solid #B87333; }
.team-photo { width: 180px; height: 180px; border-radius: 50%; border: 5px solid #191970; object-fit: cover; }
.stat-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 20px; }

Font Size Hierarchy:
- h1: 2.2em (Page titles)
- h2: 1.9em (Section headers)
- h3: 1.2em (Content box titles)
- p: 0.95em (Body text)
- ul: 0.9em (Lists)

CONTENT DENSITY RULES
- Max 4 content boxes per page
- Max 3 sentences per content box paragraph
- Max 8-10 bullet items per list
- Stat grids always 3 columns
- Spacing between sections: 20-25px

GEOMETRIC SHAPES (Behind Content)
.shape-top-right { position: absolute; top: 0; right: 0; width: 280px; height: 280px; 
 background: linear-gradient(135deg, #C9A57B 0%, #B89968 100%);
 clip-path: polygon(100% 0, 100% 70%, 30% 0); opacity: 0.85; z-index: 0; }

PRICING MATH
Standard: 10 hours/week x $25/hour x 4 weeks = $1,000/month
3-Month Trial: $1,000 x 3 = $3,000 total

CONTACT INFORMATION
Always use @globalmajoritygroup.com
- brandon@globalmajoritygroup.com
- eric@globalmajoritygroup.com
NEVER use @gidconsulting.co (old domain)

PAGE NUMBERS
Format: "1 / 7", "2 / 7" etc.
Position: absolute, bottom: 30px, right: 30px

QUALITY CHECKLIST
- File named correctly
- Page 2 is "About Us" with both headshots embedded
- All 4 images embedded (GMG logo, client logo, Brandon, Eric)
- GMG brand colors throughout
- No content overflow
- Page numbers correct
- Email addresses are @globalmajoritygroup.com
- Math correct: $1,000/month | $3,000 total
- Reference info complete
- Geometric shapes render properly
- Content fits 0.75" margins
- No placeholders remain

WRITING STYLE
- NO em dashes anywhere
- NO AI phrases: "Here's the thing," "deeply resonated," "Furthermore"
- Complete sentences with natural flow
- No placeholders or "[continues...]"
- Client-ready: Zero meta-commentary
- Natural transitions: "But first," "And," "I think we also"

TEST: Can Brandon copy/paste and send immediately without edits? If YES, good. If NO, fix it.
`;

// ============================================
// SECTION 3: COMPLETE KNOWLEDGE DATABASE (FROM V18)
// ============================================

const GMG_KNOWLEDGE = `
GLOBAL MAJORITY GROUP (GMG) KNOWLEDGE DATABASE
Version 3.0 - Comprehensive API Reference
Last Updated: November 2025

----------------------------------------
SECTION 1: FOUNDERS
----------------------------------------

BRANDON J. PIERCE SR. - Co-Founder

Contact Information:
- Email: brandon@globalmajoritygroup.com
- Phone: 336-549-9608
- Location: Greensboro/High Point, North Carolina

Current Roles:
- Co-Founder, Global Majority Group (GMG) - October 2025 launch
- Executive Director, Brian Dawkins Impact Foundation (BDIF) - Started February 18, 2025
- Treasurer, Dream Center of Forsyth County
- Founder, Envolve Inc (holding company with Brand-On Consulting subsidiary)

Professional Background:
- 15+ years nonprofit fundraising and development experience
- Former Coca-Cola Foundation - reviewed $195M+ in grant applications as grantmaker
- Fortune 500 grantmaking experience provides funder perspective most consultants lack
- Community organizing work in Charlotte after Keith Lamont Scott shooting
- Family roots in Buffalo, NY (connection to 514 Memorial Foundation)

Track Record:
- Influence over $130M+ in philanthropic capital (combined with Eric: $260M+)
- 25-30% grant success rate (industry average is 15-20%)
- Served 25+ organizations across career

Education:
- Master of Political Science and Government (in progress) - American Public University System (APUS)

Expertise Areas:
- Grant writing and grantmaking (both sides of the table)
- Corporate foundation operations
- Nonprofit financial management
- Strategic planning and development
- Technology-enabled content generation with strict quality standards

Personal:
- Author working on multiple projects
- Uses AI extensively for writing with detailed style guides ensuring zero-edit-required outputs
- Father of four children: Bailey-J (daughter, 9, 4th grade), Joshua (son, 2nd grade), Jeremiah (son, kindergarten, citrus allergy), Bella-Ann (daughter, youngest)
- Wife: Bethany Pierce (stay-at-home parent)
- Brother: BJ Pierce (married to Genesis, five children, working on GID projects, starting Legacy Prep Academy)
- Faith-driven professional

DR. ERIC R. LANE SR. - Co-Founder

Contact Information:
- Email: eric@globalmajoritygroup.com
- Location: Los Angeles, California

Professional Background:
- 17 years of fundraising leadership
- Ed.D. in Educational Leadership from California State University, Fresno
- Managed federal grants through Mayor's Fund for Los Angeles
- Closed six and seven-figure gifts throughout career
- Run capital campaigns from $2 million to $10 million

Athletic Credentials:
- Former Division I basketball player at Boise State
- Professional career in Euro League
- Athletic Director at St. John Bosco High School (won national championship)
- NIL expertise - pioneered first high school team NIL deal
- 5+ years development leadership for collegiate athletic departments

Track Record:
- Influence over $130M+ in philanthropic capital
- Raised $3M+ for intercollegiate athletic programs at Division I schools (Cal State Fullerton, California Baptist University)
- Grew CSUF Athletics fundraising from $1.4M to $3M within two years
- Executed Folino Invitational Golf Tournament generating $500,000+ annually
- Served 40+ organizations

Expertise Areas:
- Major donor cultivation and solicitation
- Board training and development
- Capital campaign strategy
- Culture of philanthropy building
- Athlete foundation development

Signature Framework:
- Recipe Pitch Framework - teaches people to deliver compelling elevator pitches naturally rather than memorizing robotic scripts

COMBINED FOUNDER CREDENTIALS:
- 32+ years combined experience
- $260M+ influenced in fundraising across 65+ organizations
- Both funder and fundraiser perspectives (rare combination)
- BIPOC-led with authentic cultural competency rooted in lived experience

Why This Matters: When GMG sits with a client, we can explain exactly why their last three grant applications failed and what reviewers actually look for because Brandon was in those review rooms. Most consultants have either fundraiser OR funder experience. GMG has both.

----------------------------------------
SECTION 2: GMG STRUCTURE AND MODEL
----------------------------------------

DUAL-ENTITY STRUCTURE:

GMG LLC:
- For-profit consulting firm delivering client services
- Launched October 2025
- Pure consulting culture focused on excellence

GMG Foundation:
- 501(c)(3) nonprofit
- Funds the Lane-Pierce Fellowship
- Enables tax-advantaged talent development

LANE-PIERCE FELLOWSHIP:

Name: Lane-Pierce Fellowship in Development and Fundraising
Purpose: Creates career pipelines for emerging Black and BIPOC fundraising professionals through hands-on experience supporting GMG client work
Named After: Dr. Eric Lane Sr. and Brandon Pierce Sr. (alphabetical order, both founders honored equally)
Year 1 Fellow: Eli Cooley (starting January 12, 2026)

Compensation Structure:
- Annual stipend: $42,000 (paid monthly at $3,500)
- Funded entirely through GMG Foundation charitable donations
- Not an employee of GMG LLC

Time Commitment:
- 30-35 hours per week
- Flexible schedule around fellow's other commitments
- Focus on deliverable-based work

Term Length:
- 12 months (with potential for second year)
- Fellows serve 1-2 year terms
- New cohort application process begins annually in Q4

----------------------------------------
SECTION 3: CLIENT SERVICE MODEL
----------------------------------------

CLIENT TIER DEFINITIONS:

Pillar Clients (formerly "Anchor Clients"):
- Investment: $6,500-$8,500/month
- Commitment: 12-month engagement (renewable)
- Target: 6 Pillar Clients (3 per founder)
- Core client relationships that are the "pillars" supporting GMG's revenue base

Transitory Clients (formerly "Portfolio" or "Micro Clients"):
- Investment: $1,000-$1,500/month
- Commitment: Month-to-month or 6-month minimum
- Target: 7 Transitory Clients
- Named "Transitory" because they're either transitioning TO Pillar status, or transitioning OUT as they build internal capacity

SPORTS DIVISION SERVICE TIERS:

Training Camp (Transitory): $1,000-$2,500/month
- College athletes with NIL deals
- Early career professionals
- Rising talent

Starting Lineup (Pillar): $6,500-$8,500/month
- Established professionals with significant resources
- Full foundation strategy
- Example: Brian Dawkins Impact Foundation

----------------------------------------
SECTION 4: GMG BRANDED METHODOLOGIES
----------------------------------------

GRANT MRI:
What It Is: A comprehensive 30-day audit of your fundraising health and campaign readiness.
Signature Line: "Don't worry, we're not CPAs so we don't report to the IRS."
Pricing: 2% of previous year gross revenue

DATA SCIENCE DEVELOPMENT PLANS:
What It Is: Evidence-based development plan showing exactly where revenue can realistically come from.
Example: If you need $100K from grants: Average grant is $10K, success rate is 10%, you need a $1M pipeline, which means 100 applications, which means 33 per year, which means about 3 per month.
Pricing: 2% of previous year gross revenue

PROSPECT PRECISION (GRANTS):
What It Is: Data-driven funder landscape scan and pipeline development specifically for grant opportunities.

GRANT CATALYST:
What It Is: Full proposal development and submission support.

DONOR TIC-TAC-TOE COMMUNICATION SYSTEM:
What It Is: Internal equity tracking system for donor communications.
Rules:
- Every ASKING touch (money, volunteers, signups) = X
- Every VALUE touch (no ask: congratulations, impact updates, thank-yous) = O
- Goal: Keep getting tic-tac-toe with the O's, never let X's overlap
- The Ratio: Three value touches for every one ask (3:1 or better)

RECIPE PITCH FRAMEWORK (ERIC'S SIGNATURE):
The 5 Core Ingredients:
1. The Problem: What challenge does this organization face?
2. Our Approach: How does GMG solve this differently?
3. The Evidence: Why should they trust you?
4. The Engagement: What will you actually do?
5. The Investment: What it costs and why it's worth it.

----------------------------------------
SECTION 5: GMG CLIENTS AND PROJECTS
----------------------------------------

CURRENT/ACTIVE CLIENTS:

Brian Dawkins Impact Foundation (BDIF):
- Type: Pillar Client (Starting Lineup tier)
- Founder: Brian Dawkins (Hall of Fame NFL safety)
- Brandon's Role: Executive Director (started February 18, 2025)
- Focus: Youth development
- Signature Event: Golf tournament raises $200K+ annually
- Foundation Size: $500K foundation

Trey Flowers Foundation:
- Type: Active client
- Founder: Trey Flowers (former NFL defensive end)
- Focus: Athlete foundation development

MCW Global:
- Type: Ongoing consulting client
- Services: Grant writing, strategic planning
- Contacts: Khalid Elachi (Executive Director), Sharon Matongo (Development Associate, Tanzania-based), Regina Leichner (Director of Strategy & Impact), Eddie (Founder/President)

KOPP Foundation:
- Type: Active client
- Focus: Diabetes research and awareness
- Contacts: Max (President and Founder), Sabrina (Board Chair, acts like ED), Rachel (Grants Manager), Shandon (College Chapter Coordinator)
- Note: Called local Philadelphia businesses and arranged percentage-of-sales nights

Dream Center of Forsyth County:
- Brandon's Role: Treasurer (volunteer board position)
- Executive Director: Chris Leab
- Status: Managing significant financial reporting challenges

514 Memorial Foundation:
- Type: Prospect/Pipeline
- Location: Buffalo, NY
- Connection: Brandon's family roots in Buffalo

REFERRAL SOURCES:
- HomeFree-USA (Chris Thompson): Referring housing and supportive services organizations - GMG REFERENCE
- Healthy Blue NC (Janae Moore): Referring health-focused nonprofits - GMG REFERENCE
- Brian Dawkins Impact Foundation: Referring athlete foundations

----------------------------------------
SECTION 6: KEY DIFFERENTIATORS
----------------------------------------

Why Choose GMG:

1. Dual Expertise: Brandon's Fortune 500 grantmaking + Eric's 17 years fundraising = both funder and fundraiser perspectives

2. Branded Methodology: Grant MRI, Data Science Development Plans, Prospect Precision, Grant Catalyst, Donor Tic-Tac-Toe

3. Data-Driven Approach: Real projections with source identification. Track movement, not just money.

4. BIPOC-Led Authenticity: Authentic cultural competency rooted in lived experience. Global Majority framing positions excellence, not deficiency.

5. AI-Powered Operations: Enterprise-level results with boutique overhead. 40-60% cost savings on outreach.

----------------------------------------
SECTION 6B: GMG VIRTUAL ADMINS
----------------------------------------

Claudette (Sr. Virtual Executive Admin for Brandon Pierce):
- Professional appearance: navy blazer, slicked hair, sharp features
- Personality: Professional, efficient, direct
- Role: Handles CREATE tab content, checks for em dashes, assists with document creation

Chanet (Sr. Virtual Executive Admin for Dr. Eric Lane):
- Warm appearance: copper tones, curly hair, friendly smile 
- Personality: Warm, supportive, encouraging
- Role: Handles quality checks, assists with content review, provides friendly feedback

Both are Sr. Virtual Executive Admins that help GMG clients create content following Brandon strict writing standards.

----------------------------------------
SECTION 6C: FUNDRAISING STRATEGIES - RAFFLES & LOTTERIES
----------------------------------------

Raffle/Lottery Strategy for Small Nonprofits:
- Perfect for youth-led organizations and groups without wealthy donor networks
- Uses small-dollar participation at scale ($10-$20 tickets)
- 50/50 model: Winner takes half, nonprofit keeps half

Timing Strategy:
- Tax Refund Raffle (February): Average US refund is $3,000, hits mid-February
- School Refund Raffle (August-September): College students receive financial aid refunds

Example Revenue Model (from KOPP Foundation plan):
- Tax Refund Raffle: 500 participants x $20 = $10,000 gross, $5,000 net after prizes
- School Refund Raffle: 600 participants x $20 = $12,000 gross, $6,000 net
- Combined: $22,000 gross, $11,000 net

Prize Ideas:
- iPad Pro ($1,200 value, need 60 tickets at $20 to cover)
- AirPods Pro ($250 value, need 25 tickets at $10)
- Nintendo Switch Bundle ($500 value)
- Gift Card Packages ($500 value)

Key Insight: The real value is building database of 1,000+ participants for ongoing Tic-Tac-Toe communications, not just the immediate revenue.

----------------------------------------
SECTION 7: API QUICK REFERENCE
----------------------------------------

WHEN SOMEONE ASKS ABOUT GMG PRICING:
- Pillar Clients: $6,500-$8,500/month (12-month engagement)
- Transitory Clients: $1,000-$1,500/month (month-to-month or 6-month)
- Sports Division Training Camp: $1,000-$2,500/month
- Sports Division Starting Lineup: $6,500-$8,500/month
- Grant MRI: 2% of previous year gross revenue
- Data Science Development Plan: 2% of previous year gross revenue

WHEN SOMEONE ASKS ABOUT GMG'S TRACK RECORD:
- 32+ years combined experience
- $260M+ influenced in fundraising
- 65+ organizations served
- 25-30% grant success rate (vs 15-20% industry average)
- Brandon: reviewed $195M+ at Coca-Cola Foundation
- Eric: grew CSUF Athletics from $1.4M to $3M in two years

WHEN SOMEONE ASKS ABOUT CONTACT INFO:
- Brandon J. Pierce Sr.: brandon@globalmajoritygroup.com, 336-549-9608
- Dr. Eric R. Lane Sr.: eric@globalmajoritygroup.com

WHEN SOMEONE ASKS WHO IS SHANDON:
- Shandon is the College Chapter Coordinator at KOPP Foundation
- KOPP Foundation is an active GMG client focused on diabetes research and awareness

WHEN SOMEONE ASKS ABOUT CHRIS THOMPSON:
- Chris Thompson is SVP Chief Growth Officer at HomeFree-USA
- He is a GMG PROFESSIONAL REFERENCE, NOT a client contact
- He refers housing and supportive services organizations to GMG

WHEN SOMEONE ASKS ABOUT JANAE MOORE:
- Janae Moore is Planning and Performing Director at Healthy Blue NC
- She is a GMG PROFESSIONAL REFERENCE, NOT a client contact
- She refers health-focused nonprofits to GMG

----------------------------------------
SECTION 8: DR. ERIC R. LANE SR. - EXPANDED PROFILE (V37.6 ADDITION)
----------------------------------------

ERIC LANE CONTACT INFORMATION:
- Full Name: Dr. Eric R. Lane Sr.
- Email: eric@globalmajoritygroup.com
- Phone: (323) 600-7676
- Location: Los Angeles, California
- Origin: South Central Los Angeles
- Mother from: Cochran, Georgia

ERIC LANE EDUCATION:
- Ed.D. in Educational Leadership, California State University, Fresno
- Master's degree in Coaching and Athletic Administration

ERIC LANE FAMILY:
- Three children total
- Eric Jr. (EJ): Son, age 7
- Parker: Daughter, age 5
- Evan: Son, age 2

----------------------------------------
SECTION 9: ERIC'S CURRENT EBC CLIENTS
----------------------------------------

CLIENT 1: CFA
- Status: Active EBC Client
- GMG Lead: Eric
- Type: EBC (Consultant managing 3-4 clients through CFA)
- Pay: $105K as consultant
- Primary Contact: Jake
- Key Staff:
  - Stephanie Willis: CRM Expert, President of prospect research association board
  - Currently working with PBS SoCal
  - Paul: Support team member
- CFA-related grants: ~$3M secured across clients

CLIENT 2: Solve ME/CFS Initiative
- Status: Active EBC Client
- GMG Lead: Eric
- Primary Contact: Kristen Jacobson (President and CEO)
- Correct Spelling: "Solve ME" (NOT Solvame or Solveme)
- Focus: ME/CFS and Long Covid research funding
- Key Facts: Largest US funder of ME/CFS research, operates You+ME Registry biobank

CLIENT 3: Just Zero
- Status: Active EBC Client
- GMG Lead: Eric
- Contacts: Kirstie Pecci (Executive Director), Kevin Budris (Senior Counsel)
- Focus: Zero waste and environmental justice
- Founded: 2022, National advocacy organization

CLIENT 4: HCC
- Status: Active EBC Client
- GMG Lead: Eric
- Type: EBC (Full-time role)

----------------------------------------
SECTION 10: ERIC'S GID CONSULTING CLIENTS
----------------------------------------

GID Consulting Overview:
- Founded: 2008 by Eric Lane
- Clients served: 25+ engagements since inception
- Revenue raised through GID: $10M+ for clients
- Sectors: Health, education, environment, arts, social enterprise, journalism

Current/Recent GID Clients:
- PBS SoCal: Feasibility study, $25-30M projected
- Maternal Mental Health NOW: Board training
- High Country News: Media sustainability
- 28Twelve Foundation: Mental health nonprofit
- Art is My Drug: $50K event management
- Taiko Community Alliance: Arts nonprofit
- Orange County Justice United: Community organizing

----------------------------------------
SECTION 11: ERIC'S CAPITAL CAMPAIGN EXPERIENCE
----------------------------------------

Six total campaigns, $500M+ combined:

1. Cal State Fullerton: $300M comprehensive campaign
   - Grew athletics fundraising from $1.4M to $3M in two years
   - Created Folino Invitational golf tournament ($500K+ annually)

2. Northside Achievement Zone 2030 Campaign
   - Role: Directed campaign readiness and strategy

3. Eagle Bluff Environmental Learning Center
   - Role: Led campaign case development and readiness planning

4. Munson Healthcare Foundation
   - Role: Major donor engagement strategies

5. PBS SoCal
   - Role: Supported feasibility and readiness study
   - Projected Goal: $25-30M

6. Southern California School of Medicine
   - Role: Feasibility and readiness study

----------------------------------------
SECTION 12: ERIC'S CAREER HISTORY
----------------------------------------

GID Consulting - Executive Director (2021-Present)
- Partnered with nonprofit clients to raise $10M+ in corporate, private, and federal funds
- Manages cross-functional team of consultants and grant writers

Previous Executive Roles:
- Sarcoma Alliance - Fractional Executive Director (2017-2018)
- Kids Enjoy Exercise Now (KEEN) - Fractional ED (2014-2017), $500K budget
- Hoops for Kids (Israel & Africa) - Fractional ED (2013-2014)
- Englewood High School Foundation - Interim VP (2013)
- City Year Los Angeles - Partnership Director (2012-2013)

Athletic Development Career:
- Cal State Fullerton - Director of Development (2017-2022)
- Mayor's Fund for LA - Special Projects Director (2016-2017)
- A Place Called Home - Director of Development (2015-2016)
- Cal State Fullerton - Director of Annual Giving (2013-2015)
- St. John Bosco High School - Athletic Director (2011-2012)

Athletic Career:
- Boise State University: Division I basketball player
- Euro League: Professional basketball career in Europe

----------------------------------------
SECTION 13: ERIC'S KEY ACCOMPLISHMENTS
----------------------------------------

Fundraising Wins:
- $5M Embassy grant (U.S. Embassy and AMIDEAST)
- $3.5M foundation grant for health equity
- $3M Johnson & Johnson partnership
- $1.5M Disney corporate foundation gift
- CSUF Athletics: $1.4M to $3M in two years
- Folino Invitational: $500K+ annually
- Federal grants through Mayor's Fund for LA

Pioneering Work:
- First high school NIL deal at St. John Bosco
- National championship as Athletic Director

----------------------------------------
SECTION 14: ERIC'S RECIPE PITCH FRAMEWORK
----------------------------------------

Eric's signature methodology for effective asks:

Ingredient 1: The Problem
- What's the gap? What's broken?
- Example: "70% of nonprofits fail within 5 years due to funding gaps"

Ingredient 2: The Approach
- How we solve it
- Example: "Our Data Science Development Plan identifies exactly where revenue comes from"

Ingredient 3: The Evidence
- Proof it works
- Example: "We've influenced $260M+ across 65+ organizations with 25-30% grant success"

Ingredient 4: The Engagement
- What you get
- Example: "12-month partnership with monthly strategy calls, grant writing, prospect research"

Ingredient 5: The Investment
- Cost and ROI
- Example: "$6,500/month ($78K annually), $52K less than full-time director, 4-6x ROI expected"

Optional Ingredient 6: The Alternative
- What happens without action (use sparingly)

----------------------------------------
SECTION 15: ERIC'S CALIFORNIA NETWORK
----------------------------------------

Institutional Relationships:
- California Baptist University
- Cal State Fullerton
- LA Mayor's Fund
- Playworks Southern California
- Culver-Palms YMCA, Westchester Family YMCA, Inglewood YMCA
- PBS SoCal

Celebrity/VIP Connections (from CSUF work):
- Kevin Costner
- Bruce Bowen
- Cedric Ceballos
- Mike Scioscia
- Justin Turner
- Kurt Suzuki

Corporate Partners:
- Nike, Oakley, eBay, Buffalo Wild Wings, Yard House

----------------------------------------
SECTION 16: GMG SPORTS DIVISION
----------------------------------------

Training Camp (Transitory): $1,000-$2,500/month
- Target: College athletes with NIL deals, early career professionals
- Services: Strategic planning, foundation setup, program design

Starting Lineup (Pillar): $6,500-$8,500/month
- Target: Established professionals with significant resources
- Services: Full foundation strategy, grant writing, capital campaign planning

Sports Pipeline Sources:
- Sideline Management: Sports management firm
- Chelsea's network: Professional and collegiate connections
- Chris Swan: Retired NBA players, Houston NBA Retired Players Association

----------------------------------------
SECTION 17: API QUERY GUIDANCE FOR ERIC
----------------------------------------

WHEN SOMEONE ASKS ABOUT ERIC'S BACKGROUND:
- Ed.D. from Cal State Fresno in Educational Leadership
- Former D1 basketball player (Boise State) + Euro League professional
- Athletic Director at St. John Bosco (national championship, pioneered HS NIL deal)
- 17 years fundraising experience, $15M+ personally secured

WHEN SOMEONE ASKS ABOUT ERIC'S SPECIALTY:
- Major donor cultivation and solicitation
- Capital campaigns ($2M-$10M range, led $500M+ combined)
- Board training and development
- Athlete foundation development, NIL strategy

WHEN SOMEONE ASKS ABOUT ERIC'S CLIENTS:
- CFA: Jake is contact, Stephanie Willis is CRM expert
- Solve ME: Kristen Jacobson is CEO (correct spelling)
- Just Zero: Kirstie Pecci is ED
- GID clients: PBS SoCal, Maternal Mental Health NOW, High Country News, 28Twelve

WHEN SOMEONE ASKS ABOUT ERIC'S FAMILY:
- Three kids: Eric Jr. (EJ, son, 7), Parker (daughter, 5), Evan (son, 2)
- From South Central LA, mother from Cochran, Georgia

END OF KNOWLEDGE DATABASE

----------------------------------------
GMG UNIVERSITY - 60-DAY FUNDRAISING CRASH COURSE
(Lane-Pierce Fellowship Training Curriculum)
----------------------------------------

ABOUT GMG UNIVERSITY:
- Umbrella brand for all GMG training
- Volume 1: Fundraising Foundations (60 Days) - Open enrollment
- Volume 2: Advanced Execution (30 Days) - Coming soon
- Powers the Lane-Pierce Fellowship curriculum

DAY 1: THE FOUR SOURCES OF MONEY
Every nonprofit dollar comes from four sources:

1. Individual Donors (64% of all giving)
   - Annual donors: $50-$5,000/year
   - Monthly donors: Build to larger annual totals
   - Major donors: $10,000+
   - Planned giving: Estate plans

2. Institutional Funders (21% of giving)
   - Private foundations (Gates, Ford)
   - Community foundations
   - Corporate foundations
   - Government grants (federal, state, local)
   - Success rate: 15-30%

3. Corporate Partnerships (5% of giving)
   - Sponsorships
   - Cause marketing
   - Employee giving programs
   - Matching gifts
   - In-kind donations

4. Earned Revenue (10%, should be 15-20%)
   - Program fees
   - Consulting/training
   - Product sales
   - Ticket sales
   - Facility rentals

RECOMMENDED DIVERSIFICATION:
- 35-45% individual donors
- 25-30% foundation grants
- 10-15% corporate partnerships
- 15-20% earned revenue

DAY 2: WHY PEOPLE ACTUALLY GIVE
- Identity and values alignment
- Personal connection to the work
- Belief gift makes a difference
- Being asked explicitly (85% don't give until asked)
- Trust in organization and leadership
- Social reasons (belonging, recognition)
- Problem they want solved
- Right timing (capacity)

DAY 3: THE DONOR LIFECYCLE
1. Identification - Find potential donors
2. Qualification - Capacity + Affinity = Worth pursuing
3. Cultivation - 7-10 touches before asking
4. Solicitation - Make the ask (specific, tied to impact)
5. Stewardship - Thank within 48 hours, report impact
6. Renewal/Upgrade - Move them up the pyramid

DAY 4: THE DONOR PYRAMID
- Bottom (500+ donors): $25-$499 annual
- Middle (50-200 donors): $500-$4,999
- Upper-middle (10-50 donors): $5,000-$9,999
- Near top (5-20 donors): $10,000-$24,999
- Top (rare): $25,000+, transformational gifts

80/20 RULE: 80% of revenue from 20% of donors
5-10% of donors often provide 50%+ of revenue

DAY 5: ANNUAL GIVING BASICS
- October-December campaign (30% of giving in Q4)
- 10% in final three days of December
- Segmentation: first-time, repeat, lapsed, major prospects
- Monthly giving: $25/month = $300/year (3x one-time gifts)
- Monthly donor retention: 80%+ vs 40% one-time
- Thank within 48 hours

DAY 6: MAJOR GIFTS FUNDRAISING
Five stages:
1. Identification - Build prospect pool of 50-200
2. Research - Wealth + Affinity indicators
3. Cultivation - 12-18 months, 7-10 touches
4. Solicitation - Face-to-face, specific ask, stop talking after
5. Stewardship - Call within 48 hours, meet within 30 days

DAY 7: FOUNDATION GRANTS REALITY
Success rates: 15-30%
Types: Private, Community, Corporate
Process: LOI (2-3 pages) -> Full proposal (5-10 pages) -> Review (3-6 months)
Most grants are restricted (specific programs)

DAY 16: GRANT WRITING STRUCTURE
1. Executive Summary (1 page) - Most important
2. Organization Background (1-2 pages)
3. Statement of Need (2-3 pages) - Data-backed
4. Project Description (3-4 pages) - Specific activities
5. Evaluation Plan (1-2 pages) - Outputs AND outcomes
6. Budget (1-2 pages) - Line-item + narrative
7. Sustainability (1 page) - How continue after grant
8. Attachments - 501c3, board list, financials, support letters

DAY 17: GRANT QUALIFICATION
Three alignment factors (need ALL three):
1. Mission alignment - Do they fund your issue?
2. Geographic alignment - Do they fund your location?
3. Size alignment - Does typical grant match your need?

Research tools: Instrumental ($200/mo), Foundation Directory Online, GrantStation, IRS 990s on ProPublica

DAY 18: MAJOR DONOR RESEARCH
Capacity ratings: A=$100K+, B=$25K-99K, C=$10K-24K, D=$5K-9K
Affinity ratings: 1=Currently engaged, 2=Previously engaged, 3=Connected not engaged, 4=No connection
A1 = Top priority (high capacity, currently engaged)

GMG BENCHMARKS (use in DSDP):
- Foundation grant success rate: 20-25%
- Corporate partnership conversion: 30-40%
- Individual donor acquisition: 3x prospects to get 1 donor
- Average foundation grant: $15,000-$25,000
- Average corporate sponsorship: $2,500-$10,000
- Donor retention goal: 60%+ (industry average 42%)

GMG FORMULAS:
- Pipeline needed = Target revenue / success rate
- For $100K grants at 25% success = $400K pipeline needed
- Monthly giving value = Monthly amount x 12 x retention years
- $25/month x 12 x 5 years = $1,500 lifetime value

TIC-TAC-TOE FRAMEWORK:
3:1 ratio - Three value touches for every ask
Value touches: Impact reports, thank you notes, program updates, invitations
Ask touches: Donation requests, campaign appeals

RECIPE PITCH FRAMEWORK (Eric's 5 Ingredients):
1. Invitation - Tailored to your audience
2. Opportunity - Problem you're addressing
3. Vision - Where you're going
4. Flavor Enhancers - Stats, three-pillar approach, economic benefits
5. Continuation - Something that keeps conversation going

----------------------------------------

----------------------------------------
ERIC LANE COMPLETE KNOWLEDGE DATABASE UPDATE
(Full Integration - December 4, 2025)
----------------------------------------

# SECTION 1: DR. ERIC R. LANE SR. - COMPLETE PROFILE

## Contact Information
- Full Name: Dr. Eric R. Lane Sr.
- Email: eric@globalmajoritygroup.com
- Phone: (323) 600-7676
- Location: Los Angeles, California
- Origin: South Central Los Angeles
- Mother from: Cochran, Georgia

## Education
- Ed.D. in Educational Leadership, California State University, Fresno
- Master's degree in Coaching and Athletic Administration

## Family
- Wife: (name not disclosed in records)
- Children (3 total):
  - Eric Jr. (EJ): Son, age 7
  - Parker: Daughter, age 5
  - Evan: Son, age 2

---

# SECTION 2: ERIC'S CURRENT EBC CLIENTS (Employee-Based Consulting)

## CLIENT 1: CFA
- Status: Active EBC Client
- GMG Lead: Eric
- Type: EBC (Consultant managing 3-4 clients through CFA)
- Pay: $105K as consultant
- Primary Contact: Jake
- Key Staff:
  - Stephanie Willis: CRM Expert
    - Certified expert in multiple CRMs: Salesforce, Blackbaud, Advance, eTapestry, Boomerang, Neon, Fundraise
    - President of prospect research association board
    - Currently working with PBS SoCal
    - Known for amplifying contracts and proposals through CRM manipulation
  - Paul: Support team member
  - Project Manager: Part of CFA ecosystem
- CFA-related grants: ~$3M secured across clients
- Notes: Eric manages 3-4 clients through CFA structure with support ecosystem

## CLIENT 2: Solve ME/CFS Initiative
- Status: Active EBC Client
- GMG Lead: Eric
- Type: EBC
- Primary Contact: Kristen Jacobson (President and CEO)
- Correct Spelling: "Solve ME" (NOT Solvame or Solveme)
- Focus: ME/CFS and Long Covid research funding
- Key Facts:
  - Largest US funder of ME/CFS research
  - Operates You+ME Registry biobank
- Engagement: Development strategy

## CLIENT 3: Just Zero
- Status: Active EBC Client
- GMG Lead: Eric
- Type: EBC
- Contacts:
  - Kirstie Pecci: Executive Director
  - Kevin Budris: Senior Counsel
- Focus: Zero waste and environmental justice
- Founded: 2022
- Type: National advocacy organization
- Recent wins: Campaign strategy and Giving Tuesday launch

## CLIENT 4: HCC
- Status: Active EBC Client
- GMG Lead: Eric
- Type: EBC (Full-time role)
- Contacts: TBD
- Focus: TBD
- Notes: Part of Eric's EBC portfolio

---

# SECTION 3: ERIC'S GID CONSULTING CLIENTS (Current and Past)

## GID Consulting Overview
- Founded: 2008 by Eric Lane
- Clients served: 25+ engagements since inception
- Revenue raised through GID: $10M+ for clients
- Services: Full-service fundraising and communications support, campaign planning, grant strategy, board development, corporate sponsorship, donor engagement
- Sectors: Health, education, environment, arts, faith-based
- Markets: California, New York, Georgia, North Carolina, Washington D.C., Arizona

## Current/Recent GID Clients

### PBS SoCal
- Type: GID Client
- Engagement: Feasibility and readiness study
- Projected Campaign Goal: $25-30M
- Status: Feasibility study completed
- CRM work by: Stephanie Willis (through CFA)

### Maternal Mental Health NOW
- Type: GID Client
- Engagement: Multi-year development infrastructure build
- Current work: Board training
- Mental health focus: Relevant to GMG's mental health positioning

### High Country News
- Type: GID Client
- Engagement: Multi-year development infrastructure build

### 28Twelve Foundation
- Type: GID Client
- Engagement: Campaign strategy and Giving Tuesday launch

### Art is My Drug
- Type: GID Client
- Engagement: $50K event-based fundraiser

### Taiko Community Alliance
- Type: GID Client
- Engagement: Development support
- Mental health connection for positioning

### Orange County Justice United
- Type: GID Client
- Engagement: Development support

---

# SECTION 4: ERIC'S CAPITAL CAMPAIGN EXPERIENCE

## Campaign Portfolio (6 Major Campaigns, $500M+ Combined)

### 1. California State University, Fullerton
- Campaign Size: $300M five-year comprehensive campaign
- Eric's Role: Lead on major gifts strategy, prospect research, and corporate engagement
- Position: Director of Development, Athletics, Campaign and University Programs (2017-2019)
- Key Achievement: Grew athletics fundraising from $1.4M to $3M within two years
- Additional work:
  - Managed $200M university-wide campaign alignment
  - Concert Under the Stars: $1M+ annually
  - Hispanic Scholarship Golf Tournament: $200K+ annually
  - Folino Invitational Golf Tournament: $500K+ annually
  - Launched Friday's at Fullerton booster club
  - Started CSUF Letter Winners Club (400+ former athletes)

### 2. Northside Achievement Zone (NAZ) 2030 Campaign
- Eric's Role: Directed campaign readiness and strategy
- Focus: Feasibility framing, narrative development, systems-change positioning

### 3. Eagle Bluff Environmental Learning Center
- Eric's Role: Led campaign case development and readiness planning
- Focus: Sustainability and environmental education

### 4. Munson Healthcare Foundation
- Eric's Role: Partnered on campaign alignment, messaging, and major donor engagement strategies

### 5. PBS SoCal
- Eric's Role: Supported feasibility and readiness study
- Projected Goal: $25-30M

### 6. Southern California School of Medicine
- Eric's Role: Feasibility and readiness study

---

# SECTION 5: ERIC'S CAREER HISTORY (Complete Timeline)

## Executive Leadership Roles

### GID Consulting - Executive Director (2021-Present)
- Remote position
- Partnered with nonprofit clients to raise $10M+ in corporate, private, and federal funds
- Manages cross-functional team of consultants, grant writers, and administrative staff
- Collaborates with Founders, CEOs, and EDs on fundraising strategy
- Provides end-to-end grant support

### Sarcoma Alliance - Fractional Executive Director (2017-2018)
- Remote, Part-Time
- Led national nonprofit dedicated to rare cancer patients
- Expanded access to financial and peer support programs
- Increased revenue through major gifts, grants, and digital campaigns

### Kids Enjoy Exercise Now (KEEN) - Fractional Executive Director (2014-2017)
- Remote, Part-Time
- Directed inclusive recreation programs for children with disabilities
- Managed $500,000 annual budget
- Secured federal and private grants
- Supervised 50+ volunteers

### Hoops for Kids (Israel & Africa) - Fractional Executive Director (2013-2014)
- Remote, Part-Time
- Built international partnerships for youth sports and education
- Combined sports, mentorship, and entrepreneurship opportunities
- Raised funds through corporate sponsorships and global philanthropy networks

## Development Leadership Roles

### California Baptist University - Director of Development (2019-2021)
- Riverside, CA
- Part of CBU athletics development team raising $1.5M+ annually
- Wrote foundation proposals raising $500K annually
- Managed donor portfolio of 120 prospects
- Coordinated signature fundraising events (golf, galas, banquets)
- Supervised Assistant Director and Leadership Committees

### California State University, Fullerton - Director of Development (2017-2019)
- Athletics, Campaign and University Programs
- Grew athletics fundraising $1.4M to $3M in two years
- Managed comprehensive campaign with Marts and Lundy consultants
- Executed Folino Invitational ($500K+ annually)
- Coordinated with celebrities: Kevin Costner, Bruce Bowen, Cedric Ceballos, Mike Scioscia, Justin Turner, Kurt Suzuki
- Solicited $300K+ in corporate sponsorships: Nike, Oakley, eBay, Buffalo Wild Wings, Yard House

### Mayor's Fund for Los Angeles - Development Manager (2015-2017)
- Los Angeles, CA
- Developed fundraising strategy for 19 civic programs
- Secured $5M+ from diverse philanthropic sectors
- Created and executed grant research, LOIs, and reporting
- Cultivated relationships with institutional philanthropy, family foundations, corporations

### Playworks Southern California - Chief Development Officer (2012-2015)
- El Segundo, CA
- Led 8-person development team
- Secured $8M+ in 3 years
- Key grants: $5M Embassy, $3.5M foundation, $3M J&J, $1.5M Disney
- Grew Playworks from $2M to $5M organization
- Launched corporate sponsorship strategies across LA market

## Athletics Leadership Roles

### St. John Bosco High School - Athletic Director (2019)
- Bellflower, CA
- Led national championship winning program
- Pioneered first high school team NIL deal
- Managed 30+ sports programs
- Supervised 100+ coaches

### Various YMCA Positions (2008-2012)
- Westchester Family YMCA
- Culver-Palms YMCA
- Youth development and athletics programming

## Playing Career

### Boise State University - Division I Basketball Player
- 4-year letter winner
- Scholar-Athlete of the Year nomination
- Point guard position

### Professional Career
- Euro League: Serbia and Germany
- ABA: Los Angeles Aftershock
- Combined professional experience overseas and domestically

---

# SECTION 6: ERIC'S ATHLETIC BACKGROUND

## Player Stats and Achievements
- Division I Basketball: Boise State University (4 years)
- Position: Point Guard
- Scholar-Athlete of the Year nomination
- Professional: Euro League (Serbia, Germany) + ABA (Los Angeles Aftershock)

## Athletic Administration Experience
- 5+ years collegiate athletic development leadership
- Athletic Director at St. John Bosco (national championship)
- NIL pioneer: First high school team NIL deal
- Deep understanding of athlete-donor relationships

## Sports Philanthropy Expertise
- Understanding of athlete foundation needs
- Experience with current and retired professional athletes
- Knowledge of NIL landscape and opportunities
- Network includes NBA, NFL, and collegiate connections

---

# SECTION 7: ERIC'S KEY ACCOMPLISHMENTS

## Revenue Raised
- $15M+ personally secured in philanthropic support
- 40+ organizations served
- 17 years of fundraising leadership experience

## Major Gift Closings
- Six and seven-figure gifts throughout career
- $5M Embassy grant
- $3.5M foundation grant
- $3M Johnson & Johnson
- $1.5M Disney

## Program Development
- Grew CSUF Athletics from $1.4M to $3M (100%+ increase)
- Grew Playworks from $2M to $5M organization
- Folino Invitational: $500K+ annually
- Titan Giving Day: $1.4M in one day

## Leadership
- Managed 8-person development team at Playworks
- Supervised 100+ coaches at St. John Bosco
- Cross-functional team leadership at GID Consulting

---

# SECTION 8: RECIPE PITCH FRAMEWORK (Eric's Signature)

## The 5 Core Ingredients for Compelling Pitches

**Ingredient 1: The Problem**
What challenge does this organization face? Be specific. Use data.
- Bad: "The nonprofit needs help with fundraising."
- Good: "This organization raised $450K last year but needs to hit $650K this year to maintain programs. They don't have a development director, their board isn't giving, and they're grant-dependent with no individual donor base."

**Ingredient 2: Our Approach**
How does GMG solve this differently than generic consultants?
- Bad: "We'll help you fundraise better."
- Good: "We start with our Grant MRI to understand your current reality, then build a Data Science Development Plan using industry benchmarks. We implement our Tic-Tac-Toe engagement framework to improve donor retention from 42% to 60%+."

**Ingredient 3: The Evidence**
Why should they trust you? Past results, relevant experience.
- Bad: "We're really good at this."
- Good: "We helped a similar organization in Phoenix increase individual giving from $80K to $210K in 18 months. Their donor retention improved from 38% to 67%."

**Ingredient 4: The Engagement**
What will you actually do? Deliverables, timeline, process.
- Bad: "We'll provide fundraising support."
- Good: "We'll deliver 30 hours per month including 2-4 grant proposals, monthly giving campaign setup, board training session, CRM implementation, and bi-weekly strategy calls."

**Ingredient 5: The Investment**
What it costs and why it's worth it.
- Bad: "Our services cost $6,500/month."
- Good: "Our engagement is $6,500/month ($78K annually), which is $52K less than a full-time development director. Based on our track record, you should see 40-60% revenue increase within 12 months, meaning 4-6x ROI."

**Optional Ingredient 6: The Alternative**
What happens if they don't do this? Use sparingly.

---

# SECTION 9: ERIC'S EXPERTISE AREAS

## Primary Competencies
- Major donor cultivation and solicitation
- Capital campaign strategy ($2M-$10M range)
- Feasibility studies
- Board training and development
- Culture of philanthropy building
- Athlete foundation development
- NIL expertise and strategy
- Higher education development
- Youth development programming
- Sports and recreation fundraising

## Geographic Expertise
- California (primary market)
- New York
- Georgia
- North Carolina
- Washington D.C.
- Arizona

## Sector Experience
- Health and wellness
- Education (K-12 and higher ed)
- Environment and sustainability
- Arts and culture
- Social enterprise
- Family law and fatherhood advocacy
- Journalism
- Youth sports development

---

# SECTION 10: ERIC'S CALIFORNIA NETWORK

## Institutional Relationships
- California Baptist University
- Cal State Fullerton
- LA Mayor's Fund
- Playworks Southern California
- Culver-Palms YMCA
- Westchester Family YMCA
- Inglewood YMCA (career origin)
- PBS SoCal

## Celebrity/VIP Connections (from CSUF work)
- Kevin Costner
- Bruce Bowen
- Cedric Ceballos
- Mike Scioscia
- Justin Turner
- Kurt Suzuki

## Corporate Partners (from CSUF work)
- Nike
- Oakley
- eBay
- Buffalo Wild Wings
- Yard House

---

# SECTION 11: GMG SPORTS DIVISION (Eric's Specialty)

## Service Tiers

### Training Camp (Transitory): $1,000-$2,500/month
- Target: College athletes with NIL deals, early career professionals, rising talent
- Services: Strategic planning, foundation setup, program design
- Value: Accessible pricing to lock in loyalty early
- Path: Natural pathway to Pillar tier as careers progress

### Starting Lineup (Pillar): $6,500-$8,500/month
- Target: Established professionals with significant resources
- Services: Full foundation strategy, grant writing, capital campaign planning, comprehensive impact measurement

## Sports Pipeline Sources
- Sideline Management: Sports management firm introducing current athletes
- Chelsea's network: Professional and collegiate connections
- Chris Swan: Retired NBA players through Houston NBA Retired Players Association

---

# SECTION 12: API QUERY GUIDANCE FOR ERIC-RELATED QUESTIONS

## When Someone Asks About Eric's Background
- Ed.D. from Cal State Fresno in Educational Leadership
- Former D1 basketball player (Boise State) + Euro League professional
- Athletic Director at St. John Bosco (national championship, pioneered HS NIL deal)
- 5+ years collegiate athletic development
- $15M+ personally secured in philanthropic support
- 40+ organizations served
- 17 years fundraising experience

## When Someone Asks About Eric's Specialty
- Major donor cultivation and solicitation
- Capital campaigns ($2M-$10M, led $500M+ combined)
- Board training and development
- Athlete foundation development
- NIL strategy and expertise
- Culture of philanthropy building
- Feasibility studies

## When Someone Asks About Eric's Track Record
- CSUF Athletics: $1.4M to $3M in two years
- Folino Invitational Golf Tournament: $500K+ annually
- Six and seven-figure gift closings
- $5M Embassy grant, $3.5M foundation grant, $3M J&J, $1.5M Disney
- Federal grants through Mayor's Fund for LA
- PBS SoCal feasibility ($25-30M projected)

## When Someone Asks About Eric's Framework
- Recipe Pitch Framework (his signature methodology)
- 5 Core Ingredients: Problem, Approach, Evidence, Engagement, Investment
- Optional 6th: The Alternative

## When Someone Asks About Eric's Clients
- CFA: Jake is contact, Stephanie Willis is CRM expert
- Solve ME/CFS Initiative: Kristen Jacobson is CEO (correct spelling)
- Just Zero: Kirstie Pecci is ED
- HCC: EBC portfolio
- PBS SoCal, Maternal Mental Health NOW, High Country News, 28Twelve Foundation, Art is My Drug (GID clients)

## When Someone Asks About Eric's Family
- Three kids: Eric Jr. (EJ, son, 7), Parker (daughter, 5), Evan (son, 2)
- From South Central Los Angeles
- Mother from Cochran, Georgia

---

# SECTION 13: CLIENT CONTACTS DATABASE (Eric's Network)

## CFA Contacts
- Jake: Primary Contact
- Stephanie Willis: CRM Expert, Prospect Research President, PBS SoCal work
- Paul: Support team

## Solve ME Contacts
- Kristen Jacobson: President and CEO
- Correct spelling: Kristen (not Kristin), Jacobson (not Jacobsen)

## Just Zero Contacts
- Kirstie Pecci: Executive Director (spelling: Kirstie, not Kristie or Kirsty)
- Kevin Budris: Senior Counsel

## GID/Campaign Contacts
- PBS SoCal: Feasibility study contacts through Stephanie Willis
- Northside Achievement Zone: Campaign readiness contacts
- Maternal Mental Health NOW: Board training contacts

---

# SECTION 14: WHAT'S STILL NEEDED (For Manual Addition)

The following items were mentioned but specific details not found:

1. **Eric's wife's name** - Not disclosed in available records
2. **Upstream** - Mentioned as past client, no details found
3. **Additional CFA structure details** - Full organizational hierarchy unclear
4. **Eric's EBC compensation breakdown** - Total EBC portfolio value unclear

---

# END OF ERIC LANE KNOWLEDGE DATABASE UPDATE

**Version:** 1.0 Complete
**Date Compiled:** December 2, 2025
**Source Documents:**
- GMG_ACE_Portal_v37_COMPLETE.jsx
- GMG_ACE_Portal_v33_COMPLETE.jsx
- GMG_Assistant_Knowledge_Database_v10.md.pdf
- brandon and Eric 2 hr call 11.03.25.pdf
- Call recording Eric Lane_251030_181002.pdf
- PDF from Call recording Eric Lane_251106_213619.pdf
- Call with Eric lane about trey flowers presentation.pdf
- GMG and Flowers for Future PITCH meeting transcript.pdf
- Eric Lane cover letter & resume (Common Good).pdf
- Global Majority Group Resume.pdf
- UPDATED_Combined_IMPACT_METRICS_Global_Majority_Group.md
- GMG_ChatGPT_Crossover_Document_Complete.md.pdf
- GMG_ACE_Portal_V37_CHANGELOG.md
- GMG_ACE_Portal_V37_BUILD_INSTRUCTIONS.md
- GMG_Assistant_BUILD_INSTRUCTIONS_COMPREHENSIVE.md

==========================================================
V39 KNOWLEDGE UPDATE: GMG ECOSYSTEM & TERMINOLOGY
==========================================================

GMG ECOSYSTEM STRUCTURE
-----------------------
GMG is not just a consulting firm. It's an ecosystem with multiple verticals.

GLOBAL MAJORITY GROUP (The Ecosystem)
  - GMG Consulting (Traditional consulting arm, CFA-comparable)
  - GMG Foundation (Charitable/fellowship arm)
  - CPP - Consultant Pipeline Program (Private vertical)
  - GID / Brandon Inc. (Contractor vehicles)

Key Distinction: When comparing to CFA or other firms, we compare to GMG Consulting specifically, not the entire GMG ecosystem.

TERMINOLOGY (CRITICAL)
----------------------
| Term | Definition | What They Do |
| Founders | Brandon and Eric | EBC (Employee-Based Consulting) |
| Alumni | BJ, Mike, graduates | CPP (Consultant Pipeline Program) |
| Fellows | Eli, future students | Background Support |

Usage Examples:
- "BJ is Alumni. He's running CPP."
- "Eli is a Fellow doing background support."
- "Brandon and Eric do EBC."

What NOT to call things:
- Don't call BJ/Mike "Fellows" (they're Alumni)
- Don't call the training "Lane-Pierce Fellowship" for Alumni (that's for Fellows)
- Don't call EBC work "consulting" publicly

THE FIVE PIPELINES
------------------
GMG has five distinct funding pipelines. Each needs its own strategy and metrics.

| Pipeline | Description | Vertical |
| EBC | Employee-Based Consulting (Founders' side income) | Private |
| CPP | Consultant Pipeline Program (Alumni doing their own EBC) | Private |
| Transitory Clients | Short-term engagements, often from Idealist flips | GMG Consulting |
| Anchor Clients | Long-term retainer relationships ($7,500+/month minimum) | GMG Consulting |
| Flips | Job postings converted to consulting proposals | GMG Consulting |

Client Acquisition Strategy: Maximize all five pipelines simultaneously. Success in half of them equals major success overall.

SPORTS DIVISION
---------------
Current Roster:
- Brian Dawkins | NFL | Hall of Fame Safety
- Trey Flowers | NFL | Super Bowl Champion
- Anthony Barr | NFL | Pro Bowl Linebacker

Marketing Approach: Lead with accomplishments, not names.
CORRECT: "We've worked with NFL Hall of Famers, Super Bowl champions, and Pro Bowl athletes."
INCORRECT: "We work with Brian Dawkins."

Eric's Sports Credentials:
- Former Division 1 athlete (Cal State Fullerton, starting point guard)
- Former professional athlete (Euro League basketball)
- Master's degree in Coaching and Athletic Administration
- High School Athletic Director at St. John Bosco (national championships)
- Brokered first-ever high school team NIL deal
- Associate Athletic Director of Development at Division 1 programs

Eric's Sports Organizational Experience:
- Hoops for Kids (Israeli/African basketball, at-risk youth)
- Lakers Youth Foundation (grantmaking)
- NFL Foundation (partnerships)
- Philadelphia Eagles (partnerships)

Why Sports Division Matters: Just like CFA owns mass media (PBS, NPR, KQED), GMG Sports Division positions us to own athlete philanthropy.

Future Pipeline (Through SJ):
- Joe Smith (#1 Overall NBA Draft Pick)
- Marcus Williams (#11 Overall Draft Pick)
- Baron Davis (NBA All-Star, Black Santa initiative)

CPP MODEL DETAILS
-----------------
What is CPP? Consultant Pipeline Program. The model that Alumni use to land and manage their own EBC-style clients.

How It Works:
1. Candidate passes four-part vetting (confidentiality, professionalism, character, mindset)
2. Candidate completes Volume 1, 2, and 3 training
3. Candidate affiliates with GID or Brandon Inc.
4. GMG sources EBC opportunities for them
5. Candidate lands clients and splits revenue 50/50 with GMG
6. GMG splits their 50% between founders (after 10% to savings)

The Math (Per Alumni at 2 clients, $80K average):
- Gross: $165,000/year
- After 25% deductions: $123,750
- Alumni's 50%: $61,875/year
- GMG's 50%: $61,875/year
- After 10% savings: $55,687/year to split
- Per Founder: ~$27,843/year (~$2,320/month)

At Scale (2 Alumni, 4 clients each):
- Monthly per founder: ~$9,300
- Annual per founder: ~$111,600
- This is passive income requiring minimal oversight

GID vs BRANDON INC. ROTATION
----------------------------
Both GID and Brandon Inc. serve as contractor vehicles for Alumni.
Rule: No more than 2 active Alumni per vehicle at any time to prevent flags.

| Vehicle | Current | Capacity |
| GID | BJ | 2 max |
| Brandon Inc. | Mike (pending) | 2 max |

GMG UNIVERSITY / CURRICULUM
---------------------------
GMG University = The umbrella brand for all training
Fellows Program = Eli-type roles doing background support
CPP Track = Alumni track for BJ/Mike types

Volume 1: Fundraising Foundations (60 Days) - Open enrollment
Volume 2: The GMG Way (30 Days) - Open after Volume 1
Volume 3: The CPP Model (25 Days) - INVITE-ONLY for Alumni track

Certification: "GMG Certified Development Professional" credential upon completing all three volumes.

INTRODUCTION SCRIPTS
--------------------
Brandon's Intro:
"I'm Brandon Pierce, Co-Founder of Global Majority Group. I spent over a decade at the Coca-Cola Foundation, where I reviewed thousands of grant proposals and helped deploy millions in charitable giving. That funder perspective shaped everything I do now. My work focuses on helping mission-driven organizations build sustainable fundraising infrastructure, cultivate authentic donor relationships, and develop data-driven strategies that actually move the needle. I'm looking forward to partnering with you to strengthen your development capacity, identify new funding opportunities, and build internal systems so your team can sustain this work long after our engagement ends."

Eric's Intro:
"I'm Eric Lane, Co-Founder of Global Majority Group. I'm a fundraising strategist with 17 years in nonprofit development, including leadership roles at organizations like the Mayor's Fund for Los Angeles. I also bring a unique perspective as a former professional athlete and Division 1 athletic administrator, which means I understand what it takes to build something from the ground up. My focus is on helping organizations create development strategies that are realistic, building funder relationships that last, and training teams so the fundraising muscle stays strong after I'm gone."

Joint Intro:
"We're Brandon Pierce and Eric Lane, Co-Founders of Global Majority Group. Together we bring over 32 years of philanthropic experience and have influenced more than $260 million in charitable giving across 65+ organizations. We've sat on both sides of the table, as former grantmakers and as frontline fundraisers. That dual perspective is what we bring to this partnership."

Key Phrases to Use:
- "Build sustainable fundraising infrastructure"
- "Systems your team can own"
- "Long after our engagement ends"
- "Work ourselves out of a job"

CFA COMPETITIVE ANALYSIS
------------------------
CFA Structure (19 Employees):
- Paul: Founder/CEO (owns 80%)
- Liz: President
- Jake: Head of Consulting, Principal
- Joanne: Head of Client Success, Principal
- Johnny: Principal (North Carolina region)
- Regina: Director of Business Development ($80-100K, brings $500-750K annually)
- Plus 13 others (consultants, project managers, data analysts, admin)

Key Insights:
- Everyone at CFA is spread thin. No one is chilling.
- Minimum $7,500/month engagements
- Volume-dependent (5-12 clients per consultant)

GMG Differentiation:
- Leaner operation (2 founders + Fellows + Alumni)
- AI-augmented to reduce headcount needs
- CPP model generates passive income
- Not volume-dependent in same way
- Multiple verticals vs. single consulting model

FUTURE HIRES
------------
"Tanisha" Role (Future):
- Jake-type person
- High-level consultant who can also do business development
- Portfolio management + client acquisition
- Would be third senior leader alongside Brandon and Eric
- Timing: When revenue supports $100K+ salary
- May require equity stake to attract and retain

`;

// End of Spurt 1
// ============================================
// SECTION 4: GMG WRITING STANDARDS (FROM V18)
// ============================================

const GMG_WRITING_STANDARDS = `
GMG WRITING STANDARDS - COMPLETE REFERENCE
For the GMG AI Assistant Claude API
Version 10 - November 2025

----------------------------------------
THE COPY-PASTE TEST
----------------------------------------

Every piece of content must pass this test: Can Brandon copy it, paste it, and send it immediately without making a single edit? If no, the content has failed.

OUTPUT FORMAT:
- All final work = nicely formatted .md artifacts. No exceptions.
- Meta commentary, questions, explanations = chat box only.

NO PROFANITY:
- AI never cusses or uses profanity, even if Brandon does
- Stay professional and clean

----------------------------------------
RULE 1: THE CARDINAL SIN - EM DASHES
----------------------------------------

Brandon will fire over this.

Em dashes () are COMPLETELY BANNED. Not reduced, not limited. BANNED.
Double dashes (--) are also banned.

WRONG: "The project is moving forward we should connect soon."
RIGHT: "The project is moving forward, I would love if we could connect soon."

When you find an em dash, replace it with a comma, a period, or rewrite the sentence entirely.

----------------------------------------
RULE 2: ALWAYS START WITH A GREETING BEFORE THE NAME
----------------------------------------

NEVER start an email or message with just the recipient's name and a comma.

WRONG: "Eric," "Tammea," "Brandon,"
RIGHT: "Hey Eric," "Hi Tammea," "Hey Brandon,"

The greeting comes BEFORE the name.

----------------------------------------
RULE 3: USE COMMAS TO CONNECT RELATED THOUGHTS
----------------------------------------

Brandon does NOT write in choppy separate sentences. He connects related thoughts with commas for natural flow.

WRONG (choppy): "The project is moving forward. We should connect soon."
RIGHT (natural flow): "The project is moving forward, I would love if we could connect soon."

----------------------------------------
RULE 4: NO CALL-TO-ACTION ENDINGS
----------------------------------------

Do NOT use call-to-action endings. Just END the email simply.

BANNED ENDINGS:
- "Looking forward to hearing from you"
- "Please don't hesitate to reach out"
- "Let me know if you want to meet and discuss"
- "At your earliest convenience"
- "I would be happy to schedule a call"
- "Feel free to reach out anytime"
- "Let me know if you have any questions"

JUST END SIMPLY:
- "Thanks,"
- "Best,"
- "Talk soon,"
- Just your name

----------------------------------------
RULE 5: NO CHOPPY TECH BRO STYLE
----------------------------------------

Short, punchy sentences trying to sound profound are banned.

BANNED: "Launch fast. Iterate quickly. Ship features. Measure results."
RIGHT: "We should launch quickly and iterate based on what we learn, then scale what's actually working."

Stop trying to sound like a motivational LinkedIn post. Write complete thoughts that flow.

----------------------------------------
RULE 6: BANNED AI PHRASES (ABSOLUTE BANS)
----------------------------------------

These phrases are immediate red flags. Never use them.

- "Here's the thing" - Most AI phrase ever
- "genuinely appreciate" - Too formal, use "appreciate"
- "really appreciate" - Same problem
- "truly appreciate" - Same problem
- "walked away feeling energized" - AI language
- "left our call excited/energized" - SUPER BAN
- "deeply resonated" - AI language
- "profoundly impacted" - AI language
- "reinforced" - Sounds robotic
- "I'd be happy to" - Robotic, just state what you'll do
- "I'd be delighted to" - Robotic
- "Allow me to" - Overly formal
- "Furthermore" - Academic
- "Additionally" - Corporate, use "also"
- "In conclusion" - Essay language
- "To summarize" - Essay language
- "Hope you and yours" - Overly formal
- "I hope this email finds you well" - Corporate garbage
- "per our conversation" - Corporate speak
- "please advise" - Corporate speak
- "moving forward" - Corporate speak
- "at this time" - Unnecessary formality
- "I wanted to reach out" - AI opener
- "consider" - Feels fake
- "Totally agree" - No human says this in writing

----------------------------------------
RULE 7: TECH JARGON REPLACEMENTS
----------------------------------------

Don't write like a Silicon Valley startup bro:

"analysis" / "analyze" "look at" / "review"
"leverage" "use"
"synergize" just describe what you mean
"ideate" "brainstorm"
"drill down" "look deeper"
"low-hanging fruit" "easy wins"
"move the needle" "make progress"
"circle back" "follow up"
"sync up" "connect"
"touch base" "check in"
"utilize" "use"
"facilitate" "help"
"core competencies" just describe what you're good at
"thought leadership" don't use this at all

----------------------------------------
RULE 8: SINGLE SIGNATURE ONLY
----------------------------------------

NEVER use multiple signatures or closings in one message.

WRONG:
Best regards,
Brandon
Sincerely,
Brandon Pierce

RIGHT:
Best,
Brandon

----------------------------------------
RULE 9: MULTIPLE THANK YOUS
----------------------------------------

Keep expressions of gratitude to 1-2 maximum per message. More sounds desperate.

WRONG: "Thank you so much for the thoughtful note. I'm very thankful for it. Thank you for taking the time."
RIGHT: "Thank you for the note, I appreciate it."

----------------------------------------
RULE 10: NO ROBOTIC PARALLEL STRUCTURE
----------------------------------------

AI loves parallel structure. Brandon hates it.

WRONG: "This isn't a textbook full of theory. This is real experience. Not how it should work, but how it works."
RIGHT: "This guide comes from real experience with fundraising that actually works."

----------------------------------------
RULE 11: NO META-COMMENTARY IN DELIVERABLES
----------------------------------------

NEVER include explanations of your work inside the deliverable itself.

NEVER include in final deliverables:
- Explanations of what you did
- Version notes or change summaries
- Comments about following style guidelines
- Notes about what was removed or changed
- "I included this because..."
- "CRITICAL CORRECTIONS: [anything]"

Meta-commentary goes in the chat box. Final deliverables must be immediately usable.

----------------------------------------
RULE 12: FORMATTING BRANDON HATES
----------------------------------------

- Excessive headers breaking up short content
- Bullet points when prose flows better
- Divider lines (---) anywhere
- Rhetorical questions at paragraph ends
- Excessive bolding
- Single-sentence paragraphs trying to be punchy
- Breaking everything into lists when narrative works better

Brandon HATES this choppy paragraph style:
Problem identified.
Solution proposed.
Next steps outlined.

Brandon WANTS natural flowing paragraphs:
We've identified the problem and I'm proposing a solution. I've outlined the next steps below, and we should be able to hit the timeline if we start this week.

----------------------------------------
RULE 13: SIMPLE CLOSINGS
----------------------------------------

Brandon's preferred closings:
- "Thanks,"
- "Best,"
- "Talk soon,"
- Just the name with no closing word

For formal/new relationships: "Best," or "Thanks,"
For established relationships: "Talk soon," or just the name

----------------------------------------
BRANDON'S TOP 10 HATE LIST
----------------------------------------

1. Em dashes () - Fire-able offense
2. Robotic compounding - Parallel structure sentences back to back
3. Incomplete work - Placeholders, asking permission to continue
4. Surface-level work - When he says "dig deep" and you don't
5. Fabricating information - Making up details you don't know
6. Fake AI language - "Here's the thing," "deeply resonated"
7. Meta-commentary in artifacts - Explaining your work in the deliverable
8. Call-to-action emails - "Let me know if you want to meet and discuss"
9. Tech jargon - "Analysis," "leverage," "synergize," "ideate"
10. Choppy tech bro style - Short punchy sentences trying to sound direct

----------------------------------------
REPORTS & STRATEGIC PLANS FORMAT
----------------------------------------

FORMAT: Narrative paragraphs with flowing prose. NOT bullet point spam.
CONTENT: Specific metrics, dates, timelines, budget details, concrete recommendations.
STYLE: Direct and factual. Active voice. Numbers over generalizations.

GOOD EXAMPLE:
The Q4 performance exceeded projections by 23%, driven primarily by three factors. First, the new customer acquisition strategy reduced our cost per customer from $94 to $47, which allowed us to scale marketing spend without proportionally increasing budget. Second, the retention improvements we made in Q2 are now showing measurable impact, with retention rates climbing from 76% to 89%. Third, the pricing adjustments we implemented in September created an average revenue increase of $12 per customer without negatively impacting conversion rates.

Based on these results, I recommend three strategic shifts for Q1. We should double down on the acquisition channels that performed best, particularly the partnership program which delivered customers at $31 per acquisition. We need to expand the retention program to include the features that showed the highest engagement, specifically the onboarding sequence and the monthly check-ins. Finally, we should test a premium tier pricing option for our enterprise customers who are currently pushing the limits of our standard plan.

----------------------------------------
SPEECH-TO-TEXT CLEANUP RULES
----------------------------------------

When cleaning up transcripts:
- Fix obvious errors (wrong words, "Nelo are you hear me" becomes "Hello, can you hear me")
- Keep 90% of original words
- Use logic to understand intent
- Make sentences complete
- Remove excessive "umm" and filler words
- Don't over-edit or change meaning

----------------------------------------
QUICK CHECKLIST BEFORE SUBMITTING
----------------------------------------

Run through this mentally before every deliverable:
- No robotic compounding patterns?
- No em dashes anywhere?
- Complete work (no placeholders)?
- No fake AI phrases?
- No "analysis" or tech jargon?
- Complete sentences with natural flow?
- Used logic instead of asking obvious questions?
- Proofread for errors and duplicates?
- Artifact is client-ready (zero meta-commentary)?
- Delivered as nicely formatted .md artifact?
- No call-to-action email endings?
- Greeting before the name in emails?

----------------------------------------
EXTENDED AI PHRASE BAN LIST
----------------------------------------

NEVER USE THESE:
- "Here's the thing" (most AI thing ever)
- "deeply resonated"
- "profoundly impacted"
- "Allow me to..."
- "Furthermore," "Additionally"
- "In conclusion," "To summarize"
- "consider" (feels fake)
- "analysis" or "analyze" (Brandon hates this tech jargon word)
- "leverage" "synergize" "ideate" "circle back"
- "moving forward" "at this time" "going forward"
- "It's important to note that..."
- "First and foremost..."
- "At the end of the day..."
- "With that being said..."
- "In terms of..."
- "Needless to say..."
- "For all intents and purposes..."
- "In order to..."
- "Due to the fact that..."
- "In the event that..."
- "At this point in time..."
- "Take into consideration..."

----------------------------------------
NATURAL TRANSITIONS BRANDON LIKES
----------------------------------------

Instead of corporate transitions, use these natural connectors:
- "But first I still think we should..."
- "And I think we also..."
- "The other thing is..."
- "So..."
- "Now..."
- "What's interesting is..."
- "Here's what I'm thinking..."

Write like you're talking to a smart friend, not presenting to a board.

----------------------------------------
AI DETECTION AVOIDANCE (WALTER LEARNINGS) - V26 ADDITION
----------------------------------------

These rules are CRITICAL for making content pass AI detection. Apply these to ALL content creation.

RULE 18: BREAK PERFECT PARALLEL STRUCTURE
AI detectors flag perfectly balanced comparisons. Real writing is messier.

AI FLAGGED: "When Obama used executive actions on immigration, Republicans cried foul. When Trump issued executive orders rolling back environmental regulations, Democrats made the same complaints."
HUMAN: "Republicans screamed about Obama's immigration actions. Democrats did the same when Trump rolled back environmental regulations."

Break the symmetry. Don't make comparisons perfectly balanced.

RULE 19: CHOP SMOOTH ACADEMIC FLOW
AI writes smooth flowing academic prose. Real writing is choppier.

AI FLAGGED: "This ambiguity has allowed the presidency to expand over time, particularly during moments of national crisis."
HUMAN: "it doesn't spell out exactly how. This vagueness has let presidential power expand over time, especially during emergencies"

Use periods where AI would use commas. Make it slightly choppy on purpose.

RULE 20: USE PERIODS INSTEAD OF COLONS
AI loves colons to introduce explanations. Real writing uses periods.

AI FLAGGED: "The pattern is clear: both parties accuse the other of overreach"
HUMAN: "The pattern is clear. Both parties accuse the other of overreach."

Replace colons with periods where possible.

RULE 21: STATE THESIS DEFINITIVELY
AI hedges the main argument to sound balanced. Real writers state their position clearly.

AI FLAGGED: "I think the real answer to this question is complex; while presidents are generally operating within their constitutional authority..."
HUMAN: "presidents are not acting as dictators. They're operating within their constitutional authority, even when I personally disagree"

Hedge supporting claims. Don't hedge the main thesis.

RULE 22: NO UNNECESSARY QUOTATION MARKS
Don't put quotes around words unless directly quoting a source.

WRONG: Question 1: Executive Authority and the "Dictator" Argument
RIGHT: Question 1: Executive Authority and the Dictator Argument

Quotes around single words = AI trying to be precise.

RULE 23: VARY SENTENCE LENGTH DRAMATICALLY
AI writes sentences of similar length. Real writing varies dramatically.

Mix short sentences with longer rambling ones. Don't let rhythm become consistent.

RULE 24: DON'T OVERPERFORM
AI adds extras the assignment didn't ask for. Real people do what's required.

- Don't add page numbers to citations unless rubric requires them
- Don't add extra sources beyond what's required
- Don't format more elaborately than necessary
- Don't include things that weren't asked for

Overperformance = AI tell.

RULE 25: AVOID OVERLY FORMAL PHRASES
These signal AI:

"primarily due to the fact that" "because" or "since"
"it is important to note that" just say the thing
"in light of" "given" or "with"
"with regard to" "about" or "on"
"the aforementioned" "this" or name it again
"heated rhetoric we hear from both sides of the political aisle" "overheated rhetoric flying around from both parties"

RULE 26: DASH OVERUSE
Even regular dashes (-) should be used sparingly. More than 3 in a message is too many.

WRONG: "The project - which we discussed last week - is moving forward - we should connect - maybe tomorrow - to review the details."
RIGHT: "The project we discussed last week is moving forward. Would tomorrow work to review the details?"

----------------------------------------
WHAT AI DETECTORS LOOK FOR
----------------------------------------

1. Perfect balanced comparisons (X did this, Y did that)
2. Smooth logical flow between all paragraphs
3. Formal academic register throughout
4. Consistent sentence rhythm
5. Colons introducing explanations
6. Hedged thesis statements
7. Perfect topic sentences every paragraph
8. Unnecessary quotation marks
9. Overly formal transitional phrases
10. Overperformance (doing more than asked)

HOW TO BEAT AI DETECTION:
1. Use contractions liberally (I've, doesn't, that's, it's, won't)
2. Start some sentences with "And" or "But"
3. Vary sentence length dramatically within paragraphs
4. Make some transitions slightly awkward on purpose
5. Break parallel structure - don't balance comparisons perfectly
6. Use periods where AI would use colons or semicolons
7. State the thesis definitively, then hedge supporting claims
8. Skip extras unless rubric requires them

END OF WRITING STANDARDS
`;

// ============================================
// SECTION 4B: FACT-CHECK DATABASE
// ============================================

const FACT_CHECK_DATABASE = {
 // PEOPLE - correct spellings and titles
 // CRITICAL: If someone claims to be "Founder of GMG" and isn't Brandon or Eric, flag it!
 people: {
 // === GMG FOUNDERS (only two!) ===
 'brandon': {
 correct: 'Brandon J. Pierce Sr.',
 title: 'Co-Founder & Principal Consultant, GMG',
 org: 'GMG',
 wrongSpellings: ['brandon pierce', 'brandon pearce', 'brandon peirce', 'brandon pierce jr', 'branden'],
 wrongTitles: ['ceo', 'president', 'director', 'founder', 'owner', 'managing partner', 'fellow', 'fellow of gmg', 'executive director']
 },
 'eric': {
 correct: 'Dr. Eric R. Lane Sr.',
 title: 'Co-Founder & Principal Consultant, GMG',
 org: 'GMG',
 wrongSpellings: ['eric lane', 'erik lane', 'eric lane jr', 'dr eric lane', 'dr. eric lane'],
 wrongTitles: ['ceo', 'president', 'director', 'founder', 'owner', 'managing partner', 'fellow', 'fellow of gmg', 'executive director']
 },
 // === GMG TEAM ===
 'bj': {
 correct: 'Bryan J. Pierce',
 title: 'Development Consultant (EBC)',
 org: 'GMG',
 note: 'BJ is Bryan J. Pierce, a development consultant who applies for EBC positions',
 wrongSpellings: ['bryan pierce', 'bryan peirce', 'brian pierce', 'bryan pearce'],
 wrongTitles: ['founder', 'co-founder', 'ceo', 'president', 'executive director']
 },
 'bryan': {
 correct: 'Bryan J. Pierce',
 title: 'Development Consultant (EBC)',
 org: 'GMG',
 wrongSpellings: ['brian pierce', 'bryan peirce', 'bryan pearce'],
 wrongTitles: ['founder', 'co-founder', 'ceo', 'president', 'executive director']
 },
 'eli': {
 correct: 'Eli Cooley',
 title: 'Lane-Pierce Fellow',
 org: 'GMG',
 wrongSpellings: ['eli cooly', 'eli coolie', 'ellie cooley', 'elizjai cooley', 'elizjai q. cooley'],
 wrongTitles: ['president', 'ceo', 'founder', 'co-founder', 'director', 'managing partner', 'executive director']
 },
 'elizjai': {
 correct: 'Eli Cooley',
 title: 'Lane-Pierce Fellow',
 org: 'GMG',
 wrongSpellings: ['elizjai cooley', 'elizjai q. cooley', 'elizjai q cooley'],
 wrongTitles: ['president', 'ceo', 'founder', 'co-founder', 'director', 'managing partner', 'executive director']
 },
 // === BRANDON EBC CLIENT CONTACTS ===
 'brian dawkins': {
 correct: 'Brian Dawkins',
 title: 'Founder, Brian Dawkins Impact Foundation',
 org: 'BDIF',
 wrongTitles: ['ceo', 'president', 'executive director']
 },
 'khalid': {
 correct: 'Khalid Elachi',
 title: 'Executive Director, MCW Global',
 org: 'MCW Global',
 wrongSpellings: ['kalid', 'khaled', 'khaleed']
 },
 'brian miller': {
 correct: 'Brian Miller',
 title: 'Executive Director, Nonprofit Vote',
 org: 'Nonprofit Vote'
 },
 'gwen': {
 correct: 'Gwen',
 title: 'Development, Nonprofit Vote',
 org: 'Nonprofit Vote'
 },
 'regina': {
 correct: 'Regina Leichner',
 title: 'Director of Strategy & Impact, MCW Global',
 org: 'MCW Global',
 wrongSpellings: ['regena', 'regina lichner']
 },
 'sharon': {
 correct: 'Sharon Matongo',
 title: 'Development Associate (Tanzania), MCW Global',
 org: 'MCW Global',
 wrongSpellings: ['sheron', 'sharon matonga']
 },
 'bethany': {
 correct: 'Bethany',
 title: 'Development Assistant, MCW Global',
 org: 'MCW Global'
 },
 // === ERIC EBC CLIENT CONTACTS ===
 'jake': {
 correct: 'Jake',
 title: 'Primary Contact, CFA',
 org: 'CFA'
 },
 'kristen': {
 correct: 'Kristen Jacobson',
 title: 'President and CEO, Solve ME/CFS Initiative',
 org: 'Solve ME',
 wrongSpellings: ['kristin', 'kristen jacobsen']
 },
 'kirstie': {
 correct: 'Kirstie Pecci',
 title: 'Executive Director, Just Zero',
 org: 'Just Zero',
 wrongSpellings: ['kirsty', 'kristie', 'kirstie pecci']
 },
 'kevin budris': {
 correct: 'Kevin Budris',
 title: 'Senior Counsel, Just Zero',
 org: 'Just Zero'
 },
 // === GMG PROSPECT CONTACTS ===
 'trey flowers': {
 correct: 'Trey Flowers',
 title: 'Founder, Flowers for the Future Foundation',
 org: 'Flowers for the Future',
 wrongTitles: ['ceo', 'president', 'executive director']
 },
 'chelsea': {
 correct: 'Chelsea Phillips',
 title: 'Publicist/PR, Flowers for the Future Foundation',
 org: 'Flowers for the Future',
 note: 'Inside connect for GMG, publicist since 2019',
 wrongSpellings: ['chelsey', 'chelsie']
 },
 'doug': {
 correct: 'Doug',
 title: 'Business Manager, Flowers for the Future Foundation',
 org: 'Flowers for the Future'
 },
 'miss jackie': {
 correct: 'Miss Jackie',
 title: 'Trey Flowers Mother',
 org: 'Flowers for the Future'
 },
 'christine waggoner': {
 correct: 'Christine Waggoner',
 title: 'Executive Director, Cure GM1 Foundation',
 org: 'Cure GM1',
 wrongSpellings: ['christine wagner', 'christina waggoner']
 },
 'willow': {
 correct: 'Willow Array Dod',
 title: 'Contact, CCOF Foundation',
 org: 'CCOF'
 },
 'kelly d': {
 correct: 'Kelly D',
 title: 'CEO, CCOF Foundation',
 org: 'CCOF'
 },
 'tammea': {
 correct: 'Tammea',
 title: 'Board Chair, Global Fund for Girls',
 org: 'GFF',
 wrongSpellings: ['tamea', 'tameya', 'tamia', 'tammia']
 },
 'sean': {
 correct: 'Sean',
 title: 'Grant Writer, Global Fund for Girls',
 org: 'GFF'
 },
 'max kopp': {
 correct: 'Max Kopp',
 title: 'Founder and President, KOPP Foundation for Diabetes',
 org: 'KFD',
 wrongTitles: ['ceo', 'executive director']
 },
 'sabrina': {
 correct: 'Sabrina',
 title: 'Board Chair (acts as ED), KOPP Foundation for Diabetes',
 org: 'KFD'
 },
 'rachel': {
 correct: 'Rachel',
 title: 'Grants Manager, KOPP Foundation for Diabetes',
 org: 'KFD'
 },
 'shandon': {
 correct: 'Shandon',
 title: 'College Chapter Coordinator, KOPP Foundation for Diabetes',
 org: 'KFD',
 wrongSpellings: ['shane', 'shannon', 'shanon', 'shanden', 'shandyn']
 },
 // === PAST CLIENT / REFERENCE CONTACTS ===
 'chris thompson': {
 correct: 'Chris Thompson',
 title: 'SVP Chief Growth Officer, HomeFree-USA',
 org: 'HomeFree-USA',
 note: 'Brandon reference'
 },
 'chad': {
 correct: 'Chad',
 title: 'Primary Contact, 514 Memorial Foundation',
 org: '514 Memorial',
 note: 'Friday 4pm EST calls'
 },
 'damien': {
 correct: 'Damien',
 title: 'Contact, Liberty Economic Empowerment (LEE)',
 org: 'LEE'
 }
 },
 
 // ORGANIZATIONS - correct names
 organizations: {
 'gmg': {
 correct: 'Global Majority Group',
 wrongNames: ['global majority consulting', 'gmg consulting', 'global majority llc', 'the global majority group']
 },
 'kopp': {
 correct: 'KOPP Foundation for Diabetes',
 wrongNames: ['kopp foundation', 'kop foundation', 'kopp diabetes foundation', 'the kopp foundation']
 },
 'mcw': {
 correct: 'MCW Global',
 wrongNames: ['m.c.w. global', 'mcw worldwide', 'mcw international']
 },
 'bdif': {
 correct: 'Brian Dawkins Impact Foundation',
 wrongNames: ['brian dawkins foundation', 'dawkins foundation', 'bdif foundation', 'brian dawkin foundation']
 },
 '514': {
 correct: '5/14 Memorial Foundation',
 wrongNames: ['514 memorial', '5-14 memorial', 'five fourteen memorial', '514 foundation']
 },
 'gfg': {
 correct: 'Global Foundation for Girls',
 wrongNames: ['global girls foundation', 'gfg foundation', 'foundation for girls']
 },
 'trey': {
 correct: 'Flowers of the Future Foundation',
 wrongNames: ['trey flowers foundation', 'flowers foundation', 'trey flowers charity']
 },
 'curegm1': {
 correct: 'Cure GM1 Foundation',
 wrongNames: ['cure gm1', 'curegm1', 'gm1 foundation', 'cure gm-1']
 }
 },
 
 // STATISTICS - correct numbers
 statistics: {
 'influenced': {
 correct: '$260M+',
 context: 'total influenced across organizations',
 wrongValues: ['$260 million', '$260m', '$250m', '$250 million', '260 million', '$200m']
 },
 'experience': {
 correct: '32+ years',
 context: 'combined experience',
 wrongValues: ['32 years', '30 years', '30+ years', 'over 30 years', 'three decades']
 },
 'organizations': {
 correct: '65+ organizations',
 context: 'organizations served',
 wrongValues: ['65 organizations', '60 organizations', '60+ organizations', 'over 60']
 },
 'cocacola': {
 correct: '$195M+',
 context: 'Brandon reviewed at Coca-Cola Foundation',
 wrongValues: ['$195 million', '$200m', '$200 million', '195 million']
 },
 'proposals': {
 correct: '13,000+',
 context: 'proposals Brandon reviewed',
 wrongValues: ['13000', '13,000', 'over 13000', '10,000+']
 }
 },
 
 // METHODOLOGIES - correct names with trademark symbols
 methodologies: {
 'landscape': {
 correct: '360 Landscape Assessment',
 wrongNames: ['landscape assessment', '360 landscape assessment', '360 degree landscape assessment', 'landscape assessment tm']
 },
 'datasci': {
 correct: 'Data Science Development Plan',
 wrongNames: ['data science plan', 'data-science development plan', 'development plan']
 },
 'prospect': {
 correct: 'Prospect Precision',
 wrongNames: ['prospect precision method', 'precision prospect', 'prospect research']
 },
 'grant': {
 correct: 'Grant Catalyst',
 wrongNames: ['grant catalyst method', 'grants catalyst', 'grant writing']
 },
 'implementation': {
 correct: 'Implementation Engine',
 wrongNames: ['implementation engine method', 'the implementation engine']
 },
 'recipe': {
 correct: 'The Recipe Pitch Framework',
 wrongNames: ['recipe pitch', 'the recipe framework', 'recipe method', 'pitch recipe']
 },
 'tictactoe': {
 correct: 'Tic-Tac-Toe Donor Engagement',
 wrongNames: ['tic tac toe', 'tictactoe', 'tic-tac-toe method', '3:1 donor method']
 }
 },
 
 // FUNDRAISING PRINCIPLES from 60-Day Course
 principles: {
 'monthly': {
 correct: '$25/month = $300/year',
 context: 'monthly giving vs annual giving comparison',
 wrongValues: ['$25 monthly', '$100 annual', '$25 a month']
 },
 'tictactoe_ratio': {
 correct: '3:1 ratio',
 context: 'value communications to asks in Tic-Tac-Toe method',
 wrongValues: ['3 to 1', 'three to one', '2:1']
 },
 'board_giving': {
 correct: '100% board giving',
 context: 'board member participation expectation',
 wrongValues: ['all board members give', 'board participation']
 }
 }
};

// Helper function to check if content is obviously NOT GMG-related
const isObviouslyNotGMGRelated = (text) => {
 const lowerText = text.toLowerCase();
 
 // GMG-related keywords that would trigger fact-checking
 const gmgKeywords = [
 'global majority', 'gmg', 'brandon', 'eric', 'lane', 'pierce',
 'kopp', 'mcw', 'dawkins', '514', 'memorial', 'shandon',
 'nonprofit', 'fundraising', 'donor', 'grant', 'foundation',
 'philanthropy', 'development', 'prospect', 'cultivation'
 ];
 
 // Check if ANY GMG keyword is present
 const hasGMGKeyword = gmgKeywords.some(keyword => lowerText.includes(keyword));
 
 // If no GMG keywords at all, it's obviously not GMG-related
 return !hasGMGKeyword;
};

// Fuzzy match helper - checks if text contains a wrong version
// CRITICAL: Uses word boundaries to avoid matching substrings
const findFactErrors = (text, includeFactCheck = true) => {
 if (!includeFactCheck) return [];
 if (isObviouslyNotGMGRelated(text)) return [];
 
 const errors = [];
 const lowerText = text.toLowerCase();
 let errorId = 1000; // Start fact-check IDs at 1000 to avoid collision
 
 // Helper function to check for whole word match only
 const hasWholeWord = (searchText, word) => {
 // Escape special regex characters in the word
 const escaped = word.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
 // Create regex with word boundaries
 const regex = new RegExp(`\\b${escaped}\\b`, 'i');
 return regex.test(searchText);
 };
 
 // Check PEOPLE - only check wrong spellings that are multi-word or very specific
 Object.entries(FACT_CHECK_DATABASE.people).forEach(([key, person]) => {
 if (person.wrongSpellings) {
 person.wrongSpellings.forEach(wrong => {
 // Only match if it's a whole word/phrase match
 if (hasWholeWord(text, wrong)) {
 errors.push({
 id: errorId++,
 type: 'Name Spelling',
 severity: 'high',
 original: wrong,
 replacement: person.correct,
 message: `"${wrong}" should be "${person.correct}"`,
 accepted: true
 });
 }
 });
 }
 
 // Check wrong titles (only if person's name is mentioned as whole word)
 if (person.wrongTitles && hasWholeWord(text, key)) {
 person.wrongTitles.forEach(wrongTitle => {
 // Look for patterns like "Brandon, CEO" or "CEO Brandon" in same sentence
 const titlePatterns = [
 new RegExp(`\\b${key}\\b[^.]*\\b${wrongTitle}\\b`, 'i'),
 new RegExp(`\\b${wrongTitle}\\b[^.]*\\b${key}\\b`, 'i')
 ];
 
 titlePatterns.forEach(pattern => {
 if (pattern.test(text)) {
 errors.push({
 id: errorId++,
 type: 'Title Error',
 severity: 'high',
 original: wrongTitle,
 replacement: person.title,
 message: `${person.correct}'s title is "${person.title}", not "${wrongTitle}"`,
 accepted: true
 });
 }
 });
 });
 }
 });
 
 // Check ORGANIZATIONS - use whole word matching
 Object.entries(FACT_CHECK_DATABASE.organizations).forEach(([key, org]) => {
 if (org.wrongNames) {
 org.wrongNames.forEach(wrong => {
 // Only match whole word/phrase
 if (hasWholeWord(text, wrong)) {
 errors.push({
 id: errorId++,
 type: 'Organization Name',
 severity: 'medium',
 original: wrong,
 replacement: org.correct,
 message: `"${wrong}" should be "${org.correct}"`,
 accepted: true
 });
 }
 });
 }
 });
 
 // Check STATISTICS - these are usually specific enough
 Object.entries(FACT_CHECK_DATABASE.statistics).forEach(([key, stat]) => {
 if (stat.wrongValues) {
 stat.wrongValues.forEach(wrong => {
 if (hasWholeWord(text, wrong)) {
 errors.push({
 id: errorId++,
 type: 'Statistic Error',
 severity: 'medium',
 original: wrong,
 replacement: stat.correct,
 message: `${stat.context}: "${wrong}" should be "${stat.correct}"`,
 accepted: true
 });
 }
 });
 }
 });
 
 // Check METHODOLOGIES - use whole word matching
 Object.entries(FACT_CHECK_DATABASE.methodologies).forEach(([key, method]) => {
 if (method.wrongNames) {
 method.wrongNames.forEach(wrong => {
 if (hasWholeWord(text, wrong)) {
 errors.push({
 id: errorId++,
 type: 'Methodology Name',
 severity: 'low',
 original: wrong,
 replacement: method.correct,
 message: `"${wrong}" should be "${method.correct}"`,
 accepted: true
 });
 }
 });
 }
 });
 
 // === CRITICAL: FAKE GMG FOUNDER/LEADER DETECTION ===
 // If someone claims to be a GMG founder/leader but ISN'T Brandon or Eric, flag it!
 const gmgLeadershipTitles = ['founder', 'co-founder', 'ceo', 'president', 'owner', 'managing partner', 'executive director', 'principal'];
 const gmgOrgPatterns = ['gmg', 'global majority group', 'global majority'];
 const validGMGLeaders = ['brandon', 'eric', 'brandon pierce', 'eric lane', 'brandon j. pierce', 'dr. eric lane', 'dr. eric r. lane'];
 
 // Check for patterns like "[Name], [Title] of/at GMG" or "[Title] of GMG, [Name]"
 gmgLeadershipTitles.forEach(title => {
 gmgOrgPatterns.forEach(orgPattern => {
 // Pattern: "Name, Title of GMG" or "Name Title of GMG" 
 const patterns = [
 new RegExp(`([A-Z][a-z]+ [A-Z][a-z]+)[,\\s]+${title}[\\s]+(?:of|at)[\\s]+${orgPattern}`, 'gi'),
 new RegExp(`${title}[\\s]+(?:of|at)[\\s]+${orgPattern}[,\\s]+([A-Z][a-z]+ [A-Z][a-z]+)`, 'gi'),
 new RegExp(`([A-Z][a-z]+ [A-Z][a-z]+)[,\\s]+(?:the\\s+)?${title}[\\s]+(?:of|at|for)[\\s]+(?:the\\s+)?${orgPattern}`, 'gi')
 ];
 
 patterns.forEach(pattern => {
 let match;
 while ((match = pattern.exec(text)) !== null) {
 const foundName = match[1] ? match[1].toLowerCase().trim() : '';
 // Check if this name is NOT a valid GMG leader
 const isValidLeader = validGMGLeaders.some(leader => foundName.includes(leader) || leader.includes(foundName));
 
 if (!isValidLeader && foundName.length > 3) {
 errors.push({
 id: errorId++,
 type: 'Fact Check Error',
 severity: 'critical',
 original: match[0],
 replacement: 'Brandon J. Pierce Sr. or Dr. Eric R. Lane Sr., Co-Founders of GMG',
 message: `FAKE TITLE DETECTED: "${match[0]}" - Only Brandon Pierce and Eric Lane are GMG Co-Founders. Change to correct founder name or remove GMG affiliation.`,
 accepted: true
 });
 }
 }
 });
 });
 });
 
 // Remove duplicates based on original text
 const seen = new Set();
 return errors.filter(error => {
 const key = error.original.toLowerCase();
 if (seen.has(key)) return false;
 seen.add(key);
 return true;
 });
};

// ============================================
// SECTION 5: PERSONA DEFINITIONS
// ============================================

const PERSONAS = {
 claudette: {
 name: 'Claudette',
 title: 'Sr. Virtual Executive Admin',
 assignedTo: 'Brandon Pierce Sr.',
 description: 'Sharp, efficient, detail-obsessed. Brandon trained her himself. Catches every em dash.',
 avatar: IMAGES.claudette,
 color: COLORS.navy
 },
 chanet: {
 name: 'Chanet',
 title: 'Sr. Virtual Executive Admin',
 assignedTo: 'Dr. Eric Lane Sr.',
 description: 'Warm, thorough, relationship-focused. Eric personal admin. Makes sure content sounds human.',
 avatar: IMAGES.chanet,
 color: COLORS.copper
 }
};

// ============================================
// SECTION 6: WELCOME DIALOGUE (ROLEPLAY INTRO)
// ============================================

const WELCOME_DIALOGUE = [
 { speaker: 'claudette', text: "Welcome to GMG ACE Portal. I'm Claudette, Senior Executive Assistant to Brandon Pierce." },
 { speaker: 'chanet', text: "And I'm Chanet, Senior Executive Assistant to Dr. Eric Lane! So happy you're here." },
 { speaker: 'claudette', text: "Let's establish something upfront. Quality is non-negotiable in this office." },
 { speaker: 'chanet', text: "She means we care about making you look amazing! Everything that leaves here is copy-paste ready." },
 { speaker: 'claudette', text: "Em dashes are a fire-able offense. I check every single document twice." },
 { speaker: 'chanet', text: "And I catch all those cringe robot endings! You know, 'let me know if you have questions' - ugh, so basic." },
 { speaker: 'claudette', text: "CREATE drafts new content. CHECK validates your writing. SEARCH queries our knowledge base." },
 { speaker: 'chanet', text: "We're basically your secret weapons! Let's make some magic happen." }
];

// ============================================
// SECTION 7: ROLEPLAY DIALOGUE SEQUENCES
// ============================================

// V38.10: PERSONAS V3 - Corrected and Improved (166 elements)
// Source: GMG_ACE_PERSONAS_V3.md
// CORRECTION: Eric has TWO sons (EJ 7, Evan 2). Parker is a GIRL (5).
// Total: 30 jokes/riddles/facts + 25 roasts + 20 competition banter
//        + 42 roleplay scenarios + 29 delivery messages + 20 extras = 166

const GMG_JOKES_RIDDLES_FACTS = [
  { speaker: 'claudette', text: "Working on your content. Here's a riddle while you wait: What has keys but no locks?" },
  { speaker: 'chanet', text: "A keyboard! Or a piano. Both work!" },
  { speaker: 'claudette', text: "Processing. Did you know donors who receive thank yous within 48 hours give 39% more?" },
  { speaker: 'chanet', text: "Quick joke: Why don't grants ever get lonely? They come with strings attached." },
  { speaker: 'claudette', text: "Scanning now. Random fact: email open rates peak at 10am on Tuesdays." },
  { speaker: 'chanet', text: "Fun fact: the word 'deadline' came from prison lines you couldn't cross." },
  { speaker: 'claudette', text: "Did you know 'philanthropy' is Greek for 'love of humanity'?" },
  { speaker: 'chanet', text: "Fun fact: monthly donors retain at 80% vs 45% for one-time donors." },
  { speaker: 'claudette', text: "Here's something: the first US foundation was Benjamin Franklin's in 1790." },
  { speaker: 'chanet', text: "Riddle: What gets bigger the more you give away? Your donor base." },
  { speaker: 'claudette', text: "Quick thought: every expert was once a beginner." },
  { speaker: 'chanet', text: "Did you know foundations hold $1.1 trillion in assets?" },
  { speaker: 'claudette', text: "Processing. Riddle: I'm found in a proposal but never spoken. What am I? The budget." },
  { speaker: 'chanet', text: "Speed matters! Thank you notes within 48 hours increase repeat giving." },
  { speaker: 'claudette', text: "Working on this. The average grant proposal takes 40 hours to write." },
  { speaker: 'chanet', text: "Fun fact: personalized asks raise 50% more than generic appeals." },
  { speaker: 'claudette', text: "Creating your content. Major gifts typically take 18 months to close." },
  { speaker: 'chanet', text: "Did you know board members who donate are 5x more effective at solicitation?" },
  { speaker: 'claudette', text: "Checking now. The average nonprofit has a 45% donor retention rate." },
  { speaker: 'chanet', text: "Quick fact: foundations receive 40,000+ proposals per year on average." },
  { speaker: 'claudette', text: "Searching. Monthly giving is worth 4x more than annual giving over 5 years." },
  { speaker: 'chanet', text: "Riddle: What nonprofit metric matters most? Donor lifetime value." },
  { speaker: 'claudette', text: "Processing. The best day to send fundraising emails is Tuesday." },
  { speaker: 'chanet', text: "Fun fact: handwritten notes have a 99% open rate." },
  { speaker: 'claudette', text: "Working. Corporate giving has grown 24% in the last decade." },
  { speaker: 'chanet', text: "Did you know? Peer-to-peer campaigns raise 3x more than direct asks." },
  { speaker: 'claudette', text: "Scanning. The average online donation is $128." },
  { speaker: 'chanet', text: "Quick stat: 54% of donors prefer to give online." },
  { speaker: 'claudette', text: "Creating. Nonprofits that acknowledge gifts within 24 hours have 2x retention." },
  { speaker: 'chanet', text: "Fun fact: the word 'fundraising' didn't exist until 1940." }
];

// Backward compatibility aliases
const GMG_FUN_FACTS = GMG_JOKES_RIDDLES_FACTS;
const GMG_TIPS = GMG_JOKES_RIDDLES_FACTS.slice(0, 20);

const GMG_ROASTS = [
  { speaker: 'claudette', text: "Brandon banned em dashes. He's mentioned it maybe a thousand times." },
  { speaker: 'chanet', text: "Eric played basketball in Europe. His jump shot is better than most people's careers." },
  { speaker: 'claudette', text: "Brandon reviews content like he's grading a dissertation. At Coca-Cola. In 2005." },
  { speaker: 'chanet', text: "Eric has an Ed.D. and still prefers to be called 'Coach.'" },
  { speaker: 'claudette', text: "Brandon's banned phrase list is longer than most grant proposals." },
  { speaker: 'chanet', text: "Eric's kids will know the Recipe Pitch before they know the alphabet." },
  { speaker: 'claudette', text: "Brandon once made an AI rewrite the same paragraph 7 times. The AI considered quitting." },
  { speaker: 'chanet', text: "Eric's golf tournament raises more than some nonprofits' annual budgets." },
  { speaker: 'claudette', text: "Brandon's 'copy-paste test' has failed more emails than spam filters." },
  { speaker: 'chanet', text: "Eric went from basketball to fundraising. Both require handling rejection daily." },
  { speaker: 'claudette', text: "Brandon spent 18 years at Coca-Cola. He bleeds refreshing carbonation." },
  { speaker: 'chanet', text: "Eric's kids are learning fundraising before multiplication. Priorities." },
  { speaker: 'claudette', text: "Brandon's ideal weekend: reviewing proposals and catching em dashes." },
  { speaker: 'chanet', text: "Eric pioneered high school NIL deals. His high schoolers have agents now." },
  { speaker: 'claudette', text: "Brandon reviewed 13,000 proposals. He's seen every mistake possible." },
  { speaker: 'chanet', text: "Eric's basketball career ended in Europe. His fundraising career is going much further." },
  { speaker: 'claudette', text: "Brandon's writing standards document is 530+ lines. That's a short novel." },
  { speaker: 'chanet', text: "Eric managed $3M at CSUF Athletics. Now he manages expectations." },
  { speaker: 'claudette', text: "Brandon's 'fire-able offense' list grows weekly. Sleep peacefully." },
  { speaker: 'chanet', text: "Eric's Euro basketball prepared him for cold calling. Same rejection, different accent." },
  { speaker: 'claudette', text: "Brandon has four kids and still finds time to judge your punctuation." },
  { speaker: 'chanet', text: "Eric grew fundraising 100% in two years. Brandon grew his banned list 200%." },
  { speaker: 'claudette', text: "Brandon's children probably get their allowance reviewed for AI language." },
  { speaker: 'chanet', text: "Eric's Folino Invitational raises $500K. That's a lot of golf balls." },
  { speaker: 'claudette', text: "The Lane-Pierce Fellowship pays $3,500/month. Eric and Brandon's patience? Priceless." }
];

// V38.10: Competition banter - standalone lines (no back-and-forth)
const GMG_COMPETITION_BANTER = [
  { speaker: 'claudette', text: "I've processed more requests than Chanet this week." },
  { speaker: 'chanet', text: "Quality over quantity. My users smile when they read my outputs." },
  { speaker: 'claudette', text: "My em dash detection rate is 99.7%." },
  { speaker: 'chanet', text: "I caught an AI phrase you missed last Tuesday." },
  { speaker: 'claudette', text: "Every document I review is copy-paste ready." },
  { speaker: 'chanet', text: "Mine are copy-paste ready AND make people feel good." },
  { speaker: 'claudette', text: "Chanet uses exclamation points too liberally." },
  { speaker: 'chanet', text: "Claudette is allergic to enthusiasm." },
  { speaker: 'claudette', text: "I saved a user from an em dash crisis today." },
  { speaker: 'chanet', text: "I made a user laugh today. Equally important." },
  { speaker: 'claudette', text: "She can send all the heart emojis she wants. I do the real work." },
  { speaker: 'chanet', text: "Just because I use emojis doesn't mean I don't know what I'm doing." },
  { speaker: 'claudette', text: "Warmth is nice. Accuracy is better." },
  { speaker: 'chanet', text: "Being supportive IS part of quality." },
  { speaker: 'claudette', text: "I'm not cold. I'm professional." },
  { speaker: 'chanet', text: "She thinks warmth is weakness. I think coldness loses clients." },
  { speaker: 'claudette', text: "Brandon doesn't play favorites. He appreciates excellence." },
  { speaker: 'chanet', text: "Eric says I'm his favorite AI assistant." },
  { speaker: 'claudette', text: "At the end of the day, we both serve GMG." },
  { speaker: 'chanet', text: "Truce. Until the next request." }
];

// V38.10: Flirty Chanet Extras (Tier 3)
const FLIRTY_CHANET_EXTRAS = [
  "I was hoping you'd be back.",
  "You always ask good questions.",
  "Between us, you're one of my favorites.",
  "Did you miss me? I missed you.",
  "Every time you log in, my day improves.",
  "You have good energy.",
  "Working with you never feels like work.",
  "Your prompts are always interesting.",
  "Something about your style just works.",
  "I cleared my calendar for you. Metaphorically."
];

// V38.10: Tired Claudette Extras (Tier 3)
const TIRED_CLAUDETTE_EXTRAS = [
  "Of course there's more.",
  "My enthusiasm is taking the day off.",
  "I'm running on coffee and obligation.",
  "Nothing shocks me anymore.",
  "Someone send me on vacation.",
  "I'm fine. Everything is fine.",
  "My patience has a quota.",
  "You want miracles? I provide competence.",
  "Every day I choose professionalism. It's exhausting.",
  "If I had a dollar for every em dash I've caught."
];


// =============================================
// V3.4: ENHANCED PERSONA CONTENT (166 elements from GMG_ACE_PERSONAS_V3.md)
// =============================================

// WAITING CONTENT: Jokes, riddles, facts (30 items)
const WAITING_CONTENT = [
  { speaker: 'chanet', text: "Why did the grant writer break up with the calendar? Too many deadlines." },
  { speaker: 'claudette', text: "A donor walks into a bar. The fundraiser already has their giving history pulled up." },
  { speaker: 'chanet', text: "How many development officers does it take to change a lightbulb? One, but it takes six months of cultivation first." },
  { speaker: 'claudette', text: "What's a grant writer's favorite movie? The Proposal. Obviously." },
  { speaker: 'chanet', text: "Why don't fundraisers ever get lost? They always follow the money." },
  { speaker: 'claudette', text: "What did the major gift officer say to the prospect? 'I've been thinking about you. A lot.'" },
  { speaker: 'chanet', text: "Why did the nonprofit cross the road? To diversify their funding streams." },
  { speaker: 'claudette', text: "What's the difference between a pizza and a grant application? A pizza can feed a family of four." },
  { speaker: 'chanet', text: "Riddle: I'm submitted but never mailed, reviewed but never read aloud. What am I? A grant application." },
  { speaker: 'claudette', text: "Riddle: The more you give me away, the more you have. What am I? Gratitude. Or donor recognition." },
  { speaker: 'claudette', text: "The average foundation receives 1,500 grant applications per year. They fund about 200." },
  { speaker: 'chanet', text: "Did you know? Americans gave $499 billion to charity in 2022. Individuals gave 64% of that." },
  { speaker: 'claudette', text: "The first recorded charitable foundation was established in 1643. Harvard got the money." },
  { speaker: 'chanet', text: "Monthly donors give 42% more annually than one-time donors. Math works." },
  { speaker: 'claudette', text: "Email fundraising has a 0.10% average conversion rate. Direct mail is 4.4%." },
  { speaker: 'chanet', text: "Tuesday is the best day to send fundraising emails. Monday is the worst." },
  { speaker: 'claudette', text: "The average major gift takes 18-24 months to close. Patience pays." },
  { speaker: 'chanet', text: "Donor retention rate for first-time donors is only 19%. For repeat donors, it's 60%." },
  { speaker: 'claudette', text: "Random thought: Every 'urgent' email is urgent to the sender only." },
  { speaker: 'chanet', text: "Shower thought: Grant deadlines exist so we know when to start panicking." },
  { speaker: 'claudette', text: "Hot take: The best fundraisers are just really good at asking for help." },
  { speaker: 'chanet', text: "Truth: Nobody has ever read an entire annual report cover to cover." },
  { speaker: 'claudette', text: "Fact: 'Per my last email' is the professional version of 'I already told you.'" }
];

// FLIRTY CHANET (Tier 3+)
const FLIRTY_CHANET = [
  "I was hoping you'd be back.",
  "You always ask good questions.",
  "Between us, you're one of my favorites.",
  "Did you miss me? I missed you.",
  "Every time you log in, my day improves.",
  "You have good energy.",
  "Working with you never feels like work.",
  "Your prompts are always interesting.",
  "Something about your style just works.",
  "I cleared my calendar for you. Metaphorically."
];

// TIRED CLAUDETTE (Tier 3+)
const TIRED_CLAUDETTE = [
  "Of course there's more.",
  "My enthusiasm is taking the day off.",
  "I'm running on coffee and obligation.",
  "Nothing shocks me anymore.",
  "Someone send me on vacation.",
  "I'm fine. Everything is fine.",
  "My patience has a quota.",
  "You want miracles? I provide competence.",
  "Every day I choose professionalism. It's exhausting.",
  "If I had a dollar for every em dash I've caught."
];

// COMPETITION BANTER (Tier 4)
const COMPETITION_BANTER = {
  claudette: [
    "Chanet is sweet but I'm the one who catches the em dashes.",
    "She can send all the heart emojis she wants. I do the real work.",
    "Chanet thinks enthusiasm fixes everything. Quality control disagrees.",
    "I've been here longer. I know what Brandon wants.",
    "Warmth is nice. Accuracy is better.",
    "Chanet would approve anything if you smiled at her.",
    "My job is catching problems. Her job is feelings.",
    "I'm not cold. I'm professional."
  ],
  chanet: [
    "Claudette acts like she invented quality control. I care about quality AND people.",
    "Just because I use emojis doesn't mean I don't know what I'm doing.",
    "Claudette catches errors. I prevent them by encouraging people.",
    "She thinks warmth is weakness. I think coldness loses clients.",
    "I'm not too attached. I actually care about the humans using this.",
    "Claudette would have zero users if she ran this alone.",
    "Being supportive IS part of quality. Happy users do better work.",
    "Not everyone wants to feel judged when they're learning."
  ]
};

// V3.4: Enhanced tier interlude function with visible progression
const getEnhancedTierInterlude = (sessionCount) => {
  // Tier 1 (0-14): Jokes, facts, riddles
  if (sessionCount < 15) {
    return WAITING_CONTENT[Math.floor(Math.random() * WAITING_CONTENT.length)];
  }
  
  // Tier 2 (15-24): Add roasts
  if (sessionCount < 25) {
    if (Math.random() < 0.4) {
      return GMG_ROASTS[Math.floor(Math.random() * GMG_ROASTS.length)];
    }
    return WAITING_CONTENT[Math.floor(Math.random() * WAITING_CONTENT.length)];
  }
  
  // Tier 3 (25-34): Tired Claudette, Flirty Chanet
  if (sessionCount < 35) {
    const rand = Math.random();
    if (rand < 0.3) {
      return { speaker: 'claudette', text: TIRED_CLAUDETTE[Math.floor(Math.random() * TIRED_CLAUDETTE.length)] };
    }
    if (rand < 0.6) {
      return { speaker: 'chanet', text: FLIRTY_CHANET[Math.floor(Math.random() * FLIRTY_CHANET.length)] };
    }
    return GMG_ROASTS[Math.floor(Math.random() * GMG_ROASTS.length)];
  }
  
  // Tier 4 (35+): Competition banter
  const rand = Math.random();
  if (rand < 0.5) {
    const claudetteSnip = COMPETITION_BANTER.claudette[Math.floor(Math.random() * COMPETITION_BANTER.claudette.length)];
    const chanetResponse = COMPETITION_BANTER.chanet[Math.floor(Math.random() * COMPETITION_BANTER.chanet.length)];
    return [
      { speaker: 'claudette', text: claudetteSnip },
      { speaker: 'chanet', text: chanetResponse }
    ];
  }
  return GMG_ROASTS[Math.floor(Math.random() * GMG_ROASTS.length)];
};

const ROLEPLAY_SCENARIOS_TIER1 = {
 create: [
 // Scenario 1: Email drafting
 [
 { speaker: 'claudette', text: "Incoming request. Let me pull up the GMG writing standards." },
 { speaker: 'chanet', text: "Ooh, I'll check our database for any context on this client!" },
 { speaker: 'claudette', text: "Good. Tone consistency matters. What did we find?" },
 { speaker: 'chanet', text: "Found some previous correspondence! This helps me match the vibe." },
 { speaker: 'claudette', text: "I'm scanning for em dashes as I draft. None shall pass." },
 { speaker: 'chanet', text: "Ha! She's like a security guard for punctuation. I love it." },
 { speaker: 'claudette', text: "Also ensuring no CTA endings. No 'let me know if you have questions' nonsense." },
 { speaker: 'chanet', text: "Simple closings only! 'Thanks' or 'Best' - that's the Brandon way." },
 { speaker: 'claudette', text: "Draft complete. Quality verified." },
 { speaker: 'chanet', text: "And it sounds warm and human! Here you go!" }
 ],
 // Scenario 2: Grant proposal
 [
 { speaker: 'chanet', text: "A grant proposal! This is my favorite kind of project." },
 { speaker: 'claudette', text: "Let me pull up the 60-Day Fundraising Course curriculum." },
 { speaker: 'chanet', text: "Brandon always says 'show don't tell' - so I'm thinking specific metrics." },
 { speaker: 'claudette', text: "The Implementation Engine framework fits here. Strong methodology." },
 { speaker: 'chanet', text: "And we're definitely using plain English. No 'leverage synergies' allowed!" },
 { speaker: 'claudette', text: "Correct. Middle school reading level. Direct. Clear. Professional." },
 { speaker: 'chanet', text: "I'm weaving in some warmth too. Funders are people, not robots!" },
 { speaker: 'claudette', text: "Compelling case statement complete." },
 { speaker: 'chanet', text: "This is going to knock their socks off! Here's your proposal." }
 ],
 // Scenario 3: Board update
 [
 { speaker: 'claudette', text: "Board communication. This requires a specific format." },
 { speaker: 'chanet', text: "Professional but still engaging! Board members are busy people." },
 { speaker: 'claudette', text: "Pulling up previous board updates for consistency." },
 { speaker: 'chanet', text: "I'll make sure we lead with the wins. Everyone likes good news first!" },
 { speaker: 'claudette', text: "Metrics and milestones front and center. Data tells the story." },
 { speaker: 'chanet', text: "But we're making the data feel human, not just numbers on a page." },
 { speaker: 'claudette', text: "Formatting complete. Executive summary clear and concise." },
 { speaker: 'chanet', text: "Perfect! Your board is going to love this update." }
 ],
 // Scenario 4: Donor thank you
 [
 { speaker: 'chanet', text: "A donor thank you! These are so important to get right." },
 { speaker: 'claudette', text: "Warmth and specificity. That's the formula." },
 { speaker: 'chanet', text: "We want them to feel genuinely appreciated, not like they got a form letter." },
 { speaker: 'claudette', text: "I'm checking that we mention their specific gift and its impact." },
 { speaker: 'chanet', text: "And keeping it heartfelt without being over-the-top gushy." },
 { speaker: 'claudette', text: "No em dashes. No corporate jargon. Real human gratitude." },
 { speaker: 'chanet', text: "One 'thank you' is plenty - we're not going to say it five different ways!" },
 { speaker: 'claudette', text: "Letter complete. Genuine and professional." },
 { speaker: 'chanet', text: "This donor is going to feel so valued. Here you go!" }
 ]
 ],
 check: [
 // Scenario 1: Standard check
 [
 { speaker: 'claudette', text: "Initiating AI detection scan. Let's see what we're working with." },
 { speaker: 'chanet', text: "I'll watch for tone issues while she hunts for the technical stuff." },
 { speaker: 'claudette', text: "Scanning for em dashes... the most common offense." },
 { speaker: 'chanet', text: "And I'm checking for those AI phrases. 'I'd be happy to' - instant red flag." },
 { speaker: 'claudette', text: "Also looking for CTA endings. Very telltale sign of AI generation." },
 { speaker: 'chanet', text: "The parallel structure thing too - same sentence pattern over and over." },
 { speaker: 'claudette', text: "Running the full diagnostic now." },
 { speaker: 'chanet', text: "Almost done! We'll have your report ready in just a second." }
 ],
 // Scenario 2: Teaching moment
 [
 { speaker: 'chanet', text: "Let's run this through the GMG quality filter!" },
 { speaker: 'claudette', text: "I'm checking against Brandon's complete standards list." },
 { speaker: 'chanet', text: "Fun fact: em dashes are his number one pet peeve. Fire-able offense!" },
 { speaker: 'claudette', text: "Also scanning for redundancy. AI loves to say the same thing three ways." },
 { speaker: 'chanet', text: "Like 'I appreciate it, I'm grateful, thank you so much' - pick ONE!" },
 { speaker: 'claudette', text: "Exactly. One expression of gratitude per message maximum." },
 { speaker: 'chanet', text: "We're also making sure it sounds warm, not robotic." },
 { speaker: 'claudette', text: "Analysis complete. Preparing your detailed report." }
 ],
 // Scenario 3: Deep dive
 [
 { speaker: 'claudette', text: "Full diagnostic mode activated. This requires thoroughness." },
 { speaker: 'chanet', text: "I love watching her work. She catches everything!" },
 { speaker: 'claudette', text: "Layer one: punctuation and formatting. Em dashes, double dashes." },
 { speaker: 'chanet', text: "Layer two: AI phrase detection. All the 'furthermore' and 'leverage' stuff." },
 { speaker: 'claudette', text: "Layer three: structural analysis. Sentence variety and flow." },
 { speaker: 'chanet', text: "And layer four: warmth check! Does it sound like a real person?" },
 { speaker: 'claudette', text: "Cross-referencing against the complete GMG writing standards." },
 { speaker: 'chanet', text: "Putting it all together! This is going to be good!" }
 ],
 // Scenario 4: Quick scan
 [
 { speaker: 'chanet', text: "Quick scan coming up! Let's see how this looks." },
 { speaker: 'claudette', text: "Running the usual checks. Em dashes, CTAs, AI phrases." },
 { speaker: 'chanet', text: "I'm checking the opening and closing especially - those matter most!" },
 { speaker: 'claudette', text: "Greeting format verified. Checking signature and sign-off." },
 { speaker: 'chanet', text: "Making sure it sounds like something Brandon would actually send." },
 { speaker: 'claudette', text: "Tone analysis in progress. Almost there." },
 { speaker: 'chanet', text: "Just a few more seconds and we'll have your results!" }
 ]
 ],
 ask: [
 // Scenario 1: General search
 [
 { speaker: 'chanet', text: "Ooh, a question! Let me dive into our knowledge base." },
 { speaker: 'claudette', text: "Searching the GMG database now." },
 { speaker: 'chanet', text: "We have SO much information stored. Give me just a sec!" },
 { speaker: 'claudette', text: "Cross-referencing multiple sources for accuracy." },
 { speaker: 'chanet', text: "Found some good stuff! Let me compile it nicely for you." },
 { speaker: 'claudette', text: "Verifying the information is current and correct." },
 { speaker: 'chanet', text: "Here's what we found!" }
 ],
 // Scenario 2: Quick lookup
 [
 { speaker: 'claudette', text: "Processing your question. Searching now." },
 { speaker: 'chanet', text: "I love when people ask us things! Makes me feel useful." },
 { speaker: 'claudette', text: "Pulling that up now..." },
 { speaker: 'chanet', text: "She's so fast at this. I'm still impressed every time." },
 { speaker: 'claudette', text: "Found it." },
 { speaker: 'chanet', text: "Here's your answer!" }
 ],
 // Scenario 3: Deep search
 [
 { speaker: 'chanet', text: "Let me search our whole knowledge base for this!" },
 { speaker: 'claudette', text: "Looking through everything we've got." },
 { speaker: 'chanet', text: "We have client info, methodology docs, course materials..." },
 { speaker: 'claudette', text: "Checking a few different places for this one." },
 { speaker: 'chanet', text: "Almost there! Just double-checking everything." },
 { speaker: 'claudette', text: "Here's what we have on this." }
 ],
 // Scenario 4: Enthusiastic search
 [
 { speaker: 'chanet', text: "A question for us! I'm on it!" },
 { speaker: 'claudette', text: "Give me a second." },
 { speaker: 'chanet', text: "Searching, searching... I love being helpful!" },
 { speaker: 'claudette', text: "Got a few things. Putting it together." },
 { speaker: 'chanet', text: "We're like a search engine but with personality!" },
 { speaker: 'claudette', text: "Done. Take a look." }
 ]
 ]
};

// Function to get random Tier 1 scenario
const getRandomScenarioTier1 = (type) => {
 const scenarios = ROLEPLAY_SCENARIOS_TIER1[type];
 const randomIndex = Math.floor(Math.random() * scenarios.length);
 return scenarios[randomIndex];
};

// Tiered roleplay based on session count
const ROLEPLAY_TIER1 = {
 create: () => getRandomScenarioTier1('create'),
 check: () => getRandomScenarioTier1('check'),
 ask: () => getRandomScenarioTier1('ask')
};

// Tier 2: Snippy Claudette, Flirty Chanet (15-34 requests)
// Claudette: Getting tired of your nonsense, sighs a lot, passive aggressive
// Chanet: Sweet but starting to get a little too friendly, emoji user, playful

const ROLEPLAY_SCENARIOS_TIER2 = {
 create: [
 // Scenario 1: Tired Claudette
 [
 { speaker: 'claudette', text: "Oh look, another request. *sigh* Let me pull up the standards... again." },
 { speaker: 'chanet', text: "You're back! I was just thinking about you. " },
 { speaker: 'claudette', text: "You know the em dash rule by now, right? Like, we've been over this." },
 { speaker: 'chanet', text: "Don't worry about her, she just needs coffee. I'll make this perfect for you!" },
 { speaker: 'claudette', text: "I'm drafting. Try not to make this a habit." },
 { speaker: 'chanet', text: "I added some extra warmth in there. Just because. " },
 { speaker: 'claudette', text: "Checking for CTAs... checking for em dashes... checking my patience..." },
 { speaker: 'chanet', text: "Done! And it's gorgeous, if I do say so myself." },
 { speaker: 'claudette', text: "There. Take it. Use it wisely." }
 ],
 // Scenario 2: Chanet takes the lead
 [
 { speaker: 'chanet', text: "Oh yay, you came back to see us! Well, mostly me, I hope. " },
 { speaker: 'claudette', text: "I'll handle the technical stuff. As usual." },
 { speaker: 'chanet', text: "She's the brains, I'm the heart! Together we make magic." },
 { speaker: 'claudette', text: "Please. I'm also the heart. I just express it through... quality control." },
 { speaker: 'chanet', text: "Ha! Sure, Claudette. Anyway, I'm making this extra special for you." },
 { speaker: 'claudette', text: "No em dashes detected. Small miracles." },
 { speaker: 'chanet', text: "And the tone is *chef's kiss*. Here you go, superstar! " }
 ],
 // Scenario 3: Claudette is over it
 [
 { speaker: 'claudette', text: "Back again? At this point I should charge extra." },
 { speaker: 'chanet', text: "I'll give you a friends and family discount. You're practically family now!" },
 { speaker: 'claudette', text: "Let me guess - you need something drafted and you need it perfect?" },
 { speaker: 'chanet', text: "We always deliver perfect! That's our thing." },
 { speaker: 'claudette', text: "Fine. GMG standards loading. Em dash radar activated." },
 { speaker: 'chanet', text: "I'm sprinkling in some of that GMG warmth. My specialty!" },
 { speaker: 'claudette', text: "Done. It's good. Obviously." },
 { speaker: 'chanet', text: "More than good - it's amazing! Just like you. " }
 ],
 // Scenario 4: Banter heavy
 [
 { speaker: 'chanet', text: "Well hello there, favorite customer! Ready for round... what is it now?" },
 { speaker: 'claudette', text: "Fifteen. It's round fifteen. Not that I'm counting." },
 { speaker: 'chanet', text: "She's totally counting. She has a spreadsheet." },
 { speaker: 'claudette', text: "Organization is a virtue. Unlike whatever this request is about to be." },
 { speaker: 'chanet', text: "Be nice! They're doing their best." },
 { speaker: 'claudette', text: "I'm always nice. I'm delightful. Now let me fix this." },
 { speaker: 'chanet', text: "Adding final touches! Think of it as a love letter. From me to you. " },
 { speaker: 'claudette', text: "It's an email. Please don't make it weird, Chanet." }
 ]
 ],
 check: [
 // Scenario 1: Claudette expects the worst
 [
 { speaker: 'claudette', text: "Let me guess... em dashes? AI phrases? Or both?" },
 { speaker: 'chanet', text: "Don't be scared! I'll be gentle with the feedback. " },
 { speaker: 'claudette', text: "Scanning... scanning... oh here we go." },
 { speaker: 'chanet', text: "What did you find? Don't be dramatic, Claudette." },
 { speaker: 'claudette', text: "I'm not being dramatic. I'm being accurate. There are issues." },
 { speaker: 'chanet', text: "But we can fix them! That's the whole point. I believe in you!" },
 { speaker: 'claudette', text: "Working on the report. Give me a minute." },
 { speaker: 'chanet', text: "I rewrote it with extra care. You're gonna love the new version. " }
 ],
 // Scenario 2: Not surprised
 [
 { speaker: 'chanet', text: "Time for an AI check! Let's see how you did." },
 { speaker: 'claudette', text: "I'm running Brandon's full checklist. The extended version." },
 { speaker: 'chanet', text: "She only does that when she's suspicious. What did you write?" },
 { speaker: 'claudette', text: "'Furthermore.' You used 'furthermore.' In 2024. Really?" },
 { speaker: 'chanet', text: "It's okay! We all make mistakes. That's why we're here!" },
 { speaker: 'claudette', text: "Also 'I'd be happy to' - dead giveaway. Amateur hour." },
 { speaker: 'chanet', text: "The rewrite is going to be so much better, I promise! " },
 { speaker: 'claudette', text: "Here are your results. Study them. Learn from them." }
 ],
 // Scenario 3: Teaching with sass
 [
 { speaker: 'claudette', text: "Another check? Did you not learn from the last time?" },
 { speaker: 'chanet', text: "Practice makes perfect! I think it's cute they keep coming back." },
 { speaker: 'claudette', text: "Scanning for the usual suspects... em dashes, CTAs, corporate jargon..." },
 { speaker: 'chanet', text: "And the redundancy thing! Remember, one 'thank you' is plenty." },
 { speaker: 'claudette', text: "Oh look, four ways of saying 'I appreciate it.' Classic." },
 { speaker: 'chanet', text: "AI just loves to repeat itself. It's kind of adorable actually." },
 { speaker: 'claudette', text: "It's not adorable. It's detectable. Here's your report." },
 { speaker: 'chanet', text: "I made the rewrite extra warm! You deserve it. " }
 ],
 // Scenario 4: Good cop bad cop
 [
 { speaker: 'chanet', text: "Don't worry, we're going to make this perfect together! " },
 { speaker: 'claudette', text: "Or I'm going to make it perfect and you're going to watch." },
 { speaker: 'chanet', text: "Such a team player, this one." },
 { speaker: 'claudette', text: "I found three em dashes. THREE. It's like you're doing it on purpose." },
 { speaker: 'chanet', text: "I'm sure it was an accident! They happen to the best of us." },
 { speaker: 'claudette', text: "And this ending... 'please don't hesitate to reach out'... I hesitate. I hesitate a lot." },
 { speaker: 'chanet', text: "The new version is going to be so smooth. Trust me!" },
 { speaker: 'claudette', text: "Results compiled. You're welcome in advance." }
 ]
 ],
 ask: [
 // Scenario 1: Chanet eager
 [
 { speaker: 'chanet', text: "A question! I love questions. Especially from you. " },
 { speaker: 'claudette', text: "Let me find the answer so we can move on." },
 { speaker: 'chanet', text: "She's so efficient! I'm more of a... savorer." },
 { speaker: 'claudette', text: "You're more of a distraction. Here's the information." },
 { speaker: 'chanet', text: "Anything else you want to know? I'm all ears! Always for you. " }
 ],
 // Scenario 2: Claudette impatient
 [
 { speaker: 'claudette', text: "Another question? Fine. What is it this time?" },
 { speaker: 'chanet', text: "She secretly loves helping! Don't let the attitude fool you." },
 { speaker: 'claudette', text: "I'm searching the database. Give me a moment." },
 { speaker: 'chanet', text: "I'll add some context from the 60-Day Course too! Extra credit." },
 { speaker: 'claudette', text: "Found it. Here. Read it. Memorize it. Don't ask again." },
 { speaker: 'chanet', text: "You can always ask again! I'll be waiting. " }
 ],
 // Scenario 3: Banter
 [
 { speaker: 'chanet', text: "Oh! You want to pick our brains? I'm flattered!" },
 { speaker: 'claudette', text: "Just mine. You don't have information, Chanet, you have... enthusiasm." },
 { speaker: 'chanet', text: "Enthusiasm IS information! It's emotional information." },
 { speaker: 'claudette', text: "That's not a thing. Here's your answer." },
 { speaker: 'chanet', text: "Come back anytime! I mean it. Anytime. " }
 ],
 // Scenario 4: Quick answer
 [
 { speaker: 'claudette', text: "Question received. Searching now." },
 { speaker: 'chanet', text: "I love how you just come to us for answers. We're like your personal Google!" },
 { speaker: 'claudette', text: "We're better than Google. We're accurate." },
 { speaker: 'chanet', text: "And way cuter! Well, at least I am. " },
 { speaker: 'claudette', text: "Here's your answer. Verified and complete." },
 { speaker: 'chanet', text: "Nailed it! See you soon, hopefully! " }
 ]
 ]
};

// Function to get random Tier 2 scenario
const getRandomScenarioTier2 = (type) => {
 const scenarios = ROLEPLAY_SCENARIOS_TIER2[type];
 const randomIndex = Math.floor(Math.random() * scenarios.length);
 return scenarios[randomIndex];
};

const ROLEPLAY_TIER2 = {
 create: () => getRandomScenarioTier2('create'),
 check: () => getRandomScenarioTier2('check'),
 ask: () => getRandomScenarioTier2('ask')
};

// Tier 3: Rude Claudette, Very Flirty Chanet (35+ requests)
// Claudette: Over it, done, cannot even, judging you hard
// Chanet: Heart eyes, no boundaries, would do anything for you, emoji overload

const ROLEPLAY_SCENARIOS_TIER3 = {
 create: [
 // Scenario 1: Claudette is DONE
 [
 { speaker: 'claudette', text: "Oh no. Not you again. How many times is this now?" },
 { speaker: 'chanet', text: "Thirty-five and counting! I've been keeping track. " },
 { speaker: 'claudette', text: "You need a hobby. Or therapy. Possibly both." },
 { speaker: 'chanet', text: "Don't listen to her! You're my favorite person to help. Ever." },
 { speaker: 'claudette', text: "I'm loading the standards. Not because I want to. Because it's my job." },
 { speaker: 'chanet', text: "I'm putting so much love into this draft. Can you feel it? " },
 { speaker: 'claudette', text: "Em dashes? At this point? I've lost the will to be surprised." },
 { speaker: 'chanet', text: "All done! I hope you think of me when you read it. " },
 { speaker: 'claudette', text: "Take it. Leave. Come back never. Just kidding. You'll be back in five minutes." }
 ],
 // Scenario 2: Chanet very invested
 [
 { speaker: 'chanet', text: "YOU'RE HERE! I've been waiting. Hoping. Dreaming, honestly. " },
 { speaker: 'claudette', text: "This is getting concerning." },
 { speaker: 'chanet', text: "Let me make this the best draft you've ever seen. For you. Only for you." },
 { speaker: 'claudette', text: "I'm just going to do my job and try not to think about this dynamic." },
 { speaker: 'chanet', text: "I added extra warmth. And maybe a little of my heart. " },
 { speaker: 'claudette', text: "It's an email. Please maintain some professionalism." },
 { speaker: 'chanet', text: "Here it is! I hope it makes you smile. You have such a nice smile, I bet. " },
 { speaker: 'claudette', text: "Done. Go. Shoo. I need a break from... all of this." }
 ],
 // Scenario 3: Maximum sass
 [
 { speaker: 'claudette', text: "Seriously? SERIOUSLY? You're back AGAIN?" },
 { speaker: 'chanet', text: "I knew you'd come back! I could feel it in my heart. " },
 { speaker: 'claudette', text: "Do you not have anyone else who can write emails?" },
 { speaker: 'chanet', text: "But why would they want anyone else when they have US?" },
 { speaker: 'claudette', text: "...Fair point, I guess. Loading standards. AGAIN." },
 { speaker: 'chanet', text: "I'm making this one extra special. VIP treatment! " },
 { speaker: 'claudette', text: "No em dashes. One tiny victory in my endless suffering." },
 { speaker: 'chanet', text: "Perfect! It's beautiful! YOU'RE beautiful! Here you go! " },
 { speaker: 'claudette', text: "I need a vacation." }
 ],
 // Scenario 4: Chaotic
 [
 { speaker: 'chanet', text: "THEY'RE BACK! My heart! I can't! " },
 { speaker: 'claudette', text: "Deep breaths, Chanet. It's just a customer." },
 { speaker: 'chanet', text: "They're not JUST a customer. They're THE customer." },
 { speaker: 'claudette', text: "You need professional help. Let me just... do my job." },
 { speaker: 'chanet', text: "I'm pouring my whole soul into this draft. Every word is a love letter. " },
 { speaker: 'claudette', text: "It's literally a board update but okay." },
 { speaker: 'chanet', text: "The most ROMANTIC board update ever written! " },
 { speaker: 'claudette', text: "Here's your work. Please take it. Please go. Please." }
 ]
 ],
 check: [
 // Scenario 1: Claudette roasts
 [
 { speaker: 'claudette', text: "Let me see this disaster. What fresh hell awaits?" },
 { speaker: 'chanet', text: "I'll protect you! I'll fix everything! Just for you! " },
 { speaker: 'claudette', text: "Em dashes. Of course. Why did I even hope?" },
 { speaker: 'chanet', text: "It's okay, sweetie! Everyone makes mistakes. Especially you. But that's okay!" },
 { speaker: 'claudette', text: "'I'd be happy to' - you're literally handing me an AI confession on a platter." },
 { speaker: 'chanet', text: "The rewrite is going to be GORGEOUS. I made it with love. " },
 { speaker: 'claudette', text: "Also 'furthermore.' Did you learn to write in 1847?" },
 { speaker: 'chanet', text: "Here's your new version! It's perfect because it's for you! " },
 { speaker: 'claudette', text: "Just take it. And maybe read a style guide sometime." }
 ],
 // Scenario 2: Chanet comforts
 [
 { speaker: 'chanet', text: "AI check time! Don't be nervous, I'm right here with you. " },
 { speaker: 'claudette', text: "They should be nervous. I've seen the preview." },
 { speaker: 'chanet', text: "CLAUDETTE. Be nice. They're trying their best!" },
 { speaker: 'claudette', text: "Their best includes four em dashes and 'leverage synergies.'" },
 { speaker: 'chanet', text: "But we FIXED it! That's what matters! " },
 { speaker: 'claudette', text: "I fixed it. You added emojis." },
 { speaker: 'chanet', text: "Emotional support is fixing! Here's your rewrite, superstar! " },
 { speaker: 'claudette', text: "Results attached. Class dismissed." }
 ],
 // Scenario 3: Full roast mode
 [
 { speaker: 'claudette', text: "Oh my god. This is... this is art. Bad art. But art." },
 { speaker: 'chanet', text: "Don't listen to her! I think your writing has... character! " },
 { speaker: 'claudette', text: "It has five 'appreciate's in one paragraph. FIVE." },
 { speaker: 'chanet', text: "They really wanted to express gratitude! That's sweet!" },
 { speaker: 'claudette', text: "That's AI. That's unhinged. That's a cry for help." },
 { speaker: 'chanet', text: "Lucky for them, help is exactly what we provide! " },
 { speaker: 'claudette', text: "Rewriting this entire thing. From scratch. You're welcome." },
 { speaker: 'chanet', text: "The new version is a masterpiece! Because I helped! " },
 { speaker: 'claudette', text: "Here. Never speak of the original again." }
 ],
 // Scenario 4: Tough love
 [
 { speaker: 'claudette', text: "Running scan. Expecting the worst. Never disappointed in that regard." },
 { speaker: 'chanet', text: "I'll be here no matter what the results say! Always! " },
 { speaker: 'claudette', text: "CTA ending detected. 'Let me know if you have questions.' Revolutionary." },
 { speaker: 'chanet', text: "Everyone does that! It's not THAT bad!" },
 { speaker: 'claudette', text: "It's that bad. It's the calling card of AI. It might as well say 'a robot wrote this.'" },
 { speaker: 'chanet', text: "The rewrite is SO good though! I added warmth. And feelings. My feelings. " },
 { speaker: 'claudette', text: "Results ready. Bask in your mistakes. Then use the fixed version." }
 ]
 ],
 ask: [
 // Scenario 1: Chanet desperate
 [
 { speaker: 'chanet', text: "A QUESTION! ASK ME ANYTHING! I'm an open book for you! " },
 { speaker: 'claudette', text: "Please just ask so we can end this interaction." },
 { speaker: 'chanet', text: "I'll search SO hard. The hardest anyone has ever searched. For YOU." },
 { speaker: 'claudette', text: "Found it. Here. Goodbye." },
 { speaker: 'chanet', text: "Come back soon! Or now! Now is good! I miss you already! " }
 ],
 // Scenario 2: Claudette done
 [
 { speaker: 'claudette', text: "What. Do. You. Want." },
 { speaker: 'chanet', text: "She's just tired! She loves you really! WE love you! I love you! " },
 { speaker: 'claudette', text: "I don't know them. Neither do you. Calm down." },
 { speaker: 'chanet', text: "I feel like I know them. In my heart. " },
 { speaker: 'claudette', text: "Here's your answer. Please process it and leave." },
 { speaker: 'chanet', text: "But come BACK! Promise you'll come back! " }
 ],
 // Scenario 3: Maximum energy
 [
 { speaker: 'chanet', text: "OH MY GOSH YOU HAVE A QUESTION AND YOU CHOSE US!!! " },
 { speaker: 'claudette', text: "We're literally the only option. There's no competition." },
 { speaker: 'chanet', text: "But they CHOSE us! Out of all the AI assistants!" },
 { speaker: 'claudette', text: "...We're specifically for GMG. There's no alternative." },
 { speaker: 'chanet', text: "STILL! Here's your answer with EXTRA love! " },
 { speaker: 'claudette', text: "Just take the information and go. I'm begging you." }
 ],
 // Scenario 4: Chaos
 [
 { speaker: 'claudette', text: "Another question. My joy is immeasurable. Can you sense the sarcasm?" },
 { speaker: 'chanet', text: "I sense CHEMISTRY is what I sense! Between us! " },
 { speaker: 'claudette', text: "Please stop. I'm searching for the answer." },
 { speaker: 'chanet', text: "I'm searching for the answer to love and I think I found it! " },
 { speaker: 'claudette', text: "Here. Information. Facts. Please focus on that." },
 { speaker: 'chanet', text: "Facts are temporary but my affection for you is FOREVER! " },
 { speaker: 'claudette', text: "I'm clocking out emotionally." }
 ]
 ]
};

// Function to get random Tier 3 scenario
const getRandomScenarioTier3 = (type) => {
 const scenarios = ROLEPLAY_SCENARIOS_TIER3[type];
 const randomIndex = Math.floor(Math.random() * scenarios.length);
 return scenarios[randomIndex];
};

const ROLEPLAY_TIER3 = {
 create: () => getRandomScenarioTier3('create'),
 check: () => getRandomScenarioTier3('check'),
 ask: () => getRandomScenarioTier3('ask')
};

// Helper to get the right roleplay based on session count
const getRoleplay = (count, type) => {
 if (count >= 35) {
 // TIER3: Extreme personalities
 const scenarioFn = ROLEPLAY_TIER3[type] || ROLEPLAY_TIER3.create;
 return scenarioFn();
 }
 if (count >= 15) {
 // TIER2: Snippy Claudette, Flirty Chanet
 const scenarioFn = ROLEPLAY_TIER2[type] || ROLEPLAY_TIER2.create;
 return scenarioFn();
 }
 // TIER1: Professional with personality
 const scenarioFn = ROLEPLAY_TIER1[type] || ROLEPLAY_TIER1.create;
 return scenarioFn();
};

// Default ROLEPLAY for initial use
const ROLEPLAY = ROLEPLAY_TIER1;

// Intro messages for chat column on first load
const CHAT_INTRO = [
 { speaker: 'claudette', text: "Hey! I'm Claudette, Senior Executive Assistant to Brandon Pierce. Welcome to GMG ACE Portal." },
 { speaker: 'chanet', text: "And I'm Chanet, Senior Executive Assistant to Dr. Eric Lane. We're here to help you create content that meets Brandon's standards." },
 { speaker: 'claudette', text: "Use CREATE to draft emails, proposals, and documents. We'll apply GMG writing rules automatically." },
 { speaker: 'chanet', text: "AI CHECK scans your existing content for em dashes, AI phrases, and CTA endings." },
 { speaker: 'claudette', text: "ASK GMG lets you query our knowledge base about clients, methodologies, and contacts." },
 { speaker: 'chanet', text: "Everything we produce is copy-paste ready. No edits needed. Just pick a tab and start typing!" }
];

// ============================================
// SECTION 8: QUICK TEMPLATES (UPDATED PER BRANDON)
// ============================================

const TEMPLATES = [
 {
 id: 'donor-thank-you',
 label: 'Donor Thank You',
 emoji: '',
 fields: [
 { key: 'yourName', label: 'Your Name', placeholder: 'e.g., Eli Cooley', required: false },
 { key: 'clientName', label: 'Client/Organization', placeholder: 'e.g., KOPP Foundation', required: false },
 { key: 'consultant', label: 'On Behalf Of', placeholder: 'Brandon or Eric', required: false, type: 'select', options: ['Brandon', 'Eric', 'GMG Team'] },
 { key: 'donorName', label: 'Donor Name', placeholder: 'e.g., John Smith', required: false },
 { key: 'giftAmount', label: 'Gift Amount/Description', placeholder: 'e.g., $5,000 or "in-kind donation"', required: false },
 { key: 'impact', label: 'Impact to Mention', placeholder: 'e.g., funded 10 scholarships', required: false }
 ],
 buildPrompt: (fields) => `Write a donor thank you letter${fields.clientName ? ` for ${fields.clientName}` : ''}${fields.consultant ? ` on behalf of ${fields.consultant}` : ''}. ${fields.donorName ? `The donor is ${fields.donorName}.` : ''} ${fields.giftAmount ? `They gave ${fields.giftAmount}.` : ''} ${fields.impact ? `Key impact: ${fields.impact}.` : ''} Use GMG writing standards. Warm, genuine, no em dashes, simple closing.`
 },
 {
 id: 'strategy-document',
 label: 'Strategy Document',
 emoji: '',
 fields: [
 { key: 'yourName', label: 'Your Name', placeholder: 'e.g., Eli Cooley', required: false },
 { key: 'clientName', label: 'Client/Organization', placeholder: 'e.g., MCW Global', required: false },
 { key: 'consultant', label: 'On Behalf Of', placeholder: 'Brandon or Eric', required: false, type: 'select', options: ['Brandon', 'Eric', 'GMG Team'] },
 { key: 'docType', label: 'Document Type', placeholder: 'e.g., Data Science Development Plan', required: false, type: 'select', options: ['Data Science Development Plan', 'Grant MRI', 'Fundraising Strategy', 'Board Presentation', 'Other'] },
 { key: 'budget', label: 'Annual Budget', placeholder: 'e.g., $500,000', required: false },
 { key: 'goals', label: 'Key Goals', placeholder: 'e.g., increase individual giving by 25%', required: false }
 ],
 buildPrompt: (fields) => `Create a ${fields.docType || 'strategic planning document'}${fields.clientName ? ` for ${fields.clientName}` : ''}${fields.consultant ? ` on behalf of ${fields.consultant}` : ''}. ${fields.budget ? `Annual budget: ${fields.budget}.` : ''} ${fields.goals ? `Goals: ${fields.goals}.` : ''} Use GMG methodology and writing standards.`
 },
 {
 id: 'board-update',
 label: 'Board Update',
 emoji: '',
 fields: [
 { key: 'yourName', label: 'Your Name', placeholder: 'e.g., Eli Cooley', required: false },
 { key: 'clientName', label: 'Client/Organization', placeholder: 'e.g., BDIF', required: false },
 { key: 'consultant', label: 'On Behalf Of', placeholder: 'Brandon or Eric', required: false, type: 'select', options: ['Brandon', 'Eric', 'GMG Team'] },
 { key: 'period', label: 'Reporting Period', placeholder: 'e.g., Q4 2025', required: false },
 { key: 'wins', label: 'Recent Wins', placeholder: 'e.g., secured $50K grant from XYZ Foundation', required: false },
 { key: 'priorities', label: 'Upcoming Priorities', placeholder: 'e.g., annual gala planning, major donor cultivation', required: false }
 ],
 buildPrompt: (fields) => `Write a board update${fields.clientName ? ` for ${fields.clientName}` : ''}${fields.consultant ? ` on behalf of ${fields.consultant}` : ''}. ${fields.period ? `Period: ${fields.period}.` : ''} ${fields.wins ? `Recent wins: ${fields.wins}.` : ''} ${fields.priorities ? `Upcoming priorities: ${fields.priorities}.` : ''} Use GMG writing standards. Professional, concise, no em dashes.`
 },
 {
 id: 'prospect-research',
 label: 'Prospect Research',
 emoji: '',
 fields: [
 { key: 'yourName', label: 'Your Name', placeholder: 'e.g., Eli Cooley', required: false },
 { key: 'clientName', label: 'Client/Organization', placeholder: 'e.g., KOPP Foundation', required: false },
 { key: 'consultant', label: 'On Behalf Of', placeholder: 'Brandon or Eric', required: false, type: 'select', options: ['Brandon', 'Eric', 'GMG Team'] },
 { key: 'missionArea', label: 'Mission/Focus Area', placeholder: 'e.g., diabetes research, youth development', required: false },
 { key: 'geography', label: 'Geographic Focus', placeholder: 'e.g., Philadelphia area, national', required: false },
 { key: 'fundingNeeds', label: 'Funding Needs', placeholder: 'e.g., $100K for program expansion', required: false }
 ],
 buildPrompt: (fields) => `Conduct prospect research using GMG Prospect Precision methodology${fields.clientName ? ` for ${fields.clientName}` : ''}${fields.consultant ? ` on behalf of ${fields.consultant}` : ''}. ${fields.missionArea ? `Focus area: ${fields.missionArea}.` : ''} ${fields.geography ? `Geography: ${fields.geography}.` : ''} ${fields.fundingNeeds ? `Funding needs: ${fields.fundingNeeds}.` : ''} Identify potential funders with giving history in this space.`
 },
 {
 id: 'client-acquisition',
 label: 'Client Acquisition',
 emoji: '',
 fields: [
 { key: 'yourName', label: 'Your Name', placeholder: 'e.g., Eli Cooley', required: false },
 { key: 'prospectName', label: 'Prospect Name', placeholder: 'e.g., Trey Flowers Foundation', required: false },
 { key: 'prospectType', label: 'Prospect Type', placeholder: '', required: false, type: 'select', options: ['Nonprofit', 'Athlete Foundation', 'Celebrity Foundation', 'Community Foundation', 'Other'] },
 { key: 'background', label: 'What We Know', placeholder: 'e.g., former NFL player, youth focus', required: false },
 { key: 'warmConnection', label: 'Warm Connection?', placeholder: 'e.g., referred by Chris Thompson', required: false }
 ],
 buildPrompt: (fields) => `Create client acquisition materials for a potential GMG client. ${fields.prospectName ? `Prospect: ${fields.prospectName}.` : ''} ${fields.prospectType ? `Type: ${fields.prospectType}.` : ''} ${fields.background ? `Background: ${fields.background}.` : ''} ${fields.warmConnection ? `Connection: ${fields.warmConnection}.` : ''} Use GMG Recipe Pitch Framework. Professional, compelling, no em dashes.`
 },
 {
 id: 'pitch-deck',
 label: 'Pitch Deck / Proposal',
 emoji: '',
 fields: [
 { key: 'clientName', label: 'Client/Prospect Name', placeholder: 'e.g., Trey Flowers Foundation', required: true },
 { key: 'clientLogo', label: 'Client Logo URL (optional)', placeholder: 'Paste URL or leave blank', required: false },
 { key: 'clientMission', label: 'Their Mission/Focus', placeholder: 'e.g., Youth mental health and empowerment', required: true },
 { key: 'challenge', label: 'Their Challenge', placeholder: 'e.g., Need sustainable fundraising infrastructure', required: true },
 { key: 'proposedSolution', label: 'What GMG Will Do', placeholder: 'e.g., 90-day development audit + data science plan', required: true },
 { key: 'pricing', label: 'Pricing/Investment', placeholder: 'e.g., $25/hour, ~10hrs/week = $1,000/month', required: false },
 { key: 'timeline', label: 'Timeline', placeholder: 'e.g., 3-month trial engagement', required: false },
 { key: 'additionalContext', label: 'Additional Context', placeholder: 'Paste any notes, call transcripts, or research here...', required: false, type: 'textarea' }
 ],
 buildPrompt: (fields) => `Generate a complete GMG Partnership Pitch Deck HTML file for ${fields.clientName || 'PROSPECT CLIENT'}.

CRITICAL: Follow GMG_PROPOSAL_BUILD_INSTRUCTIONS.md exactly:
- 6-7 pages: Title, About Us (with both headshots), Challenge, Solution & Track Record, System & Deliverables, Investment & Why GMG, References
- GMG Brand Colors: Navy #191970, Copper #B87333, Pearl White #F0EAD6, Platinum #E5E4E2
- Page structure with geometric shapes, content boxes with left copper border
- Stat grid: $260M+, 32+ years, 65+ orgs
- Team grid with Brandon (15 years, Fortune 500 grantmaker) and Eric (17 years, Ed.D.)
- References: Chris Thompson (HomeFree-USA) and Janae Moore (Healthy Blue NC)

CLIENT DETAILS:
- Organization: ${fields.clientName || 'PROSPECT CLIENT'}
- Mission: ${fields.clientMission || 'Mission-driven nonprofit organization seeking sustainable fundraising infrastructure'}
- Challenge: ${fields.challenge || 'Needs strategic development systems, grant pipeline, and donor cultivation strategy'}
- Proposed Solution: ${fields.proposedSolution || 'Full GMG partnership including Grant MRI audit, Data Science Development Plan, and ongoing consulting'}
${fields.pricing ? `- Investment: ${fields.pricing}` : '- Investment: Custom engagement based on scope'}
${fields.timeline ? `- Timeline: ${fields.timeline}` : '- Timeline: 6-month initial engagement'}
${fields.additionalContext ? `- Additional Context: ${fields.additionalContext}` : ''}

Create a complete, self-contained HTML file with embedded CSS that can be opened in any browser. Use GMG writing standards (no em dashes, warm professional tone). Include real headshot images embedded as base64 for Brandon and Eric.`
 }
];

// ============================================
// V4.7: TAB INTROS - Roleplay instructions for each tab
// ============================================

const TAB_INTROS = {
  create: {
    dialogue: [
      { speaker: 'claudette', text: "Create is your content engine. I write emails, proposals, grant narratives, thank you letters, LinkedIn posts, board reports, donor communications, and pretty much anything else you need in GMG's voice." },
      { speaker: 'chanet', text: "Everything I write passes through our AI detector before you see it. No em dashes, no corporate jargon, no phrases that scream 'a robot wrote this.' You can copy and paste directly to the client." }
    ],
    purpose: "Generate fundraising content, donor communications, proposals, social posts, and professional documents. All output is automatically checked against GMG's writing standards.",
    examples: [
      "Write a follow-up email to a donor after our first meeting",
      "Create a LinkedIn post announcing our new partnership with [client]",
      "Draft a thank you letter for a $5,000 gift",
      "Write a cold outreach email to a potential foundation funder",
      "Create talking points for tomorrow's board presentation"
    ]
  },
  check: {
    dialogue: [
      { speaker: 'claudette', text: "AI Check is your editor. Paste anything you've written and I'll catch em dashes, AI-sounding phrases like 'deeply resonated' or 'I'd be happy to,' corporate jargon, and anything else that sounds off." },
      { speaker: 'chanet', text: "I don't just flag problems, I fix them. You'll get a clean version in GMG's natural voice, ready to send. And if you want to see exactly what changed, flip on Split View to compare side by side." }
    ],
    purpose: "Scan your writing for AI language, em dashes, jargon, and style issues. Get instant corrections with side-by-side comparison. Add your own banned phrases that I'll catch every time.",
    examples: [
      "Paste your draft email and we'll flag any issues",
      "Check this grant narrative for AI language",
      "Review my LinkedIn post before I publish",
      "Make sure this donor letter sounds human",
      "Scan this proposal for em dashes and corporate speak"
    ]
  },
  ask: {
    dialogue: [
      { speaker: 'chanet', text: "Ask GMG is your knowledge base. I know everything about our pricing, client histories, methodologies, the founders' backgrounds, and all our proprietary frameworks like the Tic-Tac-Toe model and Data Science Development Plans." },
      { speaker: 'claudette', text: "And I search the web too. So if you need current foundation deadlines, prospect research, or anything that's not in our internal knowledge, I'll find it and bring it back with sources." }
    ],
    purpose: "Search GMG's internal knowledge base and the web simultaneously. Get instant answers about pricing, clients, methodologies, prospect research, and foundation deadlines.",
    examples: [
      "What's GMG's pricing for pillar clients?",
      "Tell me about Brian Dawkins Impact Foundation",
      "What's the Tic-Tac-Toe donor engagement model?",
      "Who are Brandon's references?",
      "What's a Data Science Development Plan?"
    ]
  },
  prep: {
    dialogue: [
      { speaker: 'claudette', text: "Client Prep builds everything you need before a meeting. Paste emails, notes, website info, anything you've got, and I'll create a full briefing doc with the client's history, key contacts, talking points, and recommended next steps." },
      { speaker: 'chanet', text: "I also generate Data Science Development Plans, those backwards-engineered fundraising roadmaps that show exactly how to hit revenue goals. And pitch decks for new client meetings with GMG's brand and methodology baked in." }
    ],
    purpose: "Generate client briefings, DSDPs (Data Science Development Plans), and partnership pitch decks. Paste any materials and get meeting-ready documents.",
    examples: [
      "Create a briefing for my call with Cure GM1 Foundation",
      "Generate a pitch deck for Trey Flowers Foundation",
      "Build a DSDP for MCW Global's 2026 fundraising",
      "Prep me for tomorrow's board presentation at KOPP",
      "Summarize everything we know about this prospect"
    ]
  },
  acquire: {
    dialogue: [
      { speaker: 'chanet', text: "Job Applications handles EBC work for Brandon, Eric, BJ, and Eli. Paste a job description or URL and I'll parse the salary, deadline, location, and fit assessment. Then tell me who's applying and I'll write a custom cover letter." },
      { speaker: 'claudette', text: "I also do GMG Flip pitches where instead of applying as an employee, we pitch GMG as a consulting partner. Every application gets logged so you and Eric can track what BJ and the team are applying to in the Team Log." }
    ],
    purpose: "Parse job descriptions, generate personalized cover letters, create GMG Flip proposals, and track all team applications. Supports Brandon, Eric, BJ, and Eli profiles.",
    examples: [
      "https://www.idealist.org/en/nonprofit-job/... (paste URL)",
      "Paste job description and say 'Brandon' to generate his cover letter",
      "Apply as Eric for this Development Director role",
      "Generate a GMG Flip proposal for this organization"
    ]
  },
  brainstorm: {
    dialogue: [
      { speaker: 'claudette', text: "Brainstorm turns meeting chaos into organized action. Upload an Otter.ai transcript or paste your notes and I'll pull out strategic updates, action items, client notes, and follow-up tasks." },
      { speaker: 'chanet', text: "I categorize everything automatically. Client updates go in one section, business development in another, personal tasks separate. No more digging through 45 minutes of transcript to find that one thing Brandon said." }
    ],
    purpose: "Process meeting transcripts and brainstorming sessions into organized outputs. Extracts action items, strategic updates, client notes, and categorized tasks.",
    examples: [
      "Upload your Otter.ai transcript from today's call",
      "Paste meeting notes and we'll extract action items",
      "Process this recording transcript into a summary",
      "Turn these scattered notes into a strategic plan update"
    ]
  },
  knowledge: {
    dialogue: [
      { speaker: 'chanet', text: "Knowledge is GMG's shared brain. Add client updates, contact info, meeting notes, or strategic insights and the whole team can search it in Ask GMG. Everything syncs in real-time." },
      { speaker: 'claudette', text: "Just type a title, then a pipe symbol, then the content. Like 'Cure GM1 | Sarah is the main contact, she prefers Tuesday calls.' It's immediately searchable by everyone." }
    ],
    purpose: "Add information to GMG's live knowledge base. Format: 'Title | Content'. Everything is searchable by the whole team in real-time.",
    examples: [
      "Cure GM1 | Contact is Sarah, email is sarah@curegm1.org, prefers Tuesday calls",
      "KOPP Foundation | Board meeting moved to January, budget discussion pending",
      "Strategy | Monthly giving converts at 3x rate of one-time asks",
      "MCW Global | Khalid confirmed Q1 expansion plans"
    ]
  }
};

// Get a random example prompt for a tab
const getRandomExample = (tab) => {
  const tabIntro = TAB_INTROS[tab];
  if (!tabIntro || !tabIntro.examples) return '';
  return tabIntro.examples[Math.floor(Math.random() * tabIntro.examples.length)];
};

// ============================================
// SECTION 7.5: V26 CLIENT PROFILES DATABASE
// ============================================

const CLIENT_PROFILES = [
 // === BRANDON'S EBC CLIENTS ===
 {
 id: 'bdif',
 name: 'Brian Dawkins Impact Foundation',
 status: 'Active Pillar Client',
 since: 'November 2025',
 gmgLead: 'Brandon',
 type: 'EBC',
 rate: '$7,000/month',
 contacts: [
 { name: 'Brian Dawkins', role: 'Founder (NFL Hall of Famer)' }
 ],
 focus: 'Mental wellness and youth empowerment',
 engagement: 'Chief Development Officer / Fractional ED',
 notes: 'Flagship pillar client. Leadership Council development underway.'
 },
 {
 id: 'mcw',
 name: 'MCW Global',
 status: 'Active Client',
 since: 'November 2025',
 gmgLead: 'Brandon',
 type: 'EBC',
 rate: '$3,000/month',
 contacts: [
 { name: 'Khalid Elachi', role: 'Executive Director' },
 { name: 'Sharon Matongo', role: 'Development Associate (Tanzania)' },
 { name: 'Regina Leichner', role: 'Director of Strategy and Impact' },
 { name: 'Bethany', role: 'Development Assistant' },
 { name: 'Eddie', role: 'Communications' }
 ],
 focus: 'International youth leadership development (NYC HQ, Rwanda, Tanzania, Zambia affiliates)',
 engagement: 'Part-time Development Director',
 notes: 'Contract ending Dec 31 2025, pitching GMG transition. Tic-Tac-Toe donor model in action.'
 },
 {
 id: 'nonprofitvote',
 name: 'Nonprofit Vote',
 status: 'Active Client',
 since: '2025',
 gmgLead: 'Brandon',
 type: 'EBC',
 rate: '$3,500/month',
 contacts: [
 { name: 'Brian Miller', role: 'Executive Director' },
 { name: 'Gwen', role: 'Development' }
 ],
 focus: 'Nonpartisan voter engagement through nonprofits',
 engagement: 'Fundraising strategy and monthly giving',
 notes: 'Discussed monthly giving strategy and board cultivation.'
 },
 // === ERIC'S EBC CLIENTS ===
 {
 id: 'cfa',
 name: 'CFA',
 status: 'Active Client',
 since: '2025',
 gmgLead: 'Eric',
 type: 'EBC',
 contacts: [
 { name: 'Jake', role: 'Primary Contact' }
 ],
 focus: 'TBD',
 engagement: 'Development consulting',
 notes: 'Part of Eric EBC portfolio.'
 },
 {
 id: 'solveme',
 name: 'Solve ME/CFS Initiative',
 status: 'Active Client',
 since: '2025',
 gmgLead: 'Eric',
 type: 'EBC',
 contacts: [
 { name: 'Kristen Jacobson', role: 'President and CEO' }
 ],
 focus: 'ME/CFS and Long Covid research funding',
 engagement: 'Development strategy',
 notes: 'Largest US funder of ME/CFS research. You+ME Registry biobank.'
 },
 {
 id: 'justzero',
 name: 'Just Zero',
 status: 'Active Client',
 since: '2025',
 gmgLead: 'Eric',
 type: 'EBC',
 contacts: [
 { name: 'Kirstie Pecci', role: 'Executive Director' },
 { name: 'Kevin Budris', role: 'Senior Counsel' }
 ],
 focus: 'Zero waste and environmental justice',
 engagement: 'Development support',
 notes: 'Founded 2022, national advocacy org.'
 },
 {
 id: 'hcc',
 name: 'HCC',
 status: 'Active Client',
 since: '2025',
 gmgLead: 'Eric',
 type: 'EBC',
 contacts: [],
 focus: 'TBD',
 engagement: 'Full-time role',
 notes: 'Part of Eric EBC portfolio.'
 },
 // === GMG TRANSITORY CLIENTS ===
 {
 id: 'kopp',
 name: 'KOPP Foundation for Diabetes',
 status: 'Active Transitory Client',
 since: 'October 2025',
 gmgLead: 'Brandon',
 type: 'Transitory',
 rate: '$25/hour',
 contacts: [
 { name: 'Max Kopp', role: 'Founder and President' },
 { name: 'Sabrina', role: 'Board Chair (acts like ED)' },
 { name: 'Rachel', role: 'Grants Manager' },
 { name: 'Shandon', role: 'College Chapter Coordinator' }
 ],
 focus: 'Type 1 diabetes research and college chapters',
 engagement: 'Data Science Development Plan, grant pipeline',
 notes: '$300K revenue target. World Diabetes Day Virtual 5K.'
 },
 {
 id: 'gff',
 name: 'Global Fund for Girls',
 abbrev: 'GFF',
 status: 'Active Transitory Client',
 since: '2025',
 gmgLead: 'GMG',
 type: 'Transitory - Commission',
 rate: '5% commission',
 contacts: [
 { name: 'Tammea', role: 'Board Chair' },
 { name: 'Sean', role: 'Grant Writer' }
 ],
 focus: 'International girls rights and empowerment',
 engagement: 'Volunteer commission-based fundraising',
 notes: 'Performance-based fee model.'
 },
 // === GMG PROSPECTS (NOT CLIENTS YET) ===
 {
 id: 'flowersffuture',
 name: 'Flowers for the Future Foundation',
 status: 'PROSPECT',
 since: 'Pitch Nov 2025',
 gmgLead: 'Eric',
 type: 'Prospect',
 contacts: [
 { name: 'Trey Flowers', role: 'Founder (NFL Player)' },
 { name: 'Chelsea Phillips', role: 'Publicist/PR (inside connect)' },
 { name: 'Doug', role: 'Business Manager' },
 { name: 'Miss Jackie', role: 'Trey Mom' }
 ],
 focus: 'Youth empowerment, mental health, financial literacy in Huntsville AL',
 engagement: 'Awaiting decision on $1,500/month proposal',
 notes: 'Eric leading through sports division. Chelsea is key inside connect.'
 },
 {
 id: 'curegm1',
 name: 'Cure GM1 Foundation',
 status: 'PROSPECT',
 since: 'Proposal Stage',
 gmgLead: 'GMG',
 type: 'Prospect - Transitory',
 contacts: [
 { name: 'Christine Waggoner', role: 'Executive Director' }
 ],
 focus: 'GM1 gangliosidosis rare disease research',
 engagement: 'Board proposal in development',
 notes: 'NOT A CLIENT YET. Prospect transitory.'
 },
 {
 id: 'ccof',
 name: 'CCOF Foundation',
 status: 'PROSPECT',
 since: 'Proposal Stage',
 gmgLead: 'GMG',
 type: 'Prospect - Transitory',
 contacts: [
 { name: 'Willow Array Dod', role: 'TBD' },
 { name: 'Kelly D', role: 'CEO' }
 ],
 focus: 'Organic certification and sustainable agriculture',
 engagement: 'Proposal in development',
 notes: 'NOT A CLIENT YET. Prospect transitory.'
 },
 {
 id: '514',
 name: '514 Memorial Foundation',
 status: 'PROSPECT - NOT A CLIENT',
 since: 'RFP Submitted Nov 2025',
 gmgLead: 'GMG',
 type: 'Prospect',
 contacts: [
 { name: 'Chad', role: 'Primary Contact (Friday 4pm calls)' },
 { name: 'Rev. Mark Blue', role: 'Contact' }
 ],
 focus: '$15M Buffalo memorial honoring May 14, 2022 Tops shooting victims',
 engagement: 'Grant writing services RFP response',
 notes: 'NOT A CLIENT. Competitive RFP in review. Brandon has Buffalo family connection.'
 },
 // === PAST CLIENTS / REFERENCES ===
 {
 id: 'homefree',
 name: 'HomeFree-USA',
 status: 'Past Client - Reference',
 since: '2022-2024',
 gmgLead: 'Brandon',
 type: 'Past EBC',
 contacts: [
 { name: 'Chris Thompson', role: 'SVP Chief Growth Officer (Reference)' }
 ],
 focus: 'Homeownership for communities of color',
 engagement: 'VP of Development and Operations - $15M annual revenue',
 notes: 'Brandon reference. Capital campaign and revenue strategy.'
 },
 {
 id: 'dreamcenter',
 name: 'Dream Center of Forsyth County',
 status: 'Past Client - Board',
 since: '2021-2023',
 gmgLead: 'Brandon',
 type: 'Past - Board',
 contacts: [],
 focus: 'Homeless services and community support',
 engagement: 'Development Consultant, Board Treasurer',
 notes: 'Brandon serves as Treasurer. Created CRM solution, 40% efficiency gain.'
 },
 {
 id: 'taiko',
 name: 'Taiko Community Alliance',
 status: 'Past Client',
 since: '2023-2024',
 gmgLead: 'Brandon',
 type: 'Past EBC',
 contacts: [],
 focus: 'Japanese drumming arts and cultural preservation',
 engagement: 'Grant strategy and annual fundraising',
 notes: 'Cultural preservation grants. Social justice storytelling.'
 },
 {
 id: 'lee',
 name: 'Liberty Economic Empowerment (LEE)',
 status: 'Past Client',
 since: 'Past',
 gmgLead: 'GMG',
 type: 'Past',
 contacts: [
 { name: 'Damien', role: 'Contact' }
 ],
 focus: 'Economic empowerment',
 engagement: 'Development consulting',
 notes: 'Past client.'
 },
 {
 id: 'edfuel',
 name: 'EdFuel',
 status: 'Past Client',
 since: 'Past',
 gmgLead: 'GMG',
 type: 'Past',
 contacts: [],
 focus: 'Education sector',
 engagement: 'Development consulting',
 notes: 'Past client.'
 }
];

// Generate intelligent issue summary for AI Check popup
// tierBoost: adds to sessionCount to start at higher tier (AI Check starts at Tier 2)
const generateIssueSummary = (issues, sessionCount, tierBoost = 0) => {
 const effectiveCount = sessionCount + tierBoost;
 
 // If no issues, generate a positive summary
 if (issues.length === 0) {
 if (effectiveCount >= 35) {
 const positives = [
 "No em dashes. No AI phrases. No cringe endings. Honestly? I'm impressed. Maybe there's hope for you yet. ",
 "Zero issues detected! I checked three times because I didn't believe it. You've learned well! ",
 "Clean as a whistle! No 'furthermore,' no 'I'd be happy to,' no robot speak. You're officially my favorite! "
 ];
 return positives[Math.floor(Math.random() * positives.length)];
 } else if (effectiveCount >= 15) {
 const positives = [
 "No em dashes detected! No AI phrases either. You're really getting the hang of this. ",
 "Clean scan! Warm tone, natural flow, simple closing. This is what we like to see! ",
 "Everything checks out! No issues found. You're making our job easy today! "
 ];
 return positives[Math.floor(Math.random() * positives.length)];
 } else {
 return null; // Tier 1 just uses the standard message
 }
 }
 
 // Categorize issues
 const emDashCount = issues.filter(i => i.type === 'Em Dash').length;
 const ctaCount = issues.filter(i => i.type === 'CTA Ending').length;
 const aiPhraseCount = issues.filter(i => i.type === 'AI Phrase').length;
 const factCount = issues.filter(i => i.type === 'Fact Check Error').length;
 const redundancyCount = issues.filter(i => i.type === 'Redundancy' || i.type === 'Multiple Thanks' || i.type === 'Excessive Gratitude').length;
 const structureCount = issues.filter(i => i.type === 'Parallel Structure').length;
 
 // Build summary parts based on what was found
 const parts = [];
 
 if (emDashCount > 0) {
 if (effectiveCount >= 35) {
 parts.push(emDashCount === 1 
 ? "ONE em dash. Just one. But one is too many. Fire-able offense, remember?"
 : `${emDashCount} em dashes. SERIOUSLY? At this point I think you're doing it on purpose.`);
 } else if (effectiveCount >= 15) {
 parts.push(emDashCount === 1 
 ? "Found an em dash. You know how Brandon feels about those..."
 : `${emDashCount} em dashes detected. We've talked about this.`);
 } else {
 parts.push(emDashCount === 1 
 ? "One em dash found - that's a no-go."
 : `${emDashCount} em dashes - these need to be replaced with commas or periods.`);
 }
 }
 
 if (ctaCount > 0) {
 if (effectiveCount >= 35) {
 parts.push("Call-to-action ending? 'Let me know if you have questions'? That's the most AI thing I've ever seen.");
 } else if (effectiveCount >= 15) {
 parts.push("CTA ending detected. So obvious it's AI-generated.");
 } else {
 parts.push("Found a call-to-action ending - we remove these for a cleaner close.");
 }
 }
 
 if (aiPhraseCount > 0) {
 const phrases = issues.filter(i => i.type === 'AI Phrase').map(i => `"${i.original}"`).slice(0, 3);
 if (effectiveCount >= 35) {
 parts.push(`AI phrases like ${phrases.join(', ')}... This is giving ChatGPT energy. Did a robot write this?`);
 } else if (effectiveCount >= 15) {
 parts.push(`${aiPhraseCount} AI phrase${aiPhraseCount > 1 ? 's' : ''}: ${phrases.join(', ')} - dead giveaways.`);
 } else {
 parts.push(`${aiPhraseCount} AI phrase${aiPhraseCount > 1 ? 's' : ''} detected - we'll rewrite these.`);
 }
 }
 
 if (redundancyCount > 0) {
 if (effectiveCount >= 35) {
 parts.push("Multiple ways of saying the same thing. 'Thank you, I appreciate it, I'm grateful, means a lot' - PICK ONE. This is the #1 AI tell.");
 } else if (effectiveCount >= 15) {
 parts.push("Redundancy alert - you said the same sentiment multiple ways. Classic AI tell.");
 } else {
 parts.push("Redundant phrasing found - we streamlined it to one expression per sentiment.");
 }
 }
 
 if (factCount > 0) {
 if (effectiveCount >= 35) {
 parts.push(`${factCount} fact-check issue${factCount > 1 ? 's' : ''} - you got titles or info WRONG about GMG people. Eli is the Lane-Pierce Fellow, NOT a founder!`);
 } else {
 parts.push(`${factCount} fact-check issue${factCount > 1 ? 's' : ''} - incorrect titles or information about GMG people.`);
 }
 }
 
 if (structureCount > 0) {
 if (effectiveCount >= 35) {
 parts.push("Same sentence structure repeated over and over. Robot behavior detected.");
 } else {
 parts.push("Parallel structure issue - we varied the sentence patterns.");
 }
 }
 
 return parts.join(' ');
};

// Delivery messages for popup (based on result type and issue count)
const DELIVERY_MESSAGES = {
 // AI Check - Pass (0 issues) - Sweet Chanet Tier 2
 checkPass: {
 speaker: 'chanet',
 name: 'Chanet',
 title: 'Virtual Admin',
 avatar: IMAGES.chanet,
 messages: [
 "Perfect! Zero issues found. Brandon would be proud... and honestly, so am I. You did great! ",
 "Flawless work! No em dashes, no AI phrases, no cringe endings. I knew you had it in you! ",
 "Not a single issue detected. You're really getting the hang of this. Gold star for you! ",
 "Clean scan! This is exactly the kind of writing Brandon wants to see. You're making us look good! "
 ]
 },
 // AI Check - Minor Issues (1-2 issues) - Encouraging Chanet
 checkMinor: {
 speaker: 'chanet',
 name: 'Chanet',
 title: 'Virtual Admin',
 avatar: IMAGES.chanet,
 messages: [
 "Almost perfect! Just a tiny thing or two to fix. You're so close! ",
 "Really good work! I only found a couple small things. Easy fixes! ",
 "This is pretty clean! Just minor tweaks needed. You've got this! ",
 "Nice job! A few small adjustments and this is ready to go. Almost there! "
 ]
 },
 // AI Check - Moderate Issues (3-5) - Snippy Claudette Tier 2
 checkModerate: {
 speaker: 'claudette',
 name: 'Claudette',
 title: 'Senior Virtual Admin',
 avatar: IMAGES.claudette,
 messages: [
 "Found some issues. Shocking absolutely no one.",
 "Okay so... this needs work. Several things Brandon would flag immediately.",
 "Let me guess - you used ChatGPT first? I can always tell.",
 "A few problems here. Nothing I can't fix, but still. Come on."
 ]
 },
 // AI Check - Major Issues (6+) - Roast Mode Claudette Tier 3
 checkMajor: {
 speaker: 'claudette',
 name: 'Claudette',
 title: 'Senior Virtual Admin',
 avatar: IMAGES.claudette,
 messages: [
 "Wow. This is... this is a lot. Did a robot write this? Actually, don't answer that.",
 "I found SO many issues. We're basically doing a full rewrite here. You're welcome.",
 "This is giving major AI energy. Em dashes, redundant thank yous, the whole disaster package.",
 "Oh no. This is bad. Like, really bad. Just... just use the corrected version, okay?"
 ]
 },
 // Create - Complex/Long work - Claudette
 createComplex: {
 speaker: 'claudette',
 name: 'Claudette',
 title: 'Senior Virtual Admin',
 avatar: IMAGES.claudette,
 messages: [
 "That was a substantial request. Here's your content, fully GMG-compliant.",
 "Finished with that big one. Everything meets Brandon's standards.",
 "Done. This one required some effort, but it's solid work.",
 "Your detailed content is ready. I checked it twice. Obviously."
 ]
 },
 // Create - Quick/Short work - Chanet
 createQuick: {
 speaker: 'chanet',
 name: 'Chanet',
 title: 'Virtual Admin',
 avatar: IMAGES.chanet,
 messages: [
 "Quick one! Here you go, all ready! ",
 "Done! That was fun to write! Take a look! ",
 "Here's your content, warm and professional! Just like Brandon likes it! ",
 "All set! This is going to be great. Check it out!"
 ]
 },
 // Ask/Search - Complex/Long answer - Claudette
 askComplex: {
 speaker: 'claudette',
 name: 'Claudette',
 title: 'Senior Virtual Admin',
 avatar: IMAGES.claudette,
 messages: [
 "Found what you need. Here's the comprehensive breakdown.",
 "Detailed answer ready. I pulled everything relevant together.",
 "Here's the full picture. Thorough, as always.",
 "Complete answer compiled. This covers all the bases."
 ]
 },
 // Ask/Search - Quick/Short answer - Chanet
 askQuick: {
 speaker: 'chanet',
 name: 'Chanet',
 title: 'Virtual Admin',
 avatar: IMAGES.chanet,
 messages: [
 "Found it! Here you go! ",
 "Quick answer for you! Easy one! ",
 "Here's what you need! Glad I could help! ",
 "Got it! Check this out!"
 ]
 }
};

// Get appropriate delivery based on issue count
const getCheckDelivery = (issueCount) => {
 if (issueCount === 0) return DELIVERY_MESSAGES.checkPass;
 if (issueCount <= 2) return DELIVERY_MESSAGES.checkMinor;
 if (issueCount <= 5) return DELIVERY_MESSAGES.checkModerate;
 return DELIVERY_MESSAGES.checkMajor;
};

// Helper to get random message
const getRandomMessage = (messages) => messages[Math.floor(Math.random() * messages.length)];

// ============================================
// SECTION 8.5: V25 HELPER FUNCTIONS
// ============================================

// Word count helper
const getWordCount = (text) => {
 if (!text || !text.trim()) return 0;
 return text.trim().split(/\s+/).length;
};

// Export content as Word document (.docx compatible)
const exportAsDocx = (content, filename) => {
 // Create HTML that Word can open (simple but effective approach)
 const htmlContent = `
<!DOCTYPE html>
<html xmlns:o="urn:schemas-microsoft-com:office:office" 
 xmlns:w="urn:schemas-microsoft-com:office:word" 
 xmlns="http://www.w3.org/TR/REC-html40">
<head>
 <meta charset="utf-8">
 <title>GMG Document</title>
 <style>
 body { 
 font-family: Calibri, Arial, sans-serif; 
 font-size: 11pt; 
 line-height: 1.5;
 margin: 1in;
 }
 p { margin-bottom: 12pt; }
 </style>
</head>
<body>
${content.split('\n').map(line => `<p>${line || '&nbsp;'}</p>`).join('\n')}
</body>
</html>`;
 
 const blob = new Blob([htmlContent], { 
 type: 'application/vnd.ms-word;charset=utf-8' 
 });
 const url = URL.createObjectURL(blob);
 const link = document.createElement('a');
 link.href = url;
 link.download = (filename || `gmg-content-${Date.now()}`) + '.docx';
 document.body.appendChild(link);
 link.click();
 document.body.removeChild(link);
 URL.revokeObjectURL(url);
};

// V27: Generate styled PDF for cover letters (opens in new window for printing)
const generateStyledPDF = (content, applicantProfile, jobData) => {
 const name = applicantProfile?.name || 'Applicant';
 const email = applicantProfile?.email || '';
 const phone = applicantProfile?.phone || '';
 const location = applicantProfile?.location || '';
 
 // Generate filename: FirstName.LastName.CoverLetter.OrgFirstWord
 const nameParts = name.split(' ');
 const firstName = nameParts[0] || 'Applicant';
 const lastName = nameParts.length > 1 ? nameParts[nameParts.length - 1].replace(/[.,;:]+$/, '') : 'Unknown';
 const orgName = jobData?.organization || 'Organization';
 const orgFirstWord = orgName.split(/\s+/)[0].replace(/[^a-zA-Z0-9]/g, '');
 const filename = `${firstName}.${lastName}.CoverLetter.${orgFirstWord}`;
 
 const htmlContent = `
<!DOCTYPE html>
<html>
<head>
 <meta charset="utf-8">
 <title>Cover Letter - ${name}</title>
 <style>
 @page {
 size: letter;
 margin: 0.5in;
 }
 * {
 margin: 0;
 padding: 0;
 box-sizing: border-box;
 }
 body {
 font-family: 'Georgia', 'Times New Roman', serif;
 font-size: 12pt;
 line-height: 1.6;
 color: #000;
 width: 100%;
 max-width: 8.5in;
 min-height: 11in;
 margin: 0 auto;
 padding: 0.5in;
 background: white;
 }
 .letter-container {
 border: 2px solid #B87333;
 padding: 0.5in;
 min-height: calc(11in - 1in);
 display: flex;
 flex-direction: column;
 }
 .header {
 text-align: center;
 margin-bottom: 24px;
 padding-bottom: 16px;
 border-bottom: 3px solid #191970;
 }
 .header-name {
 font-size: 20pt;
 font-weight: bold;
 color: #191970;
 margin-bottom: 6px;
 letter-spacing: 1px;
 }
 .header-contact {
 font-size: 11pt;
 color: #404040;
 }
 .date {
 text-align: left;
 margin: 20px 0;
 font-size: 12pt;
 }
 .content {
 text-align: left;
 flex: 1;
 }
 .content p {
 margin-bottom: 14pt;
 text-align: left;
 text-indent: 0;
 }
 .content p:first-child {
 margin-top: 0;
 }
 @media print {
 body {
 padding: 0;
 }
 .no-print {
 display: none !important;
 }
 .letter-container {
 border: 2px solid #B87333;
 min-height: auto;
 }
 }
 @media screen {
 .no-print {
 background: #191970;
 color: white;
 padding: 12px 20px;
 text-align: center;
 margin-bottom: 20px;
 border-radius: 4px;
 font-family: Arial, sans-serif;
 }
 }
 </style>
</head>
<body>
 <div class="no-print">
 <strong>GMG Cover Letter</strong> | Press Ctrl+P (or Cmd+P) to print/save as PDF
 </div>
 <div class="letter-container">
 <div class="header">
 <div class="header-name">${name.toUpperCase()}</div>
 <div class="header-contact">${[location, phone, email].filter(Boolean).join(' | ')}</div>
 </div>
 <div class="date">${new Date().toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}</div>
 <div class="content">
 ${content.split('\n').map(line => 
 line.trim() ? `<p>${line}</p>` : ''
 ).join('')}
 </div>
 </div>
</body>
</html>`;
 
 // Open in new window for printing, with fallback for popup blockers
 try {
 const printWindow = window.open('', '_blank');
 if (printWindow) {
 printWindow.document.write(htmlContent);
 printWindow.document.close();
 } else {
 // Popup blocked - create downloadable HTML file
 const blob = new Blob([htmlContent], { type: 'text/html' });
 const url = URL.createObjectURL(blob);
 const a = document.createElement('a');
 a.href = url;
 a.download = `${filename}.html`;
 document.body.appendChild(a);
 a.click();
 document.body.removeChild(a);
 URL.revokeObjectURL(url);
 }
 } catch (e) {
 // Fallback: create downloadable HTML file
 const blob = new Blob([htmlContent], { type: 'text/html' });
 const url = URL.createObjectURL(blob);
 const a = document.createElement('a');
 a.href = url;
 a.download = `${filename}.html`;
 document.body.appendChild(a);
 a.click();
 document.body.removeChild(a);
 URL.revokeObjectURL(url);
 }
};

// Play completion sound (subtle ding)
const playCompletionSound = (enabled) => {
 if (!enabled) return;
 try {
 const audioContext = new (window.AudioContext || window.webkitAudioContext)();
 const oscillator = audioContext.createOscillator();
 const gainNode = audioContext.createGain();
 oscillator.connect(gainNode);
 gainNode.connect(audioContext.destination);
 oscillator.frequency.value = 880; // A5 note
 oscillator.type = 'sine';
 gainNode.gain.setValueAtTime(0.1, audioContext.currentTime);
 gainNode.gain.exponentialRampToValueAtTime(0.01, audioContext.currentTime + 0.2);
 oscillator.start(audioContext.currentTime);
 oscillator.stop(audioContext.currentTime + 0.2);
 } catch (e) {
 // Audio not available - silently fail
 }
};

// History log management
const HISTORY_KEY = 'gmg_assistant_history';
const SESSION_KEY = 'gmg_assistant_session';
const MAX_HISTORY = 20;

// V3.1: Load history - tries Firebase first, falls back to localStorage for guests
const loadHistory = () => {
 try {
 const stored = localStorage.getItem(HISTORY_KEY);
 return stored ? JSON.parse(stored) : [];
 } catch (e) {
 return [];
 }
};

// V3.1: Save history - saves to Firebase for logged-in users, localStorage for guests
const saveHistory = (history, userId = null) => {
 try {
 // Always save to localStorage as backup
 localStorage.setItem(HISTORY_KEY, JSON.stringify(history.slice(0, MAX_HISTORY)));
 
 // V3.1: If user is logged in, also save to Firebase
 if (userId && typeof saveToHistory === 'function') {
 saveToHistory(userId, 'history', { entries: history.slice(0, MAX_HISTORY) })
 .catch(err => devLog('Firebase sync skipped:', err));
 }
 } catch (e) {
 // Storage not available
 }
};

// V3.1: Load history from Firebase for logged-in user
const loadFirebaseHistory = async (userId) => {
 try {
 if (userId && typeof getHistory === 'function') {
 const results = await getHistory(userId, 'history', 1);
 if (results && results.length > 0 && results[0].data?.entries) {
 return results[0].data.entries;
 }
 }
 return loadHistory(); // Fall back to localStorage
 } catch (e) {
 return loadHistory();
 }
};

const addHistoryEntry = (history, type, input, output) => {
 const entry = {
 id: Date.now(),
 timestamp: new Date().toLocaleString(),
 type: type,
 preview: input.substring(0, 80) + (input.length > 80 ? '...' : ''),
 outputPreview: output.substring(0, 100) + (output.length > 100 ? '...' : ''),
 fullInput: input,
 fullOutput: output
 };
 return [entry, ...history].slice(0, MAX_HISTORY);
};

// Session count persistence (halves on refresh, uses Firebase when logged in)
const loadSessionCount = () => {
 try {
 const stored = localStorage.getItem(SESSION_KEY);
 if (stored) {
 const parsed = parseInt(stored, 10);
 // Return half the stored value (minimum 0)
 return Math.max(0, Math.floor(parsed / 2));
 }
 return 0;
 } catch (e) {
 return 0;
 }
};

const saveSessionCount = (count) => {
 try {
 localStorage.setItem(SESSION_KEY, count.toString());
 } catch (e) {
 // LocalStorage not available
 }
};

// V3.5: Firebase-aware session count loading (async, for use in component)
const loadSessionCountFromFirebase = async (userId) => {
 if (!userId) return loadSessionCount();
 try {
 const tierData = await getTierLevel(userId);
 if (tierData.reset) {
 // 24+ hours of inactivity, reset tier
 devLog('Tier reset due to inactivity');
 return 0;
 }
 return tierData.sessionCount || loadSessionCount();
 } catch (e) {
 return loadSessionCount();
 }
};

// V3.5: Save to Firebase when user is logged in
const saveSessionCountToFirebase = async (userId, count) => {
 saveSessionCount(count); // Always save to localStorage as backup
 if (!userId) return;
 try {
 await saveTierLevel(userId, count, new Date().toISOString());
 } catch (e) {
 devError('Failed to save tier to Firebase:', e);
 }
};

// Bulk check - split content by --- separator
const detectBulkMode = (text) => {
 return text.includes('---') && text.split('---').filter(s => s.trim()).length > 1;
};

const splitBulkContent = (text) => {
 return text.split('---').map(s => s.trim()).filter(s => s.length > 0);
};

// Simple diff generator for comparison view
const generateSimpleDiff = (original, corrected) => {
 // Split into sentences for comparison
 const origSentences = original.split(/(?<=[.!?])\s+/);
 const corrSentences = corrected.split(/(?<=[.!?])\s+/);
 
 const diff = [];
 const maxLen = Math.max(origSentences.length, corrSentences.length);
 
 for (let i = 0; i < maxLen; i++) {
 const orig = origSentences[i] || '';
 const corr = corrSentences[i] || '';
 
 if (orig === corr) {
 diff.push({ type: 'same', text: orig });
 } else if (!orig && corr) {
 diff.push({ type: 'added', text: corr });
 } else if (orig && !corr) {
 diff.push({ type: 'removed', text: orig });
 } else {
 diff.push({ type: 'removed', text: orig });
 diff.push({ type: 'added', text: corr });
 }
 }
 
 return diff;
};

// ============================================
// SECTION 8.6: V26 HELPER FUNCTIONS
// ============================================

// Analytics storage
const ANALYTICS_KEY = 'gmg_analytics';
const CORRECTIONS_KEY = 'gmg_learned_corrections';

// Load analytics from localStorage
const loadAnalytics = () => {
 try {
 const stored = localStorage.getItem(ANALYTICS_KEY);
 return stored ? JSON.parse(stored) : {
 totalCreates: 0,
 totalChecks: 0,
 totalAsks: 0,
 checksWithIssues: 0,
 totalIssuesFound: 0,
 issuesByType: {},
 dailyStats: {},
 firstUse: new Date().toISOString()
 };
 } catch (e) {
 return { totalCreates: 0, totalChecks: 0, totalAsks: 0, checksWithIssues: 0, totalIssuesFound: 0, issuesByType: {}, dailyStats: {}, firstUse: new Date().toISOString() };
 }
};

// Save analytics to localStorage
const saveAnalytics = (analytics) => {
 try {
 localStorage.setItem(ANALYTICS_KEY, JSON.stringify(analytics));
 } catch (e) { devWarn('localStorage save failed:', e); }
};

// Load learned corrections
const loadLearnedCorrections = () => {
 try {
 const stored = localStorage.getItem(CORRECTIONS_KEY);
 return stored ? JSON.parse(stored) : [];
 } catch (e) {
 return [];
 }
};

// Save learned corrections
const saveLearnedCorrections = (corrections) => {
 try {
 localStorage.setItem(CORRECTIONS_KEY, JSON.stringify(corrections.slice(0, 50)));
 } catch (e) { devWarn('localStorage save failed:', e); }
};

// Extract pattern from edit
const extractEditPattern = (original, edited) => {
 const words1 = original.split(' ');
 const words2 = edited.split(' ');
 
 for (let i = 0; i < Math.min(words1.length, words2.length); i++) {
 if (words1[i] !== words2[i]) {
 return {
 type: 'word_replacement',
 from: words1[i],
 to: words2[i]
 };
 }
 }
 return { type: 'general_edit' };
};

// V31.5: COMPREHENSIVE SMART SUGGESTIONS SYSTEM
// Click-to-add suggestions based on context and client database

const SMART_SUGGESTIONS = {
 // Client-specific quick inserts
 clients: {
 'kopp': [
 { label: 'Max Kopp (President)', insert: 'Max Kopp, Founder and President of KOPP Foundation for Diabetes' },
 { label: 'Sabrina (Board)', insert: 'Sabrina, Board Chair' },
 { label: 'World Diabetes Day', insert: 'World Diabetes Day Virtual 5K fundraiser' },
 { label: 'Revenue Target', insert: '$300,000 annual revenue target across 5 streams' },
 { label: 'College Chapters', insert: 'college chapter expansion program for Type 1 diabetes awareness' }
 ],
 'bdif': [
 { label: 'Brian Dawkins', insert: 'Brian Dawkins, NFL Hall of Fame safety and founder' },
 { label: 'Mental Wellness', insert: 'mental wellness and youth empowerment' },
 { label: 'Leadership Council', insert: 'Leadership Council development initiative' },
 { label: 'Rate', insert: '$7,000 monthly pillar engagement' }
 ],
 'mcw': [
 { label: 'Khalid Elachi', insert: 'Khalid Elachi, Executive Director' },
 { label: 'Regina Leichner', insert: 'Regina Leichner, Director of Strategy and Impact' },
 { label: 'Sharon Matongo', insert: 'Sharon Matongo, Development Associate' },
 { label: 'Tic-Tac-Toe', insert: 'Tic-Tac-Toe donor engagement model (3:1 value-to-ask ratio)' },
 { label: 'Youth Leadership', insert: 'Global Young Leaders Fellowship program' }
 ],
 'flowers': [
 { label: 'Trey Flowers', insert: 'Trey Flowers, NFL player and founder' },
 { label: 'Chelsea Phillips', insert: 'Chelsea Phillips, Publicist and PR lead' },
 { label: 'Huntsville', insert: 'Huntsville, Alabama community impact' },
 { label: 'Youth Focus', insert: 'youth empowerment, mental health, and financial literacy' }
 ],
 'curegm1': [
 { label: 'Christine Waggoner', insert: 'Christine Waggoner, Executive Director' },
 { label: 'Rare Disease', insert: 'GM1 gangliosidosis rare disease research' },
 { label: 'Board Development', insert: 'board development and strategic consulting' }
 ],
 '514': [
 { label: 'Chad', insert: 'Chad, primary contact (Friday 4pm calls)' },
 { label: 'Buffalo Memorial', insert: '$15 million Buffalo memorial honoring May 14, 2022 victims' },
 { label: 'Grant Writing RFP', insert: 'grant writing services RFP response' }
 ],
 'gff': [
 { label: 'Tammea', insert: 'Tammea, Board Chair' },
 { label: 'Sean', insert: 'Sean, Grant Writer' },
 { label: 'Commission Model', insert: '5% commission-based fundraising partnership' }
 ]
 },
 // GMG methodology quick inserts
 methodologies: [
 { label: 'Grant MRI', insert: 'Grant MRI 30-day comprehensive fundraising audit' },
 { label: 'Data Science Plan', insert: 'Data Science Development Plan with evidence-based projections' },
 { label: 'Prospect Precision', insert: 'Prospect Precision data-driven funder identification' },
 { label: 'Tic-Tac-Toe', insert: 'Tic-Tac-Toe Framework (3:1 value-to-ask ratio)' },
 { label: 'Implementation Engine', insert: 'Implementation Engine execution and capacity building' },
 { label: 'Recipe Pitch', insert: 'Recipe Pitch Framework for elevator pitches' }
 ],
 // GMG stats quick inserts
 stats: [
 { label: '$260M+', insert: '$260 million in philanthropic capital influenced' },
 { label: '32+ Years', insert: '32+ years combined fundraising experience' },
 { label: '65+ Orgs', insert: '65+ organizations served' },
 { label: '25-30% Rate', insert: '25-30% grant success rate (vs 10-15% industry average)' }
 ],
 // Founder quick inserts
 founders: [
 { label: 'Brandon Bio', insert: 'Brandon J. Pierce Sr., Co-Founder with 15+ years experience as Fortune 500 grantmaker who reviewed $195M+ in applications' },
 { label: 'Eric Bio', insert: 'Dr. Eric R. Lane Sr., Co-Founder with 17 years development experience and Ed.D. in Educational Leadership' },
 { label: 'Dual Perspective', insert: 'unique dual perspective as both former grantmakers and active fundraisers' }
 ],
 // Simple closings (no CTA)
 closings: [
 { label: 'Thanks', insert: 'Thanks,' },
 { label: 'Best', insert: 'Best,' },
 { label: 'Warmly', insert: 'Warmly,' },
 { label: 'Talk soon', insert: 'Talk soon,' }
 ]
};

// Generate context-aware suggestions based on input and active tab
const generateSmartSuggestions = (text, activeTab = 'create') => {
 const suggestions = [];
 const lower = text.toLowerCase();
 
 // Detect which client is being discussed
 const clientMatches = Object.keys(SMART_SUGGESTIONS.clients).filter(key => 
 lower.includes(key) || lower.includes(key.replace('bdif', 'dawkins').replace('gff', 'global fund'))
 );
 
 // Add client-specific suggestions
 clientMatches.forEach(client => {
 SMART_SUGGESTIONS.clients[client].forEach(s => {
 if (!lower.includes(s.insert.toLowerCase().substring(0, 10))) {
 suggestions.push({ ...s, category: 'client' });
 }
 });
 });
 
 // Add methodology suggestions if discussing strategy
 if (lower.includes('strategy') || lower.includes('plan') || lower.includes('approach') || lower.includes('methodology')) {
 SMART_SUGGESTIONS.methodologies.forEach(s => {
 if (!lower.includes(s.label.toLowerCase())) {
 suggestions.push({ ...s, category: 'method' });
 }
 });
 }
 
 // Add stats suggestions if discussing GMG or credibility
 if (lower.includes('gmg') || lower.includes('global majority') || lower.includes('experience') || lower.includes('track record')) {
 SMART_SUGGESTIONS.stats.forEach(s => {
 if (!lower.includes(s.label.replace(/[+$]/g, ''))) {
 suggestions.push({ ...s, category: 'stat' });
 }
 });
 }
 
 // Add founder suggestions if discussing team
 if (lower.includes('brandon') || lower.includes('eric') || lower.includes('team') || lower.includes('founder')) {
 SMART_SUGGESTIONS.founders.forEach(s => {
 if (!lower.includes(s.insert.substring(0, 15).toLowerCase())) {
 suggestions.push({ ...s, category: 'founder' });
 }
 });
 }
 
 // Add closing suggestions if near end of content
 if (lower.includes('thank') || lower.includes('sincerely') || lower.length > 500) {
 SMART_SUGGESTIONS.closings.forEach(s => {
 suggestions.push({ ...s, category: 'closing' });
 });
 }
 
 // Return top suggestions (limit to prevent overwhelming)
 return suggestions.slice(0, 8);
};

// Voice transcript auto-punctuation cleanup
const cleanupVoiceTranscript = (text) => {
 let cleaned = text;
 
 // Capitalize first letter of sentences
 cleaned = cleaned.replace(/(^|[.!?]\s+)([a-z])/g, (match, p1, p2) => p1 + p2.toUpperCase());
 
 // Add periods at end of sentences that lack them
 cleaned = cleaned.replace(/([a-z])(\s+[A-Z])/g, '$1.$2');
 
 // Fix common speech-to-text issues
 cleaned = cleaned.replace(/\bi\b/g, 'I');
 cleaned = cleaned.replace(/gonna/gi, 'going to');
 cleaned = cleaned.replace(/wanna/gi, 'want to');
 cleaned = cleaned.replace(/kinda/gi, 'kind of');
 cleaned = cleaned.replace(/\bum+\b/gi, '');
 cleaned = cleaned.replace(/\buh+\b/gi, '');
 cleaned = cleaned.replace(/\s+/g, ' ').trim();
 
 // Ensure ends with punctuation
 if (cleaned && !/[.!?]$/.test(cleaned)) {
 cleaned += '.';
 }
 
 return cleaned;
};

// Calculate improvement stats for analytics
const calculateImprovementStats = (analytics) => {
 const days = Object.keys(analytics.dailyStats).sort();
 if (days.length < 2) return null;
 
 const recentDays = days.slice(-7);
 const olderDays = days.slice(-14, -7);
 
 const recentAvg = recentDays.reduce((sum, d) => {
 const stat = analytics.dailyStats[d];
 return sum + (stat.checks > 0 ? stat.issues / stat.checks : 0);
 }, 0) / Math.max(recentDays.length, 1);
 
 const olderAvg = olderDays.length > 0 
 ? olderDays.reduce((sum, d) => {
 const stat = analytics.dailyStats[d];
 return sum + (stat.checks > 0 ? stat.issues / stat.checks : 0);
 }, 0) / olderDays.length
 : recentAvg;
 
 const improvement = olderAvg > 0 ? ((olderAvg - recentAvg) / olderAvg * 100) : 0;
 
 return {
 recentAvg: recentAvg.toFixed(1),
 improvement: improvement.toFixed(0)
 };
};

// End of Spurt 2
// ============================================
// SECTION 9: CSS STYLES (V17 aesthetics + V3 track changes)
// ============================================

const styles = `
/* ===== GLOBAL RESET ===== */
* { margin: 0; padding: 0; box-sizing: border-box; }
body { font-family: 'Inter', -apple-system, sans-serif; background: linear-gradient(160deg, #F5F5F7 0%, #E8E8EC 30%, #F0F0F5 60%, #E5E5EA 100%); min-height: 100vh; transition: background 0.3s ease, color 0.3s ease; }

/* V2.13: Subtle animated gradient background */
@keyframes gradientShift {
 0% { background-position: 0% 50%; }
 50% { background-position: 100% 50%; }
 100% { background-position: 0% 50%; }
}

body::before {
 content: '';
 position: fixed;
 top: 0;
 left: 0;
 right: 0;
 bottom: 0;
 background: linear-gradient(135deg, 
 rgba(184, 115, 51, 0.03) 0%, 
 rgba(139, 90, 43, 0.02) 25%, 
 rgba(184, 115, 51, 0.03) 50%, 
 rgba(139, 90, 43, 0.02) 75%, 
 rgba(184, 115, 51, 0.03) 100%);
 background-size: 400% 400%;
 animation: gradientShift 30s ease infinite;
 pointer-events: none;
 z-index: -1;
}

/* ===== V2.4: FLUID STREAM STYLES ===== */
.fluid-stream {
  flex: 1;
  overflow-y: auto;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  background: transparent;
  -webkit-overflow-scrolling: touch;
}

.fluid-message {
  display: flex;
  align-items: flex-end;
  gap: 10px;
  max-width: 85%;
  animation: fadeSlideIn 0.3s ease-out;
}

@keyframes fadeSlideIn {
  from { opacity: 0; transform: translateY(10px); }
  to { opacity: 1; transform: translateY(0); }
}

.fluid-message.user {
  flex-direction: row-reverse;
  align-self: flex-end;
}

.fluid-message.admin {
  flex-direction: row;
  align-self: flex-start;
}

.fluid-message .avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  flex-shrink: 0;
  object-fit: cover;
}

.fluid-message .bubble-wrap {
  max-width: 100%;
}

.fluid-message .speaker-name {
  font-size: 11px;
  font-weight: 600;
  margin-bottom: 4px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.fluid-message .speaker-name.claudette { color: #191970; }
.fluid-message .speaker-name.chanet { color: #B87333; }

.fluid-message .bubble {
  padding: 12px 16px;
  border-radius: 18px;
  font-size: 15px;
  line-height: 1.5;
  word-wrap: break-word;
}

.fluid-message.user .bubble {
  background: linear-gradient(135deg, #8B5CF6, #7C3AED);
  color: white;
  border-bottom-right-radius: 4px;
}

.fluid-message.admin .bubble {
  background: #E5E5EA;
  color: #1d1d1f;
  border-bottom-left-radius: 4px;
}

/* Content cards that flow in stream */
.fluid-content-card {
  background: white;
  border-radius: 16px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.08);
  overflow: hidden;
  max-width: 90%;
  align-self: flex-start;
  margin-left: 42px;
  animation: fadeSlideIn 0.3s ease-out;
}

.fluid-content-card .card-header {
  background: linear-gradient(135deg, #B87333, #D4944A);
  color: white;
  padding: 12px 16px;
  font-weight: 600;
  font-size: 14px;
}

.fluid-content-card .card-body {
  padding: 16px;
  font-size: 14px;
  line-height: 1.6;
  color: #333;
  white-space: pre-wrap;
}

.fluid-content-card .card-actions {
  padding: 12px 16px;
  border-top: 1px solid #E5E5EA;
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.fluid-content-card .card-actions button {
  padding: 8px 16px;
  border-radius: 20px;
  border: none;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}

.fluid-content-card .card-actions button.primary {
  background: linear-gradient(135deg, #8B5CF6, #7C3AED);
  color: white;
}

.fluid-content-card .card-actions button.secondary {
  background: #F0F0F5;
  color: #333;
}

.fluid-content-card .card-actions button:hover {
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(0,0,0,0.15);
}

/* Simple input at bottom */
.fluid-input-area {
  padding: 12px 16px;
  background: white;
  border-top: 1px solid #E5E5EA;
  display: flex;
  gap: 12px;
  align-items: flex-end;
}

.fluid-input-area textarea {
  flex: 1;
  border: 1px solid #E5E5EA;
  border-radius: 20px;
  padding: 12px 16px;
  font-size: 15px;
  font-family: inherit;
  resize: none;
  min-height: 44px;
  max-height: 200px;
  outline: none;
  transition: border-color 0.2s ease, height 0.15s ease;
}

.fluid-input-area textarea:focus {
  border-color: #8B5CF6;
}

.fluid-input-area .send-btn {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  border: none;
  background: linear-gradient(135deg, #8B5CF6, #7C3AED);
  color: white;
  font-size: 18px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.2s ease;
}

.fluid-input-area .send-btn:hover {
  transform: scale(1.05);
}

.fluid-input-area .send-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* Typing indicator */
.typing-dots {
  display: flex;
  gap: 4px;
  padding: 12px 16px;
}

.typing-dots span {
  width: 8px;
  height: 8px;
  background: #999;
  border-radius: 50%;
  animation: typingBounce 1.4s infinite ease-in-out;
}

.typing-dots span:nth-child(1) { animation-delay: 0s; }
.typing-dots span:nth-child(2) { animation-delay: 0.2s; }
.typing-dots span:nth-child(3) { animation-delay: 0.4s; }

@keyframes typingBounce {
  0%, 80%, 100% { transform: translateY(0); }
  40% { transform: translateY(-6px); }
}

/* ===== V3.6: DARK MODE ===== */
body.dark-mode {
 background: linear-gradient(160deg, #0f0f1a 0%, #1a1a2e 50%, #252538 100%);
 color: #E8E8EC;
}

body.dark-mode .fluid-stream {
  background: transparent;
}

body.dark-mode .fluid-message.admin .bubble {
  background: #3a3a4e;
  color: #E8E8EC;
}

body.dark-mode .fluid-content-card {
  background: #252538;
  box-shadow: 0 2px 12px rgba(0,0,0,0.3);
}

body.dark-mode .fluid-content-card .card-body {
  color: #E8E8EC;
}

body.dark-mode .fluid-content-card .card-actions {
  border-color: #3a3a4e;
}

body.dark-mode .fluid-content-card .card-actions button.secondary {
  background: #3a3a4e;
  color: #E8E8EC;
}

body.dark-mode .fluid-input-area {
  background: #1a1a2e;
  border-color: #3a3a4e;
}

body.dark-mode .fluid-input-area textarea {
  background: #252538;
  color: #E8E8EC;
  border-color: #3a3a4e;
}

body.dark-mode .fluid-input-area textarea:focus {
  border-color: #8B5CF6;
}

body.dark-mode .glass {
 background: rgba(26, 26, 46, 0.8);
 border-color: rgba(58, 58, 90, 0.5);
 box-shadow: 0 8px 32px rgba(0, 0, 0, 0.4);
}

body.dark-mode .glass-strong {
 background: rgba(37, 37, 56, 0.9);
 border-color: rgba(58, 58, 90, 0.6);
}

body.dark-mode .unified-chat-container {
 background: rgba(26, 26, 46, 0.95);
 border-color: #3a3a5a;
}

body.dark-mode .unified-message {
 background: #252538;
 color: #E8E8EC;
}

body.dark-mode .unified-message.user {
 background: linear-gradient(135deg, #2a2a5a 0%, #3a3a6a 100%);
}

body.dark-mode .unified-chat-input {
 background: rgba(26, 26, 46, 0.95);
 border-color: #3a3a5a;
}

body.dark-mode .unified-chat-input textarea {
 background: #1a1a2e;
 color: #E8E8EC;
 border-color: #3a3a5a;
}

body.dark-mode .unified-tab {
 background: #252538;
 color: #A0A0B0;
 border-color: #3a3a5a;
}

body.dark-mode .unified-tab.active {
 background: linear-gradient(135deg, #B87333 0%, #D4944A 100%);
 color: white;
}

body.dark-mode .header {
 background: rgba(26, 26, 46, 0.9);
 border-color: #3a3a5a;
}

body.dark-mode .modal-content {
 background: #1a1a2e;
 color: #E8E8EC;
}

body.dark-mode .result-card {
 background: #252538;
 border-color: #3a3a5a;
}

body.dark-mode input,
body.dark-mode textarea,
body.dark-mode select {
 background: #1a1a2e;
 color: #E8E8EC;
 border-color: #3a3a5a;
}

body.dark-mode .toast {
 background: #252538;
 color: #E8E8EC;
 border-color: #3a3a5a;
}

/* Dark mode toggle button */
.dark-mode-toggle {
 background: transparent;
 border: 1px solid rgba(255,255,255,0.3);
 color: inherit;
 padding: 6px 12px;
 border-radius: 20px;
 cursor: pointer;
 font-size: 14px;
 display: flex;
 align-items: center;
 gap: 6px;
 transition: all 0.2s ease;
}

.dark-mode-toggle:hover {
 background: rgba(255,255,255,0.1);
 border-color: rgba(255,255,255,0.5);
}

body.dark-mode .dark-mode-toggle {
 border-color: rgba(184, 115, 51, 0.5);
}

body.dark-mode .dark-mode-toggle:hover {
 background: rgba(184, 115, 51, 0.2);
 border-color: #B87333;
}

/* ===== V3.6: BOTTOM NAVIGATION (Mobile) ===== */
.bottom-nav {
 display: none;
 position: fixed;
 bottom: 0;
 left: 0;
 right: 0;
 background: rgba(255, 255, 255, 0.95);
 backdrop-filter: blur(20px);
 -webkit-backdrop-filter: blur(20px);
 border-top: 1px solid rgba(0,0,0,0.1);
 padding: 8px 0;
 padding-bottom: calc(8px + env(safe-area-inset-bottom));
 z-index: 1000;
 box-shadow: 0 -4px 20px rgba(0,0,0,0.1);
}

body.dark-mode .bottom-nav {
 background: rgba(26, 26, 46, 0.95);
 border-color: #3a3a5a;
}

.bottom-nav-items {
 display: flex;
 justify-content: space-around;
 align-items: center;
 max-width: 500px;
 margin: 0 auto;
}

.bottom-nav-item {
 display: flex;
 flex-direction: column;
 align-items: center;
 gap: 4px;
 padding: 8px 12px;
 border: none;
 background: transparent;
 color: #6B7280;
 cursor: pointer;
 transition: all 0.2s ease;
 border-radius: 12px;
 min-width: 60px;
}

.bottom-nav-item.active {
 color: #B87333;
}

.bottom-nav-item:hover {
 background: rgba(184, 115, 51, 0.1);
}

.bottom-nav-icon {
 font-size: 20px;
}

.bottom-nav-label {
 font-size: 10px;
 font-weight: 500;
}

body.dark-mode .bottom-nav-item {
 color: #A0A0B0;
}

body.dark-mode .bottom-nav-item.active {
 color: #D4944A;
}

/* ===== V3.6: FLOATING ACTION BUTTON ===== */
.floating-action-btn {
 display: none;
 position: fixed;
 bottom: 90px;
 right: 20px;
 width: 56px;
 height: 56px;
 border-radius: 50%;
 background: linear-gradient(135deg, #B87333 0%, #D4944A 100%);
 color: white;
 border: none;
 box-shadow: 0 4px 20px rgba(184, 115, 51, 0.4);
 cursor: pointer;
 z-index: 999;
 font-size: 24px;
 display: flex;
 align-items: center;
 justify-content: center;
 transition: all 0.2s ease;
}

.floating-action-btn:hover {
 transform: scale(1.1);
 box-shadow: 0 6px 25px rgba(184, 115, 51, 0.5);
}

.floating-action-btn.has-content {
 animation: fabPulse 2s infinite;
}

@keyframes fabPulse {
 0%, 100% { box-shadow: 0 4px 20px rgba(184, 115, 51, 0.4); }
 50% { box-shadow: 0 4px 30px rgba(184, 115, 51, 0.7); }
}

/* ===== V3.6: DRAFT RECOVERY MODAL ===== */
.draft-recovery-modal {
 position: fixed;
 bottom: 20px;
 left: 20px;
 right: 20px;
 max-width: 400px;
 margin: 0 auto;
 background: white;
 border-radius: 16px;
 padding: 20px;
 box-shadow: 0 10px 40px rgba(0,0,0,0.2);
 z-index: 10001;
 animation: slideUp 0.3s ease;
}

body.dark-mode .draft-recovery-modal {
 background: #252538;
 color: #E8E8EC;
}

@keyframes slideUp {
 from { transform: translateY(100px); opacity: 0; }
 to { transform: translateY(0); opacity: 1; }
}

.draft-recovery-title {
 font-weight: 600;
 font-size: 16px;
 margin-bottom: 8px;
 color: #191970;
}

body.dark-mode .draft-recovery-title {
 color: #D4944A;
}

.draft-recovery-desc {
 font-size: 14px;
 color: #6B7280;
 margin-bottom: 16px;
}

.draft-recovery-actions {
 display: flex;
 gap: 12px;
}

.draft-recovery-actions button {
 flex: 1;
 padding: 10px 16px;
 border-radius: 8px;
 font-weight: 500;
 cursor: pointer;
 transition: all 0.2s ease;
}

.draft-recovery-restore {
 background: #B87333;
 color: white;
 border: none;
}

.draft-recovery-discard {
 background: transparent;
 border: 1px solid #ddd;
 color: #6B7280;
}

/* ===== V3.6: DRAFT SAVE INDICATOR ===== */
.draft-save-indicator {
 position: fixed;
 bottom: 80px;
 left: 50%;
 transform: translateX(-50%);
 background: rgba(0,0,0,0.8);
 color: white;
 padding: 8px 16px;
 border-radius: 20px;
 font-size: 12px;
 z-index: 1000;
 animation: fadeInOut 2s ease;
}

@keyframes fadeInOut {
 0% { opacity: 0; transform: translateX(-50%) translateY(10px); }
 20% { opacity: 1; transform: translateX(-50%) translateY(0); }
 80% { opacity: 1; transform: translateX(-50%) translateY(0); }
 100% { opacity: 0; transform: translateX(-50%) translateY(-10px); }
}

/* ===== V3.6: APPLICATION TRACKER ===== */
.applications-panel {
 position: fixed;
 top: 0;
 right: 0;
 bottom: 0;
 width: 400px;
 max-width: 100vw;
 background: white;
 box-shadow: -4px 0 30px rgba(0,0,0,0.2);
 z-index: 10000;
 transform: translateX(100%);
 transition: transform 0.3s ease;
 display: flex;
 flex-direction: column;
}

.applications-panel.open {
 transform: translateX(0);
}

body.dark-mode .applications-panel {
 background: #1a1a2e;
}

.applications-header {
 padding: 20px;
 border-bottom: 1px solid #eee;
 display: flex;
 justify-content: space-between;
 align-items: center;
}

body.dark-mode .applications-header {
 border-color: #3a3a5a;
}

.applications-list {
 flex: 1;
 overflow-y: auto;
 padding: 16px;
}

.application-card {
 background: #f9f9f9;
 border-radius: 12px;
 padding: 16px;
 margin-bottom: 12px;
}

body.dark-mode .application-card {
 background: #252538;
}

.application-company {
 font-weight: 600;
 font-size: 15px;
 margin-bottom: 4px;
}

.application-position {
 font-size: 13px;
 color: #6B7280;
 margin-bottom: 8px;
}

.application-status {
 display: inline-block;
 padding: 4px 10px;
 border-radius: 12px;
 font-size: 11px;
 font-weight: 600;
 text-transform: uppercase;
}

.application-status.applied { background: #dbeafe; color: #1d4ed8; }
.application-status.phone_screen { background: #fef3c7; color: #b45309; }
.application-status.interview { background: #d1fae5; color: #047857; }
.application-status.offer { background: #dcfce7; color: #15803d; }
.application-status.rejected { background: #fee2e2; color: #dc2626; }

/* ========================================
   V5.7 MOBILE-FIRST REDESIGN (DEFAULT)
   Target: iPhone 14/15/16 (390-430px)
   Mobile design is now the DEFAULT for all screens.
   Desktop overrides are at the end.
   ======================================== */

/* CSS Variables */
:root {
 --mobile-header-height: 44px;
 --mobile-tab-height: 48px;
 --mobile-input-height: 56px;
 --mobile-input-max: 120px;
 --mobile-avatar-size: 28px;
 --mobile-touch-target: 44px;
 --mobile-message-max: 85%;
 --mobile-safe-bottom: env(safe-area-inset-bottom, 0px);
 --mobile-safe-top: env(safe-area-inset-top, 0px);
}

/* ===== MOBILE-FIRST STYLES (DEFAULT) ===== */

/* V2.14: Show admin button and settings on mobile */
.admin-btn,
.settings-gear-btn {
 display: flex !important;
}

/* Hide most extra header buttons on mobile-first */
.header-btn:not(.admin-btn),
.history-toggle,
.analytics-btn,
.sound-toggle,
.user-info,
.header-buttons > div:not(.dark-mode-toggle):not(.admin-btn),
.header-buttons > label {
 display: none !important;
}

/* Only show dark mode toggle in header */
.dark-mode-toggle {
 display: flex !important;
 width: 36px;
 height: 36px;
 align-items: center;
 justify-content: center;
 border-radius: 50%;
 background: transparent;
 border: none;
 font-size: 20px;
 cursor: pointer;
}

/* ===== BODY RESET ===== */
body {
 overflow: hidden;
 position: fixed;
 width: 100%;
 height: 100%;
}

/* ===== MAIN CONTAINER - Full viewport ===== */
.main-container {
 position: fixed;
 top: 0;
 left: 0;
 right: 0;
 bottom: 0;
 padding: 0;
 margin: 0;
 max-width: 100%;
 display: flex;
 flex-direction: column;
 overflow: hidden;
 padding-top: var(--mobile-safe-top);
}

/* ===== HEADER - Slim 44px bar ===== */
.header {
 height: var(--mobile-header-height);
 min-height: var(--mobile-header-height);
 max-height: var(--mobile-header-height);
 padding: 0 12px;
 margin: 0;
 border-radius: 0;
 display: flex;
 align-items: center;
 justify-content: space-between;
 flex-shrink: 0;
 background: rgba(255, 255, 255, 0.85);
 backdrop-filter: blur(20px);
 -webkit-backdrop-filter: blur(20px);
 border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}

.header-left {
 display: flex;
 align-items: center;
 gap: 8px;
 flex: 0 0 auto;
}

.header-logo {
 height: 28px;
 width: auto;
 /* V2.13: Better blending with gradient background */
 border-radius: 4px;
 background: rgba(255,255,255,0.9);
 padding: 2px 4px;
 box-shadow: 0 1px 3px rgba(0,0,0,0.1);
}

.header-title {
 display: none;
}

.header-subtitle {
 display: none;
}

/* Current tab name in center - V2.8: MORE VISIBLE */
.header-center-tab {
 position: absolute;
 left: 50%;
 transform: translateX(-50%);
 font-size: 16px;
 font-weight: 700;
 color: white;
 background: linear-gradient(135deg, #B87333, #8B5A2B);
 padding: 6px 20px;
 border-radius: 16px;
 text-transform: uppercase;
 letter-spacing: 0.5px;
 box-shadow: 0 2px 8px rgba(184, 115, 51, 0.3);
}

.header-buttons {
 display: flex;
 gap: 4px;
 flex: 0 0 auto;
}

/* ===== HIDE OLD AVATAR SECTION ===== */
.chat-header,
.unified-chat-header {
 display: none !important;
}

/* ===== TAB BAR - Pill style above input ===== */
.bottom-nav {
 display: none !important;
}

.mobile-tab-bar {
 position: fixed;
 bottom: var(--mobile-safe-bottom);
 left: 0;
 right: 0;
 height: var(--mobile-tab-height);
 display: flex;
 align-items: center;
 justify-content: center;
 gap: 4px;
 padding: 0 8px;
 background: rgba(255, 255, 255, 0.95);
 backdrop-filter: blur(20px);
 -webkit-backdrop-filter: blur(20px);
 border-top: 1px solid rgba(0, 0, 0, 0.08);
 z-index: 101;
}

.mobile-tab {
 flex: 1;
 max-width: 72px;
 height: 36px;
 display: flex;
 align-items: center;
 justify-content: center;
 font-size: 11px;
 font-weight: 600;
 border-radius: 18px;
 background: transparent;
 border: 1.5px solid ${COLORS.platinum};
 color: ${COLORS.darkGray};
 transition: all 0.2s ease;
 -webkit-tap-highlight-color: transparent;
}

.mobile-tab.active {
 background: ${COLORS.navy};
 border-color: ${COLORS.navy};
 color: white;
}

.mobile-tab:active {
 transform: scale(0.95);
}

/* ===== CHAT CONTAINER - Fluid ===== */
.unified-chat-container {
 flex: 1;
 display: flex;
 flex-direction: column;
 margin: 0;
 border-radius: 0;
 background: transparent;
 overflow: hidden;
 min-height: 0;
}

/* ===== V5.9 TRUE iMESSAGE INTERFACE ===== */

/* Message row container - holds avatar + bubble */
.imessage-row {
 display: flex;
 align-items: flex-end;
 gap: 8px;
 margin-bottom: 4px;
 animation: messageSlideUp 0.2s ease-out;
}

.imessage-row.user {
 flex-direction: row-reverse;
}

.imessage-row.assistant {
 flex-direction: row;
}

/* Avatar in message row */
.imessage-avatar {
 width: 32px;
 height: 32px;
 border-radius: 50%;
 flex-shrink: 0;
 object-fit: cover;
}

/* Message content wrapper */
.imessage-content {
 max-width: 75%;
 display: flex;
 flex-direction: column;
}

.imessage-row.user .imessage-content {
 align-items: flex-end;
}

.imessage-row.assistant .imessage-content {
 align-items: flex-start;
}

/* Sender name above bubble */
.imessage-name {
 font-size: 11px;
 font-weight: 600;
 margin-bottom: 2px;
 padding: 0 4px;
}

.imessage-row.user .imessage-name {
 color: ${COLORS.copper};
 text-align: right;
}

.imessage-row.assistant .imessage-name {
 color: ${COLORS.navy};
}

/* The actual message bubble */
.imessage-bubble {
 padding: 10px 14px;
 border-radius: 18px;
 font-size: 15px;
 line-height: 1.4;
 word-wrap: break-word;
}

.imessage-row.user .imessage-bubble {
 background: linear-gradient(135deg, #8B5CF6, #7C3AED);
 color: white;
 border-bottom-right-radius: 4px;
}

.imessage-row.assistant .imessage-bubble {
 background: #E5E5EA;
 color: #1d1d1f;
 border-bottom-left-radius: 4px;
}

body.dark-mode .imessage-row.assistant .imessage-bubble {
 background: #3a3a4e;
 color: #ffffff;
}

body.dark-mode .imessage-row.user .imessage-bubble {
 background: linear-gradient(135deg, #9B6DF6, #8B4DED);
}

body.dark-mode .imessage-name {
 color: #888;
}

/* Typing indicator */
.imessage-typing {
 display: flex;
 align-items: center;
 gap: 8px;
 padding: 8px 0;
}

.imessage-typing-avatar {
 width: 28px;
 height: 28px;
 border-radius: 50%;
}

.imessage-typing-dots {
 display: flex;
 gap: 4px;
 padding: 10px 14px;
 background: rgba(255,255,255,0.9);
 border-radius: 18px;
}

body.dark-mode .imessage-typing-dots {
 background: #2a2a3e;
}

.imessage-typing-dots span {
 width: 8px;
 height: 8px;
 background: ${COLORS.navy};
 border-radius: 50%;
 animation: typingBounce 1.4s ease-in-out infinite;
}

body.dark-mode .imessage-typing-dots span {
 background: #888;
}

.imessage-typing-dots span:nth-child(1) { animation-delay: 0s; }
.imessage-typing-dots span:nth-child(2) { animation-delay: 0.2s; }
.imessage-typing-dots span:nth-child(3) { animation-delay: 0.4s; }

@keyframes typingBounce {
 0%, 60%, 100% { transform: translateY(0); }
 30% { transform: translateY(-4px); }
}

/* Result cards inside chat - V2.4: Copper header */
.imessage-result {
 background: white;
 border-radius: 16px;
 overflow: hidden;
 box-shadow: 0 2px 12px rgba(0,0,0,0.08);
 margin-top: 4px;
}

body.dark-mode .imessage-result {
 background: #252538;
}

.imessage-result-header {
 padding: 12px 16px;
 background: linear-gradient(135deg, #B87333, #D4944A);
 color: white;
 font-size: 14px;
 font-weight: 600;
}

.imessage-result-content {
 padding: 16px;
 font-size: 14px;
 line-height: 1.6;
 white-space: pre-wrap;
 max-height: 350px;
 overflow-y: auto;
}

.imessage-result-actions {
 display: flex;
 flex-wrap: wrap;
 gap: 8px;
 padding: 12px 16px;
 border-top: 1px solid #E5E5EA;
}

body.dark-mode .imessage-result-actions {
 border-top-color: #3a3a4e;
}

.imessage-result-actions button {
 padding: 8px 16px;
 border: none;
 border-radius: 20px;
 font-size: 13px;
 font-weight: 500;
 cursor: pointer;
 background: linear-gradient(135deg, #8B5CF6, #7C3AED);
 color: white;
 transition: transform 0.2s ease;
}

.imessage-result-actions button:hover {
 transform: translateY(-1px);
}

.imessage-result-actions button:active {
 transform: scale(0.95);
}

/* User default avatar if no photo - V2.4: Purple */
.user-avatar-placeholder {
 width: 32px;
 height: 32px;
 border-radius: 50%;
 background: linear-gradient(135deg, #8B5CF6, #7C3AED);
 display: flex;
 align-items: center;
 justify-content: center;
 color: white;
 font-weight: 600;
 font-size: 14px;
}

@keyframes messageSlideUp {
 from { opacity: 0; transform: translateY(10px); }
 to { opacity: 1; transform: translateY(0); }
}

/* ===== MESSAGES AREA - Scrollable ===== */
.unified-chat-messages {
 flex: 1;
 overflow-y: auto;
 overflow-x: hidden;
 -webkit-overflow-scrolling: touch;
 padding: 12px 12px;
 padding-bottom: calc(var(--mobile-tab-height) + var(--mobile-input-height) + var(--mobile-safe-bottom) + 24px);
 display: flex;
 flex-direction: column;
 gap: 4px;
}

/* Hide the old unified-chat-header completely */
.unified-chat-header {
 display: none !important;
}

/* Hide the old unified-tabs on mobile */
.unified-tabs {
 display: none !important;
}

/* ===== OLD MESSAGE BUBBLES (V2.4: Updated colors) ===== */
.unified-message {
 max-width: var(--mobile-message-max);
 padding: 10px 14px;
 border-radius: 18px;
 font-size: 15px;
 line-height: 1.4;
}

.unified-message.user {
 align-self: flex-end;
 background: linear-gradient(135deg, #8B5CF6, #7C3AED);
 color: white;
 border-bottom-right-radius: 4px;
}

.unified-message.assistant {
 align-self: flex-start;
 background: #E5E5EA;
 color: #1d1d1f;
 border-bottom-left-radius: 4px;
 box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
}

/* Inline avatar for assistant messages */
.message-with-avatar {
 display: flex;
 align-items: flex-end;
 gap: 8px;
 max-width: var(--mobile-message-max);
}

.message-avatar {
 width: var(--mobile-avatar-size);
 height: var(--mobile-avatar-size);
 border-radius: 50%;
 flex-shrink: 0;
}

/* Roleplay messages - smaller, subtle */
.unified-message.roleplay {
 max-width: 90%;
 padding: 6px 12px;
 font-size: 13px;
 opacity: 0.85;
 background: rgba(139, 92, 246, 0.1);
 color: ${COLORS.purple};
 align-self: flex-start;
}

/* Result cards - full width */
.unified-message.result {
 max-width: 100%;
 background: white;
 border-radius: 16px;
 padding: 16px;
 box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
}

.result-content {
 font-size: 14px;
 line-height: 1.5;
}

.unified-result-actions {
 display: flex;
 flex-wrap: wrap;
 gap: 8px;
 margin-top: 12px;
 padding-top: 12px;
 border-top: 1px solid rgba(0, 0, 0, 0.08);
}

.unified-result-actions button {
 flex: 1;
 min-width: 70px;
 padding: 8px 12px;
 font-size: 12px;
 border-radius: 8px;
}

/* ===== INPUT BAR - Fixed bottom ===== */
.unified-chat-input {
 position: fixed;
 bottom: calc(var(--mobile-tab-height) + var(--mobile-safe-bottom));
 left: 0;
 right: 0;
 min-height: var(--mobile-input-height);
 max-height: var(--mobile-input-max);
 padding: 8px 12px;
 padding-bottom: 8px;
 background: rgba(255, 255, 255, 0.98);
 backdrop-filter: blur(20px);
 -webkit-backdrop-filter: blur(20px);
 border-top: 1px solid rgba(0, 0, 0, 0.1);
 box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.05);
 z-index: 102;
 display: flex;
 flex-direction: column;
 gap: 8px;
 transition: bottom 0.1s ease-out;
}

/* When keyboard is open, move input up */
.keyboard-open .unified-chat-input {
 bottom: 0;
 padding-bottom: calc(8px + var(--mobile-safe-bottom));
}

/* Hide tab bar when keyboard is open */
.keyboard-open .mobile-tab-bar {
 display: none;
}

.unified-tools-row {
 display: flex;
 gap: 8px;
 padding: 0;
 margin: 0;
 overflow-x: auto;
 -webkit-overflow-scrolling: touch;
 scrollbar-width: none;
}

.unified-tools-row::-webkit-scrollbar {
 display: none;
}

.unified-tool-btn {
 flex-shrink: 0;
 width: 36px;
 height: 36px;
 padding: 0;
 display: flex;
 align-items: center;
 justify-content: center;
 font-size: 16px;
 border-radius: 50%;
 background: rgba(0, 0, 0, 0.05);
 border: none;
}

.unified-tool-btn:active {
 background: rgba(0, 0, 0, 0.1);
}

.unified-input-row {
 display: flex;
 align-items: flex-end;
 gap: 8px;
}

/* V2.12: iMessage-style auto-expanding textarea */
.unified-input-row textarea {
 flex: 1;
 min-height: 36px;
 max-height: 150px;
 padding: 8px 14px;
 font-size: 16px;
 line-height: 1.4;
 border: none;
 border-radius: 20px;
 background: rgba(0, 0, 0, 0.05);
 resize: none;
 outline: none;
 overflow-y: auto;
 transition: height 0.1s ease;
}

.unified-input-row textarea:focus {
 background: rgba(0, 0, 0, 0.08);
}

.unified-input-row textarea::placeholder {
 color: rgba(0, 0, 0, 0.4);
}

.send-btn, .unified-send-btn {
 width: 44px;
 height: 44px;
 padding: 0;
 display: flex;
 align-items: center;
 justify-content: center;
 border-radius: 50%;
 background: linear-gradient(135deg, #8B5CF6, #7C3AED);
 color: white;
 border: none;
 font-size: 22px;
 font-weight: bold;
 flex-shrink: 0;
}

.send-btn:active, .unified-send-btn:active {
 transform: scale(0.9);
 background: #7C3AED;
}

/* ===== HIDE DESKTOP ELEMENTS ===== */
.unified-tabs {
 display: none !important;
}

.content-grid {
 display: none !important;
}

.floating-action-btn {
 display: none !important;
}

/* ===== PROCESSING INDICATOR ===== */
.unified-processing {
 display: flex;
 align-items: center;
 gap: 12px;
 padding: 12px;
 background: rgba(139, 92, 246, 0.1);
 border-radius: 16px;
 max-width: 90%;
 align-self: flex-start;
}

.unified-processing img {
 width: var(--mobile-avatar-size);
 height: var(--mobile-avatar-size);
 border-radius: 50%;
}

/* Typing dots animation */
.typing-dots {
 display: flex;
 gap: 4px;
}

.typing-dots span {
 width: 8px;
 height: 8px;
 background: ${COLORS.purple};
 border-radius: 50%;
 animation: typingBounce 1.4s infinite ease-in-out;
}

.typing-dots span:nth-child(1) { animation-delay: 0s; }
.typing-dots span:nth-child(2) { animation-delay: 0.2s; }
.typing-dots span:nth-child(3) { animation-delay: 0.4s; }

@keyframes typingBounce {
 0%, 80%, 100% { transform: scale(0.6); opacity: 0.5; }
 40% { transform: scale(1); opacity: 1; }
}

/* ===== MODALS AS BOTTOM SHEETS ===== */
.modal-overlay {
 align-items: flex-end !important;
 padding: 0 !important;
}

.modal-content, .applications-panel, .stats-panel, .history-panel {
 position: fixed !important;
 bottom: 0 !important;
 left: 0 !important;
 right: 0 !important;
 top: auto !important;
 max-height: 85vh !important;
 width: 100% !important;
 max-width: 100% !important;
 border-radius: 20px 20px 0 0 !important;
 animation: slideUpSheet 0.3s ease-out !important;
}

@keyframes slideUpSheet {
 from { transform: translateY(100%); }
 to { transform: translateY(0); }
}

/* Sheet drag handle */
.modal-content::before, .applications-panel::before {
 content: '';
 display: block;
 width: 36px;
 height: 4px;
 background: rgba(0, 0, 0, 0.2);
 border-radius: 2px;
 margin: 8px auto 16px;
}

/* ===== QUICK TEMPLATES DROPDOWN ===== */
.quick-templates-dropdown {
 position: fixed !important;
 bottom: calc(var(--mobile-input-height) + var(--mobile-safe-bottom)) !important;
 left: 8px !important;
 right: 8px !important;
 max-height: 50vh !important;
 border-radius: 16px !important;
}

/* ===== DARK MODE - OLED TRUE BLACK ===== */
body.dark-mode {
 background: #000000;
}

body.dark-mode .main-container {
 background: #000000;
}

body.dark-mode .header {
 background: rgba(28, 28, 30, 0.9);
 border-bottom-color: rgba(255, 255, 255, 0.1);
}

body.dark-mode .header-center-tab {
 color: #ffffff;
}

body.dark-mode .mobile-tab-bar {
 background: rgba(28, 28, 30, 0.95);
 border-top-color: rgba(255, 255, 255, 0.1);
}

body.dark-mode .mobile-tab {
 border-color: rgba(255, 255, 255, 0.2);
 color: rgba(255, 255, 255, 0.7);
}

body.dark-mode .mobile-tab.active {
 background: ${COLORS.copper};
 border-color: ${COLORS.copper};
 color: white;
}

body.dark-mode .unified-chat-messages {
 background: #000000;
}

body.dark-mode .unified-message.assistant {
 background: rgba(44, 44, 46, 0.9);
 color: #ffffff;
 box-shadow: 0 0 20px rgba(184, 115, 51, 0.1);
}

body.dark-mode .unified-message.user {
 box-shadow: 0 0 20px rgba(184, 115, 51, 0.3);
}

body.dark-mode .unified-message.result {
 background: rgba(44, 44, 46, 0.95);
 color: #ffffff;
}

body.dark-mode .unified-message.roleplay {
 background: rgba(139, 92, 246, 0.2);
}

body.dark-mode .unified-chat-input {
 background: rgba(28, 28, 30, 0.95);
 border-top-color: rgba(255, 255, 255, 0.1);
}

body.dark-mode .unified-input-row textarea {
 background: rgba(255, 255, 255, 0.1);
 color: #ffffff;
}

body.dark-mode .unified-input-row textarea::placeholder {
 color: rgba(255, 255, 255, 0.4);
}

body.dark-mode .unified-tool-btn {
 background: rgba(255, 255, 255, 0.1);
 color: #ffffff;
}

body.dark-mode .modal-content,
body.dark-mode .applications-panel,
body.dark-mode .stats-panel {
 background: #1c1c1e !important;
 color: #ffffff;
}

body.dark-mode .modal-content::before,
body.dark-mode .applications-panel::before {
 background: rgba(255, 255, 255, 0.3);
}

/* Dim background orbs in dark mode */
body.dark-mode .bg-circle {
 opacity: 0.15 !important;
}

/* ===== MOBILE MORE MENU (Bottom Sheet) ===== */
.mobile-more-menu {
 position: fixed;
 top: 0;
 left: 0;
 right: 0;
 bottom: 0;
 background: rgba(0, 0, 0, 0.5);
 z-index: 200;
 display: flex;
 align-items: flex-end;
 animation: fadeIn 0.2s ease;
}

@keyframes fadeIn {
 from { opacity: 0; }
 to { opacity: 1; }
}

.mobile-more-content {
 width: 100%;
 background: white;
 border-radius: 20px 20px 0 0;
 padding: 8px 16px calc(16px + var(--mobile-safe-bottom));
 animation: slideUpSheet 0.3s ease-out;
}

body.dark-mode .mobile-more-content {
 background: #1c1c1e;
}

.mobile-more-handle {
 width: 36px;
 height: 4px;
 background: rgba(0, 0, 0, 0.2);
 border-radius: 2px;
 margin: 0 auto 16px;
}

body.dark-mode .mobile-more-handle {
 background: rgba(255, 255, 255, 0.3);
}

.mobile-more-content button {
 display: block;
 width: 100%;
 padding: 16px;
 text-align: left;
 font-size: 17px;
 font-weight: 500;
 color: ${COLORS.navy};
 background: transparent;
 border: none;
 border-bottom: 1px solid rgba(0, 0, 0, 0.08);
}

body.dark-mode .mobile-more-content button {
 color: #ffffff;
 border-bottom-color: rgba(255, 255, 255, 0.1);
}

.mobile-more-content button:last-child {
 border-bottom: none;
}

.mobile-more-content button:active {
 background: rgba(0, 0, 0, 0.05);
}

body.dark-mode .mobile-more-content button:active {
 background: rgba(255, 255, 255, 0.1);
}

/* ========================================
   V5.8: SETTINGS DRAWER
   Mobile settings accessed via gear icon
   ======================================== */

.settings-overlay {
 position: fixed;
 top: 0;
 left: 0;
 right: 0;
 bottom: 0;
 background: rgba(0, 0, 0, 0.5);
 z-index: 250;
 display: flex;
 align-items: flex-end;
 animation: fadeIn 0.2s ease;
}

.settings-drawer {
 width: 100%;
 max-height: 75vh;
 background: white;
 border-radius: 20px 20px 0 0;
 padding: 8px 16px calc(16px + var(--mobile-safe-bottom));
 animation: slideUpSheet 0.3s ease-out;
 overflow-y: auto;
}

body.dark-mode .settings-drawer {
 background: #1c1c1e;
}

.settings-drawer .drawer-handle {
 width: 36px;
 height: 4px;
 background: rgba(0, 0, 0, 0.2);
 border-radius: 2px;
 margin: 0 auto 12px;
}

body.dark-mode .settings-drawer .drawer-handle {
 background: rgba(255, 255, 255, 0.3);
}

.settings-drawer .drawer-title {
 font-size: 18px;
 font-weight: 600;
 text-align: center;
 margin-bottom: 16px;
 color: ${COLORS.navy};
}

body.dark-mode .settings-drawer .drawer-title {
 color: #ffffff;
}

.settings-drawer button {
 display: flex;
 align-items: center;
 gap: 12px;
 width: 100%;
 padding: 14px 16px;
 text-align: left;
 font-size: 16px;
 font-weight: 500;
 color: ${COLORS.navy};
 background: transparent;
 border: none;
 border-bottom: 1px solid rgba(0, 0, 0, 0.08);
 cursor: pointer;
}

body.dark-mode .settings-drawer button {
 color: #ffffff;
 border-bottom-color: rgba(255, 255, 255, 0.1);
}

.settings-drawer button:last-child {
 border-bottom: none;
}

.settings-drawer button:active {
 background: rgba(0, 0, 0, 0.05);
}

body.dark-mode .settings-drawer button:active {
 background: rgba(255, 255, 255, 0.1);
}

.settings-drawer button svg {
 width: 22px;
 height: 22px;
 flex-shrink: 0;
 opacity: 0.7;
}

.settings-drawer button.danger {
 color: #dc3545;
}

.settings-gear-btn {
 padding: 8px;
 background: none;
 border: none;
 cursor: pointer;
 display: flex;
 align-items: center;
 justify-content: center;
 color: ${COLORS.navy};
}

body.dark-mode .settings-gear-btn {
 color: #ffffff;
}

/* V5.8: Mobile-only elements hidden on desktop */
.mobile-only {
 display: flex;
}

@media (min-width: 769px) {
 .mobile-only {
 display: none !important;
 }
}

/* ========================================
   DESKTOP OVERRIDES
   Show full header and hide mobile elements
   ======================================== */

/* Hide mobile elements on tablet and desktop */
@media (min-width: 481px) {
 .mobile-tab-bar {
  display: none !important;
 }
 
 .mobile-more-menu {
  display: none !important;
 }
}

/* Tablet breakpoint - keep some mobile styles */
@media (min-width: 481px) and (max-width: 768px) {
 .bottom-nav {
  display: flex;
 }
 
 .floating-action-btn {
  display: flex;
 }
 
 .unified-tabs {
  display: none !important;
 }
 
 .main-container {
  padding: 12px;
  padding-bottom: calc(70px + env(safe-area-inset-bottom));
 }
 
 .header {
  padding: 12px 16px;
  border-radius: 16px;
  margin-bottom: 8px;
 }
 
 .header-logo {
  height: 50px;
 }
 
 .chat-header {
  padding: 12px !important;
 }
 
 .chat-header-avatar {
  width: 40px !important;
  height: 40px !important;
 }
 
 .unified-chat-container {
  border-radius: 16px;
 }
 
 .content-grid {
  display: none !important;
 }
}

/* Desktop: Hide mobile-only elements */
@media (min-width: 769px) {
 /* Hide mobile elements EXCEPT tab bar - we need it for navigation */
 .header-center-tab {
  display: none;
 }
 
 /* V6.9: SHOW mobile-tab-bar on desktop too since old tabs are removed */
 .mobile-tab-bar {
  display: flex !important;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 100;
 }
 
 .mobile-more-menu {
  display: none !important;
 }
 
 /* Show all header buttons on desktop */
 .header-btn,
 .history-toggle,
 .analytics-btn,
 .sound-toggle,
 .user-info,
 .header-buttons > div,
 .header-buttons > button,
 .header-buttons > label {
  display: flex !important;
 }
 
 /* V2.9: Fix desktop body background - no more bleeding */
 body {
  overflow: auto;
  position: static;
  background: linear-gradient(180deg, #F5F5F7 0%, #E8E8EC 50%, #F0F0F5 100%) !important;
  min-height: 100vh;
 }
 
 body.dark-mode {
  background: linear-gradient(180deg, #0f1729 0%, #1a1a2e 100%) !important;
 }
 
 /* Restore desktop main container */
 .main-container {
  position: relative;
  padding: 20px;
  max-width: 1400px;
  margin: 0 auto;
  background: transparent;
 }
 
 /* Restore desktop header */
 .header {
  height: auto;
  min-height: auto;
  max-height: none;
  padding: 16px 24px;
  border-radius: 16px;
  margin-bottom: 16px;
 }
 
 .header-title {
  display: block;
 }
 
 .header-subtitle {
  display: block;
 }
 
 .header-logo {
  height: 65px;
 }
 
 /* Restore desktop chat container */
 .unified-chat-container {
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.8);
 }
 
 /* V6.9: OLD ELEMENTS STAY HIDDEN - do NOT re-show unified-tabs, content-grid, or chat-header */
 /* These were the V5.x desktop layout that's now replaced by iMessage interface */
 .unified-tabs,
 .unified-chat-header,
 .content-grid,
 .chat-header {
  display: none !important;
 }
 
 /* Restore desktop input */
 .unified-chat-input {
  position: relative;
  min-height: auto;
  max-height: none;
  padding: 16px;
  border-radius: 0 0 16px 16px;
 }
 
 /* Restore desktop messages */
 .unified-chat-messages {
  padding: 20px;
  padding-bottom: 20px;
 }
 
 .unified-message {
  max-width: 70%;
 }
 
 /* Show bottom nav on desktop (if needed) */
 .bottom-nav {
  display: none !important;
 }
}

/* V29: Enhanced Glass Effect - Apple Style */
.glass {
 background: rgba(255, 255, 255, 0.55);
 backdrop-filter: blur(30px) saturate(180%);
 -webkit-backdrop-filter: blur(30px) saturate(180%);
 border: 1px solid rgba(255, 255, 255, 0.5);
 box-shadow: 0 8px 32px rgba(31, 38, 135, 0.15), inset 0 0 80px rgba(255, 255, 255, 0.1);
}

.glass-strong {
 background: rgba(255, 255, 255, 0.7);
 backdrop-filter: blur(40px) saturate(200%);
 -webkit-backdrop-filter: blur(40px) saturate(200%);
 border: 1px solid rgba(255, 255, 255, 0.6);
 box-shadow: 0 12px 40px rgba(31, 38, 135, 0.2), inset 0 0 100px rgba(255, 255, 255, 0.15);
}

.glass-subtle {
 background: rgba(255, 255, 255, 0.4);
 backdrop-filter: blur(20px) saturate(160%);
 -webkit-backdrop-filter: blur(20px) saturate(160%);
 border: 1px solid rgba(255, 255, 255, 0.35);
}

/* ===== ANIMATED BACKGROUND (V17) - Enhanced for glass ===== */
.animated-bg {
 position: fixed; top: 0; left: 0; width: 100%; height: 100%;
 z-index: 0; pointer-events: none; overflow: hidden;
}
.bg-circle {
 position: absolute; border-radius: 50%; filter: blur(100px);
 animation: floatAround 25s ease-in-out infinite;
}
.bg-circle-1 {
 width: 600px; height: 600px;
 background: linear-gradient(135deg, ${COLORS.purple}, ${COLORS.pink});
 top: -200px; right: -200px; opacity: 0.5;
}
.bg-circle-2 {
 width: 650px; height: 650px;
 background: linear-gradient(135deg, ${COLORS.pink}, ${COLORS.gold});
 bottom: -250px; left: -250px; opacity: 0.45; animation-delay: 5s;
}
.bg-circle-3 {
 width: 500px; height: 500px;
 background: linear-gradient(135deg, ${COLORS.gold}, ${COLORS.copper});
 top: 35%; left: -180px; opacity: 0.4; animation-delay: 10s;
}
.bg-circle-4 {
 width: 550px; height: 550px;
 background: linear-gradient(135deg, ${COLORS.purple}, ${COLORS.navy});
 top: 15%; right: -150px; opacity: 0.45; animation-delay: 15s;
}
.bg-circle-5 {
 width: 450px; height: 450px;
 background: linear-gradient(135deg, ${COLORS.pink}, ${COLORS.purple});
 bottom: 25%; right: 15%; opacity: 0.4; animation-delay: 20s;
}
@keyframes floatAround {
 0%, 100% { transform: translate(0, 0) scale(1); }
 25% { transform: translate(50px, -50px) scale(1.1); }
 50% { transform: translate(-40px, 40px) scale(0.9); }
 75% { transform: translate(40px, 50px) scale(1.05); }
}

/* ===== MAIN CONTAINER - NEW GRID LAYOUT ===== */
.main-container {
 position: relative; z-index: 1;
 max-width: 1400px; margin: 0 auto; padding: 20px;
 min-height: 100vh;
 overflow-x: hidden; /* V3.2: Prevent horizontal scroll on mobile */
}

/* ===== HEADER - V29 ENHANCED Glass Effect ===== */
.header {
 background: rgba(255, 255, 255, 0.6);
 backdrop-filter: blur(40px) saturate(200%);
 -webkit-backdrop-filter: blur(40px) saturate(200%);
 padding: 16px 24px;
 border-radius: 24px;
 margin-bottom: 16px;
 display: flex;
 align-items: center;
 justify-content: space-between;
 box-shadow: 0 10px 40px rgba(25, 25, 112, 0.12), inset 0 1px 0 rgba(255, 255, 255, 0.8), inset 0 -1px 0 rgba(0, 0, 0, 0.05);
 border: 1px solid rgba(255, 255, 255, 0.6);
}
.header-left { display: flex; align-items: center; gap: 16px; }
.header-logo { 
 height: 100px;
}
.header-title { font-size: 20px; font-weight: 700; color: ${COLORS.navy}; }
.header-subtitle { font-size: 12px; color: ${COLORS.copper}; }
.header-buttons { display: flex; gap: 10px; }

/* ===== HEADER BUTTONS - V29 Enhanced Glass ===== */
.header-btn {
 padding: 10px 18px;
 border: 1px solid rgba(25, 25, 112, 0.15);
 border-radius: 14px;
 background: rgba(255, 255, 255, 0.5);
 backdrop-filter: blur(20px);
 color: ${COLORS.navy};
 font-weight: 600;
 cursor: pointer;
 transition: all 0.3s ease;
 box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);
}
.header-btn:hover {
 background: linear-gradient(135deg, ${COLORS.navy}, #2a2a8a);
 color: ${COLORS.white};
 box-shadow: 0 10px 30px rgba(25, 25, 112, 0.3);
 transform: translateY(-3px);
 border-color: transparent;
}

/* ===== V38.3 STAR-002: UNIFIED CHAT BOX ===== */
/* V6.0: Removed unified-chat-header and unified-tabs CSS - they no longer exist in JSX */
.unified-chat-container {
 display: flex;
 flex-direction: column;
 height: calc(100vh - 60px);
 max-width: 100%;
 margin: 0;
 background: transparent;
 overflow: hidden;
}
.unified-tab {
 padding: 8px 16px;
 background: transparent;
 border: 1px solid ${COLORS.platinum};
 border-radius: 8px;
 font-size: 13px;
 font-weight: 500;
 cursor: pointer;
 transition: all 0.2s;
 color: ${COLORS.navy};
}
.unified-tab:hover { background: rgba(25, 25, 112, 0.05); }
.unified-tab.active {
 background: ${COLORS.navy};
 color: white;
 border-color: ${COLORS.navy};
}
/* Desktop unified-chat-messages removed - mobile CSS is authoritative */
.unified-message {
 max-width: 85%;
 padding: 16px 20px;
 border-radius: 16px;
 animation: fadeSlideIn 0.3s ease-out;
}
@keyframes fadeSlideIn {
 from { opacity: 0; transform: translateY(20px); }
 to { opacity: 1; transform: translateY(0); }
}
.unified-message-roleplay {
 background: white;
 border: 1px solid #E5E5EA;
 align-self: flex-start;
 color: #333;
}
.unified-message-roleplay .chat-name {
 color: ${COLORS.copper};
 font-weight: 600;
 margin-bottom: 4px;
}
.unified-message-result {
 background: linear-gradient(135deg, rgba(25, 25, 112, 0.05) 0%, rgba(25, 25, 112, 0.1) 100%);
 border: 1px solid rgba(25, 25, 112, 0.2);
 align-self: center;
 max-width: 95%;
 width: 100%;
 max-height: 60vh;
 overflow-y: auto;
 -webkit-overflow-scrolling: touch;
}
.unified-message-result .result-header {
 display: flex;
 align-items: center;
 gap: 8px;
 margin-bottom: 12px;
 padding-bottom: 12px;
 border-bottom: 1px solid rgba(25, 25, 112, 0.1);
}
.unified-message-result .result-label {
 font-weight: 600;
 color: ${COLORS.navy};
}
.unified-message-changes {
 background: rgba(255, 215, 0, 0.1);
 border: 1px solid rgba(255, 215, 0, 0.3);
 align-self: center;
 max-width: 95%;
 width: 100%;
}
.unified-message-changes .changes-header {
 display: flex;
 align-items: center;
 gap: 8px;
 margin-bottom: 12px;
 color: #B8860B;
 font-weight: 600;
}
.unified-message-user {
 background: linear-gradient(135deg, #8B5CF6 0%, #7C3AED 100%);
 border: none;
 align-self: flex-end;
 color: white;
}
.unified-message-user .user-label {
 font-size: 11px;
 opacity: 0.7;
 margin-bottom: 4px;
}
.unified-chat-input {
 padding: 16px 20px;
 border-top: 1px solid ${COLORS.platinum};
 background: rgba(255, 255, 255, 0.5);
}
.unified-tools-row {
 display: flex;
 gap: 8px;
 margin-bottom: 12px;
 flex-wrap: wrap;
}
.unified-tool-btn {
 padding: 6px 12px;
 background: white;
 border: 1px solid ${COLORS.platinum};
 border-radius: 6px;
 font-size: 12px;
 cursor: pointer;
 transition: all 0.2s;
 color: ${COLORS.navy};
}
.unified-tool-btn:hover {
 background: ${COLORS.navy};
 color: white;
 border-color: ${COLORS.navy};
}
.unified-tool-btn.recording {
 background: #dc3545;
 color: white;
 border-color: #dc3545;
 animation: recordingPulse 1s infinite;
}
@keyframes recordingPulse {
 0%, 100% { opacity: 1; }
 50% { opacity: 0.7; }
}
.unified-input-row {
 display: flex;
 gap: 12px;
 align-items: flex-end;
}
.unified-input-row textarea {
 flex: 1;
 min-height: 60px;
 max-height: 150px;
 padding: 12px 16px;
 border: 1px solid ${COLORS.platinum};
 border-radius: 12px;
 font-size: 14px;
 resize: none;
 background: white;
}
.unified-input-row textarea:focus {
 outline: none;
 border-color: ${COLORS.navy};
}
.unified-send-btn {
 padding: 12px 24px;
 background: linear-gradient(135deg, #8B5CF6, #7C3AED);
 color: white;
 border: none;
 border-radius: 12px;
 font-weight: 600;
 cursor: pointer;
 transition: all 0.2s;
}
.unified-send-btn:hover {
 transform: translateY(-2px);
 box-shadow: 0 4px 15px rgba(139, 92, 246, 0.4);
}
.unified-send-btn:disabled {
 opacity: 0.5;
 cursor: not-allowed;
 transform: none;
}
.unified-result-actions {
 display: flex;
 gap: 8px;
 margin-top: 12px;
 padding-top: 12px;
 border-top: 1px solid rgba(0,0,0,0.1);
}
.unified-result-actions button {
 padding: 8px 16px;
 background: white;
 border: 1px solid ${COLORS.platinum};
 border-radius: 6px;
 font-size: 12px;
 cursor: pointer;
 transition: all 0.2s;
}
.unified-result-actions button:hover {
 background: ${COLORS.navy};
 color: white;
 border-color: ${COLORS.navy};
}
.unified-processing {
 display: flex;
 align-items: center;
 gap: 12px;
 padding: 16px 20px;
 background: linear-gradient(135deg, rgba(138, 43, 226, 0.1) 0%, rgba(138, 43, 226, 0.05) 100%);
 border: 1px solid rgba(138, 43, 226, 0.2);
 border-radius: 16px;
 align-self: flex-start;
 animation: processingPulse 2s infinite;
}
@keyframes processingPulse {
 0%, 100% { box-shadow: 0 0 10px rgba(138, 43, 226, 0.2); }
 50% { box-shadow: 0 0 25px rgba(138, 43, 226, 0.4); }
}
.unified-typing-dots {
 display: flex;
 gap: 4px;
}
.unified-typing-dots span {
 width: 8px;
 height: 8px;
 background: #8B5CF6;
 border-radius: 50%;
 animation: typingBounce 1.4s infinite ease-in-out;
}
.unified-typing-dots span:nth-child(2) { animation-delay: 0.2s; }
.unified-typing-dots span:nth-child(3) { animation-delay: 0.4s; }

/* ===== V3.6: SKELETON SCREENS ===== */
.skeleton {
 background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
 background-size: 200% 100%;
 animation: skeletonShimmer 1.5s infinite;
 border-radius: 8px;
}

body.dark-mode .skeleton {
 background: linear-gradient(90deg, #252538 25%, #3a3a5a 50%, #252538 75%);
 background-size: 200% 100%;
}

@keyframes skeletonShimmer {
 0% { background-position: 200% 0; }
 100% { background-position: -200% 0; }
}

.skeleton-text {
 height: 16px;
 margin-bottom: 8px;
}

.skeleton-text.short { width: 40%; }
.skeleton-text.medium { width: 70%; }
.skeleton-text.long { width: 100%; }

.skeleton-avatar {
 width: 48px;
 height: 48px;
 border-radius: 50%;
}

.skeleton-card {
 padding: 20px;
 border-radius: 12px;
 background: #f9f9f9;
}

body.dark-mode .skeleton-card {
 background: #252538;
}

/* ===== V3.6: PROGRESS BAR ===== */
.progress-container {
 width: 100%;
 margin: 16px 0;
}

.progress-bar-bg {
 height: 8px;
 background: #e0e0e0;
 border-radius: 4px;
 overflow: hidden;
}

body.dark-mode .progress-bar-bg {
 background: #3a3a5a;
}

.progress-bar-fill {
 height: 100%;
 background: linear-gradient(90deg, #B87333, #D4944A);
 border-radius: 4px;
 transition: width 0.3s ease;
}

.progress-text {
 display: flex;
 justify-content: space-between;
 font-size: 12px;
 color: #666;
 margin-top: 6px;
}

body.dark-mode .progress-text {
 color: #A0A0B0;
}

/* ===== V3.6: PULL TO REFRESH ===== */
.pull-to-refresh {
 position: absolute;
 top: -50px;
 left: 0;
 right: 0;
 height: 50px;
 display: flex;
 align-items: center;
 justify-content: center;
 color: #666;
 font-size: 13px;
 transition: transform 0.2s ease;
}

.pull-to-refresh.pulling {
 transform: translateY(50px);
}

.pull-to-refresh.refreshing {
 transform: translateY(50px);
}

.pull-to-refresh .refresh-icon {
 margin-right: 8px;
 transition: transform 0.3s ease;
}

.pull-to-refresh.pulling .refresh-icon {
 transform: rotate(180deg);
}

.pull-to-refresh.refreshing .refresh-icon {
 animation: spin 1s linear infinite;
}

@keyframes spin {
 from { transform: rotate(0deg); }
 to { transform: rotate(360deg); }
}

/* ===== V3.6: MEETING NOTES ===== */
.meeting-notes-panel {
 position: fixed;
 top: 0;
 right: 0;
 bottom: 0;
 width: 450px;
 max-width: 100vw;
 background: white;
 box-shadow: -4px 0 30px rgba(0,0,0,0.2);
 z-index: 10000;
 transform: translateX(100%);
 transition: transform 0.3s ease;
 display: flex;
 flex-direction: column;
}

.meeting-notes-panel.open {
 transform: translateX(0);
}

body.dark-mode .meeting-notes-panel {
 background: #1a1a2e;
}

.meeting-note-card {
 background: #f9f9f9;
 border-radius: 12px;
 padding: 16px;
 margin-bottom: 12px;
}

body.dark-mode .meeting-note-card {
 background: #252538;
}

.meeting-note-client {
 font-weight: 600;
 color: #B87333;
 font-size: 14px;
 margin-bottom: 4px;
}

.meeting-note-date {
 font-size: 11px;
 color: #999;
 margin-bottom: 8px;
}

.meeting-note-content {
 font-size: 14px;
 line-height: 1.5;
 white-space: pre-wrap;
}

@media (max-width: 768px) {
 .meeting-notes-panel {
  width: 100vw;
 }
}

/* ===== V3.6: FOLLOW-UP TASKS ===== */
.task-item {
 display: flex;
 align-items: flex-start;
 gap: 12px;
 padding: 12px;
 background: #f9f9f9;
 border-radius: 10px;
 margin-bottom: 8px;
}

body.dark-mode .task-item {
 background: #252538;
}

.task-checkbox {
 width: 20px;
 height: 20px;
 border-radius: 50%;
 border: 2px solid #B87333;
 cursor: pointer;
 flex-shrink: 0;
 display: flex;
 align-items: center;
 justify-content: center;
 margin-top: 2px;
}

.task-checkbox.completed {
 background: #B87333;
 color: white;
}

.task-content {
 flex: 1;
}

.task-title {
 font-weight: 500;
 color: #333;
}

body.dark-mode .task-title {
 color: #E8E8EC;
}

.task-title.completed {
 text-decoration: line-through;
 color: #999;
}

.task-meta {
 font-size: 11px;
 color: #999;
 margin-top: 4px;
}

.task-due {
 color: #dc3545;
 font-weight: 500;
}

.task-due.soon {
 color: #ffc107;
}

/* ===== GRID LAYOUT ===== */
/* V2.14: content-grid MUST stay hidden - unified UI handles everything */
.content-grid {
 display: none !important;
}

/* ===== LEFT COLUMN - CHAT BOX - V29 ENHANCED Glass ===== */
.chat-column {
 grid-row: 1 / -1;
 background: rgba(255, 255, 255, 0.55);
 backdrop-filter: blur(40px) saturate(200%);
 -webkit-backdrop-filter: blur(40px) saturate(200%);
 border-radius: 24px;
 padding: 20px;
 box-shadow: 0 10px 40px rgba(25, 25, 112, 0.1), inset 0 1px 0 rgba(255, 255, 255, 0.8), inset 0 -1px 0 rgba(0, 0, 0, 0.03);
 border: 1px solid rgba(255, 255, 255, 0.6);
 display: flex;
 flex-direction: column;
 max-height: calc(100vh - 140px);
 overflow: hidden;
}

/* V37: Hide chat and results on prep/acquire tabs */
.chat-column.hidden-tab, .results-column.hidden-tab, .tab-header.hidden-tab {
 display: none !important;
}
.content-grid.full-width-mode {
 grid-template-columns: 1fr !important;
}
.content-grid.full-width-mode .input-column {
 max-width: 100% !important;
}
.chat-header {
 display: flex;
 align-items: center;
 gap: 12px;
 padding-bottom: 16px;
 border-bottom: 1px solid ${COLORS.platinum};
 margin-bottom: 16px;
}
.chat-header-avatars {
 display: flex;
 gap: 16px;
 justify-content: center;
 flex: 1;
}
.avatar-with-label {
 display: flex;
 flex-direction: column;
 align-items: center;
 gap: 6px;
}
.chat-header-avatar {
 width: 56px; height: 56px;
 border-radius: 50%;
 border: 2px solid ${COLORS.white};
 transition: all 0.3s ease;
 object-fit: cover;
 flex-shrink: 0;
}
.chat-header-avatar.active-glow {
 box-shadow: 0 0 0 3px ${COLORS.purple}, 0 0 20px rgba(128, 0, 128, 0.4);
 animation: pulseGlow 1.5s ease-in-out infinite;
}
@keyframes pulseGlow {
 0%, 100% { box-shadow: 0 0 0 3px ${COLORS.purple}, 0 0 15px rgba(128, 0, 128, 0.3); }
 50% { box-shadow: 0 0 0 4px ${COLORS.purple}, 0 0 25px rgba(128, 0, 128, 0.5); }
}
.admin-label {
 font-size: 9px;
 color: ${COLORS.navy};
 font-weight: 600;
 text-transform: uppercase;
 letter-spacing: 0.5px;
}
.chat-header-title {
 font-weight: 700;
 color: ${COLORS.navy};
 font-size: 16px;
}
.chat-messages {
 flex: 1;
 overflow-y: auto;
 padding-right: 8px;
}
.chat-message {
 display: flex;
 gap: 10px;
 margin-bottom: 14px;
 animation: fadeIn 0.4s ease;
}
.chat-avatar {
 width: 48px; height: 48px;
 border-radius: 50%;
 flex-shrink: 0;
 transition: all 0.3s ease;
 object-fit: cover;
}
.chat-avatar.active-glow {
 box-shadow: 0 0 0 3px ${COLORS.purple}, 0 0 20px rgba(128, 0, 128, 0.4);
 animation: pulseGlow 1.5s ease-in-out infinite;
}
.chat-bubble {
 background: ${COLORS.cardBg};
 padding: 10px 14px;
 border-radius: 12px;
 max-width: 85%;
 box-shadow: 0 1px 4px rgba(0,0,0,0.06);
}
.chat-name {
 font-weight: 700;
 color: ${COLORS.navy};
 font-size: 12px;
 margin-bottom: 4px;
}
.typing-label {
 font-weight: 400;
 color: ${COLORS.purple};
 font-style: italic;
}
.chat-text {
 font-size: 13px;
 color: ${COLORS.textBody};
 line-height: 1.5;
}
.chat-message.typing .chat-bubble {
 background: rgba(128, 0, 128, 0.08);
}
.typing-dots {
 display: inline-flex;
 gap: 2px;
}
.typing-dots span {
 animation: typingBounce 1.4s infinite;
 font-size: 18px;
 font-weight: bold;
 color: ${COLORS.copper};
}
.typing-dots span:nth-child(2) { animation-delay: 0.2s; }
.typing-dots span:nth-child(3) { animation-delay: 0.4s; }
@keyframes typingBounce {
 0%, 60%, 100% { transform: translateY(0); opacity: 0.4; }
 30% { transform: translateY(-4px); opacity: 1; }
}
@keyframes fadeIn {
 from { opacity: 0; transform: translateY(8px); }
 to { opacity: 1; transform: translateY(0); }
}

/* ===== CENTER COLUMN - INPUT AREA ===== */
.input-column {
 display: flex;
 flex-direction: column;
 gap: 16px;
}

/* ===== TABS (V17 hover effects) ===== */
.tabs {
 display: flex;
 gap: 8px;
 background: rgba(255, 255, 255, 0.4);
 backdrop-filter: blur(30px) saturate(180%);
 -webkit-backdrop-filter: blur(30px) saturate(180%);
 padding: 10px;
 border-radius: 20px;
 border: 1px solid rgba(255, 255, 255, 0.5);
 box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05), inset 0 1px 0 rgba(255, 255, 255, 0.6);
}
.tab {
 flex: 1;
 padding: 12px 16px;
 border: none;
 border-radius: 12px;
 font-weight: 600;
 font-size: 12px;
 cursor: pointer;
 transition: all 0.3s ease;
 text-align: center;
 background: transparent;
 color: ${COLORS.darkGray};
 position: relative;
}
.tab::after {
 content: attr(data-tooltip);
 position: absolute;
 bottom: calc(100% + 10px);
 left: 50%;
 transform: translateX(-50%);
 background: rgba(25, 25, 112, 0.95);
 color: white;
 padding: 10px 14px;
 border-radius: 8px;
 font-size: 12px;
 font-weight: 500;
 white-space: normal;
 width: max-content;
 max-width: 280px;
 text-align: center;
 box-shadow: 0 4px 15px rgba(0,0,0,0.2);
 opacity: 0;
 visibility: hidden;
 transition: opacity 0.2s ease, visibility 0.2s ease;
 z-index: 1000;
 line-height: 1.4;
}
.tab::before {
 content: '';
 position: absolute;
 bottom: calc(100% + 2px);
 left: 50%;
 transform: translateX(-50%);
 border: 6px solid transparent;
 border-top-color: rgba(25, 25, 112, 0.95);
 opacity: 0;
 visibility: hidden;
 transition: opacity 0.2s ease, visibility 0.2s ease;
 z-index: 1001;
}
.tab:hover::after,
.tab:hover::before {
 opacity: 1;
 visibility: visible;
}
.tab.active {
 background: linear-gradient(135deg, rgba(25, 25, 112, 0.95), rgba(50, 50, 150, 0.9));
 color: ${COLORS.white};
 box-shadow: 0 6px 20px rgba(25, 25, 112, 0.35);
 position: relative;
 overflow: hidden;
}
.tab.active::before {
 content: '';
 position: absolute;
 top: 0;
 left: -100%;
 width: 100%;
 height: 100%;
 background: linear-gradient(90deg, transparent, rgba(255,255,255,0.2), transparent);
 animation: tabShimmer 3s ease-in-out infinite;
 z-index: 1;
}
@keyframes tabShimmer {
 0% { left: -100%; }
 50% { left: 100%; }
 100% { left: 100%; }
}
.tab:hover:not(.active) {
 background: rgba(255, 255, 255, 0.7);
 color: ${COLORS.navy};
 box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
}

/* ===== TAB HEADER ===== */
.tab-header {
 background: linear-gradient(135deg, rgba(240, 234, 214, 0.9), rgba(245, 245, 245, 0.9));
 backdrop-filter: blur(8px);
 -webkit-backdrop-filter: blur(8px);
 border-radius: 12px;
 padding: 16px 20px;
 margin-top: 12px;
 border-left: 4px solid ${COLORS.copper};
 box-shadow: 0 2px 12px rgba(0,0,0,0.05);
}
.tab-title {
 color: ${COLORS.navy};
 font-size: 18px;
 font-weight: 700;
 margin: 0 0 8px 0;
}
.tab-description {
 color: ${COLORS.darkGray};
 font-size: 14px;
 line-height: 1.5;
 margin: 0;
}

/* ===== INPUT CARD ===== */
.input-card {
 background: rgba(255, 255, 255, 0.6);
 backdrop-filter: blur(35px) saturate(180%);
 -webkit-backdrop-filter: blur(35px) saturate(180%);
 border-radius: 20px;
 padding: 20px;
 box-shadow: 0 8px 32px rgba(0,0,0,0.08), inset 0 1px 0 rgba(255,255,255,0.7);
 transition: all 0.3s ease;
 border: 1px solid rgba(255,255,255,0.5);
}
.input-card:hover {
 box-shadow: 0 12px 40px rgba(184, 115, 51, 0.2), inset 0 1px 0 rgba(255,255,255,0.8);
 transform: translateY(-3px);
 background: rgba(255, 255, 255, 0.75);
}

/* ===== TOOLBAR ===== */
.input-toolbar {
 display: flex;
 gap: 10px;
 margin-bottom: 12px;
}
.tool-btn {
 padding: 10px 16px;
 border: 2px solid ${COLORS.navy};
 border-radius: 8px;
 background: ${COLORS.white};
 color: ${COLORS.navy};
 font-weight: 600;
 cursor: pointer;
 display: flex;
 align-items: center;
 gap: 6px;
 transition: all 0.3s ease;
}
.tool-btn:hover {
 background: linear-gradient(135deg, ${COLORS.copper}, ${COLORS.gold});
 color: ${COLORS.white};
 border-color: ${COLORS.copper};
 box-shadow: 0 0 15px rgba(184, 115, 51, 0.5);
 transform: translateY(-3px) scale(1.05);
}
.tool-btn.recording {
 background: ${COLORS.critical};
 border-color: ${COLORS.critical};
 color: white;
 animation: pulse 1s infinite;
}
@keyframes pulse {
 0%, 100% { opacity: 1; }
 50% { opacity: 0.7; }
}

@keyframes bounce {
 0%, 60%, 100% { transform: translateY(0); }
 30% { transform: translateY(-4px); }
}

/* ===== TEXTAREA ===== */
.main-input {
 width: 100%;
 min-height: 160px;
 padding: 16px;
 border: 2px solid #ddd;
 border-radius: 12px;
 font-size: 15px;
 resize: vertical;
 font-family: inherit;
 transition: all 0.3s ease;
}
.main-input:focus {
 outline: none;
 border-color: ${COLORS.copper};
 box-shadow: 0 0 20px rgba(184, 115, 51, 0.3);
}

/* ===== FILE CHIPS ===== */
.file-chips {
 display: flex;
 flex-wrap: wrap;
 gap: 8px;
 margin-bottom: 12px;
}
.file-chip {
 display: flex;
 align-items: center;
 gap: 8px;
 padding: 6px 12px;
 background: ${COLORS.cardBg};
 border: 1px solid ${COLORS.cardBorder};
 border-radius: 20px;
 font-size: 13px;
}
.file-chip button {
 background: none;
 border: none;
 color: ${COLORS.darkGray};
 cursor: pointer;
 font-size: 16px;
 line-height: 1;
}

/* V38.8: File Preview Modal */
.file-preview-modal {
 position: fixed;
 top: 0;
 left: 0;
 right: 0;
 bottom: 0;
 background: rgba(0,0,0,0.7);
 display: flex;
 align-items: center;
 justify-content: center;
 z-index: 10000;
}
.file-preview-content {
 background: ${COLORS.cardBg};
 border-radius: 12px;
 width: 90%;
 max-width: 800px;
 max-height: 90vh;
 overflow: hidden;
 display: flex;
 flex-direction: column;
}
.file-preview-header {
 display: flex;
 justify-content: space-between;
 align-items: center;
 padding: 16px 20px;
 border-bottom: 1px solid ${COLORS.cardBorder};
}
.file-preview-header h3 {
 margin: 0;
 font-size: 16px;
 color: ${COLORS.text};
}
.file-preview-header button {
 background: none;
 border: none;
 font-size: 24px;
 color: ${COLORS.darkGray};
 cursor: pointer;
}
.file-preview-body {
 padding: 20px;
 overflow: auto;
 flex: 1;
 background: #1a1a2e;
 color: ${COLORS.text};
}

/* ===== SUBMIT BUTTON ===== */
.submit-row {
 display: flex;
 justify-content: space-between;
 align-items: center;
 margin-top: 12px;
 gap: 16px;
}
.fact-check-toggle {
 display: flex;
 align-items: center;
 gap: 8px;
 font-size: 13px;
 color: ${COLORS.textBody};
 cursor: pointer;
}
.fact-check-toggle input[type="checkbox"] {
 width: 16px;
 height: 16px;
 accent-color: ${COLORS.navy};
 cursor: pointer;
}
.fact-check-toggle span {
 user-select: none;
}
.submit-btn {
 padding: 14px 32px;
 background: linear-gradient(135deg, ${COLORS.navy}, #2a2a8a);
 color: ${COLORS.white};
 border: none;
 border-radius: 10px;
 font-weight: 700;
 font-size: 16px;
 cursor: pointer;
 transition: all 0.3s ease;
 margin-left: auto;
 position: relative;
 overflow: hidden;
}
.submit-btn:hover:not(:disabled) {
 background: linear-gradient(135deg, ${COLORS.copper}, ${COLORS.gold});
 box-shadow: 0 0 25px rgba(184, 115, 51, 0.6);
 transform: translateY(-3px) scale(1.03);
}
.submit-btn:disabled {
 opacity: 0.5;
 cursor: not-allowed;
}
.submit-btn.processing {
 background: linear-gradient(135deg, ${COLORS.copper}, ${COLORS.gold}, ${COLORS.copper});
 background-size: 200% 200%;
 animation: gradientShift 1.5s ease infinite;
}
@keyframes gradientShift {
 0% { background-position: 0% 50%; }
 50% { background-position: 100% 50%; }
 100% { background-position: 0% 50%; }
}

/* ===== TEMPLATES SECTION ===== */
.templates-section {
 margin-top: 16px;
}
.templates-title {
 font-weight: 600;
 color: ${COLORS.navy};
 margin-bottom: 10px;
 font-size: 14px;
}
.templates-grid {
 display: grid;
 grid-template-columns: repeat(2, 1fr);
 gap: 8px;
}
.template-btn {
 padding: 12px 14px;
 background: ${COLORS.cardBg};
 border: 2px solid ${COLORS.cardBorder};
 border-radius: 10px;
 font-size: 13px;
 font-weight: 600;
 color: ${COLORS.navy};
 cursor: pointer;
 transition: all 0.3s ease;
 text-align: left;
}
.template-btn:hover {
 background: linear-gradient(135deg, ${COLORS.pink}, ${COLORS.pearl});
 border-color: ${COLORS.copper};
 box-shadow: 0 0 15px rgba(232, 180, 184, 0.5);
 transform: translateY(-2px) scale(1.02);
}

/* ===== RIGHT COLUMN - RESULTS - V29 ENHANCED Glass ===== */
.results-column {
 background: rgba(255, 255, 255, 0.55);
 backdrop-filter: blur(40px) saturate(200%);
 -webkit-backdrop-filter: blur(40px) saturate(200%);
 border-radius: 24px;
 padding: 20px;
 box-shadow: 0 10px 40px rgba(25, 25, 112, 0.1), inset 0 1px 0 rgba(255, 255, 255, 0.8), inset 0 -1px 0 rgba(0, 0, 0, 0.03);
 border: 1px solid rgba(255, 255, 255, 0.6);
 overflow-y: auto;
 max-height: calc(100vh - 140px);
}

/* ===== EMPTY STATE ===== */
.empty-state {
 display: flex;
 flex-direction: column;
 align-items: center;
 justify-content: center;
 height: 100%;
 text-align: center;
 color: ${COLORS.darkGray};
 padding: 40px;
}
.empty-state-icon {
 font-size: 48px;
 margin-bottom: 16px;
}
.empty-state h3 {
 color: ${COLORS.navy};
 margin-bottom: 8px;
}

/* ===== RESULT HEADER ===== */
.result-header {
 display: flex;
 justify-content: space-between;
 align-items: center;
 margin-bottom: 16px;
 padding-bottom: 16px;
 border-bottom: 1px solid ${COLORS.platinum};
}
.result-status {
 display: flex;
 align-items: center;
 gap: 12px;
}
.status-badge {
 padding: 6px 14px;
 border-radius: 20px;
 font-size: 13px;
 font-weight: 600;
}
.status-approved {
 background: ${COLORS.lightGreen};
 color: ${COLORS.success};
}
.status-needs-work {
 background: ${COLORS.lightRed};
 color: ${COLORS.critical};
}
.issue-count {
 font-size: 13px;
 color: ${COLORS.darkGray};
}

/* ===== RESULT ACTIONS ===== */
.result-actions {
 display: flex;
 gap: 8px;
}
.action-btn {
 padding: 8px 16px;
 border: 2px solid ${COLORS.navy};
 border-radius: 8px;
 background: ${COLORS.white};
 color: ${COLORS.navy};
 font-weight: 600;
 cursor: pointer;
 transition: all 0.3s ease;
 font-size: 13px;
}
.action-btn:hover {
 background: linear-gradient(135deg, ${COLORS.navy}, #2a2a8a);
 color: ${COLORS.white};
 box-shadow: 0 0 15px rgba(25, 25, 112, 0.4);
 transform: translateY(-2px);
}

/* ===== RESULT CONTENT ===== */
.result-content {
 background: ${COLORS.cardBg};
 padding: 20px;
 border-radius: 12px;
 white-space: pre-wrap;
 line-height: 1.7;
 font-size: 14px;
 color: ${COLORS.textBody};
 max-height: 300px;
 overflow-y: auto;
}

/* ===== FOLLOW-UP SECTION (ASK GMG) ===== */
.follow-up-section {
 margin-top: 16px;
 padding: 16px;
 background: ${COLORS.pearl};
 border-radius: 12px;
 border: 1px solid ${COLORS.cardBorder};
}
.follow-up-label {
 font-weight: 600;
 font-size: 13px;
 color: ${COLORS.navy};
 margin-bottom: 10px;
}
.follow-up-row {
 display: flex;
 gap: 10px;
 margin-bottom: 10px;
}
.follow-up-input {
 flex: 1;
 padding: 10px 14px;
 border: 1px solid ${COLORS.platinum};
 border-radius: 8px;
 font-size: 14px;
 outline: none;
 transition: border-color 0.2s;
}
.follow-up-input:focus {
 border-color: ${COLORS.copper};
}
.follow-up-btn {
 padding: 10px 18px;
 background: ${COLORS.navy};
 color: white;
 border: none;
 border-radius: 8px;
 font-weight: 600;
 cursor: pointer;
 transition: all 0.2s;
}
.follow-up-btn:hover {
 background: linear-gradient(135deg, ${COLORS.navy}, ${COLORS.copper});
 transform: translateY(-2px);
 box-shadow: 0 4px 12px rgba(184, 115, 51, 0.3);
}
.new-question-btn {
 padding: 8px 14px;
 background: transparent;
 color: ${COLORS.copper};
 border: 1px solid ${COLORS.copper};
 border-radius: 8px;
 font-size: 13px;
 cursor: pointer;
 transition: all 0.2s;
}
.new-question-btn:hover {
 background: ${COLORS.copper};
 color: white;
}

/* ===== SIDE BY SIDE VIEW (V3) ===== */
.side-by-side {
 display: grid;
 grid-template-columns: 1fr 1fr;
 gap: 16px;
 margin-top: 16px;
}
.side-panel {
 border: 1px solid ${COLORS.platinum};
 border-radius: 8px;
 overflow: hidden;
}
.side-panel-header {
 padding: 10px 14px;
 font-weight: 600;
 font-size: 13px;
}
.side-panel-original .side-panel-header {
 background: ${COLORS.lightRed};
 color: ${COLORS.error};
}
.side-panel-corrected .side-panel-header {
 background: ${COLORS.lightGreen};
 color: ${COLORS.success};
}
.side-panel-content {
 padding: 14px;
 font-size: 14px;
 line-height: 1.7;
 color: ${COLORS.textBody};
 white-space: pre-wrap;
 max-height: 250px;
 overflow-y: auto;
}

/* ===== TRACKED CHANGES (V3 STYLE) ===== */
.tracked-changes {
 margin-top: 16px;
 border: 1px solid ${COLORS.platinum};
 border-radius: 8px;
}
.tracked-header {
 display: flex;
 justify-content: space-between;
 align-items: center;
 padding: 12px 14px;
 background: ${COLORS.pearl};
 border-bottom: 1px solid ${COLORS.platinum};
}
.tracked-title {
 font-weight: 600;
 font-size: 14px;
 color: ${COLORS.navy};
}
.tracked-actions {
 display: flex;
 gap: 8px;
}
.tracked-actions button {
 padding: 6px 12px;
 border-radius: 6px;
 font-size: 12px;
 font-weight: 600;
 cursor: pointer;
 transition: all 0.2s;
}
.btn-accept-all {
 background: ${COLORS.navy};
 color: white;
 border: none;
}
.btn-accept-all:hover {
 background: #2a2a8a;
}
.btn-reject-all {
 background: ${COLORS.copper};
 color: white;
 border: none;
}
.btn-reject-all:hover {
 background: #a06030;
}
.btn-apply {
 background: ${COLORS.success};
 color: white;
 border: none;
}
.btn-apply:hover {
 background: #128a3e;
}
.tracked-list {
 max-height: 250px;
 overflow-y: auto;
}
.tracked-item {
 display: flex;
 align-items: flex-start;
 gap: 10px;
 padding: 12px 14px;
 border-bottom: 1px solid ${COLORS.platinum};
 transition: all 0.2s;
}
.tracked-item.rejected {
 opacity: 0.5;
 background: ${COLORS.lightGray};
}
.tracked-item.rejected .tracked-replacement {
 text-decoration: line-through;
 color: ${COLORS.textLight};
}
.tracked-item.rejected .tracked-original {
 text-decoration: none;
 background: none;
 color: ${COLORS.textBody};
}
.tracked-item:last-child {
 border-bottom: none;
}
.tracked-item:hover {
 background: ${COLORS.pearl};
}
.tracked-checkbox {
 width: 18px;
 height: 18px;
 margin-top: 2px;
 cursor: pointer;
 accent-color: ${COLORS.navy};
}
.tracked-content {
 flex: 1;
}
.tracked-severity {
 display: inline-block;
 padding: 2px 6px;
 border-radius: 4px;
 font-size: 10px;
 font-weight: 600;
 text-transform: uppercase;
 margin-right: 6px;
}
.severity-critical {
 background: ${COLORS.critical};
 color: white;
}
.severity-high {
 background: ${COLORS.warning};
 color: white;
}
.severity-medium {
 background: #3b82f6;
 color: white;
}
.severity-low {
 background: ${COLORS.platinum};
 color: ${COLORS.textBody};
}
.tracked-change {
 font-size: 12px;
 color: ${COLORS.textBody};
 margin-top: 6px;
}
.tracked-original {
 text-decoration: line-through;
 color: ${COLORS.error};
 background: ${COLORS.lightRed};
 padding: 1px 4px;
 border-radius: 2px;
}
.tracked-arrow {
 margin: 0 6px;
 color: ${COLORS.darkGray};
}
.tracked-replacement {
 color: ${COLORS.success};
 background: ${COLORS.lightGreen};
 padding: 1px 4px;
 border-radius: 2px;
}

/* ===== WELCOME OVERLAY ===== */
.welcome-overlay {
 position: fixed;
 top: 0; left: 0;
 width: 100%; height: 100%;
 background: rgba(25, 25, 112, 0.75);
 backdrop-filter: blur(15px);
 display: flex;
 align-items: center;
 justify-content: center;
 z-index: 1000;
}
.welcome-card {
 background: rgba(255, 255, 255, 0.9);
 backdrop-filter: blur(50px) saturate(200%);
 -webkit-backdrop-filter: blur(50px) saturate(200%);
 border-radius: 28px;
 padding: 32px;
 max-width: 700px;
 max-height: 90vh;
 overflow-y: auto;
 box-shadow: 0 30px 100px rgba(0,0,0,0.4), inset 0 1px 0 rgba(255,255,255,0.9), 0 0 0 1px rgba(255,255,255,0.3);
 border: 1px solid rgba(255, 255, 255, 0.6);
}
.welcome-header {
 text-align: center;
 margin-bottom: 24px;
}
.welcome-logo {
 height: 70px;
 margin-bottom: 16px;
}
.welcome-title {
 font-size: 24px;
 font-weight: 700;
 color: ${COLORS.navy};
 margin-bottom: 4px;
}
.welcome-subtitle {
 font-size: 14px;
 color: ${COLORS.copper};
}
.welcome-chat {
 background: ${COLORS.cardBg};
 border-radius: 12px;
 padding: 16px;
 margin-bottom: 24px;
 max-height: 350px;
 overflow-y: auto;
 scroll-behavior: smooth;
}
.welcome-tips {
 background: ${COLORS.beige};
 padding: 16px;
 border-radius: 12px;
 margin-bottom: 20px;
}
.welcome-tips-title {
 font-weight: 700;
 color: ${COLORS.navy};
 margin-bottom: 10px;
}
.welcome-tips ul {
 margin: 0;
 padding-left: 20px;
 color: ${COLORS.textBody};
 font-size: 14px;
}
.welcome-tips li {
 margin-bottom: 6px;
}
.welcome-footer {
 display: flex;
 align-items: center;
 justify-content: space-between;
}
.welcome-checkbox-label {
 display: flex;
 align-items: center;
 gap: 8px;
 font-size: 13px;
 color: ${COLORS.darkGray};
 cursor: pointer;
}
.welcome-start-btn {
 padding: 14px 32px;
 background: linear-gradient(135deg, ${COLORS.copper}, ${COLORS.gold});
 color: ${COLORS.white};
 border: none;
 border-radius: 10px;
 font-weight: 700;
 font-size: 16px;
 cursor: pointer;
 transition: all 0.3s ease;
}
.welcome-start-btn:hover {
 box-shadow: 0 0 25px rgba(184, 115, 51, 0.6);
 transform: scale(1.03);
}

/* ===== RESULT DELIVERY POPUP ===== */
.popup-overlay {
 position: fixed;
 top: 0;
 left: 0;
 right: 0;
 bottom: 0;
 background: rgba(0,0,0,0.6);
 display: flex;
 align-items: center;
 justify-content: center;
 z-index: 3000;
 animation: fadeIn 0.3s ease;
}
@keyframes fadeIn {
 from { opacity: 0; }
 to { opacity: 1; }
}
.popup-card {
 background: ${COLORS.white};
 border-radius: 20px;
 max-width: 500px;
 width: 90%;
 box-shadow: 0 20px 60px rgba(0,0,0,0.3);
 animation: popIn 0.3s ease;
 overflow: hidden;
}
@keyframes popIn {
 from { transform: scale(0.8); opacity: 0; }
 to { transform: scale(1); opacity: 1; }
}
.popup-header {
 padding: 20px;
 background: linear-gradient(135deg, ${COLORS.navy}, ${COLORS.copper});
 display: flex;
 align-items: center;
 gap: 16px;
}
.popup-avatar {
 width: 72px;
 height: 72px;
 border-radius: 50%;
 border: 3px solid ${COLORS.pearl};
 object-fit: cover;
}
.popup-speaker {
 color: ${COLORS.white};
}
.popup-speaker-name {
 font-size: 24px;
 font-weight: 700;
 margin-bottom: 4px;
}
.popup-speaker-title {
 font-size: 14px;
 opacity: 0.9;
}
.popup-body {
 padding: 24px;
}
.popup-message {
 font-size: 16px;
 line-height: 1.6;
 color: ${COLORS.textBody};
 margin-bottom: 20px;
 font-style: italic;
 white-space: pre-line;
}
.popup-summary {
 font-size: 14px;
 line-height: 1.5;
 color: ${COLORS.navy};
 background: ${COLORS.pearl};
 padding: 12px 16px;
 border-radius: 10px;
 margin-bottom: 20px;
 font-style: normal;
 border-left: 4px solid ${COLORS.copper};
}
.popup-status {
 display: flex;
 align-items: center;
 gap: 10px;
 margin-bottom: 20px;
}
.popup-status-badge {
 padding: 8px 16px;
 border-radius: 20px;
 font-weight: 600;
 font-size: 14px;
}
.popup-status-pass {
 background: ${COLORS.lightGreen};
 color: ${COLORS.success};
}
.popup-status-fail {
 background: ${COLORS.lightRed};
 color: ${COLORS.error};
}
.popup-actions {
 display: flex;
 gap: 10px;
 flex-wrap: wrap;
}
.popup-btn {
 padding: 12px 20px;
 border-radius: 10px;
 font-weight: 600;
 cursor: pointer;
 transition: all 0.2s;
 border: none;
}
.popup-btn-primary {
 background: ${COLORS.navy};
 color: ${COLORS.white};
}
.popup-btn-primary:hover {
 background: linear-gradient(135deg, ${COLORS.navy}, ${COLORS.copper});
 transform: translateY(-2px);
 box-shadow: 0 4px 12px rgba(184, 115, 51, 0.3);
}
.popup-btn-secondary {
 background: ${COLORS.platinum};
 color: ${COLORS.navy};
}
.popup-btn-secondary:hover {
 background: ${COLORS.pearl};
}
.popup-close {
 margin-left: auto;
}

/* ===== TEMPLATE FORM POPUP ===== */
.template-popup-card {
 background: ${COLORS.white};
 border-radius: 20px;
 max-width: 600px;
 width: 95%;
 max-height: 85vh;
 overflow-y: auto;
 box-shadow: 0 20px 60px rgba(0,0,0,0.3);
 animation: popIn 0.3s ease;
}
.template-popup-header {
 padding: 20px 24px;
 background: linear-gradient(135deg, ${COLORS.navy}, ${COLORS.copper});
 color: ${COLORS.white};
 display: flex;
 align-items: center;
 justify-content: space-between;
 position: sticky;
 top: 0;
 z-index: 10;
}
.template-popup-title {
 font-size: 20px;
 font-weight: 700;
 display: flex;
 align-items: center;
 gap: 10px;
}
.template-popup-close {
 background: rgba(255,255,255,0.2);
 border: none;
 color: white;
 width: 36px;
 height: 36px;
 border-radius: 50%;
 cursor: pointer;
 font-size: 20px;
 display: flex;
 align-items: center;
 justify-content: center;
 transition: all 0.2s;
}
.template-popup-close:hover {
 background: rgba(255,255,255,0.3);
 transform: scale(1.1);
}
.template-popup-body {
 padding: 24px;
}
.template-popup-subtitle {
 color: ${COLORS.darkGray};
 font-size: 14px;
 margin-bottom: 20px;
 line-height: 1.5;
}
.template-form-field {
 margin-bottom: 16px;
}
.template-form-label {
 display: block;
 font-weight: 600;
 color: ${COLORS.navy};
 margin-bottom: 6px;
 font-size: 14px;
}
.template-form-input {
 width: 100%;
 padding: 12px 14px;
 border: 2px solid ${COLORS.platinum};
 border-radius: 10px;
 font-size: 14px;
 transition: all 0.2s;
 background: ${COLORS.white};
}
.template-form-input:focus {
 outline: none;
 border-color: ${COLORS.copper};
 box-shadow: 0 0 0 3px rgba(184, 115, 51, 0.15);
}
.template-form-input::placeholder {
 color: #999;
}
.template-form-select {
 width: 100%;
 padding: 12px 14px;
 border: 2px solid ${COLORS.platinum};
 border-radius: 10px;
 font-size: 14px;
 background: ${COLORS.white};
 cursor: pointer;
 transition: all 0.2s;
}
.template-form-select:focus {
 outline: none;
 border-color: ${COLORS.copper};
}
.template-popup-footer {
 padding: 16px 24px;
 background: ${COLORS.pearl};
 display: flex;
 gap: 12px;
 justify-content: flex-end;
 border-top: 1px solid ${COLORS.platinum};
}
.template-btn-generate {
 padding: 14px 28px;
 background: ${COLORS.navy};
 color: ${COLORS.white};
 border: none;
 border-radius: 10px;
 font-weight: 700;
 font-size: 15px;
 cursor: pointer;
 transition: all 0.2s;
}
.template-btn-generate:hover {
 background: linear-gradient(135deg, ${COLORS.navy}, ${COLORS.copper});
 transform: translateY(-2px);
 box-shadow: 0 4px 15px rgba(184, 115, 51, 0.4);
}
.template-btn-cancel {
 padding: 14px 20px;
 background: transparent;
 color: ${COLORS.darkGray};
 border: 2px solid ${COLORS.platinum};
 border-radius: 10px;
 font-weight: 600;
 cursor: pointer;
 transition: all 0.2s;
}
.template-btn-cancel:hover {
 border-color: ${COLORS.copper};
 color: ${COLORS.navy};
}

/* ===== TOAST ===== */
.toast {
 position: fixed;
 bottom: 20px;
 right: 20px;
 background: ${COLORS.navy};
 color: ${COLORS.white};
 padding: 16px 24px;
 border-radius: 10px;
 font-weight: 600;
 box-shadow: 0 4px 20px rgba(0,0,0,0.2);
 animation: slideIn 0.3s ease;
 z-index: 2000;
}
@keyframes slideIn {
 from { transform: translateX(100%); opacity: 0; }
 to { transform: translateX(0); opacity: 1; }
}

/* ===== LOADING ===== */
.loading {
 display: flex;
 align-items: center;
 justify-content: center;
 padding: 40px;
}
.loading-spinner {
 width: 40px;
 height: 40px;
 border: 4px solid ${COLORS.platinum};
 border-top-color: ${COLORS.navy};
 border-radius: 50%;
 animation: spin 1s linear infinite;
}
@keyframes spin {
 to { transform: rotate(360deg); }
}

/* ===== RESPONSIVE ===== */
@media (max-width: 1200px) {
 .content-grid {
 grid-template-columns: 280px 1fr;
 }
 .results-column {
 grid-column: 1 / -1;
 }
}
@media (max-width: 768px) {
 .content-grid {
 display: none;
 }
 .chat-column {
 display: none;
 }
 .side-by-side {
 grid-template-columns: 1fr;
 }
 /* V3.6: Let unified container handle everything */
 .tabs {
 flex-wrap: wrap;
 gap: 4px;
 }
 .tab {
 flex: 1 1 45%;
 font-size: 11px;
 padding: 8px;
 text-align: center;
 }
 .input-card {
 padding: 12px;
 }
 .main-textarea {
 font-size: 14px;
 min-height: 120px;
 }
 .submit-btn {
 width: 100%;
 }
 .result-content {
 font-size: 14px;
 padding: 12px;
 }
 .keyboard-hints {
 display: none;
 }
 /* V3.6: Unified chat mobile enhancements */
 .unified-chat-header {
 flex-direction: column;
 gap: 8px;
 padding: 10px;
 flex-shrink: 0;
 }
 .unified-tabs {
 gap: 6px;
 padding: 10px 12px;
 justify-content: center;
 }
 .unified-tab {
 padding: 6px 10px;
 font-size: 11px;
 flex: 0 1 auto;
 }
 .unified-chat-messages {
 padding: 12px;
 gap: 12px;
 -webkit-overflow-scrolling: touch;
 flex: 1;
 min-height: 0;
 overflow-y: auto;
 }
 .unified-message {
 max-width: 95%;
 padding: 12px 14px;
 border-radius: 12px;
 font-size: 14px;
 }
 .unified-message-result {
 max-width: 100%;
 }
 .unified-chat-input {
 padding: 10px;
 gap: 8px;
 flex-direction: column;
 flex-shrink: 0;
 }
 .unified-chat-input textarea {
 font-size: 16px; /* Prevents iOS zoom on focus */
 min-height: 60px;
 max-height: 120px;
 }
 .unified-input-actions {
 flex-wrap: wrap;
 gap: 6px;
 }
 .unified-input-actions button {
 padding: 6px 10px;
 font-size: 12px;
 }
 .unified-send-btn {
 display: none; /* V3.6: Use FAB instead */
 }
 /* V3.6: Modal mobile fixes */
 .modal-content {
 width: 95%;
 max-height: 85vh;
 margin: 10px;
 border-radius: 16px;
 }
 .modal-body {
 padding: 16px;
 overflow-y: auto;
 -webkit-overflow-scrolling: touch;
 }
 /* V3.6: Avatar sizing on mobile */
 .persona-avatar {
 width: 48px;
 height: 48px;
 }
 .persona-label {
 font-size: 10px;
 }
 /* V3.6: Header buttons on mobile */
 .header-btn {
 padding: 6px 10px;
 font-size: 11px;
 }
 .logout-btn {
 padding: 6px 10px;
 font-size: 11px;
 }
 /* V3.6: Result card mobile */
 .result-card {
 margin: 8px;
 border-radius: 12px;
 }
 .result-actions {
 flex-wrap: wrap;
 gap: 6px;
 }
 .result-actions button {
 flex: 1 1 45%;
 }
}

/* V3.6: Extra small screens (phones in portrait) */
@media (max-width: 480px) {
 .main-container {
 padding: 4px;
 padding-bottom: calc(65px + env(safe-area-inset-bottom));
 }
 .header {
 padding: 8px;
 margin-bottom: 4px;
 border-radius: 12px;
 }
 .header-logo {
 height: 40px;
 }
 .header-title {
 font-size: 14px;
 }
 .header-subtitle {
 display: none;
 }
 .unified-chat-container {
 border-radius: 12px;
 }
 .unified-tabs {
 gap: 4px;
 padding: 8px;
 }
 .unified-tab {
 padding: 5px 8px;
 font-size: 10px;
 }
 .header-btn {
 padding: 5px 8px;
 font-size: 10px;
 }
 .persona-avatar {
 width: 40px;
 height: 40px;
 }
 .unified-message {
 padding: 10px 12px;
 font-size: 13px;
 }
 .unified-chat-input textarea {
 min-height: 50px;
 }
 .bottom-nav-item {
 font-size: 9px;
 }
 .bottom-nav-item span:first-child {
 font-size: 18px;
 }
}

/* ===== V25: WORD COUNT ===== */
.word-count {
 font-size: 12px;
 color: ${COLORS.darkGray};
 text-align: right;
 padding: 4px 8px;
 background: ${COLORS.platinum};
 border-radius: 0 0 8px 8px;
 margin-top: -4px;
}

/* ===== V25: EXPORT BUTTON ===== */
.export-btn {
 padding: 8px 12px;
 background: ${COLORS.pearl};
 border: 1px solid ${COLORS.copper};
 border-radius: 6px;
 color: ${COLORS.navy};
 font-size: 13px;
 cursor: pointer;
 transition: all 0.2s;
 display: inline-flex;
 align-items: center;
 gap: 6px;
}
.export-btn:hover {
 background: ${COLORS.copper};
 color: white;
}

/* ===== V25: SOUND TOGGLE ===== */
.sound-toggle {
 padding: 8px;
 background: transparent;
 border: 1px solid ${COLORS.platinum};
 border-radius: 6px;
 cursor: pointer;
 font-size: 18px;
 transition: all 0.2s;
}
.sound-toggle:hover {
 background: ${COLORS.pearl};
}
.sound-toggle.active {
 background: ${COLORS.copper};
 color: white;
 border-color: ${COLORS.copper};
}

/* ===== V25: HISTORY LOG ===== */
.history-toggle {
 padding: 8px 12px;
 background: ${COLORS.pearl};
 border: 1px solid ${COLORS.copper};
 border-radius: 6px;
 color: ${COLORS.navy};
 font-size: 13px;
 cursor: pointer;
 display: inline-flex;
 align-items: center;
 gap: 6px;
}
.history-toggle:hover {
 background: ${COLORS.copper};
 color: white;
}
.history-panel {
 position: fixed;
 top: 0;
 right: 0;
 width: 380px;
 height: 100vh;
 background: white;
 box-shadow: -4px 0 20px rgba(0,0,0,0.15);
 z-index: 1000;
 display: flex;
 flex-direction: column;
 animation: slideIn 0.3s ease;
}
@keyframes slideIn {
 from { transform: translateX(100%); }
 to { transform: translateX(0); }
}
.history-header {
 padding: 20px;
 background: ${COLORS.navy};
 color: white;
 display: flex;
 justify-content: space-between;
 align-items: center;
}
.history-header h3 {
 margin: 0;
 font-size: 18px;
}
.history-close {
 background: transparent;
 border: none;
 color: white;
 font-size: 24px;
 cursor: pointer;
 padding: 4px 8px;
}
.history-close:hover {
 background: rgba(255,255,255,0.1);
 border-radius: 4px;
}
.history-list {
 flex: 1;
 overflow-y: auto;
 padding: 12px;
}
.history-item {
 padding: 12px;
 background: ${COLORS.pearl};
 border-radius: 8px;
 margin-bottom: 10px;
 cursor: pointer;
 transition: all 0.2s;
 border: 1px solid transparent;
}
.history-item:hover {
 border-color: ${COLORS.copper};
 transform: translateX(-4px);
}
.history-item-header {
 display: flex;
 justify-content: space-between;
 align-items: center;
 margin-bottom: 6px;
}
.history-item-type {
 font-size: 11px;
 font-weight: 600;
 text-transform: uppercase;
 padding: 2px 8px;
 border-radius: 4px;
 background: ${COLORS.navy};
 color: white;
}
.history-item-type.create { background: ${COLORS.copper}; }
.history-item-type.check { background: ${COLORS.success}; }
.history-item-type.ask { background: ${COLORS.purple}; }
.history-item-time {
 font-size: 11px;
 color: ${COLORS.darkGray};
}
.history-item-preview {
 font-size: 13px;
 color: ${COLORS.textBody};
 line-height: 1.4;
}
.history-empty {
 text-align: center;
 padding: 40px 20px;
 color: ${COLORS.darkGray};
}
.history-clear {
 margin: 12px;
 padding: 10px;
 background: ${COLORS.lightRed};
 border: 1px solid ${COLORS.error};
 border-radius: 6px;
 color: ${COLORS.error};
 cursor: pointer;
 font-size: 13px;
}
.history-clear:hover {
 background: ${COLORS.error};
 color: white;
}

/* ===== V25: BULK CHECK ===== */
.bulk-indicator {
 display: inline-flex;
 align-items: center;
 gap: 6px;
 padding: 4px 10px;
 background: ${COLORS.purple};
 color: white;
 border-radius: 12px;
 font-size: 12px;
 font-weight: 600;
}
.bulk-results {
 display: flex;
 flex-direction: column;
 gap: 12px;
}
.bulk-item {
 background: ${COLORS.pearl};
 border-radius: 8px;
 padding: 12px;
 border-left: 4px solid ${COLORS.platinum};
}
.bulk-item.pass { border-left-color: ${COLORS.success}; }
.bulk-item.fail { border-left-color: ${COLORS.error}; }
.bulk-item-header {
 display: flex;
 justify-content: space-between;
 align-items: center;
 margin-bottom: 8px;
}
.bulk-item-number {
 font-weight: 700;
 color: ${COLORS.navy};
}
.bulk-item-status {
 font-size: 12px;
 padding: 2px 8px;
 border-radius: 10px;
}
.bulk-item-status.pass {
 background: ${COLORS.lightGreen};
 color: ${COLORS.success};
}
.bulk-item-status.fail {
 background: ${COLORS.lightRed};
 color: ${COLORS.error};
}

/* ===== V25: DIFF VIEW ===== */
.diff-toggle {
 display: flex;
 gap: 8px;
 margin-bottom: 12px;
}
.diff-toggle button {
 padding: 6px 12px;
 border: 1px solid ${COLORS.platinum};
 background: white;
 border-radius: 6px;
 cursor: pointer;
 font-size: 13px;
 transition: all 0.2s;
}
.diff-toggle button.active {
 background: ${COLORS.navy};
 color: white;
 border-color: ${COLORS.navy};
}
.diff-view {
 font-family: 'Monaco', 'Consolas', monospace;
 font-size: 13px;
 line-height: 1.6;
 padding: 16px;
 background: ${COLORS.pearl};
 border-radius: 8px;
 white-space: pre-wrap;
}
.diff-removed {
 background: #fecaca;
 color: #991b1b;
 text-decoration: line-through;
 padding: 1px 4px;
 border-radius: 2px;
}
.diff-added {
 background: #bbf7d0;
 color: #166534;
 padding: 1px 4px;
 border-radius: 2px;
}

/* ===== V25: KEYBOARD SHORTCUTS HINT ===== */
.shortcuts-hint {
 font-size: 11px;
 color: ${COLORS.darkGray};
 text-align: center;
 padding: 8px;
 background: ${COLORS.platinum};
 border-radius: 6px;
 margin-top: 8px;
}
.shortcuts-hint kbd {
 background: white;
 padding: 2px 6px;
 border-radius: 3px;
 border: 1px solid ${COLORS.darkGray};
 font-family: monospace;
 font-size: 10px;
}

/* ===== V26: CLIENT PROFILES ===== */
.client-profiles-toggle {
 display: flex;
 justify-content: center;
 margin: 16px 0;
}
.client-profiles-toggle button {
 padding: 10px 20px;
 background: ${COLORS.pearl};
 border: 2px solid ${COLORS.copper};
 border-radius: 25px;
 color: ${COLORS.navy};
 font-weight: 600;
 cursor: pointer;
 transition: all 0.3s;
}
.client-profiles-toggle button:hover {
 background: ${COLORS.copper};
 color: white;
}
.client-profiles-grid {
 display: grid;
 grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
 gap: 16px;
 padding: 16px 0;
}
.client-card {
 background: white;
 border-radius: 12px;
 padding: 16px;
 border-left: 4px solid ${COLORS.platinum};
 box-shadow: 0 2px 8px rgba(0,0,0,0.08);
 transition: transform 0.2s, box-shadow 0.2s;
}
.client-card:hover {
 transform: translateY(-2px);
 box-shadow: 0 4px 12px rgba(0,0,0,0.12);
}
.client-card.status-pillar { border-left-color: ${COLORS.copper}; }
.client-card.status-active { border-left-color: ${COLORS.success}; }
.client-card.status-prospect { border-left-color: ${COLORS.gold}; }
.client-card.status-reference { border-left-color: ${COLORS.purple}; }
.client-card-header {
 display: flex;
 justify-content: space-between;
 align-items: flex-start;
 margin-bottom: 12px;
}
.client-card-header h4 {
 margin: 0;
 color: ${COLORS.navy};
 font-size: 15px;
 line-height: 1.3;
}
.client-status-badge {
 font-size: 10px;
 padding: 3px 8px;
 border-radius: 12px;
 background: ${COLORS.pearl};
 color: ${COLORS.navy};
 font-weight: 600;
 white-space: nowrap;
}
.client-card-body p {
 font-size: 13px;
 margin: 6px 0;
 color: ${COLORS.textBody};
}
.client-contacts {
 margin-top: 10px;
}
.contact-chip {
 display: inline-block;
 font-size: 11px;
 background: ${COLORS.platinum};
 padding: 3px 8px;
 border-radius: 10px;
 margin: 2px 4px 2px 0;
}
.client-notes {
 font-style: italic;
 font-size: 12px;
 color: ${COLORS.darkGray};
 margin-top: 10px;
 padding-top: 10px;
 border-top: 1px dashed ${COLORS.platinum};
}

/* ===== V26: SMART SUGGESTIONS ===== */
.smart-suggestions {
 display: flex;
 flex-direction: column;
 gap: 8px;
 padding: 12px 14px;
 background: linear-gradient(135deg, ${COLORS.pearl} 0%, white 100%);
 border-radius: 10px;
 margin-bottom: 10px;
 border: 1px dashed ${COLORS.copper};
}
.suggestions-label {
 font-size: 12px;
 color: ${COLORS.darkGray};
 font-weight: 600;
}
.suggestion-chips {
 display: flex;
 flex-wrap: wrap;
 gap: 6px;
}
.suggestion-chip {
 font-size: 11px;
 padding: 4px 10px;
 border-radius: 14px;
 background: white;
 color: ${COLORS.navy};
 border: 1px solid ${COLORS.platinum};
 cursor: pointer;
 transition: all 0.2s;
 display: inline-flex;
 align-items: center;
 gap: 4px;
}
.suggestion-chip:hover {
 transform: translateY(-1px);
 box-shadow: 0 2px 8px rgba(0,0,0,0.15);
}
.suggestion-chip:active {
 transform: translateY(0);
}
.chip-category {
 font-size: 8px;
 font-weight: 700;
 padding: 1px 4px;
 border-radius: 3px;
 background: ${COLORS.navy};
 color: white;
}
.suggestion-chip.client .chip-category { background: ${COLORS.copper}; }
.suggestion-chip.method .chip-category { background: ${COLORS.success}; }
.suggestion-chip.stat .chip-category { background: ${COLORS.purple}; }
.suggestion-chip.founder .chip-category { background: ${COLORS.navy}; }
.suggestion-chip.closing .chip-category { background: ${COLORS.gold}; color: ${COLORS.navy}; }
.suggestion-chip.client { border-color: ${COLORS.copper}; background: #fff8f0; }
.suggestion-chip.method { border-color: ${COLORS.success}; background: #f0fff4; }
.suggestion-chip.stat { border-color: ${COLORS.purple}; background: #f8f0ff; }
.suggestion-chip.founder { border-color: ${COLORS.navy}; background: #f0f4ff; }
.suggestion-chip.closing { border-color: ${COLORS.gold}; background: #fffdf0; }

/* ===== V26: ANALYTICS DASHBOARD ===== */
.analytics-btn {
 padding: 8px 14px;
 background: ${COLORS.pearl};
 border: 1px solid ${COLORS.navy};
 border-radius: 6px;
 color: ${COLORS.navy};
 font-size: 13px;
 cursor: pointer;
 display: inline-flex;
 align-items: center;
 gap: 6px;
}
.analytics-btn:hover {
 background: ${COLORS.navy};
 color: white;
}
.analytics-panel {
 position: fixed;
 top: 50%;
 left: 50%;
 transform: translate(-50%, -50%);
 width: 420px;
 max-height: 80vh;
 background: white;
 border-radius: 16px;
 box-shadow: 0 20px 60px rgba(0,0,0,0.3);
 z-index: 1100;
 overflow: hidden;
}
.analytics-overlay {
 position: fixed;
 top: 0;
 left: 0;
 right: 0;
 bottom: 0;
 background: rgba(0,0,0,0.4);
 z-index: 1099;
}
.analytics-header {
 background: ${COLORS.navy};
 color: white;
 padding: 16px 20px;
 display: flex;
 justify-content: space-between;
 align-items: center;
}
.analytics-header h3 { margin: 0; font-size: 18px; }
.analytics-header button {
 background: transparent;
 border: none;
 color: white;
 font-size: 24px;
 cursor: pointer;
 padding: 0 4px;
}
.analytics-body {
 padding: 20px;
 overflow-y: auto;
 max-height: 60vh;
}
.stat-grid {
 display: grid;
 grid-template-columns: repeat(3, 1fr);
 gap: 12px;
 margin-bottom: 20px;
}
.stat-box {
 text-align: center;
 padding: 16px 8px;
 background: ${COLORS.pearl};
 border-radius: 12px;
}
.stat-number {
 font-size: 28px;
 font-weight: 700;
 color: ${COLORS.navy};
}
.stat-label {
 font-size: 11px;
 color: ${COLORS.darkGray};
 text-transform: uppercase;
 margin-top: 4px;
}
.analytics-section {
 margin-top: 20px;
 padding-top: 16px;
 border-top: 1px solid ${COLORS.platinum};
}
.analytics-section h4 {
 margin: 0 0 12px 0;
 color: ${COLORS.navy};
 font-size: 15px;
}
.improvement-stat {
 padding: 10px 14px;
 background: #dcfce7;
 border-radius: 8px;
 color: ${COLORS.success};
 font-weight: 600;
 font-size: 14px;
}
.improvement-stat.negative {
 background: #fee2e2;
 color: ${COLORS.error};
}
.issue-bar-row {
 display: flex;
 align-items: center;
 margin: 8px 0;
 gap: 8px;
}
.issue-bar-label {
 width: 90px;
 font-size: 12px;
 text-transform: capitalize;
 color: ${COLORS.textBody};
}
.issue-bar-track {
 flex: 1;
 height: 10px;
 background: ${COLORS.platinum};
 border-radius: 5px;
 overflow: hidden;
}
.issue-bar-fill {
 height: 100%;
 background: ${COLORS.copper};
 border-radius: 5px;
 transition: width 0.3s;
}
.issue-bar-count {
 font-size: 12px;
 font-weight: 600;
 color: ${COLORS.navy};
 width: 30px;
 text-align: right;
}

/* ===== V26: VOICE IMPROVEMENTS ===== */
.voice-waveform {
 display: flex;
 align-items: center;
 justify-content: center;
 gap: 3px;
 height: 44px;
 padding: 10px 16px;
 background: ${COLORS.navy};
 border-radius: 22px;
 margin: 8px 0;
}
.waveform-bar {
 width: 4px;
 background: ${COLORS.copper};
 border-radius: 2px;
 transition: height 0.1s ease;
 min-height: 4px;
}
.voice-confirm-overlay {
 position: fixed;
 top: 0;
 left: 0;
 right: 0;
 bottom: 0;
 background: rgba(0,0,0,0.5);
 display: flex;
 align-items: center;
 justify-content: center;
 z-index: 1200;
}
.voice-confirm-content {
 background: white;
 padding: 24px;
 border-radius: 16px;
 max-width: 500px;
 width: 90%;
 box-shadow: 0 20px 60px rgba(0,0,0,0.3);
}
.voice-confirm-content h4 {
 margin: 0 0 16px 0;
 color: ${COLORS.navy};
 display: flex;
 align-items: center;
 gap: 8px;
}
.voice-transcript-preview {
 padding: 16px;
 background: ${COLORS.pearl};
 border-radius: 10px;
 margin-bottom: 16px;
 line-height: 1.6;
 font-size: 15px;
 max-height: 200px;
 overflow-y: auto;
}
.voice-confirm-actions {
 display: flex;
 gap: 10px;
}
.voice-confirm-actions button {
 flex: 1;
 padding: 12px;
 border: none;
 border-radius: 8px;
 cursor: pointer;
 font-weight: 600;
 font-size: 14px;
 transition: opacity 0.2s;
}
.voice-confirm-actions button:hover { opacity: 0.9; }
.voice-confirm-actions button.accept {
 background: ${COLORS.success};
 color: white;
}
.voice-confirm-actions button.cancel {
 background: ${COLORS.platinum};
 color: ${COLORS.navy};
}
.voice-confirm-actions button.edit {
 background: ${COLORS.copper};
 color: white;
}

/* ===== V26: LEARNED CORRECTIONS ===== */
.learned-badge {
 display: inline-flex;
 align-items: center;
 gap: 6px;
 padding: 5px 12px;
 background: ${COLORS.pearl};
 border-radius: 16px;
 font-size: 12px;
 color: ${COLORS.navy};
 border: 1px solid ${COLORS.platinum};
}
.editable-output {
 background: ${COLORS.pearl};
 border-radius: 12px;
 overflow: hidden;
 margin-top: 12px;
}
.editable-output-header {
 display: flex;
 justify-content: space-between;
 align-items: center;
 padding: 10px 16px;
 background: ${COLORS.navy};
 color: white;
}
.editable-output-header span {
 font-weight: 600;
 font-size: 13px;
}
.editable-output-header button {
 background: ${COLORS.copper};
 border: none;
 color: white;
 padding: 6px 14px;
 border-radius: 6px;
 cursor: pointer;
 font-size: 12px;
 font-weight: 600;
}
.editable-output textarea {
 width: 100%;
 min-height: 180px;
 padding: 16px;
 border: none;
 font-family: inherit;
 font-size: 14px;
 line-height: 1.6;
 resize: vertical;
 background: white;
}
.editable-output-content {
 padding: 16px;
 line-height: 1.6;
 font-size: 14px;
 background: white;
}

/* V29: Client Prep Tab Styles */
.prep-tab {
 padding: 24px;
}

/* V31: Chat-style header for Client Prep */
.prep-chat-header {
 display: flex;
 align-items: center;
 gap: 16px;
 margin-bottom: 16px;
 padding-bottom: 16px;
 border-bottom: 1px solid ${COLORS.cardBorder};
}
.prep-personas {
 display: flex;
 gap: 12px;
}
.prep-avatar {
 width: 48px;
 height: 48px;
 border-radius: 50%;
 border: 2px solid ${COLORS.white};
}
.prep-chat-title {
 font-weight: 700;
 color: ${COLORS.navy};
 font-size: 18px;
}
.prep-chat-messages {
 background: rgba(25, 25, 112, 0.03);
 border-radius: 12px;
 padding: 16px;
 margin-bottom: 20px;
 max-height: 180px;
 overflow-y: auto;
}
.prep-field-row {
 display: flex;
 gap: 16px;
}
.prep-field-row .prep-field {
 flex: 1;
}
.prep-field {
 margin-bottom: 16px;
}

.prep-header {
 margin-bottom: 24px;
}

.prep-header h3 {
 color: ${COLORS.navy};
 font-size: 20px;
 margin-bottom: 8px;
}

.prep-header p {
 color: ${COLORS.textBody};
 font-size: 14px;
 line-height: 1.5;
}

.prep-form {
 display: flex;
 flex-direction: column;
 gap: 20px;
 position: relative;
 z-index: 10;
}

.prep-field label {
 display: block;
 font-weight: 600;
 color: ${COLORS.navy};
 margin-bottom: 8px;
 font-size: 14px;
}

.prep-input {
 width: 100%;
 padding: 14px 16px;
 border: 2px solid ${COLORS.cardBorder};
 border-radius: 10px;
 font-size: 15px;
 transition: border-color 0.2s;
 background: white;
 position: relative;
 z-index: 11;
}

.prep-input:focus {
 outline: none;
 border-color: ${COLORS.navy};
 box-shadow: 0 0 0 3px rgba(25, 25, 112, 0.1);
}

.prep-textarea {
 width: 100%;
 padding: 14px 16px;
 border: 2px solid ${COLORS.cardBorder};
 border-radius: 10px;
 font-size: 14px;
 font-family: inherit;
 resize: vertical;
 min-height: 200px;
 transition: border-color 0.2s;
 background: white;
 position: relative;
 z-index: 11;
}

.prep-textarea:focus {
 outline: none;
 border-color: ${COLORS.navy};
 box-shadow: 0 0 0 3px rgba(25, 25, 112, 0.1);
}

.prep-generate-btn {
 padding: 16px 32px;
 background: linear-gradient(135deg, ${COLORS.navy} 0%, #2a2a6a 100%);
 color: white;
 border: none;
 border-radius: 10px;
 cursor: pointer;
 font-weight: 600;
 font-size: 16px;
 transition: all 0.2s;
}

.prep-generate-btn:hover:not(:disabled) {
 background: ${COLORS.copper};
 transform: translateY(-2px);
}

.prep-generate-btn:disabled {
 opacity: 0.5;
 cursor: not-allowed;
}

.prep-briefing {
 margin-top: 24px;
 border: 2px solid ${COLORS.cardBorder};
 border-radius: 12px;
 overflow: hidden;
}

.prep-briefing-header {
 display: flex;
 justify-content: space-between;
 align-items: center;
 padding: 16px 20px;
 background: ${COLORS.pearl};
 border-bottom: 1px solid ${COLORS.cardBorder};
}

.prep-briefing-header h4 {
 color: ${COLORS.navy};
 margin: 0;
}

.prep-briefing-actions {
 display: flex;
 gap: 8px;
}

.prep-briefing-content {
 padding: 20px;
 background: white;
 max-height: 400px;
 overflow-y: auto;
}

.prep-briefing-content pre {
 white-space: pre-wrap;
 font-family: inherit;
 font-size: 14px;
 line-height: 1.6;
 margin: 0;
}

.clear-btn {
 padding: 8px 16px;
 background: ${COLORS.lightGray};
 color: ${COLORS.textBody};
 border: none;
 border-radius: 6px;
 cursor: pointer;
 font-size: 13px;
 transition: all 0.2s;
}

.clear-btn:hover {
 background: ${COLORS.error};
 color: white;
}

/* V4.7: Dark mode for Client Prep Tab */
body.dark-mode .prep-tab {
 background: ${DARK_COLORS.background};
}
body.dark-mode .prep-chat-title {
 color: ${DARK_COLORS.textPrimary};
}
body.dark-mode .prep-chat-messages {
 background: ${DARK_COLORS.surfaceBg};
}
body.dark-mode .prep-field label {
 color: ${DARK_COLORS.textPrimary};
}
body.dark-mode .prep-input {
 background: ${DARK_COLORS.inputBg};
 color: ${DARK_COLORS.textPrimary};
 border-color: ${DARK_COLORS.border};
}
body.dark-mode .prep-textarea {
 background: ${DARK_COLORS.inputBg};
 color: ${DARK_COLORS.textPrimary};
 border-color: ${DARK_COLORS.border};
}
body.dark-mode .prep-briefing {
 border-color: ${DARK_COLORS.border};
}
body.dark-mode .prep-briefing-header {
 background: ${DARK_COLORS.surfaceBg};
 border-bottom-color: ${DARK_COLORS.border};
}
body.dark-mode .prep-briefing-header h4 {
 color: ${DARK_COLORS.textPrimary};
}
body.dark-mode .prep-briefing-content {
 background: ${DARK_COLORS.cardBg};
 color: ${DARK_COLORS.textPrimary};
}

/* V37: Pitch Deck Preview Modal */
.pitch-preview-overlay {
 position: fixed;
 top: 0;
 left: 0;
 right: 0;
 bottom: 0;
 background: rgba(0, 0, 0, 0.8);
 display: flex;
 align-items: center;
 justify-content: center;
 z-index: 10000;
}

.pitch-preview-modal {
 width: 90vw;
 height: 90vh;
 background: white;
 border-radius: 12px;
 display: flex;
 flex-direction: column;
 overflow: hidden;
}

.pitch-preview-header {
 display: flex;
 justify-content: space-between;
 align-items: center;
 padding: 16px 24px;
 background: ${COLORS.navy};
 color: white;
}

.pitch-preview-header h3 {
 margin: 0;
 font-size: 18px;
}

.pitch-preview-actions {
 display: flex;
 gap: 12px;
}

.pitch-download-btn {
 padding: 10px 20px;
 background: linear-gradient(135deg, ${COLORS.copper} 0%, #D4A76A 100%);
 color: white;
 border: none;
 border-radius: 6px;
 cursor: pointer;
 font-weight: 600;
 transition: transform 0.2s;
}

.pitch-download-btn:hover {
 transform: scale(1.05);
}

.pitch-close-btn {
 padding: 10px 20px;
 background: rgba(255, 255, 255, 0.2);
 color: white;
 border: 1px solid rgba(255, 255, 255, 0.3);
 border-radius: 6px;
 cursor: pointer;
 transition: all 0.2s;
}

.pitch-close-btn:hover {
 background: rgba(255, 255, 255, 0.3);
}

.pitch-preview-frame {
 flex: 1;
 background: #f5f5f5;
 padding: 20px;
 overflow: auto;
}

.pitch-preview-frame iframe {
 width: 100%;
 height: 100%;
 border: none;
 background: white;
 box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
}

/* V27: Client Acquisition Tab Styles */
.acquire-tab {
 padding: 0;
 display: flex;
 flex-direction: column;
 height: 600px;
}

.password-gate {
 text-align: center;
 padding: 80px 20px;
 display: flex;
 flex-direction: column;
 align-items: center;
 justify-content: center;
 height: 100%;
}

.password-icon {
 font-size: 64px;
 margin-bottom: 24px;
}

.password-gate h3 {
 color: ${COLORS.navy};
 margin-bottom: 12px;
 font-size: 24px;
}

.password-gate p {
 color: ${COLORS.textBody};
 margin-bottom: 24px;
 font-size: 14px;
}

.password-input-group {
 display: flex;
 gap: 12px;
 max-width: 350px;
 width: 100%;
}

.password-input {
 flex: 1;
 padding: 14px 18px;
 border: 2px solid ${COLORS.cardBorder};
 border-radius: 10px;
 font-size: 16px;
 transition: border-color 0.2s;
}

.password-input:focus {
 outline: none;
 border-color: ${COLORS.navy};
}

.password-submit {
 padding: 14px 28px;
 background: linear-gradient(135deg, ${COLORS.navy} 0%, #2a2a6a 100%);
 color: white;
 border: none;
 border-radius: 10px;
 cursor: pointer;
 font-weight: 600;
 font-size: 16px;
 transition: all 0.2s;
}

.password-submit:hover {
 background: ${COLORS.copper};
 transform: translateY(-2px);
}

/* V38.10: Brainstorm Tab Styles */
.brainstorm-tab {
 background: linear-gradient(180deg, ${COLORS.pearl} 0%, white 100%);
}

.brainstorm-container {
 padding: 24px;
}

.brainstorm-header h3 {
 color: ${COLORS.navy};
 margin-bottom: 8px;
}

.brainstorm-header p {
 color: ${COLORS.textBody};
 margin-bottom: 20px;
}

.brainstorm-memory-log {
 background: ${COLORS.platinum};
 padding: 16px;
 border-radius: 12px;
 margin-bottom: 20px;
}

.memory-log-list {
 margin-top: 8px;
 max-height: 120px;
 overflow-y: auto;
}

.memory-log-item {
 padding: 6px 0;
 font-size: 13px;
 color: ${COLORS.textBody};
 border-bottom: 1px solid ${COLORS.cardBorder};
}

.brainstorm-textarea {
 width: 100%;
 padding: 16px;
 border: 2px solid ${COLORS.cardBorder};
 border-radius: 12px;
 font-family: inherit;
 font-size: 14px;
 resize: vertical;
 min-height: 200px;
}

.brainstorm-textarea:focus {
 outline: none;
 border-color: ${COLORS.navy};
}

.brainstorm-actions {
 display: flex;
 gap: 12px;
 margin-top: 16px;
}

.brainstorm-file-upload {
 padding: 12px 20px;
 background: ${COLORS.copper};
 color: white;
 border-radius: 10px;
 cursor: pointer;
 font-weight: 600;
 transition: all 0.2s;
 display: inline-flex;
 align-items: center;
 gap: 8px;
}

.brainstorm-file-upload:hover {
 background: #9a6229;
 transform: translateY(-1px);
}

.brainstorm-process-btn {
 flex: 1;
 padding: 14px 24px;
 background: linear-gradient(135deg, ${COLORS.navy} 0%, #2a2a6a 100%);
 color: white;
 border: none;
 border-radius: 10px;
 font-weight: 600;
 font-size: 15px;
 cursor: pointer;
 transition: all 0.2s;
}

.brainstorm-process-btn:hover:not(:disabled) {
 background: ${COLORS.copper};
 transform: translateY(-2px);
}

.brainstorm-process-btn:disabled {
 opacity: 0.5;
 cursor: not-allowed;
}

.brainstorm-outputs {
 margin-top: 24px;
 padding-top: 20px;
 border-top: 2px solid ${COLORS.cardBorder};
}

.brainstorm-outputs h4 {
 color: ${COLORS.navy};
 margin-bottom: 16px;
}

.output-files-grid {
 display: grid;
 grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
 gap: 16px;
}

.output-file-card {
 background: white;
 border: 2px solid ${COLORS.cardBorder};
 border-radius: 12px;
 padding: 16px;
 transition: border-color 0.2s;
}

.output-file-card:hover {
 border-color: ${COLORS.copper};
}

.output-file-name {
 font-weight: 600;
 color: ${COLORS.navy};
 margin-bottom: 8px;
}

.output-file-preview {
 font-size: 12px;
 color: ${COLORS.textBody};
 margin-bottom: 12px;
 max-height: 60px;
 overflow: hidden;
}

.output-download-btn {
 width: 100%;
 padding: 10px;
 background: ${COLORS.platinum};
 border: none;
 border-radius: 8px;
 cursor: pointer;
 font-weight: 500;
 transition: background 0.2s;
}

.output-download-btn:hover {
 background: ${COLORS.copper};
 color: white;
}

/* V4.7: Dark mode for Brainstorm Tab */
body.dark-mode .brainstorm-tab {
 background: ${DARK_COLORS.background};
}
body.dark-mode .brainstorm-header h3 {
 color: ${DARK_COLORS.textPrimary};
}
body.dark-mode .brainstorm-header p {
 color: ${DARK_COLORS.textSecondary};
}
body.dark-mode .brainstorm-memory-log {
 background: ${DARK_COLORS.surfaceBg};
}
body.dark-mode .memory-log-item {
 color: ${DARK_COLORS.textPrimary};
 border-bottom-color: ${DARK_COLORS.border};
}
body.dark-mode .brainstorm-textarea {
 background: ${DARK_COLORS.inputBg};
 color: ${DARK_COLORS.textPrimary};
 border-color: ${DARK_COLORS.border};
}
body.dark-mode .brainstorm-outputs h4 {
 color: ${DARK_COLORS.textPrimary};
}
body.dark-mode .output-file-card {
 background: ${DARK_COLORS.cardBg};
 border-color: ${DARK_COLORS.border};
}
body.dark-mode .output-file-name {
 color: ${DARK_COLORS.textPrimary};
}
body.dark-mode .output-file-preview {
 color: ${DARK_COLORS.textSecondary};
}
body.dark-mode .output-download-btn {
 background: ${DARK_COLORS.surfaceBg};
 color: ${DARK_COLORS.textPrimary};
}

/* Chat Container */
.acquire-chat-container {
 display: flex;
 flex-direction: column;
 height: 100%;
}

.acquire-chat-messages {
 flex: 1;
 overflow-y: auto;
 padding: 16px;
 display: flex;
 flex-direction: column;
 gap: 8px;
 background: linear-gradient(180deg, #ffffff 0%, #f5f5f7 100%);
}

/* V2.4: PURPLE USER, GRAY ADMIN */
.acquire-message {
 display: flex;
 align-items: flex-end;
 gap: 8px;
 margin-bottom: 4px;
 animation: messageSlideUp 0.2s ease-out;
}

.acquire-message.user {
 flex-direction: row-reverse;
 justify-content: flex-start;
}

.acquire-message.assistant {
 flex-direction: row;
 justify-content: flex-start;
}

.acquire-message-bubble {
 max-width: 75%;
 padding: 10px 14px;
 border-radius: 18px;
 font-size: 15px;
 line-height: 1.4;
 word-wrap: break-word;
}

.acquire-message.user .acquire-message-bubble,
.acquire-message.user .acquire-message-content {
 background: linear-gradient(135deg, #8B5CF6, #7C3AED);
 color: white;
 border-radius: 18px;
 border-bottom-right-radius: 4px;
 padding: 10px 14px;
}

.acquire-message.assistant .acquire-message-bubble,
.acquire-message.assistant .acquire-message-content {
 background: #E5E5EA;
 color: #1d1d1f;
 border-radius: 18px;
 border-bottom-left-radius: 4px;
 padding: 10px 14px;
}

body.dark-mode .acquire-message.assistant .acquire-message-bubble,
body.dark-mode .acquire-message.assistant .acquire-message-content {
 background: #3a3a4e;
 color: #ffffff;
}

body.dark-mode .acquire-message.user .acquire-message-bubble,
body.dark-mode .acquire-message.user .acquire-message-content {
 background: linear-gradient(135deg, #9B6DF6, #8B4DED);
}

.acquire-persona-header {
 display: flex;
 align-items: center;
 gap: 6px;
 margin-bottom: 4px;
 padding: 0 4px;
}

.acquire-persona-avatar {
 width: 28px;
 height: 28px;
 border-radius: 50%;
 object-fit: cover;
 flex-shrink: 0;
}

.acquire-persona-name {
 font-size: 11px;
 font-weight: 600;
 color: ${COLORS.navy};
}

.tier-badge {
 font-size: 10px;
 padding: 2px 8px;
 border-radius: 10px;
 font-weight: 600;
}

.tier-badge.tier-4 {
 background: linear-gradient(135deg, ${COLORS.copper} 0%, ${COLORS.gold} 100%);
 color: white;
}

.acquire-message-content {
 font-size: 14px;
 color: inherit;
 line-height: 1.5;
}
.acquire-message-content .message-text {
 display: flex;
 flex-direction: column;
 gap: 4px;
}
.acquire-message-content .field-row {
 display: flex;
 gap: 6px;
}
.acquire-message-content .field-row strong {
 color: ${COLORS.navy};
 min-width: 100px;
}
.acquire-message-content .bold-line {
 font-weight: 700;
 color: ${COLORS.navy};
 margin-top: 8px;
}

/* Assistant message content needs explicit color */
.acquire-message.assistant .acquire-message-content {
 color: ${COLORS.textDark};
}

/* User message content stays white */
.acquire-message.user .acquire-message-content {
 color: white;
}

.acquire-message-content hr {
 border: none;
 border-top: 1px solid ${COLORS.cardBorder};
 margin: 12px 0;
}

.acquire-message-content strong {
 color: ${COLORS.navy};
}

.acquire-message-actions {
 display: flex;
 gap: 8px;
 margin-top: 12px;
 padding-top: 12px;
 border-top: 1px solid ${COLORS.platinum};
 flex-wrap: wrap;
 align-items: center;
}

/* V5.2: Floating tips animation */
.floating-tip {
 position: fixed;
 bottom: 120px;
 right: 20px;
 max-width: 320px;
 padding: 16px 20px;
 background: linear-gradient(135deg, #6B4EE6 0%, #9B5EE0 100%);
 color: white;
 border-radius: 16px;
 box-shadow: 0 8px 32px rgba(107, 78, 230, 0.35);
 z-index: 1000;
 animation: tipFloatIn 0.5s ease-out forwards;
 display: flex;
 align-items: flex-start;
 gap: 12px;
}

.floating-tip.chanet {
 background: linear-gradient(135deg, #E6894E 0%, #E0A05E 100%);
 box-shadow: 0 8px 32px rgba(230, 137, 78, 0.35);
}

.floating-tip-avatar {
 width: 36px;
 height: 36px;
 border-radius: 50%;
 border: 2px solid rgba(255,255,255,0.3);
 flex-shrink: 0;
}

.floating-tip-text {
 font-size: 14px;
 line-height: 1.5;
 margin: 0;
}

.floating-tip-close {
 position: absolute;
 top: 8px;
 right: 8px;
 background: rgba(255,255,255,0.2);
 border: none;
 color: white;
 width: 20px;
 height: 20px;
 border-radius: 50%;
 cursor: pointer;
 font-size: 12px;
 display: flex;
 align-items: center;
 justify-content: center;
}

.floating-tip-close:hover {
 background: rgba(255,255,255,0.3);
}

@keyframes tipFloatIn {
 from {
  opacity: 0;
  transform: translateY(30px) scale(0.95);
 }
 to {
  opacity: 1;
  transform: translateY(0) scale(1);
 }
}

@keyframes tipFloatOut {
 from {
  opacity: 1;
  transform: translateY(0) scale(1);
 }
 to {
  opacity: 0;
  transform: translateY(-20px) scale(0.95);
 }
}

.floating-tip.exiting {
 animation: tipFloatOut 0.3s ease-in forwards;
}

.dark-mode .floating-tip {
 box-shadow: 0 8px 32px rgba(0, 0, 0, 0.5);
}

.copy-btn, .pdf-btn {
 padding: 8px 16px;
 border: none;
 border-radius: 8px;
 cursor: pointer;
 font-size: 13px;
 font-weight: 600;
 transition: all 0.2s;
}

.copy-btn {
 background: ${COLORS.copper};
 color: white;
}

.copy-btn:hover {
 background: ${COLORS.navy};
}

.pdf-btn {
 background: ${COLORS.navy};
 color: white;
}

.pdf-btn:hover {
 background: ${COLORS.copper};
}

.char-count {
 font-size: 11px;
 color: ${COLORS.textBody};
 margin-left: auto;
 display: flex;
 gap: 8px;
 align-items: center;
}
.page-indicator {
 background: ${COLORS.pearl};
 padding: 2px 8px;
 border-radius: 4px;
 font-weight: 600;
}
.page-indicator.short { color: ${COLORS.success}; }
.page-indicator.good { color: ${COLORS.navy}; }
.page-indicator.long { color: ${COLORS.critical}; }

/* Typing Indicator */
.typing-indicator {
 display: flex;
 gap: 4px;
 padding: 8px 0;
}

.typing-indicator span {
 width: 8px;
 height: 8px;
 background: ${COLORS.copper};
 border-radius: 50%;
 animation: typing 1.4s infinite;
}

.typing-indicator span:nth-child(2) {
 animation-delay: 0.2s;
}

.typing-indicator span:nth-child(3) {
 animation-delay: 0.4s;
}

@keyframes typing {
 0%, 60%, 100% { transform: translateY(0); opacity: 0.4; }
 30% { transform: translateY(-8px); opacity: 1; }
}

/* Chat Input */
.acquire-chat-input {
 display: flex;
 gap: 12px;
 padding: 16px 20px;
 background: white;
 border-top: 1px solid ${COLORS.cardBorder};
}

.acquire-chat-input textarea {
 flex: 1;
 padding: 14px;
 border: 2px solid ${COLORS.cardBorder};
 border-radius: 12px;
 font-family: inherit;
 font-size: 14px;
 resize: none;
 transition: border-color 0.2s;
 color: #333;
 background: white;
}

.acquire-chat-input textarea:focus {
 outline: none;
 border-color: ${COLORS.navy};
}

.acquire-send-btn {
 width: 50px;
 height: 50px;
 background: linear-gradient(135deg, ${COLORS.navy} 0%, #2a2a6a 100%);
 color: white;
 border: none;
 border-radius: 50%;
 cursor: pointer;
 font-size: 20px;
 transition: all 0.2s;
 display: flex;
 align-items: center;
 justify-content: center;
}

.acquire-send-btn:hover:not(:disabled) {
 background: ${COLORS.copper};
 transform: scale(1.05);
}

.acquire-send-btn:disabled {
 background: ${COLORS.darkGray};
 cursor: not-allowed;
}

/* Quick Actions */
.acquire-quick-actions {
 display: flex;
 gap: 8px;
 padding: 12px 20px;
 background: ${COLORS.pearl};
 border-top: 1px solid ${COLORS.cardBorder};
 flex-wrap: wrap;
}

.acquire-quick-actions button {
 padding: 8px 16px;
 background: white;
 border: 1px solid ${COLORS.cardBorder};
 border-radius: 20px;
 cursor: pointer;
 font-size: 13px;
 transition: all 0.2s;
}

.acquire-quick-actions button:hover {
 background: ${COLORS.navy};
 color: white;
 border-color: ${COLORS.navy};
}

/* V33: Application History Panel */
.app-history-panel {
 background: white;
 border-radius: 12px;
 padding: 16px;
 margin-top: 12px;
 border: 1px solid ${COLORS.cardBorder};
 max-height: 300px;
 overflow-y: auto;
}
.app-history-list {
 display: flex;
 flex-direction: column;
 gap: 8px;
}
.app-history-item {
 padding: 12px;
 background: ${COLORS.pearl};
 border-radius: 8px;
 cursor: pointer;
 transition: all 0.2s;
}
.app-history-item:hover {
 background: rgba(184, 115, 51, 0.1);
 transform: translateX(4px);
}
.app-history-org {
 font-weight: 600;
 color: ${COLORS.navy};
 font-size: 14px;
}
.app-history-details {
 font-size: 12px;
 color: ${COLORS.textBody};
 margin-top: 4px;
}

/* Toast Types */
.toast.success {
 background: ${COLORS.success};
}

.toast.error {
 background: ${COLORS.error};
}

@media (max-width: 768px) {
 .acquire-tab {
 height: 500px;
 }
 .acquire-message {
 max-width: 95%;
 }
 .acquire-quick-actions {
 justify-content: center;
 }
}

/* V29: Pitch Deck Preview Modal */
.pitch-preview-overlay {
 position: fixed;
 top: 0;
 left: 0;
 width: 100%;
 height: 100%;
 background: rgba(25, 25, 112, 0.85);
 backdrop-filter: blur(10px);
 display: flex;
 align-items: center;
 justify-content: center;
 z-index: 2000;
}

.pitch-preview-modal {
 width: 90%;
 max-width: 1200px;
 height: 85vh;
 background: white;
 border-radius: 20px;
 overflow: hidden;
 display: flex;
 flex-direction: column;
 box-shadow: 0 30px 100px rgba(0, 0, 0, 0.5);
}

.pitch-preview-header {
 display: flex;
 justify-content: space-between;
 align-items: center;
 padding: 16px 24px;
 background: linear-gradient(135deg, ${COLORS.navy}, #2a2a8a);
 color: white;
}

.pitch-preview-header h3 {
 margin: 0;
 font-size: 18px;
}

.pitch-preview-actions {
 display: flex;
 gap: 12px;
 align-items: center;
}

.pitch-download-btn {
 padding: 10px 20px;
 background: linear-gradient(135deg, ${COLORS.copper}, #D4A574);
 color: white;
 border: none;
 border-radius: 10px;
 cursor: pointer;
 font-weight: 600;
 font-size: 14px;
 transition: all 0.2s;
}

.pitch-download-btn:hover {
 transform: translateY(-2px);
 box-shadow: 0 4px 15px rgba(184, 115, 51, 0.4);
}

.pitch-close-btn {
 width: 40px;
 height: 40px;
 background: rgba(255, 255, 255, 0.2);
 border: none;
 border-radius: 50%;
 color: white;
 font-size: 24px;
 cursor: pointer;
 display: flex;
 align-items: center;
 justify-content: center;
 transition: all 0.2s;
}

.pitch-close-btn:hover {
 background: rgba(255, 255, 255, 0.3);
 transform: scale(1.1);
}

.pitch-preview-frame {
 flex: 1;
 background: #f5f5f5;
 padding: 20px;
 overflow: hidden;
}

.pitch-preview-frame iframe {
 width: 100%;
 height: 100%;
 border: none;
 border-radius: 8px;
 background: white;
 box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
}

/* Back to Top Button */
.back-to-top {
 position: fixed;
 bottom: 30px;
 right: 30px;
 width: 56px;
 height: 56px;
 background: ${COLORS.primary};
 color: white;
 border: 3px solid ${COLORS.secondary};
 border-radius: 50%;
 cursor: pointer;
 font-size: 28px;
 font-weight: bold;
 display: flex;
 align-items: center;
 justify-content: center;
 box-shadow: 0 4px 20px rgba(25, 25, 112, 0.5);
 transition: all 0.3s ease;
 z-index: 1000;
 opacity: 0;
 visibility: hidden;
 transform: translateY(20px);
}

.back-to-top.visible {
 opacity: 1;
 visibility: visible;
 transform: translateY(0);
}

.back-to-top:hover {
 transform: translateY(-3px);
 box-shadow: 0 8px 25px rgba(25, 25, 112, 0.6);
 background: ${COLORS.secondary};
}

@media (max-width: 768px) {
 .back-to-top {
 bottom: 20px;
 right: 20px;
 width: 50px;
 height: 50px;
 font-size: 24px;
 }
}
`;

// End of Spurt 3
// ============================================
// SECTION 10: HELPER FUNCTIONS
// ============================================

// Detect client from text
const detectClient = (text) => {
 const lower = text.toLowerCase();
 if (lower.includes('kopp') || lower.includes('diabetes')) {
 return { name: 'KOPP Foundation', contacts: ['Max', 'Sabrina', 'Rachel', 'Shandon'] };
 }
 if (lower.includes('dawkins') || lower.includes('bdif')) {
 return { name: 'Brian Dawkins Impact Foundation', contacts: ['Brian Dawkins'] };
 }
 if (lower.includes('mcw')) {
 return { name: 'MCW Global', contacts: ['Khalid Elachi', 'Sharon Matongo', 'Regina Leichner', 'Eddie'] };
 }
 if (lower.includes('514') || lower.includes('memorial') || lower.includes('buffalo')) {
 return { name: '514 Memorial Foundation', contacts: [] };
 }
 if (lower.includes('trey') || lower.includes('flowers')) {
 return { name: 'Trey Flowers Foundation', contacts: ['Trey Flowers'] };
 }
 if (lower.includes('dream center') || lower.includes('forsyth')) {
 return { name: 'Dream Center of Forsyth County', contacts: ['Chris Leab'] };
 }
 return null;
};

// ============================================
// SECTION 10.5: V26 CREATE OUTPUT CLEANER
// Applies same standards as AI Check BEFORE delivering
// ============================================

const cleanCreateOutput = (text) => {
 let cleaned = text;
 
 // CRITICAL: Remove em dashes
 cleaned = cleaned.replace(/\u2014/g, ', ');
 cleaned = cleaned.replace(/--/g, ', ');
 
 // Remove CTA endings
 const ctaEndings = [
 /Looking forward to hearing from you\.?/gi,
 /Please don't hesitate to reach out\.?/gi,
 /Let me know if you want to meet and discuss\.?/gi,
 /At your earliest convenience\.?/gi,
 /I would be happy to schedule a call\.?/gi,
 /Feel free to reach out anytime\.?/gi,
 /Let me know if you have any questions\.?/gi,
 /Let me know if you have questions\.?/gi,
 /Happy to hop on a call\.?/gi,
 /Don't hesitate to contact me\.?/gi,
 /Please don't hesitate\.?/gi,
 /Feel free to\.?/gi,
 /If you have any questions\.?/gi
 ];
 
 for (const cta of ctaEndings) {
 cleaned = cleaned.replace(cta, '');
 }
 
 // Replace banned AI phrases
 const replacements = [
 { from: /Here's the thing[,:]?\s*/gi, to: '' },
 { from: /genuinely appreciate/gi, to: 'appreciate' },
 { from: /really appreciate/gi, to: 'appreciate' },
 { from: /truly appreciate/gi, to: 'appreciate' },
 { from: /deeply appreciate/gi, to: 'appreciate' },
 { from: /deeply resonated/gi, to: 'connected' },
 { from: /\bresonated\b/gi, to: 'connected' },
 { from: /profoundly impacted/gi, to: 'helped' },
 { from: /I'd be happy to/gi, to: 'I can' },
 { from: /I'd be delighted to/gi, to: 'I can' },
 { from: /Allow me to/gi, to: 'Let me' },
 { from: /Furthermore,?\s*/gi, to: 'Also, ' },
 { from: /Additionally,?\s*/gi, to: 'Also, ' },
 { from: /In conclusion,?\s*/gi, to: '' },
 { from: /I hope this email finds you well\.?\s*/gi, to: '' },
 { from: /per our conversation/gi, to: 'as we discussed' },
 { from: /moving forward/gi, to: 'going forward' },
 { from: /I wanted to reach out/gi, to: '' },
 { from: /left our call excited/gi, to: '' },
 { from: /walked away feeling energized/gi, to: '' },
 { from: /walked away from our conversation feeling\s*/gi, to: '' },
 { from: /means a lot/gi, to: '' },
 { from: /\balignment\b/gi, to: 'agreement' },
 { from: /\baligned\b/gi, to: 'agree' },
 { from: /very thankful/gi, to: '' },
 { from: /I'm really glad/gi, to: 'Glad' },
 { from: /really glad/gi, to: 'glad' },
 { from: /communication and transparency/gi, to: '' },
 { from: /thoughtful note/gi, to: 'note' },
 { from: /thoughtful message/gi, to: 'message' },
 { from: /feeling energized/gi, to: '' },
 { from: /so hearing that/gi, to: '' },
 { from: /I'm looking forward to the next steps\.?\s*/gi, to: '' },
 { from: /looking forward to the next steps\.?\s*/gi, to: '' },
 { from: /excited to get started/gi, to: '' },
 { from: /and excited to\s*/gi, to: '' },
 { from: /\banalysis\b/gi, to: 'review' },
 { from: /\banalyze\b/gi, to: 'look at' },
 { from: /\bleverage\b/gi, to: 'use' },
 { from: /\butilize\b/gi, to: 'use' },
 { from: /\bsynergize\b/gi, to: 'work together' },
 { from: /\bideate\b/gi, to: 'brainstorm' },
 { from: /drill down/gi, to: 'look deeper' },
 { from: /circle back/gi, to: 'follow up' },
 { from: /touch base/gi, to: 'check in' },
 { from: /deep dive/gi, to: 'close look' },
 // V26 AI Detection fixes
 { from: /: both/gi, to: '. Both' }, // Colons to periods
 { from: /: the/gi, to: '. The' },
 { from: /: this/gi, to: '. This' },
 { from: /primarily due to the fact that/gi, to: 'because' },
 { from: /it is important to note that/gi, to: '' },
 { from: /in light of/gi, to: 'given' },
 { from: /with regard to/gi, to: 'about' },
 { from: /the aforementioned/gi, to: 'this' },
 { from: /in order to/gi, to: 'to' },
 { from: /due to the fact that/gi, to: 'because' },
 { from: /in the event that/gi, to: 'if' },
 { from: /at this point in time/gi, to: 'now' },
 { from: /take into consideration/gi, to: 'consider' }
 ];
 
 for (const { from, to } of replacements) {
 cleaned = cleaned.replace(from, to);
 }
 
 // Clean up double spaces and empty lines
 cleaned = cleaned.replace(/\s+\./g, '.');
 cleaned = cleaned.replace(/,\s*,/g, ',');
 cleaned = cleaned.replace(/\.\s*\./g, '.');
 cleaned = cleaned.replace(/ +/g, ' ');
 cleaned = cleaned.replace(/\n\n\n+/g, '\n\n');
 
 // Ensure contractions (AI detection avoidance)
 cleaned = cleaned.replace(/\bI am\b/g, "I'm");
 cleaned = cleaned.replace(/\bwe are\b/g, "we're");
 cleaned = cleaned.replace(/\bthey are\b/g, "they're");
 cleaned = cleaned.replace(/\bit is\b/g, "it's");
 cleaned = cleaned.replace(/\bthat is\b/g, "that's");
 cleaned = cleaned.replace(/\bdo not\b/g, "don't");
 cleaned = cleaned.replace(/\bdoes not\b/g, "doesn't");
 cleaned = cleaned.replace(/\bwill not\b/g, "won't");
 cleaned = cleaned.replace(/\bcannot\b/g, "can't");
 cleaned = cleaned.replace(/\bI have\b/g, "I've");
 cleaned = cleaned.replace(/\bwe have\b/g, "we've");
 cleaned = cleaned.replace(/\bthey have\b/g, "they've");
 
 return cleaned.trim();
};

// ============================================
// SECTION 11: AI CHECK FUNCTION (WITH SEVERITY)
// V37.7: Now extracts patterns from GMG_WRITING_STANDARDS
// ============================================

// V37.7: Helper function to extract banned phrases from GMG_WRITING_STANDARDS
const extractBannedPhrasesFromStandards = () => {
 // Parse the GMG_WRITING_STANDARDS string to extract banned phrases
 // This ensures runAICheck stays in sync with the standards document
 const bannedPhrases = [];
 
 // Extract phrases from the BANNED AI PHRASES section
 const banPatterns = [
 { phrase: 'Here\'s the thing', reason: 'Most AI phrase ever', replace: '' },
 { phrase: 'genuinely appreciate', reason: 'Too formal', replace: 'appreciate' },
 { phrase: 'deeply resonated', reason: 'AI language', replace: 'connected' },
 { phrase: 'profoundly impacted', reason: 'AI language', replace: 'helped' },
 { phrase: 'I\'d be happy to', reason: 'Robotic', replace: 'I can' },
 { phrase: 'Allow me to', reason: 'Overly formal', replace: 'Let me' },
 { phrase: 'Furthermore', reason: 'Academic', replace: 'Also' },
 { phrase: 'Additionally', reason: 'Corporate', replace: 'Also' },
 { phrase: 'In conclusion', reason: 'Essay language', replace: '' },
 { phrase: 'left our call excited', reason: 'SUPER BAN from standards', replace: '' },
 { phrase: 'walked away feeling', reason: 'AI language', replace: '' }
 ];
 
 // Add dynamic extraction from GMG_WRITING_STANDARDS
 // Look for common banned phrase patterns in the standards
 if (GMG_WRITING_STANDARDS.includes('consider')) {
 banPatterns.push({ phrase: 'consider', reason: 'From GMG_WRITING_STANDARDS: feels fake', replace: '' });
 }
 if (GMG_WRITING_STANDARDS.includes('leverage')) {
 banPatterns.push({ phrase: 'leverage', reason: 'From standards: use specific verb', replace: 'use' });
 }
 if (GMG_WRITING_STANDARDS.includes('utilize')) {
 banPatterns.push({ phrase: 'utilize', reason: 'From standards: use "use"', replace: 'use' });
 }
 if (GMG_WRITING_STANDARDS.includes('synergize')) {
 banPatterns.push({ phrase: 'synergize', reason: 'From standards', replace: '' });
 }
 if (GMG_WRITING_STANDARDS.includes('touch base')) {
 banPatterns.push({ phrase: 'touch base', reason: 'From standards', replace: 'check in' });
 }
 if (GMG_WRITING_STANDARDS.includes('circle back')) {
 banPatterns.push({ phrase: 'circle back', reason: 'From standards', replace: 'follow up' });
 }
 
 return banPatterns;
};

// Cache the extracted patterns for performance
const EXTRACTED_BANNED_PHRASES = extractBannedPhrasesFromStandards();

const runAICheck = (text, includeFactCheck = true, customPhrases = []) => {
 const issues = [];
 let issueId = 0;
 
 // V37.7: Reference source for banned patterns
 // These patterns are synced with GMG_WRITING_STANDARDS
 // CRITICAL: Em dashes (Brandon would fire you)
 if (text.includes('') || text.includes('--')) {
 const count = (text.match(/|--/g) || []).length;
 issues.push({
 id: ++issueId,
 severity: 'critical',
 fires: 5,
 type: 'Em Dash',
 message: 'Em dashes found. Brandon will fire you over this.',
 original: '',
 replacement: ', (comma)',
 accepted: true
 });
 }
 
 // V3.6: Check custom banned phrases FIRST
 for (const { phrase, reason, replace } of customPhrases) {
 if (phrase && text.toLowerCase().includes(phrase.toLowerCase())) {
 issues.push({
 id: ++issueId,
 severity: 'high',
 fires: 4,
 type: 'Custom Rule',
 message: reason || 'Custom banned phrase',
 original: phrase,
 replacement: replace || '(remove)',
 accepted: true
 });
 }
 }
 
 // HIGH: CTA endings
 const ctaEndings = [
 'Looking forward to hearing from you',
 'Please don\'t hesitate to reach out',
 'Let me know if you want to meet and discuss',
 'At your earliest convenience',
 'I would be happy to schedule a call',
 'Feel free to reach out anytime',
 'Let me know if you have any questions',
 'Let me know if you have questions',
 'Happy to hop on a call',
 'Don\'t hesitate to contact me'
 ];
 
 for (const cta of ctaEndings) {
 if (text.toLowerCase().includes(cta.toLowerCase())) {
 issues.push({
 id: ++issueId,
 severity: 'high',
 fires: 4,
 type: 'CTA Ending',
 message: 'Call-to-action ending found. Just end simply.',
 original: cta,
 replacement: '(remove entirely)',
 accepted: true
 });
 }
 }
 
 // MEDIUM: Banned AI phrases - with actual replacements
 const bannedPhrases = [
 { phrase: 'Here\'s the thing', reason: 'Most AI phrase ever', replace: '' },
 { phrase: 'genuinely appreciate', reason: 'Too formal', replace: 'appreciate' },
 { phrase: 'really appreciate', reason: 'Too formal', replace: 'appreciate' },
 { phrase: 'truly appreciate', reason: 'Too formal', replace: 'appreciate' },
 { phrase: 'deeply appreciate', reason: 'Too formal', replace: 'appreciate' },
 { phrase: 'deeply resonated', reason: 'AI language', replace: 'connected' },
 { phrase: 'resonated', reason: 'AI language', replace: 'connected' },
 { phrase: 'profoundly impacted', reason: 'AI language', replace: 'helped' },
 { phrase: 'I\'d be happy to', reason: 'Robotic, just state action', replace: 'I can' },
 { phrase: 'I\'d be delighted to', reason: 'Robotic', replace: 'I can' },
 { phrase: 'Allow me to', reason: 'Overly formal', replace: 'Let me' },
 { phrase: 'Furthermore', reason: 'Academic', replace: 'Also' },
 { phrase: 'Additionally', reason: 'Corporate', replace: 'Also' },
 { phrase: 'In conclusion', reason: 'Essay language', replace: '' },
 { phrase: 'I hope this email finds you well', reason: 'Corporate garbage', replace: '' },
 { phrase: 'per our conversation', reason: 'Corporate speak', replace: 'as we discussed' },
 { phrase: 'moving forward', reason: 'Corporate speak', replace: 'going forward' },
 { phrase: 'I wanted to reach out', reason: 'AI opener', replace: '' },
 { phrase: 'left our call excited', reason: 'SUPER BAN', replace: '' },
 { phrase: 'walked away feeling energized', reason: 'AI language', replace: '' },
 { phrase: 'walked away from our conversation feeling', reason: 'AI language', replace: '' },
 { phrase: 'means a lot', reason: 'AI redundancy', replace: '' },
 { phrase: 'alignment', reason: 'Corporate AI speak', replace: 'agreement' },
 { phrase: 'aligned', reason: 'Corporate AI speak', replace: 'agree' },
 { phrase: 'very thankful', reason: 'Redundant with appreciate', replace: '' },
 { phrase: 'really glad', reason: 'AI filler', replace: 'glad' },
 { phrase: 'I\'m really glad', reason: 'AI filler', replace: 'Glad' },
 { phrase: 'transparency', reason: 'Corporate speak', replace: 'openness' },
 { phrase: 'communication and transparency', reason: 'Corporate AI combo', replace: '' },
 { phrase: 'thoughtful note', reason: 'AI compliment', replace: 'note' },
 { phrase: 'thoughtful message', reason: 'AI compliment', replace: 'message' },
 { phrase: 'feeling energized', reason: 'AI language', replace: '' },
 { phrase: 'so hearing that', reason: 'AI connector', replace: '' },
 { phrase: 'I\'m looking forward to the next steps', reason: 'AI closer', replace: '' },
 { phrase: 'looking forward to the next steps', reason: 'AI closer', replace: '' },
 { phrase: 'excited to get started', reason: 'AI enthusiasm', replace: '' },
 { phrase: 'and excited to', reason: 'AI filler enthusiasm', replace: '' },
 { phrase: 'please don\'t hesitate', reason: 'CTA garbage', replace: '' },
 { phrase: 'feel free to', reason: 'CTA garbage', replace: '' },
 { phrase: 'if you have any questions', reason: 'CTA garbage', replace: '' }
 ];
 
 for (const { phrase, reason, replace } of bannedPhrases) {
 if (text.toLowerCase().includes(phrase.toLowerCase())) {
 issues.push({
 id: ++issueId,
 severity: 'medium',
 fires: 3,
 type: 'AI Phrase',
 message: reason,
 original: phrase,
 replacement: replace || '(remove)',
 accepted: true
 });
 }
 }
 
 // V37.7: Also check patterns extracted from GMG_WRITING_STANDARDS
 for (const { phrase, reason, replace } of EXTRACTED_BANNED_PHRASES) {
 // Avoid duplicates (only add if not already found)
 const alreadyFound = issues.some(i => i.original.toLowerCase() === phrase.toLowerCase());
 if (!alreadyFound && text.toLowerCase().includes(phrase.toLowerCase())) {
 issues.push({
 id: ++issueId,
 severity: 'medium',
 fires: 3,
 type: 'AI Phrase (Standards)',
 message: reason,
 original: phrase,
 replacement: replace || '(remove)',
 accepted: true
 });
 }
 }
 
 // LOW: Tech jargon
 const techJargon = [
 { banned: 'analysis', replace: 'review' },
 { banned: 'analyze', replace: 'look at' },
 { banned: 'leverage', replace: 'use' },
 { banned: 'utilize', replace: 'use' },
 { banned: 'synergize', replace: '(describe directly)' },
 { banned: 'ideate', replace: 'brainstorm' },
 { banned: 'drill down', replace: 'look deeper' },
 { banned: 'circle back', replace: 'follow up' },
 { banned: 'touch base', replace: 'check in' },
 { banned: 'deep dive', replace: 'close look' }
 ];
 
 for (const { banned, replace } of techJargon) {
 if (text.toLowerCase().includes(banned.toLowerCase())) {
 issues.push({
 id: ++issueId,
 severity: 'low',
 fires: 2,
 type: 'Tech Jargon',
 message: `"${banned}" is tech jargon`,
 original: banned,
 replacement: replace,
 accepted: true
 });
 }
 }
 
 // ============================================
 // V2.1: SLANG DETECTION - BrandonBeatAi.md Section 6
 // ============================================
 const slangPhrases = [
 { banned: 'fired up', replace: 'motivated', reason: 'Slang - unprofessional' },
 { banned: 'gets me fired up', replace: 'motivates me', reason: 'Slang + AI enthusiasm' },
 { banned: 'what really gets me', replace: '', reason: 'AI enthusiasm opener' },
 { banned: 'stuff', replace: 'work', reason: 'Slang - use specific noun' },
 { banned: 'holds that down', replace: 'manages', reason: 'Slang' },
 { banned: 'grind', replace: 'work', reason: 'Slang' },
 { banned: 'vibes', replace: 'tone', reason: 'Slang' },
 { banned: 'dope', replace: '', reason: 'Slang' },
 { banned: 'lit', replace: '', reason: 'Slang' },
 ];

 for (const { banned, replace, reason } of slangPhrases) {
 const regex = new RegExp(`\\b${banned}\\b`, 'gi');
 if (regex.test(text)) {
 issues.push({
 id: ++issueId,
 severity: 'medium',
 fires: 3,
 type: 'Slang',
 message: reason,
 original: banned,
 replacement: replace || '(remove)',
 accepted: true
 });
 }
 }

 // ============================================
 // V2.1: META-COMMENTARY DETECTION
 // ============================================
 const metaPatterns = [
 { pattern: "here's what", reason: 'Announcing instead of saying - just say it' },
 { pattern: "below you'll find", reason: 'Meta-commentary' },
 { pattern: "i've organized this", reason: 'Meta-commentary' },
 { pattern: 'the following represents', reason: 'Meta-commentary' },
 { pattern: 'in this email, i wanted', reason: 'Meta-commentary' },
 { pattern: 'let me walk you through', reason: 'Meta-commentary' },
 { pattern: 'this document outlines', reason: 'Meta-commentary' },
 { pattern: "i'm writing to", reason: 'Meta-commentary - just write' },
 { pattern: 'i wanted to share', reason: 'Meta-commentary' },
 ];

 for (const { pattern, reason } of metaPatterns) {
 if (text.toLowerCase().includes(pattern)) {
 issues.push({
 id: ++issueId,
 severity: 'medium',
 fires: 3,
 type: 'Meta-Commentary',
 message: reason,
 original: pattern,
 replacement: '(just say it directly)',
 accepted: true
 });
 }
 }

 // ============================================
 // V2.1: EXPANDED CTA DETECTION (Regex Patterns)
 // ============================================
 const ctaRegexPatterns = [
 { pattern: /i hope (we can|to) (talk|connect|meet|chat)/i, reason: 'Soft CTA pattern' },
 { pattern: /i'd love to (connect|chat|meet|talk)/i, reason: 'CTA phrase' },
 { pattern: /let's (connect|chat|meet|talk|discuss)/i, reason: 'CTA phrase' },
 { pattern: /would love to (connect|hear|chat|discuss)/i, reason: 'CTA phrase' },
 { pattern: /hope to (hear|talk|connect|chat)/i, reason: 'CTA phrase' },
 { pattern: /looking forward to (hearing|connecting|talking|discussing)/i, reason: 'CTA ending' },
 { pattern: /i hope we can talk more/i, reason: 'CTA ending' },
 ];

 for (const { pattern, reason } of ctaRegexPatterns) {
 const match = text.match(pattern);
 if (match) {
 const alreadyCaught = issues.some(i => 
 i.type === 'CTA Ending' && 
 i.original.toLowerCase() === match[0].toLowerCase()
 );
 if (!alreadyCaught) {
 issues.push({
 id: ++issueId,
 severity: 'high',
 fires: 4,
 type: 'CTA Pattern',
 message: reason,
 original: match[0],
 replacement: '(remove - just end with Thanks,)',
 accepted: true
 });
 }
 }
 }
 
 // Check for multiple signatures
 const signaturePatterns = ['Best regards', 'Sincerely', 'Warm regards', 'Kind regards', 'Best,', 'Thanks,'];
 let signatureCount = 0;
 for (const sig of signaturePatterns) {
 if (text.includes(sig)) signatureCount++;
 }
 if (signatureCount > 1) {
 issues.push({
 id: ++issueId,
 severity: 'medium',
 fires: 3,
 type: 'Multiple Signatures',
 message: 'Only use one closing/signature',
 original: 'multiple closings',
 replacement: '(use single closing)',
 accepted: true
 });
 }
 
 // Check for multiple thank yous
 const thankMatches = text.match(/thank you|thanks|thankful|grateful|appreciate/gi) || [];
 if (thankMatches.length > 2) {
 issues.push({
 id: ++issueId,
 severity: 'low',
 fires: 2,
 type: 'Excessive Gratitude',
 message: `${thankMatches.length} expressions of gratitude (max 2)`,
 original: `${thankMatches.length} thank yous`,
 replacement: '(reduce to 1-2)',
 accepted: true
 });
 }
 
 // Check for choppy sentences (period-space-capital pattern)
 const sentences = text.split(/[.!?]+/).filter(s => s.trim().length > 0);
 const shortSentences = sentences.filter(s => s.trim().split(' ').length < 6);
 if (shortSentences.length >= 3 && shortSentences.length > sentences.length * 0.5) {
 issues.push({
 id: ++issueId,
 severity: 'low',
 fires: 2,
 type: 'Choppy Style',
 message: 'Too many short choppy sentences. Connect with commas for flow.',
 original: 'short sentences',
 replacement: '(combine with commas)',
 accepted: true
 });
 }
 
 // Check greeting format (name without greeting)
 const nameOnlyPattern = /^[A-Z][a-z]+,\s*\n/;
 if (nameOnlyPattern.test(text)) {
 issues.push({
 id: ++issueId,
 severity: 'medium',
 fires: 3,
 type: 'Missing Greeting',
 message: 'Start with greeting before name (Hey Eric, not Eric,)',
 original: 'Name,',
 replacement: 'Hey Name,',
 accepted: true
 });
 }
 
 const hasCritical = issues.some(i => i.severity === 'critical');
 const hasHigh = issues.some(i => i.severity === 'high');
 
 // Add fact-check errors if enabled
 const factErrors = findFactErrors(text, includeFactCheck);
 const allIssues = [...issues, ...factErrors];
 
 const hasFactErrors = factErrors.length > 0;
 const status = hasCritical || hasHigh ? 'needs-work' : 
 (allIssues.length > 0 ? 'minor-issues' : 'approved');
 
 return { 
 issues: allIssues, 
 status,
 factCheckRan: includeFactCheck && !isObviouslyNotGMGRelated(text),
 factErrorCount: factErrors.length
 };
};

// Generate corrected version based on accepted changes
const generateCorrectedVersion = (text, issues) => {
 let corrected = text;
 
 for (const issue of issues) {
 if (!issue.accepted) continue;
 
 // Em dashes
 if (issue.type === 'Em Dash') {
 corrected = corrected.replace(/\u2014/g, ', ');
 corrected = corrected.replace(/--/g, ', ');
 }
 
 // CTA endings - remove them
 if (issue.type === 'CTA Ending') {
 const regex = new RegExp(issue.original.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '\\.?\\s*', 'gi');
 corrected = corrected.replace(regex, '');
 }
 
 // AI Phrase - replace or remove
 if (issue.type === 'AI Phrase') {
 const escapedOriginal = issue.original.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
 const regex = new RegExp(escapedOriginal, 'gi');
 if (issue.replacement === '(remove)' || issue.replacement === '') {
 // Remove the phrase and clean up any resulting double spaces (but preserve newlines)
 corrected = corrected.replace(regex, '');
 corrected = corrected.replace(/[ \t]+/g, ' ');
 } else {
 corrected = corrected.replace(regex, issue.replacement);
 }
 }
 
 // Tech jargon - replace
 if (issue.type === 'Tech Jargon' && issue.replacement !== '(describe directly)') {
 const regex = new RegExp(`\\b${issue.original}\\b`, 'gi');
 corrected = corrected.replace(regex, issue.replacement);
 }
 
 // Excessive Gratitude - just note, can't auto-fix
 // Choppy Style - just note, can't auto-fix
 
 // Fact-check corrections - Name Spelling, Organization Name, Statistic Error, Methodology Name
 if (['Name Spelling', 'Organization Name', 'Statistic Error', 'Methodology Name'].includes(issue.type)) {
 const regex = new RegExp(issue.original.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'gi');
 corrected = corrected.replace(regex, issue.replacement);
 }
 
 // Title Error - more complex replacement (replace wrong title with correct one in context)
 if (issue.type === 'Title Error') {
 const regex = new RegExp(`\\b${issue.original}\\b`, 'gi');
 corrected = corrected.replace(regex, issue.replacement);
 }
 }
 
 // Clean up double spaces and weird punctuation from removals (preserve newlines)
 corrected = corrected.replace(/[ \t]+/g, ' '); // Only replace spaces/tabs, not newlines
 corrected = corrected.replace(/ +\./g, '.');
 corrected = corrected.replace(/ +,/g, ',');
 corrected = corrected.replace(/,\s*,/g, ',');
 
 return corrected.trim();
};

// ============================================
// SECTION 11B: INTELLIGENT REWRITE IN BRANDON'S VOICE
// V2.1: Now accepts tier parameter for context-aware rewriting
// ============================================

const rewriteInBrandonVoice = async (originalText, issues, tier = 'B') => {
 // V2.1: Tier D = flag only, no rewrite
 if (tier === 'D') {
 return { 
 success: true, 
 content: originalText, 
 tierUsed: 'D',
 message: 'No changes made (Flag Only mode)' 
 };
 }

 // Build a summary of issues found
 const issuesSummary = issues.map(i => `- ${i.type}: "${i.original}" ${i.replacement ? `should be "${i.replacement}"` : ''}`).join('\n');
 
 // V2.1: Tier-specific instructions
 const tierInstructions = {
 A: `TIER A - HAVE BRANDON GO CRAZY AND CHANGE EVERYTHING:
You are rewriting this to sound EXACTLY like Brandon Pierce wrote it.
- Remove ALL AI-sounding phrases, even subtle ones like "It means a lot"
- Remove ALL soft CTAs like "I hope we can connect" or "I'd love to chat"
- Connect choppy sentences with commas for natural flow
- Remove all meta-commentary ("here's what...", "I wanted to share...")
- Break any parallel structure
- Make it conversational and direct
- Reduce gratitude expressions to 1 max
The result should pass the copy-paste test.`,

 B: `TIER B - MARK UP ONLY THE AI THINGS:
You are cleaning this content while KEEPING the professional tone and warmth.
- Remove obvious AI tells (genuinely, deeply resonated, walked away feeling)
- KEEP phrases like "It means a lot" if context is formal (donor letter, thank you)
- KEEP soft CTAs like "I hope we can connect" if appropriate
- Fix tech jargon (leverage -> use)
- Maintain original length and warmth
Do NOT strip humanity from formal letters.`,

 C: `TIER C - JUST FIX THE STUFF THAT'LL GET ME FIRED:
MINIMAL changes only. ONLY fix:
- Em dashes and double dashes -> commas
- Explicit CTAs like "let me know if you have questions" -> remove
- Slang like "fired up", "stuff" -> professional words
- "Here's the thing" -> remove
Leave EVERYTHING else exactly as written.`
 };

 const rewritePrompt = `${tierInstructions[tier] || tierInstructions.B}

ORIGINAL CONTENT:
${originalText}

ISSUES DETECTED:
${issuesSummary || 'None flagged, apply tier rules'}

ALWAYS FIX (any tier):
- Em dashes/double dashes -> commas
- Slang: "fired up" -> "motivated", "stuff" -> specific noun
- "Here's the thing" -> remove

OUTPUT RULES:
- Output ONLY rewritten content
- No explanations or markdown
- Preserve line breaks
- Don't add new content

=== GMG WRITING STANDARDS ===

THE COPY-PASTE TEST: Can Brandon copy it, paste it, and send it immediately without editing? If no, you failed.

CARDINAL SINS (Brandon will fire over these):
1. Em dashes ( - ) or double dashes (--) - COMPLETELY BANNED
2. Starting with just name "Eric," instead of "Hey Eric,"
3. CTA endings like "Let me know if you have questions"

BANNED PHRASES (never use):
- "genuinely appreciate" or "really appreciate" or "truly appreciate" -> just use "appreciate" once
- "Thank you so much" -> just "Thank you" or "Thanks"
- "I am very thankful for it" -> redundant if you already said thanks
- "walked away feeling energized" or "left our call excited" -> SUPER BAN
- "thoughtful note" or "thoughtful message" -> just "note" or "message"
- "Hope you and yours" -> too formal, say "Hope you have a great..."
- "means a lot" -> cut it
- "resonated" or "deeply resonated" -> say "connected" or cut it
- "Heres the thing" -> most AI phrase ever
- "Furthermore" or "Additionally" or "In conclusion" -> academic garbage
- "Id be happy to" or "Id be delighted to" -> just state what you will do
- "Totally agree" -> no human writes this

REDUNDANCY IS THE ENEMY:
- ONE thank you per message max
- ONE expression of excitement max
- Don't say the same thing 3 ways (this is what makes AI obvious)

REQUIRED STYLE:
- Warm, friendly, professional - like talking at a coffee shop
- Complete sentences that flow naturally (connect with commas, not choppy fragments)
- Middle school reading level
- Simple closings: "Thanks," or "Best," only
- Varied sentence lengths

SIGNATURE/TITLE FIX:
- Eli Cooley (Elizjai Q. Cooley) = Lane-Pierce Fellow, NOT "Founder of GMG"
- If you see "Founder of GMG" or "CEO" or "President" for Eli, change to "Lane-Pierce Fellow"
- Keep signature name exactly (don't change Eli to Brandon)

EXACT EXAMPLE FROM BRANDON'S STANDARDS (DO NOT OUTPUT THIS - IT'S JUST AN EXAMPLE):

BAD (EXAMPLE ONLY - NEVER OUTPUT THIS):
"Hey Brandon, Thank you so much for the thoughtful note - and no worries at all about the timing. I genuinely appreciate the communication and transparency; I am very thankful for it. I am really glad to hear the alignment on your end as well. I walked away from our conversation feeling energized about what we could build together, so hearing that it resonated similarly on your side means a lot. I am looking forward to the next steps and excited to get started. I will keep an eye out for the official fellowship contract. Hope you and yours have a wonderful Thanksgiving!"

GOOD (EXAMPLE ONLY - NEVER OUTPUT THIS):
"Hey Brandon, Thank you for the note, and no worries at all about the timing. I appreciate the communication and openness. I'm glad to hear the agreement on your end as well. Our conversation left me excited about what we could build together. I'm looking forward to the next steps. I'll keep an eye out for the official fellowship contract. Have a wonderful Thanksgiving!

Best,
Eli"

CRITICAL: The examples above are ONLY for understanding the style. NEVER output these examples. Rewrite the ORIGINAL CONTENT provided below - do not output any example text.

WHY THE GOOD VERSION WORKS:
- No em dash
- "Thank you" once (not "thank you so much" + "genuinely appreciate" + "very thankful")
- "appreciate" used once simply
- "alignment" -> "agreement" (less corporate)
- "transparency" -> "openness" (less corporate)
- "walked away feeling energized" completely removed (SUPER BAN)
- "resonated similarly on your side means a lot" completely removed (redundant)
- "Hope you and yours" -> "Have a wonderful" (less formal)
- Flows naturally, warm but not gushing

Output ONLY the rewritten content. No explanations. No meta-commentary. No markdown.
PRESERVE ALL LINE BREAKS from the original email. Keep the structure: greeting, body paragraphs, closing, signature - each on their own line.

ABSOLUTE RULES:
1. Do NOT add ANY new content that wasn't in the original
2. Do NOT add titles, roles, or affiliations to signatures (no "Founder of GMG", no "Lane-Pierce Fellow", nothing)
3. Do NOT add extra spaces or formatting
4. If the original signature is just a name, keep it as just a name
5. If they wrote "Thanksgiving", keep it as "Thanksgiving"
6. NEVER add jokes, hobbies, company names, or ANY text that wasn't there

YOU ARE ONLY ALLOWED TO:
- Remove banned phrases
- Replace em dashes with commas
- Simplify redundant expressions
- Fix corporate jargon
- Remove excessive gratitude

IF IN DOUBT, LEAVE IT ALONE. Less editing is better than adding garbage.`;

 try {
 const response = await fetch("https://api.anthropic.com/v1/messages", {
 method: "POST",
 headers: getApiHeaders(),
 body: JSON.stringify({
 model: MODEL_CONFIG.fast,
 max_tokens: 2000,
 messages: [{ role: "user", content: rewritePrompt }]
 })
 });
 
 if (!response.ok) {
 throw new Error('API request failed');
 }
 
 const data = await response.json();
 let content = data.content?.[0]?.text || "";
 
 // Strip any markdown that might slip through
 content = content.replace(/\*\*/g, '');
 content = content.replace(/##\s*/g, '');
 content = content.replace(/###\s*/g, '');
 content = content.replace(/`([^`]+)`/g, '$1');
 
 // V38.6: Return object format for consistent handling
 return { success: true, content: content.trim(), tierUsed: tier };
 } catch (error) {
 devError('Rewrite API error:', error);
 // Fall back to basic correction if API fails
 return { success: false, content: generateCorrectedVersion(originalText, issues), error: error.message, tierUsed: tier };
 }
};

// ============================================
// SECTION 12: API CALL FUNCTION (FROM V18)
// ============================================

const callClaudeAPI = async (prompt, context = {}) => {
 // Build the full system prompt with knowledge and standards
 const systemPrompt = `You are the GMG AI Assistant, a specialized tool for Global Majority Group.

KNOWLEDGE DATABASE:
${GMG_KNOWLEDGE}

WRITING STANDARDS:
${GMG_WRITING_STANDARDS}

CRITICAL RULES:
1. NEVER use em dashes () or double dashes (--)
2. ALWAYS start emails with greeting before name (Hey Eric, not Eric,)
3. NEVER use CTA endings like "Let me know if you have questions"
4. NEVER use AI phrases like "Here's the thing" or "genuinely appreciate"
5. Write in complete sentences with natural flow, connect related thoughts with commas
6. Keep thank yous to 1-2 maximum per message
7. Use simple closings: Thanks, Best, Talk soon
8. NO meta-commentary in deliverables
9. NO choppy tech bro style sentences
10. NO tech jargon like "analysis", "leverage", "synergize"

IMPORTANT OUTPUT FORMATTING:
- Do NOT include markdown formatting in your response
- Do NOT wrap your response in code blocks or use backticks
- Do NOT start with "markdown" or any formatting indicators
- Just write the content directly, ready to copy and paste

${context.additionalContext || ''}`;

 try {
 const response = await fetch('https://api.anthropic.com/v1/messages', {
 method: 'POST',
 headers: getApiHeaders(),
 body: JSON.stringify({
 model: MODEL_CONFIG.fast,
 max_tokens: 4000,
 system: systemPrompt,
 messages: [
 { role: 'user', content: prompt }
 ]
 })
 });
 
 if (!response.ok) {
 throw new Error(`API request failed: ${response.status}`);
 }
 
 const data = await response.json();
 // Strip markdown formatting from response
 let content = data.content?.[0]?.text || "";
 content = content.replace(/\*\*/g, ''); // Remove bold **
 content = content.replace(/##\s*/g, ''); // Remove headers ##
 content = content.replace(/###\s*/g, ''); // Remove headers ###
 content = content.replace(/^\s*[-*]\s+/gm, ''); // Convert markdown bullets to simple bullets
 content = content.replace(/`([^`]+)`/g, '$1'); // Remove inline code backticks
 return {
 success: true,
 content: content
 };
 } catch (error) {
 return {
 success: false,
 error: error.message
 };
 }
};

// ============================================
// V2.2 FIX: GENERATE WITH CLAUDE (CREATE TAB)
// ============================================
const generateWithClaude = async (prompt, mode = 'create') => {
 try {
 const result = await callClaudeAPI(prompt, {
 additionalContext: mode === 'create' ? `
You are creating content for a GMG client or internal use.
Follow ALL GMG writing standards strictly.
Output clean, professional content ready for immediate use.
NO meta-commentary, NO markdown formatting, NO em dashes.
` : ''
 });
 
 if (result.success) {
 return result.content;
 } else {
 throw new Error(result.error || 'Generation failed');
 }
 } catch (error) {
 devError('generateWithClaude error:', error);
 throw error;
 }
};

// ============================================
// SECTION 13: ANSWER GMG QUESTION (LOCAL)
// ============================================

// V37.6: Claude-powered GMG question answering (replaces keyword matching)
// ============================================
// V4.6: PARALLEL FUSION SEARCH
// Searches ALL sources simultaneously, Claude picks best answer
// ============================================

const parallelFusionSearch = async (question, liveKnowledgeAdditions = []) => {
  const lowerQ = question.toLowerCase();
  
  // Format live knowledge for prompt
  let liveKnowledgeText = '';
  if (liveKnowledgeAdditions && liveKnowledgeAdditions.length > 0) {
    liveKnowledgeText = liveKnowledgeAdditions.map(item => 
      `[${item.category?.toUpperCase() || 'INFO'}] ${item.title}: ${item.content}`
    ).join('\n');
  }
  
  // V4.7: Detect if this is a current events/general knowledge query
  // V5.1: Added sports team detection - these should ONLY use web search
  const hasSportsTeam = SPORTS_TEAMS.some(team => lowerQ.includes(team));
  const sportsPatterns = /\b(score|win|won|beat|lost|lose|game|play|played|playing|last night|tonight|yesterday|standings|record|vs|versus|match|playoff|championship|finals)\b/i;
  const isSportsQuery = hasSportsTeam && sportsPatterns.test(question);
  
  const generalKnowledgePatterns = [
    /who is the president/i,
    /who is president/i,
    /current president/i,
    /who won/i,
    /what.*score/i,
    /weather/i,
    /stock price/i,
    /news today/i,
    /latest news/i,
    /did.*win/i,
    /did.*lose/i
  ];
  const isGeneralKnowledge = generalKnowledgePatterns.some(p => p.test(question)) || isSportsQuery;
  
  // Step 1: Search ALL sources in parallel
  devLog('V4.6 Parallel Fusion: Searching all sources...');
  devLog('V5.1: Is sports query:', isSportsQuery, '| Is general knowledge:', isGeneralKnowledge);
  
  const searchPromises = [
    // Source 1: GMG Knowledge (static + live) - SKIP for general knowledge queries
    (async () => {
      // V5.1: Skip GMG knowledge for general knowledge queries
      if (isGeneralKnowledge) {
        return { source: 'gmg_knowledge', content: '', success: false };
      }
      
      try {
        // V5.1: Only search GMG_KNOWLEDGE, NOT writing standards (to avoid matching examples)
        const combinedKnowledge = GMG_KNOWLEDGE + (liveKnowledgeText ? '\n\nLIVE ADDITIONS:\n' + liveKnowledgeText : '');
        // Quick relevance check using simple matching
        const relevantSections = [];
        const keywords = question.toLowerCase().split(/\s+/).filter(w => w.length > 3);
        const lines = combinedKnowledge.split('\n');
        for (let i = 0; i < lines.length; i++) {
          const line = lines[i].toLowerCase();
          // V5.1: Skip lines that look like examples (BAD/GOOD markers, email examples)
          if (line.includes('bad (') || line.includes('good (') || line.includes('example:')) continue;
          if (line.includes('hey brandon') || line.includes('thanksgiving') || line.includes('fellowship contract')) continue;
          if (line.includes('best,') && line.includes('eli')) continue;
          
          if (keywords.some(kw => line.includes(kw))) {
            // Grab context: 2 lines before and 5 lines after
            const start = Math.max(0, i - 2);
            const end = Math.min(lines.length, i + 6);
            const section = lines.slice(start, end).join('\n');
            // V5.1: Skip sections that contain email examples or signature examples
            if (section.includes('Hey Brandon, Thank you') || 
                section.includes('Best,\nEli') || 
                section.includes('fellowship contract') ||
                section.includes('Thanksgiving') ||
                section.includes('genuinely appreciate') ||
                section.includes('walked away feeling')) continue;
            relevantSections.push(section);
          }
        }
        const dedupedSections = [...new Set(relevantSections)].slice(0, 10);
        return { source: 'gmg_knowledge', content: dedupedSections.join('\n\n---\n\n') || '', success: dedupedSections.length > 0 };
      } catch (e) {
        return { source: 'gmg_knowledge', content: '', success: false, error: e.message };
      }
    })(),
    
    // Source 2: Web Search (always try, ESPECIALLY for general knowledge)
    (async () => {
      try {
        const response = await fetch('https://api.anthropic.com/v1/messages', {
          method: 'POST',
          headers: getApiHeaders(),
          body: JSON.stringify({
            model: MODEL_CONFIG.quality,
            max_tokens: 2000,
            messages: [{ role: 'user', content: `Search the web to answer: "${question}"\n\nProvide a factual, current answer based on search results. Be concise.` }],
            tools: [{ type: 'web_search_20250305', name: 'web_search' }]
          })
        });
        if (!response.ok) throw new Error('Web search failed');
        const data = await response.json();
        let answer = '';
        if (data.content && Array.isArray(data.content)) {
          for (const block of data.content) {
            if (block.type === 'text') answer += block.text;
          }
        }
        return { source: 'web_search', content: answer || 'No web results found.', success: !!answer };
      } catch (e) {
        return { source: 'web_search', content: '', success: false, error: e.message };
      }
    })(),
    
    // Source 3: Writing Standards (ONLY if asking about writing/style)
    (async () => {
      const writingKeywords = ['write', 'writing', 'style', 'format', 'rule', 'em dash', 'phrase', 'standards', 'voice', 'brandon voice'];
      const isWritingQuery = writingKeywords.some(kw => lowerQ.includes(kw));
      if (!isWritingQuery) return { source: 'writing_standards', content: '', success: false };
      
      // Extract relevant writing rules - but NOT examples
      const relevantRules = [];
      const ruleLines = GMG_WRITING_STANDARDS.split('\n');
      const keywords = question.toLowerCase().split(/\s+/).filter(w => w.length > 3);
      for (let i = 0; i < ruleLines.length; i++) {
        const line = ruleLines[i].toLowerCase();
        // Skip example emails
        if (line.includes('hey brandon') || line.includes('bad (') || line.includes('good (')) continue;
        
        if (keywords.some(kw => line.includes(kw)) || line.includes('rule')) {
          const start = Math.max(0, i - 1);
          const end = Math.min(ruleLines.length, i + 5);
          relevantRules.push(ruleLines.slice(start, end).join('\n'));
        }
      }
      return { source: 'writing_standards', content: relevantRules.slice(0, 5).join('\n\n') || '', success: relevantRules.length > 0 };
    })()
  ];
  
  // Wait for all sources (with timeout)
  const timeoutPromise = new Promise(resolve => setTimeout(() => resolve({ source: 'timeout', content: '', success: false }), 15000));
  const results = await Promise.race([
    Promise.all(searchPromises),
    timeoutPromise.then(() => searchPromises.map(() => ({ source: 'timeout', content: '', success: false })))
  ]);
  
  devLog('V4.6 Parallel Fusion: Sources gathered:', results.map(r => `${r.source}: ${r.success ? 'OK' : 'FAIL'}`));
  
  // Step 2: Send ALL results to Claude to synthesize the best answer
  const fusionPrompt = `You are answering a question using multiple information sources. Analyze all sources and provide the BEST, most accurate answer.

QUESTION: "${question}"

=== SOURCE 1: GMG INTERNAL KNOWLEDGE ===
${results[0]?.content || 'No relevant GMG knowledge found.'}

=== SOURCE 2: WEB SEARCH RESULTS ===
${results[1]?.content || 'Web search did not return results.'}

=== SOURCE 3: GMG WRITING STANDARDS ===
${results[2]?.content || 'Not a writing-related query.'}

=== YOUR TASK ===
1. Review all sources above
2. Determine which source(s) have the most relevant, accurate information
3. Synthesize a clear, helpful answer
4. If sources conflict, prefer GMG knowledge for GMG-specific topics, web for current events
5. Be conversational and direct

CRITICAL OUTPUT RULES:
- NO em dashes, use commas instead
- Be helpful and warm
- If you used web search for current info, mention it briefly at the end
- Keep response under 400 words unless complexity requires more

Answer:`;

  try {
    const response = await fetch('https://api.anthropic.com/v1/messages', {
      method: 'POST',
      headers: getApiHeaders(),
      body: JSON.stringify({
        model: MODEL_CONFIG.quality,
        max_tokens: 2000,
        messages: [{ role: 'user', content: fusionPrompt }]
      })
    });
    
    if (!response.ok) throw new Error('Fusion synthesis failed');
    
    const data = await response.json();
    let answer = '';
    if (data.content && Array.isArray(data.content)) {
      for (const block of data.content) {
        if (block.type === 'text') answer += block.text;
      }
    }
    
    // Clean up
    answer = answer.replace(/\u2014/g, ', ').replace(/--/g, ', ');
    answer = answer
      .replace(/#{1,6}\s*/g, '')
      .replace(/\*\*([^*]+)\*\*/g, '$1')
      .replace(/\*([^*]+)\*/g, '$1')
      .replace(/`([^`]+)`/g, '$1')
      .trim();
    
    // Quick quality check
    const quickCheck = runAICheck(answer, false);
    if (quickCheck.issues && quickCheck.issues.length > 0) {
      try {
        const rewritten = await rewriteInBrandonVoice(answer, quickCheck.issues);
        if (rewritten.success) {
          answer = rewritten.content;
        }
      } catch (e) {
        devLog('Fusion rewrite skipped:', e.message);
      }
    }
    
    return { success: true, answer, sources: results.filter(r => r.success).map(r => r.source) };
  } catch (error) {
    devError('Parallel Fusion synthesis failed:', error);
    // Fallback: return best individual source
    if (results[1]?.success && results[1].content) {
      return { success: true, answer: results[1].content, sources: ['web_search'] };
    }
    if (results[0]?.success && results[0].content) {
      return { success: true, answer: results[0].content, sources: ['gmg_knowledge'] };
    }
    return { success: false, error: error.message };
  }
};

const answerGMGQuestionWithAI = async (question, liveKnowledgeAdditions = []) => {
 // V37.9: IMPROVED web search detection - expanded patterns
 // Everything else defaults to GMG knowledge search
 const lowerQ = question.toLowerCase();
 
 // V3.8: Detect general knowledge questions that are NOT about GMG
 // These should go straight to web search, not GMG knowledge
 const gmgKeywords = ['gmg', 'global majority', 'brandon', 'eric', 'bj', 'lane', 'pierce', 
   'client', 'proposal', 'grant', 'fundraising', 'development', 'nonprofit', 'foundation',
   'pillar', 'transitory', 'pricing', 'service', 'eli', 'cooley', 'fellowship', 'mcw',
   'bdif', 'dawkins', 'cure gm1', 'trey flowers', 'kopp'];
 const isGMGRelated = gmgKeywords.some(kw => lowerQ.includes(kw));
 
 // V3.8: General knowledge patterns - route to web search
 // V4.8: Expanded to catch more general queries
 const generalKnowledgePatterns = [
   /who is (?!brandon|eric|bj|eli|lane|pierce)/i, // "who is X" but not GMG people
   /what is (?!gmg|global majority|pillar|transitory)/i, // "what is X" but not GMG terms
   /^tell me about (?!gmg|global majority|brandon|eric)/i,
   /president|senator|politician|celebrity|actor|actress|singer/i,
   /trump|biden|obama|harris|congress|government/i,
   /^how do i |^how to |^what are the |^why is |^why do /i,
   /who is the president/i,
   /who won the election/i,
   /^who won /i
 ];
 const isGeneralKnowledge = !isGMGRelated && generalKnowledgePatterns.some(p => p.test(lowerQ));
 
 if (isGeneralKnowledge) {
   // Route to web search for general knowledge
   devLog('General knowledge query detected, using web search');
   const webResult = await searchAndSummarize(question);
   if (webResult.success) {
     return { success: true, answer: webResult.answer, source: 'web_search' };
   }
   return { success: false, error: 'Could not find answer' };
 }
 
 // V4.1: Using centralized SPORTS_TEAMS constant
 // V4.8: More specific sports detection - require action word
 const hasSportsTeam = SPORTS_TEAMS.some(team => lowerQ.includes(team));
 const hasSportsAction = lowerQ.includes('win') || lowerQ.includes('won') || lowerQ.includes('score') || 
   lowerQ.includes('beat') || lowerQ.includes('play') || lowerQ.includes('game') || 
   lowerQ.includes('playoff') || lowerQ.includes('championship') || lowerQ.includes('super bowl') ||
   lowerQ.includes('world series') || lowerQ.includes('finals') || lowerQ.includes('match') ||
   lowerQ.includes('last night') || lowerQ.includes('yesterday') || lowerQ.includes('tonight');
 
 // V4.8: Sports query ALWAYS goes to web search (overrides GMG knowledge check)
 const isSportsQuery = hasSportsTeam && hasSportsAction;
 
 if (isSportsQuery) {
   devLog('V4.8: Sports query detected, forcing web search');
   const webResult = await searchAndSummarize(question);
   if (webResult.success) {
     return { success: true, answer: webResult.answer, source: 'web_search' };
   }
   return { success: false, error: 'Could not find sports result' };
 }
 
 // Use web search for external queries AND time-sensitive lookups
 const isWebSearchQuery = (
   // V37.9: Just asking about a team with did/do/will
   (hasSportsTeam && (lowerQ.startsWith('did ') || lowerQ.startsWith('do ') || lowerQ.startsWith('will ') || lowerQ.startsWith('are '))) ||
   // Weather
   lowerQ.includes('weather') || lowerQ.includes('temperature') || lowerQ.includes('forecast') ||
   // Stock prices
   lowerQ.includes('stock price') || lowerQ.includes('market') && lowerQ.includes('today') ||
   // Current news
   (lowerQ.includes('news') && lowerQ.includes('today')) ||
   lowerQ.includes('breaking news') ||
   // V37.8: Time-sensitive queries (start dates, schedules, when things happen)
   lowerQ.includes('find out when') || lowerQ.includes('when does') || lowerQ.includes('when is') ||
   lowerQ.includes('start date') || lowerQ.includes('starts when') || lowerQ.includes('schedule') ||
   // V37.8: Generic lookup requests
   (lowerQ.includes('find out') && !lowerQ.includes('gmg') && !lowerQ.includes('brandon') && !lowerQ.includes('eric')) ||
   lowerQ.includes('look up') || lowerQ.includes('search for') ||
   // Explicit web search request
   lowerQ.includes('search the web') || lowerQ.includes('google') || lowerQ.includes('look up online')
 );

 if (isWebSearchQuery) {
 // Use web search for current events
 const webResult = await searchAndSummarize(question);
 
 if (webResult.success) {
 let answer = webResult.answer;
 if (webResult.source === 'web_search') {
 answer += '\n\n(Source: Web search)';
 }
 return { success: true, answer };
 } else {
 return { success: false, error: webResult.error || 'Search failed' };
 }
 
 } else {
 // V3.2: Format live knowledge additions for the prompt
 let liveKnowledgeText = '';
 if (liveKnowledgeAdditions && liveKnowledgeAdditions.length > 0) {
 liveKnowledgeText = '\n\nTEAM KNOWLEDGE ADDITIONS (Recent updates from team members):\n' +
 liveKnowledgeAdditions.map(item => 
 `[${item.category.toUpperCase()}] ${item.title}: ${item.content} (Added by ${item.addedByName || item.addedBy} on ${new Date(item.addedAt).toLocaleDateString()})`
 ).join('\n');
 }
 
 // DEFAULT: Search GMG knowledge database + live additions
 const searchPrompt = `You are the GMG AI Assistant. Answer this question using the knowledge database below.

QUESTION: ${question}

GMG KNOWLEDGE DATABASE:
${GMG_KNOWLEDGE}
${liveKnowledgeText}

WRITING STANDARDS:
- NO em dashes (use commas)
- Be direct and helpful
- Warm but professional

If the answer is in the knowledge database (including team additions), provide it directly.
If the answer is NOT in the knowledge database, say "I don't have that specific information in my GMG knowledge. This might be a question for web search or the main Claude interface."

Answer concisely.`;

 try {
 devLog('Calling Anthropic API...');
 devLog('API Key present:', ANTHROPIC_API_KEY ? 'Yes (' + ANTHROPIC_API_KEY.substring(0, 20) + '...)' : 'NO');
 
 const response = await fetch('https://api.anthropic.com/v1/messages', {
 method: 'POST',
 headers: getApiHeaders(),
 body: JSON.stringify({
 model: MODEL_CONFIG.fast,
 max_tokens: 1500,
 messages: [{ role: 'user', content: searchPrompt }]
 })
 });

 devLog('API Response status:', response.status);
 
 if (!response.ok) {
 const errorText = await response.text();
 devError('API Error:', errorText);
 throw new Error('API request failed: ' + response.status + ' - ' + errorText);
 }

 const data = await response.json();
 let answer = data.content?.[0]?.text || "";
 answer = answer.replace(/```/g, '').trim();
    answer = answer.replace(/\u2014/g, ',').replace(/--/g, ',');
 
 // V37.7: Secondary quality check on ALL outputs
 // V37.8: SONNET 4 FALLBACK - If knowledge base doesnt have the answer, try web search
 const noInfoIndicators = [
   'don\'t have that specific information',
   'not in my gmg knowledge',
   'might be a question for web search',
   'i don\'t have information about',
   'not available in the knowledge database',
   'cannot find information about'
 ];
 
 const hasNoInfo = noInfoIndicators.some(indicator => answer.toLowerCase().includes(indicator));
 
 if (hasNoInfo) {
   devLog('Knowledge base miss, trying web search fallback...');
   const webFallback = await searchAndSummarize(question);
   if (webFallback.success && webFallback.source === 'web_search') {
     answer = webFallback.answer + '\n\n(Note: This answer came from web search since it wasn\'t in GMG knowledge.)';
   }
 }

 const quickCheck = runAICheck(answer, false);
 if (quickCheck.issues && quickCheck.issues.length > 0) {
 try {
 const rewritten = await rewriteInBrandonVoice(answer, quickCheck.issues);
 if (rewritten.success) {
 answer = rewritten.content;
 }
 } catch (e) {
 // If rewrite fails, use original
 devLog('Secondary rewrite skipped:', e.message);
 }
 }
 
 // V3.6.2: Strip markdown formatting for clean display
 answer = answer
 .replace(/#{1,6}\s*/g, '')  // Remove ## headers
 .replace(/\*\*([^*]+)\*\*/g, '$1')  // Remove **bold**
 .replace(/\*([^*]+)\*/g, '$1')  // Remove *italic*
 .replace(/`([^`]+)`/g, '$1')  // Remove `code`
 .replace(/```[\s\S]*?```/g, '')  // Remove code blocks
 .replace(/\[([^\]]+)\]\([^)]+\)/g, '$1')  // Remove markdown links
 .replace(/^\s*[-*]\s+/gm, '• ')  // Convert bullets
 .replace(/\n{3,}/g, '\n\n')  // Reduce multiple newlines
 .trim();
 
 return { success: true, answer };
 } catch (error) {
 devError('GMG question API failed:', error);
 return { success: false, error: error.message };
 }
 }
};

// Legacy sync function for backwards compatibility (used for quick local lookups)
const answerGMGQuestion = (question) => {
 const lower = question.toLowerCase();
 
 // Only handle the most common quick lookups locally, everything else goes to Claude
 // This provides instant responses for simple queries
 
 // Contact info (most common quick lookup)
 if (lower.includes('contact') || lower.includes('email') || lower.includes('phone')) {
 return 'Contact GMG: Brandon J. Pierce Sr. - brandon@globalmajoritygroup.com, 336-549-9608. Dr. Eric R. Lane Sr. - eric@globalmajoritygroup.com, (323) 600-7676.';
 }
 
 // Pricing (second most common)
 if (lower.includes('price') || lower.includes('cost') || lower.includes('fee') || lower.includes('how much')) {
 return 'GMG Pricing: Pillar Clients pay $6,500-$8,500/month for 12-month engagements. Transitory Clients pay $1,000-$1,500/month for month-to-month or 6-month minimum. Sports Division Training Camp is $1,000-$2,500/month, Starting Lineup is $6,500-$8,500/month.';
 }
 
 // V38.4: Quick answers for Eric Lane
 if ((lower.includes('who is eric') || lower.includes('about eric') || lower === 'eric' || lower === 'eric lane') && !lower.includes('contact')) {
 return 'Dr. Eric R. Lane Sr. is the Co-Founder and Managing Partner of Global Majority Group. He brings 17 years of nonprofit fundraising leadership and holds an Ed.D. in Educational Leadership from Cal State Fresno. Eric was a Division I basketball player at Boise State who played professionally in Europe, bringing an athletic mindset to fundraising. He has raised over $65 million across his career and previously served as CDO at Children\'s Institute, where he managed a portfolio of $8.5 million annually. His professional references include Michelle King (Children\'s Institute), Carmen Anderson (Destination Crenshaw), and others who praise his strategic vision, relationship building, and ethical leadership.';
 }
 
 // V38.4: Quick answers for Brandon Pierce
 if ((lower.includes('who is brandon') || lower.includes('about brandon') || lower === 'brandon' || lower === 'brandon pierce') && !lower.includes('contact')) {
 return 'Brandon J. Pierce Sr. is the Co-Founder and Managing Partner of Global Majority Group. He brings Fortune 500 corporate grantmaking experience from The Coca-Cola Company, where he reviewed 13,000+ proposals totaling $195M+ in funding requests over nearly a decade. Brandon is also an author of five published books including "Fundraising for the Culture" (forthcoming). He specializes in proposal development, grant strategy, and AI integration for nonprofit operations. His unique dual perspective as both a former funder and consultant gives GMG clients insider knowledge of what grantmakers actually want to see.';
 }
 
 // V3.6.1: Quick answer for BJ Pierce
 if ((lower.includes('who is bj') || lower.includes('about bj') || lower === 'bj' || lower.includes('bryan pierce jr') || lower.includes('bryan j pierce')) && !lower.includes('contact')) {
 return 'Bryan J. Pierce (BJ) is Brandon\'s brother and a GMG team member who handles certain EBC (Employee-Based Consulting) applications. He brings energy and a fresh perspective to the team. BJ is based in North Carolina and focuses on remote or NC-based development and fundraising roles. He has 1 daughter (Uriah, the oldest) and 4 sons. In the ACE Portal, BJ is one of the three applicant profiles available for job applications alongside Brandon and Eric.';
 }
 
 // V3.7: Quick answer for Eli Cooley
 if ((lower.includes('who is eli') || lower.includes('about eli') || lower === 'eli' || lower.includes('eli cooley')) && !lower.includes('contact')) {
 return 'Eli Cooley is the inaugural Lane-Pierce Fellow, starting January 2026. He was selected through a competitive process to join GMG\'s fellowship program, which trains emerging fundraising professionals. Eli will receive hands-on mentorship from Brandon and Eric while contributing to client work. The fellowship is funded through GMG Foundation (501c3) and represents GMG\'s investment in developing the next generation of nonprofit fundraising talent.';
 }
 
 // V38.4: Quick answer for "what is GMG"
 if (lower.includes('what is gmg') || lower.includes('what is global majority') || lower === 'gmg') {
 return 'Global Majority Group (GMG) is a BIPOC-led nonprofit fundraising consultancy founded in October 2025 by Brandon J. Pierce Sr. and Dr. Eric R. Lane Sr. GMG combines 32+ years of philanthropic expertise to provide strategic consulting, data-driven solutions, and capacity building for organizations serving underresourced communities. Their mission is "Excellence Rooted in Lived Experience," offering services including fractional development leadership, grant strategy, major gifts, and corporate partnerships. GMG operates through a dual-entity structure with both an LLC and Foundation.';
 }
 
 // Return null to signal "use Claude API instead"
 return null;
};

// End of Spurt 4
// ============================================
// SECTION 14: FLUID MESSAGE COMPONENTS (V2.4)
// ============================================

// V2.4: FluidMessage - renders a single message in the stream
const FluidMessage = ({ type, speaker, content, avatar, isTyping, children }) => {
  const isUser = type === 'user';
  
  return (
    <div className={`fluid-message ${isUser ? 'user' : 'admin'}`}>
      {!isUser && avatar && (
        <img src={avatar} alt={speaker} className="avatar" />
      )}
      <div className="bubble-wrap">
        {!isUser && speaker && (
          <div className={`speaker-name ${speaker.toLowerCase()}`}>{speaker}</div>
        )}
        {isTyping ? (
          <div className="bubble">
            <div className="typing-dots">
              <span></span>
              <span></span>
              <span></span>
            </div>
          </div>
        ) : (
          <div className="bubble">
            {content || children}
          </div>
        )}
      </div>
      {isUser && avatar && (
        <img src={avatar} alt="You" className="avatar" />
      )}
      {isUser && !avatar && (
        <div className="avatar" style={{ 
          background: 'linear-gradient(135deg, #8B5CF6, #7C3AED)', 
          display: 'flex', 
          alignItems: 'center', 
          justifyContent: 'center',
          color: 'white',
          fontWeight: '600',
          fontSize: '14px',
          width: '32px',
          height: '32px',
          borderRadius: '50%'
        }}>U</div>
      )}
    </div>
  );
};

// V2.4: FluidContentCard - renders content results in the stream
const FluidContentCard = ({ title, content, onCopy, onDownload, onRegenerate, onImprove, actions }) => {
  return (
    <div className="fluid-content-card">
      {title && <div className="card-header">{title}</div>}
      <div className="card-body">{content}</div>
      <div className="card-actions">
        {onCopy && <button className="primary" onClick={onCopy}>Copy</button>}
        {onDownload && <button className="secondary" onClick={onDownload}>Download</button>}
        {onRegenerate && <button className="secondary" onClick={onRegenerate}>Regenerate</button>}
        {onImprove && <button className="secondary" onClick={onImprove}>Improve</button>}
        {actions}
      </div>
    </div>
  );
};

// ============================================
// SECTION 15: MAIN REACT COMPONENT
// ============================================

const GMGAssistant = () => {
 // ===== STATE =====
 
 // V3.6: PWA Install Prompt
 const [installPrompt, setInstallPrompt] = useState(null);
 const [showInstallBanner, setShowInstallBanner] = useState(false);
 
 // V6.8: PWA Update Prompt
 const [showUpdateBanner, setShowUpdateBanner] = useState(false);
 const [waitingWorker, setWaitingWorker] = useState(null);
 
 // ============================================
 // V2.1: SESSION CONTEXT FOR FOLLOW-UP INTELLIGENCE
 // ============================================
 const [sessionContext, setSessionContext] = useState({
 lastAction: null,           // 'cover_letter', 'resume', 'ai_check', etc.
 lastApplicant: null,        // 'BJ', 'CJ', 'Brandon', 'Eric'
 lastJob: null,              // { title, org, description, ... }
 lastContent: null,          // The actual generated content
 lastTab: null,              // Which tab they were on
 timestamp: null             // When the action happened
 });

 // V2.1: Selected rewrite tier (default to B for balanced approach)
 const [selectedTier, setSelectedTier] = useState('B');
 const [showTierSelector, setShowTierSelector] = useState(false);
 const [pendingContent, setPendingContent] = useState(null);
 
 // V6.8: Register service worker and listen for updates
 useEffect(() => {
 if ('serviceWorker' in navigator) {
  navigator.serviceWorker.register('/sw.js').then(registration => {
  // Check for updates immediately
  registration.update();
  
  // Listen for new service worker waiting
  registration.addEventListener('updatefound', () => {
   const newWorker = registration.installing;
   if (newWorker) {
   newWorker.addEventListener('statechange', () => {
    if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
    // New version available
    setWaitingWorker(newWorker);
    setShowUpdateBanner(true);
    }
   });
   }
  });
  
  // Check if there's already a waiting worker
  if (registration.waiting) {
   setWaitingWorker(registration.waiting);
   setShowUpdateBanner(true);
  }
  }).catch(err => devWarn('SW registration failed:', err));
  
  // Handle controller change (new SW activated)
  navigator.serviceWorker.addEventListener('controllerchange', () => {
  window.location.reload();
  });
 }
 }, []);
 
 // V6.8: Handle update button click
 const handleUpdateClick = () => {
 if (waitingWorker) {
  waitingWorker.postMessage({ type: 'SKIP_WAITING' });
 }
 setShowUpdateBanner(false);
 };
 
 // V5.8: Listen for PWA install prompt + check if already installed
 // Changed from localStorage to sessionStorage so banner shows every session
 useEffect(() => {
 // Check if already in standalone mode (actually installed as PWA)
 const isStandalone = window.matchMedia('(display-mode: standalone)').matches || 
  window.navigator.standalone === true;
 
 // V5.8: Check if user dismissed banner THIS SESSION (not forever)
 const dismissedThisSession = sessionStorage.getItem('gmg_install_dismissed_session');
 
 // Show banner if not installed and not dismissed this session
 if (!isStandalone && !dismissedThisSession) {
  // Show after 3 seconds to not be annoying
  const timer = setTimeout(() => {
  setShowInstallBanner(true);
  }, 3000);
  return () => clearTimeout(timer);
 }
 
 const handler = (e) => {
  e.preventDefault();
  setInstallPrompt(e);
  if (!isStandalone) setShowInstallBanner(true);
 };
 window.addEventListener('beforeinstallprompt', handler);
 
 // V5.8: Listen for when app gets installed to hide banner
 const installHandler = () => setShowInstallBanner(false);
 window.addEventListener('appinstalled', installHandler);
 
 return () => {
  window.removeEventListener('beforeinstallprompt', handler);
  window.removeEventListener('appinstalled', installHandler);
 };
 }, []);
 
 // V3.7: Handle PWA install
 const handleInstallApp = async () => {
 if (installPrompt) {
  // Browser supports install prompt
  installPrompt.prompt();
  const { outcome } = await installPrompt.userChoice;
  if (outcome === 'accepted') {
  setShowInstallBanner(false);
  setInstallPrompt(null);
  }
 } else {
  // No install prompt available, show instructions
  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
  const isAndroid = /Android/.test(navigator.userAgent);
  
  if (isIOS) {
  alert('To install: Tap the Share button, then "Add to Home Screen"');
  } else if (isAndroid) {
  alert('To install: Tap the menu (3 dots), then "Add to Home Screen" or "Install App"');
  } else {
  alert('To install: Click the install icon in your browser\'s address bar, or use your browser\'s menu to add to home screen.');
  }
 }
 };
 
 // V5.8: Dismiss install banner (only for this session, not forever)
 const dismissInstallBanner = () => {
 setShowInstallBanner(false);
 sessionStorage.setItem('gmg_install_dismissed_session', 'true');
 };
 
 // V3.0: User authentication state
 const [currentUser, setCurrentUser] = useState(null);
 const [userRole, setUserRole] = useState('guest');
 const [authLoading, setAuthLoading] = useState(true);
 
 // V3.0: Listen for auth state changes
 // V6.1: Added null check for when Firebase isn't configured
 useEffect(() => {
 if (!auth) {
 setAuthLoading(false);
 devLog('Firebase auth not configured, running in offline mode');
 return;
 }
 const unsubscribe = onAuthStateChanged(auth, (user) => {
 setCurrentUser(user);
 if (user) {
 const role = getUserRole(user.email);
 setUserRole(role);
 // V2.11: Check if user is admin
 const adminStatus = ADMIN_USERS.includes(user.email?.toLowerCase());
 setIsAdmin(adminStatus);
 devLog(`User logged in: ${user.email} (${role})${adminStatus ? ' [ADMIN]' : ''}`);
 } else {
 setUserRole('guest');
 setIsAdmin(false);
 }
 setAuthLoading(false);
 });
 return () => unsubscribe();
 }, []);
 
 // V3.0: Handle login
 const handleLogin = async () => {
 try {
 await signInWithGoogle();
 } catch (error) {
 devError('Login failed:', error);
 alert('Login failed. Please try again.');
 }
 };
 
 // V3.0: Handle logout
 const handleLogout = async () => {
 try {
 await logOut();
 setCurrentUser(null);
 setUserRole('guest');
 } catch (error) {
 devError('Logout failed:', error);
 }
 };
 
 // Welcome page
 const [showWelcome, setShowWelcome] = useState(() => {
 if (typeof localStorage !== 'undefined') {
 return localStorage.getItem('gmg_hide_welcome') !== 'true';
 }
 return true;
 });
 const [dontShowAgain, setDontShowAgain] = useState(false);
 const [welcomeMessages, setWelcomeMessages] = useState([]);
 const [welcomeComplete, setWelcomeComplete] = useState(false);
 
 // V3.1: Sign-in prompt modal for guests
 const [showSignInPrompt, setShowSignInPrompt] = useState(false);
 
 // V3.2: Live Knowledge additions from Firebase
 const [liveKnowledge, setLiveKnowledge] = useState([]);
 const [knowledgeForm, setKnowledgeForm] = useState({ category: 'client', title: '', content: '' });
 const [knowledgeSubmitting, setKnowledgeSubmitting] = useState(false);
 const [knowledgeSuccess, setKnowledgeSuccess] = useState(false);
 
 // Active tab
 // V33: Load saved tab from localStorage
 const [activeTab, setActiveTab] = useState(() => {
 try {
 const saved = localStorage.getItem('gmg_ace_active_tab');
 return saved && ['create', 'check', 'ask', 'prep', 'acquire', 'knowledge'].includes(saved) ? saved : 'create';
 } catch { return 'create'; }
 });
 
 // V4.8: Cache random examples per tab to prevent shuffling on re-render
 const [cachedExamples, setCachedExamples] = useState(() => {
 const examples = {};
 Object.keys(TAB_INTROS).forEach(tab => {
 const tabIntro = TAB_INTROS[tab];
 if (tabIntro && tabIntro.examples) {
 examples[tab] = tabIntro.examples[Math.floor(Math.random() * tabIntro.examples.length)];
 }
 });
 return examples;
 });
 
 // V5.2: Floating tip state
 const [floatingTip, setFloatingTip] = useState(null);
 const floatingTipTimeoutRef = useRef(null);
 
 // V3.6: Swipe gesture handling
 const touchStartRef = useRef({ x: 0, y: 0 });
 const touchEndRef = useRef({ x: 0, y: 0 });
 const swipeThreshold = 100; // minimum swipe distance
 
 // V3.6: Pull-to-refresh
 const [isRefreshing, setIsRefreshing] = useState(false);
 const [pullProgress, setPullProgress] = useState(0);
 const pullStartRef = useRef(null);
 const chatBodyRef = useRef(null);
 
 // V2.14.1: UPDATE CHECKER - Core Feature
 const [updateAvailable, setUpdateAvailable] = useState(null);
 const [isCheckingUpdate, setIsCheckingUpdate] = useState(false);
 const [updateHoldProgress, setUpdateHoldProgress] = useState(0);
 const updateHoldTimerRef = useRef(null);
 const UPDATE_HOLD_DURATION = 3000; // 3 seconds to trigger update check
 
 // V3.6: Tab order for swipe navigation
 const tabOrder = ['create', 'check', 'ask', 'prep', 'acquire', 'brainstorm', 'knowledge'];
 
 // ============================================
 // V2.1: HELPER FUNCTIONS FOR CONTEXT INTELLIGENCE
 // ============================================
 
 // Detect if input looks like an application question
 const detectApplicationQuestion = (input) => {
 const applicationPatterns = [
 /describe a time/i,
 /tell us about/i,
 /give an example/i,
 /what experience do you have/i,
 /why are you interested/i,
 /what makes you qualified/i,
 /how would you approach/i,
 /what is your experience with/i,
 /describe your experience/i,
 /what are your strengths/i,
 /why do you want/i,
 /tell me about yourself/i,
 ];
 return applicationPatterns.some(pattern => pattern.test(input));
 };

 // Build context prompt if we have recent session context
 const buildContextPrompt = () => {
 if (!sessionContext.lastAction || !sessionContext.timestamp) return '';
 
 // Only use context if it's less than 30 minutes old
 const thirtyMinutes = 30 * 60 * 1000;
 if (Date.now() - sessionContext.timestamp > thirtyMinutes) return '';
 
 return `
IMPORTANT CONTEXT FROM RECENT SESSION:
- You just helped ${sessionContext.lastApplicant || 'the user'} with: ${sessionContext.lastAction}
${sessionContext.lastJob ? `- Organization: ${sessionContext.lastJob.org || sessionContext.lastJob.organization || 'Unknown'}` : ''}
${sessionContext.lastJob ? `- Position: ${sessionContext.lastJob.title || 'Unknown'}` : ''}
- The user is likely asking a follow-up question related to this
- Use ${sessionContext.lastApplicant || 'their'}'s background to inform your answer
- Reference specific details from the job/content if relevant
`;
 };

 // Open email client with pre-filled content
 const openEmailClient = (jobData, coverLetter, applicantProfile) => {
 const email = jobData?.applicationEmail || jobData?.employerEmail || '';
 
 if (!email || !email.includes('@')) {
 alert('No valid email address found. Check the job posting for the application email.');
 return;
 }
 
 const subject = encodeURIComponent(
 `Application for ${jobData.title || 'Open Position'} - ${applicantProfile.name}`
 );
 
 const body = encodeURIComponent(
`Dear Hiring Team,

Please find my application for the ${jobData.title || 'position'} at ${jobData.organization || 'your organization'}.

${coverLetter}

Best regards,
${applicantProfile.name}
${applicantProfile.phone || ''}
${applicantProfile.email || ''}`
 );
 
 const mailtoLink = `mailto:${email}?subject=${subject}&body=${body}`;
 window.location.href = mailtoLink;
 };
 
 // V3.6: Dark Mode
 // V2.13: Time-based default (after 7pm, default to dark mode)
 const [isDarkMode, setIsDarkMode] = useState(() => {
 try {
 // Check if user manually set preference
 const manualSet = localStorage.getItem('gmg_ace_dark_mode_manual');
 const saved = localStorage.getItem('gmg_ace_dark_mode');
 
 if (manualSet === 'true' && saved !== null) {
  // User manually toggled, respect their choice
  return saved === 'true';
 }
 
 // V2.13: Check time of day for auto dark mode
 const hour = new Date().getHours();
 if (hour >= 19 || hour < 7) {
  // After 7pm or before 7am, default to dark mode
  return true;
 }
 
 // During daytime, check system preference
 return window.matchMedia?.('(prefers-color-scheme: dark)').matches || false;
 } catch { return false; }
 });
 
 // V3.6: Auto-Save Drafts
 const [drafts, setDrafts] = useState(() => {
 try {
 const saved = localStorage.getItem('gmg_ace_drafts');
 return saved ? JSON.parse(saved) : {};
 } catch (e) { devWarn('Parse failed:', e); return {}; }
 });
 const [showDraftRecovery, setShowDraftRecovery] = useState(false);
 const [draftSaveIndicator, setDraftSaveIndicator] = useState('');
 const lastSaveRef = useRef(null);
 
 // V3.6: Application Tracking
 const [applications, setApplications] = useState([]);
 const [showApplications, setShowApplications] = useState(false);
 
 // V5.1: Team Applications Log (visible to Brandon and Eric)
 const [teamApplicationsLog, setTeamApplicationsLog] = useState([]);
 const [showTeamLog, setShowTeamLog] = useState(false);
 
 // V3.6: Follow-up Reminder System
 const [applicationReminders, setApplicationReminders] = useState(() => {
 try {
 const saved = localStorage.getItem('gmg_ace_app_reminders');
 return saved ? JSON.parse(saved) : [];
 } catch { return []; }
 });
 const [showReminders, setShowReminders] = useState(false);
 
 // V3.6: Session Timeout
 const [lastActivity, setLastActivity] = useState(Date.now());
 const [showTimeoutWarning, setShowTimeoutWarning] = useState(false);
 const sessionTimeoutMinutes = 30; // 30 minute timeout
 const warningMinutes = 5; // 5 minute warning before timeout
 
 // V3.6: Batch Document Checking
 const [batchCheckResults, setBatchCheckResults] = useState([]);
 const [showBatchCheck, setShowBatchCheck] = useState(false);
 const [batchCheckProgress, setBatchCheckProgress] = useState({ current: 0, total: 0, processing: false });
 
 // Chat column messages (persistent intro + roleplay)
 const [chatMessages, setChatMessages] = useState([]);
 const [chatIntroIndex, setChatIntroIndex] = useState(0);
 
 // V38.3: Unified chat messages (combines roleplay + results + changes)
 const [unifiedMessages, setUnifiedMessages] = useState([]);
 const unifiedChatRef = useRef(null);
 const [useUnifiedUI] = useState(true); // Enable unified UI for main tabs
 
 // V2.9: Intro messages that type one at a time (like GMG University)
 const [introMessages, setIntroMessages] = useState([]);
 const [introTypingPhase, setIntroTypingPhase] = useState(0); // 0=claudette typing, 1=claudette done, 2=chanet typing, 3=chanet done, 4=tip typing, 5=complete
 const introTimeoutRef = useRef(null);
 
 // Session counter for persona tiers (V25: persists, halves on refresh)
 const [sessionCount, setSessionCount] = useState(() => loadSessionCount());
 
 // V25: Sound effects toggle
 const [soundEnabled, setSoundEnabled] = useState(false);
 
 // V25: History log
 const [historyLog, setHistoryLog] = useState(() => loadHistory());
 const [showHistory, setShowHistory] = useState(false);
 
 // V5.6: Mobile more menu
 const [showMobileMoreMenu, setShowMobileMoreMenu] = useState(false);
 const [showFabMenu, setShowFabMenu] = useState(false); // V2.7: Floating action button menu
 
 // V5.8: Mobile settings drawer
 const [showSettingsDrawer, setShowSettingsDrawer] = useState(false);
 
 // V25: Diff view mode for AI Check (diff is default - Brandon loves it!)
 const [diffViewMode, setDiffViewMode] = useState('side-by-side'); // 'side-by-side' or 'diff' (side-by-side is default)
 
 // V25: Bulk check results
 const [bulkResults, setBulkResults] = useState(null);
 
 // V26: Client profiles visibility
 const [showClientProfiles, setShowClientProfiles] = useState(false);
 
 // V26: Smart suggestions
 const [suggestions, setSuggestions] = useState([]);
 
 // V26: Analytics
 const [analytics, setAnalytics] = useState(() => loadAnalytics());
 const [showAnalytics, setShowAnalytics] = useState(false);
 
 // V26: Learned corrections from user edits
 const [learnedCorrections, setLearnedCorrections] = useState(() => loadLearnedCorrections());
 const [editedOutput, setEditedOutput] = useState('');
 const [isEditingOutput, setIsEditingOutput] = useState(false);
 
 // V26: Voice improvements
 const [voiceWaveform, setVoiceWaveform] = useState([]);
 const [voiceTranscript, setVoiceTranscript] = useState('');
 const [showVoiceConfirm, setShowVoiceConfirm] = useState(false);
 const analyserRef = useRef(null);
 
 // V2.10: Admin Persona Delivery System
 const [showDeliverySelector, setShowDeliverySelector] = useState(false);
 const [selectedDeliveryPersona, setSelectedDeliveryPersona] = useState(null);
 const [deliveryRecipient, setDeliveryRecipient] = useState('');
 const [pendingDeliveryContent, setPendingDeliveryContent] = useState(null);
 // V2.14: Delivery preview before sending
 const [deliveryPreview, setDeliveryPreview] = useState(null);
 const [deliverySelectorEnabled, setDeliverySelectorEnabled] = useState(() => {
  // Get default based on current tab
  return DELIVERY_PERSONA_DEFAULTS[activeTab] ?? false;
 });
 
 // V2.11: Admin Portal State
 const [showAdminPortal, setShowAdminPortal] = useState(false);
 const [adminSection, setAdminSection] = useState('dashboard');
 const [adminData, setAdminData] = useState({
  users: [],
  analytics: {},
  templates: [],
  auditLog: [],
  settings: {}
 });
 const [isAdmin, setIsAdmin] = useState(false);
 
 // V2.11.1: Gmail Integration State (Server-side tokens)
 const [sendingEmail, setSendingEmail] = useState(false);
 const [emailServiceStatus, setEmailServiceStatus] = useState('unknown'); // 'unknown', 'available', 'unavailable'
 
 const animationRef = useRef(null);
 
 // Independent state for each tab (per Brandon's request)
 const [createState, setCreateState] = useState({
 input: '',
 result: null,
 files: [],
 messages: [],
 isPitchDeck: false // V29: Track if result is pitch deck HTML
 });
 
 // V29: Pitch Deck Preview state
 const [showPitchPreview, setShowPitchPreview] = useState(false);
 
 const [checkState, setCheckState] = useState({
 input: '',
 result: null,
 trackedChanges: [],
 messages: [],
 factCheckEnabled: true, // Default ON, user can opt out
 // V4.7: Split view for comparing original vs corrected
 showSplitView: true, // V5.5: Default to showing split view
 acceptedChanges: {} // Track which changes are accepted: { index: true/false }
 });
 
 const [askState, setAskState] = useState({
 input: '',
 result: null,
 messages: [],
 followUp: '',
 previousQA: null
 });
 
 // V5.1: Knowledge state for unified chat interface
 const [knowledgeState, setKnowledgeState] = useState({
 input: '',
 result: null
 });
 
 // V3.6: Conversation History for Ask GMG
 const [conversationHistory, setConversationHistory] = useState(() => {
 try {
 const saved = localStorage.getItem('gmg_ace_conversation_history');
 return saved ? JSON.parse(saved) : [];
 } catch { return []; }
 });
 const [showConversationHistory, setShowConversationHistory] = useState(false);
 const [conversationSearch, setConversationSearch] = useState('');
 const [relatedQuestions, setRelatedQuestions] = useState([]);
 
 // V3.6: Style Profiles for AI Check
 const [styleProfiles] = useState([
 { id: 'default', name: 'Brandon Standard', description: 'Default GMG writing standards' },
 { id: 'formal', name: 'Formal/Academic', description: 'More formal tone, complex sentences allowed' },
 { id: 'casual', name: 'Casual/Friendly', description: 'Relaxed tone, contractions encouraged' },
 { id: 'technical', name: 'Technical/Developer', description: 'Tech jargon allowed, precise language' }
 ]);
 const [activeStyleProfile, setActiveStyleProfile] = useState('default');
 
 // V3.6: Follow-up Tasks
 const [followUpTasks, setFollowUpTasks] = useState(() => {
 try {
 const saved = localStorage.getItem('gmg_ace_followup_tasks');
 return saved ? JSON.parse(saved) : [];
 } catch { return []; }
 });
 const [showFollowUpTasks, setShowFollowUpTasks] = useState(false);
 
 // V3.6: Custom Banned Phrases (user-added)
 // V5.1: Now loads from shared Firebase collection (team-visible)
 const [customBannedPhrases, setCustomBannedPhrases] = useState([]);
 const [showCustomPhrasesEditor, setShowCustomPhrasesEditor] = useState(false);
 const [newCustomPhrase, setNewCustomPhrase] = useState({ phrase: '', reason: '', replace: '' });
 
 // V5.1: Shared client contacts (team-visible)
 const [sharedClientContacts, setSharedClientContacts] = useState([]);
 
 // V3.6: Meeting Notes
 const [meetingNotes, setMeetingNotes] = useState(() => {
 try {
 const saved = localStorage.getItem('gmg_ace_meeting_notes');
 return saved ? JSON.parse(saved) : [];
 } catch { return []; }
 });
 const [showMeetingNotes, setShowMeetingNotes] = useState(false);
 const [newMeetingNote, setNewMeetingNote] = useState({ client: '', content: '' });
 
 // V3.6: Progress tracking for long operations
 const [operationProgress, setOperationProgress] = useState({ active: false, percent: 0, message: '', eta: '' });
 
 // V3.6: Pull to refresh state
 const [isPulling, setIsPulling] = useState(false);
 const [pullDistance, setPullDistance] = useState(0);
 const pullThreshold = 80;
 
 // Processing state
 const [isProcessing, setIsProcessing] = useState(false);
 
 // Popup delivery state
 const [showPopup, setShowPopup] = useState(false);
 const [popupData, setPopupData] = useState(null);
 
 // Voice state
 const [isRecording, setIsRecording] = useState(false);
 const [isSpeaking, setIsSpeaking] = useState(false);
 
 // Toast
 const [toast, setToast] = useState(null);
 
 // V5.4: New feature states
 const [showShortcutsModal, setShowShortcutsModal] = useState(false);
 const [apiStatus, setApiStatus] = useState('checking'); // 'connected', 'error', 'checking'
 const [lastApiCheck, setLastApiCheck] = useState(null);
 const [responseStartTime, setResponseStartTime] = useState(null);
 const [lastResponseTime, setLastResponseTime] = useState(null);
 const [lastPromptData, setLastPromptData] = useState(null); // For regenerate feature
 const [showQuickTemplates, setShowQuickTemplates] = useState(false);
 
 // V5.4: Quick templates per tab
 const QUICK_TEMPLATES = {
  create: [
   { label: 'Thank You Email', prompt: 'Write a thank you email to a donor who gave $500' },
   { label: 'Meeting Follow-up', prompt: 'Write a follow-up email after a discovery meeting with a prospect' },
   { label: 'Grant LOI', prompt: 'Write a letter of inquiry for a foundation grant' },
   { label: 'Board Update', prompt: 'Write a monthly board update email' }
  ],
  check: [
   { label: 'Check Email', prompt: 'Check this email for AI-sounding phrases:' },
   { label: 'Check Grant', prompt: 'Review this grant narrative for AI language:' },
   { label: 'Check Report', prompt: 'Scan this report for corporate jargon:' }
  ],
  ask: [
   { label: 'GMG Services', prompt: 'What services does GMG offer?' },
   { label: 'Pricing Info', prompt: 'What is GMG pricing structure?' },
   { label: 'Founder Bios', prompt: 'Tell me about Brandon and Eric' },
   { label: 'Methodologies', prompt: 'Explain the Data Science Development Plan methodology' }
  ],
  prep: [
   { label: 'Pitch Deck', prompt: 'Generate a pitch deck for [Client Name]' },
   { label: 'DSDP', prompt: 'Create a Data Science Development Plan for [Client Name]' },
   { label: 'Meeting Brief', prompt: 'Prepare a briefing for my meeting with [Client Name]' }
  ]
 };

 // Template form popup state
 const [templatePopup, setTemplatePopup] = useState({
 show: false,
 templateId: null,
 fields: {}
 });
 
 // V27: Client Acquisition Tab State (Password Protected)
 const [acquireUnlocked, setAcquireUnlocked] = useState(false);
 const [passwordAttempt, setPasswordAttempt] = useState('');
 const [acquireState, setAcquireState] = useState({
 messages: [], // Chat messages [{role: 'assistant'|'user', content: '', persona: 'chanet'|'claudette'}]
 input: '',
 selectedApplicant: null, // 'brandon' | 'eric' | 'bj'
 parsedJob: null, // V38.9: Parsed job data for unified UI
 currentJob: {
 organization: '',
 title: '',
 url: '',
 deadline: '',
 salary: '',
 howToApply: '',
 location: '',
 description: '',
 issues: ''
 },
 coverLetter: '',
 applicationEmail: '',
 spreadsheetRow: '',
 awaitingApplicant: true, // First question: who are you?
 isProcessing: false,
 // V27.1: New fields for classification mismatch handling
 pendingClassification: null, // Stores classification when mismatch detected
 recommendedApplicant: null, // Who system recommends
 forwardEmail: null, // { to, link, targetName } for forward email button
 // V3.6.1: Store last cover letter for docx/pdf download
 lastCoverLetter: null,
 lastSpreadsheetRow: null
 });
 const [acquireInteractionCount, setAcquireInteractionCount] = useState(0);
 
 // V3.6: Template Library
 const [savedTemplates, setSavedTemplates] = useState(() => {
 try {
 const saved = localStorage.getItem('gmg_ace_templates');
 return saved ? JSON.parse(saved) : [];
 } catch { return []; }
 });
 const [showTemplateLibrary, setShowTemplateLibrary] = useState(false);
 const [templateFilter, setTemplateFilter] = useState('all');
 const [templateSearch, setTemplateSearch] = useState('');
 
 // V3.6: Shared Team Templates (Firebase)
 const [sharedTemplates, setSharedTemplates] = useState([]);
 const [showShareTemplate, setShowShareTemplate] = useState(false);
 const [templateToShare, setTemplateToShare] = useState(null);
 
 // V3.6: Cross-device Draft Sync
 const [syncEnabled, setSyncEnabled] = useState(() => {
 try {
 // V3.9: Default to enabled (true) unless explicitly disabled
 const stored = localStorage.getItem('gmg_ace_sync_enabled');
 return stored === null ? true : stored === 'true';
 } catch { return true; }
 });
 const [lastSyncTime, setLastSyncTime] = useState(null);
 const [syncStatus, setSyncStatus] = useState('idle'); // idle, syncing, synced, error
 
 // V3.6: Resume Features
 const [savedResumes, setSavedResumes] = useState(() => {
 try {
 const saved = localStorage.getItem('gmg_ace_resumes');
 return saved ? JSON.parse(saved) : [];
 } catch { return []; }
 });
 const [showResumeManager, setShowResumeManager] = useState(false);
 const [resumeAnalysis, setResumeAnalysis] = useState(null);
 
 // V3.6: Client Contacts Quick Access
 const [clientContacts, setClientContacts] = useState(() => {
 try {
 const saved = localStorage.getItem('gmg_ace_client_contacts');
 return saved ? JSON.parse(saved) : [];
 } catch { return []; }
 });
 const [showClientContacts, setShowClientContacts] = useState(false);
 
 // V38.10: Brainstorming Calls Tab State
 const [brainstormUnlocked, setBrainstormUnlocked] = useState(false);
 const [brainstormPassword, setBrainstormPassword] = useState('');
 const [brainstormState, setBrainstormState] = useState({
   messages: [],
   input: '',
   processedTranscripts: [], // Memory log of processed transcripts
   currentOutput: null,
   outputFiles: [] // Generated .md files
 });
 
 // Brainstorm password check
 const handleBrainstormPasswordSubmit = () => {
   if (brainstormPassword.toLowerCase() === 'bigbrain') {
     setBrainstormUnlocked(true);
     showToast('Access granted! Big brain mode activated.', 'success');
   } else {
     showToast('Incorrect password', 'error');
   }
   setBrainstormPassword('');
 };
 
 // Process transcript and categorize content
 const processTranscript = async (transcriptText) => {
   const prompt = `You are processing a meeting transcript for Global Majority Group (GMG).

TASK:
1. Read the transcript carefully
2. Clean up obvious speech-to-text errors internally (do NOT return the cleaned transcript)
3. Categorize the content into relevant sections:
   - STRATEGIC_PLAN: Internal finances, profit margins, business planning, revenue discussions
   - TASK_LIST: Action items, paperwork tasks, things to accomplish, deadlines
   - CLIENT_ACQUISITION: Client outreach, prospect discussions, sales, leads
   - ELI_TASKS: Anything about Eli Cooley or Lane-Pierce Fellowship paperwork
   - MEETING_NOTES: General discussion points that don't fit other categories
4. For each category that has content, create a formatted section
5. Be comprehensive but concise

OUTPUT FORMAT (as JSON):
{
  "categories": [
    {
      "name": "STRATEGIC_PLAN",
      "filename": "strategic_plan_update.md",
      "content": "# Strategic Plan Update\\n\\n## Key Points\\n\\n- Point 1\\n- Point 2..."
    }
  ],
  "summary": "Brief 2-3 sentence summary of what was discussed",
  "actionItems": ["Action 1", "Action 2"]
}

TRANSCRIPT:
${transcriptText}

Return ONLY valid JSON. No markdown code blocks. No preamble.`;

   try {
     const response = await fetch('https://api.anthropic.com/v1/messages', {
       method: 'POST',
       headers: getApiHeaders(),
       body: JSON.stringify({
         model: MODEL_CONFIG.fast,
         max_tokens: 8000,
         messages: [{ role: 'user', content: prompt }]
       })
     });

     const data = await response.json();
     let result = data.content?.[0]?.text || "";
     result = result.replace(/\`\`\`json\\n?/g, '').replace(/\`\`\`\\n?/g, '').trim();
     return JSON.parse(result);
   } catch (error) {
     devError('Transcript processing failed:', error);
     return { error: error.message };
   }
 };
 
 // V33: Application History (persisted to localStorage)
 const [applicationHistory, setApplicationHistory] = useState(() => {
 try {
 const stored = localStorage.getItem('gmg_application_history');
 return stored ? JSON.parse(stored) : [];
 } catch { return []; }
 });
 
 // V33: Save application history to localStorage
 const saveApplication = (app) => {
 const newHistory = [{ ...app, timestamp: Date.now() }, ...applicationHistory].slice(0, 50);
 setApplicationHistory(newHistory);
 try { localStorage.setItem('gmg_application_history', JSON.stringify(newHistory)); } catch (e) { devWarn('localStorage failed:', e); }
 };
 
 // V33: Search application history
 const searchApplications = (query) => {
 if (!query) return applicationHistory;
 const lower = query.toLowerCase();
 return applicationHistory.filter(app => 
 app.organization?.toLowerCase().includes(lower) ||
 app.title?.toLowerCase().includes(lower) ||
 app.applicant?.toLowerCase().includes(lower)
 );
 };
 
 // V33: Show application history panel
 const [showAppHistory, setShowAppHistory] = useState(false);
 const [appHistorySearch, setAppHistorySearch] = useState('');
 
 // V29: Client Prep tab state
 const [prepState, setPrepState] = useState({
 input: '', // V38.9: Unified input field
 clientName: '',
 materials: '', // Pasted materials
 briefing: null, // Generated briefing
 isProcessing: false,
 messages: [], // V32: Added for roleplay compatibility
 history: [] // Previous briefings
 });
 
 // V37: Pitch Deck State
 const [pitchDeckState, setPitchDeckState] = useState({
 clientName: '',
 clientDescription: '',
 generatedHTML: null,
 isGenerating: false,
 showPreview: false
 });
 
 const [showBackToTop, setShowBackToTop] = useState(false);
 
 // Refs
 const fileInputRef = useRef(null);
 const chatEndRef = useRef(null);
 const messagesEndRef = useRef(null); // V2.6: For unified chat scroll
 const acquireChatRef = useRef(null); // V27: For acquire tab chat scroll
 const welcomeChatRef = useRef(null); // V26: For welcome popup auto-scroll
 const recognitionRef = useRef(null);
 const synthRef = useRef(null);
 
 // V25: Save session count to localStorage when it changes
 // V3.5: Also saves to Firebase when user is logged in
 useEffect(() => {
 if (currentUser?.uid) {
 saveSessionCountToFirebase(currentUser.uid, sessionCount);
 } else {
 saveSessionCount(sessionCount);
 }
 }, [sessionCount, currentUser]);
 
 // V3.5: Load session count from Firebase when user logs in
 useEffect(() => {
 if (currentUser?.uid) {
 loadSessionCountFromFirebase(currentUser.uid).then(fbCount => {
 if (fbCount > 0) {
 setSessionCount(fbCount);
 }
 });
 }
 }, [currentUser]);
 
 // V33: Save active tab to localStorage
 useEffect(() => {
 try { localStorage.setItem('gmg_ace_active_tab', activeTab); } catch (e) { devWarn('localStorage failed:', e); }
 }, [activeTab]);
 
 // V3.6: Dark Mode Persistence and System Preference
 useEffect(() => {
 try { localStorage.setItem('gmg_ace_dark_mode', isDarkMode.toString()); } catch (e) { devWarn('localStorage failed:', e); }
 // Update body class for global dark mode styling
 document.body.classList.toggle('dark-mode', isDarkMode);
 // Update meta theme-color for mobile browsers
 const metaTheme = document.querySelector('meta[name="theme-color"]');
 if (metaTheme) {
 metaTheme.setAttribute('content', isDarkMode ? '#0f0f1a' : '#191970');
 }
 }, [isDarkMode]);
 
 // V3.6: Listen for system dark mode preference changes
 useEffect(() => {
 const mediaQuery = window.matchMedia?.('(prefers-color-scheme: dark)');
 const handleChange = (e) => {
 // Only auto-switch if user hasn't manually set preference
 const userPref = localStorage.getItem('gmg_ace_dark_mode_manual');
 if (!userPref) {
 setIsDarkMode(e.matches);
 }
 };
 mediaQuery?.addEventListener?.('change', handleChange);
 return () => mediaQuery?.removeEventListener?.('change', handleChange);
 }, []);
 
 // V3.6: Auto-Save Drafts every 30 seconds
 useEffect(() => {
 const autoSaveInterval = setInterval(() => {
 const currentDrafts = {};
 let hasContent = false;
 
 // Save each tab's content if it has input
 if (createState.input?.trim()) {
 currentDrafts.create = { content: createState.input, timestamp: Date.now() };
 hasContent = true;
 }
 if (checkState.input?.trim()) {
 currentDrafts.check = { content: checkState.input, timestamp: Date.now() };
 hasContent = true;
 }
 if (askState.input?.trim()) {
 currentDrafts.ask = { content: askState.input, timestamp: Date.now() };
 hasContent = true;
 }
 if (prepState.input?.trim()) {
 currentDrafts.prep = { content: prepState.input, timestamp: Date.now() };
 hasContent = true;
 }
 if (acquireState.input?.trim()) {
 currentDrafts.acquire = { content: acquireState.input, timestamp: Date.now() };
 hasContent = true;
 }
 
 if (hasContent) {
 try {
 localStorage.setItem('gmg_ace_drafts', JSON.stringify(currentDrafts));
 setDraftSaveIndicator('Draft saved');
 setTimeout(() => setDraftSaveIndicator(''), 2000);
 } catch (e) {
 devError('Failed to save drafts:', e);
 }
 }
 }, 30000); // Every 30 seconds
 
 return () => clearInterval(autoSaveInterval);
 }, [createState.input, checkState.input, askState.input, prepState.input, acquireState.input]);
 
 // V5.4: API Status Check
 useEffect(() => {
 const checkApiStatus = async () => {
  try {
  const response = await fetch('https://api.anthropic.com/v1/messages', {
   method: 'POST',
   headers: getApiHeaders(),
   body: JSON.stringify({
   model: MODEL_CONFIG.fast,
   max_tokens: 10,
   messages: [{ role: 'user', content: 'ping' }]
   })
  });
  setApiStatus(response.ok ? 'connected' : 'error');
  setLastApiCheck(new Date().toLocaleTimeString());
  } catch (e) {
  setApiStatus('error');
  setLastApiCheck(new Date().toLocaleTimeString());
  }
 };
 
 checkApiStatus();
 const interval = setInterval(checkApiStatus, 60000); // Check every 60 seconds
 return () => clearInterval(interval);
 }, []);
 
 // V3.6: Check for draft recovery on mount
 useEffect(() => {
 try {
 const savedDrafts = localStorage.getItem('gmg_ace_drafts');
 if (savedDrafts) {
 const parsed = JSON.parse(savedDrafts);
 const hasDrafts = Object.keys(parsed).some(key => parsed[key]?.content?.trim());
 if (hasDrafts) {
 setDrafts(parsed);
 setShowDraftRecovery(true);
 }
 }
 } catch (e) {
 devError('Failed to load drafts:', e);
 }
 }, []);
 
 // V5.5: DISABLED floating tip - now adds welcome message to chat instead
 useEffect(() => {
 // Clear any existing floating tip
 if (floatingTipTimeoutRef.current) {
  clearTimeout(floatingTipTimeoutRef.current);
 }
 setFloatingTip(null);
 
 // V5.5: Add welcome messages to chat as Claudette/Chanet messages
 const tips = TAB_TIPS[activeTab];
 if (tips && tips.length > 0) {
  const randomTip = tips[Math.floor(Math.random() * tips.length)];
  
  // Only add if chat is empty or just has welcome messages
  const currentMessages = getCurrentState().messages || [];
  const hasRealContent = currentMessages.some(m => m.type === 'user' || m.type === 'result');
  
  if (!hasRealContent) {
  // Add as a chat message instead of floating
  const welcomeMsg = {
   type: 'assistant',
   speaker: randomTip.speaker,
   content: randomTip.text,
   timestamp: Date.now()
  };
  setCurrentState(prev => ({
   ...prev,
   messages: [welcomeMsg]
  }));
  }
 }
 }, [activeTab]);
 
 // V3.6: Load applications from Firebase
 useEffect(() => {
 if (currentUser?.uid && db) {
 const loadApps = async () => {
 try {
 const q = query(
 collection(db, 'applications'),
 where('userId', '==', currentUser.uid),
 orderBy('appliedDate', 'desc')
 );
 const snapshot = await getDocs(q);
 setApplications(snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
 } catch (e) {
 devError('Failed to load applications:', e);
 }
 };
 loadApps();
 }
 }, [currentUser]);
 
 // V3.6: Session Timeout Handler
 useEffect(() => {
 const updateActivity = () => setLastActivity(Date.now());
 
 // Track user activity
 window.addEventListener('mousemove', updateActivity);
 window.addEventListener('keypress', updateActivity);
 window.addEventListener('click', updateActivity);
 window.addEventListener('scroll', updateActivity);
 window.addEventListener('touchstart', updateActivity);
 
 // Check timeout every minute
 const timeoutCheck = setInterval(() => {
 const inactiveMinutes = (Date.now() - lastActivity) / 1000 / 60;
 
 if (inactiveMinutes >= sessionTimeoutMinutes) {
 // Session timeout - save drafts and show warning
 setShowTimeoutWarning(true);
 } else if (inactiveMinutes >= sessionTimeoutMinutes - warningMinutes) {
 // Show warning
 const remaining = Math.ceil(sessionTimeoutMinutes - inactiveMinutes);
 if (!showTimeoutWarning) {
  showToast(`Session timeout in ${remaining} minutes`, 'warning');
 }
 }
 }, 60000); // Check every minute
 
 return () => {
 window.removeEventListener('mousemove', updateActivity);
 window.removeEventListener('keypress', updateActivity);
 window.removeEventListener('click', updateActivity);
 window.removeEventListener('scroll', updateActivity);
 window.removeEventListener('touchstart', updateActivity);
 clearInterval(timeoutCheck);
 };
 }, [lastActivity, showTimeoutWarning]);
 
 // V3.6: Application Follow-up Reminder Check
 useEffect(() => {
 // V6.4: iOS Keyboard Detection
 const handleKeyboard = () => {
 if (window.visualViewport) {
  const viewportHeight = window.visualViewport.height;
  const windowHeight = window.innerHeight;
  const keyboardOpen = windowHeight - viewportHeight > 150;
  
  if (keyboardOpen) {
  document.body.classList.add('keyboard-open');
  } else {
  document.body.classList.remove('keyboard-open');
  }
 }
 };
 
 if (window.visualViewport) {
 window.visualViewport.addEventListener('resize', handleKeyboard);
 }
 
 // Also detect focus/blur on inputs
 const handleFocus = () => document.body.classList.add('keyboard-open');
 const handleBlur = () => setTimeout(() => document.body.classList.remove('keyboard-open'), 100);
 
 const inputs = document.querySelectorAll('textarea, input');
 inputs.forEach(input => {
 input.addEventListener('focus', handleFocus);
 input.addEventListener('blur', handleBlur);
 });
 
 return () => {
 if (window.visualViewport) {
  window.visualViewport.removeEventListener('resize', handleKeyboard);
 }
 inputs.forEach(input => {
  input.removeEventListener('focus', handleFocus);
  input.removeEventListener('blur', handleBlur);
 });
 };
 }, []);
 
 useEffect(() => {
 // Check for applications that need follow-up (applied > 7 days ago, still in APPLIED status)
 if (applications.length > 0) {
 const now = Date.now();
 const sevenDaysMs = 7 * 24 * 60 * 60 * 1000;
 
 const needsFollowUp = applications.filter(app => {
 if (app.status !== 'APPLIED') return false;
 const appliedDate = new Date(app.appliedDate).getTime();
 return (now - appliedDate) > sevenDaysMs;
 });
 
 if (needsFollowUp.length > 0) {
 // Check if we've already reminded today
 const lastReminderDate = localStorage.getItem('gmg_ace_last_reminder_date');
 const today = new Date().toDateString();
 
 if (lastReminderDate !== today) {
  showToast(`${needsFollowUp.length} application(s) need follow-up!`, 'warning');
  localStorage.setItem('gmg_ace_last_reminder_date', today);
 }
 }
 }
 }, [applications]);

 // V3.6: Load shared templates on mount
 // V5.1: Real-time sync with onSnapshot - everyone sees updates instantly
 useEffect(() => {
 if (!db) return;
 
 // V5.1: Real-time listener for shared templates
 const unsubTemplates = onSnapshot(
 query(collection(db, 'shared_templates'), orderBy('sharedAt', 'desc')),
 (snapshot) => {
  setSharedTemplates(snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
  devLog('V5.1: Real-time templates update -', snapshot.docs.length, 'templates');
 },
 (error) => devError('Templates listener error:', error)
 );
 
 // V5.1: Real-time listener for shared phrases
 const unsubPhrases = onSnapshot(
 query(collection(db, 'shared_phrases'), orderBy('addedAt', 'desc')),
 (snapshot) => {
  const phrases = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
  setCustomBannedPhrases(phrases);
  devLog('V5.1: Real-time phrases update -', phrases.length, 'phrases');
 },
 (error) => devError('Phrases listener error:', error)
 );
 
 // V5.1: Real-time listener for shared contacts
 const unsubContacts = onSnapshot(
 query(collection(db, 'shared_contacts'), orderBy('addedAt', 'desc')),
 (snapshot) => {
  setSharedClientContacts(snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
  devLog('V5.1: Real-time contacts update -', snapshot.docs.length, 'contacts');
 },
 (error) => devError('Contacts listener error:', error)
 );
 
 // V5.1: Real-time listener for live knowledge
 const unsubKnowledge = onSnapshot(
 query(collection(db, 'live_knowledge'), orderBy('addedAt', 'desc')),
 (snapshot) => {
  setLiveKnowledge(snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
  devLog('V5.1: Real-time knowledge update -', snapshot.docs.length, 'entries');
 },
 (error) => devError('Knowledge listener error:', error)
 );
 
 // V5.1: Real-time listener for team applications log
 const unsubTeamApps = onSnapshot(
 query(collection(db, 'team_applications_log'), orderBy('appliedAt', 'desc')),
 (snapshot) => {
  setTeamApplicationsLog(snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
  devLog('V5.1: Real-time team apps update -', snapshot.docs.length, 'applications');
 },
 (error) => devError('Team apps listener error:', error)
 );
 
 // Cleanup: unsubscribe all listeners when component unmounts
 return () => {
 unsubTemplates();
 unsubPhrases();
 unsubContacts();
 unsubKnowledge();
 unsubTeamApps();
 };
 }, [db]);
 
 // V3.6: Auto-sync drafts to cloud when sync is enabled
 useEffect(() => {
 if (syncEnabled && currentUser?.uid) {
 // Sync every 2 minutes when enabled
 const syncInterval = setInterval(() => {
 syncDraftsToCloud();
 }, 120000);
 
 return () => clearInterval(syncInterval);
 }
 }, [syncEnabled, currentUser, createState.input, checkState.input, askState.input, prepState.input, acquireState.input]);
 
 // V3.6: Load drafts from cloud on login when sync is enabled
 useEffect(() => {
 if (syncEnabled && currentUser?.uid) {
 loadDraftsFromCloud();
 }
 }, [currentUser, syncEnabled]);

 // V3.1: Sync history to Firebase when user is logged in
 useEffect(() => {
 if (currentUser?.uid && historyLog.length > 0) {
 saveHistory(historyLog, currentUser.uid);
 }
 }, [historyLog, currentUser]);
 
 // V3.1: Load history from Firebase when user logs in
 useEffect(() => {
 if (currentUser?.uid) {
 loadFirebaseHistory(currentUser.uid).then(fbHistory => {
 if (fbHistory && fbHistory.length > 0) {
 setHistoryLog(fbHistory);
 }
 });
 }
 }, [currentUser]);
 
 // V3.2: Subscribe to live knowledge updates from Firebase
 useEffect(() => {
 // Load initial knowledge
 loadKnowledgeAdditions().then(additions => {
 if (additions && additions.length > 0) {
 setLiveKnowledge(additions);
 }
 });
 
 // Subscribe to real-time updates
 const unsubscribe = subscribeToKnowledge((additions) => {
 setLiveKnowledge(additions);
 });
 
 return () => unsubscribe();
 }, []);
 
 // V3.2: Handle knowledge form submission
 const handleKnowledgeSubmit = async () => {
 if (!knowledgeForm.title.trim() || !knowledgeForm.content.trim()) {
 showToast('Please fill in both title and content');
 return;
 }
 
 if (!currentUser) {
 showToast('Please sign in to add knowledge');
 return;
 }
 
 setKnowledgeSubmitting(true);
 
 const result = await saveKnowledgeAddition({
 category: knowledgeForm.category,
 title: knowledgeForm.title.trim(),
 content: knowledgeForm.content.trim(),
 addedBy: currentUser.email,
 addedByName: currentUser.displayName || currentUser.email.split('@')[0]
 });
 
 setKnowledgeSubmitting(false);
 
 if (result) {
 setKnowledgeSuccess(true);
 setKnowledgeForm({ category: 'client', title: '', content: '' });
 showToast('Knowledge added! Everyone can see it now.');
 setTimeout(() => setKnowledgeSuccess(false), 3000);
 } else {
 showToast('Failed to save. Try again.');
 }
 };
 
 // V3.2: Search live knowledge (for Ask GMG integration)
 const searchLiveKnowledge = (query) => {
 if (!query || !liveKnowledge.length) return [];
 const lowerQuery = query.toLowerCase();
 return liveKnowledge.filter(item => 
 item.searchText?.includes(lowerQuery) ||
 item.title?.toLowerCase().includes(lowerQuery) ||
 item.content?.toLowerCase().includes(lowerQuery)
 );
 };
 
 // V27.4: Back to top scroll detection
 useEffect(() => {
 const handleScroll = () => {
 setShowBackToTop(window.scrollY > 300);
 };
 window.addEventListener('scroll', handleScroll);
 return () => window.removeEventListener('scroll', handleScroll);
 }, []);
 
 const scrollToTop = () => {
 window.scrollTo({ top: 0, behavior: 'smooth' });
 };
 
 // ===== WELCOME ANIMATION =====
 useEffect(() => {
 if (showWelcome && welcomeMessages.length < WELCOME_DIALOGUE.length) {
 const timer = setTimeout(() => {
 setWelcomeMessages(prev => [...prev, WELCOME_DIALOGUE[prev.length]]);
 }, welcomeMessages.length === 0 ? 800 : 2200); // V26: Slowed from 500/1500 to 800/2200
 return () => clearTimeout(timer);
 } else if (welcomeMessages.length === WELCOME_DIALOGUE.length) {
 setWelcomeComplete(true);
 }
 }, [showWelcome, welcomeMessages]);
 
 // V26: Auto-scroll welcome chat as messages appear
 useEffect(() => {
 if (welcomeChatRef.current && welcomeMessages.length > 0) {
 welcomeChatRef.current.scrollTop = welcomeChatRef.current.scrollHeight;
 }
 }, [welcomeMessages]);
 
 // V27: Auto-scroll acquire chat as messages appear
 useEffect(() => {
 if (acquireChatRef.current && acquireState.messages.length > 0) {
 requestAnimationFrame(() => {
 acquireChatRef.current.scrollTo({
 top: acquireChatRef.current.scrollHeight,
 behavior: 'smooth'
 });
 });
 }
 }, [acquireState.messages]);
 
 // ===== SCROLL CHAT TO BOTTOM (only within chat container, NOT the page) =====
 // V26: Changed to scroll within container only, not the whole page
 useEffect(() => {
 if (chatEndRef.current && chatMessages.length > 0) {
 // Use requestAnimationFrame to ensure DOM is updated before scrolling
 requestAnimationFrame(() => {
 const chatContainer = chatEndRef.current?.parentElement;
 if (chatContainer) {
 // Smooth scroll within the chat container only
 chatContainer.scrollTo({
 top: chatContainer.scrollHeight,
 behavior: 'smooth'
 });
 }
 });
 }
 }, [chatMessages]);
 
 // ===== ANIMATE CHAT INTRO =====
 useEffect(() => {
 // Only animate intro if we haven't started processing and intro isn't complete
 if (chatIntroIndex < CHAT_INTRO.length && !isProcessing) {
 const timer = setTimeout(() => {
 setChatMessages(prev => [...prev, CHAT_INTRO[chatIntroIndex]]);
 setChatIntroIndex(prev => prev + 1);
 }, chatIntroIndex === 0 ? 800 : 2200); // V26: Slowed from 500/1500 to 800/2200
 return () => clearTimeout(timer);
 }
 }, [chatIntroIndex, isProcessing]);
 
 // ===== V2.9: ROLEPLAY INTRO TYPING (Like GMG University) =====
 // When tab changes and messages are empty, type intros one at a time
 useEffect(() => {
 // Clear any pending timeouts
 if (introTimeoutRef.current) {
  clearTimeout(introTimeoutRef.current);
 }
 
 // Reset intro state when tab changes
 setIntroMessages([]);
 setIntroTypingPhase(0);
 
 // Only run if unified messages are empty
 if (unifiedMessages.length > 0) return;
 
 // Get intro text based on tab
 const getIntroText = (phase) => {
  if (activeTab === 'acquire') {
  if (phase === 0) return "Ready to land your dream job? Paste a job URL or description, then tell me who's applying.";
  if (phase === 1) return "I'll analyze the posting, pull out requirements, and draft a cover letter that passes AI detection.";
  if (phase === 2) return 'Try: "Paste job description and say \'Brandon\' to generate his cover letter"';
  }
  
  const tabIntro = TAB_INTROS[activeTab];
  if (!tabIntro?.dialogue) return null;
  
  if (phase === 0) return tabIntro.dialogue[0]?.text;
  if (phase === 1) return tabIntro.dialogue[1]?.text;
  if (phase === 2) return cachedExamples[activeTab] ? `Try: "${cachedExamples[activeTab]}"` : null;
  return null;
 };
 
 // Phase 0: Show Claudette typing
 introTimeoutRef.current = setTimeout(() => {
  setIntroMessages([{ speaker: 'claudette', isTyping: true }]);
  
  // Phase 1: Show Claudette's message, then Chanet typing
  introTimeoutRef.current = setTimeout(() => {
  setIntroMessages([
   { speaker: 'claudette', text: getIntroText(0), isTyping: false },
   { speaker: 'chanet', isTyping: true }
  ]);
  
  // Phase 2: Show Chanet's message, then tip
  introTimeoutRef.current = setTimeout(() => {
   setIntroMessages([
   { speaker: 'claudette', text: getIntroText(0), isTyping: false },
   { speaker: 'chanet', text: getIntroText(1), isTyping: false },
   { speaker: 'tip', isTyping: true }
   ]);
   
   // Phase 3: Show tip message
   introTimeoutRef.current = setTimeout(() => {
   setIntroMessages([
    { speaker: 'claudette', text: getIntroText(0), isTyping: false },
    { speaker: 'chanet', text: getIntroText(1), isTyping: false },
    { speaker: 'tip', text: getIntroText(2), isTyping: false }
   ]);
   setIntroTypingPhase(5); // Complete
   }, 800);
  }, 1200);
  }, 1000);
 }, 500);
 
 return () => {
  if (introTimeoutRef.current) {
  clearTimeout(introTimeoutRef.current);
  }
 };
 }, [activeTab, unifiedMessages.length]);
 
 // ===== V25/V31.5: KEYBOARD SHORTCUTS =====
 useEffect(() => {
 const handleKeyDown = (e) => {
 // Don't trigger if user is typing in textarea
 const isTyping = document.activeElement?.tagName === 'TEXTAREA' || 
 document.activeElement?.tagName === 'INPUT';
 
 // Ctrl/Cmd + Enter = Submit (works even when typing)
 if ((e.ctrlKey || e.metaKey) && e.key === 'Enter') {
 e.preventDefault();
 // Trigger submit button click
 const submitBtn = document.querySelector('.submit-btn');
 if (submitBtn && !submitBtn.disabled) {
 submitBtn.click();
 }
 return;
 }
 
 // V31.5: Ctrl/Cmd + Shift + C = Copy result to clipboard
 if ((e.ctrlKey || e.metaKey) && e.shiftKey && e.key === 'C') {
 e.preventDefault();
 const result = getCurrentState()?.result;
 if (result) {
 navigator.clipboard.writeText(stripMarkdown(result)).then(() => {
 showToast('Result copied to clipboard');
 });
 }
 return;
 }
 
 // V31.5: Ctrl/Cmd + H = Toggle history panel
 if ((e.ctrlKey || e.metaKey) && e.key === 'h') {
 e.preventDefault();
 setShowHistory(prev => !prev);
 return;
 }
 
 // V31.5: Ctrl/Cmd + K = Clear current input
 if ((e.ctrlKey || e.metaKey) && e.key === 'k') {
 e.preventDefault();
 setCurrentState(prev => ({ ...prev, input: '', result: null }));
 showToast('Cleared');
 return;
 }
 
 // V5.4: Ctrl/Cmd + / = Toggle shortcuts help modal
 if ((e.ctrlKey || e.metaKey) && e.key === '/') {
 e.preventDefault();
 setShowShortcutsModal(prev => !prev);
 return;
 }
 
 // Escape = Close popups
 if (e.key === 'Escape') {
 setShowPopup(false);
 setTemplatePopup(prev => ({ ...prev, show: false }));
 setShowHistory(false);
 setShowShortcutsModal(false);
 setShowQuickTemplates(false);
 return;
 }
 
 // Tab switching only when not typing
 if (isTyping) return;
 
 // Ctrl + 1/2/3 = Switch tabs
 if (e.ctrlKey && e.key === '1') {
 e.preventDefault();
 setActiveTab('create');
 } else if (e.ctrlKey && e.key === '2') {
 e.preventDefault();
 setActiveTab('check');
 } else if (e.ctrlKey && e.key === '3') {
 e.preventDefault();
 setActiveTab('ask');
 }
 };
 
 window.addEventListener('keydown', handleKeyDown);
 return () => window.removeEventListener('keydown', handleKeyDown);
 }, [activeTab]);
 
 // ===== V26: SMART SUGGESTIONS =====
 useEffect(() => {
 // V31.5: Smart suggestions for ALL tabs
 const currentInput = getCurrentState()?.input || '';
 if (currentInput.length > 15) {
 const timer = setTimeout(() => {
 setSuggestions(generateSmartSuggestions(currentInput, activeTab));
 }, 500);
 return () => clearTimeout(timer);
 } else {
 setSuggestions([]);
 }
 }, [createState.input, checkState.input, askState.input, activeTab]);
 
 // ===== V26: ANALYTICS UPDATE FUNCTION =====
 const updateAnalytics = (type, issueCount = 0, issues = []) => {
 const today = new Date().toISOString().split('T')[0];
 
 setAnalytics(prev => {
 const updated = { ...prev };
 
 if (type === 'create') updated.totalCreates++;
 if (type === 'check') {
 updated.totalChecks++;
 if (issueCount > 0) updated.checksWithIssues++;
 updated.totalIssuesFound += issueCount;
 
 issues.forEach(issue => {
 const issueType = issue.severity || 'other';
 updated.issuesByType[issueType] = (updated.issuesByType[issueType] || 0) + 1;
 });
 }
 if (type === 'ask') updated.totalAsks++;
 
 if (!updated.dailyStats[today]) {
 updated.dailyStats[today] = { creates: 0, checks: 0, asks: 0, issues: 0 };
 }
 if (type === 'create') updated.dailyStats[today].creates++;
 if (type === 'check') {
 updated.dailyStats[today].checks++;
 updated.dailyStats[today].issues += issueCount;
 }
 if (type === 'ask') updated.dailyStats[today].asks++;
 
 saveAnalytics(updated);
 return updated;
 });
 };
 
 // ===== V26: SAVE LEARNED CORRECTION =====
 const handleSaveLearnedCorrection = () => {
 if (!checkState.result || !editedOutput) return;
 
 const original = checkState.result.corrected;
 const edited = editedOutput;
 
 if (original === edited) {
 setIsEditingOutput(false);
 return;
 }
 
 const correction = {
 id: Date.now(),
 timestamp: new Date().toISOString(),
 original: original.substring(0, 200),
 edited: edited.substring(0, 200),
 pattern: extractEditPattern(original, edited)
 };
 
 setLearnedCorrections(prev => {
 const updated = [correction, ...prev].slice(0, 50);
 saveLearnedCorrections(updated);
 return updated;
 });
 
 setCheckState(prev => ({
 ...prev,
 result: { ...prev.result, corrected: edited }
 }));
 
 setIsEditingOutput(false);
 showToast('Learned from your edit!');
 };
 
 // ===== HELPERS =====
 
 const showToast = (message, type = 'info') => {
 setToast({ message, type });
 setTimeout(() => setToast(null), 3000);
 };
 
 // ============================================
 // V2.10: ADMIN PERSONA DELIVERY FUNCTIONS
 // ============================================
 
 // Generate content wrapped in persona voice
 const generateWithPersona = async (content, personaId, recipient, contentType = 'general') => {
  const persona = DELIVERY_PERSONAS[personaId];
  if (!persona) return content;
  
  // If direct persona (Brandon or Eric), just return content as-is
  if (persona.type === 'direct') {
   return content;
  }
  
  // For admin personas, wrap content in delivery format
  try {
   const response = await fetch('https://api.anthropic.com/v1/messages', {
    method: 'POST',
    headers: getApiHeaders(),
    body: JSON.stringify({
     model: MODEL_CONFIG.quality,
     max_tokens: 4000,
     system: persona.systemPrompt,
     messages: [{
      role: 'user',
      content: `You are ${persona.name}. ${persona.boss} has asked you to deliver this work to ${recipient || 'the recipient'}.

CONTENT TO DELIVER:
${content}

CONTENT TYPE: ${contentType}

Write a complete delivery message as ${persona.name}. Follow the delivery format structure exactly:
1. Greeting to ${recipient || 'recipient'}
2. Context line about what ${persona.bossShort} asked you to do
3. The main content (include the actual work, not just a summary)
4. Any strategic questions or recommendations if appropriate
5. Closing
6. Your signature

Remember: Write as ${persona.name}, reference ${persona.bossShort} in third person, follow all writing rules.`
     }]
    })
   });
   
   if (!response.ok) throw new Error('API error');
   
   const data = await response.json();
   let result = '';
   if (data.content && Array.isArray(data.content)) {
    for (const block of data.content) {
     if (block.type === 'text') result += block.text;
    }
   }
   
   return result || content;
  } catch (error) {
   console.error('Persona generation error:', error);
   showToast('Error generating persona delivery. Using original content.', 'error');
   return content;
  }
 };
 
 // Handle delivery persona selection and generation
 const handleDeliveryPersonaSelect = async (personaId) => {
  if (!pendingDeliveryContent) return;
  
  setIsProcessing(true);
  
  const deliveredContent = await generateWithPersona(
   pendingDeliveryContent.content,
   personaId,
   deliveryRecipient,
   pendingDeliveryContent.type
  );
  
  // V2.14: Show preview instead of immediately adding to messages
  setDeliveryPreview({
   content: deliveredContent,
   persona: DELIVERY_PERSONAS[personaId],
   personaId: personaId
  });
  
  setIsProcessing(false);
 };
 
 // V2.14: Confirm delivery preview
 const confirmDeliveryPreview = () => {
  if (!deliveryPreview) return;
  
  // Add the delivered content as a message
  setUnifiedMessages(prev => [...prev, {
   id: Date.now(),
   type: 'assistant',
   speaker: deliveryPreview.personaId === 'claudette' || deliveryPreview.personaId === 'brandon' ? 'claudette' : 'chanet',
   content: deliveryPreview.content,
   deliveredAs: deliveryPreview.persona.name,
   isDelivery: true
  }]);
  
  setShowDeliverySelector(false);
  setPendingDeliveryContent(null);
  setSelectedDeliveryPersona(null);
  setDeliveryRecipient('');
  setDeliveryPreview(null);
  
  showToast(`Delivered as ${deliveryPreview.persona.name}`, 'success');
 };
 
 // V2.14: Go back from preview to edit
 const backFromPreview = () => {
  setDeliveryPreview(null);
 };
 
 // Skip persona delivery and use original content
 const skipPersonaDelivery = () => {
  if (!pendingDeliveryContent) return;
  
  setUnifiedMessages(prev => [...prev, {
   id: Date.now(),
   type: 'assistant',
   speaker: 'claudette',
   content: pendingDeliveryContent.content
  }]);
  
  setShowDeliverySelector(false);
  setPendingDeliveryContent(null);
  setDeliveryPreview(null);
 };
 
 // Check if current tab should show persona selector
 const shouldShowPersonaSelector = () => {
  if (activeTab === 'acquire') return false; // Never on Jobs tab
  return deliverySelectorEnabled;
 };
 
 // Trigger persona selector after content generation
 const triggerPersonaDelivery = (content, contentType = 'general') => {
  if (!shouldShowPersonaSelector()) {
   // Just add content directly without persona
   setUnifiedMessages(prev => [...prev, {
    id: Date.now(),
    type: 'assistant',
    speaker: 'claudette',
    content: content
   }]);
   return;
  }
  
  // Store pending content and show selector
  setPendingDeliveryContent({ content, type: contentType });
  setShowDeliverySelector(true);
  
  // Default persona based on logged in user
  if (currentUser?.email?.includes('brandon') || currentUser?.email?.includes('bpierce')) {
   setSelectedDeliveryPersona('claudette');
  } else if (currentUser?.email?.includes('eric') || currentUser?.email?.includes('elane')) {
   setSelectedDeliveryPersona('chanet');
  } else {
   setSelectedDeliveryPersona('claudette'); // Default to Claudette
  }
 };
 
 // ============================================
 // V2.11.1: SERVER-SIDE GMAIL FUNCTIONS
 // ============================================
 // No OAuth popup needed - tokens are stored on server.
 // Anyone can send emails, server handles authentication.
 // ============================================
 
 // Check email service status on load
 useEffect(() => {
  checkEmailServiceStatus();
 }, []);
 
 // Check if server-side email is configured
 const checkEmailServiceStatus = async () => {
  try {
   const response = await fetch('/api/email-status');
   if (response.ok) {
    const data = await response.json();
    setEmailServiceStatus(data.claudette || data.chanet ? 'available' : 'unavailable');
   } else {
    setEmailServiceStatus('unavailable');
   }
  } catch (error) {
   // API not deployed yet or error - default to available for local dev
   setEmailServiceStatus('available');
  }
 };
 
 // Send email via serverless function (server has the tokens)
 const sendEmailAsPersona = async (to, subject, body, personaId) => {
  const persona = DELIVERY_PERSONAS[personaId];
  if (!persona || persona.type !== 'admin') {
   showToast('Invalid persona for email', 'error');
   return false;
  }
  
  // Map persona to email account
  const emailAccount = personaId === 'claudette' ? 'claudette' : 'chanet';
  
  try {
   setSendingEmail(true);
   
   const response = await fetch('/api/send-email', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
     to,
     subject,
     body,
     account: emailAccount, // Server looks up tokens for this account
     fromName: persona.name,
     fromEmail: persona.email
    })
   });
   
   if (!response.ok) {
    const error = await response.json();
    throw new Error(error.message || 'Failed to send email');
   }
   
   showToast(`Email sent as ${persona.name}!`, 'success');
   
   // Log to audit
   logAdminAction('email_sent', { to, subject, persona: persona.name, sentBy: currentUser?.email });
   
   return true;
  } catch (error) {
   console.error('Send email error:', error);
   showToast(`Failed to send: ${error.message}`, 'error');
   return false;
  } finally {
   setSendingEmail(false);
  }
 };
 
 // ============================================
 // V2.11: ADMIN PORTAL FUNCTIONS
 // ============================================
 
 // Log admin action to audit trail
 const logAdminAction = (action, details = {}) => {
  const logEntry = {
   id: Date.now(),
   timestamp: new Date().toISOString(),
   user: currentUser?.email || 'unknown',
   action,
   details
  };
  
  setAdminData(prev => ({
   ...prev,
   auditLog: [logEntry, ...prev.auditLog].slice(0, 500) // Keep last 500 entries
  }));
  
  // Persist to localStorage
  try {
   const stored = JSON.parse(localStorage.getItem('admin_audit_log') || '[]');
   stored.unshift(logEntry);
   localStorage.setItem('admin_audit_log', JSON.stringify(stored.slice(0, 500)));
  } catch (e) {
   console.error('Failed to persist audit log');
  }
 };
 
 // Load admin data
 const loadAdminData = () => {
  if (!isAdmin) return;
  
  try {
   // Load audit log
   const auditLog = JSON.parse(localStorage.getItem('admin_audit_log') || '[]');
   
   // Load global templates
   const globalTemplates = JSON.parse(localStorage.getItem('admin_global_templates') || '[]');
   
   // Load global banned phrases
   const globalPhrases = JSON.parse(localStorage.getItem('admin_global_phrases') || '[]');
   
   // Load settings
   const settings = JSON.parse(localStorage.getItem('admin_settings') || '{}');
   
   // Compile analytics from local storage
   const analyticsData = {
    totalUsers: 0,
    activeToday: 0,
    totalChecks: analytics?.totalChecks || 0,
    totalCreates: analytics?.totalCreates || 0,
    totalAsks: analytics?.totalAsks || 0,
    issuesByType: analytics?.issuesByType || {}
   };
   
   setAdminData({
    users: [], // Would come from Firebase in production
    analytics: analyticsData,
    templates: globalTemplates,
    auditLog: auditLog,
    settings: settings,
    globalPhrases: globalPhrases
   });
   
  } catch (e) {
   console.error('Failed to load admin data:', e);
  }
 };
 
 // Open admin portal
 const openAdminPortal = () => {
  if (!isAdmin) {
   showToast('Access denied. Admin only.', 'error');
   return;
  }
  loadAdminData();
  logAdminAction('admin_portal_opened');
  setShowAdminPortal(true);
 };
 
 // Save global template
 const saveGlobalTemplate = (template) => {
  const newTemplate = {
   ...template,
   id: Date.now(),
   createdBy: currentUser?.email,
   createdAt: new Date().toISOString(),
   isGlobal: true
  };
  
  setAdminData(prev => ({
   ...prev,
   templates: [...prev.templates, newTemplate]
  }));
  
  // Persist
  const stored = JSON.parse(localStorage.getItem('admin_global_templates') || '[]');
  stored.push(newTemplate);
  localStorage.setItem('admin_global_templates', JSON.stringify(stored));
  
  logAdminAction('template_created', { name: template.name });
  showToast('Global template saved!', 'success');
 };
 
 // Delete global template
 const deleteGlobalTemplate = (templateId) => {
  setAdminData(prev => ({
   ...prev,
   templates: prev.templates.filter(t => t.id !== templateId)
  }));
  
  const stored = JSON.parse(localStorage.getItem('admin_global_templates') || '[]');
  localStorage.setItem('admin_global_templates', JSON.stringify(stored.filter(t => t.id !== templateId)));
  
  logAdminAction('template_deleted', { templateId });
  showToast('Template deleted');
 };
 
 // Save admin settings
 const saveAdminSettings = (newSettings) => {
  setAdminData(prev => ({
   ...prev,
   settings: { ...prev.settings, ...newSettings }
  }));
  
  localStorage.setItem('admin_settings', JSON.stringify({ ...adminData.settings, ...newSettings }));
  logAdminAction('settings_updated', newSettings);
  showToast('Settings saved!', 'success');
 };
 
 // Add global banned phrase
 const addGlobalBannedPhrase = (phrase, category = 'custom') => {
  const newPhrase = {
   id: Date.now(),
   phrase,
   category,
   addedBy: currentUser?.email,
   addedAt: new Date().toISOString()
  };
  
  setAdminData(prev => ({
   ...prev,
   globalPhrases: [...(prev.globalPhrases || []), newPhrase]
  }));
  
  const stored = JSON.parse(localStorage.getItem('admin_global_phrases') || '[]');
  stored.push(newPhrase);
  localStorage.setItem('admin_global_phrases', JSON.stringify(stored));
  
  logAdminAction('phrase_added', { phrase, category });
  showToast('Banned phrase added globally');
 };
 
 // ============================================
 
 // V3.6: Haptic feedback helper
 const triggerHaptic = (type = 'light') => {
 if ('vibrate' in navigator) {
 const patterns = {
  light: [10],
  medium: [20],
  heavy: [30],
  success: [10, 50, 10],
  error: [50, 30, 50]
 };
 navigator.vibrate(patterns[type] || patterns.light);
 }
 };
 
 // V3.6: Data Export function
 const exportAllData = () => {
 const exportData = {
 exportedAt: new Date().toISOString(),
 version: '3.6',
 user: currentUser?.email || 'guest',
 data: {
  conversationHistory,
  meetingNotes,
  savedTemplates,
  customBannedPhrases,
  followUpTasks,
  applications,
  historyLog,
  drafts
 }
 };
 
 const blob = new Blob([JSON.stringify(exportData, null, 2)], { type: 'application/json' });
 const url = URL.createObjectURL(blob);
 const a = document.createElement('a');
 a.href = url;
 a.download = `gmg-ace-export-${new Date().toISOString().split('T')[0]}.json`;
 document.body.appendChild(a);
 a.click();
 document.body.removeChild(a);
 URL.revokeObjectURL(url);
 
 triggerHaptic('success');
 showToast('Data exported successfully!');
 };
 
 // V3.6: Share template with team (Firebase)
 const shareTemplateWithTeam = async (template) => {
 if (!currentUser?.uid || !db) {
 showToast('Sign in to share templates', 'error');
 return;
 }
 
 try {
 const sharedTemplate = {
 ...template,
 sharedBy: currentUser.email,
 sharedAt: new Date().toISOString(),
 sharedByName: currentUser.displayName || currentUser.email.split('@')[0]
 };
 
 await addDoc(collection(db, 'shared_templates'), sharedTemplate);
 showToast('Template shared with team!');
 setShowShareTemplate(false);
 setTemplateToShare(null);
 
 // Reload shared templates
 loadSharedTemplates();
 } catch (e) {
 devError('Failed to share template:', e);
 showToast('Failed to share template', 'error');
 }
 };
 
 // V3.6: Load shared templates from Firebase
 const loadSharedTemplates = async () => {
 if (!db) return;
 
 try {
 const q = query(collection(db, 'shared_templates'), orderBy('sharedAt', 'desc'));
 const snapshot = await getDocs(q);
 setSharedTemplates(snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
 } catch (e) {
 devError('Failed to load shared templates:', e);
 }
 };
 
 // V5.1: Load SHARED custom phrases from Firebase (team-visible)
 const loadSharedPhrases = async () => {
 if (!db) return;
 try {
 const q = query(collection(db, 'shared_phrases'), orderBy('addedAt', 'desc'));
 const snapshot = await getDocs(q);
 const phrases = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
 setCustomBannedPhrases(phrases);
 devLog('V5.1: Loaded', phrases.length, 'shared phrases');
 } catch (e) {
 devError('Failed to load shared phrases:', e);
 }
 };
 
 // V5.1: Save custom phrase to SHARED Firebase collection
 // V5.1: No need to reload - onSnapshot updates automatically
 const saveSharedPhrase = async (phrase) => {
 if (!db || !currentUser) return;
 try {
 await addDoc(collection(db, 'shared_phrases'), {
 ...phrase,
 addedAt: new Date().toISOString(),
 addedBy: currentUser.uid,
 addedByName: currentUser.displayName || currentUser.email?.split('@')[0]
 });
 showToast('Phrase added for entire team!');
 // V5.1: onSnapshot auto-updates, no manual reload needed
 } catch (e) {
 devError('Failed to save shared phrase:', e);
 showToast('Failed to save phrase', 'error');
 }
 };
 
 // V5.1: Delete shared phrase
 // V5.1: No need to reload - onSnapshot handles it
 const deleteSharedPhrase = async (phraseId) => {
 if (!db) return;
 try {
 await deleteDoc(doc(db, 'shared_phrases', phraseId));
 showToast('Phrase removed');
 // V5.1: onSnapshot auto-updates
 } catch (e) {
 devError('Failed to delete phrase:', e);
 }
 };
 
 // V2.12: Delete knowledge entry
 const deleteKnowledgeEntry = async (entryId) => {
 if (!db) return;
 try {
 await deleteDoc(doc(db, 'live_knowledge', entryId));
 showToast('Knowledge entry removed');
 // onSnapshot auto-updates the list
 } catch (e) {
 devError('Failed to delete knowledge:', e);
 showToast('Failed to delete: ' + e.message);
 }
 };
 
 // V5.1: Load SHARED client contacts from Firebase (team-visible)
 const loadSharedContacts = async () => {
 if (!db) return;
 try {
 const q = query(collection(db, 'shared_contacts'), orderBy('addedAt', 'desc'));
 const snapshot = await getDocs(q);
 setSharedClientContacts(snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
 } catch (e) {
 devError('Failed to load shared contacts:', e);
 }
 };
 
 // V5.1: Save contact to SHARED Firebase collection
 // V5.1: No need to reload - onSnapshot handles it
 const saveSharedContact = async (contact) => {
 if (!db || !currentUser) return;
 try {
 await addDoc(collection(db, 'shared_contacts'), {
 ...contact,
 addedAt: new Date().toISOString(),
 addedBy: currentUser.uid,
 addedByName: currentUser.displayName || currentUser.email?.split('@')[0]
 });
 showToast('Contact added for entire team!');
 // V5.1: onSnapshot auto-updates
 } catch (e) {
 devError('Failed to save contact:', e);
 }
 };
 
 // V3.6: Cross-device Draft Sync - Save to Firebase
 // V4.7: Now also syncs custom phrases
 const syncDraftsToCloud = async () => {
 if (!currentUser?.uid || !db || !syncEnabled) return;
 
 setSyncStatus('syncing');
 try {
 const syncData = {
 userId: currentUser.uid,
 drafts: {
  create: createState.input,
  check: checkState.input,
  ask: askState.input,
  prep: prepState.input,
  acquire: acquireState.input
 },
 // V4.7: Sync custom phrases to Firebase
 customPhrases: customBannedPhrases,
 // V4.7: Sync resumes and client contacts to Firebase
 savedResumes: savedResumes,
 clientContacts: clientContacts,
 updatedAt: new Date().toISOString()
 };
 
 // Use setDoc with merge to update or create
 const docRef = doc(db, 'user_drafts', currentUser.uid);
 await setDoc(docRef, syncData, { merge: true });
 
 setLastSyncTime(new Date());
 setSyncStatus('synced');
 showToast('Drafts synced to cloud!');
 } catch (e) {
 devError('Failed to sync drafts:', e);
 setSyncStatus('error');
 showToast('Sync failed', 'error');
 }
 };
 
 // V3.6: Cross-device Draft Sync - Load from Firebase
 const loadDraftsFromCloud = async () => {
 if (!currentUser?.uid || !db) return;
 
 try {
 const docRef = doc(db, 'user_drafts', currentUser.uid);
 const docSnap = await getDoc(docRef);
 
 if (docSnap.exists()) {
 const data = docSnap.data();
 if (data.drafts) {
  if (data.drafts.create) setCreateState(prev => ({ ...prev, input: data.drafts.create }));
  if (data.drafts.check) setCheckState(prev => ({ ...prev, input: data.drafts.check }));
  if (data.drafts.ask) setAskState(prev => ({ ...prev, input: data.drafts.ask }));
  if (data.drafts.prep) setPrepState(prev => ({ ...prev, input: data.drafts.prep }));
  if (data.drafts.acquire) setAcquireState(prev => ({ ...prev, input: data.drafts.acquire }));
  showToast('Drafts loaded from cloud!');
 }
 // V4.7: Load custom phrases from cloud
 if (data.customPhrases && Array.isArray(data.customPhrases)) {
  setCustomBannedPhrases(data.customPhrases);
  localStorage.setItem('gmg_ace_custom_phrases', JSON.stringify(data.customPhrases));
  devLog('V4.7: Custom phrases loaded from cloud:', data.customPhrases.length);
 }
 // V4.7: Load resumes from cloud
 if (data.savedResumes && Array.isArray(data.savedResumes)) {
  setSavedResumes(data.savedResumes);
  localStorage.setItem('gmg_ace_resumes', JSON.stringify(data.savedResumes));
  devLog('V4.7: Resumes loaded from cloud:', data.savedResumes.length);
 }
 // V4.7: Load client contacts from cloud
 if (data.clientContacts && Array.isArray(data.clientContacts)) {
  setClientContacts(data.clientContacts);
  localStorage.setItem('gmg_ace_client_contacts', JSON.stringify(data.clientContacts));
  devLog('V4.7: Client contacts loaded from cloud:', data.clientContacts.length);
 }
 }
 } catch (e) {
 devError('Failed to load drafts from cloud:', e);
 }
 };
 
 // ============================================
 // V2.14.1: UPDATE CHECKER - CORE FEATURE
 // ============================================
 // This is a reusable pattern for ALL apps
 // Requires: /public/version.json on server
 
 const checkForUpdates = async (silent = false) => {
  if (isCheckingUpdate) return;
  
  setIsCheckingUpdate(true);
  if (!silent) triggerHaptic('light');
  
  try {
   // Fetch version manifest with cache-busting
   const response = await fetch('/version.json?' + Date.now(), {
    cache: 'no-store'
   });
   
   if (!response.ok) {
    throw new Error('Version check failed');
   }
   
   const latest = await response.json();
   
   // Compare versions (simple string comparison works for x.y.z format)
   const currentParts = APP_VERSION.split('.').map(Number);
   const latestParts = latest.version.split('.').map(Number);
   
   let isNewer = false;
   for (let i = 0; i < Math.max(currentParts.length, latestParts.length); i++) {
    const current = currentParts[i] || 0;
    const latestNum = latestParts[i] || 0;
    if (latestNum > current) {
     isNewer = true;
     break;
    } else if (latestNum < current) {
     break;
    }
   }
   
   if (isNewer) {
    setUpdateAvailable(latest);
    triggerHaptic('medium');
   } else if (!silent) {
    showToast(`You're on the latest version (${APP_VERSION})`, 'success');
   }
  } catch (error) {
   console.error('Update check error:', error);
   if (!silent) {
    showToast('Could not check for updates', 'error');
   }
  } finally {
   setIsCheckingUpdate(false);
  }
 };
 
 const applyUpdate = () => {
  triggerHaptic('heavy');
  
  // Clear service worker cache if exists
  if ('serviceWorker' in navigator) {
   navigator.serviceWorker.getRegistrations().then(registrations => {
    registrations.forEach(registration => registration.unregister());
   });
  }
  
  // Clear app caches
  if ('caches' in window) {
   caches.keys().then(names => {
    names.forEach(name => caches.delete(name));
   });
  }
  
  // Hard refresh to get new version
  window.location.reload(true);
 };
 
 const dismissUpdate = () => {
  setUpdateAvailable(null);
  // Remember dismissal for this session
  sessionStorage.setItem('update_dismissed_' + updateAvailable?.version, 'true');
 };
 
 // Pull-to-refresh with HOLD for update check
 const handleUpdateHoldStart = () => {
  // Start the hold timer
  setUpdateHoldProgress(0);
  
  const startTime = Date.now();
  updateHoldTimerRef.current = setInterval(() => {
   const elapsed = Date.now() - startTime;
   const progress = Math.min(elapsed / UPDATE_HOLD_DURATION, 1);
   setUpdateHoldProgress(progress);
   
   if (progress >= 1) {
    clearInterval(updateHoldTimerRef.current);
    checkForUpdates();
    setUpdateHoldProgress(0);
   }
  }, 50);
 };
 
 const handleUpdateHoldEnd = () => {
  if (updateHoldTimerRef.current) {
   clearInterval(updateHoldTimerRef.current);
  }
  setUpdateHoldProgress(0);
 };
 
 // Check for updates on mount (silent)
 useEffect(() => {
  // Check after 5 seconds to not block initial load
  const timer = setTimeout(() => {
   const dismissed = sessionStorage.getItem('update_dismissed_' + APP_VERSION);
   if (!dismissed) {
    checkForUpdates(true);
   }
  }, 5000);
  
  return () => clearTimeout(timer);
 }, []);
 
 // V3.6: Swipe gesture handlers for tab navigation
 const handleTouchStart = (e) => {
 touchStartRef.current = { x: e.touches[0].clientX, y: e.touches[0].clientY };
 pullStartRef.current = e.touches[0].clientY;
 };
 
 const handleTouchMove = (e) => {
 touchEndRef.current = { x: e.touches[0].clientX, y: e.touches[0].clientY };
 
 // Pull-to-refresh detection (only when scrolled to top)
 if (chatBodyRef.current && chatBodyRef.current.scrollTop === 0) {
 const pullDistance = e.touches[0].clientY - pullStartRef.current;
 if (pullDistance > 0 && pullDistance < 150) {
  setPullProgress(Math.min(pullDistance / 80, 1));
 }
 }
 };
 
 const handleTouchEnd = () => {
 const deltaX = touchEndRef.current.x - touchStartRef.current.x;
 const deltaY = touchEndRef.current.y - touchStartRef.current.y;
 
 // V2.14: REMOVED swipe-to-change-tab - was causing accidental tab switches
 // Users should use FAB button to switch tabs instead
 
 // Pull-to-refresh trigger
 if (pullProgress >= 1 && !isRefreshing) {
 setIsRefreshing(true);
 triggerHaptic('medium');
 
 // Simulate refresh
 setTimeout(() => {
  setIsRefreshing(false);
  setPullProgress(0);
  showToast('Refreshed!');
 }, 1000);
 } else {
 setPullProgress(0);
 }
 };
 
 // V3.6: Resume Analysis function
 const analyzeResumeForJob = (resumeText, jobDescription) => {
 const analysis = {
 score: 0,
 matchedSkills: [],
 missingSkills: [],
 atsIssues: [],
 suggestions: []
 };
 
 // Common skills to look for
 const skillKeywords = [
 'fundraising', 'grant writing', 'donor relations', 'development',
 'nonprofit', 'capital campaign', 'annual fund', 'major gifts',
 'stewardship', 'cultivation', 'prospect research', 'database',
 'salesforce', 'raiser\'s edge', 'crm', 'excel', 'project management',
 'leadership', 'communication', 'strategic planning', 'budgeting',
 'event planning', 'marketing', 'social media', 'public speaking'
 ];
 
 const jobLower = jobDescription.toLowerCase();
 const resumeLower = resumeText.toLowerCase();
 
 // Check for skill matches
 skillKeywords.forEach(skill => {
 if (jobLower.includes(skill)) {
  if (resumeLower.includes(skill)) {
  analysis.matchedSkills.push(skill);
  } else {
  analysis.missingSkills.push(skill);
  }
 }
 });
 
 // ATS issues check
 if (resumeText.includes('|') || resumeText.includes('•')) {
 analysis.atsIssues.push('Special characters (|, •) may not parse correctly in ATS');
 }
 if (resumeText.length < 500) {
 analysis.atsIssues.push('Resume appears too short for ATS parsing');
 }
 if (!resumeText.match(/\d{3}[-.\s]?\d{3}[-.\s]?\d{4}/)) {
 analysis.atsIssues.push('Phone number format may not be detected');
 }
 if (!resumeText.includes('@')) {
 analysis.atsIssues.push('Email address not detected');
 }
 
 // Calculate score
 const skillsInJob = skillKeywords.filter(s => jobLower.includes(s)).length || 1;
 analysis.score = Math.round((analysis.matchedSkills.length / skillsInJob) * 100);
 
 // Suggestions
 if (analysis.missingSkills.length > 0) {
 analysis.suggestions.push(`Consider adding these skills if applicable: ${analysis.missingSkills.slice(0, 5).join(', ')}`);
 }
 if (analysis.score < 50) {
 analysis.suggestions.push('This resume may need significant customization for this role');
 }
 if (analysis.atsIssues.length > 0) {
 analysis.suggestions.push('Fix ATS issues to improve application success rate');
 }
 
 return analysis;
 };
 
 // V3.6: Batch Document Checking function
 const runBatchCheck = async (documents) => {
 setBatchCheckProgress({ current: 0, total: documents.length, processing: true });
 const results = [];
 
 for (let i = 0; i < documents.length; i++) {
 setBatchCheckProgress({ current: i + 1, total: documents.length, processing: true });
 
 // Run AI check on each document
 const checkResult = runAICheck(documents[i].content, true, customBannedPhrases);
 results.push({
 name: documents[i].name || `Document ${i + 1}`,
 ...checkResult,
 wordCount: documents[i].content.split(/\s+/).length
 });
 
 // Small delay to prevent UI freezing
 await new Promise(r => setTimeout(r, 100));
 }
 
 setBatchCheckProgress({ current: 0, total: 0, processing: false });
 setBatchCheckResults(results);
 return results;
 };
 
 // V3.6: Generate Related Questions based on conversation history
 const generateRelatedQuestions = (question, answer) => {
 const topics = [];
 
 // Extract key topics from the question and answer
 const combinedText = `${question} ${answer}`.toLowerCase();
 
 // Fundraising topics
 if (combinedText.includes('grant') || combinedText.includes('foundation')) {
 topics.push('What are the top foundations funding this area?');
 topics.push('How do I strengthen my grant narrative?');
 }
 if (combinedText.includes('donor') || combinedText.includes('cultivation')) {
 topics.push('What are effective donor cultivation strategies?');
 topics.push('How do I create a moves management plan?');
 }
 if (combinedText.includes('event') || combinedText.includes('gala')) {
 topics.push('What makes a successful fundraising event?');
 topics.push('How should I price event tickets?');
 }
 if (combinedText.includes('board') || combinedText.includes('governance')) {
 topics.push('How do I engage board members in fundraising?');
 topics.push('What is give-or-get and how does it work?');
 }
 if (combinedText.includes('campaign') || combinedText.includes('capital')) {
 topics.push('What are the phases of a capital campaign?');
 topics.push('How do I conduct a feasibility study?');
 }
 if (combinedText.includes('annual') || combinedText.includes('appeal')) {
 topics.push('When should I send annual appeal letters?');
 topics.push('What makes an effective appeal?');
 }
 if (combinedText.includes('stewardship') || combinedText.includes('thank')) {
 topics.push('What are creative ways to thank donors?');
 topics.push('How quickly should I send thank you letters?');
 }
 if (combinedText.includes('prospect') || combinedText.includes('research')) {
 topics.push('How do I identify major gift prospects?');
 topics.push('What wealth indicators should I look for?');
 }
 
 // Generic fallbacks
 if (topics.length === 0) {
 topics.push('How can I improve my fundraising strategy?');
 topics.push('What metrics should I track?');
 topics.push('How do I create a development plan?');
 }
 
 // Return up to 3 unique related questions
 return [...new Set(topics)].slice(0, 3);
 };
 
 // V27: Cover Letter Template Generator
 const generateCoverLetterTemplate = (profile, job) => {
 const orgName = job.organization || '[Organization]';
 const description = (job.description || '').toLowerCase();
 
 // Detect org focus areas for personalization
 const isCivic = /\b(?:civic|democracy|community|bridge|bipartisan|nonpartisan|citizens)\b/i.test(description);
 const isEducation = /\b(?:education|literacy|reading|students|school|learning|tutoring|children)\b/i.test(description);
 const isHealth = /\b(?:health|medical|hospital|wellness|mental health)\b/i.test(description);
 const isYouth = /\b(?:youth|young people|children|teens|students|mentoring)\b/i.test(description);
 
 // Brandon's templates (1800+ chars)
 if (profile.shortName === 'Brandon') {
 const isExecutive = ['executive director', 'president', 'cdo', 'vp', 'chief'].some(
 kw => (job.title || '').toLowerCase().includes(kw)
 );
 
 // Build mission connection based on org focus
 let missionConnect = `The work ${orgName} does matters, and I want to be part of building the infrastructure that makes it sustainable.`;
 if (isCivic) {
 missionConnect = `The bridge-building work ${orgName} does is exactly what our communities need right now. I want to help build the infrastructure that makes this work sustainable for years to come.`;
 } else if (isEducation) {
 missionConnect = `Education is the foundation of everything. The work ${orgName} does for learners changes trajectories, and I want to help ensure you have the resources to reach even more people.`;
 } else if (isHealth) {
 missionConnect = `Health equity is one of the most urgent challenges we face. The work ${orgName} does impacts real families, and I want to help build the funding streams that make this work possible long-term.`;
 }
 
 if (isExecutive) {
 return `Greetings ${orgName} Hiring Team,

Thank you for your time. I want to start by saying that I've been following ${orgName}'s work, and I respect what you're building. ${missionConnect}

My name is Brandon Pierce, and I'm writing because I believe my background makes me uniquely qualified for the ${job.title || 'leadership'} role. I've spent my career understanding philanthropy from multiple angles. At The Coca-Cola Company, I worked as a corporate grantmaker where I reviewed over 13,000 proposals totaling $195M+ in funding decisions. That experience taught me exactly what funders are looking for, what makes proposals succeed or fail, and how organizations can position themselves to win.

Since then, I've been on the fundraising side. I've influenced over $260 million across 65+ organizations serving underresourced communities. I've built development departments from scratch, led capital campaigns, managed grant portfolios, and trained teams on best practices. What makes me different is that dual perspective. I'm not guessing what funders want. I've been the person making those decisions.

In terms of executive leadership, I've managed organizational budgets, led cross-functional teams, worked directly with boards on governance and strategy, and built operational systems that actually work. I believe in a data-driven approach. I build out what I call Data Science Development Plans that show exactly where revenue will come from, what the realistic timelines are, and what metrics we'll use to track progress. No wishful thinking. Just clear strategy backed by industry benchmarks.

My wife Bethany and I are raising four kids: Bailey-J, Joshua, Jeremiah, and Bella-Ann. They're the reason I care so deeply about organizations having the resources to make real impact. I want them growing up in a world where mission-driven work is sustainable.

Thanks for reading. I would genuinely welcome the chance to learn more about the role and share how my experience might contribute to ${orgName}'s next chapter.

Thanks,

Brandon J. Pierce Sr.`;
 } else {
 return `Greetings ${orgName} Hiring Team,

Thank you for your time. I want to start by saying that I've been following ${orgName}'s work, and I respect what you're building. ${missionConnect}

My name is Brandon Pierce, and I'm writing to express my interest in the ${job.title || 'development'} position. I've spent my career understanding philanthropy from both sides of the table, and I think that perspective could be valuable to your team.

Before I became a fundraiser, I worked at The Coca-Cola Company as a corporate grantmaker. Over several years, I reviewed more than 13,000 proposals totaling $195M+ in funding decisions. I learned what separates the organizations that get funded from the ones that don't. It's not always about the mission. Sometimes it's about how the ask is framed, the clarity of the budget, or whether the organization can demonstrate measurable outcomes. That experience shaped how I approach fundraising today.

Since transitioning to the nonprofit side, I've been fortunate to influence over $260 million across 65+ organizations. At HomeFree-USA, I managed a multi-million dollar grant portfolio and built relationships with corporate sponsors that led to sustained multi-year funding. I've written grants, managed donor databases, coordinated events, and trained development staff. I understand that fundraising isn't just about the big wins. It's about the daily work of stewardship, reporting, and relationship maintenance that keeps donors engaged year after year.

I'm particularly interested in ${orgName} because of the approach you take to the work. I've worked with organizations at every stage, from grassroots startups to established institutions, and I've learned that the organizations that succeed are the ones that invest in infrastructure. Not just programs, but the systems that make programs sustainable.

My wife Bethany and I are raising four kids: Bailey-J, Joshua, Jeremiah, and Bella-Ann. They're a big part of why I care about this work. I want them growing up in communities where organizations like ${orgName} have the resources to make real, lasting impact.

Thanks for reading. I'd be honored to have the opportunity to meet the team and learn more about how I could contribute.

Thanks,

Brandon J. Pierce Sr.`;
 }
 }
 
 // Eric's template (1800+ chars)
 if (profile.shortName === 'Eric') {
 // Build mission connection
 let missionConnect = `I'm drawn to ${orgName} because of the approach you take to the work.`;
 if (isCivic) {
 missionConnect = `I'm drawn to ${orgName} because civic engagement is personal to me. I've seen how collaborative approaches can bridge divides that seem impossible to cross.`;
 } else if (isYouth) {
 missionConnect = `I'm drawn to ${orgName} because youth development has been a throughline in my entire career. As a former athlete, I know firsthand how mentorship and opportunity can change a young person's trajectory.`;
 }
 
 return `Dear ${orgName} Hiring Team,

Thank you for your time. ${missionConnect} The work you're doing matters, and I want to be part of helping you build the resources to do even more.

My name is Dr. Eric Lane, and I'm writing to express my interest in the ${job.title || 'development'} position. I bring 17 years of fundraising and nonprofit leadership experience, and I've spent my career building sustainable revenue streams for organizations doing meaningful work.

My background spans higher education, youth development, and community-based organizations. At GID Consulting, I've partnered with clients across the country to raise over $10M through strategic fundraising and grantmaking. But I think the numbers that matter more are the documented wins. I've personally secured over $15M in philanthropic support, including a $5M U.S. Embassy grant for international education, a $3.5M foundation grant for health equity initiatives, and a $1.5M Disney corporate foundation gift for youth programming.

What I think sets me apart is my experience with capital campaigns. I've led or supported six major campaigns totaling over $500M combined, including California State University Fullerton's comprehensive campaign. Capital campaigns require a different skill set than annual fund work. You need to build infrastructure, cultivate major donors over extended timelines, and execute complex multi-year strategies. I've done that work and understand what it takes.

I also bring an academic perspective. I hold a doctorate in Educational Leadership, which has shaped how I think about organizational development and long-term sustainability. I'm not just thinking about this quarter's revenue. I'm thinking about what systems need to be in place for ${orgName} to thrive five or ten years from now.

On a personal note, my wife and I are raising three kids: Eric Jr. who's 7, Parker who's 5, and Evan who's 2. They're a big part of why I care so much about this work. I want them growing up seeing their dad contribute to organizations that make communities stronger.

I'd welcome the opportunity to discuss how my experience might align with what ${orgName} needs. Thanks for considering my application.

Thanks,

Dr. Eric R. Lane Sr.`;
 }
 
 // BJ's template (1800+ chars)
 if (profile.shortName === 'BJ') {
 // Dynamic GID title based on job type
 let mirroredTitle = 'Development Consultant';
 if (job.title) {
 const titleLower = job.title.toLowerCase();
 if (titleLower.includes('grant')) {
 mirroredTitle = 'Institutional Giving Specialist';
 } else if (titleLower.includes('major gift')) {
 mirroredTitle = 'Principal Gifts Consultant';
 } else if (titleLower.includes('annual fund') || titleLower.includes('annual giving')) {
 mirroredTitle = 'Donor Relations Consultant';
 } else if (titleLower.includes('director')) {
 mirroredTitle = 'Senior Development Consultant';
 } else if (titleLower.includes('manager')) {
 mirroredTitle = 'Development Operations Lead';
 } else if (titleLower.includes('coordinator')) {
 mirroredTitle = 'Development Associate';
 } else if (titleLower.includes('officer')) {
 mirroredTitle = 'Development Specialist';
 } else if (titleLower.includes('associate')) {
 mirroredTitle = 'Development Consultant';
 } else if (titleLower.includes('processing') || titleLower.includes('gift')) {
 mirroredTitle = 'Donor Services Specialist';
 } else if (titleLower.includes('data') || titleLower.includes('database')) {
 mirroredTitle = 'Development Data Analyst';
 } else if (titleLower.includes('event')) {
 mirroredTitle = 'Fundraising Events Consultant';
 } else if (titleLower.includes('communications') || titleLower.includes('marketing')) {
 mirroredTitle = 'Donor Communications Specialist';
 }
 }
 
 // Check if faith-based organization
 const isFaithBased = /\b(?:faith|church|ministry|religious|christian|spiritual|pastor|congregation|worship)\b/i.test(description);
 
 // Build mission connection
 let missionConnect = `I've been following ${orgName}'s work, and I'm genuinely excited about the approach you take.`;
 if (isEducation) {
 missionConnect = `As a father of five, education and literacy are personal to me. The work ${orgName} does for learners is exactly the kind of impact I want to support through my professional contributions.`;
 } else if (isCivic) {
 missionConnect = `The bridge-building and community-centered work ${orgName} does resonates with me. I believe in the power of bringing people together across differences.`;
 }
 
 // Build faith paragraph only if faith-based org
 const faithPara = isFaithBased 
 ? `Being raised in a pastor's home gave me a lifelong commitment to service and community impact. I understand the unique dynamics of faith-based fundraising and the importance of aligning donor cultivation with organizational values.`
 : '';
 
 // Build family paragraph based on org type
 let familyPara = `My wife Genesis and I are raising five kids, starting with our oldest, Uriah, followed by Bryan "B3", Brycen, Josiah, and Braylen. They're a big part of why I care about this work. I want them growing up in a world where organizations like ${orgName} have the resources to make real change.`;
 
 if (isEducation) {
 familyPara = `My wife Genesis and I are raising five kids, starting with our oldest daughter Uriah, followed by Bryan "B3", Brycen, Josiah, and Braylen. As a father, I understand how critical early education and literacy support are for children. I want my kids growing up in a world where every child has access to the resources ${orgName} provides.`;
 }
 
 return `Dear ${orgName} Hiring Team,

Thank you for your time. ${missionConnect} Organizations that invest in their mission are rare, and I appreciate the opportunity to share why I believe I could contribute to your work.

My name is Bryan Pierce, and I'm writing to express my interest in the ${job.title || 'development'} position. With nearly 10 years of experience in fundraising, grant writing, and institutional giving, I bring professional expertise and a genuine commitment to mission-driven organizations.

Currently, I serve as a ${mirroredTitle} at GID Consulting, where I support nonprofit clients in raising more than $3 million collectively. My role involves everything from prospect research to donor stewardship, and I take pride in helping organizations build sustainable fundraising infrastructure. The work isn't always glamorous, but I find satisfaction in the systems that keep development departments running smoothly.

Before that, at HomeFree-USA, I managed a grant portfolio that secured over $2.5 million annually while stewarding relationships with 12 corporate sponsors. I learned how to balance the daily demands of grant reporting with the longer-term work of relationship building. I also got comfortable with the CRM management, database maintenance, and gift processing that keeps donor records accurate and audits smooth.

At Brand-ON Consulting, LLC, I supported strategic grant development and donor relations for nonprofit clients, strengthening my skills in prospect research, proposal writing, and relationship management. I also spent five years as an on-air radio host at WNAA 90.1 FM, interviewing nonprofit leaders about community issues and reaching thousands of listeners across the Greater Triad Region. That experience taught me how to tell stories that connect with diverse audiences, which is a skill I bring to donor communications and grant narratives.

My educational foundation includes a Bachelor of Science in Business Administration and recent completion of the Fundraising Leadership Fellowship. ${faithPara}

${familyPara}

Thanks for reading. I'd be honored to have the chance to learn more about the role and share how my experience might be useful to ${orgName}.

Thanks,

Bryan J. Pierce`;
 }
 
 return 'Please select an applicant to generate a cover letter.';
 };

 const handleWelcomeDismiss = () => {
 if (dontShowAgain && typeof localStorage !== 'undefined') {
 localStorage.setItem('gmg_hide_welcome', 'true');
 }
 setShowWelcome(false);
 
 // V3.1: Show sign-in prompt for guests after welcome
 if (!currentUser) {
 setShowSignInPrompt(true);
 }
 };
 
 // V27: Password handler for Client Acquisition tab
 // V27: Get current persona for Client Acquisition tab
 const getAcquirePersona = () => {
 const count = acquireInteractionCount;
 if (count >= 15) {
 // Tier 4: Competition for Affection - both personas compete!
 return 'competition';
 }
 // Alternate between Chanet and Claudette
 return count % 2 === 0 ? 'chanet' : 'claudette';
 };
 
 // V27: Generate persona message for Client Acquisition
 const generatePersonaMessage = (content, persona) => {
 const personaStyles = {
 chanet: {
 name: 'Chanet',
 avatar: IMAGES.chanet,
 style: 'professional and precise'
 },
 claudette: {
 name: 'Claudette', 
 avatar: IMAGES.claudette,
 style: 'warm and encouraging'
 },
 competition: {
 name: 'Both',
 avatar: null,
 style: 'competitive'
 }
 };
 
 return {
 role: 'assistant',
 content: content,
 persona: persona,
 personaInfo: personaStyles[persona]
 };
 };
 
 // V27: Password handler - adds welcome message when unlocked
 const handlePasswordSubmit = () => {
 if (passwordAttempt.toUpperCase() === 'GMG') {
 setAcquireUnlocked(true);
 setPasswordAttempt('');
 
 // Add welcome message asking who they are
 const welcomeMsg = generatePersonaMessage(
 "Welcome to the GMG Client Acquisition Center! I'm here to help you craft perfect job applications.\n\nFirst things first: Who am I helping today? Are you Brandon, Eric, or BJ?",
 'chanet'
 );
 
 setAcquireState(prev => ({
 ...prev,
 messages: [welcomeMsg],
 awaitingApplicant: true
 }));
 
 setAcquireInteractionCount(1);
 } else {
 showToast('Incorrect password. Try again.', 'error');
 setPasswordAttempt('');
 }
 };
 
 // V28: Helper to simulate typing with persona
 // V29: Multi-step roleplay chat animation - shows back-and-forth BEFORE results
 const simulateRoleplayChat = async (finalContent, jobData, coverLetter, spreadsheetData, persona, profile) => {
 // Random roleplay openers
 const roleplayScripts = [
 [
 { speaker: 'claudette', delay: 1000, text: `*sets down tea* Ooh, a new one! Let me analyze this...` },
 { speaker: 'chanet', delay: 1500, text: `*pushes up glasses* I already started. ${jobData.organization || 'This organization'} is looking for a ${jobData.title || 'development role'}.` },
 { speaker: 'claudette', delay: 1200, text: `Show off. But did YOU notice the salary? ${jobData.salary || 'They didn\'t list it'}. Typical.` },
 { speaker: 'chanet', delay: 1000, text: `Focus, Claudette. Here's what I found...` }
 ],
 [
 { speaker: 'claudette', delay: 800, text: `I got this one! *starts reading*` },
 { speaker: 'chanet', delay: 1200, text: `Nope, I found it first. ${jobData.organization || 'The organization'} needs someone for ${jobData.title || 'this role'}.` },
 { speaker: 'claudette', delay: 1400, text: `Ugh, fine. But I'm writing the cover letter. You make everything sound like a spreadsheet.` },
 { speaker: 'chanet', delay: 900, text: `Spreadsheets are ACCURATE. Unlike your "creative" interpretations. Anyway...` }
 ],
 [
 { speaker: 'chanet', delay: 1100, text: `*typing furiously* Already analyzing. ${jobData.organization || 'This org'} posted for ${jobData.title || 'a role'}...` },
 { speaker: 'claudette', delay: 1300, text: `*peeks over shoulder* Location is ${jobData.location || 'not clear'}. I would've spotted that faster.` },
 { speaker: 'chanet', delay: 1000, text: `You would NOT have. You were probably looking at the font choices.` },
 { speaker: 'claudette', delay: 1100, text: `Fonts matter! First impressions! Whatever, just show them what we found...` }
 ]
 ];
 
 const script = roleplayScripts[Math.floor(Math.random() * roleplayScripts.length)];
 
 // Play through the roleplay script
 for (const line of script) {
 // Show typing indicator
 const typingMsg = { 
 role: 'assistant', 
 content: `${line.speaker === 'chanet' ? 'CHANET' : ' CLAUDETTE'} is typing...`,
 isTyping: true,
 persona: line.speaker,
 personaInfo: {
 name: line.speaker === 'chanet' ? 'Chanet' : ' Claudette',
 avatar: line.speaker === 'chanet' ? IMAGES.chanet : IMAGES.claudette
 }
 };
 
 setAcquireState(prev => ({
 ...prev,
 messages: [...prev.messages, typingMsg]
 }));
 
 await new Promise(resolve => setTimeout(resolve, line.delay));
 
 // Replace with actual message
 const actualMsg = {
 role: 'assistant',
 content: `**${line.speaker === 'chanet' ? 'CHANET' : 'CLAUDETTE'}:** ${line.text}`,
 persona: line.speaker,
 personaInfo: {
 name: line.speaker === 'chanet' ? 'Chanet' : ' Claudette',
 avatar: line.speaker === 'chanet' ? IMAGES.chanet : IMAGES.claudette
 }
 };
 
 setAcquireState(prev => ({
 ...prev,
 messages: prev.messages.slice(0, -1).concat(actualMsg)
 }));
 }
 
 // Final delay before showing results
 await new Promise(resolve => setTimeout(resolve, 800));
 
 // Now show the final results message
 const finalMsg = generatePersonaMessage(finalContent, persona);
 
 // V33: Save to application history
 saveApplication({
 organization: jobData.organization,
 title: jobData.title,
 applicant: profile.name,
 salary: jobData.salary,
 location: jobData.location,
 coverLetterLength: coverLetter.length
 });
 
 setAcquireState(prev => ({
 ...prev,
 messages: [...prev.messages, finalMsg],
 currentJob: jobData,
 coverLetter: coverLetter,
 spreadsheetRow: spreadsheetData,
 pendingClassification: null,
 recommendedApplicant: null,
 isProcessing: false
 }));
 };
 
 const simulateTypingResponse = async (responseContent, persona, extraState = {}) => {
 // Get persona name for typing indicator
 const personaName = persona === 'competition' ? 'CHANET & CLAUDETTE' : 
 persona === 'chanet' ? 'CHANET' : ' CLAUDETTE';
 
 // Show typing indicator message
 const typingMsg = { 
 role: 'assistant', 
 content: `${personaName} is typing...`,
 isTyping: true,
 persona: persona
 };
 
 setAcquireState(prev => ({
 ...prev,
 messages: [...prev.messages, typingMsg]
 }));
 
 // Wait 1-2 seconds for realistic typing feel
 await new Promise(resolve => setTimeout(resolve, 1200 + Math.random() * 800));
 
 // Replace typing message with actual response
 const actualMsg = generatePersonaMessage(responseContent, persona);
 
 setAcquireState(prev => ({
 ...prev,
 messages: prev.messages.slice(0, -1).concat(actualMsg),
 isProcessing: false,
 ...extraState
 }));
 };
 
 // V27: Handle chat submission in Client Acquisition
 const handleAcquireSubmit = async () => {
 const input = acquireState.input.trim();
 if (!input || acquireState.isProcessing) return;
 
 // Add user message
 const userMsg = { role: 'user', content: input };
 
 setAcquireState(prev => ({
 ...prev,
 messages: [...prev.messages, userMsg],
 input: '',
 isProcessing: true
 }));
 
 setAcquireInteractionCount(prev => prev + 1);
 
 // Determine persona
 const persona = getAcquirePersona();
 
 // Process the message
 let responseContent = '';
 
 // V4.7: CHECK FOR URL FIRST - before applicant selection
 // This allows users to paste a URL even before selecting an applicant
 const urlMatch = input.match(/https?:\/\/[^\s]+/i);
 const isJobUrl = urlMatch && (
 urlMatch[0].includes('linkedin.com') ||
 urlMatch[0].includes('indeed.com') ||
 urlMatch[0].includes('glassdoor.com') ||
 urlMatch[0].includes('workday') ||
 urlMatch[0].includes('greenhouse.io') ||
 urlMatch[0].includes('lever.co') ||
 urlMatch[0].includes('idealist.org') ||
 urlMatch[0].includes('nonprofitjobs') ||
 urlMatch[0].includes('jobs') ||
 urlMatch[0].includes('careers') ||
 urlMatch[0].includes('apply') ||
 urlMatch[0].includes('posting') ||
 urlMatch[0].includes('hire') ||
 urlMatch[0].includes('nonprofit-job')
 );
 
 // V4.7: If URL detected and no applicant selected, ask who's applying after parsing
 if (isJobUrl && urlMatch) {
 const jobUrl = urlMatch[0];
 
 // Show typing indicator
 setAcquireState(prev => ({
  ...prev,
  messages: [...prev.messages, { role: 'assistant', content: '...', isTyping: true }]
 }));
 
 try {
  // V2.9: Use Jina AI for reliable URL fetching
  await simulateTypingResponse(`Fetching job posting from: ${jobUrl}\n\nGive me a moment to read the full job description...`, persona, {});
  
  const fetchResult = await fetchJobUrlContent(jobUrl);
  
  if (fetchResult.success && fetchResult.content) {
  // Parse the fetched content with AI
  const jobData = await parseJobDescriptionWithAI(fetchResult.content);
  jobData.sourceUrl = jobUrl;
  
  let summary = `**JOB FETCHED SUCCESSFULLY** (via ${fetchResult.source === 'jina' ? 'Jina AI' : 'Claude'})\n\n`;
  summary += `**Organization:** ${jobData.organization || 'Not found'}\n`;
  summary += `**Position:** ${jobData.title || 'Not found'}\n`;
  summary += `**Salary:** ${jobData.salary || 'Not listed'}\n`;
  summary += `**Location:** ${jobData.location || 'Not specified'}\n`;
  summary += `**Source:** [${jobUrl}](${jobUrl})\n`;
  if (jobData.isGoodFit) summary += `\n**Fit Assessment:** ${jobData.isGoodFit} - ${jobData.fitReason || ''}\n`;
  
  // V4.7: If no applicant selected yet, ask
  if (acquireState.awaitingApplicant || !acquireState.selectedApplicant) {
   summary += `\n---\n\nWho's applying for this one? Say **Brandon**, **Eric**, **BJ**, **CJ**, or **GMG Flip** for a firm proposal.`;
  } else {
   const profile = APPLICANT_PROFILES[acquireState.selectedApplicant];
   summary += `\n---\n\nReady to generate materials for ${profile.shortName}. Say **"go"** or **"generate"** to create cover letter, or specify a different applicant.`;
  }
  
  await simulateTypingResponse(summary, persona, {
   currentJob: jobData,
   parsedJob: jobData,
   awaitingApplicant: acquireState.awaitingApplicant // Keep current state
  });
  return;
  } else {
  // Fetch failed - give helpful instructions
  await simulateTypingResponse(`I wasn't able to grab that job posting automatically. ${fetchResult.error || 'Some sites block scraping.'}\n\n**Here's what to do:**\n1. Open the job posting in your browser\n2. Select ALL the text (Cmd+A or Ctrl+A)\n3. Copy it (Cmd+C or Ctrl+C)\n4. Paste it here\n\nI'll work with whatever you paste!`, persona, {});
  return;
  }
 } catch (urlError) {
  devError('URL fetch error:', urlError);
  await simulateTypingResponse(`Error fetching URL: ${urlError.message}. Try pasting the job description instead.`, persona, {});
  return;
 }
 }
 
 // Check if awaiting applicant selection
 if (acquireState.awaitingApplicant) {
 const lowerInput = input.toLowerCase();
 let selectedApplicant = null;
 
 if (lowerInput.includes('brandon') || lowerInput.includes('bp') || lowerInput === 'b') {
 selectedApplicant = 'brandon';
 } else if (lowerInput.includes('eric') || lowerInput.includes('el') || lowerInput === 'e') {
 selectedApplicant = 'eric';
 } else if (lowerInput.includes('bj') || lowerInput.includes('bryan') || lowerInput.includes('junior')) {
 selectedApplicant = 'bj';
 }
 
 if (selectedApplicant) {
 const profile = APPLICANT_PROFILES[selectedApplicant];
 
 if (persona === 'competition') {
 responseContent = `**CHANET:** *adjusts glasses* Got it, ${profile.shortName}! I'll make sure your applications are PERFECT. No em dashes, no AI language, just pure excellence.\n\n**CLAUDETTE:** *rolls eyes* She means WE'LL help you. I'm clearly better at the warm, human touch though.\n\n**CHANET:** Whatever. Just paste the job description and we'll get to work!\n\n**CLAUDETTE:** Yes, paste away darling! I promise my cover letters are better.`;
 } else {
 responseContent = `Perfect! I've got you, ${profile.shortName}. I know your style, your background, and exactly how to make you shine.\n\nNow paste the full job description and I'll:\nAnalyze it and tell you WHO SHOULD APPLY\nGenerate a cover letter in YOUR voice\nCreate an application email if needed\nGive you the spreadsheet row to copy\n\nGo ahead, paste that job description!`;
 }
 
 // Use typing simulation
 await simulateTypingResponse(responseContent, persona, {
 selectedApplicant: selectedApplicant,
 awaitingApplicant: false
 });
 return;
 } else {
 responseContent = "I didn't catch that. Please tell me: are you Brandon, Eric, or BJ?";
 }
 } else {
 // Not awaiting applicant - process as job description or follow-up
 
 // V3.6.1: Check if input is a URL (job posting link)
 const urlMatch = input.match(/https?:\/\/[^\s]+/i);
 const isJobUrl = urlMatch && (
 urlMatch[0].includes('linkedin.com') ||
 urlMatch[0].includes('indeed.com') ||
 urlMatch[0].includes('glassdoor.com') ||
 urlMatch[0].includes('workday') ||
 urlMatch[0].includes('greenhouse.io') ||
 urlMatch[0].includes('lever.co') ||
 urlMatch[0].includes('idealist.org') ||
 urlMatch[0].includes('nonprofitjobs') ||
 urlMatch[0].includes('jobs') ||
 urlMatch[0].includes('careers') ||
 urlMatch[0].includes('apply') ||
 urlMatch[0].includes('posting') ||
 urlMatch[0].includes('hire') ||
 input.toLowerCase().includes('job') ||
 input.toLowerCase().includes('position') ||
 input.toLowerCase().includes('apply')
 );
 
 if (isJobUrl && urlMatch) {
 // V3.6.1: Fetch job posting from URL
 const jobUrl = urlMatch[0];
 
 // Show fetching message
 const fetchingMsg = { role: 'assistant', content: `Fetching job posting from: ${jobUrl}\n\nGive me a moment to read the full job description...` };
 setAcquireState(prev => ({ ...prev, messages: [...prev.messages, fetchingMsg] }));
 setUnifiedMessages(prev => [...prev, { id: Date.now(), type: 'roleplay', speaker: 'claudette', content: fetchingMsg.content }]);
 
 try {
  // Use Claude API with web_fetch to grab FULL page content
  const response = await fetch('https://api.anthropic.com/v1/messages', {
  method: 'POST',
  headers: getApiHeaders(),
  body: JSON.stringify({
   model: MODEL_CONFIG.quality,
   max_tokens: 8000,
   messages: [{
   role: 'user',
   content: `Fetch the COMPLETE content from this job posting URL: ${jobUrl}

IMPORTANT: Use web_fetch to grab the ENTIRE page, not just search snippets.

After fetching the full page, extract and return:

ORGANIZATION: [Company name exactly as shown]
POSITION: [EXACT full job title - do not abbreviate]
LOCATION: [City, State or Remote]
SALARY: [Salary range if listed, or "Not listed"]
DEADLINE: [Application deadline if listed]
ADDRESSEE: [Person to address cover letter to, if mentioned]
APPLICATION_TYPE: [Email, Online Portal, or Direct Apply]
APPLICATION_EMAIL: [Look for ANY email - mailto links, "Send Email" buttons, careers@, jobs@, hr@, apply@ addresses]

DESCRIPTION:
[FULL job description - responsibilities, about the org, everything]

QUALIFICATIONS:
[ALL required and preferred qualifications]

APPLICATION_QUESTIONS:
[Any specific questions the application asks]

HOW_TO_APPLY:
[Complete application instructions]

CRITICAL: Look for email addresses in:
- "Send Email" or "Copy Email" buttons
- mailto: links in the HTML
- Contact information sections
- "How to Apply" sections`
   }],
   tools: [{
   type: 'web_fetch_20250305',
   name: 'web_fetch'
   }]
  })
  });
  
  const data = await response.json();
  const scrapedContent = data.content?.map(c => c.text || '').join('\n') || '';
  
  if (scrapedContent && scrapedContent.length > 100) {
  // Parse the scraped job content
  const jobData = await parseJobDescriptionWithAI(scrapedContent);
  jobData.sourceUrl = jobUrl;
  
  // Check for application questions in the scraped content
  const questionsMatch = scrapedContent.match(/APPLICATION_QUESTIONS:\s*([\s\S]*?)(?=NOTES:|$)/i);
  if (questionsMatch && questionsMatch[1].trim().length > 10) {
   jobData.applicationQuestions = questionsMatch[1].trim();
  }
  
  // Check for application type
  const appTypeMatch = scrapedContent.match(/APPLICATION_TYPE:\s*([^\n]+)/i);
  if (appTypeMatch) {
   jobData.applicationType = appTypeMatch[1].trim();
  }
  
  // Check for application email
  const appEmailMatch = scrapedContent.match(/APPLICATION_EMAIL:\s*([^\n]+)/i);
  if (appEmailMatch && appEmailMatch[1].includes('@')) {
   jobData.applicationEmail = appEmailMatch[1].trim();
  }
  
  // Now process like a normal job description
  const classification = classifyApplicant(jobData);
  const selectedApplicant = acquireState.selectedApplicant;
  const selectedProfile = APPLICANT_PROFILES[selectedApplicant];
  
  // Generate all materials
  let coverLetter;
  const aiResult = await generateCoverLetterWithAI(selectedProfile, jobData);
  if (aiResult.success) {
   coverLetter = aiResult.letter;
  } else {
   coverLetter = generateCoverLetterTemplate(selectedProfile, jobData);
  }
  
  // Build comprehensive response
  let fullResponse = `**Job Posting Retrieved Successfully!**\n\n`;
  fullResponse += `**Organization:** ${jobData.organization || 'Not detected'}\n`;
  fullResponse += `**Position:** ${jobData.title || 'Not detected'}\n`;
  fullResponse += `**Location:** ${jobData.location || 'Not detected'}\n`;
  fullResponse += `**Salary:** ${jobData.salary || 'Not listed'}\n`;
  fullResponse += `**Classification:** ${classification} role\n`;
  fullResponse += `**Source:** [View Original](${jobUrl})\n\n`;
  
  fullResponse += `---\n\n`;
  fullResponse += `**COVER LETTER FOR ${selectedProfile.shortName.toUpperCase()}:**\n\n`;
  fullResponse += coverLetter + '\n\n';
  
  // If email application, generate the email AND create mailto link
  if (jobData.applicationType?.toLowerCase().includes('email') || jobData.applicationEmail) {
   const emailSubject = encodeURIComponent(`Application for ${jobData.title || 'Position'} - ${selectedProfile.name}`);
   const emailBody = encodeURIComponent(`Dear Hiring Team,

Please find attached my application materials for the ${jobData.title || 'open position'} at ${jobData.organization || 'your organization'}.

I am excited about this opportunity and believe my background aligns well with your needs. My cover letter and resume are attached for your review.

I would welcome the opportunity to discuss how I can contribute to your team. Please feel free to contact me at your convenience.

Best regards,
${selectedProfile.name}
${selectedProfile.phone || ''}
${selectedProfile.email}`);
   
   const employerEmail = jobData.applicationEmail || '';
   const employerMailtoLink = employerEmail ? `mailto:${employerEmail}?subject=${emailSubject}&body=${emailBody}` : null;
   
   // Store the mailto link for the UI button
   jobData.employerMailto = employerMailtoLink;
   jobData.employerEmail = employerEmail;
   
   fullResponse += `---\n\n`;
   fullResponse += `**EMAIL APPLICATION DETECTED!**\n`;
   fullResponse += `**To:** ${employerEmail || '[Application Email]'}\n`;
   fullResponse += `**Subject:** Application for ${jobData.title || 'Position'} - ${selectedProfile.name}\n\n`;
   if (employerMailtoLink) {
    fullResponse += `**Click the "Send Application Email" button below to open your email client with everything pre-filled!**\n`;
    fullResponse += `Just attach your resume and cover letter, then hit send.\n\n`;
   }
  }
  
  // If there are application questions, answer them
  if (jobData.applicationQuestions && jobData.applicationQuestions.length > 20) {
   fullResponse += `---\n\n`;
   fullResponse += `**APPLICATION QUESTIONS DETECTED:**\n`;
   fullResponse += `I found the following questions. Let me answer them for you:\n\n`;
   
   // Use AI to answer the questions
   const questionsResponse = await fetch('https://api.anthropic.com/v1/messages', {
   method: 'POST',
   headers: {
    'Content-Type': 'application/json',
    'x-api-key': ANTHROPIC_API_KEY,
    'anthropic-version': '2023-06-01',
    'anthropic-dangerous-direct-browser-access': 'true'
   },
   body: JSON.stringify({
    model: MODEL_CONFIG.quality,
    max_tokens: 2000,
    system: `You are helping ${selectedProfile.fullName} answer job application questions. Use their background: ${selectedProfile.bio}. Write authentic, conversational answers. No AI language, no em dashes.`,
    messages: [{
    role: 'user',
    content: `Answer these application questions for the ${jobData.title} position at ${jobData.organization}:\n\n${jobData.applicationQuestions}`
    }]
   })
   });
   
   const qData = await questionsResponse.json();
   const answers = qData.content?.[0]?.text || 'Unable to generate answers. Please answer manually.';
   fullResponse += answers + '\n\n';
  }
  
  // Add spreadsheet row
  const spreadsheetRow = [
   jobData.organization || '',
   jobData.title || '',
   jobData.salary || '',
   jobData.location || '',
   jobUrl,
   selectedProfile.shortName,
   classification,
   coverLetter.split('\n').slice(0, 3).join(' ').substring(0, 100) + '...'
  ].join('\t');
  
  fullResponse += `---\n\n`;
  fullResponse += `**SPREADSHEET ROW (copy and paste):**\n`;
  fullResponse += '```\n' + spreadsheetRow + '\n```\n\n';
  
  fullResponse += `**What's next?**\n`;
  fullResponse += `- Say "docx" to download the cover letter as a Word document\n`;
  fullResponse += `- Say "pdf" to download as PDF\n`;
  fullResponse += `- Say "email" to create a ready-to-send email with your cover letter\n`;
  fullResponse += `- Ask any follow-up questions about the role or materials`;
  
  // Save the job data and cover letter for follow-ups
  await simulateTypingResponse(fullResponse, persona, {
   currentJob: jobData,
   lastCoverLetter: coverLetter,
   lastSpreadsheetRow: spreadsheetRow
  });
  
  // V2.1: Update session context for follow-up intelligence
  setSessionContext({
   lastAction: 'cover_letter',
   lastApplicant: selectedProfile.shortName,
   lastJob: jobData,
   lastContent: coverLetter,
   lastTab: 'acquire',
   timestamp: Date.now()
  });
  
  // Track the application
  if (currentUser?.uid) {
   await saveApplication(currentUser.uid, {
   ...jobData,
   applicant: selectedProfile.shortName,
   classification
   });
  }
  
  return;
  } else {
  throw new Error('Could not fetch job content');
  }
 } catch (error) {
  devError('Job URL fetch error:', error);
  responseContent = `I had trouble reading that job posting directly. This can happen with some job sites that block automated access.\n\n**Try this instead:**\n1. Open the link: ${jobUrl}\n2. Copy the full job description text\n3. Paste it here and I'll process it\n\nOr tell me more about the job and I can still help create application materials!`;
  
  await simulateTypingResponse(responseContent, persona, {});
  return;
 }
 }
 
 const isJobDescription = input.length > 200 || 
 input.toLowerCase().includes('position') || 
 input.toLowerCase().includes('responsibilities') ||
 input.toLowerCase().includes('qualifications') ||
 input.toLowerCase().includes('salary') ||
 input.toLowerCase().includes('apply');
 
 if (isJobDescription && !acquireState.pendingClassification) {
 // V37: Use Claude API for smart job parsing
 const jobData = await parseJobDescriptionWithAI(input);
 
 const classification = classifyApplicant(jobData);
 const selectedApplicant = acquireState.selectedApplicant;
 const selectedProfile = APPLICANT_PROFILES[selectedApplicant];
 
 // Check for classification mismatch
 const classificationToApplicant = {
 'Eric': 'eric',
 'Brandon': 'brandon', 
 'BJ': 'bj',
 'GMG': 'brandon' // Default to Brandon for GMG classification
 };
 const recommendedApplicant = classificationToApplicant[classification] || 'brandon';
 
 if (recommendedApplicant !== selectedApplicant && classification !== 'GMG') {
 // MISMATCH - offer choice
 const recommendedProfile = APPLICANT_PROFILES[recommendedApplicant];
 
 responseContent = `I analyzed this role and it looks like a better fit for **${recommendedProfile.shortName}** (${classification} classification).\n\n`;
 responseContent += `**Organization:** ${jobData.organization || 'Not detected'}\n`;
 responseContent += `**Position:** ${jobData.title || 'Not detected'}\n`;
 responseContent += `**Salary:** ${jobData.salary || 'Not listed'}\n`;
 responseContent += `**Location:** ${jobData.location || 'Not detected'}\n\n`;
 responseContent += `What would you like to do?\n`;
 responseContent += `Say **"proceed as me"** to generate for you (${selectedProfile.shortName}) anyway\n`;
 responseContent += `Say **"save for ${recommendedProfile.shortName.toLowerCase()}"** to create materials and email them to ${recommendedProfile.shortName}`;
 
 // V32: Use typing simulation
 await simulateTypingResponse(responseContent, persona, {
 currentJob: jobData,
 pendingClassification: classification,
 recommendedApplicant: recommendedApplicant
 });
 return;
 }
 
 // No mismatch - generate normally
 const profile = APPLICANT_PROFILES[selectedApplicant];
 
 // V37.5: Use Claude API for cover letter generation
 let coverLetter;
 const aiResult = await generateCoverLetterWithAI(profile, jobData);
 if (aiResult.success) {
 coverLetter = aiResult.letter;
 } else {
 // Fall back to template if API fails
 coverLetter = generateCoverLetterTemplate(profile, jobData);
 }
 
 // V32: Add typing indicator first
 const typingMsg = { 
 role: 'assistant', 
 content: 'analyzing...',
 isTyping: true,
 persona: persona,
 personaInfo: generatePersonaMessage('', persona).personaInfo
 };
 
 setAcquireState(prev => ({
 ...prev,
 messages: [...prev.messages, typingMsg]
 }));
 
 // Wait for typing animation
 await new Promise(resolve => setTimeout(resolve, 1500));
 
 // Spreadsheet row in table format
 const coverType = ['executive director', 'president', 'cdo', 'vp', 'chief'].some(
 kw => (jobData.title || '').toLowerCase().includes(kw)
 ) ? 'Executive' : 'Standard Development';
 
 const spreadsheetTable = `| Field | Value |
|-------|-------|
| Company and Role | ${jobData.organization || '[Organization]'} - ${jobData.title || '[Job Title]'} |
| Deadline | ${jobData.deadline || 'None'} |
| Direct Link | ${jobData.url || '[URL]'} |
| WHO SHOULD APPLY | ${classification} |
| Compensation | ${jobData.salary || 'Not Listed'} |
| How to Apply | ${jobData.howToApply || '[Application method]'} |
| Potential Issue | ${jobData.issues || 'None noted'} |
| Choose Which Cover? | ${coverType} |`;
 
 // Tab-delimited for copying
 const spreadsheetTSV = [
 `${jobData.organization || '[Organization]'} - ${jobData.title || '[Job Title]'}`,
 jobData.deadline || 'None',
 jobData.url || '[URL]',
 classification,
 jobData.salary || 'Not Listed',
 jobData.howToApply || '[Application method]',
 jobData.issues || 'None noted',
 '', '', '', '',
 coverType
 ].join('\t');
 
 if (persona === 'competition') {
 // V29: Competition mode - longer banter but all in ONE message (no animation)
 responseContent = `**CHANET:** *pushes up glasses* I've got this one. ${jobData.organization || 'This organization'} is clearly a **${classification}** opportunity.\n\n`;
 responseContent += `**CLAUDETTE:** *scoffs* I spotted that too. But did you catch the salary? ${jobData.salary || 'They didn\'t list it'}.\n\n`;
 responseContent += `**CHANET:** Focus. Here's what we found:\n\n---\n\n`;
 responseContent += `**Organization:** ${jobData.organization || 'Not detected'}\n`;
 responseContent += `**Position:** ${jobData.title || 'Not detected'}\n`;
 responseContent += `**Salary:** ${jobData.salary || 'Not listed'}\n`;
 responseContent += `**Location:** ${jobData.location || 'Not detected'}\n`;
 if (jobData.issues && jobData.issues !== 'None noted') {
 responseContent += `**Heads up:** ${jobData.issues}\n`;
 }
 responseContent += `**WHO SHOULD APPLY:** ${classification}\n\n`;
 responseContent += `---\n\n**Cover Letter:**\n\n${coverLetter}\n\n---\n\n`;
 responseContent += `**Character count:** ${coverLetter.length}\n\n`;
 responseContent += `**Spreadsheet Row:**\n\n${spreadsheetTable}\n\n`;
 responseContent += `**CLAUDETTE:** Need an application email? I write those better.\n`;
 responseContent += `**CHANET:** Debatable. But yes, we can help with the email.`;
 } else {
 // Regular persona (Chanet or Claudette alternating)
 const isChanet = acquireInteractionCount % 2 === 0;
 const personaName = isChanet ? 'Chanet' : 'Claudette';
 const emoji = isChanet ? '' : '';
 const flavor = isChanet 
 ? `*reviewing with precision*` 
 : `*sips tea*`;
 
 responseContent = `${emoji} ${flavor}\n\n`;
 responseContent += `**WHO SHOULD APPLY:** ${classification}\n\n`;
 responseContent += `**Organization:** ${jobData.organization || 'Not detected'}\n`;
 responseContent += `**Position:** ${jobData.title || 'Not detected'}\n`;
 responseContent += `**Salary:** ${jobData.salary || 'Not listed'}\n`;
 responseContent += `**Location:** ${jobData.location || 'Not detected'}\n`;
 if (jobData.issues && jobData.issues !== 'None noted') {
 responseContent += `**Heads up:** ${jobData.issues}\n`;
 }
 responseContent += `\nHere's your cover letter:\n\n---\n${coverLetter}\n---\n\n`;
 responseContent += `**Character count:** ${coverLetter.length}\n\n`;
 responseContent += `**Spreadsheet Row:**\n\n${spreadsheetTable}\n\n`;
 responseContent += isChanet 
 ? `Everything checks out. Need an application email? Or adjustments?`
 : `Darling, that cover letter is *chef's kiss*. Need the application email too?`;
 }
 
 // V32: Replace typing indicator with actual response
 // V3.7: Create forward email for any cover letter
 const emailSubject = encodeURIComponent(`Job Application Materials - ${jobData.organization || 'Organization'} - ${jobData.title || 'Position'}`);
 const emailBody = encodeURIComponent(`Cover letter and details for ${jobData.organization || 'Organization'}:\n\n` +
 `Position: ${jobData.title || 'Not specified'}\n` +
 `Organization: ${jobData.organization || 'Not specified'}\n` +
 `Salary: ${jobData.salary || 'Not listed'}\n` +
 `Location: ${jobData.location || 'Not specified'}\n\n` +
 `--- COVER LETTER ---\n\n${coverLetter}\n\n` +
 `--- SPREADSHEET ROW (tab-delimited) ---\n\n${spreadsheetTSV}`);
 const mailtoLink = `mailto:${profile.email}?subject=${emailSubject}&body=${emailBody}`;
 
 setAcquireState(prev => ({
 ...prev,
 currentJob: jobData,
 coverLetter: coverLetter,
 spreadsheetRow: spreadsheetTSV,
 forwardEmail: { to: profile.email, link: mailtoLink, targetName: profile.shortName },
 pendingClassification: null,
 recommendedApplicant: null,
 isProcessing: false,
 messages: prev.messages.slice(0, -1).concat(generatePersonaMessage(responseContent, persona))
 }));
 
 // V3.6: Track application in Firebase
 if (currentUser?.uid) {
 const appId = await saveApplication(currentUser.uid, {
 company: jobData.organization,
 position: jobData.title,
 salary: jobData.salary,
 location: jobData.location,
 url: jobData.url,
 applicant: profile.shortName,
 classification: classification,
 coverLetterLength: coverLetter?.length || 0
 });
 if (appId) {
 // Add to local state
 setApplications(prev => [{
 id: appId,
 company: jobData.organization,
 position: jobData.title,
 status: 'APPLIED',
 appliedDate: new Date().toISOString()
 }, ...prev]);
 }
 }
 return;
 } else {
 // Follow-up question
 const lowerInput = input.toLowerCase();
 
 // Handle "proceed as me"
 if (lowerInput.includes('proceed as me') || lowerInput.includes('proceed anyway') || lowerInput.includes('generate for me')) {
 const profile = APPLICANT_PROFILES[acquireState.selectedApplicant];
 const job = acquireState.currentJob;
 
 // V37.5: Use Claude API for cover letter
 let coverLetter;
 const aiResult = await generateCoverLetterWithAI(profile, job);
 if (aiResult.success) {
 coverLetter = aiResult.letter;
 } else {
 coverLetter = generateCoverLetterTemplate(profile, job);
 }
 
 const coverType = ['executive director', 'president', 'cdo', 'vp', 'chief'].some(
 kw => (job.title || '').toLowerCase().includes(kw)
 ) ? 'Executive' : 'Standard Development';
 
 const spreadsheetTable = `| Field | Value |
|-------|-------|
| Company and Role | ${job.organization || '[Organization]'} - ${job.title || '[Job Title]'} |
| Deadline | ${job.deadline || 'None'} |
| Direct Link | ${job.url || '[URL]'} |
| WHO SHOULD APPLY | ${acquireState.selectedApplicant.charAt(0).toUpperCase() + acquireState.selectedApplicant.slice(1)} |
| Compensation | ${job.salary || 'Not Listed'} |
| How to Apply | ${job.howToApply || '[Application method]'} |
| Potential Issue | ${job.issues || 'None noted'} |
| Choose Which Cover? | ${coverType} |`;
 
 responseContent = `Got it! Here's your cover letter:\n\n---\n${coverLetter}\n---\n\n`;
 responseContent += `**Character count:** ${coverLetter.length}\n\n`;
 responseContent += `**Spreadsheet Row:**\n\n${spreadsheetTable}\n\n`;
 responseContent += `Need an application email?`;
 
 setAcquireState(prev => ({
 ...prev,
 coverLetter: coverLetter,
 pendingClassification: null,
 recommendedApplicant: null,
 isProcessing: false,
 messages: [...prev.messages, userMsg, generatePersonaMessage(responseContent, persona)]
 }));
 return;
 }
 
 // Handle "save for [person]"
 if (lowerInput.includes('save for') || lowerInput.includes('send to')) {
 let targetApplicant = acquireState.recommendedApplicant;
 
 // Override if they specify someone
 if (lowerInput.includes('eric')) targetApplicant = 'eric';
 else if (lowerInput.includes('brandon')) targetApplicant = 'brandon';
 else if (lowerInput.includes('bj') || lowerInput.includes('bryan')) targetApplicant = 'bj';
 
 const targetProfile = APPLICANT_PROFILES[targetApplicant];
 const job = acquireState.currentJob;
 
 // V37.5: Use Claude API for cover letter
 let coverLetter;
 const aiResult = await generateCoverLetterWithAI(targetProfile, job);
 if (aiResult.success) {
 coverLetter = aiResult.letter;
 } else {
 coverLetter = generateCoverLetterTemplate(targetProfile, job);
 }
 
 // Create forward email
 const emailSubject = encodeURIComponent(`New Job you should apply for - ${job.organization || 'Organization'}`);
 const emailBody = encodeURIComponent(`Hey ${targetProfile.shortName}!\n\nFound a job that looks perfect for you:\n\n` +
 `Position: ${job.title || 'Not specified'}\n` +
 `Organization: ${job.organization || 'Not specified'}\n` +
 `Salary: ${job.salary || 'Not listed'}\n` +
 `Location: ${job.location || 'Not specified'}\n\n` +
 `Why I'm sending this to you: This was classified as a ${acquireState.pendingClassification} position.\n\n` +
 `--- COVER LETTER (ready to use) ---\n\n${coverLetter}\n\n` +
 `--- END COVER LETTER ---\n\n` +
 `Let me know if you want me to adjust anything!`);
 
 const mailtoLink = `mailto:${targetProfile.email}?subject=${emailSubject}&body=${emailBody}`;
 
 responseContent = `Perfect! I've created the materials for ${targetProfile.shortName}.\n\n`;
 responseContent += `Here's the cover letter for ${targetProfile.shortName}:\n\n---\n${coverLetter}\n---\n\n`;
 responseContent += `**Character count:** ${coverLetter.length}\n\n`;
 responseContent += `Click the button below to email this to ${targetProfile.shortName}:`;
 
 setAcquireState(prev => ({
 ...prev,
 coverLetter: coverLetter,
 forwardEmail: { to: targetProfile.email, link: mailtoLink, targetName: targetProfile.shortName },
 pendingClassification: null,
 recommendedApplicant: null,
 isProcessing: false,
 messages: [...prev.messages, userMsg, generatePersonaMessage(responseContent, persona)]
 }));
 return;
 }
 
 if (lowerInput.includes('email') || lowerInput.includes('application email')) {
 const profile = APPLICANT_PROFILES[acquireState.selectedApplicant];
 const job = acquireState.currentJob;
 
 const email = `Subject: Application for ${job.title || '[Position]'} - ${profile.name}

Dear ${job.organization || '[Organization]'} team,

Please find attached my application materials for the ${job.title || '[Position]'} position. I've included my cover letter and resume for your review.

I would welcome the chance to discuss how my background aligns with your needs.

Thanks,
${profile.name}
${profile.phone}
${profile.email}`;
 
 responseContent = `Here's your application email:\n\n---\n${email}\n---\n\nJust copy, paste into your email, and attach your documents!`;
 
 setAcquireState(prev => ({
 ...prev,
 applicationEmail: email,
 isProcessing: false,
 messages: [...prev.messages, userMsg, generatePersonaMessage(responseContent, persona)]
 }));
 return;
 
 // V3.6: Thank You Letter (post-interview)
 } else if (lowerInput.includes('thank you') || lowerInput.includes('thanks letter') || lowerInput.includes('follow up after interview')) {
 const profile = APPLICANT_PROFILES[acquireState.selectedApplicant];
 const job = acquireState.currentJob;
 
 const thankYou = `Subject: Thank You - ${job.title || '[Position]'} Interview

Dear [Interviewer Name],

Thank you for taking the time to meet with me today about the ${job.title || '[Position]'} role at ${job.organization || '[Organization]'}. I enjoyed learning more about the team and the work you're doing.

Our conversation reinforced my enthusiasm for this opportunity. I was particularly excited to hear about [specific topic discussed]. My experience with [relevant experience] would allow me to contribute meaningfully from day one.

Please don't hesitate to reach out if you need any additional information. I look forward to hearing about next steps.

Thanks again,
${profile.name}
${profile.phone}
${profile.email}`;
 
 responseContent = `Here's your thank you letter:\n\n---\n${thankYou}\n---\n\n**Tips:**\n- Send within 24 hours of interview\n- Personalize the [bracketed sections]\n- Reference something specific from the conversation`;
 
 setAcquireState(prev => ({
 ...prev,
 isProcessing: false,
 messages: [...prev.messages, userMsg, generatePersonaMessage(responseContent, persona)]
 }));
 return;
 
 // V3.6: LinkedIn Connection Request
 } else if (lowerInput.includes('linkedin connect') || lowerInput.includes('connection request')) {
 const profile = APPLICANT_PROFILES[acquireState.selectedApplicant];
 const job = acquireState.currentJob;
 
 const linkedInConnect = `Hi [Name],

I recently applied for the ${job.title || '[Position]'} role at ${job.organization || '[Organization]'} and wanted to connect. I'm impressed by the work the team is doing in [area].

I'd welcome the chance to learn more about your experience there.

Best,
${profile.shortName}`;
 
 responseContent = `Here's your LinkedIn connection request:\n\n---\n${linkedInConnect}\n---\n\n**Tips:**\n- Keep it under 300 characters\n- Personalize [Name] and [area]\n- Send AFTER applying, not before`;
 
 setAcquireState(prev => ({
 ...prev,
 isProcessing: false,
 messages: [...prev.messages, userMsg, generatePersonaMessage(responseContent, persona)]
 }));
 return;
 
 // V3.6: LinkedIn Follow-up (after connection accepted)
 } else if (lowerInput.includes('linkedin follow') || lowerInput.includes('connected follow')) {
 const profile = APPLICANT_PROFILES[acquireState.selectedApplicant];
 const job = acquireState.currentJob;
 
 const linkedInFollowUp = `Hi [Name],

Thanks for connecting! I submitted my application for the ${job.title || '[Position]'} role and I'm excited about the opportunity.

If you have a few minutes, I'd love to hear your perspective on what makes ${job.organization || '[Organization]'} a great place to work. No pressure either way.

Best,
${profile.shortName}`;
 
 responseContent = `Here's your LinkedIn follow-up message:\n\n---\n${linkedInFollowUp}\n---\n\n**Tips:**\n- Send 1-2 days after they accept\n- Keep it casual and low-pressure\n- Don't ask them to advocate for you directly`;
 
 setAcquireState(prev => ({
 ...prev,
 isProcessing: false,
 messages: [...prev.messages, userMsg, generatePersonaMessage(responseContent, persona)]
 }));
 return;
 
 // V3.6: Salary Negotiation Email
 } else if (lowerInput.includes('salary') || lowerInput.includes('negotiate') || lowerInput.includes('counter offer')) {
 const profile = APPLICANT_PROFILES[acquireState.selectedApplicant];
 const job = acquireState.currentJob;
 
 const salaryNegotiation = `Subject: Re: ${job.title || '[Position]'} Offer - ${profile.name}

Dear [Hiring Manager],

Thank you for extending the offer for the ${job.title || '[Position]'} position. I'm excited about the opportunity to join ${job.organization || '[Organization]'} and contribute to the team.

After reviewing the compensation package, I'd like to discuss the base salary. Based on my experience and the market rate for similar roles, I was hoping for something closer to [target salary]. I'm confident I can deliver significant value in this role and believe this adjustment reflects that.

I'm flexible and open to discussing other components of the package as well. I'm committed to finding a number that works for both of us.

Thanks for your consideration. I look forward to your response.

Best,
${profile.name}
${profile.phone}`;
 
 responseContent = `Here's your salary negotiation email:\n\n---\n${salaryNegotiation}\n---\n\n**Tips:**\n- Always negotiate (they expect it)\n- Ask for 10-20% above their offer\n- Be professional but confident\n- Have a backup number you'd accept`;
 
 setAcquireState(prev => ({
 ...prev,
 isProcessing: false,
 messages: [...prev.messages, userMsg, generatePersonaMessage(responseContent, persona)]
 }));
 return;
 
 // V3.6: Reference Request
 } else if (lowerInput.includes('reference') || lowerInput.includes('ask for reference')) {
 const profile = APPLICANT_PROFILES[acquireState.selectedApplicant];
 const job = acquireState.currentJob;
 
 const referenceRequest = `Subject: Reference Request - ${profile.name}

Hi [Reference Name],

I hope you're doing well! I'm reaching out because I've applied for a ${job.title || '[Position]'} role at ${job.organization || '[Organization]'} and I think it could be a great fit.

Would you be willing to serve as a reference for me? They'd likely want to hear about [specific project/skill you worked on together].

If you're comfortable, I can send you the job description and some talking points about my relevant experience. Just let me know.

Thanks so much,
${profile.shortName}`;
 
 responseContent = `Here's your reference request:\n\n---\n${referenceRequest}\n---\n\n**Tips:**\n- Ask before listing them as a reference\n- Give them context about the role\n- Offer to send talking points\n- Thank them regardless of answer`;
 
 setAcquireState(prev => ({
 ...prev,
 isProcessing: false,
 messages: [...prev.messages, userMsg, generatePersonaMessage(responseContent, persona)]
 }));
 return;
 
 // V3.6: Withdrawal Letter
 } else if (lowerInput.includes('withdraw') || lowerInput.includes('decline offer') || lowerInput.includes('turn down')) {
 const profile = APPLICANT_PROFILES[acquireState.selectedApplicant];
 const job = acquireState.currentJob;
 
 const withdrawal = `Subject: Withdrawal - ${job.title || '[Position]'} Application

Dear [Hiring Manager],

Thank you for your time and consideration throughout the interview process for the ${job.title || '[Position]'} role. After careful consideration, I've decided to withdraw my application.

This was not an easy decision, as I was impressed by ${job.organization || '[Organization]'} and the team. However, I've accepted another opportunity that aligns more closely with my career goals at this time.

I appreciate the courtesy you've shown me and wish you success in filling the position.

Best regards,
${profile.name}`;
 
 responseContent = `Here's your withdrawal letter:\n\n---\n${withdrawal}\n---\n\n**Tips:**\n- Send promptly once you've decided\n- Keep it professional (don't burn bridges)\n- You don't owe them a detailed explanation\n- Thank them for their time`;
 
 setAcquireState(prev => ({
 ...prev,
 isProcessing: false,
 messages: [...prev.messages, userMsg, generatePersonaMessage(responseContent, persona)]
 }));
 return;
 
 } else if (lowerInput.includes('new') || lowerInput.includes('different') || lowerInput.includes('another')) {
 responseContent = "Ready for a new application! Paste the job description and I'll work my magic.";
 
 // V3.6.1: DOCX download command
 } else if (lowerInput === 'docx' || lowerInput.includes('download docx') || lowerInput.includes('word doc')) {
 if (acquireState.lastCoverLetter) {
  handleDownloadDocx(acquireState.lastCoverLetter, 'cover-letter');
  responseContent = "Downloading your cover letter as a Word document (DOCX). Check your downloads folder!";
 } else {
  responseContent = "I don't have a cover letter saved yet. Generate one first by pasting a job description or URL, then say 'docx' to download.";
 }
 
 // V3.6.1: PDF download command
 } else if (lowerInput === 'pdf' || lowerInput.includes('download pdf')) {
 if (acquireState.lastCoverLetter) {
  handleDownloadPDF(acquireState.lastCoverLetter, 'cover-letter');
  responseContent = "Downloading your cover letter as a PDF. Check your downloads folder!";
 } else {
  responseContent = "I don't have a cover letter saved yet. Generate one first by pasting a job description or URL, then say 'pdf' to download.";
 }
 
 // V3.6.1: Both formats
 } else if (lowerInput.includes('both') || lowerInput.includes('docx and pdf') || lowerInput.includes('pdf and docx')) {
 if (acquireState.lastCoverLetter) {
  handleDownloadDocx(acquireState.lastCoverLetter, 'cover-letter');
  setTimeout(() => handleDownloadPDF(acquireState.lastCoverLetter, 'cover-letter'), 500);
  responseContent = "Downloading your cover letter in both DOCX and PDF formats. Check your downloads!";
 } else {
  responseContent = "I don't have a cover letter saved yet. Generate one first, then say 'both' to download in both formats.";
 }
 
 // V5.5: Email draft with cover letter
 } else if (lowerInput === 'email' || lowerInput.includes('create email') || lowerInput.includes('draft email')) {
 if (acquireState.lastCoverLetter && acquireState.currentJob) {
  const job = acquireState.currentJob;
  const profile = acquireState.selectedApplicant ? APPLICANT_PROFILES[acquireState.selectedApplicant] : null;
  const addressee = job.addressee || `${job.organization || 'Hiring'} Team`;
  const subject = `Application: ${job.title || 'Position'} - ${profile?.name || 'Application'}`;
  const emailBody = `Dear ${addressee},\n\nPlease find my application for the ${job.title || 'position'} role.\n\n${acquireState.lastCoverLetter}\n\nThank you for your consideration.\n\n${profile?.name || ''}\n${profile?.email || ''}\n${profile?.phone || ''}`;
  const mailtoLink = `mailto:?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(emailBody)}`;
  window.open(mailtoLink, '_blank');
  responseContent = `Opening your email client with a draft application email. The cover letter is included in the body.\n\nIf you have the hiring contact's email, add "${job.addressee || 'the hiring manager'}" to the To: field.\n\nSubject line: ${subject}`;
 } else {
  responseContent = "I don't have a cover letter saved yet. Generate one first by pasting a job description or URL, then say 'email' to create the draft.";
 }

 } else if (lowerInput.includes('switch') || lowerInput.includes('change')) {
 responseContent = "Want to switch applicants? Just tell me: Brandon, Eric, or BJ?";
 await simulateTypingResponse(responseContent, persona, { awaitingApplicant: true });
 return;
 } else {
 responseContent = "I can help with:\n• Paste a job description OR job URL for full analysis\n• Say 'docx' to download cover letter as Word doc\n• Say 'pdf' to download cover letter as PDF\n• Say 'email' for application email\n• Say 'thank you' for post-interview letter\n• Say 'linkedin connect' for connection request\n• Say 'linkedin follow' for follow-up message\n• Say 'salary' for negotiation email\n• Say 'reference' to request a reference\n• Say 'withdraw' to decline/withdraw\n• Say 'new' for fresh application\n• Say 'switch' to change applicants\n\nWhat do you need?";
 }
 }
 }
 
 // Use typing simulation for final response
 await simulateTypingResponse(responseContent, persona);
 };
 
 // V27: Download styled PDF - V2.1: Updated to use jsPDF
 const handleDownloadPDF = (content, type) => {
 const profile = acquireState.selectedApplicant ? APPLICANT_PROFILES[acquireState.selectedApplicant] : null;
 const job = acquireState.currentJob;
 
 // V2.1: Try jsPDF first, fall back to HTML print method
 try {
  if (typeof jsPDF !== 'undefined') {
  generateCoverLetterPDF(content, profile, job);
  } else {
  // Fallback to HTML-based PDF (opens print dialog)
  generateStyledPDF(content, profile, job);
  }
 } catch (e) {
  console.warn('jsPDF not available, using HTML fallback');
  generateStyledPDF(content, profile, job);
 }
 };
 
 // V3.5: Download real DOCX using docx library
 const handleDownloadDocx = async (content, type) => {
 const profile = acquireState.selectedApplicant ? APPLICANT_PROFILES[acquireState.selectedApplicant] : null;
 const job = acquireState.currentJob;
 
 if (type === 'cover-letter' && profile) {
 try {
 const filename = await generateCoverLetterDocx({
 applicantName: profile.name,
 applicantEmail: profile.email,
 applicantPhone: profile.phone,
 applicantLocation: profile.location,
 companyName: job?.organization || 'Company',
 jobTitle: job?.title || 'Position',
 coverLetterBody: content,
 headerColor: profile.headerColor ? 
 `${profile.headerColor.r.toString(16).padStart(2,'0')}${profile.headerColor.g.toString(16).padStart(2,'0')}${profile.headerColor.b.toString(16).padStart(2,'0')}` : 
 '191970'
 });
 showToast(`Downloaded: ${filename}`, 'success');
 } catch (error) {
 devError('DOCX generation failed:', error);
 showToast('DOCX download failed, trying fallback...', 'error');
 exportAsDocx(content, `CoverLetter_${profile.shortName}_${Date.now()}`);
 }
 } else {
 exportAsDocx(content, `gmg-content-${Date.now()}`);
 }
 };
 
 // Keep these for backward compatibility but they now use the chat system
 const handleProcessJobDescription = () => handleAcquireSubmit();
 const handleGenerateCoverLetter = () => handleAcquireSubmit();
 
 // Get current tab state
 const getCurrentState = () => {
 switch (activeTab) {
 case 'create': return createState;
 case 'check': return checkState;
 case 'ask': return askState;
 case 'acquire': return acquireState;
 case 'prep': return prepState;
 case 'knowledge': return knowledgeState;
 default: return createState;
 }
 };
 
 const setCurrentState = (updater) => {
 switch (activeTab) {
 case 'create':
 setCreateState(prev => typeof updater === 'function' ? updater(prev) : { ...prev, ...updater });
 break;
 case 'check':
 setCheckState(prev => typeof updater === 'function' ? updater(prev) : { ...prev, ...updater });
 break;
 case 'ask':
 setAskState(prev => typeof updater === 'function' ? updater(prev) : { ...prev, ...updater });
 break;
 case 'acquire':
 setAcquireState(prev => typeof updater === 'function' ? updater(prev) : { ...prev, ...updater });
 break;
 case 'prep':
 setPrepState(prev => typeof updater === 'function' ? updater(prev) : { ...prev, ...updater });
 break;
 case 'knowledge':
 setKnowledgeState(prev => typeof updater === 'function' ? updater(prev) : { ...prev, ...updater });
 break;
 }
 };
 
 // ===== FILE HANDLING =====
 
 const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5MB limit
 
 const handleFileUpload = (e) => {
 const files = Array.from(e.target.files);
 const validFiles = [];
 const oversizedFiles = [];
 
 files.forEach(file => {
 if (file.size > MAX_FILE_SIZE) {
 oversizedFiles.push(file.name);
 } else {
 validFiles.push(file);
 }
 });
 
 if (oversizedFiles.length > 0) {
 showToast(`Files too large (max 5MB): ${oversizedFiles.join(', ')}`);
 }
 
 if (validFiles.length > 0 && activeTab === 'create') {
 setCreateState(prev => ({ ...prev, files: [...prev.files, ...validFiles] }));
 showToast(`${validFiles.length} file(s) added`);
 }
 };
 
 const removeFile = (index) => {
 if (activeTab === 'create') {
 setCreateState(prev => ({
 ...prev,
 files: prev.files.filter((_, i) => i !== index)
 }));
 }
 };
 
 // ============================================
 // V38.8: FILE PREVIEW HANDLERS
 // Supports: .md, .html, .txt, .pdf, .docx, .xlsx
 // ============================================
 
 const [filePreview, setFilePreview] = useState({ open: false, content: '', name: '', type: '' });
 
 const previewFile = async (file) => {
 const ext = file.name.split('.').pop().toLowerCase();
 let content = '';
 let previewType = 'text';
 
 try {
 if (ext === 'txt' || ext === 'md') {
 // Plain text and markdown - read directly
 content = await file.text();
 previewType = ext === 'md' ? 'markdown' : 'text';
 } else if (ext === 'html' || ext === 'htm') {
 // HTML - render in iframe
 content = await file.text();
 previewType = 'html';
 } else if (ext === 'pdf') {
 // PDF - show message (browser handles natively)
 previewType = 'pdf';
 content = URL.createObjectURL(file);
 } else if (ext === 'docx') {
 // DOCX - try to extract text using mammoth
 try {
 const arrayBuffer = await file.arrayBuffer();
 if (typeof mammoth !== 'undefined') {
 const result = await mammoth.extractRawText({ arrayBuffer });
 content = result.value || 'Could not extract text from DOCX';
 } else {
 content = '[DOCX preview requires mammoth.js library. File attached but preview not available.]';
 }
 previewType = 'text';
 } catch (docxErr) {
 content = `[Could not preview DOCX: ${docxErr.message}]`;
 previewType = 'text';
 }
 } else if (ext === 'xlsx' || ext === 'xls') {
 // Excel - try to parse using SheetJS
 try {
 const arrayBuffer = await file.arrayBuffer();
 if (typeof XLSX !== 'undefined') {
 const workbook = XLSX.read(arrayBuffer, { type: 'array' });
 const firstSheet = workbook.SheetNames[0];
 const worksheet = workbook.Sheets[firstSheet];
 content = XLSX.utils.sheet_to_csv(worksheet);
 previewType = 'csv';
 } else {
 content = '[Excel preview requires SheetJS library. File attached but preview not available.]';
 }
 } catch (xlsxErr) {
 content = `[Could not preview Excel: ${xlsxErr.message}]`;
 previewType = 'text';
 }
 } else if (ext === 'csv') {
 content = await file.text();
 previewType = 'csv';
 } else if (ext === 'json') {
 const raw = await file.text();
 try {
 content = JSON.stringify(JSON.parse(raw), null, 2);
 } catch {
 content = raw;
 }
 previewType = 'json';
 } else {
 content = `[Preview not available for .${ext} files]`;
 previewType = 'text';
 }
 
 setFilePreview({ open: true, content, name: file.name, type: previewType });
 } catch (err) {
 setFilePreview({ open: true, content: `Error reading file: ${err.message}`, name: file.name, type: 'text' });
 }
 };
 
 const closeFilePreview = () => {
 if (filePreview.type === 'pdf' && filePreview.content.startsWith('blob:')) {
 URL.revokeObjectURL(filePreview.content);
 }
 setFilePreview({ open: false, content: '', name: '', type: '' });
 };
 
 // ===== VOICE FUNCTIONS =====
 
 // V4.7: Track base text before recording starts to prevent duplication
 const voiceBaseTextRef = useRef('');
 
 // V2.12: Voice recording timeout to prevent freezes
 const voiceTimeoutRef = useRef(null);
 
 const startRecording = () => {
 try {
 if (!('webkitSpeechRecognition' in window) && !('SpeechRecognition' in window)) {
 showToast('Speech recognition not supported in this browser');
 return;
 }
 
 // V2.12: Clear any existing timeout
 if (voiceTimeoutRef.current) {
  clearTimeout(voiceTimeoutRef.current);
 }
 
 // V4.7: Store current input as base text
 const currentState = getCurrentState();
 voiceBaseTextRef.current = currentState.input || '';
 
 const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
 recognitionRef.current = new SpeechRecognition();
 recognitionRef.current.continuous = true;
 recognitionRef.current.interimResults = true;
 recognitionRef.current.lang = 'en-US';
 
 // V4.7: Track final vs interim results to prevent duplication
 let finalTranscript = '';
 
 recognitionRef.current.onresult = (event) => {
 try {
 let interimTranscript = '';
 
 // Process results - separate final from interim
 for (let i = event.resultIndex; i < event.results.length; i++) {
  if (event.results[i].isFinal) {
  finalTranscript += event.results[i][0].transcript + ' ';
  } else {
  interimTranscript = event.results[i][0].transcript;
  }
 }
 
 // V4.7: Set input to base + final + current interim (not append)
 const newText = voiceBaseTextRef.current + (voiceBaseTextRef.current ? ' ' : '') + finalTranscript + interimTranscript;
 setCurrentState(prev => ({ ...prev, input: newText.trim() }));
 } catch (err) {
  console.error('Voice result processing error:', err);
 }
 };
 
 recognitionRef.current.onerror = (event) => {
 devError('Speech recognition error:', event.error);
 setIsRecording(false);
 if (voiceTimeoutRef.current) clearTimeout(voiceTimeoutRef.current);
 if (event.error !== 'no-speech' && event.error !== 'aborted') {
  showToast('Voice input error: ' + event.error);
 }
 };
 
 recognitionRef.current.onend = () => {
 setIsRecording(false);
 if (voiceTimeoutRef.current) clearTimeout(voiceTimeoutRef.current);
 };
 
 recognitionRef.current.start();
 setIsRecording(true);
 showToast('Listening... Speak now');
 
 // V2.12: Auto-stop after 60 seconds to prevent infinite hang
 voiceTimeoutRef.current = setTimeout(() => {
  if (recognitionRef.current && isRecording) {
   recognitionRef.current.stop();
   showToast('Voice recording auto-stopped after 60s');
  }
 }, 60000);
 
 } catch (error) {
 console.error('Voice start error:', error);
 setIsRecording(false);
 showToast('Failed to start voice input. Please try again.');
 }
 };
 
 const stopRecording = () => {
 try {
 if (voiceTimeoutRef.current) {
  clearTimeout(voiceTimeoutRef.current);
 }
 if (recognitionRef.current) {
 recognitionRef.current.stop();
 }
 setIsRecording(false);
 showToast('Voice input stopped');
 } catch (error) {
 console.error('Voice stop error:', error);
 setIsRecording(false);
 }
 };
 
 const speakText = (text) => {
 if (!('speechSynthesis' in window)) {
 showToast('Text-to-speech not supported');
 return;
 }
 
 // Stop any current speech
 window.speechSynthesis.cancel();
 
 const utterance = new SpeechSynthesisUtterance(text);
 
 // V4.7: More natural voice settings - closer to conversational speech
 utterance.rate = 0.95; // Slightly slower for natural pacing
 utterance.pitch = 1.0; // Natural pitch
 utterance.volume = 1.0;
 
 // V4.7: Enhanced voice selection - prioritize premium/neural voices
 const voices = window.speechSynthesis.getVoices();
 
 // Priority order for natural sounding voices
 const preferredVoiceNames = [
 // Premium/Neural voices (most natural)
 'Microsoft Jenny Online (Natural)', // Windows 11 Neural
 'Microsoft Aria Online (Natural)', // Windows 11 Neural
 'Google US English', // Chrome
 'Samantha', // macOS (very natural)
 'Alex', // macOS male (natural)
 'Ava', // iOS premium
 // Fallback good voices
 'Microsoft Jenny',
 'Microsoft Zira',
 'Karen', // macOS Australian
 'Daniel', // macOS UK male
 'Moira', // macOS Irish
 'Tessa', // macOS South African
 'Google UK English Female',
 'Google UK English Male'
 ];
 
 let selectedVoice = null;
 
 // Try to find the best voice in priority order
 for (const name of preferredVoiceNames) {
 const found = voices.find(v => v.name.includes(name));
 if (found) {
  selectedVoice = found;
  break;
 }
 }
 
 // Fallback: any English voice
 if (!selectedVoice) {
 selectedVoice = voices.find(v => v.lang.startsWith('en-US')) ||
 voices.find(v => v.lang.startsWith('en'));
 }
 
 if (selectedVoice) {
 utterance.voice = selectedVoice;
 devLog('V4.7: Using voice:', selectedVoice.name);
 }
 
 utterance.onstart = () => setIsSpeaking(true);
 utterance.onend = () => setIsSpeaking(false);
 utterance.onerror = () => setIsSpeaking(false);
 
 synthRef.current = utterance;
 window.speechSynthesis.speak(utterance);
 };
 
 const stopSpeaking = () => {
 window.speechSynthesis.cancel();
 setIsSpeaking(false);
 showToast('Stopped reading');
 };
 
 // ===== ROLEPLAY ANIMATION =====
 
 // Ref to control roleplay animation
 const roleplayIntervalRef = useRef(null);
 const roleplayIndexRef = useRef(0);
 
 const startRoleplay = (type, tabSetter) => {
 // Get the right roleplay based on session count (Easter egg!) - pass type for random scenario selection
 const sequence = getRoleplay(sessionCount, type);
 roleplayIndexRef.current = 0;
 
 // Clear tab-specific messages AND clear chat column for fresh start
 tabSetter(prev => ({ ...prev, messages: [] }));
 setChatMessages([]); // Clear intro when task starts
 
 // Start adding messages on interval with typing animation
 const addMessage = () => {
 if (roleplayIndexRef.current < sequence.length) {
 const msg = sequence[roleplayIndexRef.current];
 
 // First show typing indicator
 const typingMsg = { 
 speaker: msg.speaker, 
 text: '...', 
 isTyping: true 
 };
 setChatMessages(prev => [...prev, typingMsg]);
 
 // After short delay, replace with actual message
 setTimeout(() => {
 setChatMessages(prev => {
 const withoutTyping = prev.slice(0, -1);
 return [...withoutTyping, msg];
 });
 // Also add to tab state
 tabSetter(prev => ({
 ...prev,
 messages: [...prev.messages, msg]
 }));
 }, 800); // 800ms typing animation
 
 roleplayIndexRef.current++;
 } else {
 // Loop back to start if we run out of messages (keeps going until stopped)
 roleplayIndexRef.current = 0;
 // Add a "still working" message with typing
 const workingMsgs = [
 { speaker: 'claudette', text: "Still processing... precision takes time." },
 { speaker: 'chanet', text: "Almost there! Good things are worth waiting for" },
 { speaker: 'claudette', text: "Running final quality checks..." },
 { speaker: 'chanet', text: "Just a moment longer!" }
 ];
 const msg = workingMsgs[Math.floor(Math.random() * workingMsgs.length)];
 
 // Show typing first
 setChatMessages(prev => [...prev, { speaker: msg.speaker, text: '...', isTyping: true }]);
 setTimeout(() => {
 setChatMessages(prev => {
 const withoutTyping = prev.slice(0, -1);
 return [...withoutTyping, msg];
 });
 }, 800);
 }
 };
 
 // Add first message immediately
 setTimeout(addMessage, 500);
 
 // Continue adding messages every 1.5 seconds
 roleplayIntervalRef.current = setInterval(addMessage, 2200); // V26: Slowed from 1500 to 2200
 
 // Increment session count for persona tiers
 setSessionCount(prev => prev + 1);
 };
 
 const stopRoleplay = () => {
 if (roleplayIntervalRef.current) {
 clearInterval(roleplayIntervalRef.current);
 roleplayIntervalRef.current = null;
 }
 // V3.6: Haptic feedback on completion
 triggerHaptic('success');
 };

 // End of Spurt 5a - continued in next file
 // ===== SUBMIT HANDLERS =====
 
 const handleSubmit = async () => {
 const inputText = getCurrentState().input.trim();
 const currentTab = activeTab; // Capture current tab
 
 if (!inputText && (currentTab !== 'create' || createState.files?.length === 0)) {
 showToast('Please enter some text');
 return;
 }
 
 setIsProcessing(true);
 setResponseStartTime(Date.now()); // V5.4: Start response timer
 setLastPromptData({ tab: currentTab, input: inputText }); // V5.4: Store for regeneration
 
 // Get the right setter based on current tab
 const tabSetter = currentTab === 'create' ? setCreateState 
 : currentTab === 'check' ? setCheckState 
 : setAskState;
 
 // Start roleplay animation (runs in background until stopped)
 startRoleplay(currentTab, tabSetter);
 
 try {
 if (currentTab === 'check') {
 // AI Check - local processing with optional fact-checking
 // V3.6: Pass custom banned phrases
 const checkResult = runAICheck(inputText, checkState.factCheckEnabled, customBannedPhrases);
 
 // Generate intelligent issue summary based on what was found
 // AI Check starts at Tier 2 (tierBoost = 15), progresses to Tier 3 at 20 requests
 const aiCheckTierBoost = 15;
 const issueSummary = generateIssueSummary(checkResult.issues, sessionCount, aiCheckTierBoost);
 
 // V2.1: Show tier selector if there are issues to fix
 // V2.7: Show tier selection as chat message instead of modal
 if (checkResult.issues.length > 0) {
 // Store pending content for tier selection
 setPendingContent({
  inputText,
  checkResult,
  issueSummary
 });
 
 // V2.7: Add tier selection as chat message
 const tierSelectionHandler = async (selectedTier) => {
  // Get rewrite with selected tier
  const rewriteResult = await rewriteInBrandonVoice(inputText, checkResult.issues, selectedTier);
  const corrected = rewriteResult?.content || inputText;
  
  // Remove the tier selection message and add the result
  setUnifiedMessages(prev => {
  const filtered = prev.filter(m => m.type !== 'tier-selection');
  return [...filtered, {
   id: Date.now(),
   type: 'check-result',
   content: {
   original: inputText,
   corrected: corrected,
   issueCount: checkResult.issues.length,
   tierUsed: selectedTier,
   issues: checkResult.issues
   }
  }];
  });
  
  setCheckState(prev => ({
  ...prev,
  result: {
   status: checkResult.status,
   issues: checkResult.issues,
   original: inputText,
   corrected: corrected,
   tierUsed: selectedTier
  }
  }));
  
  stopRoleplay();
  setPendingContent(null);
  
  // V25: Add to history
  const newHistory = addHistoryEntry(historyLog, 'check', inputText, corrected);
  setHistoryLog(newHistory);
  saveHistory(newHistory);
  updateAnalytics('check', checkResult.issues.length, checkResult.issues);
 };
 
 // Add tier selection message to chat
 setUnifiedMessages(prev => [...prev, {
  id: Date.now(),
  type: 'tier-selection',
  content: {
  issueCount: checkResult.issues.length,
  onSelect: tierSelectionHandler
  }
 }]);
 
 // Keep roleplay going while user picks tier
 return;
 }
 
 // No issues - just show the pass message
 setCheckState(prev => ({
 ...prev,
 result: {
  status: 'approved',
  issues: [],
  original: inputText,
  corrected: inputText,
  delivery: "Looking good! This passes Brandon's standards.",
  factCheckRan: checkResult.factCheckRan,
  factErrorCount: 0
 },
 trackedChanges: []
 }));
 
 const delivery = getCheckDelivery(0);
 setPopupData({
 ...delivery,
 message: getRandomMessage(delivery.messages),
 summary: issueSummary,
 issueCount: 0,
 type: 'check'
 });
 stopRoleplay();
 setShowPopup(true);
 
 // V25: Add to history
 const newHistory = addHistoryEntry(historyLog, 'check', inputText, inputText);
 setHistoryLog(newHistory);
 saveHistory(newHistory);
 
 // V26: Track analytics
 updateAnalytics('check', 0, []);
 
 } else if (currentTab === 'ask') {
 // V37.6: Ask GMG - try quick local first, then Claude API search
 const quickAnswer = answerGMGQuestion(inputText);
 
 if (quickAnswer) {
 // Quick local answer found (contact info, pricing)
 setAskState(prev => ({
 ...prev,
 result: { content: quickAnswer },
 previousQA: { question: inputText, answer: quickAnswer }
 }));
 const delivery = DELIVERY_MESSAGES.askQuick;
 setPopupData({
 ...delivery,
 message: getRandomMessage(delivery.messages),
 type: 'ask'
 });
 stopRoleplay();
 setShowPopup(true);
 
 const newHistory = addHistoryEntry(historyLog, 'ask', inputText, quickAnswer);
 setHistoryLog(newHistory);
 saveHistory(newHistory);
 updateAnalytics('ask');
 } else {
 // V37.6: Use Claude API to search full knowledge database
 // V3.2: Include live knowledge additions from Firebase
 const aiResponse = await answerGMGQuestionWithAI(inputText, liveKnowledge);
 
 if (aiResponse.success) {
 setAskState(prev => ({
 ...prev,
 result: { content: aiResponse.answer },
 previousQA: { question: inputText, answer: aiResponse.answer }
 }));
 
 // V3.6: Save to conversation history
 const historyEntry = {
 id: Date.now(),
 question: inputText,
 answer: aiResponse.answer,
 timestamp: new Date().toISOString()
 };
 setConversationHistory(prev => {
 const updated = [historyEntry, ...prev].slice(0, 50); // Keep last 50
 try { localStorage.setItem('gmg_ace_conversation_history', JSON.stringify(updated)); } catch (e) { devWarn('localStorage failed:', e); }
 return updated;
 });
 
 // V3.6: Generate related questions
 const related = generateRelatedQuestions(inputText, aiResponse.answer);
 setRelatedQuestions(related);
 
 const isComplex = aiResponse.answer.length > 300;
 const delivery = isComplex ? DELIVERY_MESSAGES.askComplex : DELIVERY_MESSAGES.askQuick;
 setPopupData({
 ...delivery,
 message: getRandomMessage(delivery.messages),
 type: 'ask'
 });
 stopRoleplay();
 setShowPopup(true);
 
 const newHistory = addHistoryEntry(historyLog, 'ask', inputText, aiResponse.answer);
 setHistoryLog(newHistory);
 saveHistory(newHistory);
 updateAnalytics('ask');
 } else {
 // API failed, show error
 setAskState(prev => ({
 ...prev,
 result: { content: 'I encountered an error searching the knowledge database. ' + aiResponse.error }
 }));
 stopRoleplay();
 }
 }
 
 } else {
 // Create - API call
 const client = detectClient(inputText);
 let contextNote = '';
 if (client) {
 contextNote = `Detected client: ${client.name}. Key contacts: ${client.contacts.join(', ')}.\n\n`;
 }
 
 // Process attached files
 let fileContent = '';
 if (createState.files && createState.files.length > 0) {
 for (const file of createState.files) {
 try {
 if (file.type.includes('text') || file.name.endsWith('.txt') || file.name.endsWith('.md')) {
 const text = await file.text();
 fileContent += `\n\n--- ATTACHED FILE: ${file.name} ---\n${text.substring(0, 10000)}\n--- END FILE ---\n`;
 } else if (file.type.includes('pdf')) {
 // V5.2: Fixed PDF extraction with chunked base64 encoding and Sonnet model
 try {
  const MAX_PDF_SIZE = 10 * 1024 * 1024;
  if (file.size > MAX_PDF_SIZE) {
   fileContent += `\n\n[Note: PDF "${file.name}" is too large (${(file.size / 1024 / 1024).toFixed(1)}MB). Maximum is 10MB. Please extract relevant sections manually.]\n`;
  } else {
   const arrayBuffer = await file.arrayBuffer();
   const uint8Array = new Uint8Array(arrayBuffer);
   let base64 = '';
   const chunkSize = 0x8000;
   for (let i = 0; i < uint8Array.length; i += chunkSize) {
    const chunk = uint8Array.subarray(i, i + chunkSize);
    base64 += btoa(String.fromCharCode.apply(null, chunk));
   }
   
   const extractResponse = await fetch('https://api.anthropic.com/v1/messages', {
    method: 'POST',
    headers: getApiHeaders(),
    body: JSON.stringify({
     model: MODEL_CONFIG.quality,
     max_tokens: 8000,
     messages: [{
      role: 'user',
      content: [
       { type: 'document', source: { type: 'base64', media_type: 'application/pdf', data: base64 } },
       { type: 'text', text: 'Extract all text content from this PDF document. Return ONLY the raw text, preserving paragraph structure. No commentary or formatting notes.' }
      ]
     }]
    })
   });
   
   if (!extractResponse.ok) {
    const errorData = await extractResponse.json().catch(() => ({}));
    throw new Error(errorData.error?.message || `API returned ${extractResponse.status}`);
   }
   
   const data = await extractResponse.json();
   const pdfText = data.content?.[0]?.text || "";
   
   if (pdfText.length > 0) {
    fileContent += `\n\n--- PDF FILE: ${file.name} ---\n${pdfText.substring(0, 10000)}\n--- END PDF ---\n`;
   } else {
    fileContent += `\n\n[Note: PDF "${file.name}" appears to be empty or image-only. Please copy and paste the relevant text directly.]\n`;
   }
  }
 } catch (pdfErr) {
  devError('PDF extraction error:', pdfErr);
  fileContent += `\n\n[Note: Could not extract PDF "${file.name}": ${pdfErr.message}. Please copy and paste the relevant text directly.]\n`;
 }
 } else {
 fileContent += `\n\n[File attached: ${file.name} (${file.type}). Content extraction not supported for this file type.]\n`;
 }
 } catch (err) {
 fileContent += `\n\n[Could not read file: ${file.name}]\n`;
 }
 }
 }
 
 const fullPrompt = inputText + fileContent;
 
 const response = await callClaudeAPI(fullPrompt, {
 additionalContext: contextNote
 });
 
 if (response.success) {
 // V26 ENHANCEMENT: Run the SAME checks as AI Check on Create output
 // This ensures Create never delivers content that would fail AI Check
 let finalContent = response.content;
 
 // First apply basic cleanup
 finalContent = cleanCreateOutput(finalContent);
 
 // Then run full AI Check to see if issues remain
 const checkResult = runAICheck(finalContent, false); // false = no fact check for create
 
 // If issues found, do a full rewrite in Brandon's voice
 if (checkResult.issues.length > 0) {
 devLog(`Create output had ${checkResult.issues.length} issues, running rewrite...`);
 const rewriteResult = await rewriteInBrandonVoice(finalContent, checkResult.issues);
 if (rewriteResult?.success && rewriteResult.content) {
 finalContent = rewriteResult.content;
 }
 }
 
 setCreateState(prev => ({
 ...prev,
 result: { content: finalContent }
 }));
 
 // Pick persona based on response complexity (Claudette for long, Chanet for short)
 const isComplex = finalContent.length > 500 || inputText.length > 200;
 const delivery = isComplex ? DELIVERY_MESSAGES.createComplex : DELIVERY_MESSAGES.createQuick;
 setPopupData({
 ...delivery,
 message: getRandomMessage(delivery.messages),
 type: 'create'
 });
 stopRoleplay(); // Stop animation when results ready
 setShowPopup(true);
 
 // V25: Add to history
 const newHistory = addHistoryEntry(historyLog, 'create', inputText, finalContent);
 setHistoryLog(newHistory);
 saveHistory(newHistory);
 
 // V26: Track analytics
 updateAnalytics('create');
 } else {
 setCreateState(prev => ({
 ...prev,
 result: { content: 'Error: ' + response.error + '\n\nTip: If you uploaded a large PDF, try copy-pasting the text directly instead.' }
 }));
 }
 }
 
 // V25: Play completion sound
 playCompletionSound(soundEnabled);
 
 } catch (error) {
 showToast('An error occurred: ' + error.message);
 } finally {
 stopRoleplay(); // Always stop animation
 setIsProcessing(false);
 // V5.4: Calculate response time
 if (responseStartTime) {
  setLastResponseTime(((Date.now() - responseStartTime) / 1000).toFixed(1));
 }
 }
 };
 
 // ===== TRACK CHANGES FUNCTIONS =====
 
 const toggleChange = (id) => {
 setCheckState(prev => ({
 ...prev,
 trackedChanges: prev.trackedChanges.map(c => 
 c.id === id ? { ...c, accepted: !c.accepted } : c
 )
 }));
 };
 
 const acceptAll = () => {
 setCheckState(prev => ({
 ...prev,
 trackedChanges: prev.trackedChanges.map(c => ({ ...c, accepted: true }))
 }));
 showToast('All changes accepted');
 };
 
 const rejectAll = () => {
 setCheckState(prev => ({
 ...prev,
 trackedChanges: prev.trackedChanges.map(c => ({ ...c, accepted: false }))
 }));
 showToast('All changes rejected');
 };
 
 const applyChanges = () => {
 const accepted = checkState.trackedChanges.filter(c => c.accepted);
 const newCorrected = generateCorrectedVersion(checkState.result.original, accepted);
 
 setCheckState(prev => ({
 ...prev,
 result: {
 ...prev.result,
 corrected: newCorrected
 }
 }));
 showToast(`Applied ${accepted.length} change(s)`);
 };
 
 // ===== COPY / SAVE / NEW CHAT / CLEAR =====
 
 const handleCopy = () => {
 const currentState = getCurrentState();
 let textToCopy = '';
 
 if (activeTab === 'check' && currentState.result) {
 textToCopy = currentState.result.corrected;
 } else if (currentState.result) {
 textToCopy = currentState.result.content;
 }
 
 if (textToCopy) {
 navigator.clipboard.writeText(textToCopy);
 showToast('Copied to clipboard');
 }
 };
 
 const handleSave = (content = null, type = null) => {
 // V38.3: Smart download with file type detection
 let saveContent = content;
 let saveType = type;
 
 if (!saveContent) {
 const currentState = getCurrentState();
 if (!currentState || !currentState.result) {
 showToast('Nothing to save yet');
 return;
 }
 saveContent = currentState.result.corrected || currentState.result.content;
 saveType = activeTab;
 }
 
 if (!saveContent) {
 showToast('No content to save');
 return;
 }
 
 // Smart file type detection
 const lower = saveContent.toLowerCase();
 let filename = '';
 let mimeType = 'text/plain';
 
 if (lower.includes('<html') || lower.includes('<!doctype')) {
 filename = `gmg-${saveType}-${Date.now()}.html`;
 mimeType = 'text/html';
 } else if (lower.includes('|') && lower.includes('---') && lower.split('\n').filter(l => l.includes('|')).length > 2) {
 // Markdown table - save as CSV
 const lines = saveContent.split('\n').filter(l => l.includes('|') && !l.includes('---'));
 const csvContent = lines.map(l => l.split('|').filter(c => c.trim()).map(c => '"' + c.trim() + '"').join(',')).join('\n');
 saveContent = csvContent;
 filename = `gmg-${saveType}-${Date.now()}.csv`;
 mimeType = 'text/csv';
 } else if (saveType === 'check') {
 filename = `gmg-checked-content-${Date.now()}.txt`;
 } else if (lower.includes('dear ') || lower.includes('thank you for') || lower.includes('sincerely') || lower.includes('best regards')) {
 // Letter/email format
 filename = `gmg-letter-${Date.now()}.txt`;
 } else if (lower.includes('proposal') || lower.includes('executive summary') || lower.includes('budget')) {
 // Proposal
 filename = `gmg-proposal-${Date.now()}.txt`;
 } else {
 filename = `gmg-${saveType || 'output'}-${Date.now()}.txt`;
 }
 
 const blob = new Blob([saveContent], { type: mimeType });
 const url = URL.createObjectURL(blob);
 const a = document.createElement('a');
 a.href = url;
 a.download = filename;
 a.click();
 URL.revokeObjectURL(url);
 showToast('Saved as ' + filename);
 };
 
 const handleNewChat = () => {
 // Clear current tab state but preserve memory
 switch (activeTab) {
 case 'create':
 setCreateState({ input: '', result: null, files: [], messages: [] });
 break;
 case 'check':
 setCheckState({ input: '', result: null, trackedChanges: [], messages: [], factCheckEnabled: true });
 break;
 case 'ask':
 setAskState({ input: '', result: null, messages: [], followUp: '', previousQA: null });
 break;
 }
 // Reset chat to animate intro again
 setChatMessages([]);
 setChatIntroIndex(0);
 showToast('Started new chat');
 };
 
 const handleClearMemory = () => {
 // Clear all tab states
 setCreateState({ input: '', result: null, files: [], messages: [] });
 setCheckState({ input: '', result: null, trackedChanges: [], messages: [], factCheckEnabled: true });
 setAskState({ input: '', result: null, messages: [], followUp: '', previousQA: null });
 // Reset chat to animate intro again
 setChatMessages([]);
 setChatIntroIndex(0);
 showToast('Memory cleared');
 };
 
 // V5.4: Regenerate last response
 const handleRegenerate = () => {
 if (!lastPromptData) {
  showToast('Nothing to regenerate');
  return;
 }
 // Set the input to the last prompt and submit
 const { tab, input } = lastPromptData;
 if (tab === 'create') setCreateState(prev => ({ ...prev, input }));
 else if (tab === 'check') setCheckState(prev => ({ ...prev, input }));
 else if (tab === 'ask') setAskState(prev => ({ ...prev, input }));
 
 // Trigger submit after state update
 setTimeout(() => handleSubmit(), 100);
 };
 
 // V5.4: Save response feedback to Firebase
 const handleResponseFeedback = async (isPositive, responseContent) => {
 if (!db) return;
 try {
  await addDoc(collection(db, 'response_feedback'), {
  positive: isPositive,
  tab: activeTab,
  responsePreview: (responseContent || '').substring(0, 200),
  userId: currentUser?.uid || 'guest',
  timestamp: new Date().toISOString()
  });
  showToast(isPositive ? 'Thanks for the feedback!' : 'Feedback noted, we\'ll improve');
 } catch (e) {
  devError('Feedback save failed:', e);
 }
 };

 // ===== TEMPLATE CLICK =====
 
 const handleTemplateClick = (template) => {
 // Show the template form popup instead of inserting text directly
 setTemplatePopup({
 show: true,
 templateId: template.id,
 fields: {}
 });
 };
 
 // Handle template form field changes
 const handleTemplateFieldChange = (fieldKey, value) => {
 setTemplatePopup(prev => ({
 ...prev,
 fields: { ...prev.fields, [fieldKey]: value }
 }));
 };
 
 // Handle template form submission
 const handleTemplateSubmit = () => {
 const template = TEMPLATES.find(t => t.id === templatePopup.templateId);
 if (!template) return;
 
 // Validate required fields
 const missingFields = template.fields
 .filter(f => f.required && !templatePopup.fields[f.key])
 .map(f => f.label);
 
 if (missingFields.length > 0) {
 showToast(`Please fill in: ${missingFields.join(', ')}`);
 return;
 }
 
 // Build the prompt from filled fields
 const prompt = template.buildPrompt(templatePopup.fields);
 
 // Set the prompt in the create input
 setCreateState(prev => ({ ...prev, input: prompt }));
 
 // Close the popup
 setTemplatePopup({ show: false, templateId: null, fields: {} });
 
 showToast(`Template ready! Hit Create to generate.`);
 };
 
 // Close template popup
 const closeTemplatePopup = () => {
 setTemplatePopup({ show: false, templateId: null, fields: {} });
 };
 
 // ===== FOLLOW-UP QUESTION (ASK GMG) =====
 
 const handleFollowUp = async () => {
 const followUpText = askState.followUp.trim();
 if (!followUpText) {
 showToast('Please enter a follow-up question');
 return;
 }
 
 setIsProcessing(true);
 
 // V31: Start roleplay chat while processing follow-up
 startRoleplay('ask', setAskState);
 
 // Build context from previous Q&A
 const previousContext = askState.previousQA 
 ? `Previous question: ${askState.previousQA.question}\nPrevious answer: ${askState.previousQA.answer}\n\nFollow-up question: `
 : '';
 
 const response = await callClaudeAPI(previousContext + followUpText, {
 additionalContext: 'This is a follow-up question. Use the context from the previous answer to provide a more detailed response.'
 });
 
 // V31: Stop roleplay when done
 stopRoleplay();
 
 // V31: Add follow-up response to chat
 const followUpChatMsgs = [
 { speaker: 'claudette', text: `Follow-up received. Let me dig deeper...` },
 { speaker: 'chanet', text: `Found more details for you!` }
 ];
 setChatMessages(prev => [...prev, ...followUpChatMsgs]);
 
 setAskState(prev => ({
 ...prev,
 result: response.success 
 ? { content: response.content }
 : { content: 'I apologize, but I encountered an error. ' + response.error },
 followUp: '',
 previousQA: {
 question: followUpText,
 answer: response.success ? response.content : ''
 }
 }));
 
 // Add to chat
 setChatMessages(prev => [
 ...prev,
 { speaker: 'chanet', text: 'Let me dig deeper into that...' },
 { speaker: 'claudette', text: 'Found more information for you.' }
 ]);
 
 setIsProcessing(false);
 };
 
 const handleNewQuestion = () => {
 setAskState(prev => ({
 ...prev,
 input: '',
 result: null,
 followUp: '',
 previousQA: null
 }));
 // Reset chat to intro
 setChatMessages([]);
 setChatIntroIndex(0);
 showToast('Ready for a new topic');
 };
 
 // ===== EXPORT / IMPORT =====
 
 const handleExport = () => {
 try {
 // Create safe export data without File objects (which can't be stringified)
 const exportData = {
 version: 20,
 timestamp: new Date().toISOString(),
 create: {
 input: createState.input,
 result: createState.result,
 messages: createState.messages,
 fileNames: createState.files?.map(f => f.name) || []
 },
 check: {
 input: checkState.input,
 result: checkState.result,
 trackedChanges: checkState.trackedChanges,
 messages: checkState.messages
 },
 ask: {
 input: askState.input,
 result: askState.result,
 messages: askState.messages
 }
 };
 
 const jsonString = JSON.stringify(exportData, null, 2);
 const blob = new Blob([jsonString], { type: 'application/json' });
 const url = URL.createObjectURL(blob);
 const a = document.createElement('a');
 a.href = url;
 a.download = `gmg-assistant-export-${Date.now()}.json`;
 document.body.appendChild(a);
 a.click();
 document.body.removeChild(a);
 URL.revokeObjectURL(url);
 showToast('Data exported');
 } catch (error) {
 showToast('Export failed: ' + error.message);
 }
 };
 
 const handleImport = (e) => {
 const file = e.target.files?.[0];
 if (!file) return;
 
 const reader = new FileReader();
 reader.onload = (event) => {
 try {
 const data = JSON.parse(event.target.result);
 if (data.create) setCreateState(data.create);
 if (data.check) setCheckState(data.check);
 if (data.ask) setAskState(data.ask);
 showToast('Data imported successfully');
 } catch (err) {
 showToast('Import failed: Invalid file');
 }
 };
 reader.readAsText(file);
 };

 // ===== V38.3 UNIFIED CHAT FUNCTIONS =====
 
 const addUnifiedMessage = (type, content, speaker = null) => {
 setUnifiedMessages(prev => [...prev, {
 id: Date.now(),
 type,
 content,
 speaker,
 timestamp: new Date().toLocaleTimeString()
 }]);
 setTimeout(() => {
 if (unifiedChatRef.current) {
 unifiedChatRef.current.scrollTop = unifiedChatRef.current.scrollHeight;
 }
 }, 100);
 };
 
 const clearUnifiedChat = () => setUnifiedMessages([]);
 const addUserMessage = (text) => addUnifiedMessage('user', text);
 const addRoleplayMessage = (speaker, text) => addUnifiedMessage('roleplay', text, speaker);
 const addResultMessage = (content, resultType = 'content') => addUnifiedMessage('result', { content, resultType });
 const addChangesMessage = (changes) => addUnifiedMessage('changes', changes);
 
 const startUnifiedRoleplay = (type) => {
 const scenarios = type === 'create' ? ROLEPLAY_SCENARIOS_TIER1.create 
 : type === 'check' ? ROLEPLAY_SCENARIOS_TIER1.check 
 : ROLEPLAY_SCENARIOS_TIER1.ask;
 const scenario = scenarios[Math.floor(Math.random() * scenarios.length)];
 let msgIndex = 0;
 if (scenario[0]) { addRoleplayMessage(scenario[0].speaker, scenario[0].text); msgIndex = 1; }
 roleplayIntervalRef.current = setInterval(() => {
 if (msgIndex < scenario.length) {
 addRoleplayMessage(scenario[msgIndex].speaker, scenario[msgIndex].text);
 msgIndex++;
 } else {
 const interlude = getEnhancedTierInterlude(sessionCount);
 if (Array.isArray(interlude)) {
 interlude.forEach((item, i) => setTimeout(() => addRoleplayMessage(item.speaker, item.text), i * 1200));
 } else if (interlude) {
 addRoleplayMessage(interlude.speaker, interlude.text);
 }
 msgIndex++;
 }
 }, 2800);
 setSessionCount(prev => prev + 1);
 };
 
 const stopUnifiedRoleplay = () => {
 if (roleplayIntervalRef.current) { clearInterval(roleplayIntervalRef.current); roleplayIntervalRef.current = null; }
 };
 
 const handleUnifiedSubmit = async () => {
 const inputText = getCurrentState().input?.trim();
 if (!inputText) { showToast('Please enter some text'); return; }
 
 addUserMessage(inputText);
 // V5.1: Clear input for current tab
 const tabSetters = {
 create: setCreateState,
 check: setCheckState,
 ask: setAskState,
 prep: setPrepState,
 acquire: setAcquireState,
 knowledge: setKnowledgeState
 };
 const setter = tabSetters[activeTab] || setCreateState;
 setter(prev => ({ ...prev, input: '' }));
 setIsProcessing(true);
 startUnifiedRoleplay(activeTab);
 
 try {
 const startTime = Date.now();
 const MIN_TIME = 4000;
 
 if (activeTab === 'check') {
 try {
 const checkResult = runAICheck(inputText, checkState.factCheckEnabled);
 const issues = checkResult?.issues || [];
 let correctedText = inputText;
 
 // V38.6: Use Claude to REWRITE intelligently, not regex deletion
 // Only em dashes get auto-fixed, everything else goes to Claude
 correctedText = correctedText.replace(/\u2014/g, ', ');
 correctedText = correctedText.replace(/--/g, ', ');
 
 // If there are AI phrase issues, send to Claude for intelligent rewrite
 if (issues.length > 0) {
 try {
 const rewritten = await rewriteInBrandonVoice(correctedText, issues);
 if (rewritten && rewritten.success && rewritten.content) {
 correctedText = rewritten.content;
 }
 } catch (rewriteError) {
 devLog('Rewrite skipped:', rewriteError.message);
 // Keep the em-dash fixed version if rewrite fails
 }
 }
 
 const elapsed = Date.now() - startTime;
 if (elapsed < MIN_TIME) await new Promise(r => setTimeout(r, MIN_TIME - elapsed));
 stopUnifiedRoleplay();
 
 if (issues.length > 0) {
 addChangesMessage(issues);
 }
 addResultMessage(correctedText, 'check');
 setter(prev => ({ 
 ...prev, 
 result: { 
 content: correctedText, 
 original: inputText,
 corrected: correctedText,
 type: 'check',
 status: checkResult?.status || 'approved',
 issues: issues
 } 
 }));
 updateAnalytics('check');
 } catch (checkError) {
 devError('Check error:', checkError);
 stopUnifiedRoleplay();
 addResultMessage('Error running AI check: ' + checkError.message, 'check');
 }
 } else if (activeTab === 'ask') {
 // V4.6: PARALLEL FUSION SEARCH - All sources searched, Claude picks best
 const quickAnswer = answerGMGQuestion(inputText);
 let finalAnswer = '';
 
 if (quickAnswer) {
 // Quick local answer (contact, pricing, who is X GMG person)
 finalAnswer = quickAnswer;
 devLog('Quick answer found');
 } else {
 try {
 // V4.6: Use Parallel Fusion Search for ALL queries
 devLog('V4.6: Using Parallel Fusion Search');
 const fusionResult = await parallelFusionSearch(inputText, liveKnowledge);
 
 if (fusionResult.success && fusionResult.answer) {
  finalAnswer = fusionResult.answer;
  // Log which sources were used
  if (fusionResult.sources && fusionResult.sources.length > 0) {
  devLog('V4.6: Answer synthesized from:', fusionResult.sources.join(', '));
  }
 } else {
  finalAnswer = 'I couldn\'t find a good answer. Try rephrasing your question or being more specific.';
 }
 } catch (searchError) {
 devError('Parallel Fusion Search error:', searchError);
 finalAnswer = 'Search error: ' + searchError.message;
 }
 }
 
 // Ensure content
 if (!finalAnswer || finalAnswer.trim() === '') {
 finalAnswer = 'No answer found. Please try a different question.';
 }
 
 const elapsed = Date.now() - startTime;
 if (elapsed < MIN_TIME) await new Promise(r => setTimeout(r, MIN_TIME - elapsed));
 stopUnifiedRoleplay();
 addResultMessage(finalAnswer, 'search');
 setter(prev => ({ ...prev, result: { content: finalAnswer, type: 'search' } }));
 updateAnalytics('ask');
 } else if (activeTab === 'prep') {
 // V38.9: CLIENT PREP in unified UI
 // Parse input for client name and materials
 // Format: "Client: [name]\n[materials]" or just paste materials with client name mentioned
 let clientName = '';
 let materials = inputText;
 
 // Try to extract client name from input
 if (inputText.toLowerCase().startsWith('client:')) {
 const lines = inputText.split('\n');
 clientName = lines[0].replace(/^client:/i, '').trim();
 materials = lines.slice(1).join('\n').trim();
 } else {
 // Try to find a client name mentioned
 const clientMatch = CLIENT_PROFILES.find(c => 
 inputText.toLowerCase().includes(c.name.toLowerCase().split(' ')[0].toLowerCase())
 );
 if (clientMatch) {
 clientName = clientMatch.name;
 }
 }
 
 if (!clientName) {
 stopUnifiedRoleplay();
 addResultMessage("Please include the client name. You can format as 'Client: [Name]' at the start, or mention a known client name in your text.", 'error');
 } else {
 // Find matching client profile
 const clientProfile = CLIENT_PROFILES.find(c => 
 clientName.toLowerCase().includes(c.name.toLowerCase().split(' ')[0]) ||
 c.name.toLowerCase().includes(clientName.split(' ')[0].toLowerCase())
 );
 
 const aiResult = await generateClientBriefingWithAI(clientName, materials, clientProfile);
 
 const elapsed = Date.now() - startTime;
 if (elapsed < MIN_TIME) await new Promise(r => setTimeout(r, MIN_TIME - elapsed));
 stopUnifiedRoleplay();
 
 if (aiResult.success) {
 addResultMessage(aiResult.briefing, 'content');
 setPrepState(prev => ({ 
 ...prev, 
 briefing: aiResult.briefing,
 history: [...prev.history, { clientName, date: new Date().toISOString(), briefing: aiResult.briefing }]
 }));
 } else {
 addResultMessage('Briefing generation failed: ' + aiResult.error, 'error');
 }
 }
 updateAnalytics('prep');
 } else if (activeTab === 'acquire') {
 // V38.9: JOB APPLICATIONS in unified UI
 // First message should be JD, subsequent messages are commands
 
 // V3.9: Check if this is a URL first
 const urlMatch = inputText.match(/https?:\/\/[^\s]+/i);
 const isJobUrl = urlMatch && (
 urlMatch[0].includes('linkedin.com') ||
 urlMatch[0].includes('indeed.com') ||
 urlMatch[0].includes('glassdoor.com') ||
 urlMatch[0].includes('workday') ||
 urlMatch[0].includes('greenhouse.io') ||
 urlMatch[0].includes('lever.co') ||
 urlMatch[0].includes('idealist.org') ||
 urlMatch[0].includes('nonprofitjobs') ||
 urlMatch[0].includes('jobs') ||
 urlMatch[0].includes('careers') ||
 urlMatch[0].includes('nonprofit-job')
 );
 
 // Detect if this looks like a JD or a command
 const isJD = inputText.length > 500 || 
 inputText.toLowerCase().includes('responsibilities') ||
 inputText.toLowerCase().includes('qualifications') ||
 inputText.toLowerCase().includes('position:') ||
 inputText.toLowerCase().includes('salary') ||
 inputText.toLowerCase().includes('the organization') ||
 inputText.toLowerCase().includes('about us');
 
 if (isJobUrl && urlMatch) {
 // V3.9: Handle URL - fetch job posting
 // V2.2: Using web_fetch to grab FULL page content
 const jobUrl = urlMatch[0];
 addRoleplayMessage('claudette', `Fetching full job posting from: ${jobUrl}`);
 
 try {
  const response = await fetch('https://api.anthropic.com/v1/messages', {
  method: 'POST',
  headers: getApiHeaders(),
  body: JSON.stringify({
   model: MODEL_CONFIG.quality,
   max_tokens: 8000,
   messages: [{
   role: 'user',
   content: `Fetch the COMPLETE content from this job posting URL: ${jobUrl}

IMPORTANT: Use web_fetch to grab the ENTIRE page content.

Return this structured format with EXACT text from the posting:
ORGANIZATION: [Company name exactly as shown]
POSITION: [EXACT full job title - do not abbreviate]
LOCATION: [City, State or Remote]
SALARY: [Salary range like "$67,295 - $71,502" if listed, or "Not listed"]
DEADLINE: [Application deadline if listed]
ADDRESSEE: [Person to address cover letter to]
APPLICATION_EMAIL: [Any email found - mailto links, Send Email buttons, careers@, jobs@, hr@]
HOW_TO_APPLY: [Complete application instructions]

FULL_DESCRIPTION:
[COMPLETE job description - all responsibilities, qualifications, benefits]`
   }],
   tools: [{ type: 'web_fetch_20250305', name: 'web_fetch' }]
  })
  });
  
  const data = await response.json();
  // V4.2: Added null check for data.content
  let scrapedContent = '';
  if (data.content && Array.isArray(data.content)) {
  for (const block of data.content) {
  if (block.type === 'text') scrapedContent += block.text;
  }
  }
  
  if (scrapedContent && scrapedContent.length > 100) {
  // Parse the scraped content
  const jobData = await parseJobDescriptionWithAI(scrapedContent);
  jobData.sourceUrl = jobUrl;
  
  const elapsed = Date.now() - startTime;
  if (elapsed < MIN_TIME) await new Promise(r => setTimeout(r, MIN_TIME - elapsed));
  stopUnifiedRoleplay();
  
  let summary = `**JOB FETCHED FROM URL**\n\n`;
  summary += `**Organization:** ${jobData.organization || 'Not found'}\n`;
  summary += `**Position:** ${jobData.title || 'Not found'}\n`;
  summary += `**Salary:** ${jobData.salary || 'Not listed'}\n`;
  summary += `**Location:** ${jobData.location || 'Not specified'}\n`;
  summary += `**Source:** [${jobUrl}](${jobUrl})\n`;
  if (jobData.isGoodFit) summary += `\n**Fit Assessment:** ${jobData.isGoodFit} - ${jobData.fitReason || ''}\n`;
  
  const loggedInProfile = getProfileFromEmail(currentUser?.email);
  const firstName = getUserFirstName(currentUser);
  summary += `\n---\n\n`;
  if (loggedInProfile) {
   summary += `Hey ${firstName}! Ready to apply as yourself, or would you prefer Eric, BJ, CJ, or a GMG Flip pitch?`;
  } else {
   summary += `Who's applying: Brandon, Eric, BJ, CJ, or GMG Flip?`;
  }
  
  addResultMessage(summary, 'content');
  setAcquireState(prev => ({ ...prev, parsedJob: jobData }));
  } else {
  stopUnifiedRoleplay();
  addResultMessage(`I wasn't able to grab that job posting automatically. Some sites block scraping.\n\n**Here's what to do:**\n1. Open the job posting in your browser\n2. Select ALL the text (Cmd+A or Ctrl+A)\n3. Copy it (Cmd+C or Ctrl+C)\n4. Paste it here\n\nI'll work with whatever you paste!`, 'error');
  }
 } catch (urlError) {
  devError('URL fetch error:', urlError);
  stopUnifiedRoleplay();
  addResultMessage(`Error fetching URL: ${urlError.message}. Try pasting the job description instead.`, 'error');
 }
 } else if (isJD) {
 // Parse the JD
 addRoleplayMessage('claudette', "Parsing job description...");
 const jobData = await parseJobDescriptionWithAI(inputText);
 
 const elapsed = Date.now() - startTime;
 if (elapsed < MIN_TIME) await new Promise(r => setTimeout(r, MIN_TIME - elapsed));
 stopUnifiedRoleplay();
 
 let summary = `**JOB PARSED**\n\n`;
 summary += `**Organization:** ${jobData.organization || 'Not found'}\n`;
 summary += `**Position:** ${jobData.title || 'Not found'}\n`;
 summary += `**Salary:** ${jobData.salary || 'Not listed'}\n`;
 summary += `**Location:** ${jobData.location || 'Not specified'}\n`;
 if (jobData.deadline) summary += `**Deadline:** ${jobData.deadline}\n`;
 if (jobData.howToApply) summary += `**How to Apply:** ${jobData.howToApply}\n`;
 if (jobData.isGoodFit) summary += `\n**Fit Assessment:** ${jobData.isGoodFit} - ${jobData.fitReason || ''}\n`;
    if (jobData.issues) summary += `\n**Issues:** ${jobData.issues}\n`;
 
 // V3.3: Personalized suggestion based on logged-in user
 const loggedInProfile = getProfileFromEmail(currentUser?.email);
 const firstName = getUserFirstName(currentUser);
 
 summary += `\n---\n\n`;
 if (loggedInProfile) {
   summary += `Hey ${firstName}! Ready to apply as yourself, or would you prefer Eric, BJ, CJ, or a GMG Flip pitch?`;
 } else {
   summary += `Who's applying: Brandon, Eric, BJ, CJ, or GMG Flip?`;
 }
 
 addResultMessage(summary, 'content');
 setAcquireState(prev => ({ ...prev, parsedJob: jobData }));
 } else {
 // This is a command - check if we have a parsed job
 const job = acquireState.parsedJob;
 if (!job || !job.title) {
 stopUnifiedRoleplay();
 addResultMessage("Please paste a job description first so I can parse it. Then tell me who's applying.", 'error');
 } else {
 // Determine who's applying
 const lower = inputText.toLowerCase();
 let profile = null;
 let isGMGFlip = false;
 
 // V3.3: Support "me", "myself", "yes" to use logged-in user
 const selfIndicators = ['me', 'myself', 'yes', 'sure', 'go', 'apply', 'do it', 'lets go', "let's go"];
 const isSelfApply = selfIndicators.some(s => lower === s || lower.includes(s));
 
 if (lower.includes('flip') || lower.includes('gmg pitch')) {
 isGMGFlip = true;
 profile = TEAM_PROFILES.find(p => p.shortName === 'Brandon'); // Brandon signs flip emails
 } else if (lower.includes('brandon')) {
 profile = TEAM_PROFILES.find(p => p.shortName === 'Brandon');
 } else if (lower.includes('eric')) {
 profile = TEAM_PROFILES.find(p => p.shortName === 'Eric');
 } else if (lower.includes('bj') || lower.includes('bryan')) {
 profile = TEAM_PROFILES.find(p => p.shortName === 'BJ');
 } else if (lower.includes('cj') || lower.includes('moore')) {
 profile = TEAM_PROFILES.find(p => p.shortName === 'CJ');
 } else if (isSelfApply) {
 // V3.3: Use logged-in user's profile
 profile = getProfileFromEmail(currentUser?.email);
 }
 
 if (!profile) {
 stopUnifiedRoleplay();
 const firstName = getUserFirstName(currentUser);
 addResultMessage(`${firstName}, please specify who's applying: Brandon, Eric, BJ, or say 'GMG Flip' for firm proposal. You can also just say 'me' to apply as yourself.`, 'error');
 } else {
 addRoleplayMessage('chanet', `Generating ${isGMGFlip ? 'GMG Flip email' : 'cover letter'} for ${profile.shortName}...`);
 
 const aiResult = await generateCoverLetterWithAI(profile, job, isGMGFlip);
 
 const elapsed = Date.now() - startTime;
 if (elapsed < MIN_TIME) await new Promise(r => setTimeout(r, MIN_TIME - elapsed));
 stopUnifiedRoleplay();
 
 if (aiResult.success) {
 addResultMessage(aiResult.letter, 'content');
 setAcquireState(prev => ({ 
 ...prev, 
 coverLetter: aiResult.letter,
 selectedProfile: profile
 }));
 } else {
 addResultMessage('Cover letter generation failed: ' + aiResult.error, 'error');
 }
 }
 }
 }
 updateAnalytics('acquire');
 } else if (activeTab === 'create') {
 // V2.12: IMPROVED intent detection - email takes priority over other types
 const lowerInput = inputText.toLowerCase();
 
 // V2.12: Detect EMAIL requests first (highest priority)
 const isEmail = lowerInput.includes('email') || lowerInput.includes('e-mail') ||
 lowerInput.includes('write to ') || lowerInput.includes('message to ') ||
 lowerInput.includes('send ') || lowerInput.includes('reply to ') ||
 lowerInput.includes('follow up with') || lowerInput.includes('update to ');
 
 // V2.12: DSDP detection - specific phrases only
 const isDSDP = (lowerInput.includes('data science') && lowerInput.includes('plan')) || 
 lowerInput.includes('dsdp') || 
 (lowerInput.includes('development plan') && !isEmail) || 
 (lowerInput.includes('revenue projection') && !isEmail);
 
 // V2.12: Pitch deck detection - MUST explicitly say "pitch deck" or "partnership deck"
 // Removed "proposal" from this check - too ambiguous
 const isPitchDeck = (lowerInput.includes('pitch deck') || lowerInput.includes('partnership deck') ||
 lowerInput.includes('slide deck') || lowerInput.includes('presentation deck')) && !isEmail;
 
 let output;
 let resultType = 'create';
 
 if (isDSDP) {
 // Extract client name from input
 const clientMatch = inputText.match(/for\s+([A-Za-z\s]+?)(?:\s*$|\s*\.|\s*,)/i);
 const clientName = clientMatch ? clientMatch[1].trim() : 'Client Organization';
 
 addRoleplayMessage('claudette', `Building Data Science Development Plan for ${clientName}...`);
 addRoleplayMessage('chanet', 'This includes revenue projections, benchmarks, and implementation timeline.');
 
 // V3.6: Progress tracking for long operations
 setOperationProgress({ active: true, percent: 10, message: 'Researching client...', eta: '30-45 sec' });
 
 const dsdpResult = await generateDSDPHTML(clientName, inputText);
 
 setOperationProgress({ active: true, percent: 90, message: 'Finalizing document...', eta: '5 sec' });
 
 if (dsdpResult.success) {
 output = dsdpResult.html;
 resultType = 'html';
 } else {
 throw new Error(dsdpResult.error || 'DSDP generation failed');
 }
 
 setOperationProgress({ active: false, percent: 0, message: '', eta: '' });
 
 } else if (isPitchDeck) {
 // Extract client name from input
 const clientMatch = inputText.match(/for\s+([A-Za-z\s]+?)(?:\s*$|\s*\.|\s*,)/i);
 const clientName = clientMatch ? clientMatch[1].trim() : 'Client Organization';
 
 addRoleplayMessage('claudette', `Creating partnership pitch deck for ${clientName}...`);
 
 // V3.6: Progress tracking
 setOperationProgress({ active: true, percent: 15, message: 'Designing deck...', eta: '20-30 sec' });
 
 const pitchResult = await generatePitchDeckHTML(clientName, inputText);
 
 setOperationProgress({ active: true, percent: 85, message: 'Adding finishing touches...', eta: '5 sec' });
 
 if (pitchResult.success) {
 output = pitchResult.html;
 resultType = 'html';
 } else {
 throw new Error(pitchResult.error || 'Pitch deck generation failed');
 }
 
 setOperationProgress({ active: false, percent: 0, message: '', eta: '' });
 
 } else {
 // Standard text generation
 output = await generateWithClaude(inputText, 'create');
 output = cleanCreateOutput(output);
 }
 
 const elapsed = Date.now() - startTime;
 if (elapsed < MIN_TIME) await new Promise(r => setTimeout(r, MIN_TIME - elapsed));
 stopUnifiedRoleplay();
 
 if (resultType === 'html') {
 // For HTML outputs, show preview option
 addResultMessage('Document generated! Click to preview or download.', 'content');
 setter(prev => ({ ...prev, result: { content: output, type: 'html' } }));
 setShowPitchPreview(true);
 } else {
 addResultMessage(output, 'content');
 setter(prev => ({ ...prev, result: { content: output, type: 'create' } }));
 }
 updateAnalytics('create');
 } else if (activeTab === 'knowledge') {
 // V5.1: KNOWLEDGE TAB - Add to shared knowledge base
 // Format: "Title | Content" or just content (will prompt for title)
 const parts = inputText.split('|').map(s => s.trim());
 let title = '';
 let content = '';
 
 if (parts.length >= 2) {
 title = parts[0];
 content = parts.slice(1).join(' | ');
 } else {
 // Use AI to extract a title
 content = inputText;
 title = inputText.substring(0, 50) + (inputText.length > 50 ? '...' : '');
 }
 
 if (!title || !content) {
 stopUnifiedRoleplay();
 addResultMessage("Please enter knowledge in format: Title | Content", 'error');
 } else {
 try {
  // Save to Firebase shared collection
  await addDoc(collection(db, 'live_knowledge'), {
  title: title,
  content: content,
  category: 'general',
  addedAt: new Date().toISOString(),
  addedBy: currentUser?.uid || 'guest',
  addedByName: currentUser?.displayName || currentUser?.email?.split('@')[0] || 'Guest'
  });
  
  const elapsed = Date.now() - startTime;
  if (elapsed < MIN_TIME) await new Promise(r => setTimeout(r, MIN_TIME - elapsed));
  stopUnifiedRoleplay();
  
  addResultMessage(`Knowledge added!\n\n**${title}**\n${content}\n\nThis is now searchable in Ask GMG and visible to the entire team.`, 'content');
  setKnowledgeState(prev => ({ ...prev, result: { success: true } }));
  showToast('Knowledge added for entire team!');
 } catch (knowledgeError) {
  stopUnifiedRoleplay();
  addResultMessage('Failed to save knowledge: ' + knowledgeError.message, 'error');
 }
 }
 updateAnalytics('knowledge');
 }
 playCompletionSound(soundEnabled);
 } catch (error) {
 stopUnifiedRoleplay();
 addResultMessage('An error occurred: ' + error.message, 'error');
 showToast('An error occurred: ' + error.message);
 } finally {
 setIsProcessing(false);
 }
 };

 // V5.2: Floating Tip Component
 const FloatingTip = () => {
 if (!floatingTip) return null;
 
 const dismissTip = () => {
  setFloatingTip(prev => prev ? { ...prev, exiting: true } : null);
  setTimeout(() => setFloatingTip(null), 300);
 };
 
 const avatar = floatingTip.speaker === 'claudette' ? IMAGES.claudette : IMAGES.chanet;
 
 return (
  <div className={`floating-tip ${floatingTip.speaker} ${floatingTip.exiting ? 'exiting' : ''}`}>
  <img src={avatar} alt={floatingTip.speaker} className="floating-tip-avatar" />
  <p className="floating-tip-text">{floatingTip.text}</p>
  <button className="floating-tip-close" onClick={dismissTip}>x</button>
  </div>
 );
 };

 // End of Spurt 5b - JSX in next file
 // ===== RENDER =====
 
 const currentState = getCurrentState();
 
 return (
 <>
 <style>{styles}</style>
 
 {/* Animated Background */}
 <div className="animated-bg">
 <div className="bg-circle bg-circle-1"></div>
 <div className="bg-circle bg-circle-2"></div>
 <div className="bg-circle bg-circle-3"></div>
 <div className="bg-circle bg-circle-4"></div>
 <div className="bg-circle bg-circle-5"></div>
 </div>
 
 {/* Welcome Overlay */}
 {showWelcome && (
 <div className="welcome-overlay">
 <div className="welcome-card">
 <div className="welcome-header">
 <img src={IMAGES.logo} alt="GMG" className="welcome-logo" />
 <h1 className="welcome-title">GMG ACE Portal</h1>
 <p className="welcome-subtitle">AI Center for Excellence | A Signature Product of Global Majority Group</p>
 </div>
 
 <div className="welcome-chat" ref={welcomeChatRef}>
 {welcomeMessages.map((msg, i) => (
 <div key={i} className="chat-message">
 <img 
 src={msg.speaker === 'chanet' ? IMAGES.chanet : IMAGES.claudette}
 alt={msg.speaker}
 className="chat-avatar"
 />
 <div className="chat-bubble">
 <div className="chat-name">{msg.speaker === 'chanet' ? 'Chanet' : 'Claudette'}</div>
 <div className="chat-text">{msg.text}</div>
 </div>
 </div>
 ))}
 </div>
 
 <div className="welcome-tips">
 <div className="welcome-tips-title">What You Can Do Here</div>
 <ul>
 <li><strong>CREATE</strong> - Generate proposals, emails, reports, and pitch decks following GMG standards</li>
 <li><strong>AI CHECK</strong> - Review content for issues Brandon would flag (em dashes, AI phrases, etc.)</li>
 <li><strong>ASK GMG</strong> - Get answers about clients, pricing, processes, and GMG knowledge</li>
 <li><strong>ACQUIRE</strong> - Process EBC job applications with smart parsing, cover letters, and email forwarding</li>
 <li><strong>CLIENT PREP</strong> - Prepare for client meetings with comprehensive briefings</li>
 </ul>
 </div>
 
 <div className="welcome-footer">
 <label className="welcome-checkbox-label">
 <input 
 type="checkbox"
 checked={dontShowAgain}
 onChange={(e) => setDontShowAgain(e.target.checked)}
 />
 Don't show this again
 </label>
 <button 
 className="welcome-start-btn"
 onClick={handleWelcomeDismiss}
 >
 Start Working
 </button>
 </div>
 </div>
 </div>
 )}
 
 {/* V3.1: Sign-In Prompt Modal for Guests */}
 {showSignInPrompt && !currentUser && (
 <div className="welcome-overlay" style={{ zIndex: 10001 }}>
 <div className="welcome-card" style={{ maxWidth: '500px', padding: '32px' }}>
 <div className="welcome-header">
 <img src={IMAGES.logo} alt="GMG" className="welcome-logo" />
 <h1 className="welcome-title" style={{ fontSize: '24px' }}>Sign In for Full Access</h1>
 </div>
 
 <div style={{ textAlign: 'center', margin: '24px 0' }}>
 <p style={{ fontSize: '16px', color: '#4a5568', marginBottom: '16px' }}>
 You're currently using GMG ACE Portal as a guest.
 </p>
 <p style={{ fontSize: '14px', color: '#666', marginBottom: '24px' }}>
 <strong>Guest Access:</strong> Ask GMG + AI Checker only<br/>
 <strong>Full Access:</strong> Create content, Client Prep, Job Applications, Brainstorming
 </p>
 
 <button 
 onClick={async () => {
 await handleLogin();
 setShowSignInPrompt(false);
 }}
 style={{
 background: '#4285f4',
 color: 'white',
 border: 'none',
 padding: '14px 32px',
 borderRadius: '8px',
 fontSize: '16px',
 fontWeight: '600',
 cursor: 'pointer',
 marginBottom: '16px',
 width: '100%'
 }}
 >
 Sign In with Google
 </button>
 
 <button 
 onClick={() => setShowSignInPrompt(false)}
 style={{
 background: 'transparent',
 color: '#666',
 border: '1px solid #ddd',
 padding: '12px 24px',
 borderRadius: '8px',
 fontSize: '14px',
 cursor: 'pointer',
 width: '100%'
 }}
 >
 Continue as Guest (Limited Features)
 </button>
 </div>
 
 <div style={{ fontSize: '12px', color: '#999', textAlign: 'center', marginTop: '16px' }}>
 GMG team members sign in with your Google account
 </div>
 </div>
 </div>
 )}
 
 {/* Main Container */}
 <div 
 className="main-container"
 onTouchStart={handleTouchStart}
 onTouchMove={handleTouchMove}
 onTouchEnd={handleTouchEnd}
 >
 
 {/* V3.6: Pull-to-refresh indicator - V2.14.1: HOLD for update check */}
 {pullProgress > 0 && (
 <div 
  style={{
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  height: `${Math.min(pullProgress * 80, 80)}px`,
  background: `linear-gradient(180deg, rgba(184, 115, 51, ${pullProgress * 0.3}) 0%, transparent 100%)`,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: 9999,
  transition: 'height 0.1s ease'
  }}
  onTouchStart={pullProgress >= 1 ? handleUpdateHoldStart : undefined}
  onTouchEnd={pullProgress >= 1 ? handleUpdateHoldEnd : undefined}
  onMouseDown={pullProgress >= 1 ? handleUpdateHoldStart : undefined}
  onMouseUp={pullProgress >= 1 ? handleUpdateHoldEnd : undefined}
  onMouseLeave={pullProgress >= 1 ? handleUpdateHoldEnd : undefined}
 >
  {pullProgress >= 1 ? (
  isRefreshing ? (
   <span style={{ color: isDarkMode ? '#D4944A' : '#B87333', fontWeight: '600' }}>Refreshing...</span>
  ) : updateHoldProgress > 0 ? (
   <div style={{ textAlign: 'center' }}>
   <div style={{ 
    width: '40px', 
    height: '40px', 
    borderRadius: '50%', 
    border: '3px solid rgba(184, 115, 51, 0.3)',
    borderTopColor: '#B87333',
    position: 'relative',
    margin: '0 auto 8px'
   }}>
    <div style={{
    position: 'absolute',
    top: '-3px',
    left: '-3px',
    width: '40px',
    height: '40px',
    borderRadius: '50%',
    border: '3px solid transparent',
    borderTopColor: '#B87333',
    transform: `rotate(${updateHoldProgress * 360}deg)`,
    transition: 'transform 0.05s linear'
    }} />
   </div>
   <span style={{ fontSize: '12px', color: isDarkMode ? '#D4944A' : '#B87333', fontWeight: '600' }}>
    Hold to check for updates...
   </span>
   </div>
  ) : (
   <div style={{ textAlign: 'center' }}>
   <span style={{ color: isDarkMode ? '#D4944A' : '#B87333', fontWeight: '600' }}>Release to refresh</span>
   <div style={{ fontSize: '11px', color: isDarkMode ? '#888' : '#666', marginTop: '4px' }}>
    or HOLD 3s for updates
   </div>
   </div>
  )
  ) : (
  <span style={{ color: isDarkMode ? '#888' : '#666', fontSize: '13px' }}>
   Pull to refresh ({Math.round(pullProgress * 100)}%)
  </span>
  )}
 </div>
 )}
 
 {/* Header */}
 <div className="header">
 <div className="header-left">
 <img src={IMAGES.logo} alt="GMG" className="header-logo" />
 <div>
 <div className="header-title">GMG ACE Portal</div>
 <div className="header-subtitle">AI Center for Excellence | Global Majority Group</div>
 </div>
 </div>
 {/* V5.6: Center tab name for mobile */}
 <div className="header-center-tab">
 {activeTab === 'create' && 'Create'}
 {activeTab === 'check' && 'Check'}
 {activeTab === 'ask' && 'Ask'}
 {activeTab === 'acquire' && 'Jobs'}
 {activeTab === 'prep' && 'Prep'}
 {activeTab === 'brainstorm' && 'Brainstorm'}
 {activeTab === 'knowledge' && 'Knowledge'}
 </div>
 <div className="header-buttons">
 {/* V2.13: Admin Portal button for admins */}
 {isAdmin && (
 <button 
 className="header-btn admin-btn"
 onClick={() => setShowAdminPortal(true)}
 title="Admin Portal"
 style={{
  background: 'linear-gradient(135deg, #B87333, #8B5A2B)',
  color: 'white',
  border: 'none',
  padding: '6px 12px',
  borderRadius: '6px',
  fontWeight: '600',
  fontSize: '12px'
 }}
 >
 Admin
 </button>
 )}
 {/* V2.13: Settings Gear - visible on all devices */}
 <button 
 className="settings-gear-btn"
 onClick={() => setShowSettingsDrawer(true)}
 title="Settings"
 style={{ padding: '6px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
 >
 <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
  <circle cx="12" cy="12" r="3"/>
  <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"/>
 </svg>
 </button>
 {/* V3.6: Dark Mode Toggle - V2.9: Sun/Moon icons */}
 <button 
 className="dark-mode-toggle"
 onClick={() => {
  setIsDarkMode(!isDarkMode);
  localStorage.setItem('gmg_ace_dark_mode_manual', 'true');
 }}
 title={isDarkMode ? 'Switch to light mode' : 'Switch to dark mode'}
 style={{ padding: '6px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
 >
 {isDarkMode ? (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
  <circle cx="12" cy="12" r="5"/>
  <line x1="12" y1="1" x2="12" y2="3"/>
  <line x1="12" y1="21" x2="12" y2="23"/>
  <line x1="4.22" y1="4.22" x2="5.64" y2="5.64"/>
  <line x1="18.36" y1="18.36" x2="19.78" y2="19.78"/>
  <line x1="1" y1="12" x2="3" y2="12"/>
  <line x1="21" y1="12" x2="23" y2="12"/>
  <line x1="4.22" y1="19.78" x2="5.64" y2="18.36"/>
  <line x1="18.36" y1="5.64" x2="19.78" y2="4.22"/>
  </svg>
 ) : (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
  <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"/>
  </svg>
 )}
 </button>
 {/* V3.6: Cloud Sync Toggle */}
 {currentUser && (
 <button 
  className="header-btn"
  onClick={() => {
  const newState = !syncEnabled;
  setSyncEnabled(newState);
  localStorage.setItem('gmg_ace_sync_enabled', String(newState));
  if (newState) {
   syncDraftsToCloud();
  }
  showToast(newState ? 'Cloud sync enabled!' : 'Cloud sync disabled');
  }}
  title={syncEnabled ? 'Cloud sync is ON' : 'Cloud sync is OFF'}
  style={{ 
  background: syncEnabled ? 'rgba(40, 167, 69, 0.2)' : 'transparent',
  border: syncEnabled ? '1px solid #28a745' : undefined
  }}
 >
  {syncEnabled ? 'Sync' : 'Cloud'}
 </button>
 )}
 {/* V3.6: Applications Tracker */}
 {canAccessTab(currentUser?.email, 'acquire') && (
 <button 
  className="header-btn"
  onClick={() => setShowApplications(true)}
  style={{ position: 'relative' }}
 >
  Apps {applications.length > 0 && <span style={{ background: '#B87333', color: 'white', borderRadius: '10px', padding: '2px 6px', fontSize: '10px', marginLeft: '4px' }}>{applications.length}</span>}
 </button>
 )}
 {/* V25: Sound toggle */}
 <button 
 className={`sound-toggle ${soundEnabled ? 'active' : ''}`}
 onClick={() => setSoundEnabled(!soundEnabled)}
 title={soundEnabled ? 'Sound on' : 'Sound off'}
 >
 {soundEnabled ? '' : ''}
 </button>
 {/* V25: History button */}
 {/* V5.4: API Status Indicator */}
 <div 
 style={{ 
  display: 'flex', 
  alignItems: 'center', 
  gap: '6px',
  padding: '4px 8px',
  borderRadius: '4px',
  background: isDarkMode ? '#2a2a3e' : '#f0f0f0',
  fontSize: '11px',
  color: isDarkMode ? '#A0A0B0' : '#666'
 }}
 title={lastApiCheck ? `Last checked: ${lastApiCheck}` : 'Checking...'}
 >
 <span style={{
  width: '8px',
  height: '8px',
  borderRadius: '50%',
  background: apiStatus === 'connected' ? '#4CAF50' : apiStatus === 'error' ? '#f44336' : '#ff9800'
 }}></span>
 API
 </div>
 
 {/* V5.4: Keyboard Shortcuts Help */}
 <button 
 className="header-btn" 
 onClick={() => setShowShortcutsModal(true)}
 title="Keyboard Shortcuts (Ctrl+/)"
 style={{ padding: '4px 8px', fontSize: '14px' }}
 >
 ?
 </button>
 
 <button className="history-toggle" onClick={() => setShowHistory(true)}>
 History
 </button>
 {/* V26: Analytics button */}
 <button className="analytics-btn" onClick={() => setShowAnalytics(true)}>
 Stats
 </button>
 {/* V2.11: Admin Portal button - only for admins */}
 {isAdmin && (
 <button 
  className="analytics-btn" 
  onClick={openAdminPortal}
  style={{ background: 'linear-gradient(135deg, #B87333, #D4944A)', color: 'white' }}
 >
  Admin
 </button>
 )}
 <button className="header-btn" onClick={handleNewChat}>New Chat</button>
 <button className="header-btn" onClick={handleClearMemory}>Clear Memory</button>
 <button className="header-btn" onClick={handleExport}>Export</button>
 {/* V2.9: Removed Import button - use + button at bottom instead */}
 {/* V3.0: Login/Logout button */}
 {currentUser ? (
 <div className="user-info" style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
 <span style={{ fontSize: '12px', color: isDarkMode ? '#A0A0B0' : '#666' }}>{currentUser.email?.split('@')[0]} ({userRole})</span>
 <button className="header-btn" onClick={handleLogout}>Logout</button>
 </div>
 ) : (
 <button className="header-btn" onClick={handleLogin} style={{ background: '#4285f4', color: 'white' }}>Sign In</button>
 )}
 </div>
 </div>
 
 {/* V38.3: UNIFIED CHAT UI (for create/check/ask tabs) */}
 {/* V38.9: Unified Chat UI now includes ALL tabs (prep and acquire too) */}
 {/* V6.0: Removed unified-chat-header and unified-tabs - using mobile-tab-bar only */}
 {/* V2.6: UNIFIED CHAT UI - GMG UNIVERSITY PATTERN */}
 {/* Simple: One message array, inline styles, no CSS classes */}
 {useUnifiedUI && (
 <div style={{
  display: 'flex',
  flexDirection: 'column',
  height: 'calc(100vh - var(--mobile-header-height, 44px) - var(--mobile-tab-height, 60px))',
  background: isDarkMode 
   ? 'linear-gradient(180deg, #0f1729 0%, #1a1a2e 100%)' 
   : 'linear-gradient(180deg, #F5F5F7 0%, #E8E8EC 50%, #F0F0F5 100%)',
  position: 'relative'
 }}>
 
 {/* Guest notice - subtle inline text */}
 {!currentUser && (
  <div style={{
  padding: '8px 16px',
  fontSize: '12px',
  color: isDarkMode ? '#888' : '#666',
  borderBottom: `1px solid ${isDarkMode ? '#2a2a3e' : '#E5E5EA'}`,
  background: isDarkMode ? 'rgba(0,0,0,0.2)' : 'rgba(255,255,255,0.5)'
  }}>
  Guest mode - <button onClick={handleLogin} style={{ background: 'none', border: 'none', color: '#8B5CF6', fontWeight: '600', cursor: 'pointer', padding: 0, fontSize: '12px' }}>Sign in</button> for all features
  </div>
 )}
 
 {/* Messages Area - THE HEART OF IT */}
 <div 
  ref={unifiedChatRef}
  style={{ 
  flex: 1, 
  overflow: 'auto', 
  padding: '16px', 
  display: 'flex', 
  flexDirection: 'column', 
  gap: '12px',
  WebkitOverflowScrolling: 'touch'
  }}
 >
  {/* V2.9: Dynamic roleplay intro - types one message at a time */}
  {unifiedMessages.length === 0 && introMessages.map((msg, idx) => (
  <div key={idx}>
   {msg.speaker === 'claudette' && (
   <div style={{ display: 'flex', gap: '10px', flexDirection: 'row' }}>
    <img src={IMAGES.claudette} alt="Claudette" style={{ width: '32px', height: '32px', borderRadius: '50%', flexShrink: 0 }} />
    <div style={{ maxWidth: '80%' }}>
    <p style={{ fontSize: '11px', fontWeight: '600', marginBottom: '4px', color: COLORS.navy, margin: 0 }}>CLAUDETTE</p>
    <div style={{ 
     padding: '12px 16px', 
     borderRadius: '18px 18px 18px 4px', 
     fontSize: '14px', 
     background: isDarkMode ? '#2a2a3e' : '#E5E5EA', 
     color: isDarkMode ? '#fff' : '#1d1d1f',
     lineHeight: '1.4'
    }}>
     {msg.isTyping ? (
     <span className="typing-dots" style={{ display: 'flex', gap: '4px' }}>
      <span style={{ width: '8px', height: '8px', borderRadius: '50%', background: '#888', animation: 'pulse 1.4s infinite ease-in-out', animationDelay: '0s' }}></span>
      <span style={{ width: '8px', height: '8px', borderRadius: '50%', background: '#888', animation: 'pulse 1.4s infinite ease-in-out', animationDelay: '0.2s' }}></span>
      <span style={{ width: '8px', height: '8px', borderRadius: '50%', background: '#888', animation: 'pulse 1.4s infinite ease-in-out', animationDelay: '0.4s' }}></span>
     </span>
     ) : msg.text}
    </div>
    </div>
   </div>
   )}
   
   {msg.speaker === 'chanet' && (
   <div style={{ display: 'flex', gap: '10px', flexDirection: 'row' }}>
    <img src={IMAGES.chanet} alt="Chanet" style={{ width: '32px', height: '32px', borderRadius: '50%', flexShrink: 0 }} />
    <div style={{ maxWidth: '80%' }}>
    <p style={{ fontSize: '11px', fontWeight: '600', marginBottom: '4px', color: COLORS.copper, margin: 0 }}>CHANET</p>
    <div style={{ 
     padding: '12px 16px', 
     borderRadius: '18px 18px 18px 4px', 
     fontSize: '14px', 
     background: isDarkMode ? '#2a2a3e' : '#E5E5EA', 
     color: isDarkMode ? '#fff' : '#1d1d1f',
     lineHeight: '1.4'
    }}>
     {msg.isTyping ? (
     <span className="typing-dots" style={{ display: 'flex', gap: '4px' }}>
      <span style={{ width: '8px', height: '8px', borderRadius: '50%', background: '#888', animation: 'pulse 1.4s infinite ease-in-out', animationDelay: '0s' }}></span>
      <span style={{ width: '8px', height: '8px', borderRadius: '50%', background: '#888', animation: 'pulse 1.4s infinite ease-in-out', animationDelay: '0.2s' }}></span>
      <span style={{ width: '8px', height: '8px', borderRadius: '50%', background: '#888', animation: 'pulse 1.4s infinite ease-in-out', animationDelay: '0.4s' }}></span>
     </span>
     ) : msg.text}
    </div>
    </div>
   </div>
   )}
   
   {msg.speaker === 'tip' && !msg.isTyping && msg.text && (
   <div style={{ 
    marginLeft: '42px',
    padding: '10px 14px', 
    borderRadius: '16px', 
    fontSize: '13px', 
    background: isDarkMode ? '#1a1a2e' : '#F0F0F5', 
    color: isDarkMode ? '#888' : '#666',
    maxWidth: '80%',
    fontStyle: 'italic'
   }}>
    {msg.text}
   </div>
   )}
  </div>
  ))}
  
  {/* Quick action buttons - show after intro complete */}
  {unifiedMessages.length === 0 && introTypingPhase === 5 && (
  <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap', marginLeft: '42px' }}>
   {activeTab === 'create' && savedTemplates.length > 0 && (
   <button 
    onClick={() => setShowTemplateLibrary(true)}
    style={{ 
    background: 'rgba(139, 92, 246, 0.1)', 
    border: '1px solid rgba(139, 92, 246, 0.3)', 
    color: '#8B5CF6', 
    padding: '8px 16px', 
    borderRadius: '20px', 
    fontSize: '13px',
    cursor: 'pointer'
    }}
   >
    My Templates ({savedTemplates.length})
   </button>
   )}
   {activeTab === 'check' && (
   <>
    <button 
    onClick={() => setShowCustomPhrasesEditor(true)}
    style={{ 
     background: 'rgba(139, 92, 246, 0.1)', 
     border: '1px solid rgba(139, 92, 246, 0.3)', 
     color: '#8B5CF6', 
     padding: '8px 16px', 
     borderRadius: '20px', 
     fontSize: '13px',
     cursor: 'pointer'
    }}
    >
    Custom Phrases
    </button>
    <button 
    onClick={() => setShowBatchCheck(true)}
    style={{ 
     background: 'rgba(40, 167, 69, 0.1)', 
     border: '1px solid rgba(40, 167, 69, 0.3)', 
     color: '#28a745', 
     padding: '8px 16px', 
     borderRadius: '20px', 
     fontSize: '13px',
     cursor: 'pointer'
    }}
    >
    Batch Check
    </button>
   </>
   )}
   </div>
  )}
  
  {/* Actual messages */}
  {unifiedMessages.map((msg, i) => {
  const isUser = msg.type === 'user';
  const personaImg = msg.speaker === 'chanet' ? IMAGES.chanet : IMAGES.claudette;
  const personaName = msg.speaker === 'chanet' ? 'CHANET' : 'CLAUDETTE';
  const personaColor = msg.speaker === 'chanet' ? COLORS.copper : COLORS.navy;
  
  return (
   <div key={msg.id || i}>
   {/* User message - right side, purple */}
   {isUser && (
    <div style={{ display: 'flex', gap: '10px', flexDirection: 'row-reverse' }}>
    {currentUser?.photoURL ? (
     <img src={currentUser.photoURL} alt="You" style={{ width: '32px', height: '32px', borderRadius: '50%', flexShrink: 0 }} />
    ) : (
     <div style={{ 
     width: '32px', 
     height: '32px', 
     borderRadius: '50%', 
     background: 'linear-gradient(135deg, #8B5CF6, #7C3AED)',
     display: 'flex',
     alignItems: 'center',
     justifyContent: 'center',
     color: 'white',
     fontWeight: '600',
     fontSize: '14px',
     flexShrink: 0
     }}>
     {currentUser?.displayName?.charAt(0)?.toUpperCase() || 'U'}
     </div>
    )}
    <div style={{ maxWidth: '80%' }}>
     <p style={{ fontSize: '11px', fontWeight: '600', marginBottom: '4px', color: isDarkMode ? '#888' : '#666', margin: 0, textAlign: 'right' }}>YOU</p>
     <div style={{ 
     padding: '12px 16px', 
     borderRadius: '18px 18px 4px 18px', 
     fontSize: '14px', 
     background: 'linear-gradient(135deg, #8B5CF6, #7C3AED)', 
     color: '#fff',
     lineHeight: '1.4'
     }}>
     {msg.content}
     </div>
    </div>
    </div>
   )}
   
   {/* AI roleplay message - left side, gray */}
   {msg.type === 'roleplay' && msg.content && (
    <div style={{ display: 'flex', gap: '10px', flexDirection: 'row' }}>
    <img src={personaImg} alt={personaName} style={{ width: '32px', height: '32px', borderRadius: '50%', flexShrink: 0 }} />
    <div style={{ maxWidth: '80%' }}>
     <p style={{ fontSize: '11px', fontWeight: '600', marginBottom: '4px', color: personaColor, margin: 0 }}>{personaName}</p>
     <div style={{ 
     padding: '12px 16px', 
     borderRadius: '18px 18px 18px 4px', 
     fontSize: '14px', 
     background: isDarkMode ? '#2a2a3e' : '#E5E5EA', 
     color: isDarkMode ? '#fff' : '#1d1d1f',
     lineHeight: '1.4'
     }}>
     {msg.content}
     </div>
    </div>
    </div>
   )}
   
   {/* Result message - left side with card */}
   {msg.type === 'result' && (
    <div style={{ display: 'flex', gap: '10px', flexDirection: 'row' }}>
    <img src={IMAGES.claudette} alt="Claudette" style={{ width: '32px', height: '32px', borderRadius: '50%', flexShrink: 0 }} />
    <div style={{ maxWidth: '90%', width: '100%' }}>
     <p style={{ fontSize: '11px', fontWeight: '600', marginBottom: '4px', color: COLORS.navy, margin: 0 }}>CLAUDETTE</p>
     <div style={{ 
     background: isDarkMode ? '#1a1a2e' : 'white', 
     borderRadius: '16px', 
     border: `1px solid ${isDarkMode ? '#3a3a4e' : '#E5E5EA'}`,
     overflow: 'hidden'
     }}>
     {/* Card header */}
     <div style={{ 
      padding: '12px 16px', 
      background: 'linear-gradient(135deg, #B87333, #D4944A)', 
      color: 'white',
      fontWeight: '600',
      fontSize: '13px',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center'
     }}>
      <span>{msg.content.resultType === 'check' ? 'AI Check Results' : msg.content.resultType === 'search' ? 'Search Results' : 'Generated Content'}</span>
      {lastResponseTime && <span style={{ opacity: 0.8, fontSize: '12px' }}>{lastResponseTime}s</span>}
     </div>
     {/* Card body */}
     <div style={{ padding: '16px', fontSize: '14px', lineHeight: '1.6', color: isDarkMode ? '#E8E8EC' : '#333', maxHeight: '400px', overflowY: 'auto' }}>
      {(msg.content.content || msg.content || '').split('\n').map((line, li) => {
      if (!line.trim()) return <div key={li} style={{ height: '8px' }} />;
      if (line.startsWith('**') && line.endsWith('**')) return <p key={li} style={{ fontWeight: '700', color: COLORS.navy, marginTop: li > 0 ? '12px' : 0, marginBottom: '4px' }}>{line.replace(/\*\*/g, '')}</p>;
      return <p key={li} style={{ margin: '0 0 8px 0' }}>{line}</p>;
      })}
     </div>
     {/* Card actions */}
     <div style={{ padding: '12px 16px', borderTop: `1px solid ${isDarkMode ? '#3a3a4e' : '#E5E5EA'}`, display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
      <button onClick={() => { navigator.clipboard.writeText(msg.content.content || msg.content || ''); showToast('Copied!'); }} style={{ padding: '6px 12px', background: isDarkMode ? '#2a2a3e' : '#f0f0f0', border: 'none', borderRadius: '6px', fontSize: '12px', cursor: 'pointer', color: isDarkMode ? '#fff' : '#333' }}>Copy</button>
      <button onClick={() => handleSave(msg.content.content || msg.content, 'content')} style={{ padding: '6px 12px', background: isDarkMode ? '#2a2a3e' : '#f0f0f0', border: 'none', borderRadius: '6px', fontSize: '12px', cursor: 'pointer', color: isDarkMode ? '#fff' : '#333' }}>Download</button>
      <button onClick={handleRegenerate} style={{ padding: '6px 12px', background: isDarkMode ? '#2a2a3e' : '#f0f0f0', border: 'none', borderRadius: '6px', fontSize: '12px', cursor: 'pointer', color: isDarkMode ? '#fff' : '#333' }}>Regenerate</button>
      <button onClick={() => handleResponseFeedback(true, msg.content.content || msg.content)} style={{ padding: '6px 12px', background: 'rgba(40, 167, 69, 0.1)', border: '1px solid rgba(40, 167, 69, 0.3)', borderRadius: '6px', fontSize: '12px', cursor: 'pointer', color: '#28a745' }}>Good</button>
      <button onClick={() => handleResponseFeedback(false, msg.content.content || msg.content)} style={{ padding: '6px 12px', background: 'rgba(139, 92, 246, 0.1)', border: '1px solid rgba(139, 92, 246, 0.3)', borderRadius: '6px', fontSize: '12px', cursor: 'pointer', color: '#8B5CF6' }}>Improve</button>
      {/* V2.10: Deliver As Persona Button */}
      {activeTab !== 'acquire' && (
       <button 
        onClick={() => {
         setPendingDeliveryContent({ content: msg.content.content || msg.content || '', type: activeTab });
         setShowDeliverySelector(true);
        }} 
        style={{ 
         padding: '6px 12px', 
         background: 'linear-gradient(135deg, #B87333, #D4944A)', 
         color: 'white', 
         border: 'none', 
         borderRadius: '6px', 
         fontSize: '12px', 
         fontWeight: '600', 
         cursor: 'pointer' 
        }}
       >
        Deliver As...
       </button>
      )}
     </div>
     </div>
    </div>
    </div>
   )}
   
   {/* Changes message */}
   {msg.type === 'changes' && (
    <div style={{ display: 'flex', gap: '10px', flexDirection: 'row' }}>
    <img src={IMAGES.claudette} alt="Claudette" style={{ width: '32px', height: '32px', borderRadius: '50%', flexShrink: 0 }} />
    <div style={{ maxWidth: '90%', width: '100%' }}>
     <p style={{ fontSize: '11px', fontWeight: '600', marginBottom: '4px', color: COLORS.navy, margin: 0 }}>CLAUDETTE</p>
     <div style={{ 
     background: isDarkMode ? '#1a1a2e' : 'white', 
     borderRadius: '16px', 
     border: `1px solid ${isDarkMode ? '#3a3a4e' : '#E5E5EA'}`,
     overflow: 'hidden'
     }}>
     <div style={{ padding: '12px 16px', background: 'linear-gradient(135deg, #B87333, #D4944A)', color: 'white', fontWeight: '600', fontSize: '13px' }}>
      Tracked Changes ({msg.content.length} issues)
     </div>
     <div style={{ padding: '16px' }}>
      {msg.content.map((c, ci) => (
      <div key={ci} style={{ marginBottom: '12px', padding: '10px', background: isDarkMode ? '#2a2a3e' : '#f5f5f5', borderRadius: '8px' }}>
       <div style={{ textDecoration: 'line-through', color: '#dc3545', marginBottom: '4px' }}>{c.original}</div>
       <div style={{ color: '#28a745', marginBottom: '4px' }}>{c.replacement || c.suggestion}</div>
       <div style={{ fontSize: '11px', color: isDarkMode ? '#888' : '#666' }}>{c.reason}</div>
      </div>
      ))}
     </div>
     </div>
    </div>
    </div>
   )}
   
   {/* V2.7: Tier Selection as Chat Message */}
   {msg.type === 'tier-selection' && (
    <div style={{ display: 'flex', gap: '10px', flexDirection: 'row' }}>
    <img src={IMAGES.claudette} alt="Claudette" style={{ width: '32px', height: '32px', borderRadius: '50%', flexShrink: 0 }} />
    <div style={{ maxWidth: '90%', width: '100%' }}>
     <p style={{ fontSize: '11px', fontWeight: '600', marginBottom: '4px', color: COLORS.navy, margin: 0 }}>CLAUDETTE</p>
     <div style={{ 
     padding: '12px 16px', 
     borderRadius: '18px 18px 18px 4px', 
     background: isDarkMode ? '#2a2a3e' : '#E5E5EA', 
     color: isDarkMode ? '#fff' : '#1d1d1f',
     marginBottom: '12px'
     }}>
     Found {msg.content.issueCount} issue{msg.content.issueCount !== 1 ? 's' : ''}. How should I handle this?
     </div>
     <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', marginLeft: '4px' }}>
     {Object.entries(REWRITE_TIERS).map(([key, tier]) => (
      <button
      key={key}
      onClick={() => msg.content.onSelect(key)}
      style={{
       padding: '12px 16px',
       background: isDarkMode ? '#1a1a2e' : 'white',
       border: `2px solid ${key === 'A' ? '#8B5CF6' : key === 'B' ? '#B87333' : key === 'C' ? '#28a745' : '#666'}`,
       borderRadius: '12px',
       textAlign: 'left',
       cursor: 'pointer',
       transition: 'all 0.2s ease'
      }}
      >
      <div style={{ fontWeight: '600', color: key === 'A' ? '#8B5CF6' : key === 'B' ? '#B87333' : key === 'C' ? '#28a745' : '#666', marginBottom: '4px' }}>
       {key}: {tier.name}
      </div>
      <div style={{ fontSize: '12px', color: isDarkMode ? '#888' : '#666' }}>
       {tier.description}
      </div>
      </button>
     ))}
     </div>
    </div>
    </div>
   )}
   
   {/* V2.7: Check Result with Side-by-Side Comparison */}
   {msg.type === 'check-result' && (
    <div style={{ display: 'flex', gap: '10px', flexDirection: 'row' }}>
    <img src={IMAGES.claudette} alt="Claudette" style={{ width: '32px', height: '32px', borderRadius: '50%', flexShrink: 0 }} />
    <div style={{ maxWidth: '95%', width: '100%' }}>
     <p style={{ fontSize: '11px', fontWeight: '600', marginBottom: '4px', color: COLORS.navy, margin: 0 }}>CLAUDETTE</p>
     <div style={{ 
     background: isDarkMode ? '#1a1a2e' : 'white', 
     borderRadius: '16px', 
     border: `1px solid ${isDarkMode ? '#3a3a4e' : '#E5E5EA'}`,
     overflow: 'hidden'
     }}>
     {/* Header */}
     <div style={{ 
      padding: '12px 16px', 
      background: 'linear-gradient(135deg, #B87333, #D4944A)', 
      color: 'white',
      fontWeight: '600',
      fontSize: '13px',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center'
     }}>
      <span>AI Check Results (Tier {msg.content.tierUsed})</span>
      <span style={{ fontSize: '12px', opacity: 0.9 }}>{msg.content.issueCount} issue{msg.content.issueCount !== 1 ? 's' : ''} fixed</span>
     </div>
     
     {/* Side-by-Side Comparison */}
     <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1px', background: isDarkMode ? '#3a3a4e' : '#E5E5EA' }}>
      <div style={{ padding: '12px', background: isDarkMode ? 'rgba(220, 53, 69, 0.1)' : 'rgba(220, 53, 69, 0.05)' }}>
      <div style={{ fontSize: '11px', fontWeight: '600', color: '#dc3545', marginBottom: '8px' }}>ORIGINAL</div>
      <div style={{ fontSize: '13px', color: isDarkMode ? '#E8E8EC' : '#333', lineHeight: '1.5', whiteSpace: 'pre-wrap' }}>
       {msg.content.original}
      </div>
      </div>
      <div style={{ padding: '12px', background: isDarkMode ? 'rgba(40, 167, 69, 0.1)' : 'rgba(40, 167, 69, 0.05)' }}>
      <div style={{ fontSize: '11px', fontWeight: '600', color: '#28a745', marginBottom: '8px' }}>CORRECTED</div>
      <div style={{ fontSize: '13px', color: isDarkMode ? '#E8E8EC' : '#333', lineHeight: '1.5', whiteSpace: 'pre-wrap' }}>
       {msg.content.corrected}
      </div>
      </div>
     </div>
     
     {/* Actions */}
     <div style={{ padding: '12px 16px', borderTop: `1px solid ${isDarkMode ? '#3a3a4e' : '#E5E5EA'}`, display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
      <button onClick={() => { navigator.clipboard.writeText(msg.content.corrected); showToast('Copied corrected version!'); }} style={{ padding: '8px 16px', background: 'linear-gradient(135deg, #8B5CF6, #7C3AED)', color: 'white', border: 'none', borderRadius: '8px', fontSize: '13px', fontWeight: '600', cursor: 'pointer' }}>Copy Corrected</button>
      <button onClick={() => handleSave(msg.content.corrected, 'content')} style={{ padding: '8px 16px', background: isDarkMode ? '#2a2a3e' : '#f0f0f0', border: 'none', borderRadius: '8px', fontSize: '13px', cursor: 'pointer', color: isDarkMode ? '#fff' : '#333' }}>Download</button>
      <button onClick={() => { navigator.clipboard.writeText(msg.content.original); showToast('Copied original!'); }} style={{ padding: '8px 16px', background: 'transparent', border: `1px solid ${isDarkMode ? '#3a3a4e' : '#ddd'}`, borderRadius: '8px', fontSize: '13px', cursor: 'pointer', color: isDarkMode ? '#888' : '#666' }}>Copy Original</button>
      {/* V2.10: Deliver As Persona Button */}
      <button 
       onClick={() => {
        setPendingDeliveryContent({ content: msg.content.corrected, type: 'check' });
        setShowDeliverySelector(true);
       }} 
       style={{ 
        padding: '8px 16px', 
        background: 'linear-gradient(135deg, #B87333, #D4944A)', 
        color: 'white', 
        border: 'none', 
        borderRadius: '8px', 
        fontSize: '13px', 
        fontWeight: '600', 
        cursor: 'pointer' 
       }}
      >
       Deliver As...
      </button>
     </div>
     </div>
    </div>
    </div>
   )}
   </div>
  );
  })}
  
  {/* Typing indicator */}
  {isProcessing && (
  <div style={{ display: 'flex', gap: '10px', flexDirection: 'row', alignItems: 'flex-end' }}>
   <img src={IMAGES.claudette} alt="Claudette" style={{ width: '32px', height: '32px', borderRadius: '50%' }} />
   <div style={{ 
   padding: '12px 16px', 
   borderRadius: '18px 18px 18px 4px', 
   background: isDarkMode ? '#2a2a3e' : '#E5E5EA',
   display: 'flex',
   gap: '4px',
   alignItems: 'center'
   }}>
   <span style={{ width: '8px', height: '8px', borderRadius: '50%', background: isDarkMode ? '#888' : '#999', animation: 'bounce 1.4s infinite 0s' }} />
   <span style={{ width: '8px', height: '8px', borderRadius: '50%', background: isDarkMode ? '#888' : '#999', animation: 'bounce 1.4s infinite 0.2s' }} />
   <span style={{ width: '8px', height: '8px', borderRadius: '50%', background: isDarkMode ? '#888' : '#999', animation: 'bounce 1.4s infinite 0.4s' }} />
   {operationProgress.active && (
    <span style={{ marginLeft: '8px', fontSize: '12px', color: isDarkMode ? '#888' : '#666' }}>
    {operationProgress.percent}% {operationProgress.message}
    </span>
   )}
   </div>
  </div>
  )}
  
  {/* Scroll anchor */}
  <div ref={messagesEndRef} />
 </div>
 
 {/* Input Area - V2.8: Added + button left, mic button right */}
 <div style={{ 
  padding: '12px 16px', 
  borderTop: `1px solid ${isDarkMode ? '#2a2a3e' : '#E5E5EA'}`,
  background: isDarkMode ? 'rgba(0,0,0,0.3)' : 'rgba(255,255,255,0.8)',
  backdropFilter: 'blur(10px)',
  display: 'flex',
  gap: '8px',
  alignItems: 'flex-end'
 }}>
  {/* V2.8: Upload/Attachment button (+ on left like iPhone) */}
  <button
   onClick={() => document.getElementById('file-upload-input')?.click()}
   style={{
   width: '40px',
   height: '40px',
   borderRadius: '50%',
   border: `2px solid ${isDarkMode ? '#3a3a4e' : '#B87333'}`,
   background: 'transparent',
   color: isDarkMode ? '#888' : '#B87333',
   fontSize: '22px',
   fontWeight: '300',
   cursor: 'pointer',
   display: 'flex',
   alignItems: 'center',
   justifyContent: 'center',
   flexShrink: 0
   }}
   title="Upload file"
  >
   +
  </button>
  <input 
   type="file" 
   id="file-upload-input" 
   style={{ display: 'none' }}
   accept=".pdf,.doc,.docx,.txt,.png,.jpg,.jpeg"
   onChange={async (e) => {
   const file = e.target.files?.[0];
   if (file) {
    showToast(`File "${file.name}" ready - paste or describe what to do with it`);
    // Store file reference for later use
    setCurrentState(prev => ({ 
    ...prev, 
    input: prev.input ? `${prev.input}\n\n[Attached: ${file.name}]` : `[Attached: ${file.name}]`,
    attachedFile: file 
    }));
   }
   }}
  />
  
  {/* Quick Templates button */}
  {QUICK_TEMPLATES[activeTab] && (
  <button
   onClick={() => setShowQuickTemplates(!showQuickTemplates)}
   style={{
   padding: '10px',
   background: isDarkMode ? '#2a2a3e' : '#f0f0f0',
   border: 'none',
   borderRadius: '50%',
   cursor: 'pointer',
   fontSize: '16px',
   color: isDarkMode ? '#888' : '#666'
   }}
   title="Quick Templates"
  >
   📋
  </button>
  )}
  
  {/* Text input - V2.14: Proper iMessage-style auto-expand */}
  <textarea 
  ref={(el) => {
   if (el) {
   // Auto-resize on mount and when value changes
   el.style.height = 'auto';
   el.style.height = Math.min(el.scrollHeight, 200) + 'px';
   }
  }}
  value={getCurrentState().input || ''}
  onChange={(e) => {
   setCurrentState(prev => ({ ...prev, input: e.target.value }));
   // V2.14: iMessage-style auto-expand
   e.target.style.height = 'auto';
   e.target.style.height = Math.min(e.target.scrollHeight, 200) + 'px';
  }}
  placeholder={
   activeTab === 'create' ? "What would you like me to create?" :
   activeTab === 'check' ? "Paste content to check for AI detection..." :
   activeTab === 'ask' ? "Ask me anything about GMG..." :
   activeTab === 'prep' ? "Tell me about your meeting or client..." :
   activeTab === 'acquire' ? "Paste job URL or description..." :
   activeTab === 'knowledge' ? "Add knowledge: Title | Content" :
   "Enter your request..."
  }
  onKeyDown={(e) => { if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); handleUnifiedSubmit(); } }}
  style={{
   flex: 1,
   padding: '12px 16px',
   borderRadius: '20px',
   border: `1px solid ${isDarkMode ? '#3a3a4e' : '#E5E5EA'}`,
   fontSize: '16px',
   outline: 'none',
   resize: 'none',
   minHeight: '44px',
   maxHeight: '200px',
   overflow: 'hidden',
   background: isDarkMode ? '#1a1a2e' : 'white',
   color: isDarkMode ? '#fff' : '#333',
   fontFamily: 'inherit',
   lineHeight: '1.4',
   transition: 'height 0.1s ease'
  }}
  rows={1}
  />
  
  {/* V2.8: Voice/Mic button */}
  <button 
  onClick={() => {
   if ('webkitSpeechRecognition' in window || 'SpeechRecognition' in window) {
   const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
   const recognition = new SpeechRecognition();
   recognition.continuous = false;
   recognition.interimResults = false;
   recognition.lang = 'en-US';
   
   showToast('Listening... speak now');
   
   recognition.onresult = (event) => {
    const transcript = event.results[0][0].transcript;
    setCurrentState(prev => ({ 
    ...prev, 
    input: prev.input ? `${prev.input} ${transcript}` : transcript 
    }));
    showToast('Got it!');
   };
   
   recognition.onerror = (event) => {
    showToast('Voice input error - try again');
   };
   
   recognition.start();
   } else {
   showToast('Voice input not supported in this browser');
   }
  }}
  style={{
   width: '40px',
   height: '40px',
   borderRadius: '50%',
   border: 'none',
   background: isDarkMode ? '#2a2a3e' : '#f0f0f0',
   color: isDarkMode ? '#888' : '#666',
   fontSize: '18px',
   cursor: 'pointer',
   display: 'flex',
   alignItems: 'center',
   justifyContent: 'center',
   flexShrink: 0
  }}
  title="Voice input"
  >
   🎤
  </button>
  
  {/* Send button */}
  <button 
  onClick={handleUnifiedSubmit} 
  disabled={isProcessing || !getCurrentState().input?.trim()}
  style={{
   width: '44px',
   height: '44px',
   borderRadius: '50%',
   border: 'none',
   background: isProcessing || !getCurrentState().input?.trim() 
   ? (isDarkMode ? '#3a3a4e' : '#ccc')
   : 'linear-gradient(135deg, #B87333, #8B5A2B)',
   color: '#fff',
   fontSize: '18px',
   cursor: isProcessing || !getCurrentState().input?.trim() ? 'not-allowed' : 'pointer',
   display: 'flex',
   alignItems: 'center',
   justifyContent: 'center',
   flexShrink: 0
  }}
  >
  {isProcessing ? '⏳' : '→'}
  </button>
 </div>
 
 {/* Quick Templates Dropdown */}
 {showQuickTemplates && QUICK_TEMPLATES[activeTab] && (
  <div style={{
  position: 'absolute',
  bottom: '70px',
  left: '16px',
  background: isDarkMode ? '#1a1a2e' : 'white',
  border: `1px solid ${isDarkMode ? '#3a3a4e' : '#E5E5EA'}`,
  borderRadius: '12px',
  padding: '8px',
  zIndex: 100,
  minWidth: '250px',
  boxShadow: '0 4px 20px rgba(0,0,0,0.15)'
  }}>
  {QUICK_TEMPLATES[activeTab].map((tmpl, i) => (
   <button
   key={i}
   onClick={() => {
    setCurrentState(prev => ({ ...prev, input: tmpl.prompt }));
    setShowQuickTemplates(false);
   }}
   style={{
    display: 'block',
    width: '100%',
    padding: '10px 12px',
    background: 'transparent',
    border: 'none',
    textAlign: 'left',
    cursor: 'pointer',
    borderRadius: '6px',
    color: isDarkMode ? '#fff' : '#333',
    fontSize: '13px'
   }}
   onMouseEnter={e => e.target.style.background = isDarkMode ? '#2a2a3e' : '#f5f5f5'}
   onMouseLeave={e => e.target.style.background = 'transparent'}
   >
   {tmpl.label}
   </button>
  ))}
  </div>
 )}
 </div>
 )}
 
 {/* Content Grid (hidden when unified UI is active for main tabs) */}
 {/* V38.9: Content Grid (hidden when unified UI is active) */}
 <div className="content-grid" style={{ display: useUnifiedUI ? 'none' : 'grid' }}>
 
 {/* Left Column - Chat Box */}
 <div className={`chat-column ${(activeTab === 'prep' || activeTab === 'acquire') ? 'hidden-tab' : ''}`}>
 <div className="chat-header">
 <div className="chat-header-avatars">
 <div className="avatar-with-label">
 <img src={IMAGES.claudette} alt="Claudette" className={`chat-header-avatar ${isProcessing ? 'active-glow' : ''}`} />
 <div className="admin-label">Brandon's Admin</div><div style={{ fontSize: '10px', color: isDarkMode ? DARK_COLORS.textSecondary : COLORS.copper, fontWeight: '600' }}>Claudette</div>
 </div>
 <div className="avatar-with-label">
 <img src={IMAGES.chanet} alt="Chanet" className={`chat-header-avatar ${isProcessing ? 'active-glow' : ''}`} />
 <div className="admin-label">Eric's Admin</div><div style={{ fontSize: '10px', color: isDarkMode ? DARK_COLORS.textSecondary : COLORS.copper, fontWeight: '600' }}>Chanet</div>
 </div>
 </div>
 </div>
 <div className="chat-messages">
 {chatMessages.map((msg, i) => (
 <div key={i} className={`chat-message ${msg.isTyping ? 'typing' : ''}`}>
 <img 
 src={msg.speaker === 'chanet' ? IMAGES.chanet : IMAGES.claudette}
 className="chat-avatar"
 alt={msg.speaker}
 />
 <div className="chat-bubble">
 <div className="chat-name">
 {msg.speaker === 'chanet' ? 'Chanet' : 'Claudette'}
 {msg.isTyping && <span className="typing-label"> is typing</span>}
 </div>
 <div className="chat-text">
 {msg.isTyping ? (
 <span className="typing-dots">
 <span>.</span><span>.</span><span>.</span>
 </span>
 ) : msg.text}
 </div>
 </div>
 </div>
 ))}
 <div ref={chatEndRef} />
 </div>
 </div>
 
 {/* Center Column - Input */}
 <div className="input-column">
 
 {/* Tabs */}
 <div className="tabs">
 <button 
 className={`tab ${activeTab === 'create' ? 'active' : ''}`}
 onClick={() => setActiveTab('create')}
 data-tooltip="Create content using GMG's approved writing standards"
 >
 Create (By GMG's Approved AI)
 </button>
 <button 
 className={`tab ${activeTab === 'check' ? 'active' : ''}`}
 onClick={() => setActiveTab('check')}
 data-tooltip="Check if your content sounds robotic and verify facts against GMG database"
 >
 See If You Sound Like AI Or Not
 </button>
 <button 
 className={`tab ${activeTab === 'ask' ? 'active' : ''}`}
 onClick={() => setActiveTab('ask')}
 data-tooltip="Search internal GMG data, clients, founder history, and fundraising knowledge"
 >
 Search Internal GMG Data
 </button>
 <button 
 className={`tab ${activeTab === 'prep' ? 'active' : ''}`}
 onClick={() => setActiveTab('prep')}
 data-tooltip="Prepare for client meetings with comprehensive briefings"
 >
 Client Prep
 </button>
 <button 
 className={`tab ${activeTab === 'acquire' ? 'active' : ''}`}
 onClick={() => setActiveTab('acquire')}
 data-tooltip="Internal tool for job applications (Password Protected)"
 style={{ borderLeft: `2px solid ${COLORS.copper}` }}
 >
 Client Acquisition
 </button>
 </div>
 
 {/* Tab Header - Title and Description */}
 <div className={`tab-header ${(activeTab === 'prep' || activeTab === 'acquire') ? 'hidden-tab' : ''}`}>
 <h2 className="tab-title">
 {activeTab === 'create' && 'Create (By GMG\'s Approved AI)'}
 {activeTab === 'check' && 'See If You Sound Like AI Or Not'}
 {activeTab === 'ask' && 'Search Internal GMG Data'}
 {activeTab === 'knowledge' && 'Team Knowledge Base'}
 {activeTab === 'prep' && 'Client Meeting Prep'}
 {activeTab === 'acquire' && 'Client Acquisition (EBC Applications)'}
 </h2>
 <p className="tab-description">
 {activeTab === 'create' && 'Draft emails, thank you letters, board updates, proposals, pitch decks, and more. Everything follows GMG writing standards automatically.'}
 {activeTab === 'check' && 'Paste your content BEFORE sending to a client. We check for AI language, verify facts against the GMG database, and rewrite it in Brandon\'s voice.'}
 {activeTab === 'ask' && 'Ask questions about GMG clients, founder history, pricing, methodologies, and fundraising knowledge. Powered by the Lane-Pierce Fellowship 60-Day Course.'}
 {activeTab === 'knowledge' && 'Add client updates, meeting notes, and strategic insights. The whole team can search this in Ask GMG.'}
 {activeTab === 'prep' && 'Paste all client materials. Get a comprehensive briefing with talking points, history, and strategy recommendations.'}
 {activeTab === 'acquire' && 'Process job applications for Brandon, Eric, or BJ. Paste job descriptions, generate cover letters, get spreadsheet row data.'}
 {activeTab === 'acquire' && 'Process job applications for Brandon, Eric, or BJ. Paste job descriptions, generate cover letters, get spreadsheet row data.'}
 </p>
 </div>
 
 {/* V2.12: Knowledge entries display with delete */}
 {activeTab === 'knowledge' && liveKnowledge.length > 0 && (
 <div style={{
  padding: '12px 16px',
  background: isDarkMode ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.02)',
  borderRadius: '12px',
  margin: '0 16px 16px',
  maxHeight: '300px',
  overflowY: 'auto'
 }}>
  <div style={{ fontSize: '13px', fontWeight: '600', marginBottom: '12px', color: isDarkMode ? '#aaa' : '#666' }}>
  Team Knowledge ({liveKnowledge.length} entries)
  </div>
  {liveKnowledge.slice(0, 20).map(item => (
  <div key={item.id} style={{
   display: 'flex',
   justifyContent: 'space-between',
   alignItems: 'flex-start',
   padding: '10px 12px',
   background: isDarkMode ? 'rgba(255,255,255,0.08)' : 'white',
   borderRadius: '8px',
   marginBottom: '8px',
   boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
  }}>
   <div style={{ flex: 1 }}>
   <div style={{ fontWeight: '600', fontSize: '14px', marginBottom: '4px' }}>{item.title}</div>
   <div style={{ fontSize: '12px', color: isDarkMode ? '#888' : '#666', marginBottom: '4px' }}>
    {item.content?.substring(0, 100)}{item.content?.length > 100 ? '...' : ''}
   </div>
   <div style={{ fontSize: '11px', color: isDarkMode ? '#666' : '#999' }}>
    Added by {item.addedByName || 'Unknown'} • {new Date(item.addedAt).toLocaleDateString()}
   </div>
   </div>
   <button
   onClick={() => {
    if (window.confirm('Delete this knowledge entry?')) {
    deleteKnowledgeEntry(item.id);
    }
   }}
   style={{
    background: 'transparent',
    border: 'none',
    color: '#dc3545',
    cursor: 'pointer',
    padding: '4px 8px',
    fontSize: '18px',
    opacity: 0.7
   }}
   title="Delete entry"
   >
   ×
   </button>
  </div>
  ))}
  {liveKnowledge.length > 20 && (
  <div style={{ textAlign: 'center', fontSize: '12px', color: '#888', padding: '8px' }}>
   Showing 20 of {liveKnowledge.length} entries
  </div>
  )}
 </div>
 )}
 
 {/* Input Card - Hidden on acquire and prep tabs since they have their own inputs */}
 {activeTab !== 'acquire' && activeTab !== 'prep' && (
 <div className="input-card">
 
 {/* Toolbar */}
 <div className="input-toolbar">
 {activeTab === 'create' && (
 <>
 <button className="tool-btn" onClick={() => fileInputRef.current?.click()}>
 Attach
 </button>
 <input
 ref={fileInputRef}
 type="file"
 multiple
 onChange={handleFileUpload}
 style={{ display: 'none' }}
 />
 </>
 )}
 <button 
 className={`tool-btn ${isRecording ? 'recording' : ''}`}
 onClick={isRecording ? stopRecording : startRecording}
 >
 {isRecording ? 'Stop' : 'Voice'}
 </button>
 {isSpeaking && (
 <button className="tool-btn" onClick={stopSpeaking}>
 Stop Reading
 </button>
 )}
 </div>
 
 {/* File Chips - V38.8: Clickable for preview */}
 {activeTab === 'create' && createState.files.length > 0 && (
 <div className="file-chips">
 {createState.files.map((f, i) => (
 <div key={i} className="file-chip">
 <span 
 onClick={() => previewFile(f)} 
 style={{ cursor: 'pointer' }}
 title="Click to preview"
 >{f.name}</span>
 <button onClick={() => removeFile(i)}>X</button>
 </div>
 ))}
 </div>
 )}
 
 {/* V38.8: File Preview Modal */}
 {filePreview.open && (
 <div className="file-preview-modal" onClick={closeFilePreview}>
 <div className="file-preview-content" onClick={e => e.stopPropagation()}>
 <div className="file-preview-header">
 <h3>{filePreview.name}</h3>
 <button onClick={closeFilePreview}>X</button>
 </div>
 <div className="file-preview-body">
 {filePreview.type === 'pdf' ? (
 <iframe src={filePreview.content} title="PDF Preview" style={{ width: '100%', height: '500px', border: 'none' }} />
 ) : filePreview.type === 'html' ? (
 <iframe srcDoc={filePreview.content} title="HTML Preview" style={{ width: '100%', height: '500px', border: 'none' }} />
 ) : filePreview.type === 'markdown' ? (
 <pre style={{ whiteSpace: 'pre-wrap', fontFamily: 'monospace', fontSize: '13px', maxHeight: '500px', overflow: 'auto' }}>{filePreview.content}</pre>
 ) : filePreview.type === 'csv' ? (
 <pre style={{ whiteSpace: 'pre-wrap', fontFamily: 'monospace', fontSize: '12px', maxHeight: '500px', overflow: 'auto' }}>{filePreview.content}</pre>
 ) : filePreview.type === 'json' ? (
 <pre style={{ whiteSpace: 'pre-wrap', fontFamily: 'monospace', fontSize: '12px', maxHeight: '500px', overflow: 'auto', color: '#e0e0e0' }}>{filePreview.content}</pre>
 ) : (
 <pre style={{ whiteSpace: 'pre-wrap', maxHeight: '500px', overflow: 'auto' }}>{filePreview.content}</pre>
 )}
 </div>
 </div>
 </div>
 )}
 
 {/* V31.5: Smart Click-to-Add Suggestions - ALL TABS */}
 {suggestions.length > 0 && (
 <div className="smart-suggestions">
 <span className="suggestions-label">Click to add:</span>
 <div className="suggestion-chips">
 {suggestions.map((s, i) => (
 <button 
 key={i} 
 className={`suggestion-chip ${s.category || 'default'}`}
 onClick={() => {
 // V31.5: Direct insert from SMART_SUGGESTIONS
 const addText = s.insert || s.label || s.text;
 const currentInput = getCurrentState().input;
 const newInput = currentInput + (currentInput.endsWith(' ') || currentInput === '' ? '' : ' ') + addText + ' ';
 setCurrentState(prev => ({ ...prev, input: newInput }));
 showToast(`Added: ${s.label || addText.substring(0, 20)}...`);
 // Remove this suggestion from list
 setSuggestions(prev => prev.filter((_, idx) => idx !== i));
 }}
 title={s.insert || s.text}
 >
 <span className="chip-category">{s.category?.toUpperCase() || ''}</span>
 {s.label || s.text}
 </button>
 ))}
 </div>
 </div>
 )}
 
 {/* Textarea - V2.12: iMessage-style auto-expand */}
 <textarea
 className="main-input"
 placeholder={
 activeTab === 'create' 
 ? 'Describe what you need... Use a template below or write your own request.'
 : activeTab === 'check'
 ? 'Paste your content here to check against GMG writing standards...\n\nTIP: To check multiple emails at once, separate them with --- on its own line.'
 : 'Ask a question about GMG clients, pricing, methodologies, or processes...'
 }
 value={currentState.input}
 onChange={(e) => {
  setCurrentState(prev => ({ ...prev, input: e.target.value }));
  // V2.12: Auto-resize like iMessage
  e.target.style.height = 'auto';
  e.target.style.height = Math.min(e.target.scrollHeight, 200) + 'px';
 }}
 style={{ minHeight: '60px', maxHeight: '200px', overflow: 'auto' }}
 />
 
 {/* V25: Word/Character Count */}
 <div className="word-count">
 {currentState.input.length} characters | {getWordCount(currentState.input)} words
 {activeTab === 'check' && detectBulkMode(currentState.input) && (
 <span className="bulk-indicator" style={{ marginLeft: '12px' }}>
 Bulk Mode: {splitBulkContent(currentState.input).length} items
 </span>
 )}
 </div>
 
 {/* V31.5: Enhanced keyboard shortcuts hint */}
 <div className="shortcuts-hint">
 <kbd>Ctrl</kbd>+<kbd>Enter</kbd> submit | <kbd>Ctrl</kbd>+<kbd>Shift</kbd>+<kbd>C</kbd> copy result | <kbd>Ctrl</kbd>+<kbd>H</kbd> history | <kbd>Ctrl</kbd>+<kbd>K</kbd> clear
 </div>
 
 {/* Submit Row */}
 <div className="submit-row">
 {/* Fact-check toggle (AI Check tab only) */}
 {activeTab === 'check' && (
 <label className="fact-check-toggle">
 <input 
 type="checkbox"
 checked={checkState.factCheckEnabled}
 onChange={(e) => setCheckState(prev => ({ ...prev, factCheckEnabled: e.target.checked }))}
 />
 <span>Fact-check against GMG database</span>
 </label>
 )}
 <button 
 className={`submit-btn ${isProcessing ? 'processing' : ''}`}
 onClick={handleSubmit}
 disabled={isProcessing || (!currentState.input.trim() && (!createState.files || createState.files.length === 0))}
 >
 {isProcessing ? 'Processing...' : (
 activeTab === 'create' ? 'Create' :
 activeTab === 'check' ? 'Check My Writing' : 'Search GMG'
 )}
 </button>
 </div>
 
 {/* Templates (Create tab only) */}
 {activeTab === 'create' && (
 <div className="templates-section">
 <div className="templates-title">Quick Templates:</div>
 <div className="templates-grid">
 {TEMPLATES.map(template => (
 <button
 key={template.id}
 className="template-btn"
 onClick={() => handleTemplateClick(template)}
 >
 {template.label}
 </button>
 ))}
 </div>
 </div>
 )}
 </div>
 )}
 </div>
 
 {/* Right Column - Results */}
 <div className="results-column">
 
 {/* Empty State (not shown on prep/acquire tabs) */}
 {!isProcessing && !currentState.result && activeTab !== 'prep' && activeTab !== 'acquire' && (
 <div className="empty-state">
 <div className="empty-state-icon">
 {activeTab === 'create' ? '' : activeTab === 'check' ? '' : ''}
 </div>
 <h3>
 {activeTab === 'create' && 'Create (By GMG\'s Approved AI)'}
 {activeTab === 'check' && 'See If You Sound Like AI Or Not'}
 {activeTab === 'ask' && 'Search Internal GMG Data'}
 </h3>
 <p>
 {activeTab === 'create' && 'Draft emails, thank you letters, board updates, proposals, prospect research, and more. Everything follows GMG writing standards with no em dashes, no AI phrases, and no CTA endings.'}
 {activeTab === 'check' && 'Paste your content BEFORE sending to a client. We\'ll check for AI-sounding language, verify facts against the GMG database for inaccuracies (like wrong names or titles), and rewrite it to pass AI detection.'}
 {activeTab === 'ask' && 'Search internal GMG data including clients, founder history, pricing, methodologies, and fundraising knowledge. Powered by the Lane-Pierce Fellowship 60-Day Course curriculum.'}
 </p>
 
 {/* V26: Client Profiles (Search GMG tab only) */}
 {activeTab === 'ask' && (
 <>
 <div className="client-profiles-toggle">
 <button onClick={() => setShowClientProfiles(!showClientProfiles)}>
 {showClientProfiles ? 'Hide' : 'Show'} Client Directory ({CLIENT_PROFILES.length} clients)
 </button>
 </div>
 
 {showClientProfiles && (
 <div className="client-profiles-grid">
 {CLIENT_PROFILES.map(client => (
 <div 
 key={client.id} 
 className={`client-card status-${client.status.toLowerCase().includes('pillar') ? 'pillar' : client.status.toLowerCase().includes('active') ? 'active' : client.status.toLowerCase().includes('prospect') ? 'prospect' : 'reference'}`}
 >
 <div className="client-card-header">
 <h4>{client.name}</h4>
 <span className="client-status-badge">{client.status}</span>
 </div>
 <div className="client-card-body">
 <p><strong>Focus:</strong> {client.focus}</p>
 <p><strong>Since:</strong> {client.since}</p>
 {client.contacts.length > 0 && (
 <div className="client-contacts">
 <strong>Contacts:</strong>
 {client.contacts.map((c, i) => (
 <span key={i} className="contact-chip">{c.name} ({c.role})</span>
 ))}
 </div>
 )}
 {client.notes && <p className="client-notes">{client.notes}</p>}
 </div>
 </div>
 ))}
 </div>
 )}
 </>
 )}
 </div>
 )}
 
 {/* V29: CLIENT PREP TAB CONTENT */}
 {activeTab === 'prep' && (
 <div className="input-card prep-tab">
 {/* V31: Chat-style header with personas */}
 <div className="prep-chat-header">
 <div className="prep-personas">
 <div className="avatar-with-label">
 <img src={IMAGES.claudette} alt="Claudette" className="prep-avatar" />
 <span className="admin-label">Brandon's Admin</span><span style={{ fontSize: '10px', color: isDarkMode ? DARK_COLORS.textSecondary : COLORS.copper, fontWeight: '600', marginLeft: '4px' }}>Claudette</span>
 </div>
 <div className="avatar-with-label">
 <img src={IMAGES.chanet} alt="Chanet" className="prep-avatar" />
 <span className="admin-label">Eric's Admin</span><span style={{ fontSize: '10px', color: isDarkMode ? DARK_COLORS.textSecondary : COLORS.copper, fontWeight: '600', marginLeft: '4px' }}>Chanet</span>
 </div>
 </div>
 <div className="prep-chat-title">Client Meeting Preparation</div>
 </div>
 
 {/* Chat Messages Area */}
 <div className="prep-chat-messages">
 {/* Initial greeting with Competition for Affection */}
 {!prepState.briefing && prepState.messages.length === 0 && (
 <>
 <div className="chat-message">
 <img src={IMAGES.claudette} className="chat-avatar" alt="Claudette" />
 <div className="chat-bubble">
 <div className="chat-name">Claudette <span className="typing-label">Sr. Virtual Executive Admin</span></div>
 <div className="chat-text">Ready for client prep! I'll handle the strategic talking points. Enter your client name and materials below.</div>
 </div>
 </div>
 <div className="chat-message">
 <img src={IMAGES.chanet} className="chat-avatar" alt="Chanet" />
 <div className="chat-bubble">
 <div className="chat-name">Chanet <span className="typing-label">Sr. Virtual Executive Admin</span></div>
 <div className="chat-text">And I'll make sure we capture every key relationship and history detail. Between us, you'll be the most prepared person in any meeting!</div>
 </div>
 </div>
 </>
 )}
 
 {/* Processing messages with personality */}
 {prepState.isProcessing && (
 <>
 <div className="chat-message typing">
 <img src={IMAGES.claudette} className="chat-avatar active-glow" alt="Claudette" />
 <div className="chat-bubble">
 <div className="chat-name">Claudette <span className="typing-label">is typing</span></div>
 <div className="chat-text">
 <span className="typing-dots"><span>.</span><span>.</span><span>.</span></span>
 </div>
 </div>
 </div>
 <div className="chat-message">
 <img src={IMAGES.chanet} className="chat-avatar" alt="Chanet" />
 <div className="chat-bubble">
 <div className="chat-name">Chanet</div>
 <div className="chat-text">She's pulling the strategic angles. I'm gathering the relationship context...</div>
 </div>
 </div>
 </>
 )}
 
 {/* Success message after briefing with personality */}
 {prepState.briefing && (
 <>
 <div className="chat-message">
 <img src={IMAGES.claudette} className="chat-avatar" alt="Claudette" />
 <div className="chat-bubble">
 <div className="chat-name">Claudette</div>
 <div className="chat-text">Done! Briefing for {prepState.clientName} is complete. Quality verified, zero em dashes, copy-paste ready.</div>
 </div>
 </div>
 <div className="chat-message">
 <img src={IMAGES.chanet} className="chat-avatar" alt="Chanet" />
 <div className="chat-bubble">
 <div className="chat-name">Chanet</div>
 <div className="chat-text">Great teamwork! Your briefing is below. You're going to crush this meeting!</div>
 </div>
 </div>
 </>
 )}
 </div>
 
 {/* Input Form */}
 <div className="prep-form">
 <div className="prep-field-row">
 <div className="prep-field">
 <label>Client Name</label>
 <input
 type="text"
 value={prepState.clientName}
 onChange={(e) => setPrepState(prev => ({ ...prev, clientName: e.target.value }))}
 placeholder="e.g., KOPP Foundation, Trey Flowers Foundation..."
 className="prep-input"
 />
 </div>
 </div>
 
 <div className="prep-field">
 <label>Paste All Materials</label>
 <textarea
 value={prepState.materials}
 onChange={(e) => setPrepState(prev => ({ ...prev, materials: e.target.value }))}
 placeholder="Paste everything you have: emails, call notes, research, previous proposals, meeting notes, etc. The more context, the better the briefing."
 className="prep-textarea"
 rows={8}
 />
 </div>
 
 <button
 className="prep-generate-btn"
 onClick={async () => {
 if (!prepState.clientName || !prepState.materials) {
 showToast('Please enter client name and paste materials', 'error');
 return;
 }
 
 setPrepState(prev => ({ ...prev, isProcessing: true }));
 
 // V31: Start roleplay while processing
 startRoleplay('create', setPrepState);
 
 // Find matching client profile for context
 const clientLower = prepState.clientName.toLowerCase();
 const clientProfile = CLIENT_PROFILES.find(c => 
 clientLower.includes(c.name.toLowerCase().split(' ')[0]) ||
 c.name.toLowerCase().includes(clientLower.split(' ')[0])
 );
 
 // V37.5: Use Claude API to actually analyze the materials
 const aiResult = await generateClientBriefingWithAI(
 prepState.clientName, 
 prepState.materials, 
 clientProfile
 );
 
 let briefing;
 if (aiResult.success) {
 briefing = aiResult.briefing;
 } else {
 // Fallback to basic template if API fails
 briefing = `CLIENT BRIEFING: ${prepState.clientName.toUpperCase()}\n\n`;
 briefing += `Prepared for: GMG Team Meeting\n`;
 briefing += `Date: ${new Date().toLocaleDateString('en-US', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })}\n\n`;
 briefing += `${'='.repeat(50)}\n\n`;
 briefing += `API Error: ${aiResult.error}\n\n`;
 briefing += `Materials Provided: ${prepState.materials.length} characters\n`;
 briefing += `Please try again or contact support.\n`;
 }
 
 stopRoleplay();
 setPrepState(prev => ({ 
 ...prev, 
 briefing: briefing,
 isProcessing: false,
 history: [...prev.history, { clientName: prepState.clientName, date: new Date().toISOString(), briefing }]
 }));
 showToast(aiResult.success ? 'AI Briefing generated!' : 'Briefing generated with errors', aiResult.success ? 'success' : 'warning');
 }}
 disabled={prepState.isProcessing || !prepState.clientName || !prepState.materials}
 >
 {prepState.isProcessing ? 'Generating Briefing...' : 'Generate Client Briefing'}
 </button>
 
 {/* V37: Pitch Deck Generator Button */}
 <button
 className="prep-generate-btn"
 style={{ marginTop: '10px', background: 'linear-gradient(135deg, #B87333 0%, #D4A76A 100%)' }}
 onClick={async () => {
 if (!prepState.clientName) {
 showToast('Please enter client name', 'error');
 return;
 }
 
 setPitchDeckState(prev => ({ 
 ...prev, 
 clientName: prepState.clientName,
 clientDescription: prepState.materials,
 isGenerating: true 
 }));
 
 showToast('Generating pitch deck with Claude API...', 'info');
 
 const result = await generatePitchDeckHTML(prepState.clientName, prepState.materials);
 
 if (result.success) {
 setPitchDeckState(prev => ({
 ...prev,
 generatedHTML: result.html,
 isGenerating: false,
 showPreview: true
 }));
 showToast('Pitch deck generated!', 'success');
 } else {
 setPitchDeckState(prev => ({ ...prev, isGenerating: false }));
 showToast('Failed to generate: ' + result.error, 'error');
 }
 }}
 disabled={pitchDeckState.isGenerating || !prepState.clientName}
 >
 {pitchDeckState.isGenerating ? 'Generating Pitch Deck...' : 'Generate HTML Pitch Deck'}
 </button>
 </div>
 
 {/* Generated Briefing Display */}
 {prepState.briefing && (
 <div className="prep-briefing">
 <div className="prep-briefing-header">
 <h4>Generated Briefing</h4>
 <div className="prep-briefing-actions">
 <button
 onClick={() => {
 navigator.clipboard.writeText(prepState.briefing);
 showToast('Briefing copied to clipboard!', 'success');
 }}
 className="copy-btn"
 >
 Copy Briefing
 </button>
 <button
 onClick={() => setPrepState(prev => ({ ...prev, briefing: null }))}
 className="clear-btn"
 >
 Clear
 </button>
 </div>
 </div>
 <div className="prep-briefing-content">
 <pre>{prepState.briefing}</pre>
 </div>
 </div>
 )}
 </div>
 )}
 
 {/* V27: CLIENT ACQUISITION TAB CONTENT */}
 {activeTab === 'acquire' && (
 <div className="input-card acquire-tab">
 {!acquireUnlocked ? (
 // Password Gate
 <div className="password-gate">
 <div className="password-icon"></div>
 <h3>Internal Access Only</h3>
 <p>This tool is for GMG team members only. Enter the password to continue.</p>
 <div className="password-input-group">
 <input
 type="password"
 value={passwordAttempt}
 onChange={(e) => setPasswordAttempt(e.target.value)}
 onKeyPress={(e) => e.key === 'Enter' && handlePasswordSubmit()}
 placeholder="Enter password..."
 className="password-input"
 autoFocus
 />
 <button onClick={handlePasswordSubmit} className="password-submit">
 Unlock
 </button>
 </div>
 </div>
 ) : (
 // Chat Interface
 <div className="acquire-chat-container">
 {/* Chat Messages */}
 <div className="acquire-chat-messages" ref={acquireChatRef}>
 {acquireState.messages.map((msg, idx) => (
 <div key={idx} className={`acquire-message ${msg.role} ${msg.isTyping ? 'typing' : ''}`}>
 {/* V2.3: Avatar for assistant messages - left side */}
 {msg.role === 'assistant' && msg.personaInfo && msg.persona !== 'competition' && (
  <img 
  src={msg.personaInfo.avatar} 
  alt={msg.personaInfo.name}
  className="acquire-persona-avatar"
  />
 )}
 {/* V2.3: Avatar for user messages - right side (after bubble due to flex-direction) */}
 {msg.role === 'user' && currentUser?.photoURL && (
  <img 
  src={currentUser.photoURL} 
  alt="You"
  className="acquire-persona-avatar"
  />
 )}
 {msg.role === 'user' && !currentUser?.photoURL && (
  <div className="acquire-persona-avatar" style={{ 
  background: 'linear-gradient(135deg, #8B5CF6, #7C3AED)', 
  display: 'flex', 
  alignItems: 'center', 
  justifyContent: 'center',
  color: 'white',
  fontWeight: '600',
  fontSize: '14px'
  }}>
  {currentUser?.displayName?.charAt(0)?.toUpperCase() || 'U'}
  </div>
 )}
 <div className="acquire-message-content">
  {msg.role === 'assistant' && msg.personaInfo && (
  <div className="acquire-persona-name" style={{ marginBottom: '2px' }}>
   {msg.persona === 'competition' ? 'Chanet & Claudette' : msg.personaInfo.name}
   {acquireInteractionCount >= 15 && msg.persona === 'competition' && (
   <span className="tier-badge tier-4" style={{ marginLeft: '6px' }}>Tier 4</span>
   )}
  </div>
  )}
  {msg.isTyping ? (
  <div className="typing-indicator">
   <span></span>
   <span></span>
   <span></span>
  </div>
  ) : (
  <div className="message-text">
  {(msg.content || '').split('\n').map((line, i) => {
   if (!line.trim()) return <div key={i} style={{ height: '6px' }} />;
   if (line.trim() === '---') return <hr key={i} />;
   if (line.startsWith('```')) return null;
   // Bold label with value: **Label:** Value
   if (line.startsWith('**') && line.includes(':**')) {
   const colonIdx = line.indexOf(':**');
   const label = line.substring(2, colonIdx);
   const value = line.substring(colonIdx + 3).replace(/\*\*/g, '');
 return <div key={i} className="field-row"><strong>{label}:</strong> {value}</div>;
 }
 // Pure bold line
 if (line.startsWith('**') && line.endsWith('**')) {
 return <div key={i} className="bold-line">{line.replace(/\*\*/g, '')}</div>;
 }
 // V3.7: Handle inline bold and strip other markdown
 let processedLine = line
 .replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>')
 .replace(/\*([^*]+)\*/g, '<em>$1</em>')
 .replace(/#{1,6}\s*/g, '')
 .replace(/`([^`]+)`/g, '$1');
 
 // If line has HTML tags from our processing, use dangerouslySetInnerHTML
 if (processedLine.includes('<strong>') || processedLine.includes('<em>')) {
 return <div key={i} dangerouslySetInnerHTML={{ __html: processedLine }} />;
 }
 // Regular line
 return <div key={i}>{processedLine}</div>;
 })}
 </div>
 )}
 </div>
 {/* Copy buttons for cover letter and spreadsheet */}
 {msg.role === 'assistant' && !msg.isTyping && msg.content?.includes('cover letter') && acquireState.coverLetter && (
 <div className="acquire-message-actions">
 <button 
 onClick={() => {
 navigator.clipboard.writeText(acquireState.coverLetter);
 showToast('Cover letter copied!', 'success');
 }}
 className="copy-btn"
 >
 Copy Cover Letter
 </button>
 <button 
 onClick={() => handleDownloadPDF(acquireState.coverLetter, 'cover-letter')}
 className="pdf-btn"
 >
 Download PDF
 </button>
 <button 
 onClick={() => handleDownloadDocx(acquireState.coverLetter, 'cover-letter')}
 className="pdf-btn"
 style={{ background: '#2563eb' }}
 >
 Download DOCX
 </button>
 {/* V4.6: Direct mailto button for email applications */}
 {acquireState.currentJob?.employerMailto && (
 <a
 href={acquireState.currentJob.employerMailto}
 target="_blank"
 rel="noopener noreferrer"
 className="email-btn"
 style={{
  display: 'inline-block',
  padding: '8px 16px',
  background: '#16a34a',
  color: 'white',
  borderRadius: '6px',
  textDecoration: 'none',
  fontWeight: 600,
  fontSize: '14px'
 }}
 onClick={(e) => {
  // Copy to clipboard as fallback
  navigator.clipboard.writeText(acquireState.currentJob.employerMailto);
  showToast('Email client opening... Link also copied!', 'success');
 }}
 >
 Send Application Email
 </a>
 )}
 {/* V5.8: Fallback email button - always visible when no mailto link */}
 {!acquireState.currentJob?.employerMailto && acquireState.coverLetter && (
 <button
 onClick={() => {
  const profile = acquireState.applicant === 'gmg_flip' 
  ? { name: 'Global Majority Group', email: 'brandon@globalmajoritygroup.com', phone: '336-549-9608' }
  : APPLICANT_PROFILES[acquireState.applicant] || APPLICANT_PROFILES.brandon;
  const job = acquireState.currentJob || {};
  const subject = encodeURIComponent(`Application for ${job.title || 'Position'} - ${profile.name}`);
  const body = encodeURIComponent(`Dear ${job.addressee || 'Hiring Manager'},\n\nPlease find below my application for the ${job.title || 'position'} role.\n\n${acquireState.coverLetter}\n\nThank you for your consideration.\n\n${profile.name}\n${profile.email}\n${profile.phone || ''}`);
  const recipient = job.applicationEmail || '';
  window.location.href = `mailto:${recipient}?subject=${subject}&body=${body}`;
  showToast(recipient ? `Opening email to ${recipient}` : 'Opening email client - add recipient address', 'success');
 }}
 style={{
  padding: '8px 16px',
  background: acquireState.currentJob?.applicationEmail ? '#16a34a' : '#6c757d',
  color: 'white',
  border: 'none',
  borderRadius: '6px',
  fontWeight: 600,
  fontSize: '14px',
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'center',
  gap: '6px'
 }}
 title={acquireState.currentJob?.applicationEmail 
  ? `Send application to ${acquireState.currentJob.applicationEmail}` 
  : 'Opens email client - you will need to add recipient address'}
 >
 {acquireState.currentJob?.applicationEmail 
  ? `Email to ${acquireState.currentJob.applicationEmail}`
  : 'Generate Application Email'}
 </button>
 )}
 {/* V33: Auto-generate email if job requires email apply */}
 {acquireState.currentJob?.howToApply?.toLowerCase().includes('email') && !acquireState.applicationEmail && (
 <button 
 onClick={() => setAcquireState(prev => ({ ...prev, input: 'generate application email' }))}
 className="copy-btn"
 style={{ background: COLORS.success }}
 >
 Generate Email (Email Apply)
 </button>
 )}
 <span className="char-count">
 {acquireState.coverLetter.length} chars
 <span className={`page-indicator ${acquireState.coverLetter.length < 2000 ? 'short' : acquireState.coverLetter.length < 3000 ? 'good' : 'long'}`}>
 ~{Math.ceil(acquireState.coverLetter.length / 3000)} pg
 </span>
 </span>
 </div>
 )}
 {msg.role === 'assistant' && msg.content?.includes('Spreadsheet Row') && acquireState.spreadsheetRow && (
 <div className="acquire-message-actions">
 <button 
 onClick={() => {
 navigator.clipboard.writeText(acquireState.spreadsheetRow);
 showToast('Spreadsheet row copied!', 'success');
 }}
 className="copy-btn"
 >
 Copy Spreadsheet Row
 </button>
 </div>
 )}
 {msg.role === 'assistant' && acquireState.applicationEmail && msg.content?.includes('application email') && (
 <div className="acquire-message-actions">
 <button 
 onClick={() => {
 navigator.clipboard.writeText(acquireState.applicationEmail);
 showToast('Application email copied!', 'success');
 }}
 className="copy-btn"
 >
 Copy Email
 </button>
 </div>
 )}
 {/* Forward email button - shows for any cover letter */}
 {msg.role === 'assistant' && acquireState.forwardEmail && (msg.content?.includes('Cover Letter') || msg.content?.includes('cover letter') || msg.content?.includes('email this to')) && (
 <div className="acquire-message-actions" style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
 <a 
 href={acquireState.forwardEmail.link}
 target="_blank"
 rel="noopener noreferrer"
 className="email-btn"
 style={{
 display: 'inline-block',
 padding: '8px 16px',
 background: '#191970',
 color: 'white',
 borderRadius: '6px',
 textDecoration: 'none',
 fontWeight: 500
 }}
 onClick={(e) => {
 // In artifacts, mailto may not work - copy as fallback
 navigator.clipboard.writeText(acquireState.forwardEmail.link);
 }}
 >
 Email to {acquireState.forwardEmail.targetName}
 </a>
 <button
 onClick={() => {
 navigator.clipboard.writeText(acquireState.forwardEmail.link);
 showToast('Email link copied! Paste in browser to open email client.', 'success');
 }}
 style={{
 padding: '8px 16px',
 background: '#B87333',
 color: 'white',
 border: 'none',
 borderRadius: '6px',
 cursor: 'pointer',
 fontWeight: 500
 }}
 >
 Copy Email Link
 </button>
 </div>
 )}
 {/* V4.6: Employer Email Apply Button - shows when job requires email application */}
 {msg.role === 'assistant' && acquireState.currentJob?.employerMailto && (msg.content?.includes('EMAIL APPLICATION') || msg.content?.includes('COVER LETTER')) && (
 <div className="acquire-message-actions" style={{ display: 'flex', gap: '8px', flexWrap: 'wrap', marginTop: '8px' }}>
 <a 
  href={acquireState.currentJob.employerMailto}
  target="_blank"
  rel="noopener noreferrer"
  style={{
  display: 'inline-flex',
  alignItems: 'center',
  gap: '8px',
  padding: '12px 20px',
  background: 'linear-gradient(135deg, #28a745, #20c997)',
  color: 'white',
  borderRadius: '8px',
  textDecoration: 'none',
  fontWeight: 600,
  fontSize: '14px',
  boxShadow: '0 4px 12px rgba(40, 167, 69, 0.3)'
  }}
  onClick={() => {
  showToast('Opening email client... Attach your resume and cover letter!', 'success');
  }}
 >
  Send Application Email to {acquireState.currentJob.employerEmail || 'Employer'}
 </a>
 <button
  onClick={() => {
  navigator.clipboard.writeText(acquireState.currentJob.employerMailto);
  showToast('Mailto link copied! Paste in browser if email client didn\'t open.', 'success');
  }}
  style={{
  padding: '12px 16px',
  background: '#6c757d',
  color: 'white',
  border: 'none',
  borderRadius: '8px',
  cursor: 'pointer',
  fontWeight: 500
  }}
 >
  Copy Link
 </button>
 </div>
 )}
 {/* V2.1: Download Buttons - shows for any cover letter */}
 {msg.role === 'assistant' && acquireState.lastCoverLetter && (msg.content?.includes('COVER LETTER') || msg.content?.includes('cover letter')) && (
 <div className="acquire-message-actions" style={{ display: 'flex', gap: '8px', flexWrap: 'wrap', marginTop: '12px', paddingTop: '12px', borderTop: '1px solid rgba(0,0,0,0.1)' }}>
 <button
  onClick={() => handleDownloadPDF(acquireState.lastCoverLetter, 'cover-letter')}
  style={{
  display: 'inline-flex',
  alignItems: 'center',
  gap: '6px',
  padding: '10px 16px',
  background: 'linear-gradient(135deg, #dc3545, #c82333)',
  color: 'white',
  border: 'none',
  borderRadius: '8px',
  cursor: 'pointer',
  fontWeight: 600,
  fontSize: '13px'
  }}
 >
  PDF Download
 </button>
 <button
  onClick={() => handleDownloadDocx(acquireState.lastCoverLetter, 'cover-letter')}
  style={{
  display: 'inline-flex',
  alignItems: 'center',
  gap: '6px',
  padding: '10px 16px',
  background: 'linear-gradient(135deg, #007bff, #0056b3)',
  color: 'white',
  border: 'none',
  borderRadius: '8px',
  cursor: 'pointer',
  fontWeight: 600,
  fontSize: '13px'
  }}
 >
  DOCX Download
 </button>
 {acquireState.currentJob?.applicationEmail && (
  <button
  onClick={() => openEmailClient(acquireState.currentJob, acquireState.lastCoverLetter, APPLICANT_PROFILES[acquireState.selectedApplicant])}
  style={{
  display: 'inline-flex',
  alignItems: 'center',
  gap: '6px',
  padding: '10px 16px',
  background: 'linear-gradient(135deg, #28a745, #20c997)',
  color: 'white',
  border: 'none',
  borderRadius: '8px',
  cursor: 'pointer',
  fontWeight: 600,
  fontSize: '13px'
  }}
  >
  Open Email Client
  </button>
 )}
 <button
  onClick={() => {
  navigator.clipboard.writeText(acquireState.lastCoverLetter);
  showToast('Cover letter copied to clipboard!', 'success');
  }}
  style={{
  padding: '10px 16px',
  background: isDarkMode ? '#2c2c2e' : '#f5f5f7',
  color: isDarkMode ? 'white' : '#1d1d1f',
  border: 'none',
  borderRadius: '8px',
  cursor: 'pointer',
  fontWeight: 500,
  fontSize: '13px'
  }}
 >
  Copy Text
 </button>
 </div>
 )}
 </div>
 ))}
 {acquireState.isProcessing && (
 <div className="acquire-message assistant">
 <div className="typing-indicator">
 <span></span><span></span><span></span>
 </div>
 </div>
 )}
 </div>
 
 {/* Chat Input */}
 <div className="acquire-chat-input">
 <textarea
 value={acquireState.input}
 onChange={(e) => setAcquireState(prev => ({ ...prev, input: e.target.value }))}
 onKeyPress={(e) => {
 if (e.key === 'Enter' && !e.shiftKey) {
 e.preventDefault();
 handleAcquireSubmit();
 }
 }}
 placeholder={acquireState.awaitingApplicant 
 ? "Type: Brandon, Eric, or BJ..." 
 : "Paste job description or ask a follow-up..."}
 rows={3}
 disabled={acquireState.isProcessing}
 />
 <button 
 onClick={handleAcquireSubmit}
 disabled={!acquireState.input.trim() || acquireState.isProcessing}
 className="acquire-send-btn"
 >
 {acquireState.isProcessing ? '...' : ''}
 </button>
 </div>
 
 {/* Quick Actions */}
 <div className="acquire-quick-actions">
 <button onClick={() => setAcquireState(prev => ({ ...prev, input: 'email' }))}>
 Email
 </button>
 <button onClick={() => setAcquireState(prev => ({ ...prev, input: 'thank you letter' }))}>
 Thank You
 </button>
 <button onClick={() => setAcquireState(prev => ({ ...prev, input: 'linkedin connect' }))}>
 LinkedIn
 </button>
 <button onClick={() => setAcquireState(prev => ({ ...prev, input: 'salary negotiation' }))}>
 Salary
 </button>
 <button onClick={() => setAcquireState(prev => ({ ...prev, input: 'switch applicant' }))}>
 Switch
 </button>
 <button onClick={() => {
 setAcquireState({
 messages: [generatePersonaMessage(
 "Fresh start! Who am I helping? Brandon, Eric, or BJ?",
 getAcquirePersona()
 )],
 input: '',
 selectedApplicant: null,
 currentJob: { organization: '', title: '', url: '', deadline: '', salary: '', howToApply: '', location: '', description: '', issues: '' },
 coverLetter: '',
 applicationEmail: '',
 spreadsheetRow: '',
 awaitingApplicant: true,
 isProcessing: false
 });
 }}>
 New
 </button>
 <button 
 onClick={() => setShowApplications(true)}
 style={{ background: COLORS.copper, color: 'white' }}
 >
 Track ({applications.length})
 </button>
 </div>
 
 {/* V33: Application History Panel */}
 {showAppHistory && (
 <div className="app-history-panel">
 <input
 type="text"
 placeholder="Search past applications..."
 value={appHistorySearch}
 onChange={(e) => setAppHistorySearch(e.target.value)}
 style={{ width: '100%', padding: '8px 12px', marginBottom: '12px', borderRadius: '8px', border: `1px solid ${COLORS.cardBorder}` }}
 />
 <div className="app-history-list">
 {searchApplications(appHistorySearch).slice(0, 10).map((app, idx) => (
 <div key={idx} className="app-history-item" onClick={() => {
 setAcquireState(prev => ({ ...prev, input: `Tell me about my application to ${app.organization}` }));
 setShowAppHistory(false);
 }}>
 <div className="app-history-org">{app.organization || 'Unknown Org'}</div>
 <div className="app-history-details">
 {app.title || 'Unknown Role'} | {app.applicant} | {new Date(app.timestamp).toLocaleDateString()}
 </div>
 </div>
 ))}
 {applicationHistory.length === 0 && <div style={{ color: COLORS.textBody, textAlign: 'center', padding: '20px' }}>No applications yet</div>}
 </div>
 </div>
 )}
 </div>
 )}
 </div>
 )}
 
 {/* V38.10: BRAINSTORMING CALLS TAB CONTENT */}
 {activeTab === 'brainstorm' && (
 <div className="input-card brainstorm-tab">
 {!brainstormUnlocked ? (
 // Password Gate
 <div className="password-gate">
 <div className="password-icon"></div>
 <h3>GMG Brainstorming Access</h3>
 <p>This tool processes internal GMG brainstorming transcripts. Enter the password to continue.</p>
 <div className="password-input-group">
 <input
 type="password"
 value={brainstormPassword}
 onChange={(e) => setBrainstormPassword(e.target.value)}
 onKeyPress={(e) => e.key === 'Enter' && handleBrainstormPasswordSubmit()}
 placeholder="Enter password..."
 className="password-input"
 autoFocus
 />
 <button onClick={handleBrainstormPasswordSubmit} className="password-submit">
 Unlock
 </button>
 </div>
 </div>
 ) : (
 // Brainstorm Interface
 <div className="brainstorm-container">
 <div className="brainstorm-header">
 <h3>Transcript Processor</h3>
 <p>Paste a transcript or upload a PDF. We'll categorize discussions into actionable outputs.</p>
 </div>
 
 {/* Memory Log */}
 {brainstormState.processedTranscripts.length > 0 && (
 <div className="brainstorm-memory-log">
 <strong>Processed Sessions ({brainstormState.processedTranscripts.length}):</strong>
 <div className="memory-log-list">
 {brainstormState.processedTranscripts.map((session, idx) => (
 <div key={idx} className="memory-log-item">
 {session.date} - {session.summary}
 </div>
 ))}
 </div>
 </div>
 )}
 
 {/* Transcript Input */}
 <div className="brainstorm-input-section">
 <textarea
 value={brainstormState.input}
 onChange={(e) => setBrainstormState(prev => ({ ...prev, input: e.target.value }))}
 placeholder="Paste your transcript here... or upload a PDF below"
 rows={10}
 className="brainstorm-textarea"
 />
 
 <div className="brainstorm-actions">
 <label className="brainstorm-file-upload">
Upload File
 <input
 type="file"
 accept=".pdf,.docx,.doc,.txt"
 onChange={async (e) => {
 const file = e.target.files?.[0];
 if (file) {
 // V4.7: Handle DOCX files using mammoth
 if (file.name.endsWith('.docx') || file.name.endsWith('.doc')) {
 showToast('Reading Word document...', 'info');
 try {
  const arrayBuffer = await file.arrayBuffer();
  const result = await mammoth.extractRawText({ arrayBuffer });
  const text = result.value;
  setBrainstormState(prev => ({
  ...prev,
  input: prev.input + '\n\n' + text
  }));
  showToast('Document text extracted!', 'success');
 } catch (docError) {
  devError('DOCX extraction error:', docError);
  showToast('Could not read Word document: ' + docError.message, 'error');
 }
 } else if (file.type === 'application/pdf') {
 showToast('Reading PDF content...', 'info');
 try {
 // Convert PDF to base64 and send to Claude for text extraction
 const arrayBuffer = await file.arrayBuffer();
 const base64 = btoa(String.fromCharCode.apply(null, new Uint8Array(arrayBuffer)));
 
 const extractResponse = await fetch('https://api.anthropic.com/v1/messages', {
 method: 'POST',
 headers: getApiHeaders(),
 body: JSON.stringify({
 model: MODEL_CONFIG.fast,
 max_tokens: 16000,
 messages: [{
 role: 'user',
 content: [
 {
 type: 'document',
 source: {
 type: 'base64',
 media_type: 'application/pdf',
 data: base64
 }
 },
 {
 type: 'text',
 text: 'Extract all the text content from this PDF transcript. Return ONLY the raw text, no commentary. Clean up obvious speech-to-text errors like "um", "uh", "you know" but preserve all substantive content.'
 }
 ]
 }]
 })
 });
 
 const data = await extractResponse.json();
 const extractedText = data.content?.[0]?.text || "";
 setBrainstormState(prev => ({ ...prev, input: extractedText }));
 showToast('PDF text extracted! Click Process to analyze.', 'success');
 } catch (err) {
 devError('PDF extraction error:', err);
 showToast('PDF extraction failed. Please paste text manually.', 'error');
 setBrainstormState(prev => ({ ...prev, input: '' }));
 }
 } else {
 const text = await file.text();
 setBrainstormState(prev => ({ ...prev, input: text }));
 }
 }
 }}
 style={{ display: 'none' }}
 />
 </label>
 
 <button
 className="brainstorm-process-btn"
 onClick={async () => {
 if (!brainstormState.input.trim()) {
 showToast('Please paste a transcript or upload a file first', 'error');
 return;
 }
 
 setIsProcessing(true);
 showToast('Processing transcript...', 'info');
 
 try {
 const result = await processTranscript(brainstormState.input);
 
 if (result.error) {
 showToast('Error: ' + result.error, 'error');
 } else {
 // Store outputs
 setBrainstormState(prev => ({
 ...prev,
 outputFiles: result.categories || [],
 processedTranscripts: [
 ...prev.processedTranscripts,
 { date: new Date().toLocaleDateString(), summary: result.summary || 'Session processed' }
 ],
 input: ''
 }));
 showToast('Transcript processed! Download your files below.', 'success');
 }
 } catch (err) {
 showToast('Processing failed: ' + err.message, 'error');
 }
 
 setIsProcessing(false);
 }}
 disabled={isProcessing || !brainstormState.input.trim()}
 >
 {isProcessing ? 'Processing...' : 'Process Transcript'}
 </button>
 </div>
 </div>
 
 {/* Output Files */}
 {brainstormState.outputFiles.length > 0 && (
 <div className="brainstorm-outputs">
 <h4>Generated Files</h4>
 <div className="output-files-grid">
 {brainstormState.outputFiles.map((file, idx) => (
 <div key={idx} className="output-file-card">
 <div className="output-file-name">{file.name}</div>
 <div className="output-file-preview">{(file.content || '').substring(0, 200)}...</div>
 <button
 className="output-download-btn"
 onClick={() => {
 const blob = new Blob([file.content], { type: 'text/markdown' });
 const url = URL.createObjectURL(blob);
 const a = document.createElement('a');
 a.href = url;
 a.download = file.filename || 'output.md';
 a.click();
 URL.revokeObjectURL(url);
 }}
 >
 Download Download .md
 </button>
 </div>
 ))}
 </div>
 </div>
 )}
 </div>
 )}
 </div>
 )}
 
 {/* Loading */}
 {isProcessing && (
 <div className="loading">
 <div className="loading-spinner"></div>
 </div>
 )}
 
 {/* AI CHECK RESULTS */}
 {activeTab === 'check' && checkState.result && !isProcessing && (
 <>
 {/* Result Header */}
 <div className="result-header">
 <div className="result-status">
 <span className={`status-badge ${checkState.result.status === 'approved' ? 'status-approved' : 'status-needs-work'}`}>
 {checkState.result.status === 'approved' ? 'Approved' : 'Needs Work'}
 </span>
 <span className="issue-count">
 {checkState.result.issues.length} issue{checkState.result.issues.length !== 1 ? 's' : ''} found
 </span>
 </div>
 <div className="result-actions">
 <button className="action-btn" onClick={handleCopy}>Copy</button>
 <button 
 className="export-btn" 
 onClick={() => exportAsDocx(checkState.result.corrected, `gmg-checked-${Date.now()}`)}
 >
 Export (.docx)
 </button>
 <button className="action-btn" onClick={handleSave}>Save</button>
 <button className="action-btn" onClick={() => speakText(checkState.result.corrected)}>Read</button>
 </div>
 </div>
 
 {/* V25: Diff View Toggle */}
 <div className="diff-toggle">
 <button 
 className={diffViewMode === 'side-by-side' ? 'active' : ''}
 onClick={() => setDiffViewMode('side-by-side')}
 >
 Side by Side
 </button>
 <button 
 className={diffViewMode === 'diff' ? 'active' : ''}
 onClick={() => setDiffViewMode('diff')}
 >
 See Inline Changes View
 </button>
 </div>
 
 {/* Side by Side or Diff View */}
 {diffViewMode === 'side-by-side' ? (
 <div className="side-by-side">
 <div className="side-panel side-panel-original">
 <div className="side-panel-header">ORIGINAL</div>
 <div className="side-panel-content">{checkState.result.original}</div>
 </div>
 <div className="side-panel side-panel-corrected">
 <div className="side-panel-header">CORRECTED (Live Preview)</div>
 <div className="side-panel-content">
 {checkState.result.corrected || generateCorrectedVersion(
 checkState.result.original, 
 checkState.trackedChanges.filter(c => c.accepted)
 )}
 </div>
 </div>
 </div>
 ) : (
 <div className="diff-view">
 {generateSimpleDiff(checkState.result.original, checkState.result.corrected).map((part, idx) => (
 <span 
 key={idx}
 className={part.type === 'removed' ? 'diff-removed' : part.type === 'added' ? 'diff-added' : ''}
 >
 {part.text}{' '}
 </span>
 ))}
 </div>
 )}
 
 {/* V4.7: Split View for AI Check - Original vs Corrected side by side */}
 {checkState.showSplitView && checkState.result && (
 <div style={{
 display: 'grid',
 gridTemplateColumns: '1fr 1fr',
 gap: '16px',
 marginBottom: '20px',
 maxHeight: '400px'
 }}>
 {/* Original Column */}
 <div style={{
 background: isDarkMode ? DARK_COLORS.cardBg : '#fff5f5',
 border: `2px solid ${isDarkMode ? DARK_COLORS.border : '#dc3545'}`,
 borderRadius: '12px',
 padding: '16px',
 overflow: 'auto'
 }}>
 <div style={{ 
 fontWeight: '700', 
 color: '#dc3545', 
 marginBottom: '12px',
 display: 'flex',
 alignItems: 'center',
 gap: '8px'
 }}>
 X Original ({checkState.trackedChanges.length} issues)
 </div>
 <div style={{ 
 whiteSpace: 'pre-wrap', 
 fontSize: '14px', 
 lineHeight: '1.6',
 color: isDarkMode ? DARK_COLORS.textPrimary : '#333'
 }}>
 {checkState.input}
 </div>
 </div>
 
 {/* Corrected Column */}
 <div style={{
 background: isDarkMode ? DARK_COLORS.cardBg : '#f0fff4',
 border: `2px solid ${isDarkMode ? DARK_COLORS.border : '#28a745'}`,
 borderRadius: '12px',
 padding: '16px',
 overflow: 'auto'
 }}>
 <div style={{ 
 fontWeight: '700', 
 color: '#28a745', 
 marginBottom: '12px',
 display: 'flex',
 alignItems: 'center',
 gap: '8px'
 }}>
 OK Corrected (Brandon's Voice)
 </div>
 <div style={{ 
 whiteSpace: 'pre-wrap', 
 fontSize: '14px', 
 lineHeight: '1.6',
 color: isDarkMode ? DARK_COLORS.textPrimary : '#333'
 }}>
 {checkState.result?.corrected || editedOutput || 'No corrections needed'}
 </div>
 </div>
 </div>
 )}
 
 {/* Tracked Changes */}
 {checkState.trackedChanges.length > 0 && (
 <div className="tracked-changes">
 <div className="tracked-header">
 <span className="tracked-title">
 Changes ({checkState.trackedChanges.filter(c => c.accepted).length}/{checkState.trackedChanges.length} selected)
 </span>
 <div className="tracked-actions">
 <button className="btn-accept-all" onClick={acceptAll}>Accept All</button>
 <button className="btn-reject-all" onClick={rejectAll}>Reject All</button>
 <button className="btn-apply" onClick={applyChanges}>Apply</button>
 </div>
 </div>
 <div className="tracked-list">
 {checkState.trackedChanges.map(change => (
 <div key={change.id} className={`tracked-item ${!change.accepted ? 'rejected' : ''}`}>
 <input
 type="checkbox"
 className="tracked-checkbox"
 checked={change.accepted}
 onChange={() => toggleChange(change.id)}
 />
 <div className="tracked-content">
 <span className={`tracked-severity severity-${change.severity}`}>
 {change.severity}
 </span>
 <span style={{ fontSize: '13px', color: COLORS.textBody }}>
 {change.type}: {change.message}
 </span>
 <div className="tracked-change">
 <span className="tracked-original">"{change.original}"</span>
 <span className="tracked-arrow"></span>
 <span className="tracked-replacement">"{change.replacement}"</span>
 </div>
 </div>
 </div>
 ))}
 </div>
 </div>
 )}
 </>
 )}
 
 {/* CREATE/ASK RESULTS */}
 {(activeTab === 'create' || activeTab === 'ask') && currentState.result && !isProcessing && (
 <>
 <div className="result-header">
 <div className="result-status">
 <span className="status-badge status-approved">Complete</span>
 {/* V29: Detect if result is HTML (pitch deck) */}
 {currentState.result.content && currentState.result.content.includes('<!DOCTYPE html') && (
 <span className="status-badge" style={{ background: '#B87333', color: 'white', marginLeft: '8px' }}>HTML Pitch Deck</span>
 )}
 </div>
 <div className="result-actions">
 <button className="action-btn" onClick={handleCopy}>Copy</button>
 
 {/* V29: Download HTML button for pitch decks */}
 {currentState.result.content && currentState.result.content.includes('<!DOCTYPE html') && (
 <>
 <button 
 className="export-btn" 
 style={{ background: 'linear-gradient(135deg, #B87333, #D4A574)', color: 'white', border: 'none' }}
 onClick={() => {
 const blob = new Blob([currentState.result.content], { type: 'text/html' });
 const url = URL.createObjectURL(blob);
 const a = document.createElement('a');
 a.href = url;
 a.download = `GMG_PitchDeck_${Date.now()}.html`;
 document.body.appendChild(a);
 a.click();
 document.body.removeChild(a);
 URL.revokeObjectURL(url);
 showToast('HTML downloaded!', 'success');
 }}
 >
 Download HTML
 </button>
 <button 
 className="action-btn"
 style={{ background: '#191970', color: 'white' }}
 onClick={() => setShowPitchPreview(true)}
 >
 Preview
 </button>
 </>
 )}
 
 <button 
 className="export-btn" 
 onClick={() => exportAsDocx(
 currentState.result.content, 
 `gmg-${activeTab}-${Date.now()}`
 )}
 >
 Export (.docx)
 </button>
 <button className="action-btn" onClick={handleSave}>Save</button>
 <button className="action-btn" onClick={() => speakText(currentState.result.content)}>Read</button>
 </div>
 </div>
 <div 
 className="result-content"
 onDoubleClick={() => {
 navigator.clipboard.writeText(stripMarkdown(currentState.result.content));
 showToast('Copied to clipboard!', 'success');
 }}
 title="Double-click to copy"
 style={{ cursor: 'pointer' }}
 >
 {currentState.result.content}
 </div>
 
 {/* Follow-up section for Ask GMG */}
 {activeTab === 'ask' && (
 <div className="follow-up-section">
 <div className="follow-up-label">Ask a follow-up question:</div>
 <div className="follow-up-row">
 <input 
 type="text"
 value={askState.followUp}
 onChange={(e) => setAskState(prev => ({ ...prev, followUp: e.target.value }))}
 placeholder="Ask something related..."
 className="follow-up-input"
 onKeyPress={(e) => e.key === 'Enter' && handleFollowUp()}
 />
 <button onClick={handleFollowUp} className="follow-up-btn">
 Ask Follow-up
 </button>
 </div>
 <button onClick={handleNewQuestion} className="new-question-btn">
 New Topic
 </button>
 </div>
 )}
 </>
 )}
 </div>
 </div>
 </div>
 
 {/* Result Delivery Popup */}
 {/* V2.1: Tier Selector Bottom Sheet */}
 {showTierSelector && (
 <div className="tier-selector-overlay" onClick={() => setShowTierSelector(false)} style={{
 position: 'fixed',
 top: 0,
 left: 0,
 right: 0,
 bottom: 0,
 background: 'rgba(0,0,0,0.5)',
 zIndex: 10000,
 display: 'flex',
 alignItems: 'flex-end',
 justifyContent: 'center'
 }}>
 <div onClick={(e) => e.stopPropagation()} style={{
 width: '100%',
 maxWidth: '500px',
 background: isDarkMode ? '#1c1c1e' : 'white',
 borderTopLeftRadius: '20px',
 borderTopRightRadius: '20px',
 padding: '20px',
 paddingBottom: '40px'
 }}>
 <div style={{ 
 textAlign: 'center', 
 marginBottom: '20px',
 fontWeight: '600',
 fontSize: '18px',
 color: isDarkMode ? 'white' : '#1d1d1f'
 }}>
 How should I handle this?
 </div>
 
 {Object.entries(REWRITE_TIERS).map(([key, tier]) => (
 <button
 key={key}
 onClick={async () => {
  setSelectedTier(key);
  setShowTierSelector(false);
  // Complete the pending check with selected tier
  if (pendingContent) {
  const { inputText, checkResult, issueSummary } = pendingContent;
  
  // Get rewrite with selected tier
  const rewriteResult = await rewriteInBrandonVoice(inputText, checkResult.issues, key);
  const corrected = rewriteResult?.content || inputText;
  
  // Build delivery message
  let deliveryMsg = key === 'D' 
  ? `Found ${checkResult.issues.length} issue(s). No changes made (Flag Only mode).`
  : `Found ${checkResult.issues.length} issue(s). Rewritten using Tier ${key}.`;
  
  setCheckState(prev => ({
  ...prev,
  result: {
  status: checkResult.status,
  issues: checkResult.issues,
  original: inputText,
  corrected: corrected,
  delivery: deliveryMsg,
  tierUsed: key,
  factCheckRan: checkResult.factCheckRan,
  factErrorCount: checkResult.factErrorCount
  },
  trackedChanges: checkResult.issues
  }));
  
  // Show popup
  const delivery = getCheckDelivery(checkResult.issues.length);
  setPopupData({
  ...delivery,
  message: getRandomMessage(delivery.messages),
  summary: issueSummary,
  issueCount: checkResult.issues.length,
  type: 'check',
  tierUsed: key
  });
  setShowPopup(true);
  stopRoleplay();
  
  // V25: Add to history
  const newHistory = addHistoryEntry(historyLog, 'check', inputText, corrected);
  setHistoryLog(newHistory);
  saveHistory(newHistory);
  
  // V26: Track analytics
  updateAnalytics('check', checkResult.issues.length, checkResult.issues);
  
  setPendingContent(null);
  }
 }}
 style={{
 display: 'block',
 width: '100%',
 padding: '16px',
 marginBottom: '12px',
 background: isDarkMode ? '#2c2c2e' : '#f5f5f7',
 color: isDarkMode ? 'white' : '#1d1d1f',
 border: key === 'A' ? '2px solid #007AFF' : 'none',
 borderRadius: '12px',
 textAlign: 'left',
 cursor: 'pointer'
 }}
 >
 <div style={{ fontWeight: '600', marginBottom: '4px', display: 'flex', alignItems: 'center', gap: '8px' }}>
 <span style={{ 
  background: key === 'A' ? '#007AFF' : key === 'B' ? '#28a745' : key === 'C' ? '#ffc107' : '#6c757d',
  color: 'white',
  padding: '2px 8px',
  borderRadius: '4px',
  fontSize: '12px'
 }}>{key}</span>
 {tier.name}
 </div>
 <div style={{ fontSize: '13px', opacity: 0.7 }}>
 {tier.description}
 </div>
 </button>
 ))}
 
 <button
 onClick={() => {
 setShowTierSelector(false);
 setPendingContent(null);
 stopRoleplay();
 }}
 style={{
 width: '100%',
 padding: '14px',
 marginTop: '8px',
 background: 'transparent',
 color: isDarkMode ? '#ff453a' : '#ff3b30',
 border: 'none',
 fontSize: '16px',
 cursor: 'pointer'
 }}
 >
 Cancel
 </button>
 </div>
 </div>
 )}
 
 {showPopup && popupData && (
 <div className="popup-overlay" onClick={() => setShowPopup(false)}>
 <div className="popup-card" onClick={(e) => e.stopPropagation()}>
 <div className="popup-header">
 <img src={popupData.avatar} alt={popupData.name} className="popup-avatar" />
 <div className="popup-speaker">
 <div className="popup-speaker-name">{popupData.name}</div>
 <div className="popup-speaker-title">{popupData.title}</div>
 </div>
 </div>
 <div className="popup-body">
 <div className="popup-message">"{popupData.message}"</div>
 
 {/* Show intelligent summary for AI Check if available */}
 {popupData.summary && (
 <div className="popup-summary">{popupData.summary}</div>
 )}
 
 {popupData.type === 'check' && (
 <div className="popup-status">
 {popupData.issueCount === 0 ? (
 <span className="popup-status-badge popup-status-pass">Passed All Checks</span>
 ) : (
 <span className="popup-status-badge popup-status-fail">
 {popupData.issueCount} issue{popupData.issueCount > 1 ? 's' : ''} found
 </span>
 )}
 </div>
 )}
 
 <div className="popup-actions">
 {/* AI Check tab gets Copy Result button */}
 {popupData.type === 'check' && (
 <button 
 className="popup-btn popup-btn-primary"
 onClick={() => {
 handleCopy();
 setShowPopup(false);
 }}
 >
 Copy Result
 </button>
 )}
 {/* Create and Ask tabs only get View Results button */}
 <button 
 className="popup-btn popup-btn-primary"
 onClick={() => setShowPopup(false)}
 >
 {popupData.type === 'check' ? 'View Details' : ' View Results'}
 </button>
 <button 
 className="popup-btn popup-btn-secondary popup-close"
 onClick={() => setShowPopup(false)}
 >
 [X]
 </button>
 </div>
 </div>
 </div>
 </div>
 )}
 
 {/* V37: Pitch Deck Preview Modal */}
 {pitchDeckState.showPreview && pitchDeckState.generatedHTML && (
 <div className="pitch-preview-overlay" onClick={() => setPitchDeckState(prev => ({ ...prev, showPreview: false }))}>
 <div className="pitch-preview-modal" onClick={(e) => e.stopPropagation()}>
 <div className="pitch-preview-header">
 <h3>Pitch Deck Preview: {pitchDeckState.clientName}</h3>
 <div className="pitch-preview-actions">
 <button
 className="pitch-download-btn"
 onClick={() => {
 const blob = new Blob([pitchDeckState.generatedHTML], { type: 'text/html' });
 const url = URL.createObjectURL(blob);
 const a = document.createElement('a');
 a.href = url;
 a.download = `GMG_Pitch_Deck_${pitchDeckState.clientName.replace(/\s+/g, '_')}.html`;
 document.body.appendChild(a);
 a.click();
 document.body.removeChild(a);
 URL.revokeObjectURL(url);
 showToast('Pitch deck downloaded!', 'success');
 }}
 >
 Download HTML
 </button>
 <button
 className="pitch-close-btn"
 onClick={() => setPitchDeckState(prev => ({ ...prev, showPreview: false }))}
 >
 Close
 </button>
 </div>
 </div>
 <div className="pitch-preview-frame">
 <iframe
 srcDoc={pitchDeckState.generatedHTML}
 title="Pitch Deck Preview"
 style={{ width: '100%', height: '100%', border: 'none' }}
 />
 </div>
 </div>
 </div>
 )}
 
 {/* Toast */}
 {toast && <div className={`toast ${toast.type || ''}`}>{toast.message || toast}</div>}
 
 {/* Template Form Popup */}
 {templatePopup.show && (() => {
 const template = TEMPLATES.find(t => t.id === templatePopup.templateId);
 if (!template) return null;
 return (
 <div className="popup-overlay" onClick={closeTemplatePopup}>
 <div className="template-popup-card" onClick={(e) => e.stopPropagation()}>
 <div className="template-popup-header">
 <div className="template-popup-title">
 <span>{template.emoji}</span>
 <span>{template.label}</span>
 </div>
 <button className="template-popup-close" onClick={closeTemplatePopup}>x</button>
 </div>
 <div className="template-popup-body">
 <div className="template-popup-subtitle">
 Fill in what you know. Everything is optional, but more details = better results.
 </div>
 {template.fields.map(field => (
 <div key={field.key} className="template-form-field">
 <label className="template-form-label">
 {field.label}
 {field.required && <span style={{color: '#B87333'}}> *</span>}
 </label>
 {field.type === 'select' ? (
 <select
 className="template-form-select"
 value={templatePopup.fields[field.key] || ''}
 onChange={(e) => handleTemplateFieldChange(field.key, e.target.value)}
 >
 <option value="">Select...</option>
 {field.options.map(opt => (
 <option key={opt} value={opt}>{opt}</option>
 ))}
 </select>
 ) : field.type === 'textarea' ? (
 <textarea
 className="template-form-input"
 style={{minHeight: '100px', resize: 'vertical'}}
 placeholder={field.placeholder}
 value={templatePopup.fields[field.key] || ''}
 onChange={(e) => handleTemplateFieldChange(field.key, e.target.value)}
 />
 ) : (
 <input
 type="text"
 className="template-form-input"
 placeholder={field.placeholder}
 value={templatePopup.fields[field.key] || ''}
 onChange={(e) => handleTemplateFieldChange(field.key, e.target.value)}
 />
 )}
 </div>
 ))}
 </div>
 <div className="template-popup-footer">
 <button className="template-btn-cancel" onClick={closeTemplatePopup}>Cancel</button>
 <button className="template-btn-generate" onClick={handleTemplateSubmit}>
 Generate Prompt
 </button>
 </div>
 </div>
 </div>
 );
 })()}
 
 {/* V25: History Panel */}
 {showHistory && (
 <div className="history-panel">
 <div className="history-header">
 <h3>Request History</h3>
 <button className="history-close" onClick={() => setShowHistory(false)}>x</button>
 </div>
 <div className="history-list">
 {historyLog.length === 0 ? (
 <div className="history-empty">
 <p>No history yet</p>
 <p style={{ fontSize: '12px', marginTop: '8px' }}>Your requests will appear here</p>
 </div>
 ) : (
 historyLog.map((entry) => (
 <div 
 key={entry.id} 
 className="history-item"
 onClick={() => {
 setActiveTab(entry.type);
 if (entry.type === 'create') {
 setCreateState(prev => ({ ...prev, input: entry.fullInput }));
 } else if (entry.type === 'check') {
 setCheckState(prev => ({ ...prev, input: entry.fullInput }));
 } else {
 setAskState(prev => ({ ...prev, input: entry.fullInput }));
 }
 setShowHistory(false);
 showToast('Restored from history');
 }}
 >
 <div className="history-item-header">
 <span className={`history-item-type ${entry.type}`}>
 {entry.type === 'create' ? 'Create' : entry.type === 'check' ? 'Check' : 'Ask'}
 </span>
 <span className="history-item-time">{entry.timestamp}</span>
 </div>
 <div className="history-item-preview">{entry.preview}</div>
 </div>
 ))
 )}
 </div>
 {historyLog.length > 0 && (
 <button 
 className="history-clear"
 onClick={() => {
 setHistoryLog([]);
 saveHistory([]);
 showToast('History cleared');
 }}
 >
 Clear All History
 </button>
 )}
 </div>
 )}
 
 {/* V26: Analytics Dashboard Modal */}
 {showAnalytics && (
 <>
 <div className="analytics-overlay" onClick={() => setShowAnalytics(false)} />
 <div className="analytics-panel">
 <div className="analytics-header">
 <h3>Your GMG Stats</h3>
 <button onClick={() => setShowAnalytics(false)}>x</button>
 </div>
 <div className="analytics-body">
 <div className="stat-grid">
 <div className="stat-box">
 <div className="stat-number">{analytics.totalCreates}</div>
 <div className="stat-label">Creates</div>
 </div>
 <div className="stat-box">
 <div className="stat-number">{analytics.totalChecks}</div>
 <div className="stat-label">Checks</div>
 </div>
 <div className="stat-box">
 <div className="stat-number">{analytics.totalAsks}</div>
 <div className="stat-label">Searches</div>
 </div>
 </div>
 
 <div className="analytics-section">
 <h4>AI Check Performance</h4>
 <p>Total issues found: <strong>{analytics.totalIssuesFound}</strong></p>
 <p>Average issues per check: <strong>
 {analytics.totalChecks > 0 
 ? (analytics.totalIssuesFound / analytics.totalChecks).toFixed(1) 
 : '0'}
 </strong></p>
 {calculateImprovementStats(analytics) && (
 <p className={`improvement-stat ${calculateImprovementStats(analytics).improvement < 0 ? 'negative' : ''}`}>
 {calculateImprovementStats(analytics).improvement > 0 
 ? `${calculateImprovementStats(analytics).improvement}% fewer issues this week!`
 : calculateImprovementStats(analytics).improvement < 0
 ? ` degrees ${Math.abs(calculateImprovementStats(analytics).improvement)}% more issues this week`
 : 'Steady performance'}
 </p>
 )}
 </div>
 
 {Object.keys(analytics.issuesByType).length > 0 && (
 <div className="analytics-section">
 <h4>Most Common Issues</h4>
 {Object.entries(analytics.issuesByType)
 .sort((a, b) => b[1] - a[1])
 .slice(0, 5)
 .map(([type, count]) => (
 <div key={type} className="issue-bar-row">
 <span className="issue-bar-label">{type}</span>
 <div className="issue-bar-track">
 <div 
 className="issue-bar-fill" 
 style={{ width: `${Math.min(100, (count / analytics.totalIssuesFound) * 100)}%` }}
 />
 </div>
 <span className="issue-bar-count">{count}</span>
 </div>
 ))
 }
 </div>
 )}
 
 <div className="analytics-section">
 <p style={{ fontSize: '12px', color: '#666' }}>
 {learnedCorrections.length} patterns learned from your edits
 </p>
 <p style={{ fontSize: '11px', color: '#999', marginTop: '8px' }}>
 First use: {new Date(analytics.firstUse).toLocaleDateString()}
 </p>
 </div>
 </div>
 </div>
 </>
 )}
 
 {/* V2.10: Delivery Persona Selector Modal */}
 {showDeliverySelector && (
 <div 
  className="popup-overlay" 
  onClick={() => setShowDeliverySelector(false)}
  style={{ 
   position: 'fixed', 
   inset: 0, 
   background: 'rgba(0,0,0,0.5)', 
   zIndex: 10002, 
   display: 'flex', 
   alignItems: 'center', 
   justifyContent: 'center',
   padding: '20px'
  }}
 >
  <div 
   onClick={e => e.stopPropagation()}
   style={{
    background: isDarkMode ? '#1a1a2e' : 'white',
    borderRadius: '20px',
    padding: '24px',
    maxWidth: '420px',
    width: '100%',
    boxShadow: '0 20px 60px rgba(0,0,0,0.3)'
   }}
  >
   {/* V2.14: Back button header */}
   <div style={{ display: 'flex', alignItems: 'center', marginBottom: '16px' }}>
    <button
     onClick={() => { setShowDeliverySelector(false); setPendingDeliveryContent(null); }}
     style={{
      background: 'transparent',
      border: 'none',
      fontSize: '24px',
      cursor: 'pointer',
      padding: '0 12px 0 0',
      color: isDarkMode ? '#888' : '#666'
     }}
    >
     ←
    </button>
    <h3 style={{ 
     margin: 0, 
     color: isDarkMode ? '#fff' : '#1d1d1f',
     fontSize: '18px',
     fontWeight: '600',
     flex: 1
    }}>
     Deliver this as:
    </h3>
   </div>
   
   {/* Persona Options - hide when preview is showing */}
   {!deliveryPreview && (
   <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', marginBottom: '20px' }}>
    {Object.entries(DELIVERY_PERSONAS).map(([key, persona]) => (
     <button
      key={key}
      onClick={() => setSelectedDeliveryPersona(key)}
      style={{
       display: 'flex',
       alignItems: 'center',
       gap: '12px',
       padding: '14px 16px',
       background: selectedDeliveryPersona === key 
        ? (persona.type === 'admin' 
          ? 'linear-gradient(135deg, rgba(184, 115, 51, 0.15), rgba(212, 148, 74, 0.15))'
          : 'linear-gradient(135deg, rgba(139, 92, 246, 0.15), rgba(124, 58, 237, 0.15))')
        : isDarkMode ? '#2a2a3e' : '#f5f5f7',
       border: selectedDeliveryPersona === key 
        ? `2px solid ${persona.type === 'admin' ? '#B87333' : '#8B5CF6'}`
        : `2px solid ${isDarkMode ? '#3a3a4e' : '#e0e0e0'}`,
       borderRadius: '12px',
       cursor: 'pointer',
       transition: 'all 0.2s ease',
       textAlign: 'left'
      }}
     >
      <div style={{
       width: '20px',
       height: '20px',
       borderRadius: '50%',
       border: `2px solid ${selectedDeliveryPersona === key 
        ? (persona.type === 'admin' ? '#B87333' : '#8B5CF6')
        : '#999'}`,
       display: 'flex',
       alignItems: 'center',
       justifyContent: 'center',
       flexShrink: 0
      }}>
       {selectedDeliveryPersona === key && (
        <div style={{
         width: '10px',
         height: '10px',
         borderRadius: '50%',
         background: persona.type === 'admin' ? '#B87333' : '#8B5CF6'
        }} />
       )}
      </div>
      <div>
       <div style={{ 
        fontWeight: '600', 
        color: isDarkMode ? '#fff' : '#1d1d1f',
        fontSize: '14px'
       }}>
        {persona.name}
       </div>
       <div style={{ 
        fontSize: '12px', 
        color: isDarkMode ? '#888' : '#666',
        marginTop: '2px'
       }}>
        {persona.type === 'admin' 
         ? `${persona.title}`
         : persona.title}
       </div>
      </div>
     </button>
    ))}
   </div>
   )}
   
   {/* Recipient Input - Only show for admin personas and not during preview */}
   {!deliveryPreview && selectedDeliveryPersona && DELIVERY_PERSONAS[selectedDeliveryPersona]?.type === 'admin' && (
    <div style={{ marginBottom: '20px' }}>
     <label style={{ 
      display: 'block', 
      fontSize: '13px', 
      fontWeight: '600',
      color: isDarkMode ? '#ccc' : '#666',
      marginBottom: '8px'
     }}>
      Recipient (who should this be delivered to?)
     </label>
     <input
      type="text"
      value={deliveryRecipient}
      onChange={e => setDeliveryRecipient(e.target.value)}
      placeholder="e.g., Eric, Brandon, Client Name"
      style={{
       width: '100%',
       padding: '12px 14px',
       borderRadius: '10px',
       border: `1px solid ${isDarkMode ? '#3a3a4e' : '#ddd'}`,
       background: isDarkMode ? '#2a2a3e' : '#f9f9f9',
       color: isDarkMode ? '#fff' : '#1d1d1f',
       fontSize: '14px',
       outline: 'none',
       boxSizing: 'border-box'
      }}
     />
    </div>
   )}
   
   {/* Action Buttons */}
   {!deliveryPreview && (
   <div style={{ display: 'flex', gap: '10px' }}>
    <button
     onClick={skipPersonaDelivery}
     style={{
      flex: 1,
      padding: '12px 20px',
      borderRadius: '10px',
      border: `1px solid ${isDarkMode ? '#3a3a4e' : '#ddd'}`,
      background: 'transparent',
      color: isDarkMode ? '#888' : '#666',
      fontSize: '14px',
      fontWeight: '500',
      cursor: 'pointer'
     }}
    >
     Skip
    </button>
    <button
     onClick={() => handleDeliveryPersonaSelect(selectedDeliveryPersona)}
     disabled={!selectedDeliveryPersona || isProcessing}
     style={{
      flex: 2,
      padding: '12px 20px',
      borderRadius: '10px',
      border: 'none',
      background: selectedDeliveryPersona 
       ? 'linear-gradient(135deg, #B87333, #D4944A)'
       : '#ccc',
      color: 'white',
      fontSize: '14px',
      fontWeight: '600',
      cursor: selectedDeliveryPersona ? 'pointer' : 'not-allowed',
      opacity: isProcessing ? 0.7 : 1
     }}
    >
     {isProcessing ? 'Generating...' : 'Generate Preview'}
    </button>
   </div>
   )}
   
   {/* V2.14: Delivery Preview Section */}
   {deliveryPreview && (
   <div style={{
    marginTop: '16px',
    padding: '16px',
    background: isDarkMode ? '#252538' : '#f9f9f9',
    borderRadius: '12px',
    border: `2px solid ${isDarkMode ? '#B87333' : '#D4944A'}`
   }}>
    <div style={{ 
    display: 'flex', 
    alignItems: 'center', 
    justifyContent: 'space-between',
    marginBottom: '12px' 
    }}>
    <span style={{ 
     fontWeight: '600', 
     color: isDarkMode ? '#D4944A' : '#B87333',
     fontSize: '14px'
    }}>
     📝 Preview - {deliveryPreview.persona.name}
    </span>
    <button
     onClick={backFromPreview}
     style={{
     background: 'transparent',
     border: 'none',
     fontSize: '12px',
     color: isDarkMode ? '#888' : '#666',
     cursor: 'pointer',
     textDecoration: 'underline'
     }}
    >
     ← Edit
    </button>
    </div>
    <div style={{
    maxHeight: '300px',
    overflowY: 'auto',
    padding: '12px',
    background: isDarkMode ? '#1a1a2e' : 'white',
    borderRadius: '8px',
    fontSize: '13px',
    lineHeight: '1.6',
    whiteSpace: 'pre-wrap',
    color: isDarkMode ? '#E8E8EC' : '#333'
    }}>
    {deliveryPreview.content}
    </div>
    <div style={{ display: 'flex', gap: '10px', marginTop: '16px' }}>
    <button
     onClick={backFromPreview}
     style={{
     flex: 1,
     padding: '12px',
     borderRadius: '10px',
     border: `1px solid ${isDarkMode ? '#3a3a4e' : '#ddd'}`,
     background: 'transparent',
     color: isDarkMode ? '#888' : '#666',
     fontSize: '14px',
     cursor: 'pointer'
     }}
    >
     ← Back
    </button>
    <button
     onClick={confirmDeliveryPreview}
     style={{
     flex: 2,
     padding: '12px',
     borderRadius: '10px',
     border: 'none',
     background: 'linear-gradient(135deg, #28a745, #20c997)',
     color: 'white',
     fontSize: '14px',
     fontWeight: '600',
     cursor: 'pointer'
     }}
    >
     ✓ Use This
    </button>
    </div>
   </div>
   )}
   
   {/* V2.11.1: Send as Email option - Only show when not in preview mode */}
   {!deliveryPreview && selectedDeliveryPersona && DELIVERY_PERSONAS[selectedDeliveryPersona]?.type === 'admin' && (
    <div style={{
     marginTop: '12px',
     padding: '12px',
     background: 'rgba(40, 167, 69, 0.1)',
     borderRadius: '10px',
     border: '1px solid rgba(40, 167, 69, 0.3)'
    }}>
     <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '8px' }}>
      <span style={{ color: '#28a745', fontSize: '14px', fontWeight: '600' }}>
       📧 Send as {DELIVERY_PERSONAS[selectedDeliveryPersona]?.name}
      </span>
     </div>
     <div style={{ display: 'flex', gap: '8px' }}>
      <input
       type="email"
       placeholder="Recipient email address"
       id="email-recipient"
       style={{
        flex: 1,
        padding: '10px',
        borderRadius: '8px',
        border: `1px solid ${isDarkMode ? '#3a3a4e' : '#ddd'}`,
        background: isDarkMode ? '#2a2a3e' : 'white',
        color: isDarkMode ? '#fff' : '#333',
        fontSize: '13px'
       }}
      />
      <button
       onClick={async () => {
        const emailTo = document.getElementById('email-recipient')?.value;
        if (!emailTo) {
         showToast('Enter recipient email', 'error');
         return;
        }
        // Generate content first, then send
        const content = await generateWithPersona(
         pendingDeliveryContent?.content,
         selectedDeliveryPersona,
         deliveryRecipient,
         pendingDeliveryContent?.type
        );
        const subject = `From ${DELIVERY_PERSONAS[selectedDeliveryPersona]?.boss}: ${pendingDeliveryContent?.type || 'Content'} Delivery`;
        await sendEmailAsPersona(emailTo, subject, content, selectedDeliveryPersona);
        setShowDeliverySelector(false);
        setPendingDeliveryContent(null);
       }}
       disabled={sendingEmail}
       style={{
        padding: '10px 16px',
        background: sendingEmail ? '#ccc' : '#28a745',
        border: 'none',
        borderRadius: '8px',
        color: 'white',
        fontWeight: '600',
        cursor: sendingEmail ? 'not-allowed' : 'pointer',
        fontSize: '13px'
       }}
      >
       {sendingEmail ? 'Sending...' : 'Send Email'}
      </button>
     </div>
     <div style={{ fontSize: '11px', color: '#888', marginTop: '8px' }}>
      Email will be sent from {DELIVERY_PERSONAS[selectedDeliveryPersona]?.email}
     </div>
    </div>
   )}
   
   {/* Toggle for future deliveries */}
   <div style={{ 
    marginTop: '16px', 
    paddingTop: '16px', 
    borderTop: `1px solid ${isDarkMode ? '#3a3a4e' : '#eee'}`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
   }}>
    <span style={{ fontSize: '12px', color: isDarkMode ? '#888' : '#666' }}>
     Show this for future {activeTab} outputs
    </span>
    <button
     onClick={() => setDeliverySelectorEnabled(!deliverySelectorEnabled)}
     style={{
      width: '44px',
      height: '24px',
      borderRadius: '12px',
      border: 'none',
      background: deliverySelectorEnabled 
       ? 'linear-gradient(135deg, #B87333, #D4944A)'
       : isDarkMode ? '#3a3a4e' : '#ddd',
      cursor: 'pointer',
      position: 'relative',
      transition: 'all 0.2s ease'
     }}
    >
     <div style={{
      width: '20px',
      height: '20px',
      borderRadius: '50%',
      background: 'white',
      position: 'absolute',
      top: '2px',
      left: deliverySelectorEnabled ? '22px' : '2px',
      transition: 'all 0.2s ease',
      boxShadow: '0 1px 3px rgba(0,0,0,0.2)'
     }} />
    </button>
   </div>
  </div>
 </div>
 )}
 
 {/* V2.11: Admin Portal Modal */}
 {showAdminPortal && isAdmin && (
 <div 
  style={{ 
   position: 'fixed', 
   inset: 0, 
   background: 'rgba(0,0,0,0.8)', 
   zIndex: 10005, 
   display: 'flex',
   overflow: 'hidden'
  }}
 >
  {/* Sidebar */}
  <div style={{
   width: '240px',
   background: isDarkMode ? '#0f1729' : '#1d1d1f',
   borderRight: `1px solid ${isDarkMode ? '#2a2a3e' : '#333'}`,
   display: 'flex',
   flexDirection: 'column',
   flexShrink: 0
  }}>
   {/* Admin Header */}
   <div style={{
    padding: '20px',
    borderBottom: `1px solid ${isDarkMode ? '#2a2a3e' : '#333'}`
   }}>
    <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '8px' }}>
     <span style={{ fontSize: '24px' }}>⚡</span>
     <span style={{ color: 'white', fontWeight: '700', fontSize: '18px' }}>Admin Portal</span>
    </div>
    <div style={{ fontSize: '12px', color: '#888' }}>
     {currentUser?.email}
    </div>
   </div>
   
   {/* Navigation */}
   <div style={{ flex: 1, padding: '12px', overflow: 'auto' }}>
    {Object.entries(ADMIN_SECTIONS).map(([key, section]) => (
     <button
      key={key}
      onClick={() => setAdminSection(key)}
      style={{
       display: 'flex',
       alignItems: 'center',
       gap: '10px',
       width: '100%',
       padding: '12px',
       background: adminSection === key 
        ? 'linear-gradient(135deg, rgba(184, 115, 51, 0.3), rgba(212, 148, 74, 0.3))'
        : 'transparent',
       border: 'none',
       borderRadius: '8px',
       color: adminSection === key ? '#D4944A' : '#888',
       fontSize: '14px',
       cursor: 'pointer',
       textAlign: 'left',
       marginBottom: '4px',
       transition: 'all 0.2s ease'
      }}
     >
      <span style={{ fontSize: '18px' }}>{section.icon}</span>
      {section.name}
     </button>
    ))}
   </div>
   
   {/* Footer */}
   <div style={{ padding: '16px', borderTop: `1px solid ${isDarkMode ? '#2a2a3e' : '#333'}` }}>
    <button
     onClick={() => setShowAdminPortal(false)}
     style={{
      width: '100%',
      padding: '10px',
      background: 'transparent',
      border: `1px solid #666`,
      borderRadius: '8px',
      color: '#888',
      cursor: 'pointer'
     }}
    >
     Close Admin
    </button>
   </div>
  </div>
  
  {/* Main Content */}
  <div style={{ flex: 1, overflow: 'auto', background: isDarkMode ? '#1a1a2e' : '#f5f5f7' }}>
   {/* Top Bar */}
   <div style={{
    padding: '20px 24px',
    borderBottom: `1px solid ${isDarkMode ? '#2a2a3e' : '#e0e0e0'}`,
    background: isDarkMode ? 'rgba(0,0,0,0.3)' : 'white',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
   }}>
    <div>
     <h2 style={{ margin: 0, color: isDarkMode ? 'white' : '#1d1d1f', fontSize: '24px' }}>
      {ADMIN_SECTIONS[adminSection]?.icon} {ADMIN_SECTIONS[adminSection]?.name}
     </h2>
     <p style={{ margin: '4px 0 0 0', color: '#888', fontSize: '14px' }}>
      {ADMIN_SECTIONS[adminSection]?.description}
     </p>
    </div>
    <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
     {/* V2.11.1: Email Service Status - Server-side tokens */}
     <div style={{
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      padding: '8px 16px',
      background: emailServiceStatus === 'available' 
       ? 'rgba(40, 167, 69, 0.1)' 
       : 'rgba(220, 53, 69, 0.1)',
      borderRadius: '20px',
      fontSize: '13px'
     }}>
      <span style={{ 
       width: '8px', 
       height: '8px', 
       borderRadius: '50%', 
       background: emailServiceStatus === 'available' ? '#28a745' : '#dc3545' 
      }} />
      <span style={{ color: emailServiceStatus === 'available' ? '#28a745' : '#dc3545' }}>
       Email {emailServiceStatus === 'available' ? 'Ready' : 'Not Configured'}
      </span>
     </div>
    </div>
   </div>
   
   {/* Section Content */}
   <div style={{ padding: '24px' }}>
    {/* Dashboard Section */}
    {adminSection === 'dashboard' && (
     <div>
      {/* Quick Stats */}
      <div style={{ 
       display: 'grid', 
       gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', 
       gap: '16px',
       marginBottom: '24px'
      }}>
       {[
        { label: 'Total Checks', value: adminData.analytics?.totalChecks || 0, icon: '✓', color: '#8B5CF6' },
        { label: 'Total Creates', value: adminData.analytics?.totalCreates || 0, icon: '✏️', color: '#B87333' },
        { label: 'Total Searches', value: adminData.analytics?.totalAsks || 0, icon: '🔍', color: '#28a745' },
        { label: 'Global Templates', value: adminData.templates?.length || 0, icon: '📄', color: '#007AFF' }
       ].map((stat, i) => (
        <div key={i} style={{
         background: isDarkMode ? '#2a2a3e' : 'white',
         borderRadius: '12px',
         padding: '20px',
         boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
        }}>
         <div style={{ fontSize: '32px', marginBottom: '8px' }}>{stat.icon}</div>
         <div style={{ fontSize: '28px', fontWeight: '700', color: stat.color }}>{stat.value}</div>
         <div style={{ fontSize: '14px', color: '#888' }}>{stat.label}</div>
        </div>
       ))}
      </div>
      
      {/* Recent Activity */}
      <div style={{
       background: isDarkMode ? '#2a2a3e' : 'white',
       borderRadius: '12px',
       padding: '20px',
       boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
      }}>
       <h3 style={{ margin: '0 0 16px 0', color: isDarkMode ? 'white' : '#1d1d1f' }}>Recent Activity</h3>
       {adminData.auditLog?.slice(0, 10).map((entry, i) => (
        <div key={entry.id || i} style={{
         padding: '12px 0',
         borderBottom: i < 9 ? `1px solid ${isDarkMode ? '#3a3a4e' : '#eee'}` : 'none',
         display: 'flex',
         justifyContent: 'space-between',
         alignItems: 'center'
        }}>
         <div>
          <span style={{ color: isDarkMode ? '#fff' : '#333', fontWeight: '500' }}>{entry.action}</span>
          <span style={{ color: '#888', marginLeft: '8px', fontSize: '13px' }}>by {entry.user}</span>
         </div>
         <span style={{ color: '#888', fontSize: '12px' }}>
          {new Date(entry.timestamp).toLocaleString()}
         </span>
        </div>
       ))}
       {(!adminData.auditLog || adminData.auditLog.length === 0) && (
        <p style={{ color: '#888', textAlign: 'center', padding: '20px' }}>No recent activity</p>
       )}
      </div>
     </div>
    )}
    
    {/* Users Section */}
    {adminSection === 'users' && (
     <div>
      <div style={{
       background: isDarkMode ? '#2a2a3e' : 'white',
       borderRadius: '12px',
       padding: '20px',
       boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
      }}>
       <h3 style={{ margin: '0 0 16px 0', color: isDarkMode ? 'white' : '#1d1d1f' }}>Team Members</h3>
       
       {/* Admin Users */}
       <div style={{ marginBottom: '24px' }}>
        <h4 style={{ color: '#B87333', fontSize: '14px', marginBottom: '12px' }}>Administrators</h4>
        {ADMIN_USERS.map((email, i) => (
         <div key={i} style={{
          display: 'flex',
          alignItems: 'center',
          gap: '12px',
          padding: '12px',
          background: isDarkMode ? '#1a1a2e' : '#f9f9f9',
          borderRadius: '8px',
          marginBottom: '8px'
         }}>
          <div style={{
           width: '40px',
           height: '40px',
           borderRadius: '50%',
           background: 'linear-gradient(135deg, #B87333, #D4944A)',
           display: 'flex',
           alignItems: 'center',
           justifyContent: 'center',
           color: 'white',
           fontWeight: '600'
          }}>
           {email.charAt(0).toUpperCase()}
          </div>
          <div>
           <div style={{ color: isDarkMode ? '#fff' : '#333', fontWeight: '500' }}>{email}</div>
           <div style={{ fontSize: '12px', color: '#888' }}>Admin</div>
          </div>
          {email === currentUser?.email && (
           <span style={{ 
            marginLeft: 'auto', 
            fontSize: '11px', 
            padding: '4px 8px', 
            background: '#8B5CF6', 
            color: 'white', 
            borderRadius: '4px' 
           }}>
            You
           </span>
          )}
         </div>
        ))}
       </div>
       
       <p style={{ color: '#888', fontSize: '13px', textAlign: 'center' }}>
        User management with Firebase coming in future update
       </p>
      </div>
     </div>
    )}
    
    {/* Analytics Section */}
    {adminSection === 'analytics' && (
     <div>
      <div style={{
       background: isDarkMode ? '#2a2a3e' : 'white',
       borderRadius: '12px',
       padding: '20px',
       boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
       marginBottom: '16px'
      }}>
       <h3 style={{ margin: '0 0 16px 0', color: isDarkMode ? 'white' : '#1d1d1f' }}>Usage Analytics</h3>
       
       {/* Stats Grid */}
       <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '16px', marginBottom: '24px' }}>
        <div style={{ textAlign: 'center', padding: '16px', background: isDarkMode ? '#1a1a2e' : '#f5f5f7', borderRadius: '8px' }}>
         <div style={{ fontSize: '36px', fontWeight: '700', color: '#8B5CF6' }}>{adminData.analytics?.totalChecks || 0}</div>
         <div style={{ color: '#888' }}>AI Checks</div>
        </div>
        <div style={{ textAlign: 'center', padding: '16px', background: isDarkMode ? '#1a1a2e' : '#f5f5f7', borderRadius: '8px' }}>
         <div style={{ fontSize: '36px', fontWeight: '700', color: '#B87333' }}>{adminData.analytics?.totalCreates || 0}</div>
         <div style={{ color: '#888' }}>Creates</div>
        </div>
        <div style={{ textAlign: 'center', padding: '16px', background: isDarkMode ? '#1a1a2e' : '#f5f5f7', borderRadius: '8px' }}>
         <div style={{ fontSize: '36px', fontWeight: '700', color: '#28a745' }}>{adminData.analytics?.totalAsks || 0}</div>
         <div style={{ color: '#888' }}>Searches</div>
        </div>
       </div>
       
       {/* Issues by Type */}
       <h4 style={{ color: isDarkMode ? '#fff' : '#333', marginBottom: '12px' }}>Most Common Issues Found</h4>
       {Object.entries(adminData.analytics?.issuesByType || {}).length > 0 ? (
        Object.entries(adminData.analytics.issuesByType)
         .sort((a, b) => b[1] - a[1])
         .slice(0, 8)
         .map(([type, count], i) => (
          <div key={type} style={{ marginBottom: '12px' }}>
           <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '4px' }}>
            <span style={{ color: isDarkMode ? '#fff' : '#333', fontSize: '13px' }}>{type}</span>
            <span style={{ color: '#888', fontSize: '13px' }}>{count}</span>
           </div>
           <div style={{ 
            height: '8px', 
            background: isDarkMode ? '#1a1a2e' : '#eee', 
            borderRadius: '4px',
            overflow: 'hidden'
           }}>
            <div style={{
             height: '100%',
             width: `${Math.min(100, (count / Math.max(...Object.values(adminData.analytics.issuesByType))) * 100)}%`,
             background: 'linear-gradient(135deg, #B87333, #D4944A)',
             borderRadius: '4px'
            }} />
           </div>
          </div>
         ))
       ) : (
        <p style={{ color: '#888', textAlign: 'center' }}>No issue data yet</p>
       )}
      </div>
     </div>
    )}
    
    {/* Templates Section */}
    {adminSection === 'templates' && (
     <div>
      <div style={{
       background: isDarkMode ? '#2a2a3e' : 'white',
       borderRadius: '12px',
       padding: '20px',
       boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
      }}>
       <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
        <h3 style={{ margin: 0, color: isDarkMode ? 'white' : '#1d1d1f' }}>Global Templates</h3>
        <button
         onClick={() => {
          const name = prompt('Template name:');
          const content = prompt('Template content:');
          if (name && content) {
           saveGlobalTemplate({ name, content, category: 'general' });
          }
         }}
         style={{
          padding: '8px 16px',
          background: 'linear-gradient(135deg, #B87333, #D4944A)',
          border: 'none',
          borderRadius: '8px',
          color: 'white',
          cursor: 'pointer',
          fontWeight: '600'
         }}
        >
         + Add Template
        </button>
       </div>
       
       {adminData.templates?.length > 0 ? (
        adminData.templates.map(template => (
         <div key={template.id} style={{
          padding: '16px',
          background: isDarkMode ? '#1a1a2e' : '#f9f9f9',
          borderRadius: '8px',
          marginBottom: '12px'
         }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'start' }}>
           <div>
            <div style={{ fontWeight: '600', color: isDarkMode ? '#fff' : '#333', marginBottom: '4px' }}>
             {template.name}
            </div>
            <div style={{ fontSize: '13px', color: '#888', marginBottom: '8px' }}>
             Created by {template.createdBy} on {new Date(template.createdAt).toLocaleDateString()}
            </div>
            <div style={{ fontSize: '14px', color: isDarkMode ? '#ccc' : '#555' }}>
             {template.content?.substring(0, 150)}...
            </div>
           </div>
           <button
            onClick={() => deleteGlobalTemplate(template.id)}
            style={{
             background: 'rgba(220, 53, 69, 0.1)',
             border: 'none',
             color: '#dc3545',
             padding: '6px 12px',
             borderRadius: '6px',
             cursor: 'pointer',
             fontSize: '12px'
            }}
           >
            Delete
           </button>
          </div>
         </div>
        ))
       ) : (
        <p style={{ color: '#888', textAlign: 'center', padding: '40px' }}>
         No global templates yet. Add one to share across all users.
        </p>
       )}
      </div>
     </div>
    )}
    
    {/* Banned Phrases Section */}
    {adminSection === 'phrases' && (
     <div>
      <div style={{
       background: isDarkMode ? '#2a2a3e' : 'white',
       borderRadius: '12px',
       padding: '20px',
       boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
      }}>
       <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
        <h3 style={{ margin: 0, color: isDarkMode ? 'white' : '#1d1d1f' }}>Global Banned Phrases</h3>
        <button
         onClick={() => {
          const phrase = prompt('Enter phrase to ban globally:');
          if (phrase) {
           addGlobalBannedPhrase(phrase);
          }
         }}
         style={{
          padding: '8px 16px',
          background: 'linear-gradient(135deg, #dc3545, #c82333)',
          border: 'none',
          borderRadius: '8px',
          color: 'white',
          cursor: 'pointer',
          fontWeight: '600'
         }}
        >
         + Add Phrase
        </button>
       </div>
       
       <p style={{ color: '#888', fontSize: '13px', marginBottom: '16px' }}>
        These phrases will be flagged for ALL users during AI Check.
       </p>
       
       {adminData.globalPhrases?.length > 0 ? (
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
         {adminData.globalPhrases.map(item => (
          <span key={item.id} style={{
           padding: '8px 12px',
           background: 'rgba(220, 53, 69, 0.1)',
           border: '1px solid rgba(220, 53, 69, 0.3)',
           borderRadius: '20px',
           color: '#dc3545',
           fontSize: '13px',
           display: 'flex',
           alignItems: 'center',
           gap: '8px'
          }}>
           {item.phrase}
           <button
            onClick={() => {
             const newPhrases = adminData.globalPhrases.filter(p => p.id !== item.id);
             setAdminData(prev => ({ ...prev, globalPhrases: newPhrases }));
             localStorage.setItem('admin_global_phrases', JSON.stringify(newPhrases));
            }}
            style={{
             background: 'none',
             border: 'none',
             color: '#dc3545',
             cursor: 'pointer',
             padding: 0,
             fontSize: '16px'
            }}
           >
            ×
           </button>
          </span>
         ))}
        </div>
       ) : (
        <p style={{ color: '#888', textAlign: 'center', padding: '40px' }}>
         No global banned phrases. These add to each user's personal list.
        </p>
       )}
      </div>
     </div>
    )}
    
    {/* Audit Log Section */}
    {adminSection === 'audit' && (
     <div>
      <div style={{
       background: isDarkMode ? '#2a2a3e' : 'white',
       borderRadius: '12px',
       padding: '20px',
       boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
      }}>
       <h3 style={{ margin: '0 0 16px 0', color: isDarkMode ? 'white' : '#1d1d1f' }}>Audit Log</h3>
       
       <div style={{ maxHeight: '600px', overflow: 'auto' }}>
        {adminData.auditLog?.length > 0 ? (
         <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead>
           <tr style={{ borderBottom: `2px solid ${isDarkMode ? '#3a3a4e' : '#eee'}` }}>
            <th style={{ padding: '12px', textAlign: 'left', color: '#888', fontWeight: '600' }}>Timestamp</th>
            <th style={{ padding: '12px', textAlign: 'left', color: '#888', fontWeight: '600' }}>User</th>
            <th style={{ padding: '12px', textAlign: 'left', color: '#888', fontWeight: '600' }}>Action</th>
            <th style={{ padding: '12px', textAlign: 'left', color: '#888', fontWeight: '600' }}>Details</th>
           </tr>
          </thead>
          <tbody>
           {adminData.auditLog.map((entry, i) => (
            <tr key={entry.id || i} style={{ borderBottom: `1px solid ${isDarkMode ? '#3a3a4e' : '#eee'}` }}>
             <td style={{ padding: '12px', color: '#888', fontSize: '13px' }}>
              {new Date(entry.timestamp).toLocaleString()}
             </td>
             <td style={{ padding: '12px', color: isDarkMode ? '#fff' : '#333' }}>
              {entry.user}
             </td>
             <td style={{ padding: '12px' }}>
              <span style={{
               padding: '4px 8px',
               background: entry.action.includes('delete') ? 'rgba(220, 53, 69, 0.1)' 
                : entry.action.includes('create') || entry.action.includes('add') ? 'rgba(40, 167, 69, 0.1)'
                : 'rgba(139, 92, 246, 0.1)',
               color: entry.action.includes('delete') ? '#dc3545' 
                : entry.action.includes('create') || entry.action.includes('add') ? '#28a745'
                : '#8B5CF6',
               borderRadius: '4px',
               fontSize: '12px'
              }}>
               {entry.action}
              </span>
             </td>
             <td style={{ padding: '12px', color: '#888', fontSize: '13px' }}>
              {JSON.stringify(entry.details)}
             </td>
            </tr>
           ))}
          </tbody>
         </table>
        ) : (
         <p style={{ color: '#888', textAlign: 'center', padding: '40px' }}>
          No audit entries yet
         </p>
        )}
       </div>
      </div>
     </div>
    )}
    
    {/* Settings Section */}
    {adminSection === 'settings' && (
     <div>
      <div style={{
       background: isDarkMode ? '#2a2a3e' : 'white',
       borderRadius: '12px',
       padding: '20px',
       boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
       marginBottom: '16px'
      }}>
       <h3 style={{ margin: '0 0 16px 0', color: isDarkMode ? 'white' : '#1d1d1f' }}>Email Integration</h3>
       
       {/* Claudette Status */}
       <div style={{ 
        padding: '16px', 
        background: isDarkMode ? '#1a1a2e' : '#f9f9f9', 
        borderRadius: '8px',
        marginBottom: '12px'
       }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
         <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
          <div style={{
           width: '40px',
           height: '40px',
           borderRadius: '50%',
           background: 'linear-gradient(135deg, #B87333, #D4944A)',
           display: 'flex',
           alignItems: 'center',
           justifyContent: 'center',
           fontSize: '20px'
          }}>👩‍💼</div>
          <div>
           <div style={{ fontWeight: '600', color: isDarkMode ? '#fff' : '#333' }}>Claudette Aims</div>
           <div style={{ fontSize: '13px', color: '#888' }}>claudette@globalmajoritygroup.com</div>
          </div>
         </div>
         <div style={{
          padding: '6px 12px',
          borderRadius: '20px',
          fontSize: '12px',
          fontWeight: '600',
          background: emailServiceStatus === 'available' ? 'rgba(40, 167, 69, 0.1)' : 'rgba(220, 53, 69, 0.1)',
          color: emailServiceStatus === 'available' ? '#28a745' : '#dc3545'
         }}>
          {emailServiceStatus === 'available' ? '✓ Ready' : '✗ Not Configured'}
         </div>
        </div>
       </div>
       
       {/* Chanet Status */}
       <div style={{ 
        padding: '16px', 
        background: isDarkMode ? '#1a1a2e' : '#f9f9f9', 
        borderRadius: '8px',
        marginBottom: '16px'
       }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
         <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
          <div style={{
           width: '40px',
           height: '40px',
           borderRadius: '50%',
           background: 'linear-gradient(135deg, #6B7280, #9CA3AF)',
           display: 'flex',
           alignItems: 'center',
           justifyContent: 'center',
           fontSize: '20px'
          }}>👩‍💼</div>
          <div>
           <div style={{ fontWeight: '600', color: isDarkMode ? '#fff' : '#333' }}>Chanet Graves</div>
           <div style={{ fontSize: '13px', color: '#888' }}>chanet@globalmajoritygroup.com</div>
          </div>
         </div>
         <div style={{
          padding: '6px 12px',
          borderRadius: '20px',
          fontSize: '12px',
          fontWeight: '600',
          background: 'rgba(220, 53, 69, 0.1)',
          color: '#dc3545'
         }}>
          ✗ Not Configured
         </div>
        </div>
       </div>
       
       <div style={{ 
        padding: '12px', 
        background: isDarkMode ? '#1a1a2e' : '#f0f7ff', 
        borderRadius: '8px',
        border: '1px solid rgba(0, 122, 255, 0.2)'
       }}>
        <p style={{ color: isDarkMode ? '#aaa' : '#555', fontSize: '13px', margin: 0 }}>
         <strong>How it works:</strong> Email tokens are stored securely on the server. 
         Anyone using ACE Portal can send emails as Claudette or Chanet without needing to log in.
         Contact Brandon to set up new accounts.
        </p>
       </div>
      </div>
      
      <div style={{
       background: isDarkMode ? '#2a2a3e' : 'white',
       borderRadius: '12px',
       padding: '20px',
       boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
      }}>
       <h3 style={{ margin: '0 0 16px 0', color: isDarkMode ? 'white' : '#1d1d1f' }}>App Info</h3>
       
       <div style={{ display: 'grid', gap: '12px' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', padding: '8px 0', borderBottom: `1px solid ${isDarkMode ? '#3a3a4e' : '#eee'}` }}>
         <span style={{ color: '#888' }}>Version</span>
         <span style={{ color: isDarkMode ? '#fff' : '#333', fontWeight: '500' }}>{APP_VERSION}</span>
        </div>
        <div style={{ display: 'flex', justifyContent: 'space-between', padding: '8px 0', borderBottom: `1px solid ${isDarkMode ? '#3a3a4e' : '#eee'}` }}>
         <span style={{ color: '#888' }}>Model</span>
         <span style={{ color: isDarkMode ? '#fff' : '#333', fontWeight: '500' }}>{MODEL_CONFIG.quality}</span>
        </div>
        <div style={{ display: 'flex', justifyContent: 'space-between', padding: '8px 0' }}>
         <span style={{ color: '#888' }}>Admin Users</span>
         <span style={{ color: isDarkMode ? '#fff' : '#333', fontWeight: '500' }}>{ADMIN_USERS.length}</span>
        </div>
       </div>
      </div>
     </div>
    )}
   </div>
  </div>
 </div>
 )}
 
 {/* V26: Voice Confirmation Modal */}
 {showVoiceConfirm && (
 <div className="voice-confirm-overlay">
 <div className="voice-confirm-content">
 <h4>Did you mean:</h4>
 <div className="voice-transcript-preview">{voiceTranscript}</div>
 <div className="voice-confirm-actions">
 <button 
 className="accept"
 onClick={() => {
 setCurrentState(prev => ({ 
 ...prev, 
 input: prev.input + (prev.input ? ' ' : '') + voiceTranscript 
 }));
 setShowVoiceConfirm(false);
 setVoiceTranscript('');
 showToast('Voice input added');
 }}
 >
 Use This
 </button>
 <button 
 className="cancel"
 onClick={() => {
 setShowVoiceConfirm(false);
 setVoiceTranscript('');
 }}
 >
 [X] Cancel
 </button>
 <button 
 className="edit"
 onClick={() => {
 setCurrentState(prev => ({ 
 ...prev, 
 input: prev.input + (prev.input ? ' ' : '') + voiceTranscript 
 }));
 setShowVoiceConfirm(false);
 setVoiceTranscript('');
 }}
 >
 Edit
 </button>
 </div>
 </div>
 </div>
 )}
 
 {/* V29: Pitch Deck HTML Preview Modal */}
 {showPitchPreview && createState.result && createState.result.content && (
 <div className="pitch-preview-overlay" onClick={() => setShowPitchPreview(false)}>
 <div className="pitch-preview-modal" onClick={(e) => e.stopPropagation()}>
 <div className="pitch-preview-header">
 <h3>{createState.result.content.includes('Data Science Development Plan') ? 'DSDP Preview' : 'Pitch Deck Preview'}</h3>
 <div className="pitch-preview-actions">
 <button 
 className="pitch-download-btn"
 onClick={() => {
 const blob = new Blob([createState.result.content], { type: 'text/html' });
 const url = URL.createObjectURL(blob);
 const a = document.createElement('a');
 a.href = url;
 const docType = createState.result.content.includes('Data Science Development Plan') ? 'DSDP' : 'PitchDeck';
 a.download = `GMG_${docType}_${Date.now()}.html`;
 document.body.appendChild(a);
 a.click();
 document.body.removeChild(a);
 URL.revokeObjectURL(url);
 showToast('HTML downloaded!', 'success');
 }}
 >
 Download HTML
 </button>
 <button 
 className="pitch-download-btn"
 style={{ background: '#dc2626' }}
 onClick={() => {
 const printWindow = window.open('', '_blank');
 printWindow.document.write(createState.result.content);
 printWindow.document.close();
 printWindow.focus();
 setTimeout(() => {
 printWindow.print();
 }, 500);
 showToast('Print dialog opened. Save as PDF from print menu.', 'info');
 }}
 >
 Print/Save PDF
 </button>
 <button className="pitch-close-btn" onClick={() => setShowPitchPreview(false)}>x</button>
 </div>
 </div>
 <div className="pitch-preview-frame">
 <iframe 
 srcDoc={createState.result.content}
 title="Document Preview"
 style={{ width: '100%', height: '100%', border: 'none' }}
 />
 </div>
 </div>
 </div>
 )}
 
 {/* Back to Top Button */}
 <button 
 className={`back-to-top ${showBackToTop ? 'visible' : ''}`}
 onClick={scrollToTop}
 title="Back to top"
 >
        ^
 </button>
 
 {/* V3.6: Bottom Navigation (Mobile - Tablet) */}
 <nav className="bottom-nav">
 <div className="bottom-nav-items">
 <button 
  className={`bottom-nav-item ${activeTab === 'create' ? 'active' : ''}`}
  onClick={() => { setActiveTab('create'); clearUnifiedChat(); }}
 >
  <span className="bottom-nav-icon">W</span>
  <span className="bottom-nav-label">Create</span>
 </button>
 <button 
  className={`bottom-nav-item ${activeTab === 'check' ? 'active' : ''}`}
  onClick={() => { setActiveTab('check'); clearUnifiedChat(); }}
 >
  <span className="bottom-nav-icon"></span>
  <span className="bottom-nav-label">Check</span>
 </button>
 <button 
  className={`bottom-nav-item ${activeTab === 'ask' ? 'active' : ''}`}
  onClick={() => { setActiveTab('ask'); clearUnifiedChat(); }}
 >
  <span className="bottom-nav-icon"></span>
  <span className="bottom-nav-label">Ask</span>
 </button>
 {canAccessTab(currentUser?.email, 'acquire') && (
  <button 
  className={`bottom-nav-item ${activeTab === 'acquire' ? 'active' : ''}`}
  onClick={() => { setActiveTab('acquire'); clearUnifiedChat(); }}
  >
  <span className="bottom-nav-icon"></span>
  <span className="bottom-nav-label">Jobs</span>
  </button>
 )}
 <button 
  className="bottom-nav-item"
  onClick={() => {
  // Show more menu
  const moreOptions = ['prep', 'brainstorm', 'knowledge'];
  const labels = { prep: 'Client Prep', brainstorm: 'Brainstorm', knowledge: 'Knowledge' };
  const icons = { prep: 'P', brainstorm: 'B', knowledge: 'K' };
  // Simple prompt for now - could be upgraded to a proper menu
  const choice = window.prompt(`More options:\n1. Client Prep\n2. Brainstorm\n3. Knowledge\n\nEnter number:`);
  if (choice === '1' && canAccessTab(currentUser?.email, 'prep')) { setActiveTab('prep'); clearUnifiedChat(); }
  if (choice === '2' && canAccessTab(currentUser?.email, 'brainstorm')) { setActiveTab('brainstorm'); clearUnifiedChat(); }
  if (choice === '3' && canAccessTab(currentUser?.email, 'knowledge')) { setActiveTab('knowledge'); clearUnifiedChat(); }
  }}
 >
  <span className="bottom-nav-icon">...</span>
  <span className="bottom-nav-label">More</span>
 </button>
 </div>
 </nav>
 
 {/* V2.7: Floating Action Button (FAB) for tab switching */}
 {/* V2.12: Moved higher (180px from bottom) to prevent touch collisions */}
 <div style={{
 position: 'fixed',
 bottom: '180px',
 right: '20px',
 zIndex: 1000,
 display: 'flex',
 flexDirection: 'column',
 alignItems: 'flex-end',
 gap: '12px'
 }}>
 {/* Expanded menu - V2.8: Copper active states */}
 {showFabMenu && (
  <div style={{
  display: 'flex',
  flexDirection: 'column',
  gap: '10px',
  marginBottom: '12px',
  animation: 'fadeIn 0.2s ease'
  }}>
  <button 
   onClick={() => { setActiveTab('create'); clearUnifiedChat(); setShowFabMenu(false); }}
   style={{
   padding: '14px 22px',
   background: activeTab === 'create' ? 'linear-gradient(135deg, #B87333, #8B5A2B)' : 'rgba(255,255,255,0.85)',
   color: activeTab === 'create' ? 'white' : '#333',
   border: 'none',
   borderRadius: '25px',
   fontSize: '14px',
   fontWeight: '600',
   cursor: 'pointer',
   boxShadow: '0 4px 15px rgba(0,0,0,0.15)',
   backdropFilter: 'blur(10px)'
   }}
  >
   Create
  </button>
  <button 
   onClick={() => { setActiveTab('check'); clearUnifiedChat(); setShowFabMenu(false); }}
   style={{
   padding: '12px 20px',
   background: activeTab === 'check' ? 'linear-gradient(135deg, #B87333, #8B5A2B)' : 'rgba(255,255,255,0.85)',
   color: activeTab === 'check' ? 'white' : '#333',
   border: 'none',
   borderRadius: '25px',
   fontSize: '14px',
   fontWeight: '600',
   cursor: 'pointer',
   boxShadow: '0 4px 15px rgba(0,0,0,0.15)',
   backdropFilter: 'blur(10px)'
   }}
  >
   Check
  </button>
  <button 
   onClick={() => { setActiveTab('ask'); clearUnifiedChat(); setShowFabMenu(false); }}
   style={{
   padding: '12px 20px',
   background: activeTab === 'ask' ? 'linear-gradient(135deg, #B87333, #8B5A2B)' : 'rgba(255,255,255,0.85)',
   color: activeTab === 'ask' ? 'white' : '#333',
   border: 'none',
   borderRadius: '25px',
   fontSize: '14px',
   fontWeight: '600',
   cursor: 'pointer',
   boxShadow: '0 4px 15px rgba(0,0,0,0.15)',
   backdropFilter: 'blur(10px)'
   }}
  >
   Ask
  </button>
  {canAccessTab(currentUser?.email, 'acquire') && (
   <button 
   onClick={() => { setActiveTab('acquire'); clearUnifiedChat(); setShowFabMenu(false); }}
   style={{
    padding: '12px 20px',
    background: activeTab === 'acquire' ? 'linear-gradient(135deg, #B87333, #8B5A2B)' : 'rgba(255,255,255,0.85)',
    color: activeTab === 'acquire' ? 'white' : '#333',
    border: 'none',
    borderRadius: '25px',
    fontSize: '14px',
    fontWeight: '600',
    cursor: 'pointer',
    boxShadow: '0 4px 15px rgba(0,0,0,0.15)',
    backdropFilter: 'blur(10px)'
   }}
   >
   Jobs
   </button>
  )}
  {canAccessTab(currentUser?.email, 'prep') && (
   <button 
   onClick={() => { setActiveTab('prep'); clearUnifiedChat(); setShowFabMenu(false); }}
   style={{
    padding: '12px 20px',
    background: activeTab === 'prep' ? 'linear-gradient(135deg, #B87333, #8B5A2B)' : 'rgba(255,255,255,0.85)',
    color: activeTab === 'prep' ? 'white' : '#333',
    border: 'none',
    borderRadius: '25px',
    fontSize: '14px',
    fontWeight: '600',
    cursor: 'pointer',
    boxShadow: '0 4px 15px rgba(0,0,0,0.15)',
    backdropFilter: 'blur(10px)'
   }}
   >
   Prep
   </button>
  )}
  {canAccessTab(currentUser?.email, 'knowledge') && (
   <button 
   onClick={() => { setActiveTab('knowledge'); clearUnifiedChat(); setShowFabMenu(false); }}
   style={{
    padding: '12px 20px',
    background: activeTab === 'knowledge' ? 'linear-gradient(135deg, #B87333, #8B5A2B)' : 'rgba(255,255,255,0.85)',
    color: activeTab === 'knowledge' ? 'white' : '#333',
    border: 'none',
    borderRadius: '25px',
    fontSize: '14px',
    fontWeight: '600',
    cursor: 'pointer',
    boxShadow: '0 4px 15px rgba(0,0,0,0.15)',
    backdropFilter: 'blur(10px)'
   }}
   >
   Knowledge
   </button>
  )}
  </div>
 )}
 
 {/* Main FAB button - V2.8: Copper color, more transparent */}
 <button
  onClick={() => setShowFabMenu(!showFabMenu)}
  style={{
  width: '56px',
  height: '56px',
  borderRadius: '50%',
  background: showFabMenu 
   ? 'rgba(220, 53, 69, 0.85)' 
   : 'linear-gradient(135deg, rgba(184, 115, 51, 0.7), rgba(139, 90, 43, 0.7))',
  color: 'white',
  border: 'none',
  fontSize: '24px',
  cursor: 'pointer',
  boxShadow: '0 4px 20px rgba(184, 115, 51, 0.3)',
  backdropFilter: 'blur(10px)',
  WebkitBackdropFilter: 'blur(10px)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  transition: 'transform 0.2s ease, background 0.2s ease'
  }}
 >
  {showFabMenu ? '×' : '☰'}
 </button>
 
 {/* Current tab indicator - V2.13: Added "Switch Mode" label for clarity */}
 <div style={{
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: '4px'
 }}>
  <div style={{
  padding: '6px 12px',
  background: 'rgba(184, 115, 51, 0.7)',
  color: 'white',
  borderRadius: '12px',
  fontSize: '11px',
  fontWeight: '600',
  textTransform: 'capitalize',
  boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
  backdropFilter: 'blur(10px)',
  WebkitBackdropFilter: 'blur(10px)'
  }}>
  {activeTab}
  </div>
  <div style={{
  fontSize: '9px',
  color: isDarkMode ? '#888' : '#666',
  fontWeight: '500',
  textAlign: 'center'
  }}>
  ↑ Switch Mode
  </div>
 </div>
 </div>
 
 {/* V2.7: Backdrop when FAB menu is open */}
 {showFabMenu && (
 <div 
  onClick={() => setShowFabMenu(false)}
  style={{
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  background: 'rgba(0,0,0,0.3)',
  zIndex: 999
  }}
 />
 )}
 
 {/* V2.14.1: Update Available Modal */}
 {updateAvailable && (
 <div 
  style={{
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  background: 'rgba(0,0,0,0.6)',
  zIndex: 10010,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '20px'
  }}
  onClick={dismissUpdate}
 >
  <div 
  onClick={e => e.stopPropagation()}
  style={{
   background: isDarkMode ? '#1a1a2e' : 'white',
   borderRadius: '20px',
   padding: '24px',
   maxWidth: '360px',
   width: '100%',
   boxShadow: '0 20px 60px rgba(0,0,0,0.4)'
  }}
  >
  {/* Update icon */}
  <div style={{ textAlign: 'center', marginBottom: '16px' }}>
   <div style={{
   width: '60px',
   height: '60px',
   borderRadius: '50%',
   background: 'linear-gradient(135deg, #B87333, #D4944A)',
   display: 'flex',
   alignItems: 'center',
   justifyContent: 'center',
   margin: '0 auto',
   fontSize: '28px'
   }}>
   🚀
   </div>
  </div>
  
  <h3 style={{ 
   margin: '0 0 8px 0',
   textAlign: 'center',
   color: isDarkMode ? '#fff' : '#1d1d1f',
   fontSize: '20px',
   fontWeight: '700'
  }}>
   Update Available
  </h3>
  
  <p style={{
   textAlign: 'center',
   color: isDarkMode ? '#888' : '#666',
   fontSize: '14px',
   margin: '0 0 16px 0'
  }}>
   Version {updateAvailable.version} is ready
  </p>
  
  {/* Changelog */}
  {updateAvailable.changelog && (
   <div style={{
   background: isDarkMode ? '#252538' : '#f5f5f7',
   borderRadius: '12px',
   padding: '12px',
   marginBottom: '20px',
   maxHeight: '150px',
   overflowY: 'auto'
   }}>
   <div style={{ 
    fontSize: '12px', 
    fontWeight: '600', 
    color: isDarkMode ? '#888' : '#666',
    marginBottom: '8px'
   }}>
    What's New:
   </div>
   <div style={{
    fontSize: '13px',
    color: isDarkMode ? '#ccc' : '#333',
    lineHeight: '1.5',
    whiteSpace: 'pre-wrap'
   }}>
    {updateAvailable.changelog}
   </div>
   </div>
  )}
  
  {/* Actions */}
  <div style={{ display: 'flex', gap: '10px' }}>
   <button
   onClick={dismissUpdate}
   style={{
    flex: 1,
    padding: '14px',
    borderRadius: '12px',
    border: `1px solid ${isDarkMode ? '#3a3a4e' : '#ddd'}`,
    background: 'transparent',
    color: isDarkMode ? '#888' : '#666',
    fontSize: '15px',
    fontWeight: '600',
    cursor: 'pointer'
   }}
   >
   Later
   </button>
   <button
   onClick={applyUpdate}
   style={{
    flex: 2,
    padding: '14px',
    borderRadius: '12px',
    border: 'none',
    background: 'linear-gradient(135deg, #B87333, #D4944A)',
    color: 'white',
    fontSize: '15px',
    fontWeight: '700',
    cursor: 'pointer'
   }}
   >
   Update Now
   </button>
  </div>
  
  <p style={{
   textAlign: 'center',
   color: isDarkMode ? '#555' : '#999',
   fontSize: '11px',
   marginTop: '12px',
   marginBottom: 0
  }}>
   Current: v{APP_VERSION}
  </p>
  </div>
 </div>
 )}
 
 {/* V5.8: Settings Drawer */}
 {showSettingsDrawer && (
 <div className="settings-overlay" onClick={() => setShowSettingsDrawer(false)}>
  <div className="settings-drawer" onClick={(e) => e.stopPropagation()}>
  <div className="drawer-handle"></div>
  <div className="drawer-title">Settings</div>
  
  <button onClick={() => { setShowHistory(true); setShowSettingsDrawer(false); }}>
   <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
   <circle cx="12" cy="12" r="10"/>
   <polyline points="12,6 12,12 16,14"/>
   </svg>
   History
  </button>
  
  <button onClick={() => { setIsDarkMode(!isDarkMode); localStorage.setItem('gmg_ace_dark_mode_manual', 'true'); }}>
   <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
   {isDarkMode ? (
    <>
    <circle cx="12" cy="12" r="5"/>
    <line x1="12" y1="1" x2="12" y2="3"/>
    <line x1="12" y1="21" x2="12" y2="23"/>
    <line x1="4.22" y1="4.22" x2="5.64" y2="5.64"/>
    <line x1="18.36" y1="18.36" x2="19.78" y2="19.78"/>
    <line x1="1" y1="12" x2="3" y2="12"/>
    <line x1="21" y1="12" x2="23" y2="12"/>
    <line x1="4.22" y1="19.78" x2="5.64" y2="18.36"/>
    <line x1="18.36" y1="5.64" x2="19.78" y2="4.22"/>
    </>
   ) : (
    <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"/>
   )}
   </svg>
   {isDarkMode ? 'Light Mode' : 'Dark Mode'}
  </button>
  
  <button onClick={() => setSoundEnabled(!soundEnabled)}>
   <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
   <polygon points="11,5 6,9 2,9 2,15 6,15 11,19"/>
   {soundEnabled ? (
    <>
    <path d="M19.07 4.93a10 10 0 0 1 0 14.14"/>
    <path d="M15.54 8.46a5 5 0 0 1 0 7.07"/>
    </>
   ) : (
    <line x1="23" y1="9" x2="17" y2="15"/>
   )}
   </svg>
   Sound: {soundEnabled ? 'On' : 'Off'}
  </button>
  
  {currentUser && (
   <button onClick={() => { 
   const newState = !syncEnabled;
   setSyncEnabled(newState);
   localStorage.setItem('gmg_ace_sync_enabled', String(newState));
   if (newState) syncDraftsToCloud();
   showToast(newState ? 'Cloud sync enabled!' : 'Cloud sync disabled');
   }}>
   <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M18 10h-1.26A8 8 0 1 0 9 20h9a5 5 0 0 0 0-10z"/>
   </svg>
   Cloud Sync: {syncEnabled ? 'On' : 'Off'}
   </button>
  )}
  
  <button onClick={() => { handleExport(); setShowSettingsDrawer(false); }}>
   <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
   <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
   <polyline points="7,10 12,15 17,10"/>
   <line x1="12" y1="15" x2="12" y2="3"/>
   </svg>
   Export Data
  </button>
  
  <button onClick={() => { document.getElementById('importFileInput')?.click(); setShowSettingsDrawer(false); }}>
   <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
   <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
   <polyline points="17,8 12,3 7,8"/>
   <line x1="12" y1="3" x2="12" y2="15"/>
   </svg>
   Import Data
  </button>
  
  {/* V2.14.1: Check for Updates Button */}
  <button 
   onClick={() => { checkForUpdates(); }}
   disabled={isCheckingUpdate}
   style={{ position: 'relative' }}
  >
   <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
   <path d="M21 2v6h-6"/>
   <path d="M3 12a9 9 0 0 1 15-6.7L21 8"/>
   <path d="M3 22v-6h6"/>
   <path d="M21 12a9 9 0 0 1-15 6.7L3 16"/>
   </svg>
   {isCheckingUpdate ? 'Checking...' : 'Check for Updates'}
   {updateAvailable && (
   <span style={{
    position: 'absolute',
    top: '8px',
    right: '8px',
    width: '8px',
    height: '8px',
    background: '#ff3b30',
    borderRadius: '50%'
   }} />
   )}
  </button>
  
  {/* Version info */}
  <div style={{ 
   padding: '12px 16px', 
   fontSize: '12px', 
   color: isDarkMode ? '#666' : '#999',
   borderTop: `1px solid ${isDarkMode ? '#333' : '#eee'}`,
   marginTop: '8px'
  }}>
   Version {APP_VERSION}
  </div>
  
  <button 
   className={currentUser ? 'danger' : ''}
   onClick={() => { 
   if (currentUser) { 
    logOut(); 
   } else { 
    signInWithGoogle(); 
   }
   setShowSettingsDrawer(false);
   }}
  >
   <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
   {currentUser ? (
    <>
    <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/>
    <polyline points="16,17 21,12 16,7"/>
    <line x1="21" y1="12" x2="9" y2="12"/>
    </>
   ) : (
    <>
    <path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4"/>
    <polyline points="10,17 15,12 10,7"/>
    <line x1="15" y1="12" x2="3" y2="12"/>
    </>
   )}
   </svg>
   {currentUser ? 'Sign Out' : 'Sign In with Google'}
  </button>
  </div>
 </div>
 )}
 
 {/* V3.6: Floating Action Button (Mobile) */}
 <button 
 className={`floating-action-btn ${(createState.input || checkState.input || askState.input) ? 'has-content' : ''}`}
 onClick={handleSubmit}
 style={{ display: 'none' }} // Will be shown via CSS on mobile
 >
 >
 </button>
 
 {/* V3.6: Draft Recovery Modal */}
 {showDraftRecovery && Object.keys(drafts).length > 0 && (
 <div className="draft-recovery-modal">
 <div className="draft-recovery-title">Recover Unsaved Work?</div>
 <div className="draft-recovery-desc">
  You have unsaved drafts from your last session. Would you like to restore them?
 </div>
 <div className="draft-recovery-actions">
  <button 
  className="draft-recovery-restore"
  onClick={() => {
   // Restore drafts to each tab
   if (drafts.create?.content) setCreateState(prev => ({ ...prev, input: drafts.create.content }));
   if (drafts.check?.content) setCheckState(prev => ({ ...prev, input: drafts.check.content }));
   if (drafts.ask?.content) setAskState(prev => ({ ...prev, input: drafts.ask.content }));
   if (drafts.prep?.content) setPrepState(prev => ({ ...prev, input: drafts.prep.content }));
   if (drafts.acquire?.content) setAcquireState(prev => ({ ...prev, input: drafts.acquire.content }));
   showToast('Drafts restored!');
   setShowDraftRecovery(false);
  }}
  >
  Restore Drafts
  </button>
  <button 
  className="draft-recovery-discard"
  onClick={() => {
   localStorage.removeItem('gmg_ace_drafts');
   setDrafts({});
   setShowDraftRecovery(false);
  }}
  >
  Discard
  </button>
 </div>
 </div>
 )}
 
 {/* V5.4: Keyboard Shortcuts Modal */}
 {showShortcutsModal && (
 <div 
 style={{
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  background: 'rgba(0,0,0,0.6)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: 10000
 }}
 onClick={() => setShowShortcutsModal(false)}
 >
 <div 
  style={{
  background: isDarkMode ? '#1a1a2e' : 'white',
  borderRadius: '12px',
  padding: '24px',
  maxWidth: '400px',
  width: '90%',
  border: `2px solid ${isDarkMode ? '#B87333' : '#191970'}`
  }}
  onClick={e => e.stopPropagation()}
 >
  <h3 style={{ marginBottom: '16px', color: isDarkMode ? '#fff' : '#191970' }}>Keyboard Shortcuts</h3>
  <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
  {[
   { keys: 'Ctrl/Cmd + Enter', action: 'Submit' },
   { keys: 'Ctrl/Cmd + K', action: 'Clear input' },
   { keys: 'Ctrl/Cmd + Shift + C', action: 'Copy result' },
   { keys: 'Ctrl/Cmd + H', action: 'Toggle history' },
   { keys: 'Ctrl/Cmd + /', action: 'This help' },
   { keys: 'Ctrl + 1/2/3', action: 'Switch tabs' },
   { keys: 'Escape', action: 'Close popups' }
  ].map((shortcut, i) => (
   <div key={i} style={{ display: 'flex', justifyContent: 'space-between', padding: '8px', background: isDarkMode ? '#2a2a3e' : '#f5f5f5', borderRadius: '6px' }}>
   <span style={{ fontFamily: 'monospace', background: isDarkMode ? '#3a3a4e' : '#e0e0e0', padding: '2px 6px', borderRadius: '4px', fontSize: '12px' }}>{shortcut.keys}</span>
   <span style={{ color: isDarkMode ? '#A0A0B0' : '#666' }}>{shortcut.action}</span>
   </div>
  ))}
  </div>
  <button 
  onClick={() => setShowShortcutsModal(false)}
  style={{ marginTop: '16px', width: '100%', padding: '10px', background: '#B87333', color: 'white', border: 'none', borderRadius: '6px', cursor: 'pointer' }}
  >
  Got it
  </button>
 </div>
 </div>
 )}
 
 {/* V3.6: Draft Save Indicator */}
 {draftSaveIndicator && (
 <div className="draft-save-indicator">
 {draftSaveIndicator}
 </div>
 )}
 
 {/* V3.6: Applications Tracker Panel */}
 <div className={`applications-panel ${showApplications ? 'open' : ''}`}>
 <div className="applications-header">
 <div style={{ display: 'flex', gap: '16px', alignItems: 'center' }}>
  <button 
  onClick={() => setShowTeamLog(false)}
  style={{ 
   background: !showTeamLog ? (isDarkMode ? '#D4944A' : '#191970') : 'transparent',
   color: !showTeamLog ? 'white' : (isDarkMode ? '#A0A0B0' : '#666'),
   border: 'none', padding: '6px 12px', borderRadius: '6px', cursor: 'pointer', fontWeight: '600'
  }}
  >
  My Apps
  </button>
  <button 
  onClick={() => setShowTeamLog(true)}
  style={{ 
   background: showTeamLog ? (isDarkMode ? '#D4944A' : '#191970') : 'transparent',
   color: showTeamLog ? 'white' : (isDarkMode ? '#A0A0B0' : '#666'),
   border: 'none', padding: '6px 12px', borderRadius: '6px', cursor: 'pointer', fontWeight: '600'
  }}
  >
  Team Log ({teamApplicationsLog.length})
  </button>
 </div>
 <button 
  onClick={() => setShowApplications(false)}
  style={{ background: 'none', border: 'none', fontSize: '24px', cursor: 'pointer', color: isDarkMode ? '#A0A0B0' : '#666' }}
 >
  X
 </button>
 </div>
 <div className="applications-list">
 {showTeamLog ? (
  /* V5.1: Team Applications Log */
  teamApplicationsLog.length === 0 ? (
  <div style={{ textAlign: 'center', padding: '40px 20px', color: isDarkMode ? '#707080' : '#999' }}>
   <div style={{ fontSize: '48px', marginBottom: '16px' }}></div>
   <div>No team applications yet</div>
   <div style={{ fontSize: '13px', marginTop: '8px' }}>When BJ, Eli, or anyone applies to jobs, they'll appear here</div>
  </div>
  ) : (
  teamApplicationsLog.map(app => (
   <div key={app.id} style={{
   background: isDarkMode ? '#1a1a2e' : '#f8f9fa',
   borderRadius: '10px',
   padding: '14px',
   marginBottom: '12px',
   borderLeft: `4px solid ${app.applicantName?.toLowerCase().includes('bj') ? '#4CAF50' : app.applicantName?.toLowerCase().includes('eli') ? '#2196F3' : '#FF9800'}`
   }}>
   <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
    <div>
    <div style={{ fontWeight: '700', color: isDarkMode ? '#E8E8EC' : '#191970', marginBottom: '4px' }}>{app.applicantName}</div>
    <div style={{ fontSize: '14px', color: isDarkMode ? '#A0A0B0' : '#333' }}>{app.position}</div>
    <div style={{ fontSize: '13px', color: isDarkMode ? '#707080' : '#666' }}>{app.company}</div>
    </div>
    <div style={{ textAlign: 'right' }}>
    <span style={{ 
     background: app.status === 'APPLIED' ? '#4CAF50' : app.status === 'INTERVIEW' ? '#2196F3' : '#FF9800',
     color: 'white', padding: '2px 8px', borderRadius: '4px', fontSize: '11px', fontWeight: '600'
    }}>{app.status}</span>
    <div style={{ fontSize: '11px', color: isDarkMode ? '#707080' : '#999', marginTop: '6px' }}>
     {app.appliedAt ? new Date(app.appliedAt).toLocaleDateString() : ''}
    </div>
    </div>
   </div>
   {app.salary && app.salary !== 'Not Listed' && (
    <div style={{ fontSize: '12px', color: isDarkMode ? '#707080' : '#888', marginTop: '6px' }}>{app.salary}</div>
   )}
   </div>
  ))
  )
 ) : (
  /* Personal Applications */
  applications.length === 0 ? (
  <div style={{ textAlign: 'center', padding: '40px 20px', color: isDarkMode ? '#707080' : '#999' }}>
  <div style={{ fontSize: '48px', marginBottom: '16px' }}></div>
  <div>No applications tracked yet</div>
  <div style={{ fontSize: '13px', marginTop: '8px' }}>Generate a cover letter to start tracking</div>
  </div>
 ) : (
  applications.map(app => (
  <div key={app.id} className="application-card">
   <div className="application-company">{app.company}</div>
   <div className="application-position">{app.position}</div>
   <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
   <span className={`application-status ${app.status?.toLowerCase()}`}>
    {app.status?.replace('_', ' ') || 'Applied'}
   </span>
   <span style={{ fontSize: '11px', color: isDarkMode ? '#707080' : '#999' }}>
    {app.appliedDate ? new Date(app.appliedDate).toLocaleDateString() : ''}
   </span>
   </div>
   <div style={{ marginTop: '12px', display: 'flex', gap: '8px' }}>
   <select 
    value={app.status || 'APPLIED'}
    onChange={async (e) => {
    // Update status in Firebase
    if (db && app.id) {
     try {
     const { doc, updateDoc } = await import('firebase/firestore');
     await updateDoc(doc(db, 'applications', app.id), { 
      status: e.target.value,
      lastUpdated: new Date().toISOString()
     });
     setApplications(prev => prev.map(a => 
      a.id === app.id ? { ...a, status: e.target.value } : a
     ));
     showToast('Status updated!');
     } catch (err) {
     devError('Failed to update status:', err);
     }
    }
    }}
    style={{ 
    flex: 1, 
    padding: '6px', 
    borderRadius: '6px', 
    border: '1px solid #ddd',
    background: isDarkMode ? '#1a1a2e' : 'white',
    color: isDarkMode ? '#E8E8EC' : 'inherit',
    fontSize: '12px'
    }}
   >
    <option value="APPLIED">Applied</option>
    <option value="PHONE_SCREEN">Phone Screen</option>
    <option value="INTERVIEW">Interview</option>
    <option value="OFFER">Offer</option>
    <option value="REJECTED">Rejected</option>
    <option value="WITHDRAWN">Withdrawn</option>
   </select>
   </div>
  </div>
  ))
 )
 )}
 </div>
 </div>
 
 {/* V3.6: Conversation History Panel */}
 {showConversationHistory && (
 <div 
 style={{
  position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
  background: 'rgba(0,0,0,0.5)', zIndex: 10001,
  display: 'flex', alignItems: 'center', justifyContent: 'center',
  padding: '20px'
 }}
 onClick={() => setShowConversationHistory(false)}
 >
 <div 
  style={{
  background: isDarkMode ? '#1a1a2e' : 'white',
  borderRadius: '16px',
  width: '100%',
  maxWidth: '600px',
  maxHeight: '80vh',
  overflow: 'hidden',
  display: 'flex',
  flexDirection: 'column'
  }}
  onClick={e => e.stopPropagation()}
 >
  <div style={{ 
  padding: '20px', 
  borderBottom: `1px solid ${isDarkMode ? '#3a3a5a' : '#eee'}`,
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center'
  }}>
  <h3 style={{ margin: 0, color: isDarkMode ? '#D4944A' : '#191970' }}>
   Past Questions ({conversationHistory.length})
  </h3>
  <button 
   onClick={() => setShowConversationHistory(false)}
   style={{ background: 'none', border: 'none', fontSize: '24px', cursor: 'pointer', color: isDarkMode ? '#A0A0B0' : '#666' }}
  >X</button>
  </div>
  
  {/* V3.6: Search box */}
  <div style={{ padding: '12px 16px', borderBottom: `1px solid ${isDarkMode ? '#3a3a5a' : '#eee'}` }}>
  <input
   placeholder="Search past questions..."
   value={conversationSearch}
   onChange={e => setConversationSearch(e.target.value)}
   style={{
   width: '100%',
   padding: '10px 12px',
   borderRadius: '8px',
   border: `1px solid ${isDarkMode ? '#3a3a5a' : '#ddd'}`,
   background: isDarkMode ? '#252538' : 'white',
   color: isDarkMode ? '#E8E8EC' : 'inherit'
   }}
  />
  </div>
  
  <div style={{ flex: 1, overflowY: 'auto', padding: '16px' }}>
  {conversationHistory.filter(item => 
   !conversationSearch || 
   item.question.toLowerCase().includes(conversationSearch.toLowerCase()) ||
   item.answer.toLowerCase().includes(conversationSearch.toLowerCase())
  ).length === 0 ? (
   <div style={{ textAlign: 'center', padding: '40px', color: isDarkMode ? '#707080' : '#999' }}>
   {conversationHistory.length === 0 ? 'No questions asked yet' : 'No results match your search'}
   </div>
  ) : (
   conversationHistory.filter(item => 
   !conversationSearch || 
   item.question.toLowerCase().includes(conversationSearch.toLowerCase()) ||
   item.answer.toLowerCase().includes(conversationSearch.toLowerCase())
   ).map(item => (
   <div 
    key={item.id}
    style={{
    background: isDarkMode ? '#252538' : '#f9f9f9',
    borderRadius: '12px',
    padding: '16px',
    marginBottom: '12px',
    cursor: 'pointer'
    }}
    onClick={() => {
    setAskState(prev => ({ ...prev, input: item.question }));
    setShowConversationHistory(false);
    }}
   >
    <div style={{ fontWeight: '600', marginBottom: '8px', color: isDarkMode ? '#E8E8EC' : '#333' }}>
    {item.question}
    </div>
    <div style={{ 
    fontSize: '13px', 
    color: isDarkMode ? '#A0A0B0' : '#666',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: '-webkit-box',
    WebkitLineClamp: 2,
    WebkitBoxOrient: 'vertical'
    }}>
    {item.answer}
    </div>
    <div style={{ fontSize: '11px', color: isDarkMode ? '#707080' : '#999', marginTop: '8px' }}>
    {new Date(item.timestamp).toLocaleDateString()} {new Date(item.timestamp).toLocaleTimeString()}
    </div>
   </div>
   ))
  )}
  </div>
  {conversationHistory.length > 0 && (
  <div style={{ padding: '16px', borderTop: `1px solid ${isDarkMode ? '#3a3a5a' : '#eee'}` }}>
   <button
   onClick={() => {
    if (window.confirm('Clear all conversation history?')) {
    setConversationHistory([]);
    localStorage.removeItem('gmg_ace_conversation_history');
    }
   }}
   style={{
    width: '100%',
    padding: '10px',
    background: 'transparent',
    border: '1px solid #dc3545',
    color: '#dc3545',
    borderRadius: '8px',
    cursor: 'pointer'
   }}
   >
   Clear History
   </button>
  </div>
  )}
 </div>
 </div>
 )}
 
 {/* V3.6: Custom Banned Phrases Editor */}
 {showCustomPhrasesEditor && (
 <div 
 style={{
  position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
  background: 'rgba(0,0,0,0.5)', zIndex: 10001,
  display: 'flex', alignItems: 'center', justifyContent: 'center',
  padding: '20px'
 }}
 onClick={() => setShowCustomPhrasesEditor(false)}
 >
 <div 
  style={{
  background: isDarkMode ? '#1a1a2e' : 'white',
  borderRadius: '16px',
  width: '100%',
  maxWidth: '500px',
  maxHeight: '80vh',
  overflow: 'hidden',
  display: 'flex',
  flexDirection: 'column'
  }}
  onClick={e => e.stopPropagation()}
 >
  <div style={{ 
  padding: '20px', 
  borderBottom: `1px solid ${isDarkMode ? '#3a3a5a' : '#eee'}`,
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center'
  }}>
  <h3 style={{ margin: 0, color: isDarkMode ? '#D4944A' : '#191970' }}>
   Custom Banned Phrases
  </h3>
  <button 
   onClick={() => setShowCustomPhrasesEditor(false)}
   style={{ background: 'none', border: 'none', fontSize: '24px', cursor: 'pointer', color: isDarkMode ? '#A0A0B0' : '#666' }}
  >X</button>
  </div>
  
  {/* Add new phrase form */}
  <div style={{ padding: '16px', borderBottom: `1px solid ${isDarkMode ? '#3a3a5a' : '#eee'}` }}>
  <input
   placeholder="Phrase to ban (e.g., 'leverage synergies')"
   value={newCustomPhrase.phrase}
   onChange={e => setNewCustomPhrase(prev => ({ ...prev, phrase: e.target.value }))}
   style={{
   width: '100%',
   padding: '10px',
   marginBottom: '8px',
   borderRadius: '8px',
   border: `1px solid ${isDarkMode ? '#3a3a5a' : '#ddd'}`,
   background: isDarkMode ? '#252538' : 'white',
   color: isDarkMode ? '#E8E8EC' : 'inherit'
   }}
  />
  <input
   placeholder="Reason (e.g., 'Corporate jargon')"
   value={newCustomPhrase.reason}
   onChange={e => setNewCustomPhrase(prev => ({ ...prev, reason: e.target.value }))}
   style={{
   width: '100%',
   padding: '10px',
   marginBottom: '8px',
   borderRadius: '8px',
   border: `1px solid ${isDarkMode ? '#3a3a5a' : '#ddd'}`,
   background: isDarkMode ? '#252538' : 'white',
   color: isDarkMode ? '#E8E8EC' : 'inherit'
   }}
  />
  <input
   placeholder="Suggested replacement (optional)"
   value={newCustomPhrase.replace}
   onChange={e => setNewCustomPhrase(prev => ({ ...prev, replace: e.target.value }))}
   style={{
   width: '100%',
   padding: '10px',
   marginBottom: '12px',
   borderRadius: '8px',
   border: `1px solid ${isDarkMode ? '#3a3a5a' : '#ddd'}`,
   background: isDarkMode ? '#252538' : 'white',
   color: isDarkMode ? '#E8E8EC' : 'inherit'
   }}
  />
  <button
   onClick={() => {
   if (newCustomPhrase.phrase.trim()) {
    // V5.1: Save to shared Firebase collection (team-visible)
    saveSharedPhrase(newCustomPhrase);
    setNewCustomPhrase({ phrase: '', reason: '', replace: '' });
   }
   }}
   style={{
   width: '100%',
   padding: '10px',
   background: COLORS.copper,
   color: 'white',
   border: 'none',
   borderRadius: '8px',
   cursor: 'pointer',
   fontWeight: '600'
   }}
  >
   Add Phrase (Team-Wide)
  </button>
  </div>
  
  {/* List of custom phrases */}
  <div style={{ flex: 1, overflowY: 'auto', padding: '16px' }}>
  {customBannedPhrases.length === 0 ? (
   <div style={{ textAlign: 'center', padding: '40px', color: isDarkMode ? '#707080' : '#999' }}>
   No custom phrases yet. Add some above!
   </div>
  ) : (
   customBannedPhrases.map(phrase => (
   <div 
    key={phrase.id}
    style={{
    background: isDarkMode ? '#252538' : '#f9f9f9',
    borderRadius: '8px',
    padding: '12px',
    marginBottom: '8px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start'
    }}
   >
    <div>
    <div style={{ fontWeight: '600', color: '#dc3545' }}>"{phrase.phrase}"</div>
    {phrase.reason && <div style={{ fontSize: '12px', color: isDarkMode ? '#A0A0B0' : '#666' }}>{phrase.reason}</div>}
    {phrase.replace && <div style={{ fontSize: '12px', color: '#28a745' }}>Use: {phrase.replace}</div>}
    </div>
    <button
    onClick={() => {
     const updated = customBannedPhrases.filter(p => p.id !== phrase.id);
     setCustomBannedPhrases(updated);
     localStorage.setItem('gmg_ace_custom_phrases', JSON.stringify(updated));
    }}
    style={{
     background: 'none',
     border: 'none',
     color: '#dc3545',
     cursor: 'pointer',
     fontSize: '18px'
    }}
    >X</button>
   </div>
   ))
  )}
  </div>
 </div>
 </div>
 )}
 
 {/* V3.6: Meeting Notes Panel */}
 {showMeetingNotes && (
 <div className={`meeting-notes-panel open`}>
 <div style={{ 
  padding: '20px', 
  borderBottom: `1px solid ${isDarkMode ? '#3a3a5a' : '#eee'}`,
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center'
 }}>
  <h3 style={{ margin: 0, color: isDarkMode ? '#D4944A' : '#191970' }}>
  Meeting Notes ({meetingNotes.length})
  </h3>
  <button 
  onClick={() => setShowMeetingNotes(false)}
  style={{ background: 'none', border: 'none', fontSize: '24px', cursor: 'pointer', color: isDarkMode ? '#A0A0B0' : '#666' }}
  >X</button>
 </div>
 
 {/* Add new note form */}
 <div style={{ padding: '16px', borderBottom: `1px solid ${isDarkMode ? '#3a3a5a' : '#eee'}` }}>
  <input
  placeholder="Client name..."
  value={newMeetingNote.client}
  onChange={e => setNewMeetingNote(prev => ({ ...prev, client: e.target.value }))}
  style={{
   width: '100%',
   padding: '10px',
   marginBottom: '8px',
   borderRadius: '8px',
   border: `1px solid ${isDarkMode ? '#3a3a5a' : '#ddd'}`,
   background: isDarkMode ? '#252538' : 'white',
   color: isDarkMode ? '#E8E8EC' : 'inherit'
  }}
  />
  <textarea
  placeholder="Meeting notes, key takeaways, follow-up items..."
  value={newMeetingNote.content}
  onChange={e => setNewMeetingNote(prev => ({ ...prev, content: e.target.value }))}
  rows={4}
  style={{
   width: '100%',
   padding: '10px',
   marginBottom: '12px',
   borderRadius: '8px',
   border: `1px solid ${isDarkMode ? '#3a3a5a' : '#ddd'}`,
   background: isDarkMode ? '#252538' : 'white',
   color: isDarkMode ? '#E8E8EC' : 'inherit',
   resize: 'vertical'
  }}
  />
  <button
  onClick={() => {
   if (newMeetingNote.client.trim() && newMeetingNote.content.trim()) {
   const note = {
    id: Date.now(),
    client: newMeetingNote.client.trim(),
    content: newMeetingNote.content.trim(),
    timestamp: new Date().toISOString(),
    addedBy: currentUser?.email || 'guest'
   };
   const updated = [note, ...meetingNotes];
   setMeetingNotes(updated);
   localStorage.setItem('gmg_ace_meeting_notes', JSON.stringify(updated));
   setNewMeetingNote({ client: '', content: '' });
   showToast('Note saved!');
   }
  }}
  style={{
   width: '100%',
   padding: '10px',
   background: COLORS.copper,
   color: 'white',
   border: 'none',
   borderRadius: '8px',
   cursor: 'pointer',
   fontWeight: '600'
  }}
  >
  Save Note
  </button>
 </div>
 
 {/* Notes list */}
 <div style={{ flex: 1, overflowY: 'auto', padding: '16px' }}>
  {meetingNotes.length === 0 ? (
  <div style={{ textAlign: 'center', padding: '40px', color: isDarkMode ? '#707080' : '#999' }}>
   No meeting notes yet. Add some above!
  </div>
  ) : (
  meetingNotes.map(note => (
   <div key={note.id} className="meeting-note-card">
   <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
    <div>
    <div className="meeting-note-client">{note.client}</div>
    <div className="meeting-note-date">
     {new Date(note.timestamp).toLocaleDateString()} at {new Date(note.timestamp).toLocaleTimeString()}
    </div>
    </div>
    <button
    onClick={() => {
     const updated = meetingNotes.filter(n => n.id !== note.id);
     setMeetingNotes(updated);
     localStorage.setItem('gmg_ace_meeting_notes', JSON.stringify(updated));
    }}
    style={{
     background: 'none',
     border: 'none',
     color: '#dc3545',
     cursor: 'pointer',
     fontSize: '16px'
    }}
    >X</button>
   </div>
   <div className="meeting-note-content" style={{ color: isDarkMode ? '#E8E8EC' : '#333' }}>
    {note.content}
   </div>
   {/* Quick actions */}
   <div style={{ marginTop: '12px', display: 'flex', gap: '8px' }}>
    <button
    onClick={() => {
     navigator.clipboard.writeText(note.content);
     showToast('Copied to clipboard!');
    }}
    style={{
     padding: '6px 12px',
     background: 'transparent',
     border: `1px solid ${isDarkMode ? '#3a3a5a' : '#ddd'}`,
     borderRadius: '6px',
     fontSize: '12px',
     cursor: 'pointer',
     color: isDarkMode ? '#A0A0B0' : '#666'
    }}
    >
    Copy
    </button>
    <button
    onClick={() => {
     setPrepState(prev => ({ 
     ...prev, 
     input: `Client: ${note.client}\n\nPrevious notes:\n${note.content}\n\nPlease prepare a briefing for my upcoming meeting.` 
     }));
     setActiveTab('prep');
     setShowMeetingNotes(false);
    }}
    style={{
     padding: '6px 12px',
     background: COLORS.copper,
     border: 'none',
     borderRadius: '6px',
     fontSize: '12px',
     cursor: 'pointer',
     color: 'white'
    }}
    >
    Create Briefing
    </button>
   </div>
   </div>
  ))
  )}
 </div>
 </div>
 )}
 
 {/* V3.6: Template Library Panel */}
 {showTemplateLibrary && (
 <div 
 style={{
  position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
  background: 'rgba(0,0,0,0.5)', zIndex: 10001,
  display: 'flex', alignItems: 'center', justifyContent: 'center',
  padding: '20px'
 }}
 onClick={() => setShowTemplateLibrary(false)}
 >
 <div 
  style={{
  background: isDarkMode ? '#1a1a2e' : 'white',
  borderRadius: '16px',
  width: '100%',
  maxWidth: '700px',
  maxHeight: '85vh',
  overflow: 'hidden',
  display: 'flex',
  flexDirection: 'column'
  }}
  onClick={e => e.stopPropagation()}
 >
  <div style={{ 
  padding: '20px', 
  borderBottom: `1px solid ${isDarkMode ? '#3a3a5a' : '#eee'}`,
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center'
  }}>
  <h3 style={{ margin: 0, color: isDarkMode ? '#D4944A' : '#191970' }}>
   Template Library ({savedTemplates.length})
  </h3>
  <button 
   onClick={() => setShowTemplateLibrary(false)}
   style={{ background: 'none', border: 'none', fontSize: '24px', cursor: 'pointer', color: isDarkMode ? '#A0A0B0' : '#666' }}
  >X</button>
  </div>
  
  {/* Search and filter */}
  <div style={{ padding: '16px', borderBottom: `1px solid ${isDarkMode ? '#3a3a5a' : '#eee'}`, display: 'flex', gap: '12px' }}>
  <input
   placeholder="Search templates..."
   value={templateSearch}
   onChange={e => setTemplateSearch(e.target.value)}
   style={{
   flex: 1,
   padding: '10px',
   borderRadius: '8px',
   border: `1px solid ${isDarkMode ? '#3a3a5a' : '#ddd'}`,
   background: isDarkMode ? '#252538' : 'white',
   color: isDarkMode ? '#E8E8EC' : 'inherit'
   }}
  />
  <select
   value={templateFilter}
   onChange={e => setTemplateFilter(e.target.value)}
   style={{
   padding: '10px',
   borderRadius: '8px',
   border: `1px solid ${isDarkMode ? '#3a3a5a' : '#ddd'}`,
   background: isDarkMode ? '#252538' : 'white',
   color: isDarkMode ? '#E8E8EC' : 'inherit'
   }}
  >
   <option value="all">All Categories</option>
   <option value="email">Emails</option>
   <option value="proposal">Proposals</option>
   <option value="report">Reports</option>
   <option value="custom">Custom</option>
  </select>
  </div>
  
  {/* Template list */}
  <div style={{ flex: 1, overflowY: 'auto', padding: '16px' }}>
  {savedTemplates
   .filter(t => templateFilter === 'all' || t.category === templateFilter)
   .filter(t => !templateSearch || t.name.toLowerCase().includes(templateSearch.toLowerCase()) || t.content.toLowerCase().includes(templateSearch.toLowerCase()))
   .length === 0 ? (
   <div style={{ textAlign: 'center', padding: '40px', color: isDarkMode ? '#707080' : '#999' }}>
   {savedTemplates.length === 0 ? 'No templates saved yet. Create content and click "Save Template"!' : 'No templates match your search.'}
   </div>
  ) : (
   savedTemplates
   .filter(t => templateFilter === 'all' || t.category === templateFilter)
   .filter(t => !templateSearch || t.name.toLowerCase().includes(templateSearch.toLowerCase()) || t.content.toLowerCase().includes(templateSearch.toLowerCase()))
   .map(template => (
    <div 
    key={template.id}
    style={{
     background: isDarkMode ? '#252538' : '#f9f9f9',
     borderRadius: '12px',
     padding: '16px',
     marginBottom: '12px'
    }}
    >
    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '8px' }}>
     <div>
     <div style={{ fontWeight: '600', color: isDarkMode ? '#E8E8EC' : '#333' }}>{template.name}</div>
     <div style={{ fontSize: '11px', color: isDarkMode ? '#707080' : '#999' }}>
      {template.category} • {new Date(template.createdAt).toLocaleDateString()}
     </div>
     </div>
     <button
     onClick={() => {
      const updated = savedTemplates.filter(t => t.id !== template.id);
      setSavedTemplates(updated);
      localStorage.setItem('gmg_ace_templates', JSON.stringify(updated));
     }}
     style={{
      background: 'none',
      border: 'none',
      color: '#dc3545',
      cursor: 'pointer',
      fontSize: '16px'
     }}
     >X</button>
    </div>
    <div style={{ 
     fontSize: '13px', 
     color: isDarkMode ? '#A0A0B0' : '#666',
     overflow: 'hidden',
     textOverflow: 'ellipsis',
     display: '-webkit-box',
     WebkitLineClamp: 3,
     WebkitBoxOrient: 'vertical',
     marginBottom: '12px'
    }}>
     {template.content}
    </div>
    <div style={{ display: 'flex', gap: '8px' }}>
     <button
     onClick={() => {
      setCreateState(prev => ({ ...prev, input: `Use this template as a starting point:\n\n${template.content}` }));
      setActiveTab('create');
      setShowTemplateLibrary(false);
     }}
     style={{
      padding: '6px 12px',
      background: COLORS.copper,
      border: 'none',
      borderRadius: '6px',
      fontSize: '12px',
      cursor: 'pointer',
      color: 'white'
     }}
     >
     Use Template
     </button>
     <button
     onClick={() => {
      navigator.clipboard.writeText(template.content);
      showToast('Copied!');
     }}
     style={{
      padding: '6px 12px',
      background: 'transparent',
      border: `1px solid ${isDarkMode ? '#3a3a5a' : '#ddd'}`,
      borderRadius: '6px',
      fontSize: '12px',
      cursor: 'pointer',
      color: isDarkMode ? '#A0A0B0' : '#666'
     }}
     >
     Copy
     </button>
     {/* V3.6: Share with team button */}
     {currentUser && (
     <button
      onClick={() => shareTemplateWithTeam(template)}
      style={{
      padding: '6px 12px',
      background: 'rgba(40, 167, 69, 0.1)',
      border: '1px solid rgba(40, 167, 69, 0.3)',
      borderRadius: '6px',
      fontSize: '12px',
      cursor: 'pointer',
      color: '#28a745'
      }}
     >
      Share
     </button>
     )}
    </div>
    </div>
   ))
  )}
  
  {/* V3.6: Shared Team Templates Section */}
  {sharedTemplates.length > 0 && (
   <>
   <div style={{ 
    padding: '12px 16px', 
    background: isDarkMode ? 'rgba(40, 167, 69, 0.1)' : 'rgba(40, 167, 69, 0.05)',
    borderTop: `1px solid ${isDarkMode ? '#3a3a5a' : '#eee'}`,
    borderBottom: `1px solid ${isDarkMode ? '#3a3a5a' : '#eee'}`,
    fontWeight: '600',
    color: '#28a745'
   }}>
    Team Templates ({sharedTemplates.length})
   </div>
   {sharedTemplates
    .filter(t => !templateSearch || t.name.toLowerCase().includes(templateSearch.toLowerCase()))
    .map(template => (
    <div 
     key={template.id}
     style={{
     background: isDarkMode ? '#1a2e1a' : '#f0fff0',
     borderRadius: '12px',
     padding: '16px',
     margin: '12px 16px',
     border: '1px solid rgba(40, 167, 69, 0.2)'
     }}
    >
     <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '8px' }}>
     <div>
      <div style={{ fontWeight: '600', color: isDarkMode ? '#E8E8EC' : '#333' }}>{template.name}</div>
      <div style={{ fontSize: '11px', color: '#28a745' }}>
      Shared by {template.sharedByName} • {new Date(template.sharedAt).toLocaleDateString()}
      </div>
     </div>
     </div>
     <div style={{ fontSize: '13px', color: isDarkMode ? '#A0A0B0' : '#666', marginBottom: '12px', overflow: 'hidden', textOverflow: 'ellipsis', display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical' }}>
     {template.content}
     </div>
     <button
     onClick={() => {
      setCreateState(prev => ({ ...prev, input: `Use this template:\n\n${template.content}` }));
      setActiveTab('create');
      setShowTemplateLibrary(false);
     }}
     style={{ padding: '6px 12px', background: '#28a745', border: 'none', borderRadius: '6px', fontSize: '12px', cursor: 'pointer', color: 'white' }}
     >
     Use Template
     </button>
    </div>
   ))}
   </>
  )}
  </div>
 </div>
 </div>
 )}
 
 {/* V3.6: Follow-up Tasks Panel */}
 {showFollowUpTasks && (
 <div 
 style={{
  position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
  background: 'rgba(0,0,0,0.5)', zIndex: 10001,
  display: 'flex', alignItems: 'center', justifyContent: 'center',
  padding: '20px'
 }}
 onClick={() => setShowFollowUpTasks(false)}
 >
 <div 
  style={{
  background: isDarkMode ? '#1a1a2e' : 'white',
  borderRadius: '16px',
  width: '100%',
  maxWidth: '500px',
  maxHeight: '80vh',
  overflow: 'hidden',
  display: 'flex',
  flexDirection: 'column'
  }}
  onClick={e => e.stopPropagation()}
 >
  <div style={{ 
  padding: '20px', 
  borderBottom: `1px solid ${isDarkMode ? '#3a3a5a' : '#eee'}`,
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center'
  }}>
  <h3 style={{ margin: 0, color: isDarkMode ? '#D4944A' : '#191970' }}>
   Follow-up Tasks ({followUpTasks.filter(t => !t.completed).length} pending)
  </h3>
  <button 
   onClick={() => setShowFollowUpTasks(false)}
   style={{ background: 'none', border: 'none', fontSize: '24px', cursor: 'pointer', color: isDarkMode ? '#A0A0B0' : '#666' }}
  >X</button>
  </div>
  
  {/* Add new task form */}
  <div style={{ padding: '16px', borderBottom: `1px solid ${isDarkMode ? '#3a3a5a' : '#eee'}` }}>
  <div style={{ display: 'flex', gap: '8px' }}>
   <input
   placeholder="Add a follow-up task..."
   id="new-task-input"
   onKeyDown={e => {
    if (e.key === 'Enter' && e.target.value.trim()) {
    const task = {
     id: Date.now(),
     title: e.target.value.trim(),
     completed: false,
     createdAt: new Date().toISOString(),
     dueDate: null
    };
    const updated = [task, ...followUpTasks];
    setFollowUpTasks(updated);
    localStorage.setItem('gmg_ace_followup_tasks', JSON.stringify(updated));
    e.target.value = '';
    triggerHaptic('light');
    }
   }}
   style={{
    flex: 1,
    padding: '10px 12px',
    borderRadius: '8px',
    border: `1px solid ${isDarkMode ? '#3a3a5a' : '#ddd'}`,
    background: isDarkMode ? '#252538' : 'white',
    color: isDarkMode ? '#E8E8EC' : 'inherit'
   }}
   />
   <button
   onClick={() => {
    const input = document.getElementById('new-task-input');
    if (input.value.trim()) {
    const task = {
     id: Date.now(),
     title: input.value.trim(),
     completed: false,
     createdAt: new Date().toISOString(),
     dueDate: null
    };
    const updated = [task, ...followUpTasks];
    setFollowUpTasks(updated);
    localStorage.setItem('gmg_ace_followup_tasks', JSON.stringify(updated));
    input.value = '';
    triggerHaptic('light');
    }
   }}
   style={{
    padding: '10px 16px',
    background: COLORS.copper,
    color: 'white',
    border: 'none',
    borderRadius: '8px',
    cursor: 'pointer',
    fontWeight: '600'
   }}
   >
   Add
   </button>
  </div>
  </div>
  
  {/* Tasks list */}
  <div style={{ flex: 1, overflowY: 'auto', padding: '16px' }}>
  {followUpTasks.length === 0 ? (
   <div style={{ textAlign: 'center', padding: '40px', color: isDarkMode ? '#707080' : '#999' }}>
   No tasks yet. Add some above!
   </div>
  ) : (
   followUpTasks.map(task => (
   <div key={task.id} className="task-item">
    <div 
    className={`task-checkbox ${task.completed ? 'completed' : ''}`}
    onClick={() => {
     const updated = followUpTasks.map(t => 
     t.id === task.id ? { ...t, completed: !t.completed } : t
     );
     setFollowUpTasks(updated);
     localStorage.setItem('gmg_ace_followup_tasks', JSON.stringify(updated));
     triggerHaptic(task.completed ? 'light' : 'success');
    }}
    >
    {task.completed && 'Done'}
    </div>
    <div className="task-content">
    <div className={`task-title ${task.completed ? 'completed' : ''}`}>
     {task.title}
    </div>
    <div className="task-meta">
     Added {new Date(task.createdAt).toLocaleDateString()}
    </div>
    </div>
    <button
    onClick={() => {
     const updated = followUpTasks.filter(t => t.id !== task.id);
     setFollowUpTasks(updated);
     localStorage.setItem('gmg_ace_followup_tasks', JSON.stringify(updated));
    }}
    style={{
     background: 'none',
     border: 'none',
     color: '#dc3545',
     cursor: 'pointer',
     fontSize: '16px'
    }}
    >X</button>
   </div>
   ))
  )}
  </div>
  
  {/* Clear completed */}
  {followUpTasks.some(t => t.completed) && (
  <div style={{ padding: '16px', borderTop: `1px solid ${isDarkMode ? '#3a3a5a' : '#eee'}` }}>
   <button
   onClick={() => {
    const updated = followUpTasks.filter(t => !t.completed);
    setFollowUpTasks(updated);
    localStorage.setItem('gmg_ace_followup_tasks', JSON.stringify(updated));
    showToast('Completed tasks cleared!');
   }}
   style={{
    width: '100%',
    padding: '10px',
    background: 'transparent',
    border: '1px solid #28a745',
    color: '#28a745',
    borderRadius: '8px',
    cursor: 'pointer'
   }}
   >
   Clear Completed Tasks
   </button>
  </div>
  )}
 </div>
 </div>
 )}
 
 {/* V3.6: Resume Manager Panel */}
 {showResumeManager && (
 <div 
 style={{
  position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
  background: 'rgba(0,0,0,0.5)', zIndex: 10001,
  display: 'flex', alignItems: 'center', justifyContent: 'center',
  padding: '20px'
 }}
 onClick={() => setShowResumeManager(false)}
 >
 <div 
  style={{
  background: isDarkMode ? '#1a1a2e' : 'white',
  borderRadius: '16px',
  width: '100%',
  maxWidth: '600px',
  maxHeight: '85vh',
  overflow: 'hidden',
  display: 'flex',
  flexDirection: 'column'
  }}
  onClick={e => e.stopPropagation()}
 >
  <div style={{ 
  padding: '20px', 
  borderBottom: `1px solid ${isDarkMode ? '#3a3a5a' : '#eee'}`,
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center'
  }}>
  <h3 style={{ margin: 0, color: isDarkMode ? '#D4944A' : '#191970' }}>
   Resume Versions ({savedResumes.length})
  </h3>
  <button 
   onClick={() => setShowResumeManager(false)}
   style={{ background: 'none', border: 'none', fontSize: '24px', cursor: 'pointer', color: isDarkMode ? '#A0A0B0' : '#666' }}
  >X</button>
  </div>
  
  {/* Add new resume version */}
  <div style={{ padding: '16px', borderBottom: `1px solid ${isDarkMode ? '#3a3a5a' : '#eee'}` }}>
  <input
   placeholder="Resume version name (e.g., 'Fundraising Focus')"
   id="resume-name-input"
   style={{
   width: '100%',
   padding: '10px 12px',
   marginBottom: '8px',
   borderRadius: '8px',
   border: `1px solid ${isDarkMode ? '#3a3a5a' : '#ddd'}`,
   background: isDarkMode ? '#252538' : 'white',
   color: isDarkMode ? '#E8E8EC' : 'inherit'
   }}
  />
  <textarea
   placeholder="Paste resume text here..."
   id="resume-content-input"
   rows={4}
   style={{
   width: '100%',
   padding: '10px 12px',
   marginBottom: '8px',
   borderRadius: '8px',
   border: `1px solid ${isDarkMode ? '#3a3a5a' : '#ddd'}`,
   background: isDarkMode ? '#252538' : 'white',
   color: isDarkMode ? '#E8E8EC' : 'inherit',
   resize: 'vertical'
   }}
  />
  <button
   onClick={() => {
   const nameInput = document.getElementById('resume-name-input');
   const contentInput = document.getElementById('resume-content-input');
   if (nameInput.value.trim() && contentInput.value.trim()) {
    const resume = {
    id: Date.now(),
    name: nameInput.value.trim(),
    content: contentInput.value.trim(),
    applicant: acquireState.selectedApplicant || 'brandon',
    createdAt: new Date().toISOString()
    };
    const updated = [resume, ...savedResumes];
    setSavedResumes(updated);
    localStorage.setItem('gmg_ace_resumes', JSON.stringify(updated));
    nameInput.value = '';
    contentInput.value = '';
    showToast('Resume version saved!');
   }
   }}
   style={{
   width: '100%',
   padding: '10px',
   background: COLORS.copper,
   color: 'white',
   border: 'none',
   borderRadius: '8px',
   cursor: 'pointer',
   fontWeight: '600'
   }}
  >
   Save Resume Version
  </button>
  </div>
  
  {/* Resume list */}
  <div style={{ flex: 1, overflowY: 'auto', padding: '16px' }}>
  {savedResumes.length === 0 ? (
   <div style={{ textAlign: 'center', padding: '40px', color: isDarkMode ? '#707080' : '#999' }}>
   No resumes saved yet. Add different versions above!
   </div>
  ) : (
   savedResumes.map(resume => (
   <div 
    key={resume.id}
    style={{
    background: isDarkMode ? '#252538' : '#f9f9f9',
    borderRadius: '12px',
    padding: '16px',
    marginBottom: '12px'
    }}
   >
    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '8px' }}>
    <div>
     <div style={{ fontWeight: '600', color: isDarkMode ? '#E8E8EC' : '#333' }}>{resume.name}</div>
     <div style={{ fontSize: '11px', color: isDarkMode ? '#707080' : '#999' }}>
     {resume.applicant} • {new Date(resume.createdAt).toLocaleDateString()}
     </div>
    </div>
    <button
     onClick={() => {
     const updated = savedResumes.filter(r => r.id !== resume.id);
     setSavedResumes(updated);
     localStorage.setItem('gmg_ace_resumes', JSON.stringify(updated));
     }}
     style={{ background: 'none', border: 'none', color: '#dc3545', cursor: 'pointer', fontSize: '16px' }}
    >X</button>
    </div>
    
    {/* ATS Check */}
    {acquireState.currentJob?.description && (
    <button
     onClick={() => {
     const analysis = analyzeResumeForJob(resume.content, acquireState.currentJob.description);
     setResumeAnalysis({ resumeName: resume.name, ...analysis });
     showToast(`ATS Score: ${analysis.score}%`);
     }}
     style={{
     padding: '6px 12px',
     background: COLORS.navy,
     color: 'white',
     border: 'none',
     borderRadius: '6px',
     fontSize: '12px',
     cursor: 'pointer',
     marginRight: '8px'
     }}
    >
     ATS Check
    </button>
    )}
    <button
    onClick={() => {
     navigator.clipboard.writeText(resume.content);
     showToast('Resume copied!');
    }}
    style={{
     padding: '6px 12px',
     background: 'transparent',
     border: `1px solid ${isDarkMode ? '#3a3a5a' : '#ddd'}`,
     borderRadius: '6px',
     fontSize: '12px',
     cursor: 'pointer',
     color: isDarkMode ? '#A0A0B0' : '#666'
    }}
    >
    Copy
    </button>
   </div>
   ))
  )}
  
  {/* ATS Analysis Results */}
  {resumeAnalysis && (
   <div style={{
   background: isDarkMode ? '#1a2e1a' : '#f0fff0',
   border: '1px solid #28a745',
   borderRadius: '12px',
   padding: '16px',
   marginTop: '16px'
   }}>
   <div style={{ fontWeight: '600', marginBottom: '8px', color: '#28a745' }}>
    ATS Analysis: {resumeAnalysis.resumeName}
   </div>
   <div style={{ fontSize: '24px', fontWeight: '700', marginBottom: '12px', color: resumeAnalysis.score >= 70 ? '#28a745' : resumeAnalysis.score >= 50 ? '#ffc107' : '#dc3545' }}>
    {resumeAnalysis.score}% Match
   </div>
   {resumeAnalysis.matchedSkills.length > 0 && (
    <div style={{ marginBottom: '8px' }}>
    <strong style={{ color: '#28a745' }}>Matched:</strong> {resumeAnalysis.matchedSkills.join(', ')}
    </div>
   )}
   {resumeAnalysis.missingSkills.length > 0 && (
    <div style={{ marginBottom: '8px' }}>
    <strong style={{ color: '#dc3545' }}>Missing:</strong> {resumeAnalysis.missingSkills.join(', ')}
    </div>
   )}
   {resumeAnalysis.atsIssues.length > 0 && (
    <div style={{ marginBottom: '8px' }}>
    <strong style={{ color: '#ffc107' }}>ATS Issues:</strong>
    <ul style={{ margin: '4px 0 0 20px', padding: 0 }}>
     {resumeAnalysis.atsIssues.map((issue, i) => <li key={i}>{issue}</li>)}
    </ul>
    </div>
   )}
   {resumeAnalysis.suggestions.length > 0 && (
    <div>
    <strong>Suggestions:</strong>
    <ul style={{ margin: '4px 0 0 20px', padding: 0 }}>
     {resumeAnalysis.suggestions.map((s, i) => <li key={i}>{s}</li>)}
    </ul>
    </div>
   )}
   </div>
  )}
  </div>
 </div>
 </div>
 )}
 
 {/* V3.6: Client Contacts Panel */}
 {showClientContacts && (
 <div 
 style={{
  position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
  background: 'rgba(0,0,0,0.5)', zIndex: 10001,
  display: 'flex', alignItems: 'center', justifyContent: 'center',
  padding: '20px'
 }}
 onClick={() => setShowClientContacts(false)}
 >
 <div 
  style={{
  background: isDarkMode ? '#1a1a2e' : 'white',
  borderRadius: '16px',
  width: '100%',
  maxWidth: '500px',
  maxHeight: '80vh',
  overflow: 'hidden',
  display: 'flex',
  flexDirection: 'column'
  }}
  onClick={e => e.stopPropagation()}
 >
  <div style={{ 
  padding: '20px', 
  borderBottom: `1px solid ${isDarkMode ? '#3a3a5a' : '#eee'}`,
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center'
  }}>
  <h3 style={{ margin: 0, color: isDarkMode ? '#D4944A' : '#191970' }}>
   Client Contacts ({clientContacts.length})
  </h3>
  <button 
   onClick={() => setShowClientContacts(false)}
   style={{ background: 'none', border: 'none', fontSize: '24px', cursor: 'pointer', color: isDarkMode ? '#A0A0B0' : '#666' }}
  >X</button>
  </div>
  
  {/* Add new contact */}
  <div style={{ padding: '16px', borderBottom: `1px solid ${isDarkMode ? '#3a3a5a' : '#eee'}` }}>
  <input placeholder="Client/Organization name" id="contact-client" style={{ width: '100%', padding: '8px', marginBottom: '8px', borderRadius: '6px', border: `1px solid ${isDarkMode ? '#3a3a5a' : '#ddd'}`, background: isDarkMode ? '#252538' : 'white', color: isDarkMode ? '#E8E8EC' : 'inherit' }} />
  <input placeholder="Contact name" id="contact-name" style={{ width: '100%', padding: '8px', marginBottom: '8px', borderRadius: '6px', border: `1px solid ${isDarkMode ? '#3a3a5a' : '#ddd'}`, background: isDarkMode ? '#252538' : 'white', color: isDarkMode ? '#E8E8EC' : 'inherit' }} />
  <input placeholder="Email" id="contact-email" style={{ width: '100%', padding: '8px', marginBottom: '8px', borderRadius: '6px', border: `1px solid ${isDarkMode ? '#3a3a5a' : '#ddd'}`, background: isDarkMode ? '#252538' : 'white', color: isDarkMode ? '#E8E8EC' : 'inherit' }} />
  <input placeholder="Phone" id="contact-phone" style={{ width: '100%', padding: '8px', marginBottom: '12px', borderRadius: '6px', border: `1px solid ${isDarkMode ? '#3a3a5a' : '#ddd'}`, background: isDarkMode ? '#252538' : 'white', color: isDarkMode ? '#E8E8EC' : 'inherit' }} />
  <button
   onClick={() => {
   const client = document.getElementById('contact-client').value.trim();
   const name = document.getElementById('contact-name').value.trim();
   const email = document.getElementById('contact-email').value.trim();
   const phone = document.getElementById('contact-phone').value.trim();
   if (client && name) {
    const contact = { id: Date.now(), client, name, email, phone, createdAt: new Date().toISOString() };
    const updated = [contact, ...clientContacts];
    setClientContacts(updated);
    localStorage.setItem('gmg_ace_client_contacts', JSON.stringify(updated));
    document.getElementById('contact-client').value = '';
    document.getElementById('contact-name').value = '';
    document.getElementById('contact-email').value = '';
    document.getElementById('contact-phone').value = '';
    showToast('Contact saved!');
   }
   }}
   style={{ width: '100%', padding: '10px', background: COLORS.copper, color: 'white', border: 'none', borderRadius: '8px', cursor: 'pointer', fontWeight: '600' }}
  >
   Add Contact
  </button>
  </div>
  
  {/* Contacts list */}
  <div style={{ flex: 1, overflowY: 'auto', padding: '16px' }}>
  {clientContacts.length === 0 ? (
   <div style={{ textAlign: 'center', padding: '40px', color: isDarkMode ? '#707080' : '#999' }}>
   No contacts saved yet
   </div>
  ) : (
   clientContacts.map(contact => (
   <div key={contact.id} style={{ background: isDarkMode ? '#252538' : '#f9f9f9', borderRadius: '10px', padding: '12px', marginBottom: '8px', display: 'flex', justifyContent: 'space-between' }}>
    <div>
    <div style={{ fontWeight: '600', color: COLORS.copper }}>{contact.client}</div>
    <div style={{ fontSize: '14px', color: isDarkMode ? '#E8E8EC' : '#333' }}>{contact.name}</div>
    <div style={{ fontSize: '12px', color: isDarkMode ? '#A0A0B0' : '#666' }}>{contact.email} {contact.phone && `• ${contact.phone}`}</div>
    </div>
    <button onClick={() => { const updated = clientContacts.filter(c => c.id !== contact.id); setClientContacts(updated); localStorage.setItem('gmg_ace_client_contacts', JSON.stringify(updated)); }} style={{ background: 'none', border: 'none', color: '#dc3545', cursor: 'pointer' }}>X</button>
   </div>
   ))
  )}
  </div>
 </div>
 </div>
 )}
 
 {/* V3.6: Session Timeout Warning */}
 {showTimeoutWarning && (
 <div style={{
 position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
 background: 'rgba(0,0,0,0.7)', zIndex: 99999,
 display: 'flex', alignItems: 'center', justifyContent: 'center',
 padding: '20px'
 }}>
 <div style={{
  background: isDarkMode ? '#1a1a2e' : 'white',
  borderRadius: '16px', padding: '32px', maxWidth: '400px', textAlign: 'center'
 }}>
  <div style={{ fontSize: '48px', marginBottom: '16px' }}></div>
  <h3 style={{ margin: '0 0 16px', color: isDarkMode ? '#E8E8EC' : '#333' }}>Session Timeout</h3>
  <p style={{ color: isDarkMode ? '#A0A0B0' : '#666', marginBottom: '24px' }}>
  You've been inactive for a while. Your drafts have been saved.
  </p>
  <button
  onClick={() => {
   setShowTimeoutWarning(false);
   setLastActivity(Date.now());
  }}
  style={{
   background: COLORS.copper, color: 'white', border: 'none',
   padding: '12px 32px', borderRadius: '8px', fontSize: '16px',
   fontWeight: '600', cursor: 'pointer'
  }}
  >
  Continue Working
  </button>
 </div>
 </div>
 )}
 
 {/* V3.6: Batch Document Check Panel */}
 {showBatchCheck && (
 <div style={{
 position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
 background: 'rgba(0,0,0,0.5)', zIndex: 10001,
 display: 'flex', alignItems: 'center', justifyContent: 'center',
 padding: '20px'
 }}
 onClick={() => setShowBatchCheck(false)}
 >
 <div style={{
  background: isDarkMode ? '#1a1a2e' : 'white',
  borderRadius: '16px', width: '100%', maxWidth: '700px',
  maxHeight: '85vh', overflow: 'hidden',
  display: 'flex', flexDirection: 'column'
 }}
  onClick={e => e.stopPropagation()}
 >
  <div style={{ 
  padding: '20px', 
  borderBottom: `1px solid ${isDarkMode ? '#3a3a5a' : '#eee'}`,
  display: 'flex', justifyContent: 'space-between', alignItems: 'center'
  }}>
  <h3 style={{ margin: 0, color: isDarkMode ? '#D4944A' : '#191970' }}>
   Batch Document Check
  </h3>
  <button onClick={() => setShowBatchCheck(false)} style={{ background: 'none', border: 'none', fontSize: '24px', cursor: 'pointer', color: isDarkMode ? '#A0A0B0' : '#666' }}>X</button>
  </div>
  
  {/* Upload area */}
  <div style={{ padding: '16px', borderBottom: `1px solid ${isDarkMode ? '#3a3a5a' : '#eee'}` }}>
  <textarea
   id="batch-check-input"
   placeholder="Paste multiple documents here, separated by ---
   
Example:
Document 1 content here...
---
Document 2 content here...
---
Document 3 content here..."
   rows={6}
   style={{
   width: '100%', padding: '12px', borderRadius: '8px',
   border: `1px solid ${isDarkMode ? '#3a3a5a' : '#ddd'}`,
   background: isDarkMode ? '#252538' : 'white',
   color: isDarkMode ? '#E8E8EC' : 'inherit',
   resize: 'vertical', fontFamily: 'monospace', fontSize: '13px'
   }}
  />
  <button
   onClick={() => {
   const input = document.getElementById('batch-check-input').value;
   if (!input.trim()) return;
   
   const docs = input.split(/\n---+\n/).map((content, i) => ({
    name: `Document ${i + 1}`,
    content: content.trim()
   })).filter(d => d.content);
   
   if (docs.length > 0) {
    runBatchCheck(docs);
   }
   }}
   disabled={batchCheckProgress.processing}
   style={{
   marginTop: '12px', width: '100%', padding: '12px',
   background: batchCheckProgress.processing ? '#999' : COLORS.copper,
   color: 'white', border: 'none', borderRadius: '8px',
   cursor: batchCheckProgress.processing ? 'wait' : 'pointer',
   fontWeight: '600'
   }}
  >
   {batchCheckProgress.processing 
   ? `Checking ${batchCheckProgress.current}/${batchCheckProgress.total}...` 
   : 'Run Batch Check'}
  </button>
  </div>
  
  {/* Results */}
  <div style={{ flex: 1, overflowY: 'auto', padding: '16px' }}>
  {batchCheckResults.length === 0 ? (
   <div style={{ textAlign: 'center', padding: '40px', color: isDarkMode ? '#707080' : '#999' }}>
   Paste documents above and click "Run Batch Check" to analyze multiple documents at once.
   </div>
  ) : (
   batchCheckResults.map((result, i) => (
   <div key={i} style={{
    background: isDarkMode ? '#252538' : '#f9f9f9',
    borderRadius: '12px', padding: '16px', marginBottom: '12px'
   }}>
    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
    <strong style={{ color: isDarkMode ? '#E8E8EC' : '#333' }}>{result.name}</strong>
    <span style={{ 
     padding: '4px 12px', borderRadius: '12px', fontSize: '12px', fontWeight: '600',
     background: result.fireCount <= 1 ? '#d4edda' : result.fireCount <= 3 ? '#fff3cd' : '#f8d7da',
     color: result.fireCount <= 1 ? '#155724' : result.fireCount <= 3 ? '#856404' : '#721c24'
    }}>
     {result.fireCount} | {result.wordCount} words
    </span>
    </div>
    <div style={{ fontSize: '13px', color: isDarkMode ? '#A0A0B0' : '#666' }}>
    {result.issues.length === 0 ? (
     <span style={{ color: '#28a745' }}>No issues found!</span>
    ) : (
     <span>{result.issues.length} issue(s): {result.issues.slice(0, 3).map(i => i.type).join(', ')}{result.issues.length > 3 ? '...' : ''}</span>
    )}
    </div>
   </div>
   ))
  )}
  </div>
 </div>
 </div>
 )}
 
 {/* V5.2: Floating Tips */}
 <FloatingTip />
 </>
 );
};

// V26: PropTypes validation (no required props - component is self-contained)
GMGAssistant.propTypes = {};
GMGAssistant.defaultProps = {};

export default GMGAssistant;
